// src/internals/components/appointmentBooking/index.tsx
import { Button as Button2 } from "@lls/lls-kit";
import { cx as cx2 } from "@lls/utils";
import { useState } from "react";

// src/internals/components/appointmentBooking/appointmentModal.tsx
import { usePageViewedEvent } from "@lls/utils";

// src/internals/components/modal/modalWithTheme.jsx
import { KIT_CLASSNAME_LIGHT_THEME, Modal, styleThemeProps } from "@lls/lls-kit";
import { cx } from "@lls/utils";

// src/internals/v2/utils/constants.ts
var SUMMARY_PART_TYPE = "Part";
var SUMMARY_CHAPTER_TYPE = "Chapter";
var SUMMARY_PAGE_TYPE = "Page";
var BOOK_DRAWER_WIDTH = 350;
var DATA_TOUR_PREFIX = "superkit";
var ANALYTICS_EVENTS_CORRECTION_STARTED = "correction_started";
var ANALYTICS_EVENTS_PAGE_EXPORT_STARTED = "page_export_started";
var ANALYTICS_EVENTS_PAGE_SHARE_STARTED = "page_share_started";
var ANALYTICS_EVENTS_PAGE_EXPORTED = "page_exported";
var ANALYTICS_EVENTS_CONTENT_VIEW_CHANGED = "content_view_changed";
var ANALYTICS_EVENTS_STUDENT_ANSWER_VIEWED = "student_answer_viewed";
var ANALYTICS_EVENTS_REPORT_STARTED = "report_started";
var ANALYTICS_EVENT_REPORT_SENT = "report_sent";
var ANALYTIC_EVENTS_LINK_CLICKED = "link_clicked";
var ANALYTICS_VIEW_WEB = "web";
var ANALYTICS_VIEW_PRESENTATION_WEB = "presentation_web";
var ANALYTICS_VIEW_PDF = "pdf";
var ANALYTICS_VIEW_PRESENTATION_PDF = "presentation_pdf";
var ANALYTICS_EVENT_GROUP_RENAMED = "group_renamed";
var ANALYTICS_INVITATION_METHOD_USED = "invitation_method_used";
var DATA_TOUR = {
  SESSION: `${DATA_TOUR_PREFIX}-session`,
  SESSION_TAB: `${DATA_TOUR_PREFIX}-tabs`,
  EXERCISES_WRAPPER: `${DATA_TOUR_PREFIX}-exercises-wrapper`,
  AVAILABLE_COPIES_HEADER: `${DATA_TOUR_PREFIX}-available-copies-header`,
  AVAILABLE_COPIES_HEADER_BUTTON: `${DATA_TOUR_PREFIX}-available-copies-header-button`,
  COPY_TABLE_LINE: `${DATA_TOUR_PREFIX}-copy-table-line`,
  CORRECTION_HEADER_CARD: `${DATA_TOUR_PREFIX}-correction-header-card`,
  CORRECTION_HEADER_BUTTON: `${DATA_TOUR_PREFIX}-correction-header-button`,
  SUMMARY_PAGE: `${DATA_TOUR_PREFIX}-summary-page`,
  SAVE_BAR_CONTAINER: `${DATA_TOUR_PREFIX}-save-bar-container`,
  SAVE_BAR_ACTION: `${DATA_TOUR_PREFIX}-save-bar-action`,
  SUMMARY_BUTTON: `${DATA_TOUR_PREFIX}-summary-button`,
  SUMMARY_MODIFIED_PAGES: `${DATA_TOUR_PREFIX}-summary-modified-pages`
};
var TOOLBAR_CLASS = "toolbar-toolbox";
var FONT_LATO = "LatoWeb";
var FONT_VERDANA = "Verdana";
var FONT_SABON = "Sabon";
var FONTS_FAMILY = [FONT_LATO, FONT_VERDANA, FONT_SABON];
var ACCESSIBILITY_MODAL_CLASSNAME = "accessibility-modal";
var SHARE_MODAL_CLASSNAME = "share-modal";
var EXPORT_MODAL_CLASSNAME = "export-modal";
var TTS_MODAL_CLASSNAME = "tts-modal";
var OFFLINE_MODAL_CLASSNAME = "offline-modal";
var RIGHT_ANSWER_COLOR = "var(--primary-40-color)";
var MEDIUM_ANSWER_COLOR = "var(--secondary-40-color)";
var WRONG_ANSWER_COLOR = "var(--premium-color)";
var SESSION_RATIO_SECTIONS = [
  {
    label: "Moins de 45% de r\xE9ussite",
    color: "#FF5C93",
    lightColor: "#FFBFD5",
    darkColor: "#8F153E",
    themeStamp: "red",
    min: 0,
    max: 0.44
  },
  {
    label: "Entre 45% et 70% de r\xE9ussite",
    color: "#FFA800",
    lightColor: "#FEE57F",
    darkColor: "#522600",
    themeStamp: "orange",
    min: 0.45,
    max: 0.7
  },
  {
    label: "Plus de 70% de r\xE9ussite",
    color: "#21BFEF",
    lightColor: "#99E7FF",
    darkColor: "#004370",
    themeStamp: "blue",
    min: 0.71,
    max: 1
  }
];
var NB_DAYS_LIMIT = 14;
var CLASSROOM_STEP = {
  CHOOSE_CLASSROOM_TYPE: "CHOOSE_CLASSROOM_TYPE",
  ADD_ENT_CLASSROOM: "ADD_ENT_CLASSROOM",
  ADD_CUSTOM_CLASSROOM: "ADD_CLASSROOM",
  SUCCES_RETRIEVE_CLASS: "SUCCES_RETRIEVE_CLASS",
  SUCCES_ADDED_CLASS: "SUCCES_ADDED_CLASSROOM",
  ALL_CLASSROOMS: "ALL_CLASSROOMS",
  CLASSROOM: "CLASSROOM"
};
var PAGES_THEMATIC = {
  REVISION_EXERCISE: "Exercices de r\xE9vision - Exclusivit\xE9 num\xE9rique",
  REVISION_SHEET: "Fiches de r\xE9vision - Exclusivit\xE9 num\xE9rique"
};
var LEARNING_ASSESSMENT_STEPS = {
  DEFAULT: "suivi-des-acquis",
  SELECT_NOTION: "select_notion",
  SELECT_EXERCISES: "select_exercises",
  SELECT_GROUPS: "select_groups",
  START_SESSION: "start_session",
  FOLLOW_GROUP_PROGRESSION: "follow_group_progression"
};
var ASSETS_URL = "https://assets.lls.fr";

// tmp_esbuild1736180050074/_src_internals_components_modal_modalWithTheme.module.css
var src_internals_components_modal_modalWithTheme_default = { "div": "sk-oQb7vq-div kit-themecss" };

// src/internals/components/modal/modalWithTheme.jsx
import { jsx } from "react/jsx-runtime";
var ModalWithTheme = ({
  children,
  isDysMode = false,
  sizeIndex = 2,
  fontFamily = FONT_LATO,
  themeClassName = KIT_CLASSNAME_LIGHT_THEME,
  className = "",
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cx(themeClassName, src_internals_components_modal_modalWithTheme_default.div),
      style: styleThemeProps({ isDysMode, sizeIndex, font: fontFamily }),
      children: /* @__PURE__ */ jsx(Modal, { className: cx(className, ` ${themeClassName} ${isDysMode + fontFamily + sizeIndex}`), ...props, children })
    }
  );
};
var modalWithTheme_default = ModalWithTheme;

// tmp_esbuild1736180050074/_src_internals_components_appointmentBooking_appointmentModal.module.css
var src_internals_components_appointmentBooking_appointmentModal_default = { "iframe": "sk-JzXfzG-iframe", "container": "sk-JzXfzG-container" };

// src/internals/components/appointmentBooking/appointmentModal.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var GOOGLE_CALENDER_DEFAULT_LINK = "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1lZp83UFJZRTuelUlE9mJliuFvCh5ZWY2D3K8emIMcn32K1iW7S-jepcvp8A4CbAon_8r2d-ND?gv=true";
var AppointmentModal = ({
  onClose,
  calendarUrl = GOOGLE_CALENDER_DEFAULT_LINK
}) => {
  usePageViewedEvent({ featureName: "interview_booking" });
  return /* @__PURE__ */ jsx2(modalWithTheme_default, { closeModal: onClose, children: /* @__PURE__ */ jsx2("div", { className: src_internals_components_appointmentBooking_appointmentModal_default.container, children: /* @__PURE__ */ jsx2("iframe", { className: src_internals_components_appointmentBooking_appointmentModal_default.iframe, src: calendarUrl, title: "calendrier pour prise de rendez-vous" }) }) });
};
var appointmentModal_default = AppointmentModal;

// src/internals/components/appointmentBooking/explicativeModal.tsx
import { Button, Icon } from "@lls/lls-kit";
import { dispatchAnalyticsEvent } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_appointmentBooking_explicativeModal.module.css
var src_internals_components_appointmentBooking_explicativeModal_default = { "info": "sk-JyCCua-info", "ul": "sk-JyCCua-ul", "span": "sk-JyCCua-span", "cta": "sk-JyCCua-cta", "icon": "sk-JyCCua-icon", "content": "sk-JyCCua-content", "title": "sk-JyCCua-title" };

// src/internals/components/appointmentBooking/explicativeModal.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var ExplicativeModal = ({
  onClose,
  openAppointmentModal
}) => {
  const iconProps = {
    className: src_internals_components_appointmentBooking_explicativeModal_default.icon,
    width: 20,
    height: 20
  };
  const onOpenAppointementModal = () => {
    onClose();
    openAppointmentModal();
    dispatchAnalyticsEvent(ANALYTIC_EVENTS_LINK_CLICKED, {
      featureName: "interview_booking"
    });
  };
  return /* @__PURE__ */ jsx3(modalWithTheme_default, { closeModal: onClose, children: /* @__PURE__ */ jsxs("div", { className: src_internals_components_appointmentBooking_explicativeModal_default.content, children: [
    /* @__PURE__ */ jsx3("img", { src: "/assets/img/appointmentBooking/books.webp" }),
    /* @__PURE__ */ jsxs("div", { className: src_internals_components_appointmentBooking_explicativeModal_default.info, children: [
      /* @__PURE__ */ jsx3("h1", { className: src_internals_components_appointmentBooking_explicativeModal_default.title, children: "Votre avis compte !" }),
      /* @__PURE__ */ jsxs("span", { children: [
        "Pour nous rencontrer : ",
        /* @__PURE__ */ jsx3("br", {})
      ] }),
      /* @__PURE__ */ jsxs("ul", { className: src_internals_components_appointmentBooking_explicativeModal_default.ul, children: [
        /* @__PURE__ */ jsxs("li", { children: [
          /* @__PURE__ */ jsx3(Icon, { ...iconProps, name: "calendar" }),
          " S\xE9lectionnez un cr\xE9neau-horaire."
        ] }),
        /* @__PURE__ */ jsxs("li", { children: [
          /* @__PURE__ */ jsx3(Icon, { ...iconProps, name: "mailfill" }),
          " Le jour J, cliquez sur le lien dans le mail de rendez-vous."
        ] }),
        /* @__PURE__ */ jsxs("li", { children: [
          /* @__PURE__ */ jsx3(Icon, { ...iconProps, name: "clock" }),
          "Profitez d'une conversation de 30 min avec l'\xE9quipe"
        ] })
      ] }),
      /* @__PURE__ */ jsxs("span", { className: src_internals_components_appointmentBooking_explicativeModal_default.span, children: [
        "S'il n\u2019y a plus de cr\xE9neaux disponibles, n'h\xE9sitez pas \xE0 revenir :",
        /* @__PURE__ */ jsx3("br", {}),
        "nous en ajoutons chaque semaine."
      ] }),
      /* @__PURE__ */ jsxs("div", { className: src_internals_components_appointmentBooking_explicativeModal_default.cta, children: [
        /* @__PURE__ */ jsx3(Button, { onClick: onClose, theme: "gray", accent: "floating", children: "Annuler" }),
        /* @__PURE__ */ jsx3(Button, { onClick: onOpenAppointementModal, children: "Prendre rendez-vous" })
      ] })
    ] })
  ] }) });
};
var explicativeModal_default = ExplicativeModal;

// tmp_esbuild1736180050074/_src_internals_components_appointmentBooking_index.module.css
var src_internals_components_appointmentBooking_index_default = { "subTitle": "sk-aJxApW-subTitle", "container": "sk-aJxApW-container", "absoluteImg": "sk-aJxApW-absoluteImg", "img": "sk-aJxApW-img", "triangle": "sk-aJxApW-triangle", "partLeft": "sk-aJxApW-partLeft", "content": "sk-aJxApW-content", "title": "sk-aJxApW-title", "span": "sk-aJxApW-span", "button": "sk-aJxApW-button" };

// src/internals/components/appointmentBooking/index.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var AppointmentBooking = ({ className, calendarUrl }) => {
  const [isOpenedExplicativeModal, setIsOpenedExplicativeModal] = useState(false);
  const [isOpenedAppointementModal, setIsOpenedAppointementModal] = useState(false);
  return /* @__PURE__ */ jsxs2("div", { className: cx2(className, src_internals_components_appointmentBooking_index_default.container), children: [
    /* @__PURE__ */ jsx4(
      "img",
      {
        src: "/assets/img/appointmentBooking/laptop.webp",
        className: src_internals_components_appointmentBooking_index_default.absoluteImg,
        style: {
          "--top": "-50px",
          "--left": "360px"
        }
      }
    ),
    /* @__PURE__ */ jsx4(
      "img",
      {
        src: "/assets/img/appointmentBooking/pencil.webp",
        className: src_internals_components_appointmentBooking_index_default.absoluteImg,
        style: {
          "--left": "224px",
          "--bottom": "-33px"
        }
      }
    ),
    /* @__PURE__ */ jsx4("div", { className: src_internals_components_appointmentBooking_index_default.triangle }),
    /* @__PURE__ */ jsxs2("div", { className: src_internals_components_appointmentBooking_index_default.content, children: [
      /* @__PURE__ */ jsxs2("div", { className: src_internals_components_appointmentBooking_index_default.partLeft, children: [
        /* @__PURE__ */ jsx4("h1", { className: src_internals_components_appointmentBooking_index_default.title, children: "Votre avis compte !" }),
        /* @__PURE__ */ jsxs2("h3", { className: src_internals_components_appointmentBooking_index_default.subTitle, children: [
          "Des id\xE9es ou remarques sur le manuel num\xE9rique\xA0? ",
          /* @__PURE__ */ jsx4("br", {}),
          "Discutons-en et partagez votre exp\xE9rience d'enseignant !"
        ] }),
        /* @__PURE__ */ jsxs2("span", { className: src_internals_components_appointmentBooking_index_default.span, children: [
          "Prenez rendez-vous avec un membre de l\u2019\xE9quipe Lelivrescolaire.fr pour 30 ",
          /* @__PURE__ */ jsx4("br", {}),
          "minutes d\u2019\xE9change et fa\xE7onnez l\u2019avenir de vos manuels et outils num\xE9riques."
        ] }),
        /* @__PURE__ */ jsx4(Button2, { onClick: () => setIsOpenedExplicativeModal(true), className: src_internals_components_appointmentBooking_index_default.button, children: "R\xE9servez un cr\xE9neau" })
      ] }),
      /* @__PURE__ */ jsx4("img", { className: src_internals_components_appointmentBooking_index_default.img, src: "/assets/img/appointmentBooking/teacher_room.webp" })
    ] }),
    isOpenedExplicativeModal && /* @__PURE__ */ jsx4(
      explicativeModal_default,
      {
        onClose: () => setIsOpenedExplicativeModal(false),
        openAppointmentModal: () => setIsOpenedAppointementModal(true)
      }
    ),
    isOpenedAppointementModal && /* @__PURE__ */ jsx4(appointmentModal_default, { calendarUrl, onClose: () => setIsOpenedAppointementModal(false) })
  ] });
};
var appointmentBooking_default = AppointmentBooking;

// src/internals/components/copies/appreciationHeader.tsx
import { Fragment } from "react";
import { Quote } from "@lls/lls-kit";
import _4 from "lodash/fp.js";
import { cx as cx3 } from "@lls/utils";

// src/internals/utils/user.ts
import _3 from "lodash/fp.js";

// src/internals/utils/entities.jsx
import _ from "lodash/fp.js";
var filterEntitiesArrayFieldByValues = (fieldName, fieldValues) => (entities) => _.isEmpty(fieldValues) ? entities : _.filter(_.flow(_.get(fieldName), _.intersection(fieldValues), _.negate(_.isEmpty)), entities);
var filterEntitiesSimpleFieldByValues = (fieldName, fieldValues) => (entities) => _.isNil(fieldValues) ? entities : _.filter(
  _.flow(_.get(fieldName), (fieldValue) => _.includes(fieldValue, fieldValues)),
  entities
);

// src/internals/utils/string.ts
import _2 from "lodash/fp.js";
var percentFormatter = new Intl.NumberFormat("fr-FR", { style: "percent" });
var formatPercent = percentFormatter.format;
var formatDigit = _2.padCharsStart("0", 2);
var cleanString = _2.flow(_2.toLower, _2.trim, _2.deburr);
var handlePlural = (string, arg) => _2.isArray(arg) ? `${string}${_2.size(arg) > 1 ? "s" : ""}` : _2.isInteger(arg) ? `${string}${arg > 1 ? "s" : ""}` : null;

// src/internals/utils/constants.ts
import { METHOD_URI_LECTURE_CP, METHOD_URI_MATHS_CP } from "@lls/utils";
var FULLWIDTH_DRAWER_BREAKPOINT = 650;
var MEDALS = {
  beginner: {
    score: 0,
    name: "D\xE9butant"
  },
  bronze: {
    score: 2e3,
    name: "M\xE9daille de bronze"
  },
  silver: {
    score: 12e3,
    name: "M\xE9daille d'argent"
  },
  gold: {
    score: 32e3,
    name: "M\xE9daille d'or"
  }
};
var SESSION_EXERCISE_TAB = "session-exercise-tab";
var SESSION_STATS_TAB = "session-stats-tab";
var SESSION_STATS_TEACHER_TAB = "session-stats-teacher-tab";
var SESSION_WEEK_PERIOD = "SESSION_WEEK_PERIOD";
var SESSION_MONTH_PERIOD = "SESSION_MONTH_PERIOD";
var SESSION_YEAR_PERIOD = "SESSION_YEAR_PERIOD";
var SESSION_STATS_CHART_CONFIG = {
  padding: { left: 0, right: 0 },
  margin: { top: 20, left: 0, right: 0, bottom: 0 }
};
var SESSION_STATS_CARTESION_GRID_CONFIG = {
  vertical: false,
  stroke: "#ADBACC",
  margin: { top: 20, left: 0, right: 0, bottom: 0 }
};
var CONNECTOR_NAME_TO_LABEL = {
  statim: "EcoleDirecte",
  pronote: "Pronote",
  "atrium-paca": "Atrium"
};
var READ_STATUSES = {
  READ: { id: "Lu", label: "Lu" },
  UNREAD: { id: "Non lu", label: "Non lu" }
};
var PRIMARY_SECTIONS = [
  {
    name: "CP",
    meliName: "activity",
    links: [
      { name: "Lecture", href: `/primaire/${METHOD_URI_LECTURE_CP}` },
      { name: "Math\xE9matiques", href: `/primaire/${METHOD_URI_MATHS_CP}` }
    ]
  },
  {
    name: "CE1",
    meliName: "display",
    tag: "\xC0 para\xEEtre Printemps 2025"
  },
  {
    name: "CE2",
    meliName: "reading",
    tag: "\xC0 para\xEEtre Printemps 2025"
  },
  {
    name: "Cycle 3",
    meliName: "listen",
    tag: "\xC0 para\xEEtre"
  }
];

// src/internals/utils/user.ts
var getStudentFullName = (u) => `${_3.toUpper((u == null ? void 0 : u.lastname) ?? "")} ${_3.capitalize((u == null ? void 0 : u.firstname) ?? "")}`;
var getStudentsWithoutGroup = ({
  selectedGroup,
  withoutGroup,
  userIds,
  groups
}) => (selectedGroup == null ? void 0 : selectedGroup.id) === (withoutGroup == null ? void 0 : withoutGroup.id) ? _3.flow(_3.flatMap("students"), _3.uniq, _3.difference(userIds))(groups) : null;
var getTeacherTitleAndLastName = (currentUser) => {
  const lastName = _3.capitalize((currentUser == null ? void 0 : currentUser.lastname) ?? "");
  const gender = currentUser == null ? void 0 : currentUser.gender;
  switch (gender) {
    case "male":
      return `Monsieur ${lastName}`;
    case "female":
      return `Madame ${lastName}`;
    default:
      return `M./Mme ${lastName}`;
  }
};
var getUserFirstLetter = (user) => _3.flow(_3.first, _3.deburr, _3.toUpper)(user == null ? void 0 : user.lastname);
var searchUsers = (users, { search, levels, connectorNames }) => _3.flow(
  _3.isEmpty(search) ? _3.identity : _3.filter(
    _3.flow(
      getStudentFullName,
      cleanString,
      (fullName) => _3.flow(
        cleanString,
        _3.split(" "),
        _3.every((searchWord) => _3.includes(searchWord, fullName))
      )(search)
    )
  ),
  _3.isNil(levels) ? _3.identity : filterEntitiesArrayFieldByValues("levels", levels),
  _3.isNil(connectorNames) ? _3.identity : _3.filter(
    _3.flow(
      _3.get("connectorName"),
      _3.overSome(
        _3.map((expectedConnectorName) => {
          return expectedConnectorName === "ENT" ? (connectorName) => !_3.isEmpty(connectorName) && !_3.includes(connectorName, _3.keys(CONNECTOR_NAME_TO_LABEL)) : _3.isEqual(expectedConnectorName);
        }, connectorNames)
      )
    )
  )
)(users);
var isAdmin = _3.matchesProperty("isAdmin", true);
var isEditorLLS = _3.matchesProperty("isEditorLLS", true);
var isReviewer = _3.matchesProperty("isReviewer", true);
var hasAccessToInvalidPageOrChapter = (user) => isAdmin(user) || isEditorLLS(user) || isReviewer(user);
var isTeacher = _3.matchesProperty("isTeacher", true);
var isStudent = _3.matchesProperty("isStudent", true);

// tmp_esbuild1736180050074/_src_internals_components_copies_appreciationHeader.module.css
var src_internals_components_copies_appreciationHeader_default = { "viewer-fullscreen-modal": "sk-DNlxHq-viewer-fullscreen-modal", "title": "sk-DNlxHq-title", "card": "sk-DNlxHq-card" };

// src/internals/components/copies/appreciationHeader.tsx
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var AppreciationHeader = ({ className, content, teacher, title = "Appr\xE9ciation globale" }) => {
  const breakingLineContent = _4.flow(
    _4.split(/\r?\n/),
    (str) => _4.map.convert({ cap: false })(
      (line, i) => /* @__PURE__ */ jsxs3(Fragment, { children: [
        i > 0 && /* @__PURE__ */ jsx5("br", {}),
        line
      ] }, i),
      str
    )
  )(content);
  return /* @__PURE__ */ jsx5("div", { className: cx3(className, src_internals_components_copies_appreciationHeader_default.card), children: /* @__PURE__ */ jsxs3("div", { className: "container", children: [
    /* @__PURE__ */ jsx5("h4", { className: src_internals_components_copies_appreciationHeader_default.title, children: title }),
    /* @__PURE__ */ jsx5(Quote, { "data-clarity-mask": "true", className: "quote", author: getTeacherTitleAndLastName(teacher), children: breakingLineContent })
  ] }) });
};
var appreciationHeader_default = AppreciationHeader;

// src/internals/components/copies/availableCopiesHeader.jsx
import { Button as Button3 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_copies_availableCopiesHeader.module.css
var src_internals_components_copies_availableCopiesHeader_default = { "availableCopies": "sk-yo050a-availableCopies", "text": "sk-yo050a-text" };

// src/internals/components/copies/availableCopiesHeader.jsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var AvailableCopiesHeader = ({ nbAvailableCopies, onClick }) => /* @__PURE__ */ jsxs4("div", { className: src_internals_components_copies_availableCopiesHeader_default.availableCopies, "data-tour": DATA_TOUR.AVAILABLE_COPIES_HEADER, children: [
  /* @__PURE__ */ jsxs4("span", { className: src_internals_components_copies_availableCopiesHeader_default.text, children: [
    "Vous avez ",
    nbAvailableCopies,
    " ",
    handlePlural("r\xE9ponse", nbAvailableCopies),
    "\xA0",
    handlePlural("d'\xE9l\xE8ve", nbAvailableCopies),
    " sur cette page :"
  ] }),
  /* @__PURE__ */ jsx6(Button3, { theme: "gray", onClick, "data-tour": DATA_TOUR.AVAILABLE_COPIES_HEADER_BUTTON, children: "Acc\xE9der aux r\xE9ponses" })
] });
var availableCopiesHeader_default = AvailableCopiesHeader;

// src/internals/components/cardToolbar/index.jsx
import _23 from "lodash/fp.js";
import { useCallback as useCallback12, useState as useState9 } from "react";
import { Button as Button10, Divider as Divider3, Z_CARD_TOOLBAR } from "@lls/lls-kit";
import { cx as cx7 } from "@lls/utils";

// src/internals/components/modal/shareModal/defaultShareModal.jsx
import { useCallback as useCallback2, useState as useState3 } from "react";
import { Divider, Icon as Icon2, Modal as Modal2, TextField, Toast } from "@lls/lls-kit";

// src/internals/components/modal/shareModal/copyLinkButton.jsx
import { Button as Button4, Tooltip } from "@lls/lls-kit";
import clipboardCopy from "clipboard-copy";
import { useCallback, useState as useState2 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_modal_shareModal_copyLinkButton.module.css
var src_internals_components_modal_shareModal_copyLinkButton_default = { "button": "sk-7EyrVW-button" };

// src/internals/components/modal/shareModal/copyLinkButton.jsx
import { jsx as jsx7 } from "react/jsx-runtime";
var CopyLinkButton = ({ link }) => {
  const [hasCopied, setHasCopied] = useState2(false);
  const handleClick = useCallback(() => {
    clipboardCopy(link);
    setTimeout(() => {
      setHasCopied(true);
    }, 300);
  }, [link]);
  return /* @__PURE__ */ jsx7(Tooltip, { content: "Copier le lien", withTail: true, children: /* @__PURE__ */ jsx7(
    Button4,
    {
      className: src_internals_components_modal_shareModal_copyLinkButton_default.button,
      accent: "floating",
      theme: "gray",
      icon: hasCopied ? "checkmark" : "squareonsquare",
      size: "small",
      onClick: handleClick
    }
  ) });
};
var copyLinkButton_default = CopyLinkButton;

// src/internals/config/development.tsx
var development_default = {
  env: "development",
  host: "https://dev.lelivrescolaire.fr",
  host_premium: "https://premium-dev.lelivrescolaire.fr",
  api_node_js: "https://api-dev.lelivrescolaire.fr",
  export_pdf_url: "https://pdf-dev.lls.fr",
  export_word_url: "https://word-dev.lls.fr",
  export_moodle_url: "https://moodle-dev.lls.fr",
  export_share_url: "https://share-dev.lls.fr",
  export_share_url_premium: "https://beta-premium-dev.lelivrescolaire.fr",
  export_qrcode_url: "https://qrcode-dev.lls.fr",
  export_quiz_url: "https://quiz-dev.lls.fr",
  mini_url: "https://mini-urls-dev.lls.fr"
};

// src/internals/config/production.tsx
var production_default = {
  env: "production",
  host: "https://www.lelivrescolaire.fr",
  host_premium: "https://premium.lelivrescolaire.fr",
  api_node_js: "https://api.lelivrescolaire.fr",
  export_pdf_url: "https://pdf.lls.fr",
  export_word_url: "https://word.lls.fr",
  export_moodle_url: "https://moodle.lls.fr",
  export_share_url: "https://share.lls.fr",
  export_share_url_premium: "https://beta-premium.lelivrescolaire.fr",
  export_qrcode_url: "https://qrcode.lls.fr",
  export_quiz_url: "https://quiz.lls.fr",
  mini_url: "https://lls.fr"
};

// src/internals/config/index.tsx
var config = process.env.CONF_ENV === "production" || process.env.CONF_ENV === "prod" ? production_default : development_default;
var config_default = config;

// src/internals/utils/url.ts
import _5 from "lodash/fp.js";
var generatePageUrl = (baseUrl) => ({ slug, fullscreenId, tabId, type }) => {
  const params = new URLSearchParams(
    _5.omitBy(_5.isUndefined, { docId: fullscreenId, tabId, type })
  ).toString();
  return slug ? `${baseUrl}/${slug}${params ? `?${params}` : ""}` : "";
};
var encodeParams = (params) => _5.flow(
  _5.omitBy((value) => _5.isUndefined(value) || value === ""),
  JSON.stringify,
  encodeURIComponent,
  btoa
)(params);
var getParams = (params, shouldEncode = true) => {
  if (!params) return "";
  const encoded = encodeParams(params);
  const decoded = new URLSearchParams(
    _5.omitBy((value) => _5.isUndefined(value) || value === "", params)
  ).toString();
  return shouldEncode ? `?data=${encoded}` : `?${decoded}`;
};
var generatePageExportUrl = (baseUrl, shouldEncode) => ({
  slug,
  fullscreenId,
  type,
  showCorrections: iShowCorrections,
  showQuestions,
  tabId,
  renewalDisplayed: iRenewalDisplayed
}) => {
  const showCorrections = +!!iShowCorrections;
  const areQuestionsHidden = +!showQuestions;
  const renewalDisplayed = +!!iRenewalDisplayed;
  const params = getParams(
    {
      docId: fullscreenId,
      type,
      showCorrections,
      areQuestionsHidden,
      tabId,
      renewal: renewalDisplayed
    },
    shouldEncode
  );
  return slug ? `${baseUrl}/${slug}${params}` : "";
};
var generateShareUrl = generatePageUrl(config_default.export_share_url);
var generatePdfUrl = generatePageExportUrl(config_default.export_pdf_url);
var generateWordUrl = generatePageExportUrl(config_default.export_word_url);
var generateMoodleUrl = generatePageExportUrl(config_default.export_moodle_url);
var generateQrcodeUrl = generatePageExportUrl(config_default.export_qrcode_url, false);
var generateCodeClasroomMiniUrl = ({ code }) => `${config_default.mini_url}/code/${code}`;
var getNavbarLink = (schoolTypeSlug, subjectSlug) => {
  var _a;
  return `/${schoolTypeSlug}/${(_a = subjectSlug == null ? void 0 : subjectSlug.split("/")) == null ? void 0 : _a[1]}`;
};

// src/internals/components/modal/shareModal/defaultShareModal.jsx
import _6 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_modal_shareModal_defaultShareModal.module.css
var src_internals_components_modal_shareModal_defaultShareModal_default = { "toast": "sk-MntuEW-toast", "overridingTextInput": "sk-MntuEW-overridingTextInput", "subtitle": "sk-MntuEW-subtitle", "divider": "sk-MntuEW-divider", "centerAlign": "sk-MntuEW-centerAlign", "linkContainer": "sk-MntuEW-linkContainer", "textField": "sk-MntuEW-textField", "contentImg": "sk-MntuEW-contentImg", "copyButtonContainer": "sk-MntuEW-copyButtonContainer", "img": "sk-MntuEW-img", "overridingInputWrapper": "sk-MntuEW-overridingInputWrapper" };

// src/internals/components/modal/shareModal/defaultShareModal.jsx
import { Fragment as Fragment2, jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var LinkShareInput = ({ link }) => /* @__PURE__ */ jsxs5("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.linkContainer, children: [
  /* @__PURE__ */ jsx8(TextField, { className: src_internals_components_modal_shareModal_defaultShareModal_default.textField, defaultValue: link, width: "100%", link, readonly: true }),
  /* @__PURE__ */ jsx8("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.copyButtonContainer, children: /* @__PURE__ */ jsx8(copyLinkButton_default, { link }) })
] });
var QrCodeLink = ({ currentPage, tabId }) => {
  const title = `qrcode de la page ${currentPage == null ? void 0 : currentPage.displayTitle}`;
  const src = generateQrcodeUrl({ slug: _6.get("slug", currentPage), tabId, type: "image" });
  const [isFullScreen, setIsFullScreen] = useState3(false);
  const toggleFullScreen = useCallback2(() => setIsFullScreen((prevIsFullScreen) => !prevIsFullScreen), []);
  return /* @__PURE__ */ jsx8("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.contentImg, "data-fullscreen": +isFullScreen, onClick: toggleFullScreen, children: /* @__PURE__ */ jsx8("img", { className: src_internals_components_modal_shareModal_defaultShareModal_default.img, src, title, alt: title }) });
};
var RenewalWarningToast = () => /* @__PURE__ */ jsx8(
  Toast,
  {
    withIcon: true,
    className: src_internals_components_modal_shareModal_defaultShareModal_default.toast,
    severity: "secondary",
    message: /* @__PURE__ */ jsxs5(Fragment2, { children: [
      "Pour que vos \xE9l\xE8ves voient le m\xEAme contenu que vous, demandez-leur de cliquer sur",
      " ",
      /* @__PURE__ */ jsx8("strong", { children: `"Afficher la version d'origine"` })
    ] })
  }
);
var ShareWithLinkOrQrCode = ({ link, currentPage, isOffline, withRenewalWarning = false, tabId }) => /* @__PURE__ */ jsxs5(Fragment2, { children: [
  /* @__PURE__ */ jsx8("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.subtitle, style: { "--s-marginbottom": `${24}px` }, children: "La page sera accessible \xE0 toute personne disposant du lien\xA0:" }),
  /* @__PURE__ */ jsx8(LinkShareInput, { link }),
  /* @__PURE__ */ jsx8(Divider, { className: src_internals_components_modal_shareModal_defaultShareModal_default.divider }),
  isOffline ? /* @__PURE__ */ jsxs5(Fragment2, { children: [
    /* @__PURE__ */ jsx8("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.subtitle, style: { "--s-marginbottom": `${24}px` }, children: "Vous devez \xEAtre connect\xE9 \xE0 Internet pour acc\xE9der \xE0 la fonctionnalit\xE9 QR code." }),
    /* @__PURE__ */ jsx8("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.centerAlign, children: /* @__PURE__ */ jsx8(Icon2, { name: "wifislash" }) })
  ] }) : /* @__PURE__ */ jsxs5(Fragment2, { children: [
    /* @__PURE__ */ jsx8("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.subtitle, style: { "--s-marginbottom": `${24}px` }, children: "Scannez le QR code pour partager la page :" }),
    /* @__PURE__ */ jsx8("div", { className: src_internals_components_modal_shareModal_defaultShareModal_default.centerAlign, children: /* @__PURE__ */ jsx8(QrCodeLink, { currentPage, tabId }) })
  ] }),
  withRenewalWarning && /* @__PURE__ */ jsx8(RenewalWarningToast, {})
] });
var DefaultShareModal = ({
  isModalOpen,
  closeModal,
  link,
  title = "Partager",
  currentPage,
  className,
  isOffline,
  tabId
}) => isModalOpen && /* @__PURE__ */ jsx8(Modal2, { title, closeModal, className, children: /* @__PURE__ */ jsx8(ShareWithLinkOrQrCode, { link, currentPage, isOffline, tabId }) });
var defaultShareModal_default = DefaultShareModal;

// src/internals/components/modal/shareModal/studentShareModal.jsx
import { useCallback as useCallback3, useState as useState4 } from "react";
import _7 from "lodash/fp.js";
import { Button as Button5, Modal as Modal3, SelectList, Tab, Tabs } from "@lls/lls-kit";
import { makeComponent } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_modal_shareModal_studentShareModal.module.css
var src_internals_components_modal_shareModal_studentShareModal_default = { "dialogContent": "sk-H06heq-dialogContent", "fixedContent": "sk-H06heq-fixedContent", "selectList": "sk-H06heq-selectList", "subtitle": "sk-H06heq-subtitle", "sharedTeacher": "sk-H06heq-sharedTeacher", "centeredButtonContainer": "sk-H06heq-centeredButtonContainer", "greyText": "sk-H06heq-greyText" };

// src/internals/components/modal/shareModal/studentShareModal.jsx
import { Fragment as Fragment3, jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var StyledSubtitle = makeComponent("div", src_internals_components_modal_shareModal_studentShareModal_default.subtitle);
var formatTeacherToOption = (teacher) => ({
  value: teacher,
  label: _7.get("name", teacher),
  labelExtension: `- ${_7.get("subject", teacher)}`
});
var TeacherList = ({ selectTeacher, teachersList, selectedTeacher }) => {
  const options = _7.map(formatTeacherToOption, teachersList);
  const selectedOption = formatTeacherToOption(selectedTeacher);
  const selectOption = useCallback3(
    (selected) => {
      selectTeacher(_7.get("value", selected));
    },
    [selectTeacher]
  );
  return /* @__PURE__ */ jsxs6(Fragment3, { children: [
    /* @__PURE__ */ jsx9("div", { className: src_internals_components_modal_shareModal_studentShareModal_default.subtitle, children: 'S\xE9lectionnez le professeur \xE0 qui vous devez envoyer votre travail puis cliquez sur le bouton "Partager".' }),
    /* @__PURE__ */ jsx9(
      SelectList,
      {
        className: src_internals_components_modal_shareModal_studentShareModal_default.selectList,
        "data-clarity-mask": "true",
        options,
        selectedOption,
        selectOption
      }
    )
  ] });
};
var ModalMenu = ({ selectedTab, handleTabChange, isOffline, openOfflineModal }) => /* @__PURE__ */ jsxs6(Tabs, { value: selectedTab, onChange: handleTabChange, variant: "noBackground", children: [
  isOffline ? /* @__PURE__ */ jsx9("div", { onClick: openOfflineModal, children: /* @__PURE__ */ jsx9(Tab, { disabled: true, children: "Professeur" }) }) : /* @__PURE__ */ jsx9(Tab, { children: "Professeur" }),
  /* @__PURE__ */ jsx9(Tab, { children: "Lien" })
] });
var StudentShareModal = ({
  isModalOpen,
  closeModal,
  link,
  teachersList = [],
  onShare = _7.noop,
  sharedUser,
  currentPage,
  className,
  isOffline,
  openOfflineModal,
  tabId
}) => {
  const [selectedTeacher, setSelectedTeacher] = useState4(void 0);
  const [selectedTab, setSelectedTab] = useState4(_7.isEmpty(teachersList) || isOffline ? 1 : 0);
  const handleTabChange = useCallback3((value) => {
    setSelectedTab(value);
  }, []);
  const share = useCallback3(() => {
    onShare(selectedTeacher);
    closeModal();
  }, [onShare, selectedTeacher, closeModal]);
  const notifiy = useCallback3(() => {
    onShare(sharedUser);
    closeModal();
  }, [onShare, sharedUser, closeModal]);
  const selectTeacher = useCallback3((teacher) => {
    setSelectedTeacher(teacher);
  }, []);
  return isModalOpen && /* @__PURE__ */ jsx9(Modal3, { title: "Partager", closeModal, className, children: /* @__PURE__ */ jsxs6("div", { className: src_internals_components_modal_shareModal_studentShareModal_default.dialogContent, children: [
    (!_7.isEmpty(teachersList) || sharedUser) && /* @__PURE__ */ jsx9(
      ModalMenu,
      {
        selectedTab,
        handleTabChange,
        isOffline,
        openOfflineModal
      }
    ),
    /* @__PURE__ */ jsxs6("div", { className: src_internals_components_modal_shareModal_studentShareModal_default.fixedContent, children: [
      (!_7.isEmpty(teachersList) || sharedUser) && selectedTab === 0 && (!sharedUser ? /* @__PURE__ */ jsxs6(Fragment3, { children: [
        /* @__PURE__ */ jsx9(
          TeacherList,
          {
            selectTeacher,
            selectedTeacher,
            teachersList
          }
        ),
        /* @__PURE__ */ jsx9("div", { className: src_internals_components_modal_shareModal_studentShareModal_default.centeredButtonContainer, children: /* @__PURE__ */ jsx9(Button5, { onClick: share, disabled: _7.isUndefined(selectedTeacher), icon: "share", children: "Partager" }) })
      ] }) : /* @__PURE__ */ jsxs6(Fragment3, { children: [
        /* @__PURE__ */ jsxs6("div", { className: src_internals_components_modal_shareModal_studentShareModal_default.sharedTeacher, children: [
          "Votre travail est partag\xE9 avec le professeur :",
          /* @__PURE__ */ jsx9("br", {}),
          sharedUser.name,
          " - ",
          /* @__PURE__ */ jsx9("span", { className: src_internals_components_modal_shareModal_studentShareModal_default.greyText, children: sharedUser.subject })
        ] }),
        /* @__PURE__ */ jsx9("div", { className: src_internals_components_modal_shareModal_studentShareModal_default.centeredButtonContainer, children: /* @__PURE__ */ jsx9(Button5, { onClick: notifiy, icon: "bell", children: "Notifier" }) })
      ] })),
      selectedTab === 1 && /* @__PURE__ */ jsx9(ShareWithLinkOrQrCode, { link, currentPage, isOffline, tabId })
    ] })
  ] }) });
};
var studentShareModal_default = StudentShareModal;

// src/internals/components/modal/shareModal/teacherShareModal.jsx
import { useCallback as useCallback4, useEffect, useState as useState5 } from "react";
import { Button as Button6, Modal as Modal4, SelectList as SelectList2, Tab as Tab2, Tabs as Tabs2, Tooltip as Tooltip2 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent2 } from "@lls/utils";
import _9 from "lodash/fp.js";

// src/internals/utils/page.ts
import _8 from "lodash/fp.js";
var checkNumericPage = (page) => {
  const numericOrder = page == null ? void 0 : page.numericOrder;
  return !!numericOrder && _8.isInteger(numericOrder) && numericOrder >= 0;
};
var sortPages = _8.sortBy([
  "page",
  (page) => _8.get("numericOrder", page) || 0
]);
var isWorkplanPage = (page) => (page == null ? void 0 : page.isWorkplan) === true;
var isModifiedPage = (page) => (page == null ? void 0 : page.isOriginal) === false;
var isOriginalPage = (page) => (page == null ? void 0 : page.isOriginal) === true;
var isModifiedPageFromOriginalPage = (page) => isModifiedPage(page) && (page == null ? void 0 : page.originalPage) === (page == null ? void 0 : page.parent);
var checkSwitchPagePermission = ({
  page,
  user,
  isFreeMode,
  isEducationalGuide
}) => {
  if (isEducationalGuide) return true;
  return !(page == null ? void 0 : page.isPartOfSession) && !isFreeMode && (isOriginalPage(page) || isModifiedPageFromOriginalPage(page) && !!(user == null ? void 0 : user.isStudent)) && !checkNumericPage(page);
};
var checkShareButtonPermission = ({
  isCreatingPage,
  isPresentationMode,
  isPrintMode,
  user,
  page,
  isFreeMode
}) => !isFreeMode && !isCreatingPage && !isPresentationMode && !isPrintMode && (isTeacher(user) || !isOriginalPage(page));
var isPageOwner = (page, user) => {
  const pageUserId = _8.get("user", page);
  const userId = _8.get("id", user);
  return !_8.isNil(userId) && pageUserId === userId;
};
var WITHOUT_GROUP = { id: -1, name: "Sans classe" };
var getStudentsFromGroup = ({ selectedGroup, sharedPages, groups }) => (selectedGroup == null ? void 0 : selectedGroup.id) === WITHOUT_GROUP.id ? getStudentsWithoutGroup({
  selectedGroup,
  withoutGroup: WITHOUT_GROUP,
  userIds: _8.map((p) => p.user, sharedPages),
  groups
}) : _8.get("students", selectedGroup);
var transformPages = ({ pages, studentById }) => {
  return _8.map((page) => {
    var _a;
    const fullName = getStudentFullName(studentById == null ? void 0 : studentById[((_a = page == null ? void 0 : page.user) == null ? void 0 : _a.toString()) ?? ""]);
    const sharedAt = _8.get("sharedCorrections.0.updatedAt", page);
    return _8.assign(page, { studentFullName: fullName, sharedAt });
  })(pages);
};
var studentsToPagesNotShared = ({ selectedGroup, sharedPages }) => {
  const selectedGroupStudentIds = selectedGroup == null ? void 0 : selectedGroup.students;
  const studentIdsWhoShared = _8.map("user", sharedPages);
  const studentIdsFromSelectedGroupWhoShared = _8.intersection(studentIdsWhoShared, selectedGroupStudentIds);
  if (_8.isEmpty(studentIdsFromSelectedGroupWhoShared)) return [];
  const studentIdsFromSelectedGroupWhoNotShared = _8.difference(selectedGroupStudentIds, studentIdsWhoShared);
  return _8.map(
    (id) => ({
      id,
      user: id,
      isShared: false,
      read: false
    }),
    studentIdsFromSelectedGroupWhoNotShared
  );
};
var getFilteredSharedPages = ({
  selectedGroup,
  sharedPages,
  groups,
  selectedStatus,
  readPageIds
}) => _8.flow(
  filterEntitiesSimpleFieldByValues("user", getStudentsFromGroup({ selectedGroup, sharedPages, groups })),
  selectedStatus ? _8.filter((page) => {
    return _8.isEqual(selectedStatus, READ_STATUSES.READ) ? _8.includes(page == null ? void 0 : page.id, readPageIds) : !_8.includes(page == null ? void 0 : page.id, readPageIds);
  }) : _8.identity
)(sharedPages);
var sortSharedPages = ({ sort, pages }) => {
  const { order = "asc", name } = sort ?? {};
  switch (name) {
    case "name":
      return _8.orderBy("studentFullName", order, pages);
    case "receivedAt":
      return _8.orderBy("updatedAt", order, pages);
    case "sharedAt":
      return _8.orderBy("sharedAt", order, pages);
    default:
      return pages;
  }
};
var getOrderedSharedPages = ({
  sharedPages,
  selectedGroup,
  groups,
  students,
  sort,
  selectedStatus,
  readPageIds
}) => {
  const studentById = _8.keyBy("id", students);
  const selectedGroupPagesNotShared = studentsToPagesNotShared({
    selectedGroup,
    sharedPages
  });
  const filteredPages = getFilteredSharedPages({
    selectedGroup,
    sharedPages: _8.concat(sharedPages, selectedGroupPagesNotShared),
    groups,
    selectedStatus,
    readPageIds
  });
  const pages = transformPages({ pages: filteredPages, studentById });
  return sortSharedPages({ sort, pages });
};
var shouldDisplayStudentShareModal = (currentUser, page) => isStudent(currentUser) && isPageOwner(page, currentUser) && isModifiedPage(page);

// tmp_esbuild1736180050074/_src_internals_components_modal_shareModal_teacherShareModal.module.css
var src_internals_components_modal_shareModal_teacherShareModal_default = { "centerAlign": "sk-VFklzG-centerAlign", "selectList": "sk-VFklzG-selectList", "actions": "sk-VFklzG-actions", "tooltip": "sk-VFklzG-tooltip", "groupTab": "sk-VFklzG-groupTab", "dialogContent": "sk-VFklzG-dialogContent" };

// src/internals/components/modal/shareModal/teacherShareModal.jsx
import { Fragment as Fragment4, jsx as jsx10, jsxs as jsxs7 } from "react/jsx-runtime";
var ResourceTab = ({ currentPage, fullscreenId, isOffline, openOfflineModal, ...props }) => {
  switch (true) {
    case isOffline:
      return /* @__PURE__ */ jsx10(Tab2, { disabled: true, onClick: openOfflineModal, children: "Ressources" });
    case (!isOffline && isOriginalPage(currentPage) && !_9.isEmpty(fullscreenId)):
      return /* @__PURE__ */ jsx10(
        Tooltip2,
        {
          className: src_internals_components_modal_shareModal_teacherShareModal_default.tooltip,
          position: "bottom",
          content: "La s\xE9lection de ressources n'est pas disponible en plein \xE9cran.",
          margin: 15,
          children: /* @__PURE__ */ jsx10(Tab2, { disabled: true, children: "Ressources" })
        }
      );
    case (!isOffline && !isOriginalPage(currentPage)):
      return /* @__PURE__ */ jsx10(
        Tooltip2,
        {
          className: src_internals_components_modal_shareModal_teacherShareModal_default.tooltip,
          position: "bottom",
          content: "La s\xE9lection de ressources n'est pas disponible sur les pages personnalis\xE9es.",
          margin: 15,
          children: /* @__PURE__ */ jsx10(Tab2, { disabled: true, children: "Ressources" })
        }
      );
    case (!isOffline && isOriginalPage(currentPage) && _9.isEmpty(fullscreenId) && currentPage.isPartOfSession):
      return /* @__PURE__ */ jsx10(
        Tooltip2,
        {
          className: src_internals_components_modal_shareModal_teacherShareModal_default.tooltip,
          position: "bottom",
          content: "La s\xE9lection de ressources n'est pas disponible sur les pages Exercices de r\xE9visions.",
          margin: 15,
          children: /* @__PURE__ */ jsx10(Tab2, { disabled: true, children: "Ressources" })
        }
      );
    case (!isOffline && isOriginalPage(currentPage) && _9.isEmpty(fullscreenId)):
      return /* @__PURE__ */ jsx10(Tab2, { ...props, children: "Ressources" });
  }
};
var ModalMenu2 = ({ selectedTab, handleTabChange, currentPage, fullscreenId, isOffline, openOfflineModal }) => /* @__PURE__ */ jsxs7(Tabs2, { value: selectedTab, onChange: handleTabChange, variant: "noBackground", children: [
  /* @__PURE__ */ jsx10(Tab2, { disabled: isOffline, onClick: isOffline ? openOfflineModal : _9.noop, "data-tour": "superkit-share-group-tab", children: "Classes" }),
  /* @__PURE__ */ jsx10(Tab2, { "data-tour": "superkit-share-link-tab", children: "Lien" }),
  /* @__PURE__ */ jsx10(
    ResourceTab,
    {
      currentPage,
      fullscreenId,
      isOffline,
      openOfflineModal,
      "data-tour": "superkit-share-resource-tab"
    }
  )
] });
var GroupTab = ({ groups, onManageGroupClick, onShareGroup, closeModal, withRenewalWarning }) => {
  const [selectedGroup, setSelectedGroup] = useState5();
  const onShareCallback = useCallback4(() => {
    closeModal();
    onShareGroup(selectedGroup);
  }, [closeModal, onShareGroup, selectedGroup]);
  const formatGroupToOption = (group) => ({
    value: group,
    label: _9.get("name", group)
  });
  const options = _9.map(formatGroupToOption, groups);
  const selectedOption = formatGroupToOption(selectedGroup);
  const selectOption = useCallback4((selected) => {
    setSelectedGroup(_9.get("value", selected));
  }, []);
  return /* @__PURE__ */ jsxs7("div", { className: src_internals_components_modal_shareModal_teacherShareModal_default.groupTab, children: [
    /* @__PURE__ */ jsx10("div", { className: "subtitle", children: "Choisissez la classe avec qui vous souhaitez partager cette page" }),
    _9.isEmpty(groups) ? /* @__PURE__ */ jsxs7(Fragment4, { children: [
      /* @__PURE__ */ jsx10("div", { className: "subtitle-2", children: "Vous n'avez pas d\xE9fini de classe d'\xE9l\xE8ves" }),
      /* @__PURE__ */ jsx10(Button6, { onClick: onManageGroupClick, children: "Cr\xE9er des classes" })
    ] }) : /* @__PURE__ */ jsxs7(Fragment4, { children: [
      /* @__PURE__ */ jsx10(
        SelectList2,
        {
          className: src_internals_components_modal_shareModal_teacherShareModal_default.selectList,
          "data-clarity-mask": "true",
          options,
          selectedOption,
          selectOption
        }
      ),
      /* @__PURE__ */ jsxs7("div", { className: src_internals_components_modal_shareModal_teacherShareModal_default.actions, children: [
        /* @__PURE__ */ jsx10(Button6, { onClick: onManageGroupClick, children: "G\xE9rer les classes" }),
        /* @__PURE__ */ jsx10(Button6, { onClick: onShareCallback, disabled: _9.isUndefined(selectedGroup), icon: "share", children: "Partager" })
      ] }),
      withRenewalWarning && /* @__PURE__ */ jsx10(RenewalWarningToast, {})
    ] })
  ] });
};
var TeacherShareModal = ({
  isModalOpen,
  closeModal,
  link,
  currentPage,
  onSelectClick = _9.noop,
  fullscreenId,
  groups,
  onManageGroupClick,
  onShareGroup,
  className,
  isOffline,
  openOfflineModal,
  withRenewalWarning = false,
  tabId
}) => {
  const select = useCallback4(() => {
    onSelectClick();
    closeModal();
    dispatchAnalyticsEvent2(ANALYTICS_EVENTS_PAGE_SHARE_STARTED);
  }, [onSelectClick, closeModal]);
  const [selectedTab, setSelectedTab] = useState5(isOffline ? 1 : 0);
  const handleTabChange = useCallback4((value) => {
    setSelectedTab(value);
  }, []);
  useEffect(() => {
    const setShareLinkTab = () => handleTabChange(1);
    const setShareResourceTab = () => handleTabChange(2);
    document.addEventListener("superkit-set-share-link-tab", setShareLinkTab);
    document.addEventListener("superkit-set-share-resource-tab", setShareResourceTab);
    document.addEventListener("superkit-close-share-modal", closeModal);
    return () => {
      document.removeEventListener("superkit-set-share-link-tab", setShareLinkTab);
      document.removeEventListener("superkit-set-share-resource-tab", setShareResourceTab);
      document.removeEventListener("superkit-close-share-modal", closeModal);
    };
  }, [handleTabChange, closeModal]);
  return isModalOpen && /* @__PURE__ */ jsx10(Modal4, { title: "Partager", closeModal, className, children: /* @__PURE__ */ jsxs7("div", { className: src_internals_components_modal_shareModal_teacherShareModal_default.dialogContent, children: [
    /* @__PURE__ */ jsx10(
      ModalMenu2,
      {
        selectedTab,
        handleTabChange,
        currentPage,
        fullscreenId,
        isOffline,
        openOfflineModal
      }
    ),
    selectedTab === 2 && /* @__PURE__ */ jsxs7(Fragment4, { children: [
      /* @__PURE__ */ jsx10(StyledSubtitle, { variant: "caption", component: "div", children: "S\xE9lectionnez les ressources \xE0 partager dans la page :" }),
      /* @__PURE__ */ jsx10("div", { className: src_internals_components_modal_shareModal_teacherShareModal_default.centerAlign, children: /* @__PURE__ */ jsx10(Button6, { onClick: select, children: "S\xE9lectionner les ressources" }) })
    ] }),
    selectedTab === 1 && /* @__PURE__ */ jsx10(
      ShareWithLinkOrQrCode,
      {
        link,
        currentPage,
        isOffline,
        withRenewalWarning,
        tabId
      }
    ),
    selectedTab === 0 && /* @__PURE__ */ jsx10(
      GroupTab,
      {
        groups,
        onManageGroupClick,
        onShareGroup,
        closeModal,
        withRenewalWarning
      }
    )
  ] }) });
};
var teacherShareModal_default = TeacherShareModal;

// src/internals/v2/utils/url.tsx
import _10 from "lodash/fp.js";
var generateQrcodeClassroomUrl = ({ code, type = "image" }) => `${config_default.export_qrcode_url}/classroom/${code}?type=${type}`;
var generateShareUrl2 = generatePageUrl(config_default.export_share_url);
var isFromLLS = _10.includes("lelivrescolaire.fr");

// src/internals/components/modal/shareModal/index.jsx
import _11 from "lodash/fp.js";
import { jsx as jsx11 } from "react/jsx-runtime";
var ShareModal = ({
  page,
  currentUser,
  teachersList,
  isModalOpen,
  closeModal,
  onShare = _11.noop,
  onShareGroup = _11.noop,
  sharedUser,
  onSelectClick,
  copyMessage,
  fullscreenId,
  groups = [],
  onManageGroupClick = _11.noop,
  isOffline = false,
  openOfflineModal = _11.noop,
  renewalDisplayed = true,
  tabId
}) => {
  const link = generateShareUrl2({ slug: _11.get("slug", page), fullscreenId, tabId });
  const displayStudentShareModal = shouldDisplayStudentShareModal(currentUser, page);
  const displayTeacherShareModal = isTeacher(currentUser);
  switch (true) {
    case !isModalOpen:
      return null;
    case displayStudentShareModal:
      return /* @__PURE__ */ jsx11(
        studentShareModal_default,
        {
          className: SHARE_MODAL_CLASSNAME,
          teachersList,
          link,
          tabId,
          isModalOpen,
          closeModal,
          onShare,
          sharedUser,
          currentPage: page,
          isOffline,
          openOfflineModal
        }
      );
    case displayTeacherShareModal:
      return /* @__PURE__ */ jsx11(
        teacherShareModal_default,
        {
          className: SHARE_MODAL_CLASSNAME,
          onSelectClick,
          link,
          tabId,
          isModalOpen,
          closeModal,
          fullscreenId,
          currentPage: page,
          groups,
          onManageGroupClick,
          onShareGroup,
          isOffline,
          openOfflineModal,
          withRenewalWarning: !renewalDisplayed
        }
      );
    default:
      return /* @__PURE__ */ jsx11(
        defaultShareModal_default,
        {
          className: SHARE_MODAL_CLASSNAME,
          copyMessage,
          link,
          tabId,
          isModalOpen,
          closeModal,
          currentPage: page,
          isOffline
        }
      );
  }
};
var shareModal_default = ShareModal;

// src/internals/components/modal/ttsModal/index.jsx
import _14 from "lodash/fp.js";
import React, { Suspense, useEffect as useEffect2, useState as useState6 } from "react";
import { AUDIO_CLASSNAME_DARK, AUDIO_CLASSNAME_LIGHT } from "@lls/lls-audio";
import { KIT_CLASSNAME_DARK_THEME, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME2, SelectField, SidePanel } from "@lls/lls-kit";
import { cx as cx4, openWindow } from "@lls/utils";

// src/internals/services/graphql.jsx
import request from "axios";
import _12 from "lodash/fp.js";
var headers = {
  "content-type": "application/json",
  "Access-Control-Allow-Origin": "*"
};
var wrapResponse = (r) => ({ body: r.data, status: r.status });
var post = async (endPoint, { body, params }) => {
  const res = await request.post(`${_12.get("api_node_js", config_default)}/${endPoint}`, body, {
    headers,
    ...params
  });
  return wrapResponse(res);
};

// src/internals/api/tts.jsx
var fetchTextToSpeechUrl = ({ text, voiceId }) => {
  if (!text) throw new Error(`Missing 'text' params to fetch tts url`);
  if (!voiceId) throw new Error(`Missing 'voiceId' params to fetch tts url`);
  return post("texttospeech", { body: { text, voiceId, noCache: true, type: "file" } }).then((response) => response.body);
};

// src/internals/utils/dom.ts
var isSsr = () => typeof window === "undefined";
var interop = (key) => (m) => ({ default: m[key] || m.default[key] });

// src/internals/utils/tts.jsx
import _13 from "lodash/fp.js";
var concat = _13.concat.convert({ rearg: true });
var FR_VOICE_ID = [
  {
    value: "Mathieu",
    displayName: "Mathieu",
    flag: "fr"
  },
  {
    value: "Celine",
    displayName: "C\xE9line",
    flag: "fr"
  },
  {
    value: "Chantal",
    displayName: "Chantal",
    flag: "ca"
  }
];
var ESP_VOICE_ID = [
  {
    value: "Conchita",
    displayName: "Maria",
    flag: "es"
  },
  {
    value: "Enrique",
    displayName: "Enrique",
    flag: "es"
  },
  {
    value: "Penelope",
    displayName: "Pen\xE9lope",
    flag: "as"
  },
  {
    value: "Miguel",
    displayName: "Miguel",
    flag: "as"
  }
];
var ANG_VOICE_ID = [
  {
    value: "Emma",
    displayName: "Emma",
    flag: "gb"
  },
  {
    value: "Amy",
    displayName: "Amy",
    flag: "gb"
  },
  {
    value: "Brian",
    displayName: "Brian",
    flag: "gb"
  },
  {
    value: "Joanna",
    displayName: "Joanna",
    flag: "us"
  },
  {
    value: "Ivy",
    displayName: "Ivy",
    flag: "us"
  },
  {
    value: "Joey",
    displayName: "Joey",
    flag: "us"
  },
  {
    value: "Justin",
    displayName: "Justin",
    flag: "us"
  },
  {
    value: "Nicole",
    displayName: "Nicole",
    flag: "au"
  },
  {
    value: "Russell",
    displayName: "Russell",
    flag: "au"
  },
  {
    value: "Geraint",
    displayName: "Geraint",
    flag: "ws"
  },
  {
    value: "Raveena",
    displayName: "Raveena",
    flag: "in"
  }
];
var getVoicesBySubjectId = (subjectId) => {
  switch (true) {
    case subjectId === 272:
      return ANG_VOICE_ID;
    case subjectId === 276:
      return ESP_VOICE_ID;
    default:
      return FR_VOICE_ID;
  }
};
var getVoiceIdBySubjectId = _13.flow(getVoicesBySubjectId, _13.get("0.value"));
var getVoices = (subjectId, forceFrench) => {
  const voices = getVoicesBySubjectId(subjectId);
  return forceFrench ? _13.flow(concat(FR_VOICE_ID), _13.uniqBy("value"))(voices) : voices;
};

// tmp_esbuild1736180050074/_src_internals_components_modal_ttsModal_index.module.css
var src_internals_components_modal_ttsModal_index_default = { "sidePanelContainer": "sk-oKgePG-sidePanelContainer" };

// src/internals/components/modal/ttsModal/icons.jsx
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var FlagAs = (props) => /* @__PURE__ */ jsxs8("svg", { width: 24, height: 24, viewBox: "0 -150 900 900", fill: "#FFF", ...props, children: [
  /* @__PURE__ */ jsx12("path", { d: "M0 0h900v600H0" }),
  /* @__PURE__ */ jsx12("path", { stroke: "#E00", strokeWidth: 120, d: "M0 60h900m0 240H0m0 240h900" }),
  /* @__PURE__ */ jsx12("path", { fill: "#0050F0", d: "M0 0v600l520-300" }),
  /* @__PURE__ */ jsx12("path", { d: "M114 382l59-183 59 183L77 269h192" })
] });
var FlagAu = (props) => /* @__PURE__ */ jsxs8("svg", { width: 24, height: 24, viewBox: "0 -1260 7560 7560", ...props, children: [
  /* @__PURE__ */ jsxs8("defs", { children: [
    /* @__PURE__ */ jsx12("clipPath", { id: "icon-flag-au_svg__c", children: /* @__PURE__ */ jsx12("path", { d: "M0 0v1.5h7V3H4.5zm4.5 0H2.25v3.5H0V3z" }) }),
    /* @__PURE__ */ jsx12("clipPath", { id: "icon-flag-au_svg__b", children: /* @__PURE__ */ jsx12("path", { d: "M0 0h4.5v3H0z" }) }),
    /* @__PURE__ */ jsx12(
      "path",
      {
        id: "icon-flag-au_svg__a",
        d: "M0-360l69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z"
      }
    ),
    /* @__PURE__ */ jsx12(
      "path",
      {
        id: "icon-flag-au_svg__e",
        d: "M0-210L54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z"
      }
    ),
    /* @__PURE__ */ jsx12("use", { id: "icon-flag-au_svg__d", xlinkHref: "#icon-flag-au_svg__a", transform: "scale(2.1)" })
  ] }),
  /* @__PURE__ */ jsx12("path", { fill: "#00008b", d: "M0 0h10080v5040H0z" }),
  /* @__PURE__ */ jsxs8("g", { clipPath: "url(#icon-flag-au_svg__b)", transform: "scale(840)", children: [
    /* @__PURE__ */ jsx12("path", { d: "M0 0l4.5 3m0-3L0 3", stroke: "#fff", strokeWidth: 0.6 }),
    /* @__PURE__ */ jsx12("path", { d: "M0 0l4.5 3m0-3L0 3", stroke: "red", strokeWidth: 0.4, clipPath: "url(#icon-flag-au_svg__c)" }),
    /* @__PURE__ */ jsx12("path", { d: "M2.25 0v3.5M0 1.5h7", stroke: "#fff" }),
    /* @__PURE__ */ jsx12("path", { d: "M2.25 0v3.5M0 1.5h7", stroke: "red", strokeWidth: 0.6 })
  ] }),
  /* @__PURE__ */ jsxs8("g", { fill: "#fff", children: [
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-au_svg__d", x: 1890, y: 3780 }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-au_svg__a", x: 5885, y: 4200 }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-au_svg__a", x: 4625, y: 2205 }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-au_svg__a", x: 5885, y: 840 }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-au_svg__a", x: 7005, y: 1869 }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-au_svg__e", x: 6389, y: 2730 })
  ] })
] });
var FlagCa = (props) => /* @__PURE__ */ jsxs8("svg", { width: 24, height: 24, viewBox: "0 -100 600 600", ...props, children: [
  /* @__PURE__ */ jsx12("path", { d: "M0 0h600v400H0z", fill: "#fff" }),
  /* @__PURE__ */ jsxs8("g", { id: "icon-flag-ca_svg__a", children: [
    /* @__PURE__ */ jsx12("path", { d: "M0 0h250v150H0z", fill: "#002495" }),
    /* @__PURE__ */ jsx12(
      "path",
      {
        d: "M149.5 93.1c1.6-2.4 1.5-7.6-1.7-9.5-2.5-1.2-5.2-.7-6.5.3-2.1 1.3-4.1 5.3-4.1 9.4h7.2v8.1h-15c.2 4.1 2.5 7.5 6.7 9.3-.5 1.7-3.1 5.3-6.6 5.1-.7 3.8-1.3 5.9-4.5 9.3-3.1-3.4-3.8-5.5-4.5-9.3-3.5.2-6-3.3-6.6-5.1 4.2-1.8 6.5-5.2 6.7-9.3h-15v-8.1h7.2c0-4.1-2-8.1-4.1-9.4-1.3-1.1-4.1-1.5-6.5-.3-3.2 1.8-3.4 7.1-1.7 9.5-15.2-2.8-13.7-17.5-8.5-22.8 4.2-4.3 8.7-5 12.3-3.6 8 2.9 13.4 12.4 13.6 26.7h4.2c0-13-2.3-17.1-8.1-33.4-3-7.7-1.2-17.2 4.1-25.9 1.9-3.1 4.3-6 7-9 2.7 3 5.1 5.9 7 9 5.3 8.8 7.1 18.3 4.1 25.9-5.9 16.3-8.1 20.4-8.1 33.4h4.2c.3-14.2 5.6-23.8 13.6-26.7 3.5-1.4 8.1-.7 12.3 3.6 5.2 5.3 6.7 20-8.5 22.8z",
        fill: "#fff"
      }
    )
  ] }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-ca_svg__a", x: 350 }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-ca_svg__a", y: 250 }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-ca_svg__a", x: 350, y: 250 })
] });
var FlagEs = (props) => /* @__PURE__ */ jsxs8("svg", { height: 24, width: 24, viewBox: "0 -125 750 750", ...props, children: [
  /* @__PURE__ */ jsx12("path", { fill: "#c60b1e", d: "M0 0h750v500H0z" }),
  /* @__PURE__ */ jsx12("path", { fill: "#ffc400", d: "M0 125h750v250H0z" }),
  /* @__PURE__ */ jsxs8("g", { stroke: "#000", strokeWidth: 0.39, children: [
    /* @__PURE__ */ jsxs8("g", { strokeWidth: 0.26, children: [
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#ad1519",
          strokeLinejoin: "round",
          d: "M167.99 222.24s-.51 0-.79-.16-1.13-.96-1.13-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.91.91-1.23 1.42-1.5.51-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.32 1.3-.32s.28-.16.56-.27c.29-.11.68-.11.91-.16.22-.06.79-.24 1.13-.26.52-.02 1.36.1 1.64.1s1.24.05 1.64.05c.39 0 1.8-.11 2.2-.11.39 0 .68-.05 1.13 0 .45.06 1.24.32 1.47.43s1.58.59 2.09.75 1.75.37 2.32.64c.56.27.91.72 1.19 1.1.28.37.34.78.45 1.05.11.26.11.84 0 1.11-.11.26-.51.81-.51.81l-.62 1.02-.79.64s-.57.54-1.02.48c-.45-.04-5.03-.86-7.97-.86s-7.64.86-7.64.86h.01z"
        }
      ),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12("ellipse", { cx: 175.66, cy: 215.68, rx: 1.38, ry: 2.5 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 175.68, cy: 215.68, rx: 0.64, ry: 2.3 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 175.68, cy: 213.04, rx: 0.93, ry: 0.87, stroke: "none" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.3,
            d: "M176.96 212.74v.58h-2.53v-.58h.94v-1.32h-.62v-.57h.62v-.57h.6v.57h.62v.57h-.62v1.32h.99"
          }
        ),
        /* @__PURE__ */ jsx12("path", { fill: "none", d: "M175.94 212.2a.93.87 0 11-.5 0" }),
        /* @__PURE__ */ jsx12("path", { d: "M175.68 222.08h-4.81l-.11-1.18-.23-1.23-.23-1.53c-1.33-1.75-2.55-2.9-2.96-2.65.1-.32.22-.56.47-.71 1.18-.7 3.61.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.82-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.41-.24-1.62.9-2.96 2.65l-.23 1.53-.23 1.23-.1 1.18h-4.84z" }),
        /* @__PURE__ */ jsx12("path", { fill: "none", d: "M167.55 215.44c.91-.53 3.02 1.14 4.73 3.74m11.55-3.74c-.91-.53-3.01 1.14-4.73 3.74" })
      ] }),
      /* @__PURE__ */ jsxs8("g", { id: "icon-flag-es_svg__a", fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12("path", { d: "M168.58 224.25c-.2-.57-.58-1.08-.58-1.08 1.95-.57 4.66-.93 7.67-.94 3.01.01 5.75.37 7.69.94 0 0-.22.38-.52.91-.17.3-.39.81-.38.81-1.75-.54-4.02-.81-6.8-.82-2.79.01-5.46.35-6.86.86.02 0-.1-.32-.23-.68h.01" }),
        /* @__PURE__ */ jsx12("path", { d: "M175.67 226.73c2.43-.01 5.11-.38 6.1-.63.66-.2 1.05-.49.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.71-.8-2.63 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.64.98.84.99.25 3.68.62 6.11.63zM183.48 222.08l-.59-.53s-.57.34-1.28.24c-.7-.11-.93-.97-.93-.97s-.79.67-1.44.62c-.65-.06-1.07-.62-1.07-.62s-.71.51-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72-1.47-.62-1.47-.62-.45.73-.99.92c-.54.18-1.24-.27-1.24-.27s-.12.27-.2.43-.31.19-.31.19l.18.47c1.93-.56 4.56-.91 7.53-.91s5.67.35 7.61.92l.2-.54h-.01z" }),
        /* @__PURE__ */ jsx12("path", { d: "M175.69 219.49l.28.05c-.05.12-.06.24-.06.38 0 .58.5 1.05 1.12 1.05.49 0 .91-.31 1.06-.73.01.01.11-.38.15-.38.03 0 .03.41.05.41.07.53.55.89 1.1.89.62 0 1.11-.47 1.11-1.06 0-.04 0-.08-.01-.12l.35-.35.19.44c-.07.14-.1.29-.1.46 0 .56.47 1.01 1.06 1.01.37 0 .69-.18.88-.45l.23-.29v.36c0 .34.14.66.49.71 0 0 .38.03.91-.38.52-.41.8-.75.8-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.31-.95.25-.32-.05-.55-.31-.67-.61-.23.14-.51.22-.8.22-.63 0-1.2-.35-1.42-.86-.29.31-.69.5-1.16.5-.51 0-.97-.23-1.26-.58-.28.27-.67.43-1.09.43-.55 0-1.05-.28-1.33-.69-.29.41-.78.69-1.34.69-.42 0-.81-.16-1.09-.43-.29.35-.75.58-1.25.58-.48 0-.88-.19-1.17-.5-.22.51-.79.86-1.42.86-.29 0-.56-.08-.79-.22-.12.3-.35.56-.68.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.29.34.81.75.91.38.91.38c.34-.05.49-.37.49-.71v-.36l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.89.89 0 00-.1-.46l.19-.44.35.35c-.01.04-.01.08-.01.12 0 .59.49 1.06 1.11 1.06.55 0 1.03-.36 1.11-.89.01 0 .01-.41.04-.41.05 0 .14.39.16.38.14.42.56.73 1.06.73.61 0 1.11-.47 1.11-1.05 0-.14 0-.26-.05-.38l.29-.05h.01z" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeLinejoin: "round",
            d: "M175.67 222.23c-3.01.01-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.98 7.82-.98s5.88.38 7.83.98c.13.04.22.19.18.32-.04.11-.2.21-.33.17-1.95-.57-4.67-.93-7.68-.94z"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M165.43 221c-.01.01-.38-.48-.65-.73-.2-.18-.68-.33-.68-.33 0-.08.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.35.32c.12.29.05.72.05.72s-.05.2-.14.3zM167.32 220.22l-.11.66-1.4.15-.21-.12.04-.23 1.06-.87.62.41" }),
        /* @__PURE__ */ jsx12("path", { d: "M165.45 220.75c.12-.12.36-.09.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5zM168.02 220.88c-.06-.18 0-.37.13-.42.14-.03.3.09.37.27.06.19 0 .38-.14.42-.13.04-.29-.08-.36-.27zM168.67 220.04l.51.48 1.22-.66.09-.21-.17-.17-1.4-.12-.25.68" }),
        /* @__PURE__ */ jsx12("path", { d: "M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32" }),
        /* @__PURE__ */ jsx12("path", { d: "M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.22 1.22-.64.52.52" }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 170.51, cy: 219.65, rx: 0.49, ry: 0.47 }),
        /* @__PURE__ */ jsx12("path", { d: "M172.87 219.95c-.03-.2.07-.37.21-.39s.28.13.3.33c.03.19-.07.37-.21.38-.14.02-.28-.13-.3-.32zM173.78 219.24l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62" }),
        /* @__PURE__ */ jsx12("path", { d: "M175.66 217.15l-.86.52.64 1.38.22.14.22-.14.64-1.38-.86-.52" }),
        /* @__PURE__ */ jsx12("path", { d: "M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.39.62" }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 175.67, cy: 219.21, rx: 0.49, ry: 0.47 }),
        /* @__PURE__ */ jsx12("path", { d: "M178.5 219.95c.02-.2-.08-.37-.22-.39s-.28.13-.3.33c-.02.19.07.37.21.38.14.02.28-.13.31-.32zM178.99 219.3l.26.63 1.4-.13.18-.16-.1-.22-1.22-.64-.52.52" }),
        /* @__PURE__ */ jsx12("path", { d: "M181.27 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32" }),
        /* @__PURE__ */ jsx12("path", { d: "M182.68 220.04l-.51.48-1.22-.66-.1-.21.19-.17 1.4-.12.24.68" }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 180.85, cy: 219.65, rx: 0.49, ry: 0.47 }),
        /* @__PURE__ */ jsx12("path", { d: "M183.34 220.88c.06-.18 0-.37-.13-.42-.14-.03-.3.09-.37.27-.06.19 0 .38.14.42.13.04.29-.08.36-.27zM185.73 221c.01.01.38-.48.66-.73.19-.18.67-.33.67-.33 0-.08-.28-.28-.58-.28-.18 0-.35.07-.45.2l-.04-.2s-.24.05-.36.32c-.11.29-.03.72-.03.72s.04.2.13.3zM183.84 220.22l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41" }),
        /* @__PURE__ */ jsx12("path", { d: "M185.74 220.75c-.11-.12-.35-.09-.53.06s-.24.38-.12.5c.12.13.36.1.54-.06.18-.15.23-.38.11-.5z" })
      ] }),
      /* @__PURE__ */ jsxs8("g", { id: "icon-flag-es_svg__b", fill: "none", children: [
        /* @__PURE__ */ jsx12("path", { fill: "#ad1519", d: "M168.05 224.3l.31-.5.65.13-.38.56-.58-.19" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#058e6e",
            d: "M170.85 223.81l-.69.11c-.18.02-.35-.09-.38-.26a.32.32 0 01.27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11"
          }
        ),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#fff", cx: 173.19, cy: 223.3, rx: 0.44, ry: 0.41 }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            d: "M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31s.14-.31.32-.31h1.96c.19 0 .33.14.33.31s-.15.31-.33.31h-.99"
          }
        ),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#fff", cx: 178.16, cy: 223.3, rx: 0.44, ry: 0.41 }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#058e6e",
            d: "M180.5 223.81l.69.11c.18.02.35-.09.38-.26a.313.313 0 00-.27-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.37.25a.3.3 0 00.27.35l.71.11"
          }
        ),
        /* @__PURE__ */ jsx12("path", { fill: "#ad1519", d: "M183.24 224.33l-.25-.53-.67.06.32.59.6-.12" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            strokeLinejoin: "round",
            d: "M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.69 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.43-3.89.65-6.33.65z"
          }
        ),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.01, d: "M176.8 226.08v-1.16m-.58 1.2l.01-1.23m-.43 1.25v-1.26" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.02, d: "M175.44 226.15v-1.27" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.03, d: "M175.09 226.15v-1.27" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.04, d: "M174.77 226.15v-1.27M174.44 226.15v-1.27" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.05, d: "M174.16 226.15v-1.27" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.06, d: "M173.61 226.08l-.01-1.15m.27 1.17v-1.21" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.07, d: "M173.1 226.03v-1.06m.26 1.09l-.01-1.13" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.08, d: "M172.42 225.97v-.93m.23.94V225m.23 1.02V225" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.09, d: "M172.19 225.96v-.9" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.1, d: "M171.97 225.92v-.85" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.11, d: "M171.73 225.89v-.78" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.12, d: "M171.24 225.82l-.01-.62m.26.66v-.7M170.99 225.77v-.55" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.13, d: "M170.76 225.73v-.46" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.14, d: "M170.51 225.67v-.36" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.15, d: "M170.26 225.64v-.27" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.18, d: "M169.99 225.58v-.13" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-es_svg__c", children: [
      /* @__PURE__ */ jsxs8("g", { fill: "#005bbf", children: [
        /* @__PURE__ */ jsx12("path", { d: "M191.28 330.68c-1.54 0-2.91-.33-3.93-.87-1-.51-2.36-.82-3.86-.82-1.51 0-2.9.32-3.91.83-1.01.53-2.4.86-3.92.86-1.54 0-2.92-.36-3.93-.9-1-.49-2.33-.79-3.79-.79-1.52 0-2.86.29-3.86.81-1.02.54-2.42.88-3.95.88v2.41c1.53 0 2.93-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.31 3.79.8 1.01.53 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1.01-.52 2.4-.84 3.91-.84 1.5 0 2.86.32 3.86.83 1.02.54 2.37.87 3.91.87l.02-2.41z" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ccc",
            d: "M191.28 333.09c-1.54 0-2.91-.33-3.93-.87-1-.51-2.36-.83-3.86-.83-1.51 0-2.9.32-3.91.84-1.01.53-2.4.86-3.92.86-1.54 0-2.92-.37-3.93-.9-1-.49-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v2.41c1.53 0 2.93-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.31 3.79.8 1.01.54 2.39.9 3.93.9 1.52 0 2.91-.34 3.92-.86s2.4-.84 3.91-.84c1.5 0 2.86.32 3.86.84 1.02.53 2.37.86 3.91.86l.02-2.41"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M191.28 335.5c-1.54 0-2.91-.33-3.93-.86-1-.52-2.36-.84-3.86-.84-1.51 0-2.9.32-3.91.84s-2.4.86-3.92.86c-1.54 0-2.92-.36-3.93-.9-1-.49-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v2.4c1.53 0 2.93-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1.01.54 2.39.89 3.93.89 1.52 0 2.91-.32 3.92-.85 1.01-.52 2.4-.83 3.91-.83 1.5 0 2.86.31 3.86.82 1.02.55 2.37.86 3.91.86l.02-2.4" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ccc",
            d: "M191.26 340.32c-1.54 0-2.89-.33-3.91-.87-1-.51-2.36-.82-3.86-.82-1.51 0-2.9.31-3.91.83s-2.4.86-3.92.86c-1.54 0-2.92-.37-3.93-.9-1-.5-2.33-.79-3.79-.79-1.52 0-2.86.29-3.86.81-1.02.53-2.42.88-3.95.88v-2.4c1.53 0 2.93-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1.01.54 2.39.89 3.93.89 1.52 0 2.91-.32 3.92-.85 1.01-.52 2.4-.83 3.91-.83 1.5 0 2.86.31 3.86.82 1.02.55 2.39.86 3.93.86l-.02 2.42"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M191.26 342.73c-1.54 0-2.89-.33-3.91-.86-1-.52-2.36-.84-3.86-.84-1.51 0-2.9.32-3.91.84s-2.4.86-3.92.86c-1.54 0-2.92-.37-3.93-.9-1-.5-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v-2.39c1.53 0 2.93-.37 3.95-.9 1-.52 2.34-.81 3.86-.81 1.45 0 2.79.3 3.79.79 1.01.53 2.39.9 3.93.9 1.52 0 2.91-.34 3.92-.86s2.4-.83 3.91-.83c1.5 0 2.86.31 3.86.82 1.02.54 2.38.87 3.93.87l-.02 2.41z" })
      ] }),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeLinejoin: "round",
            d: "M166.92 320.78c.05.21.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.09-.62-.13.05-.29.06-.44.06h-16.69c-.13 0-.29-.02-.41-.06z"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M167.33 319.27h16.69c.57 0 1.02.35 1.02.78s-.45.79-1.02.79h-16.69c-.56 0-1.02-.36-1.02-.79s.46-.78 1.02-.78zM164.27 329.86h22.87v-5.83h-22.87v5.83z" })
      ] }),
      /* @__PURE__ */ jsx12("path", { fill: "#ccc", d: "M167.55 318.32h16.25v-79.63h-16.25v79.63z" }),
      /* @__PURE__ */ jsx12("path", { fill: "none", d: "M179.13 238.8v79.46m1.83-79.46v79.46" }),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12("path", { d: "M164.58 232.37h22.29v-5.84h-22.29v5.84z" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeLinejoin: "round",
            d: "M166.92 236.26a.91.91 0 01.41-.07h16.69c.17 0 .32.03.46.08-.58-.19-.99-.71-.99-1.32s.45-1.14 1.03-1.33c-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.09.02c.6.18.94.71.94 1.29 0 .56-.38 1.13-.97 1.31z"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M167.33 236.19h16.69c.57 0 1.02.35 1.02.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78zM167.33 232.37h16.7c.57 0 1.03.3 1.03.66 0 .37-.46.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66z" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-es_svg__d", fill: "#ad1519", children: [
      /* @__PURE__ */ jsx12("path", { d: "M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.61.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07 1.34-1.08 2.19-2.69 2.19-4.49 0-1.87-.9-3.56-2.34-4.64z" }),
      /* @__PURE__ */ jsx12(
        "path",
        {
          strokeLinejoin: "round",
          d: "M200.4 268.47c-3.54-1.46-9.57-2.55-16.49-2.78-2.39.02-5.04.25-7.79.7-9.72 1.63-17.13 5.51-16.54 8.67.01.06.04.2.05.26 0 0-3.64-8.21-3.7-8.52-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.69-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82"
        }
      ),
      /* @__PURE__ */ jsx12("path", { d: "M167.52 278.47c-4.51-.32-7.58-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.11 5.67l.03-7.83" }),
      /* @__PURE__ */ jsx12(
        "path",
        {
          strokeLinejoin: "round",
          d: "M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.79l-.09-.17c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.91 3.2-10.44 4.09-4.54 1.57-9.04 4.54-8.63 5.64l-1.51-8.09v-.01z"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs8("g", { strokeWidth: 0.26, children: [
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#ad1519",
          strokeWidth: 0.27,
          d: "M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.51-1.08.64c-.59.14-1.41-.66-1.41-.66s-.57.8-1.07.99c-.51.18-1.13-.24-1.13-.24s-.23.39-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.31-1.07c-.02-.16-.08-.57-.08-.57-.13-.65.87-1.4 2.3-1.72.82-.19 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.19.82.53-.16 1.24-.17 2.07.02 1.42.32 2.43 1.07 2.3 1.72 0 0-.06.41-.08.57-.03.16-.32 1.07-.32 1.07l-.62.24-.68.72-.58.38s-.3.14-.48.05c-.43-.21-.66-.61-.66-.61s-.62.42-1.13.24c-.51-.19-1.07-.99-1.07-.99s-.82.8-1.42.66c-.59-.13-1.07-.64-1.07-.64s-.68.59-1.21.49c-.54-.11-1.27-.89-1.27-.89z"
        }
      ),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12("ellipse", { cx: 324.82, cy: 216.2, rx: 1.38, ry: 1.96 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 324.85, cy: 216.2, rx: 0.63, ry: 1.81 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 324.84, cy: 213.95, rx: 0.93, ry: 0.88, stroke: "none" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.3,
            d: "M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.58h.62v-.58h.61v.58h.61v.58h-.61v1.3h.98"
          }
        ),
        /* @__PURE__ */ jsx12("path", { fill: "none", d: "M325.11 213.12a.93.88 0 11-.51-.01" })
      ] }),
      /* @__PURE__ */ jsxs8("g", { fill: "none", strokeWidth: 0.21, children: [
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.26,
            strokeLinecap: "round",
            d: "M314.41 219.99c-.13-.33-.22-.7-.22-1.08 0-1.59 1.26-2.88 2.83-2.88.5 0 .96.13 1.37.37"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.26,
            d: "M319.48 217.93c-.15-.26-.29-.54-.29-.84 0-1.15 1.19-2.08 2.64-2.08.62 0 1.2.17 1.65.45M330.17 217.96c.15-.26.25-.57.25-.87 0-1.15-1.18-2.08-2.64-2.08-.62 0-1.19.17-1.64.45"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.26,
            strokeLinecap: "round",
            d: "M335.21 219.99c.13-.33.21-.7.21-1.08 0-1.59-1.26-2.88-2.82-2.88-.5 0-.97.13-1.38.37"
          }
        ),
        /* @__PURE__ */ jsx12("ellipse", { cx: 313.57, cy: 218.68, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 313.74, cy: 217.1, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 314.76, cy: 215.9, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 316.11, cy: 215.25, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 317.55, cy: 215.31, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#fff", cx: 318.43, cy: 217.08, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 318.68, cy: 215.58, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 319.81, cy: 214.64, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 321.23, cy: 214.19, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 322.67, cy: 214.24, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 326.94, cy: 214.24, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 328.39, cy: 214.19, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 329.8, cy: 214.64, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 330.93, cy: 215.58, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#fff", cx: 331.18, cy: 217.08, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 332.06, cy: 215.31, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 333.51, cy: 215.25, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 334.86, cy: 215.9, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 335.88, cy: 217.1, rx: 0.45, ry: 0.43 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 336.05, cy: 218.68, rx: 0.45, ry: 0.43 })
      ] }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-es_svg__a", x: 149.17 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-es_svg__b", x: 149.17 })
    ] }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-es_svg__c", x: 149.17 }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-es_svg__d", transform: "matrix(-1 0 0 1 500.57 0)" }),
    /* @__PURE__ */ jsx12("g", { fill: "#c8b100", stroke: "none", children: /* @__PURE__ */ jsx12("path", { d: "M166.42 264.65c1.99-.72 3.29-1.58 2.66-3.14-.41-1-1.43-1.19-2.97-.63l-2.71.99 2.44 6.03c.27-.12.54-.24.81-.34.28-.1.57-.18.85-.26l-1.08-2.64v-.01zm-1.18-2.91l.69-.25c.57-.21 1.21.1 1.5.8.21.53.16 1.13-.5 1.55-.21.13-.46.23-.7.33l-.99-2.43M172.78 259.22c-.29.08-.57.16-.86.22-.29.05-.59.09-.88.12l1.41 6.28 4.38-.88c-.05-.12-.12-.26-.14-.38-.03-.14-.03-.28-.04-.41-.77.22-1.61.46-2.61.66l-1.26-5.61M181.56 264.63c.82-2.28 1.82-4.46 2.81-6.67-.18.03-.36.06-.54.07s-.37.01-.54 0c-.53 1.61-1.18 3.21-1.87 4.8-.82-1.51-1.73-2.99-2.43-4.51-.34.04-.69.09-1.03.12-.34.02-.7.01-1.04.02 1.26 2.06 2.48 4.11 3.64 6.23.16-.03.32-.06.5-.08.16-.01.33.01.5.02M190.72 259.8c.15-.31.31-.6.48-.89-.24-.22-.96-.55-1.81-.63-1.79-.18-2.81.61-2.93 1.69-.26 2.26 3.31 2.07 3.14 3.57-.07.64-.75.9-1.48.83-.81-.08-1.41-.53-1.51-1.19l-.22-.02c-.12.39-.29.77-.48 1.15.53.34 1.21.53 1.85.59 1.83.19 3.22-.54 3.35-1.74.23-2.15-3.37-2.27-3.23-3.54.06-.53.47-.88 1.4-.79.67.07 1.08.43 1.26.95l.18.02M310.3 264.98c.62-2.33 1.41-4.58 2.19-6.87-.17.05-.35.09-.53.11-.17.03-.36.04-.54.05-.37 1.64-.88 3.29-1.42 4.94-.96-1.44-2-2.84-2.83-4.3-.34.07-.68.15-1.02.2s-.69.07-1.04.11c1.45 1.94 2.85 3.89 4.2 5.91.16-.04.32-.1.5-.12.16-.02.33-.02.49-.03M316.48 258.16c-.29.01-.59.04-.88.03-.3 0-.6-.04-.89-.06l-.12 6.41 4.49.08c-.03-.13-.06-.28-.06-.41s.04-.27.07-.4c-.81.05-1.68.1-2.71.08l.1-5.73M323.52 259.21c.72.06 1.41.19 2.1.31-.01-.13-.03-.27-.02-.41.01-.13.06-.26.1-.39l-6.07-.5c.01.14.03.27.02.4-.01.14-.06.27-.1.4.62-.02 1.37-.02 2.21.05l-.53 5.77c.29 0 .59 0 .88.03.3.02.59.07.88.11l.53-5.77M326.01 265.53c.29.05.59.09.88.15.28.06.57.15.85.23l.72-2.94.08.01c.16.41.38.9.49 1.19l.9 2.22c.36.06.71.11 1.05.18.36.08.7.18 1.04.28l-.31-.67c-.48-1-.99-2.01-1.41-3.02 1.12.04 1.98-.36 2.2-1.26.15-.62-.1-1.11-.68-1.53-.44-.31-1.28-.47-1.83-.6l-2.44-.53-1.54 6.29m3.14-5.42c.71.16 1.59.27 1.59 1.07-.01.21-.03.35-.06.48-.23.94-.94 1.26-2.13.91l.6-2.46M337.57 267.46c-.05.69-.18 1.37-.31 2.1.3.14.61.27.9.44.3.16.57.34.86.52l.6-7.23c-.14-.06-.27-.12-.41-.19-.13-.07-.25-.15-.37-.24l-6.38 4.05c.17.08.35.16.51.25.17.09.31.19.47.28.54-.45 1.1-.82 1.74-1.3l2.39 1.31v.01zm-1.81-1.66l2.13-1.37-.25 2.4-1.88-1.03" }) }),
    /* @__PURE__ */ jsxs8("g", { children: [
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#ad1519",
          strokeWidth: 0.26,
          d: "M249.65 182.72c6.64 0 12.56.99 16.41 2.51 2.2 1 5.16 1.73 8.4 2.17 2.47.33 4.81.39 6.85.24 2.73-.06 6.67.74 10.62 2.48 3.26 1.45 5.99 3.21 7.8 4.91l-1.57 1.4-.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6.21-.79 2.25-32.91-3.86-33.02 3.86-.79-2.25-2.61-.21-5.08-4.07-2.15-1.83-4.3-4.92-.44-3.96-1.58-1.4c1.82-1.7 4.54-3.46 7.8-4.91 3.95-1.74 7.89-2.54 10.62-2.48 2.04.15 4.38.09 6.85-.24 3.24-.44 6.2-1.17 8.4-2.17 3.86-1.52 9.44-2.51 16.08-2.51z"
        }
      ),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12("path", { d: "M225.34 191.42l1.38 1.11 2.08-3.4c-2.25-1.38-3.8-3.78-3.8-6.51 0-.31.02-.61.06-.91.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86-2.43-1.42-5.6-2.28-9.05-2.28-7.71 0-13.74 4.39-14.03 9.57-.03.31-.05.61-.05.92 0 2.76 1.26 5.26 3.26 6.99l-1.1 1.81" }),
        /* @__PURE__ */ jsx12("path", { d: "M225.43 191.46c-2.63-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.41-2.07 1.67-3.33 3.83-3.51 6.23-.03.31-.05.61-.05.92 0 2.76 1.26 5.26 3.26 6.99l-1.01 1.85" }),
        /* @__PURE__ */ jsx12("path", { d: "M202.21 194.89c-1.48-1.65-2.38-3.79-2.38-6.12 0-1.41.33-2.75.91-3.95 2.13-4.38 8.82-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.36 2.83-15.12 6.65a7.33 7.33 0 00-.73 3.2c0 2.32 1.09 4.4 2.79 5.82l-2.63 4.3-1.41-1.12 1.81-2.88z" }),
        /* @__PURE__ */ jsx12("path", { d: "M204.9 180.48c-1.91 1.21-3.36 2.69-4.16 4.34-.58 1.2-.91 2.54-.91 3.95 0 2.33.9 4.47 2.38 6.12l-1.6 2.59c-1.53-1.96-2.42-4.26-2.42-6.7 0-4.2 2.67-7.87 6.71-10.3zM250.04 171.27c1.76 0 3.28 1.16 3.64 2.73.23 1.38.38 2.95.41 4.62.01.18-.01.35-.01.52 0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.29-8.52 0-.2.04-.41.04-.61 0-.17-.01-.34-.01-.52.03-1.67.18-3.24.41-4.62.36-1.57 1.94-2.73 3.7-2.73z" }),
        /* @__PURE__ */ jsx12("path", { d: "M250.04 172.94c.91 0 1.68.58 1.87 1.39.23 1.31.37 2.8.4 4.38 0 .16-.01.32-.01.48 0 .2.03.39.04.59.05 3.32.53 6.25 1.21 8.05l-3.54 3.35-3.54-3.35c.67-1.8 1.15-4.73 1.21-8.05 0-.2.04-.39.04-.59 0-.16-.01-.32-.01-.48.03-1.58.17-3.07.4-4.38.18-.81 1.02-1.39 1.93-1.39zM274.7 191.42l-1.39 1.11-2.08-3.4c2.26-1.38 3.81-3.78 3.81-6.51 0-.31-.02-.61-.06-.91-.21-4.34-5.5-7.92-12.2-7.92-3.49 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86 2.44-1.42 5.6-2.28 9.06-2.28 7.71 0 13.74 4.39 14.03 9.57.03.31.05.61.05.92 0 2.76-1.27 5.26-3.27 6.99l1.11 1.81" }),
        /* @__PURE__ */ jsx12("path", { d: "M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.41 2.07 1.67 3.33 3.83 3.51 6.23.03.31.05.61.05.92 0 2.76-1.27 5.26-3.27 6.99l1.02 1.85" }),
        /* @__PURE__ */ jsx12("path", { d: "M297.83 194.89c1.47-1.65 2.38-3.79 2.38-6.12 0-1.41-.33-2.75-.91-3.95-2.14-4.38-8.82-7.57-16.76-7.57-2.16 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.81-2.88z" }),
        /* @__PURE__ */ jsx12("path", { d: "M295.14 180.48c1.91 1.21 3.36 2.69 4.16 4.34.58 1.2.91 2.54.91 3.95 0 2.33-.91 4.47-2.38 6.12l1.6 2.59c1.53-1.96 2.41-4.26 2.41-6.7 0-4.2-2.67-7.87-6.7-10.3z" }),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#005bbf", strokeWidth: 0.26, cx: 250.05, cy: 167.3, rx: 4.43, ry: 4.2 }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.26,
            d: "M248.89 155.54v2.26h-2.42v2.3h2.42V166.71h-3.05c-.03.21-.22.37-.22.59 0 .58.12 1.14.35 1.64 0 .02.02.02.03.03h8.12c0-.01.02-.01.03-.03.22-.5.35-1.06.35-1.64 0-.22-.19-.38-.22-.59h-2.96v-6.61h2.42v-2.3h-2.42v-2.26h-2.43z"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs8("g", { fill: "#fff", children: [
        /* @__PURE__ */ jsx12("ellipse", { cx: 250.04, cy: 188.94, rx: 1.91, ry: 1.8 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 250.04, cy: 185.4, rx: 1.91, ry: 1.8 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 250.04, cy: 181.6, rx: 1.52, ry: 1.44 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 250.04, cy: 178.18, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 250.04, cy: 175.18, rx: 0.88, ry: 0.83 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 198.94, cy: 198.67, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 197.44, cy: 196.02, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 196.44, cy: 192.94, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 196.31, cy: 189.64, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 197.12, cy: 186.4, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 198.81, cy: 183.45, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 201.06, cy: 181.02, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 203.68, cy: 179.01, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 206.8, cy: 177.36, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 210.04, cy: 176.19, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 213.66, cy: 175.54, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 217.1, cy: 175.36, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 220.47, cy: 175.48, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 224.21, cy: 190.32, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 222.34, cy: 187.65, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 221.35, cy: 184.75, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 221.47, cy: 181.57, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 222.16, cy: 178.37, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 223.84, cy: 175.48, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 226.4, cy: 173.47, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 229.39, cy: 171.81, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 232.7, cy: 170.82, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 236.13, cy: 170.23, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 239.5, cy: 170.28, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 242.99, cy: 170.87, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 246.23, cy: 171.99, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 253.8, cy: 171.99, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 257.04, cy: 170.87, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 260.54, cy: 170.28, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 263.9, cy: 170.23, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 267.34, cy: 170.82, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 270.64, cy: 171.81, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 273.64, cy: 173.47, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 276.19, cy: 175.48, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 277.88, cy: 178.37, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 278.57, cy: 181.57, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 278.69, cy: 184.75, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 277.69, cy: 187.65, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 275.83, cy: 190.32, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 279.57, cy: 175.48, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 282.94, cy: 175.36, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 286.38, cy: 175.54, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 290, cy: 176.19, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 293.24, cy: 177.36, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 296.36, cy: 179.01, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 298.97, cy: 181.02, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 301.22, cy: 183.45, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 302.91, cy: 186.4, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 303.72, cy: 189.64, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 303.6, cy: 192.94, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 302.6, cy: 196.02, rx: 1.1, ry: 1.04 }),
        /* @__PURE__ */ jsx12("ellipse", { cx: 301.1, cy: 198.67, rx: 1.1, ry: 1.04 })
      ] }),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12("path", { d: "M250.15 226.18c-12.26-.02-23.25-1.47-31.09-3.83-.57-.18-.87-.7-.84-1.25-.01-.52.29-1 .84-1.17 7.84-2.36 18.83-3.81 31.09-3.83 12.27.02 23.25 1.47 31.09 3.83.55.17.84.65.83 1.17.03.55-.27 1.07-.83 1.25-7.84 2.36-18.82 3.81-31.09 3.83" }),
        /* @__PURE__ */ jsx12("path", { d: "M250.07 216.09c-12.41.03-23.55 1.58-31.39 4 .65-.31.59-1.12-.22-3.2-.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44.02 25.6 1.62 34.27 4.18 0 0-1.53-.11-2.51 2.42-.81 2.08-.87 2.89-.21 3.2-7.84-2.42-19.19-3.97-31.6-4" }),
        /* @__PURE__ */ jsx12("path", { d: "M250.12 210.3c-13.43.02-25.5 1.62-34.16 4.18-.58.17-1.19-.05-1.38-.6s.12-1.18.7-1.35c8.71-2.67 21.08-4.35 34.84-4.38 13.77.03 26.19 1.71 34.9 4.38.58.17.89.8.7 1.35s-.8.77-1.38.6c-8.67-2.56-20.78-4.16-34.22-4.18" }),
        /* @__PURE__ */ jsx12("path", { d: "M250.2 199.78l1.23.22c-.19.5-.24 1.05-.24 1.63 0 2.57 2.21 4.65 4.92 4.65 2.18 0 4.04-1.35 4.67-3.21.08.05.47-1.68.68-1.66.17.02.15 1.8.22 1.77.31 2.34 2.46 3.93 4.87 3.93 2.71 0 4.91-2.08 4.91-4.65 0-.19-.01-.38-.04-.57l1.54-1.52.83 1.94c-.33.61-.46 1.3-.46 2.03 0 2.46 2.1 4.44 4.69 4.44 1.63 0 3.06-.78 3.9-1.97l.99-1.25-.01 1.53c0 1.55.66 2.93 2.16 3.18 0 0 1.73.1 4.03-1.7 2.29-1.8 3.55-3.29 3.55-3.29l.2 1.8s-1.9 2.95-3.97 4.15c-1.14.66-2.86 1.35-4.23 1.13-1.44-.24-2.48-1.4-3.01-2.74-1.03.61-2.25.97-3.55.97-2.81 0-5.33-1.54-6.32-3.86-1.29 1.4-3.09 2.25-5.2 2.25-2.24 0-4.29-1.01-5.57-2.56a7.198 7.198 0 01-4.88 1.87c-2.48 0-4.69-1.22-5.94-3.05-1.25 1.83-3.46 3.05-5.94 3.05-1.89 0-3.61-.71-4.87-1.87-1.28 1.55-3.34 2.56-5.58 2.56-2.11 0-3.9-.85-5.19-2.25-1 2.32-3.52 3.86-6.32 3.86-1.31 0-2.52-.36-3.55-.97-.54 1.34-1.57 2.5-3.02 2.74-1.36.22-3.08-.47-4.22-1.13-2.08-1.2-3.98-4.15-3.98-4.15l.2-1.8s1.27 1.49 3.56 3.29c2.29 1.81 4.02 1.7 4.02 1.7 1.51-.25 2.16-1.63 2.16-3.18l-.01-1.53.99 1.25c.84 1.19 2.28 1.97 3.9 1.97 2.59 0 4.69-1.98 4.69-4.44 0-.73-.13-1.42-.46-2.03l.83-1.94 1.54 1.52c-.02.19-.04.38-.04.57 0 2.57 2.2 4.65 4.91 4.65 2.42 0 4.56-1.59 4.88-3.93.06.03.05-1.75.22-1.77.2-.02.6 1.71.67 1.66.64 1.86 2.49 3.21 4.68 3.21 2.71 0 4.91-2.08 4.91-4.65 0-.58-.03-1.13-.24-1.63l1.29-.22" }),
        /* @__PURE__ */ jsx12("path", { d: "M208.37 206.32a2.24 2.24 0 00-.72-1.06c-.79-.68-1.84-.79-2.36-.25-.07.07-.13.17-.17.25 0 0-1.11-2.08-2.41-2.78-1.29-.7-3.49-.52-3.49-.52 0-1.6 1.3-2.89 2.99-2.89.99 0 1.92.41 2.48 1.11l.23-1.07s1.36.27 1.98 1.82-.06 3.8-.06 3.8.34-.96.85-1.61c.51-.64 1.81-1.34 2.49-1.66.67-.31 1.37-.79 1.37-.79s.03.18.05.61c.03.51-.01.83-.01.83 1.24-.17 2.69.04 3.83.48-.49.95-1.41 1.84-2.62 2.3 0 0 .44.36.83.75.34.34.44.49.44.49s-.85.13-1.27.19c-.43.05-1.84.28-2.69.22-.62-.04-1.32-.14-1.74-.22" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            d: "M205.29 205.01c.52-.54 1.57-.43 2.36.25.8.67 1.02 1.66.51 2.19-.51.54-1.57.42-2.36-.25-.79-.68-1.02-1.66-.51-2.19"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M216.39 205.91c-.28-.83-.03-1.65.57-1.83.6-.19 1.32.33 1.6 1.16s.03 1.65-.57 1.84c-.6.18-1.31-.34-1.6-1.17"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M226.12 201.86c-.33-.27-.59-.64-.67-1.08s.01-.87.23-1.23c0 0-.88-.44-1.83-.69-.72-.19-1.99-.2-2.37-.2-.38-.02-1.15-.03-1.15-.03s.07.17.28.55c.27.46.5.75.5.75-1.27.29-2.35 1.12-3.03 2.09.99.68 2.3 1.1 3.6.97 0 0-.12.34-.2.86-.06.43-.06.61-.06.61s.71-.26 1.07-.39c.35-.13 1.54-.55 2.15-.96.8-.54 1.48-1.25 1.48-1.25" }),
        /* @__PURE__ */ jsx12("path", { d: "M225.68 191.65c1.06.67 1.98 1.79 2.3 3.03 0 0 .13-.25.71-.59.59-.33 1.09-.32 1.09-.32s-.17.97-.25 1.32c-.09.34-.09 1.38-.32 2.32-.23.93-.63 1.68-.63 1.68-.42-.34-.99-.51-1.58-.41-.58.1-1.06.44-1.32.9 0 0-.66-.58-1.21-1.38-.55-.81-.93-1.78-1.13-2.08-.21-.3-.72-1.15-.72-1.15s.47-.18 1.14-.05c.67.12.88.32.88.32-.14-1.28.28-2.62 1.04-3.59" }),
        /* @__PURE__ */ jsx12("path", { d: "M228.97 201.38a1.727 1.727 0 00-.42-2.3s.67-.71 1.47-1.26c.6-.41 1.8-.82 2.15-.95.36-.13 1.07-.4 1.07-.4s0 .18-.06.61c-.08.52-.2.87-.2.87 1.3-.14 2.62.29 3.61.98-.69.97-1.77 1.79-3.04 2.08 0 0 .23.28.5.74.21.39.28.56.28.56l-1.15-.03c-.38 0-1.65-.01-2.37-.2-.95-.25-1.84-.69-1.84-.69" }),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#ad1519", cx: 227.37, cy: 200.45, rx: 2.17, ry: 2.06 }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M237.76 201.77c-.11-.87.31-1.63.93-1.7.63-.07 1.23.57 1.34 1.44.11.86-.3 1.63-.93 1.7-.62.07-1.22-.57-1.34-1.44"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M248.5 199.83c-.32-.36-.53-.82-.53-1.33 0-.5.19-.97.51-1.32 0 0-.89-.67-1.89-1.12-.77-.35-2.18-.59-2.6-.67l-1.28-.24s.04.2.2.67c.2.56.4.93.4.93-1.47.08-2.85.81-3.81 1.76.96.94 2.34 1.66 3.81 1.75 0 0-.2.36-.4.93-.16.46-.2.67-.2.67l1.28-.24c.42-.08 1.83-.32 2.6-.67 1-.46 1.91-1.11 1.91-1.11" }),
        /* @__PURE__ */ jsx12("path", { d: "M250.11 188.36c1.05.95 1.85 2.36 1.95 3.82 0 0 .19-.27.91-.53.73-.26 1.28-.16 1.28-.16s-.39 1.05-.55 1.42c-.17.37-.39 1.53-.84 2.53-.44 1-1.05 1.76-1.05 1.76-.4-.45-1-.75-1.67-.75-.68 0-1.27.3-1.67.75 0 0-.61-.76-1.05-1.76-.45-1-.67-2.16-.84-2.53s-.56-1.42-.56-1.42.56-.1 1.28.16.92.53.92.53c.1-1.46.86-2.87 1.89-3.82" }),
        /* @__PURE__ */ jsx12("path", { d: "M251.76 199.83c.33-.36.53-.82.53-1.33 0-.5-.19-.97-.51-1.32 0 0 .89-.67 1.9-1.12.76-.35 2.17-.59 2.6-.67l1.26-.24s-.02.2-.19.67c-.2.56-.4.93-.4.93 1.47.08 2.86.81 3.81 1.76-.95.94-2.33 1.66-3.81 1.75 0 0 .2.36.4.93.16.46.19.67.19.67l-1.26-.24c-.43-.08-1.84-.32-2.6-.67-1.01-.46-1.92-1.11-1.92-1.11" }),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#ad1519", cx: 250.14, cy: 198.5, rx: 2.17, ry: 2.06 }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M262.58 201.77c.11-.87-.3-1.63-.93-1.7s-1.23.57-1.34 1.44c-.11.86.31 1.63.93 1.7.63.07 1.23-.57 1.34-1.44"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M271.38 201.38c-.22-.35-.32-.79-.25-1.23.09-.44.33-.81.67-1.07 0 0-.67-.71-1.47-1.26-.61-.41-1.8-.82-2.16-.95-.35-.13-1.06-.4-1.06-.4s-.01.18.06.61c.08.52.19.87.19.87-1.29-.14-2.61.29-3.6.98.68.97 1.77 1.79 3.03 2.08 0 0-.23.28-.49.74-.22.39-.28.56-.28.56l1.14-.03c.38 0 1.66-.01 2.37-.2.95-.25 1.84-.69 1.84-.69" }),
        /* @__PURE__ */ jsx12("path", { d: "M274.67 191.65c-1.06.67-1.98 1.79-2.31 3.03 0 0-.12-.25-.71-.59-.58-.33-1.09-.32-1.09-.32s.17.97.26 1.32c.09.34.09 1.38.31 2.32.23.93.64 1.68.64 1.68.42-.34.99-.51 1.57-.41.59.1 1.06.44 1.33.9 0 0 .66-.58 1.21-1.38.54-.81.92-1.78 1.12-2.08.21-.3.72-1.15.72-1.15s-.47-.18-1.14-.05c-.67.12-.88.32-.88.32.15-1.28-.28-2.62-1.03-3.59" }),
        /* @__PURE__ */ jsx12("path", { d: "M274.22 201.86c.34-.27.6-.64.67-1.08.09-.44 0-.87-.22-1.23 0 0 .88-.44 1.83-.69.72-.19 1.99-.2 2.36-.2.39-.02 1.15-.03 1.15-.03s-.06.17-.28.55c-.26.46-.49.75-.49.75 1.26.29 2.34 1.12 3.03 2.09-.99.68-2.31 1.1-3.6.97 0 0 .11.34.19.86.06.43.06.61.06.61s-.71-.26-1.06-.39c-.36-.13-1.55-.55-2.16-.96-.79-.54-1.48-1.25-1.48-1.25" }),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#ad1519", cx: 272.98, cy: 200.45, rx: 2.17, ry: 2.06 }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M283.96 205.91c.28-.83.03-1.65-.57-1.83-.6-.19-1.32.33-1.61 1.16-.28.83-.03 1.65.57 1.84.6.18 1.32-.34 1.61-1.17"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M291.97 206.32c.11-.37.36-.75.72-1.06.79-.68 1.85-.79 2.36-.25.07.07.14.17.18.25 0 0 1.1-2.08 2.4-2.78s3.5-.52 3.5-.52c0-1.6-1.31-2.89-3-2.89-.99 0-1.92.41-2.47 1.11l-.23-1.07s-1.36.27-1.98 1.82.05 3.8.05 3.8-.33-.96-.84-1.61c-.51-.64-1.81-1.34-2.49-1.66-.68-.31-1.37-.79-1.37-.79s-.03.18-.06.61c-.02.51.02.83.02.83-1.25-.17-2.7.04-3.83.48.48.95 1.4 1.84 2.61 2.3 0 0-.43.36-.83.75-.33.34-.43.49-.43.49s.85.13 1.27.19c.43.05 1.84.28 2.68.22.63-.04 1.32-.14 1.74-.22" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            d: "M295.05 205.01c-.51-.54-1.57-.43-2.36.25-.79.67-1.02 1.66-.51 2.19.51.54 1.57.42 2.36-.25.79-.68 1.02-1.66.51-2.19"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs8("g", { fill: "none", children: [
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            strokeLinejoin: "round",
            d: "M250.12 224.57c-11.06-.01-21.07-1.29-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.19 11.07.02 21.13 1.22 28.74 3.19-7.61 1.97-17.67 3.25-28.74 3.26z"
          }
        ),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.05, d: "M258.04 224.28v-6.01m-3.02 6.21l.04-6.37m-2.24 6.45v-6.49" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.09, d: "M250.95 224.64v-6.57" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.14, d: "M249.16 224.64v-6.57" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.18, d: "M247.48 224.64v-6.57" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.23, d: "M245.81 224.64v-6.57" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.28, d: "M244.32 224.64v-6.57" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.33, d: "M241.48 224.28l-.04-5.97m1.39 6.05v-6.25" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.37, d: "M238.86 224.01v-5.5m1.33 5.66l-.04-5.86" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.42, d: "M235.35 223.7v-4.84m1.15 4.92v-5.08m1.19 5.24v-5.28" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.46, d: "M234.12 223.66v-4.68" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.51, d: "M232.97 223.42v-4.36" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.56, d: "M231.74 223.31v-4.06" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.6, d: "M229.22 222.95l-.04-3.22m1.33 3.38v-3.62" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.63, d: "M227.93 222.68v-2.84" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.68, d: "M226.74 222.45v-2.36" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.73, d: "M225.45 222.13v-1.85" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.77, d: "M224.12 221.98v-1.38" }),
        /* @__PURE__ */ jsx12("path", { strokeWidth: 0.91, d: "M222.72 221.66v-.67" }),
        /* @__PURE__ */ jsx12("path", { d: "M220.12 221.66c7.75-2.18 18.29-3.52 30-3.54 11.72.02 22.31 1.36 30.06 3.54" }),
        /* @__PURE__ */ jsx12("path", { fill: "#ad1519", d: "M216.72 217.16l1.22-1.59 3.37.43-2.69 1.96-1.9-.8" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M224.03 215.28c0-.58.49-1.04 1.1-1.04s1.1.46 1.1 1.04c0 .57-.49 1.04-1.1 1.04s-1.1-.47-1.1-1.04"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#058e6e",
            d: "M233.64 215.07l-2.36.27c-.61.07-1.17-.33-1.24-.9-.08-.57.35-1.09.96-1.15l2.37-.28 2.42-.28c.6-.07 1.15.33 1.22.9s-.36 1.09-.96 1.16l-2.41.28"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M240.54 213.35c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            d: "M250.15 214.16h-3.29c-.6 0-1.11-.46-1.11-1.03 0-.58.49-1.04 1.1-1.04h6.64c.61 0 1.1.46 1.1 1.04 0 .57-.51 1.03-1.11 1.03h-3.33"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M257.56 213.35c0-.58.5-1.04 1.1-1.04.61 0 1.1.46 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#058e6e",
            d: "M266.66 215.07l2.36.27c.6.07 1.17-.33 1.24-.9s-.36-1.09-.96-1.15l-2.37-.28-2.42-.28c-.61-.07-1.15.33-1.22.9-.08.57.36 1.09.96 1.16l2.41.28"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#fff",
            d: "M274.07 215.28c0-.58.49-1.04 1.1-1.04s1.1.46 1.1 1.04c0 .57-.49 1.04-1.1 1.04s-1.1-.47-1.1-1.04"
          }
        ),
        /* @__PURE__ */ jsx12("path", { fill: "#ad1519", d: "M283.57 217.16l-1.21-1.59-3.37.43 2.69 1.96 1.89-.8" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs8("g", { strokeWidth: 0.52, children: [
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#ccc",
          d: "M250.49 344.33c-13.08 0-26.05-3.2-36.95-8.54-8.03-3.98-13.36-12-13.36-21.19v-33.3H300.6v33.3c0 9.19-5.32 17.21-13.36 21.19-10.9 5.34-23.66 8.54-36.75 8.54z"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#ffd691",
          d: "M252.91 329.55c2.09.63 3.15 2.19 3.15 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.42-1.8-5.42-4.18 0-1.79 1-3.8 3.08-3.94 0 0-.06-.19-.24-.5-.22-.23-.64-.66-.64-.66s.79-.15 1.25.02c.46.18.77.47.77.47s.21-.43.52-.76c.3-.33.7-.53.7-.53s.46.38.61.64c.15.27.25.59.25.59s.42-.35.79-.49c.37-.15.84-.26.84-.26s-.13.46-.22.69-.14.72-.14.72"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#058e6e",
          d: "M250.32 340.32s-3.98-2.68-5.7-3.04c-2.21-.47-4.69-.09-5.76-.15.03.03 1.29.93 1.84 1.48s2.39 1.65 3.43 1.91c3.22.81 6.19-.2 6.19-.2M251.46 340.56s2.54-2.66 5.21-3.02c3.15-.44 5.22.26 6.44.58.03 0-1.01.49-1.56.87-.55.37-1.97 1.57-4.14 1.59-2.18.03-4.58-.23-4.97-.17-.4.06-.98.15-.98.15"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#ad1519",
          d: "M250.69 337.28c-1-.93-1.62-2.25-1.62-3.72 0-1.46.62-2.78 1.63-3.71a5.08 5.08 0 01-.01 7.43"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fill: "#058e6e",
          d: "M249.68 342.71s.61-1.52.67-2.83c.06-1.09-.15-2.17-.15-2.17h.8s.39 1.16.39 2.17c0 1.02-.18 2.37-.18 2.37s-.55.08-.73.17c-.19.09-.8.29-.8.29"
        }
      ),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", children: [
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            d: "M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82s-25.15-10.66-25.15-23.82v-33.35h50.2v33.35"
          }
        ),
        /* @__PURE__ */ jsx12("path", { d: "M200.03 314.12c.15 7.02 2.95 12.25 5.73 15.67v-49.47h-5.66l-.07 33.8zM211.08 334.23c1.57.83 3.72 2.22 6.03 2.77l-.15-56.96h-5.88v54.19zM222.28 338.25c2.3.23 4.01.19 5.87 0v-58.21h-5.87v58.21zM233.32 337c2.3-.46 4.9-1.89 6.03-2.63v-54.33h-5.88l-.15 56.96zM244.81 329.24c2.45-2.18 4.75-7.12 5.59-12.76l.14-36.44h-5.87l.14 49.2z" })
      ] }),
      /* @__PURE__ */ jsxs8("g", { children: [
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#ad1519",
            d: "M300.65 281.22v33.35c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82v-33.35h50.33"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            id: "icon-flag-es_svg__e",
            fill: "#c8b100",
            stroke: "#c8b100",
            strokeWidth: 0.26,
            d: "M272.71 306.14c.05-.14.12-.27.19-.4l-4.26-4.74-1.67.72-3.06-3.39 1-1.46-5.34-5.99c-.07.02-.2.02-.27.04l.03 4.02 1.75.5v4.46l-1.75.48-.03 4.08c.84.26 1.48.88 1.74 1.67l3.21.01.51-1.67h4.72l.5 1.67zm-6.98-18.5v1.61h2.76v-1.61zm-7.3 20.37c.64 0 1.16-.49 1.16-1.1s-.52-1.11-1.16-1.11c-.65 0-1.17.5-1.17 1.11s.52 1.1 1.17 1.1zm15.99-9.73l-1.76-.48v-4.46l1.76-.5-.01-1.92c-.85-.25-1.51-.87-1.79-1.67h-2.68l-.51 1.67h-4.71l-.51-1.67h-3.09c-.08.22-.17.42-.29.61l5.38 5.96 1.67-.71 3.06 3.4-1 1.45 4.18 4.64c.09-.04.18-.08.28-.12zm-7.25-1.39l-1.29 1.04 1.77 1.98 1.29-1.05zm8.004 36.186c-1.24-.065-2.255-.902-2.514-2.016-1.67-.23-3.25-.66-4.73-1.3l.84-1.43c1.29.55 2.66.91 4.08 1.11.31-.66.86-1.16 1.58-1.4l.01-5.62-1.76-.49v-4.46l1.76-.48v-7.64a.882.882 0 01-.2-.09l-3.98 4.42 1 1.44-3.06 3.4-1.67-.71-3.3 3.67c.57.87.55 2-.11 2.85a15.58 15.58 0 003.24 2.75l-.84 1.44c-1.42-.89-2.7-1.99-3.79-3.22-.87.26-1.86.11-2.6-.5-1.15-.93-1.29-2.56-.3-3.64l.14-.16c-.69-1.56-1.16-3.24-1.32-5l1.71.01c.14 1.5.51 2.93 1.09 4.27.49-.06 1-.01 1.46.16l3.32-3.68-1-1.45 3.06-3.4 1.67.72 3.99-4.43a2.15 2.15 0 01-.21-.46l-2.76.01-.5 1.67h-4.72l-.51-1.67-3.24-.01c-.27.76-.9 1.36-1.69 1.62l-.01 4.04-1.71-.01v-4.01c-1.1-.33-1.91-1.31-1.91-2.47 0-1.15.82-2.15 1.92-2.48l.01-4.05-1.76-.48v-4.46l1.76-.5v-4.05c-1.08-.35-1.84-1.32-1.84-2.45 0-1.43 1.22-2.58 2.73-2.58 1.22 0 2.25.74 2.61 1.78h3.09l.51-1.67h4.71l.51 1.67h2.68c.357-1.031 1.363-1.767 2.559-1.78l.071 8.37h-.85v2.61h.845l-.021 21.59h-.784v2.61h.78zm-5.914-18.306l-1.29-1.04-1.78 1.98 1.29 1.04zm-9.96-18.44h-1.69l-.01 2.61h1.7zm9.16 11.41v-1.6h-2.85v1.6zm-10.6 9.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.74.19 2.24.19 2.24l-1.76.58c-.18-.9-.24-1.84-.24-2.79zm10.81 16.93l.39-1.7c-1.52-.48-2.93-1.18-4.17-2.09l-1.26 1.11c1.48 1.15 3.19 2.08 5.04 2.68zm-.85 1.44l-1.3 1.22c-1.47-.54-2.86-1.26-4.12-2.11l.38-1.77c1.5 1.13 3.21 2.03 5.04 2.66z"
          }
        ),
        /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-es_svg__e", transform: "matrix(-1 0 0 1 550.43 0)" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#058e6e",
            d: "M272.59 306.94c0-1.44 1.23-2.6 2.74-2.6s2.73 1.16 2.73 2.6c0 1.43-1.22 2.58-2.73 2.58s-2.74-1.15-2.74-2.58",
            stroke: "none"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", strokeWidth: 0.46, children: [
        /* @__PURE__ */ jsx12("path", { fill: "#ad1519", strokeWidth: 0.52, d: "M200.12 281.25h50.18v-55.72h-50.18v55.72z" }),
        /* @__PURE__ */ jsx12("path", { d: "M217.34 238.41h-.92v-.92h-1.62v3.69h1.62v2.55h-3.47v7.39h1.85v14.79h-3.7v7.63h28.42v-7.63h-3.69v-14.79h1.85v-7.39h-3.47v-2.55h1.62v-3.69h-1.62v.92h-.93v-.92h-1.61v.92h-1.16v-.92h-1.62v3.69h1.62v2.55h-3.46v-8.09h1.84v-3.7h-1.84v.93h-.93v-.93h-1.62v.93h-.92v-.93h-1.85v3.7h1.85v8.09h-3.47v-2.55h1.62v-3.69h-1.62v.92h-.92v-.92h-1.85v.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.31h7.16m-12.47 7.86h3.69m-5.31-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.69-1.85v1.85m3.47-1.85v1.85m-1.85-1.85v-2.08m1.85-1.84v1.84m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.69v1.84m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.85 1.85v1.85m-3.47 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.84v1.84m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.69v1.84m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.55v-1.85m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.69m3.47-5.54h3.47m3.46 5.54h3.7" }),
        /* @__PURE__ */ jsx12("path", { d: "M230.05 273.54v-4.86c0-.92-.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z" }),
        /* @__PURE__ */ jsx12("path", { d: "M222.19 268.91l-2.31-.23c0-.92.23-2.31.93-2.77l2.08 1.62c-.23.23-.7.92-.7 1.38zM226.12 266.6l1.16-2.08c-.46-.23-1.39-.46-2.08-.46-.46 0-1.39.23-1.85.46l1.15 2.08h1.62zM228.43 268.91l2.31-.23c0-.92-.23-2.31-.92-2.77l-2.08 1.62c.23.23.69.92.69 1.38zM221.73 260.83v-5.09c0-1.38-.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08zM228.89 260.83v-5.09c0-1.38.93-2.54 2.55-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09zM220.11 248.35l.23-4.62h-4.39l.47 4.62h3.69zM227.05 248.35l.46-4.62h-4.39l.23 4.62h3.7zM230.51 248.35l-.46-4.62h4.62l-.46 4.62h-3.7z" }),
        /* @__PURE__ */ jsx12("g", { fill: "#0039f0", stroke: "none", children: /* @__PURE__ */ jsx12("path", { d: "M228.43 273.54v-4.16c0-.7-.46-2.78-3.23-2.78-2.54 0-3.01 2.08-3.01 2.78v4.16h6.24zM221.27 260.36v-4.39c0-1.15-.69-2.31-2.08-2.31s-2.08 1.16-2.08 2.31v4.39h4.16zM229.36 260.36v-4.39c0-1.15.69-2.31 2.08-2.31 1.38 0 2.08 1.16 2.08 2.31v4.39h-4.16z" }) })
      ] }),
      /* @__PURE__ */ jsxs8("g", { children: [
        /* @__PURE__ */ jsx12("path", { fill: "#ccc", d: "M250.28 281.25h50.32v-55.72h-50.32v55.72z" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#db4446",
            strokeWidth: 0.39,
            d: "M275.93 239.26l.05-.62.09-.34s-1.61.13-2.46-.11-1.61-.59-2.4-1.25c-.79-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.31 1.59 1.41 1.95 1.53c.59.18 2.66.05 3.22.07.57.03 1.84.19 1.84.19z"
          }
        ),
        /* @__PURE__ */ jsxs8("g", { fill: "none", strokeWidth: 0.39, children: [
          /* @__PURE__ */ jsx12(
            "path",
            {
              fill: "#ed72aa",
              d: "M283.46 237s.01.72.08 1.4c.06.67-.22 1.24-.11 1.61s.16.66.3.93c.14.26.21.94.21.94s-.38-.28-.74-.54c-.35-.27-.6-.44-.6-.44l.1 1.03c.04.31.22.89.51 1.24.29.33.87.89 1.05 1.33.18.45.14 1.44.14 1.44s-.46-.75-.87-.89c-.39-.14-1.26-.62-1.26-.62s.79.79.79 1.55c0 .75-.32 1.6-.32 1.6s-.36-.68-.83-1.12c-.47-.45-1.13-.9-1.13-.9s.52 1.17.52 1.95c0 .79-.15 2.47-.15 2.47s-.39-.64-.79-.96c-.4-.31-.87-.58-1.02-.78-.14-.21.48.64.54 1.16.07.51.32 2.35 1.92 4.69.94 1.37 2.39 3.77 5.5 2.98 3.11-.78 1.96-4.97 1.3-6.92-.65-1.95-.98-4.11-.94-4.87.04-.75.58-2.97.51-3.39-.07-.41-.24-2 .14-3.28.4-1.33.73-1.85.95-2.4.21-.55.39-.86.46-1.34s.07-1.37.07-1.37.58 1.06.73 1.44c.14.38.14 1.5.14 1.5s.11-1.12.98-1.67 1.88-1.13 2.13-1.44.33-.51.33-.51-.08 1.92-.62 2.67c-.36.49-1.77 2.09-1.77 2.09s.73-.28 1.23-.3c.51-.04.87 0 .87 0s-.62.48-1.41 1.64c-.8 1.16-.47 1.26-1.05 2.22s-1.05 1-1.78 1.58c-1.08.87-.5 4.34-.36 4.86.15.51 2.03 4.76 2.07 5.79.03 1.03.21 3.33-1.6 4.8-1.16.95-3.07.96-3.51 1.23-.43.28-1.29 1.13-1.29 2.91 0 1.79.64 2.06 1.15 2.51.51.44 1.16.2 1.3.55.15.34.22.54.44.75.21.2.36.44.29.82-.08.38-.91 1.23-1.2 1.85-.29.61-.87 2.23-.87 2.47s-.07.99.18 1.37c0 0 .91 1.06.29 1.26-.4.14-.78-.25-.97-.2-.54.14-.83.47-.98.45-.36-.07-.36-.25-.4-.76-.03-.51-.01-.72-.17-.72-.22 0-.33.18-.37.45s-.04.89-.29.89-.61-.45-.83-.55-.83-.2-.87-.48c-.03-.27.36-.85.76-.96.4-.1.76-.3.51-.51-.26-.2-.51-.2-.76 0-.25.21-.79.04-.76-.27.04-.31.11-.69.07-.86-.03-.17-.47-.51.1-.82.59-.31.84.27 1.42.17s.86-.31 1.08-.65.18-1.06-.22-1.5c-.39-.45-.79-.52-.94-.8-.14-.27-.36-.92-.36-.92s.11 1.2.04 1.37-.04.89-.04.89-.39-.45-.72-.79c-.32-.34-.65-1.37-.65-1.37s-.03.96-.03 1.34c0 .37.43.72.29.86-.15.13-.83-.72-1.02-.86-.18-.14-.76-.58-1.01-1.06s-.44-1.16-.51-1.41c-.07-.24-.19-1.31-.07-1.58.18-.4.47-1.13.47-1.13h-1.41c-.76 0-1.3-.23-1.59.28s-.15 1.54.21 2.88c.37 1.33.58 1.98.48 2.22-.11.24-.58.79-.76.89-.19.11-.69.07-.91-.03-.21-.1-.57-.27-1.26-.27s-1.12.03-1.37-.03c-.26-.07-.88-.38-1.17-.31s-.79.32-.65.72c.22.61-.21.75-.51.72-.29-.04-.53-.14-.9-.24-.36-.11-.9 0-.83-.42.07-.41.22-.44.4-.74.18-.32.25-.52.04-.54-.25-.02-.51-.05-.7.11-.2.16-.51.51-.76.38-.26-.14-.46-.43-.46-1.08 0-.64-.68-1.2-.05-1.17.62.03 1.41.48 1.55.13s.06-.51-.28-.78-.76-.43-.31-.77c.45-.35.56-.35.74-.54.17-.18.41-.79.73-.64.62.3.02.73.65 1.42.62.69 1.01.94 2.06.83 1.04-.11 1.33-.24 1.33-.54 0-.29-.09-.82-.12-1.04-.02-.21.15-.99.15-.99s-.48.3-.63.59c-.13.29-.42.8-.42.8s-.11-.6-.08-1.09c.02-.29.12-.79.11-.89-.03-.27-.23-.94-.23-.94s-.16.73-.28.94c-.11.21-.16 1.07-.16 1.07s-.67-.58-.48-1.55c.13-.75-.12-1.74.11-2.06.22-.33.75-1.64 2.06-1.69 1.3-.05 2.31.05 2.77.03.45-.03 2.06-.33 2.06-.33s-2.97-1.52-3.64-1.98c-.68-.45-1.73-1.63-2.07-2.16-.34-.54-.65-1.58-.65-1.58s-.53.02-1.02.29c-.48.27-.96.67-1.24.99s-.73 1.05-.73 1.05.08-.94.08-1.23-.06-.86-.06-.86-.33 1.28-1.01 1.76c-.68.49-1.47 1.15-1.47 1.15s.08-.71.08-.88c0-.16.17-.99.17-.99s-.48.72-1.21.86c-.74.13-1.81.11-1.9.56-.08.45.2 1.07.03 1.39s-.54.54-.54.54-.42-.35-.79-.38c-.36-.03-.71.16-.71.16s-.31-.4-.19-.67c.11-.26.67-.66.54-.83-.15-.16-.6.06-.88.19-.28.14-.88.27-.82-.19.05-.45.2-.72.05-1.04-.14-.32-.05-.53.18-.61.22-.08 1.12.02 1.21-.19.08-.21-.22-.48-.82-.61-.59-.14-.88-.49-.57-.78.32-.3.4-.38.54-.64.14-.27.2-.76.74-.51.53.24.42.83.99 1.01.56.19 1.89-.08 2.17-.24s1.19-.83 1.5-.99c.31-.15 1.61-1.12 1.61-1.12s-.76-.53-1.05-.8c-.28-.27-.78-.91-1.04-1.05-.25-.13-1.5-.61-1.92-.64-.42-.02-1.72-.48-1.72-.48s.59-.19.79-.35c.19-.16.64-.56.87-.53.22.02.28.02.28.02s-1.21-.05-1.47-.13c-.25-.08-.99-.54-1.27-.54s-.84.11-.84.11.76-.48 1.38-.59c.62-.1 1.1-.08 1.1-.08s-.96-.27-1.19-.58c-.22-.33-.45-.8-.62-1.02-.17-.21-.28-.56-.59-.59s-.85.38-1.16.35-.54-.22-.57-.67c-.02-.46 0-.3-.1-.54-.12-.24-.57-.8-.15-.93.43-.14 1.33.08 1.42-.08.08-.16-.48-.65-.85-.83-.37-.19-.96-.51-.65-.78.31-.26.62-.37.79-.61s.37-.91.74-.7c.36.21.87 1.26 1.16 1.18.28-.08.3-.83.25-1.15-.06-.32 0-.88.28-.83s.51.43.96.46c.45.02 1.13-.11 1.07.21-.05.32-.31.71-.62 1.06-.3.36-.45 1.05-.25 1.5.2.46.71 1.19 1.16 1.48s1.3.51 1.84.85c.53.35 1.78 1.34 2.2 1.45s.85.32.85.32.48-.21 1.13-.21 2.14.1 2.71-.14 1.3-.64 1.08-1.15c-.23-.51-1.47-.96-1.36-1.36s.57-.43 1.33-.46c.76-.02 1.8.14 2-.94.2-1.06.26-1.68-.81-1.92-1.08-.24-1.87-.27-2.07-1.04-.2-.78-.39-.97-.17-1.18.23-.21.62-.32 1.41-.37.8-.06 1.7-.06 1.96-.25.25-.18.3-.69.61-.91.31-.21 1.53-.4 1.53-.4s1.46.71 2.8 1.71c1.21.9 2.3 2.23 2.3 2.23"
            }
          ),
          /* @__PURE__ */ jsx12("path", { d: "M269 243.39s-.8.23-1.1.67c-.37.53-.34 1.07-.34 1.07s.68-.56 1.56-.33c.87.24.96.33 1.33.3s1.27-.35 1.27-.35-.74.86-.65 1.45c.08.58.19.85.17 1.15-.06.72-.6 1.61-.6 1.61s.31-.19 1.05-.35c.73-.16 1.36-.51 1.75-.81.39-.29.9-1.02.9-1.02s-.16 1 0 1.42c.17.44.23 1.67.23 1.67s.47-.42.85-.62c.19-.11.7-.38.9-.7.14-.22.32-1.06.32-1.06s.11.9.39 1.34c.28.42.7 1.74.7 1.74s.29-.86.6-1.21.68-.8.7-1.07c.03-.27-.08-.85-.08-.85l.39.85m-11.41.61s.48-.83.93-1.1c.46-.26 1.08-.74 1.25-.8.16-.05.9-.46.9-.46m.99 5.17s1.09-.55 1.41-.75c.68-.4 1.16-1.12 1.16-1.12" }),
          /* @__PURE__ */ jsx12("path", { strokeWidth: 0.26, d: "M282.57 240.9s-.34-.48-.42-.65c-.09-.15-.23-.48-.23-.48" }),
          /* @__PURE__ */ jsx12("path", { d: "M278.33 257.41s2.04 1.26 1.98 2.31c-.06 1.04-1.13 2.41-1.13 2.41" })
        ] }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.26,
            d: "M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.34.37-.05.11-.19.27-.19.27z"
          }
        ),
        /* @__PURE__ */ jsx12(
          "path",
          {
            strokeWidth: 0.05,
            d: "M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.91 1.05-.1.09-.54-.27-.85-.37 0 0-.23.05-.45.05-.23 0-.34-.11-.37-.21-.03-.12.03-.3.03-.3l-.34-.05z"
          }
        ),
        /* @__PURE__ */ jsx12("g", { strokeWidth: 0.26, children: /* @__PURE__ */ jsx12("path", { d: "M273.08 240.14l.33-.53.34.49-.67.04M273.89 240.12l.4-.53.43.48-.83.05M273.53 236.83l.82.29-.74.38-.08-.67M274.52 237.1l.73.18-.59.46-.14-.64" }) }),
        /* @__PURE__ */ jsx12("g", { fill: "#db4446", strokeWidth: 0.39, children: /* @__PURE__ */ jsx12("path", { d: "M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.05 0 .17-.54.11-.91-.2-1.2-1.3-1.47-1.3-1.47s.33.73.17 1.07c-.23.48-.65.86-.65.86zM259.59 237.12s-.43-.77-1.33-.67c-.9.11-1.5.81-1.5.81s1-.03 1.25.13c.37.24.48.86.48.86s.54-.32.71-.54c.16-.21.39-.59.39-.59zM258.49 240.25s-.77.11-1.19.59c-.43.49-.36 1.4-.36 1.4s.5-.54.95-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.81-.34-.81zM261.06 250.37s-.42-.45-1.16-.32c-.74.14-1.22.97-1.22.97s.63-.17 1-.08c.36.08.62.45.62.45s.34-.29.45-.45.31-.57.31-.57zM260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.51-.43.91-.37c.39.05.87.27.87.27s.08-.51.11-.64c.09-.38-.17-.84-.17-.84zM261.66 256.08s-.05.79.33 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.79.06-.79.06zM269 263.12s-.51-.64-1.21-.62c-.71.03-1.45.69-1.45.69s.88-.07 1.11.22c.23.3.45.67.45.67s.4-.21.57-.35c.17-.13.53-.61.53-.61zM266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56 1.08.32 1.08.32-.09-.53-.15-.78c-.05-.24-.19-.69-.19-.69zM268.84 268.9s-.46.64-.12 1.15 1.05.75 1.05.75-.26-.37-.14-.8c.09-.34.67-.8.67-.8l-1.46-.3zM281.24 270.11s-.81-.19-1.27.08c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45zM281.64 273.1s-.62.64-.4 1.18c.23.54.62 1.1.62 1.1s-.02-.8.23-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35zM284.75 274.04s-.31.78.28 1.28c.59.52 1.11.57 1.11.57s-.46-.81-.32-1.23c.15-.45.54-.72.54-.72s-.74-.25-.85-.22c-.11.02-.76.32-.76.32z" }) }),
        /* @__PURE__ */ jsxs8("g", { fill: "#c8b100", strokeWidth: 0.26, children: [
          /* @__PURE__ */ jsx12("path", { d: "M282.88 232.71l-.29.02c-.01.03-.14.24-.26.35-.26.25-.65.28-.86.07a.486.486 0 01-.14-.41c-.17.09-.35.09-.51-.01-.26-.15-.32-.5-.14-.79.03-.06.06-.14.11-.18l-.02-.32-.35.08-.1.19c-.22.25-.54.31-.7.17a.526.526 0 01-.13-.27c0 .01-.09.09-.17.11-.54.13-.75-1.05-.77-1.35l-.17.25s.16.7.08 1.3c-.08.59-.29 1.19-.29 1.19.74.19 1.86.8 2.97 1.65s1.98 1.78 2.34 2.42c0 0 .58-.32 1.18-.51s1.36-.2 1.36-.2l.22-.21c-.32.05-1.58.1-1.56-.43 0-.08.07-.18.08-.18a.697.697 0 01-.3-.06c-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.11.09-.15.13-.27.23-.65.25-.86.03a.416.416 0 01-.11-.46.58.58 0 01-.45-.05c-.26-.15-.31-.52-.11-.8.09-.14.28-.31.31-.32l-.07-.3h-.01z" }),
          /* @__PURE__ */ jsx12("g", { fill: "#000", strokeWidth: 0.05, children: /* @__PURE__ */ jsx12("path", { d: "M280.63 233.4c.05-.07.15-.06.23 0s.1.16.06.21c-.05.06-.15.06-.24-.01-.07-.05-.1-.15-.05-.2zM281.58 234.19l-.33-.25c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.33.26.33.25c.05.04.08.12.04.16s-.12.04-.18 0l-.33-.26M279.84 233l-.26-.15c-.07-.04-.1-.12-.07-.17s.11-.06.17-.02l.26.16.26.15c.06.03.09.11.07.16-.03.05-.11.06-.17.02l-.26-.15M278.8 232.29c.05-.06.16-.06.24 0 .08.07.1.16.05.22-.05.05-.15.05-.23-.01s-.1-.15-.06-.21zM282.63 234.92c.05-.05.03-.14-.05-.21-.08-.06-.19-.06-.24 0-.04.05-.02.15.06.21s.18.06.23 0zM283.2 235.58l.22.21c.05.05.13.07.18.03.04-.04.04-.11-.01-.16l-.21-.21-.22-.21c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21M284.15 236.39c.05-.06.03-.15-.05-.21-.08-.07-.18-.07-.23-.01s-.03.15.05.22c.08.05.18.06.23 0z" }) }),
          /* @__PURE__ */ jsx12("path", { d: "M281.4 230.36l-.59.01-.11.87.06.14.15-.01.76-.51-.27-.5" }),
          /* @__PURE__ */ jsx12("path", { d: "M281.4 230.36l-.59.01-.11.87.06.14.15-.01.76-.51-.27-.5" }),
          /* @__PURE__ */ jsx12("path", { d: "M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.71-.5.27" }),
          /* @__PURE__ */ jsx12("path", { d: "M281.7 231.92l-.49.27-.54-.71-.01-.15.14-.06.93.11-.03.54" }),
          /* @__PURE__ */ jsx12("path", { d: "M280.51 231.25c.08-.13.26-.17.39-.09.14.07.18.24.1.37s-.26.17-.39.09a.26.26 0 01-.1-.37zM278.36 230.35c-.02.01-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.05.42-.19.87.09.38.31-.03.87-.03.87s-.09.14-.19.18z" }),
          /* @__PURE__ */ jsx12("path", { d: "M279.39 230.66l-.42.37-.68-.6.06-.08.03-.15.92-.07.09.53" }),
          /* @__PURE__ */ jsx12("path", { d: "M278.24 230.29c.05-.15.18-.23.28-.2.11.04.15.18.1.33s-.18.23-.29.2c-.11-.04-.15-.18-.09-.33zM283.67 231.77l-.59-.06-.25.85.05.14.15.01.83-.41-.19-.53" }),
          /* @__PURE__ */ jsx12("path", { d: "M282.01 232.03l-.1.54.9.23.15-.04.01-.14-.43-.79-.53.2" }),
          /* @__PURE__ */ jsx12("path", { d: "M283.73 233.36l-.53.2-.42-.78.01-.15.15-.03.89.23-.1.53" }),
          /* @__PURE__ */ jsx12("path", { d: "M282.65 232.54c.1-.12.28-.13.4-.04.13.09.15.26.05.38s-.28.13-.41.04a.26.26 0 01-.04-.38zM285.64 233.61l.11.55-.87.3-.16-.04-.01-.14.36-.81.57.14" }),
          /* @__PURE__ */ jsx12("path", { d: "M285.49 235.2l-.56.13-.31-.83.04-.15.15-.02.85.35-.17.52" }),
          /* @__PURE__ */ jsx12("path", { d: "M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13" }),
          /* @__PURE__ */ jsx12("path", { d: "M284.91 234.63c.12-.11.12-.28.02-.39a.318.318 0 00-.41-.02c-.11.11-.12.28-.01.39.1.11.29.12.4.02zM286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.12-.42-.28-.79-.39-.28-.88.22-.88.22s-.12.12-.15.21z" }),
          /* @__PURE__ */ jsx12("path", { d: "M285.75 235.54l-.29.46.76.51.09-.08.13-.04-.12-.88-.57.03" }),
          /* @__PURE__ */ jsx12("path", { d: "M286.37 236.53c.14-.07.21-.22.15-.31s-.22-.1-.36-.02-.2.22-.14.31c.05.09.21.1.35.02z" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs8("g", { strokeWidth: 0.61, children: [
        /* @__PURE__ */ jsx12("ellipse", { fill: "#ad1519", cx: 250.43, cy: 281.01, rx: 16.26, ry: 18.3 }),
        /* @__PURE__ */ jsx12("ellipse", { fill: "#005bbf", cx: 250.44, cy: 280.97, rx: 11.44, ry: 13.42 }),
        /* @__PURE__ */ jsxs8("g", { id: "icon-flag-es_svg__f", fill: "#c8b100", strokeWidth: 0.34, children: [
          /* @__PURE__ */ jsx12(
            "path",
            {
              strokeLinejoin: "round",
              d: "M245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39.57 2.54.57 2.54-.21-.55-.76-.94-1.41-.94-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.59 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25l-1.22.01v1.03h1.09l-.81 1.61 1.07-.42.81.91.84-.91 1.07.42-.8-1.61h1.08v-1.03l-1.22-.01c-.02-.08-.02-.16-.02-.25 0-.56.47-1.01 1.06-1.01.44 0 .82.2.98.57l.49-.99c.1-.19.24-.55.24-.77 0-.79-.67-1.42-1.49-1.42-.66 0-1.21.39-1.41.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"
            }
          ),
          /* @__PURE__ */ jsx12("path", { d: "M242.87 281.11h4.36v-1.03h-4.36v1.03z" })
        ] }),
        /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-es_svg__f", x: 10.63 }),
        /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-es_svg__f", x: 5.31, y: 9.14 })
      ] })
    ] })
  ] })
] });
var FlagFr = (props) => /* @__PURE__ */ jsxs8("svg", { width: 24, height: 24, viewBox: "0 -150 900 900", ...props, children: [
  /* @__PURE__ */ jsx12("path", { fill: "#ED2939", d: "M0 0h900v600H0z" }),
  /* @__PURE__ */ jsx12("path", { fill: "#fff", d: "M0 0h600v600H0z" }),
  /* @__PURE__ */ jsx12("path", { fill: "#002395", d: "M0 0h300v600H0z" })
] });
var FlagGb = (props) => /* @__PURE__ */ jsxs8("svg", { viewBox: "0 -7.5 45 45", width: 24, height: 24, ...props, children: [
  /* @__PURE__ */ jsx12("clipPath", { id: "icon-flag-gb_svg__b", children: /* @__PURE__ */ jsx12("path", { d: "M22.5 15H45v15zv15H0zH0V0zV0H45z" }) }),
  /* @__PURE__ */ jsx12("clipPath", { id: "icon-flag-gb_svg__a", children: /* @__PURE__ */ jsx12("path", { d: "M0 0h45v30H0z" }) }),
  /* @__PURE__ */ jsxs8("g", { clipPath: "url(#icon-flag-gb_svg__a)", children: [
    /* @__PURE__ */ jsx12("path", { d: "M0 0v30h45V0z", fill: "#00247d" }),
    /* @__PURE__ */ jsx12("path", { d: "M0 0l45 30m0-30L0 30", stroke: "#fff", strokeWidth: 6 }),
    /* @__PURE__ */ jsx12("path", { d: "M0 0l45 30m0-30L0 30", clipPath: "url(#icon-flag-gb_svg__b)", stroke: "#cf142b", strokeWidth: 4 }),
    /* @__PURE__ */ jsx12("path", { d: "M22.5 0v30M0 15h45", stroke: "#fff", strokeWidth: 10 }),
    /* @__PURE__ */ jsx12("path", { d: "M22.5 0v30M0 15h45", stroke: "#cf142b", strokeWidth: 6 })
  ] })
] });
var FlagIn = (props) => /* @__PURE__ */ jsxs8("svg", { viewBox: "0 -37.5 225 225", width: 24, height: 24, ...props, children: [
  /* @__PURE__ */ jsx12("path", { fill: "#f93", d: "M0 0h225v150H0z" }),
  /* @__PURE__ */ jsx12("path", { fill: "#fff", d: "M0 50h225v50H0z" }),
  /* @__PURE__ */ jsx12("path", { fill: "#128807", d: "M0 100h225v50H0z" }),
  /* @__PURE__ */ jsxs8("g", { transform: "translate(112.5 75)", children: [
    /* @__PURE__ */ jsx12("circle", { r: 20, fill: "#008" }),
    /* @__PURE__ */ jsx12("circle", { r: 17.5, fill: "#fff" }),
    /* @__PURE__ */ jsx12("circle", { r: 3.5, fill: "#008" }),
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-in_svg__d", children: [
      /* @__PURE__ */ jsxs8("g", { id: "icon-flag-in_svg__c", children: [
        /* @__PURE__ */ jsxs8("g", { id: "icon-flag-in_svg__b", children: [
          /* @__PURE__ */ jsxs8("g", { id: "icon-flag-in_svg__a", fill: "#008", children: [
            /* @__PURE__ */ jsx12("circle", { r: 0.875, transform: "rotate(7.5 -8.75 133.5)" }),
            /* @__PURE__ */ jsx12("path", { d: "M0 17.5L.6 7 0 2l-.6 5L0 17.5z" })
          ] }),
          /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-in_svg__a", transform: "rotate(15)" })
        ] }),
        /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-in_svg__b", transform: "rotate(30)" })
      ] }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-in_svg__c", transform: "rotate(60)" })
    ] }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-in_svg__d", transform: "rotate(120)" }),
    /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-in_svg__d", transform: "rotate(-120)" })
  ] })
] });
var FlagUs = (props) => /* @__PURE__ */ jsxs8("svg", { width: 24, height: 24, viewBox: "0 -162.5 975 975", ...props, children: [
  /* @__PURE__ */ jsxs8("defs", { children: [
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-us_svg__b", children: [
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__a", transform: "rotate(-144)" }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__a", transform: "rotate(-72)" }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__a" }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__a", transform: "rotate(72)" }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__a", transform: "rotate(144)" })
    ] }),
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-us_svg__c", children: [
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__b", x: -0.232 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__b", x: -0.116 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__b" }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__b", x: 0.116 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__b", x: 0.232 })
    ] }),
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-us_svg__d", children: [
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__c", x: -0.058 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__b", x: 0.29 })
    ] }),
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-us_svg__e", children: [
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__d" }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__c", y: 0.054 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__d", y: 0.108 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__c", y: 0.162 })
    ] }),
    /* @__PURE__ */ jsxs8("g", { id: "icon-flag-us_svg__g", children: [
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__e", y: -0.216 }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__e" }),
      /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__d", y: 0.216 })
    ] }),
    /* @__PURE__ */ jsx12("path", { id: "icon-flag-us_svg__a", transform: "scale(.0616)", fill: "#FFF", d: "M-.162 0L0-.5l.162.5z" }),
    /* @__PURE__ */ jsx12("path", { id: "icon-flag-us_svg__f", fill: "#BB133E", d: "M0 0h975v50H0z" })
  ] }),
  /* @__PURE__ */ jsx12("path", { fill: "#FFF", d: "M0 0h975v650H0z" }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__f" }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__f", y: 100 }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__f", y: 200 }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__f", y: 300 }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__f", y: 400 }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__f", y: 500 }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__f", y: 600 }),
  /* @__PURE__ */ jsx12("path", { fill: "#002664", d: "M0 0h440v350H0z" }),
  /* @__PURE__ */ jsx12("use", { xlinkHref: "#icon-flag-us_svg__g", transform: "matrix(650 0 0 650 219 176)" })
] });
var FlagWs = (props) => /* @__PURE__ */ jsxs8("svg", { width: 24, height: 24, viewBox: "0 -124.5 747 747", ...props, children: [
  /* @__PURE__ */ jsx12("path", { fill: "#00ab39", d: "M0 0h747v498H0z" }),
  /* @__PURE__ */ jsx12("path", { fill: "#fff", d: "M0 0h747v249H0z" }),
  /* @__PURE__ */ jsxs8("g", { stroke: "#000", strokeWidth: 1.8, children: [
    /* @__PURE__ */ jsx12(
      "path",
      {
        fill: "#d21034",
        d: "M501.782 29.532c-.011.02-.019.044-.031.063.033-.018.061-.044.094-.063h-.063zm-.031.063c-52.242 28.887-99.003 58.945-144.969 97.25-22.06 19.27-15.833 34.631-16.687 51.937.711 11.618-2.511 22.426-9.656 28.938-16.35 3.306-32.715 6.632-49.063 9.938-1.566-4.524-3.121-9.042-4.687-13.563 1.495-6.94 7.232-10.352 19.312-6 .952-8.923-6.227-12.555-14.625-15.656-2.885-2.246-6.468-3.971-6-11.688-1.412-17.467 26.615 1.25 26.875 1.25.261 0-.934-17.627-13.812-21.156-7.022-2.485-9.994-9.892-7.313-15.375 5.618-11.209 16.194.878 24.282 1.312-.304-7.316-2.387-12.531-8.688-18.437-3.392-2.087-11.722-3.657-11.938-7.156-.176-4.752 7.808-6.784 18.782-5.469-2.288-6.66-9.668-10.968-19.813-14.094l-6-10.437c-2.841-5.26-4.115-5.402 2.469-15.375 5.915-3.827 13.774-9.237 19.688-13.063l-6.532-.781c.869-7.131.969-9.53 2.625-21.375-6.346 8.672-14.275 7.121-21.406 10.687 0 0-20.33 3.61-26.875 12.25-.261 0-51.125-2.593-51.125-2.593-10.84 1.51-20.099 4.582-21.906 15.125-24.792 2.502-50.755.289-69.657 24 12.87-.609 24.136-3.674 38.594-1.813 0 0 12.321.233 14.875 13.281.261.522 4.188.532 4.188.532 1.566 1.217 3.121 2.439 4.687 3.656.609-1.652 1.204-3.317 1.813-4.969l4.187 2.875c.434-1.826.879-3.642 1.313-5.469 1.392.957 2.764 1.919 4.156 2.875.087-2.174.195-4.357.281-6.53l5.469 3.905v-8.593s20.192-.047 26.344 12.781c.262.261-56.665 10.463-111.657 5.75 5.306-2.609 10.602-5.235 15.907-7.844-20.05-4.076-38.901-7.761-56.594-21.656 6.677 25.137 41.181 54.663 48.25 54.531 0 .261-6.781-12.25-6.781-12.25 19.916.87 39.835 1.725 59.75 2.594 2.175 6.61 1.213 14.02 6.531 19.844 0 0-3.299 10.925 4.031 15.375.262.521 8.75-22.157 8.75-22.157s2.6 6.101 5.219 10.157c3.795-19.508 25.031-22.688 25.031-22.688s4.438 10.176 4.438 10.438c-6.636.96-14.89 14.486-10.438 21.906-4.45.085-12.351 13.186-9.906 20.344-3.741 3.723-13.058 8.686-10.688 24.281-7.334 1.572-11.676 14.991-9.406 29.219-11.349 10.564-8.563 29.956 1.563 37.812-4.203 3.74-6.791 6.616-6.781 11.219-3.996-1.485-7.68-.244-9.407 2.375-4.898-5.021-11.931-9.418-16.937-4.719-1.296-5.94-9.032-12.474-17.5-11.718.496-6.264-2.755-14.018-11.719-16.719 0 0-1.814-29.358-10.719-38.875-.873-5.326.51-8.948 7.844-13.313 7.323-3.906 8.879-6.935 8.344-18 2.887-7.396 5.08-14.936-3.906-20.062.27 8.795-2.43 13.031-6 16.937-4.266-.621-5.756 4.358-8.626 6.532-4.016-5.414 8.472-13.799-.781-25.844-.521-.523-6.459-15.723-21.125-15.375 6.971 4.082 9.92 10.951 9.906 18-4.624 13.045-6.973 23.127-2.343 38.093-6.093-9.128-9.549-26.482-14.594-29.5-4.422-.862-6.582-11.321-23.75-8.343 7.406 1.992 9.757 7.647 11.75 12.781-4.541 2.342-2.285 8.519 1.031 12.781-.63 10.015 5.37 15.866 14.344 19.594-1.478 13.653-2.96 27.283-4.438 40.937-3.564-.454-9.05 13.425-11.218 13.844-3.489 2.171-9.581 8.01-2.594 9.656-2.076 7.492-4.001 12.009-15.156 13.563 0 0 11.787 6.991 21.562-4.969 10.474-.262 7.03-12.752 12.094-18.25 0-.26 2.874-2.066 7.062-13.062 1.832 9.819 11.908 39.888 34.688 54.812 19.856 21.256 36.175 41.33 36 69.656 7.75-7.208 12.378-18.624 15.938-29.5 10.776-3.748 26.191-5.179 39.937-4.562-2.358 4.961-4.997 9.721-1.594 12.938-9.593 3.294-11.695 10.256-7.843 17.218-10.112 6.867-10.778 11.28-10.938 22.688-18.708 23.985-30.249 23.188-48.781 16.968-6.086-3.572-15.505-8.714-19.844-6-8.004-5.334-19.512-6.126-21.406 6 6.006-4.978 9.592-4.018 14.375.782-.962 2.436-1.766 4.862 1.812 6.25-1.566 1.739-3.121 3.48-4.687 5.218-8.613-1.324-20.194-1.25-23.219 11.219 4.424-3.665 14.24-4.525 22.156-1.031 1.479.522 2.959 1.04 4.438 1.562.174 2 .358 4 .531 6 0 0-11.732-1.811-14.875 17.219 11-11.702 18.781-8.625 18.781-8.625 4.239 6.205 19.841 5.271 31.063-4.937 15.762-8.812 20.357 3.851 30.531-4.438 8.436-6.292 18.417-2.108 25.281 5.219 7.915 2.969 16.2 5.413 22.719 0 0 0 7.963-5.081 15.906 3.125.087-9.253-6.47-14.169-15.375-14.344l-2.625-2.625c-8.349-1.74-17.73-1.034-25.031-5.218 3.442-13.066 8.457-24.904 18.25-34.969 12.088-12.958 20.987-18.85 36.25-38.688-.589 11.211 8.003 23.677 12.531 35.063 0 0 9.116-14.555 10.438-26.375.26 0 11.423-5.81 16.187-10.75 10.056 6.237 26.446-4.994 37.032-14.281 6.524 2.47 11.478 2.292 19.062 0-6.088 12.39 3.521 23.883 18.781 28.687 1.411 10.938 12.459 13.229 29.219 13.313.706 6.436 10.688 7.312 10.688 7.312-6.308 2.94-9.596 5.886-9.376 12.531-6.464.044-11.36 1.671-13.062 9.125-8.876.152-17.922.833-25.562 5.219-8.176-1.269-18.122-4.657-24.532-11.219-3.306-2.783-4.131-6.796-9.906-8.344-3.66-4.326-8.039-3.36-9.406.782-3.783-2.955-17.972-4.328-20.344 9.125 6.624-4.848 12.564-6.696 16.719-.781-2.264 4.106 5.516 6.455 12.25 8.093 4.776.296 13.247 4.647 15.906 12-6.16 1.869-15.496 1.253-21.656-3.406-5.476-4.582-12.872-4.036-16.938-1.031-5.64-3.596-19.071 3.193-19.593 14.062 5.658-5.184 10.807-7.691 15.937-4.406-2.553.606-1.583.855-1.313 2.344l13.032 7.562c-6.394 1.687-12.405 4.238-9.625 16.156 0 0 5.208-10.296 16.937-6.5.261-.26 1.617 3.678 4.969 1.032 5.076-5.776 16.682-8.362 26.875-9.375 8.18-.977 16.347-3.387 23.469 1.281 6.341-3.262 13.401-5.456 20.625-.25 8.523 2.696 14.746 12.631 25.562 8.094 5.379-3.723 11.99-3.912 18.782 3.656.082-9.543-7.069-12.742-17.219-14.875-2.349-1.393-4.683-2.795-7.031-4.187-6.522-.958-13.072.198-19.594-2.876 34.134-8.824 58.062-27.859 74.906-55.031 5.392 1.913 10.764 3.805 16.156 5.719 3.825.245 4.117 1.574 12 3.938.297-11.614-4.689-23.578-25.562-24.782l-27.406-10.437c-5.818-6.135-8.447-19.152-1.032-26.875 7.258-6.463 8.525-5.689 13.313-13.563 5.822-.53 11.309 5.469 16.687 5.469 2.554 7.587 17.274 14.294 26.625 12 5.859 5.187 17.008 8.07 29.219 3.906 6.93 6.067 15.959 8.6 26.594 3.906 2.823 2.824 8.783 5.069 15.656 3.657.522 0 3.473 7.541 10.969 10.187-3.268 3.176-1.259 16.966 2.093 21.906-2.288 5.302-3.008 10.958-1.062 16.438-7.559 4.86-9.098 8.475-5.719 16.688-9.899 15.906-21.741 17.724-32.875 12.812-4.002-2.522-7.998-5.071-12-7.594-4.261-4.175-8.52-8.325-12.781-12.5-2.17-2.037-6.66-2.677-7.594 1.813 0 0-16.399-3.658-17.719 10.187 6.798-6.62 16.438-.792 16.438-.531s-2.296 1.823-.531 4.469c.397-.331 11.973 4.32 22.281 8.75 5.6 2.122 6.831 2.786 9.281 4.094a441.984 441.984 0 00-9.281-4.094c-6.275-2.379-12.388-4.279-14.188-3.813-5.84-.545-12.034-1.27-14.874 3.125-6.278 2.656-16.084 4.783-15.657 16.438 4.239-6.94 10.055-6.647 17.469-6-.174.522-.326 1.04-.5 1.562 8.05 3.667 6.523-.998 14.031-1.687 6.277-.576 15.174 1.672 19.875 3.25-5.913 1.739-13.954 1.009-17.75 5.219-.696 1.392-3.131.823-2.062 4.156 0 0-11.534-.298-14.625 15.656 11.728-7.509 20.615-7.281 20.875-7.281.261 0 3.656.781 3.656.781s14.084-9.406 14.344-9.406c.262 0 13.638-5.923 19.812.781 5.389 2.649 11.153 2.818 16.719-.531 10.966-4.77 21.231-5.104 31.313 1.594l9.124 5.468c1.304-.869 2.603-1.755 3.907-2.625 0 0 10.329-2.917 17.906 6.281-3.132-15.914-14.5-16.437-14.5-16.437-.87-.783-1.756-1.561-2.625-2.344-5.392-2.087-10.764-4.194-16.156-6.281-2.354-5.826-8.268-10.465-2.375-17.469 6.02-29.926 13.218-52.401 1.562-82.719 10.871 4.696 19.005 19.217 32.625 14.094 0-12.176-44.822-35.294-79.062-53.875 56.094-2.87 123.51-44.277 97.594-96.906 4.088-12.697 8.162-25.397 12.25-38.094 5.77 11.623 17.453 20.483 27.937 24.25-8.641-16.496-13.6-66.93-8.625-101.75-22.603 27.922-47.563 52.702-74.094 77.875 13.05 3.05 24.453.904 37.063-.656-3.566 7.305-7.029 14.632-10.594 21.938-34.473-20.188-74.947-5.038-75.25 21.906 1.179 31.42 40.027 35.885 62.437 24.937-4.442 28.647-70.281 18.094-70.281 18.094-23.394-8.064-45.613-6.683-70.187-6.5 5.106-15.71 33.46-29.652 55.062-23.5-30.243-33.91 4.275-76.008 45.906-88.97-45.376-14.965-6.304-49.557 27.657-74.343 0 0-97.663 41.101-106.563 40.969-27.779-2.087-20.207-34.967-9.625-52.656zM195.22 69.064c2.273.012 4.945.234 7.062.75 4.404 1.073 9.763 1.688 9.688 3-2.039 3.412-7.047 7.529-11.969 7.281-4.921-.248-7.766-3.198-9.406-10.594.503-.272 2.352-.45 4.625-.437zm411.094 115.875c6.403-.088 14.074 2.62 21.562 10.562-3.6 10.37-34.842 15.697-36.937.344-.633-4.641 6.016-10.78 15.375-10.906z"
      }
    ),
    /* @__PURE__ */ jsx12(
      "path",
      {
        fill: "none",
        strokeLinejoin: "round",
        d: "M227.48 159.71l4.737 6.891m-.215.217s0 9.259 1.938 9.476m-4.307 4.952c.215.216 4.954 8.184 4.954 8.184m-13.569 2.153c.215 0 6.031 6.677 6.031 6.677m5.051-5.18c0 .215 5.501 10.565 5.932 10.565m-13.136-3.447s1.938 12.491 3.66 12.061m-11.801 10.828l5.556 8.339m4.738-17.229s3.015 11.845 5.383 10.767m2.364-17.879c.216.215 5.606 7.974 7.112 6.897m-1.291 3.014l5.168 10.338m-13.783-2.37c.215.432 4.307 12.277 4.307 12.277m-14.214-6.03s3.877 13.137 7.323 10.982m-8.83 6.462s.215 6.891 3.661 7.321m2.37-10.767c0 .215 3.445 4.954 3.445 4.954m6.398-13.149l2.862 4.534m6.246-12.921l4.308 5.383m-24.293-67.137c.215 5.815 9.437-2.048 13.098-7.002m-17.018 27.19s10.122-7.107 17.875-17.875m-21.106 34.889c7.107-1.938 20.183-17.753 22.767-26.152m-24.275 41.873c1.94.861 26.367-16.732 27.014-29.653m-27.659 43.221c0-.215 22.33-5.693 31.591-30.244m-32.79 48.826s35.657-21.381 37.595-37.102m240.77 73.006s-2.299 18.453-20.82 21.252m26.635 11.699c.215-.216 17.659-19.383 13.137-25.198m27.351 6.676s-.215 13.353-11.199 22.613m32.95-18.735s.432 16.151-6.46 22.612m26.488-12.922s-7.727 15.126-10.526 16.634m10.191 10.173s10.167 2.534 13.397-4.143m-10.761 26.084s9.399 1.697 13.706-7.347m-14.714 24.284s7.607 6.391 12.776-2.007m-121.95-122.44s-.862 32.735 45.225 39.41c51.472 14.215 75.807 6.677 78.823 64.394-1.938 21.967-4.668 46.778-20.604 37.301m-152.32-110.95s7.323 13.136 16.152 12.275c11.629-3.446 15.936 3.661 15.936 3.661m-63.53-2.8s19.383 9.476 35.964-5.815m-33.811-7.753c1.722 22.613-26.059 35.535-37.043 33.382m38.36 53.27c.216 0 15.05-8.905 12.036-15.152m-41.566 1.94c.431-.432 24.982-2.801 29.505-11.631m-40.919-24.552c0-.215 34.845.097 37.213 6.557m9.09-27.231s-34.028 58.148 28.858 58.148m-64.824-59.01s-7.323 21.753-17.66 29.074m-18.52-36.61s12.636 24.449-.071 36.509m-32.879-29.618c.215.43 4.091 34.673-4.524 44.364m-11.843-43.287s1.291 21.751-5.169 29.504c-6.462 7.753 1.513 23.856 1.513 23.856m-78.5 10.457s4.624 8.114 11.086 5.313m-3.231-23.042s10.337 4.522 13.783 2.799m-2.584-39.411s-15.291 4.307-9.476 22.397c8.829 7.108 17.444 6.03 17.444 6.03m-38.119 48.456c-.215 0 1.723 14.215 11.63 3.446 6.891-14.428 28.643-55.132 33.597-69.131m10.121-6.675s-10.553-8.184-10.121 3.23c-.217 7.106 3.229 8.829 3.229 8.829.43 5.169 4.954 12.49 8.614 5.815 1.508-6.461-1.076-9.261-1.076-9.261m6.03-11.63c-9.476-.646-14.644 20.245 3.662 7.11m6.245-14.216s-2.368 3.232-6.03-.215c-1.939-3.445-8.829 15.507 3.231 16.152 2.153-5.6 8.83-7.107 8.83-7.107m5.6-17.875s-5.385 2.584-7.323 2.153c-6.461 1.508-5.17 16.584 3.014 15.722 2.799-3.23 5.815-7.753 5.815-7.753m-52.29-29.83c-.216 0-21.372 33.268 11.794 42.098m256.71-92.175s-12.922 10.984-.862 28.643c-40.058-.645-61.592 17.875-63.315 30.365-51.041-3.66-41.78 11.416-58.364 16.368-22.182-18.521-54.702-8.183-52.548 10.337-14.861-20.89-37.688-10.767-40.487-5.599-2.8 5.169-1.723-25.628-1.723-25.628s-14.86 6.677-25.199 18.952c.217-8.183 0-21.536 0-25.843-12.418 2.512-24.407 2.654-37.257 2.369m-33.596-9.476s18.52 10.337 41.349-3.661m-42.857-33.596s14.43 12.92 41.566 8.829m-32.52-38.55s3.229 10.553 34.243 11.199m-23.74-35.604s11.679 14.283 27.4 12.13m-17.443-32.52s4.522 7.753 21.751 9.045m-11.631-31.658s9.046 9.907 19.384 8.184m34.431-88.698s4.006-4.005 10.682-2.003m-13.573 23.142s-12.463-.445-11.573-5.34c.892-5.563 13.13-9.569 13.13-9.569s16.243-10.458 18.691-14.019m-73.432 56.966l15.8 30.263 7.565-11.349 4.006 7.788 6.453-11.348 11.126 7.12-4.228-13.796 9.345-.667s-2.448-6.676-10.904-8.01c2.226-1.78 10.014-6.899 10.014-6.899s-4.449-5.118-11.348-5.34c2.225-2.448 5.34-8.456 5.118-8.456-.222 0-6.899-1.558-6.899-1.558s15.8 5.118 28.038-2.003m-30.25-24.467c.222.223-.891 6.231-4.229 9.791m-56.742 6.899s9.774-2.69 17.088-1.165c7.245 1.488 16.958 4.057 16.958 4.057s11.57-1.557 15.354-4.228m-73.656 7.789s-1.334 4.672-1.779 7.788c0 2.225-7.122 5.118-7.122 5.118m13.353-22.475s6.23 7.788 6.452 12.238c.223 4.45-4.672 7.789-4.672 7.789m-66.089 33.156l-6.454-10.458 5.786-2.003m117.2 156.72c-5.168-6.676 3.876-109.19 23.044-135.89-6.676 48.24 15.506 97.558 21.105 97.343m-102.4-125.99s8.722 3.337 26.812-10.984m24.443 34.676l12.975.16m389.49-80.51s-216.19 101.02-219.34 106.37c36.505-11.015 191.33-36.82 195.11-34.616-9.126 2.203-197 45.315-205.81 55.7 46.889-1.573 145.08 15.106 160.49 31.155-33.358-7.552-133.12-22.343-163.64-15.735 22.344 5.35 107.94 60.737 107.94 69.548-12.902-12.272-115.81-54.757-119.9-50.665 23.6 14.16 56.96 66.714 56.958 79.617-6.923-11.014-66.4-74.898-69.861-70.807 6.294 8.813 18.766 84.222 12.39 87.717 0-9.126-23.09-75.13-24.978-77.017-4.721 1.258-34.152 80.528-28.321 87.899-3.776-26.433.628-81.604 7.866-79.402-12.901 1.888-54.078 56.18-49.673 64.677 1.259-13.532 3.1-22.507 26.386-67.51-25.805 1.573-79.302 35.247-88.43 47.205 7.239-21.398 52.555-57.59 72.381-60.107m93.316-78.747c22.85-12.68 93.46-38.557 140.56-57.543m-184.91 125.78s15.576-.222 31.153-42.501c15.35-57.85 137.07-122.38 139.52-134.4m-376.67 235.07s-3.615 7.703-8.066 9.929m25.525 1.744s-4.829 9.382-5.942 13.832m22.65-9.243s4.052 12.803.714 18.812m-47.239-52.053c-12.238 6.899 6.964 50.494 65.041 54.722m-9.346-23.587s-1.557 7.788 9.346 23.365c-3.115 17.356 13.195 30.996 19.649 33.22m-33.67-213.01c0-.222 1.78-4.672 1.78-4.672l1.984 5.144 3.193-.083 2.107-5.158 1.73 5.177h3.173l1.957-5.748 2.957 5.442 2.512.128 1.977-6.63 4.077 4.75 1.481-.574 1.27-6.632 4.028 4.638 1.155-.677 1.868-6.536 3.345 4.86 1.685-.55 1.563-5.492 3.11 5.048m-50.532 8.149l24.274-.361c7.723-.115 20.442-10.82 34.684-7.481m-110.12 59.774s4.005 8.679 9.569 3.783m-18.914 2.003s-7.789 20.917 1.557 25.81M87.97 158.45s0 4.895 10.236-2.67m-42.073 112.59s8.233 2.448 6.898 8.679m-3.788-104.81s5.118 2.448 10.014-5.117m44.282 245.89c8.01-.445 9.735 3.172 17.023 3.172 8.396.256 16.577-3.172 27.26-6.065m68.757 19.36c-.223 0-3.783 7.565-.667 11.347m-113.49-10.68s12.685-10.46 19.36-4.005c6.454 2.226 10.013 1.78 10.013 1.78m-22.69-27.59s3.115 8.01-7.344 6.898m-3.115 11.57s6.675 4.23-.89 9.792m4.895 7.566s9.123 1.336 3.782 8.678m290.91-64.115s24.776 2.564 25.915 4.415c2.85-2.991 24.972-20.911-2.225-23.473-4.555 18.654-23.263 19.343-23.69 19.058zm-8.828 12.388c9.255 7.404 5.463 11.84 34.513-7.666m-47.756 16.923s13.67 14.667 23.637-3.134m-49.695 8.402l-18.51 9.682m-33.322 13.67s11.25-9.682 16.518-4.556c5.268 5.126 27.624-4.413 27.624-4.413m-35.74-33.037s3.845 7.689-3.56 8.686m-11.107 15.379s3.901 7.23-3.646 9.223m12.332 10.428s11.677.569 7.547 9.397m101.67-10.964s-6.408 5.41-1.708 11.535m94.691-50.408s7.404 3.559-1.424 9.683m-7.404 12.815s5.553 5.839 1.851 10.679m13.67 11.676s7.688 2.136 6.835 8.544m100.81-14.24s-6.408 4.699-2.99 10.823m-111.139-197.97c15.38-1.852 37.45 32.322 48.698 39.015m67.272-87.425s7.79 6.8.936 23.205m13.505-49.366c2.167 1.686 10.54 6.154 16.07 16.496m5.311-67.659c0 .142-10.822 29.191-10.822 29.191m22.925-30.615s-2.136 25.915-5.268 31.184m-42.957 47.223c-3.6 10.371-34.84 15.678-36.935.326-1.065-7.816 18.503-19.872 36.935-.326z"
      }
    ),
    /* @__PURE__ */ jsx12("path", { strokeLinejoin: "round", d: "M194.98 69.148L207 71.373s-8.46 11.349-12.02-2.225z" })
  ] })
] });

// src/internals/components/modal/ttsModal/ttsFlags.jsx
import { jsx as jsx13 } from "react/jsx-runtime";
var Flat = ({ flag }) => {
  switch (true) {
    case flag === "as":
      return /* @__PURE__ */ jsx13(FlagAs, {});
    case flag === "au":
      return /* @__PURE__ */ jsx13(FlagAu, {});
    case flag === "ca":
      return /* @__PURE__ */ jsx13(FlagCa, {});
    case flag === "es":
      return /* @__PURE__ */ jsx13(FlagEs, {});
    case flag === "fr":
      return /* @__PURE__ */ jsx13(FlagFr, {});
    case flag === "gb":
      return /* @__PURE__ */ jsx13(FlagGb, {});
    case flag === "in":
      return /* @__PURE__ */ jsx13(FlagIn, {});
    case flag === "us":
      return /* @__PURE__ */ jsx13(FlagUs, {});
    case flag === "ws":
      return /* @__PURE__ */ jsx13(FlagWs, {});
    default:
      return null;
  }
};
var ttsFlags_default = Flat;

// src/internals/components/modal/ttsModal/index.jsx
import { Fragment as Fragment5, jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var Player = isSsr() ? () => null : React.lazy(() => import("@lls/lls-audio").then(interop("Player")));
var TtsModal = ({ open, isDarkMode = false, close = _14.noop, subjectId, isTouchable, fullscreenHtml }) => {
  const [audioFiles, setAudioFiles] = useState6([]);
  const [voices, setVoices] = useState6();
  const [selectedVoice, setSelectedVoice] = useState6();
  const className = isDarkMode ? `${AUDIO_CLASSNAME_DARK} ${KIT_CLASSNAME_DARK_THEME}` : `${AUDIO_CLASSNAME_LIGHT} ${KIT_CLASSNAME_LIGHT_THEME2}`;
  const onClose = () => {
    setAudioFiles([]);
    close();
  };
  useEffect2(() => {
    const voices2 = _14.flow(
      getVoices,
      _14.map(({ value, displayName, flag }) => ({
        label: /* @__PURE__ */ jsxs9(Fragment5, { children: [
          /* @__PURE__ */ jsx14(ttsFlags_default, { flag }),
          displayName
        ] }),
        value
      }))
    )(subjectId);
    setVoices(voices2);
    setSelectedVoice(_14.first(voices2));
  }, [subjectId]);
  useEffect2(() => {
    const fetch = async () => {
      if (open && selectedVoice) {
        const { url } = await fetchTextToSpeechUrl({
          text: fullscreenHtml,
          voiceId: _14.get("value", selectedVoice)
        }).catch(_14.constant({ url: "invalidurl" }));
        setAudioFiles([
          {
            src: url,
            title: "lecture_audio",
            titleElement: /* @__PURE__ */ jsx14(
              SelectField,
              {
                width: "150px",
                options: voices,
                onChange: _14.flow((value) => _14.find({ value }, voices), setSelectedVoice),
                value: selectedVoice.value,
                className: "kit-select",
                classNamePrefix: "kit-select",
                listMaxHeight: "100px"
              }
            )
          }
        ]);
      }
    };
    fetch();
  }, [fullscreenHtml, voices, selectedVoice, open]);
  return /* @__PURE__ */ jsx14(
    SidePanel,
    {
      className: cx4(className, TTS_MODAL_CLASSNAME, src_internals_components_modal_ttsModal_index_default.sidePanelContainer),
      open,
      onClose,
      position: "right",
      title: "Lecture audio",
      sideLabelTitle: "",
      shouldMask: false,
      height: "200px",
      top: "calc(100vh - 224px)",
      children: !_14.isEmpty(audioFiles) && /* @__PURE__ */ jsx14("div", { className: src_internals_components_modal_ttsModal_index_default.audioContainer, children: /* @__PURE__ */ jsx14(Suspense, { children: /* @__PURE__ */ jsx14(
        Player,
        {
          audioFiles,
          autoPlay: true,
          size: "compact",
          isTouchable,
          onGoTo: isTouchable ? ({ href, target }) => openWindow(href, target) : void 0
        }
      ) }) })
    }
  );
};
var ttsModal_default = TtsModal;

// src/internals/hooks/useExportModal.ts
import _15 from "lodash/fp.js";
import { useCallback as useCallback5 } from "react";
var useExportModal = ({
  closeOnExport,
  onExportButtonClick = _15.noop,
  setIsExportModalOpen = _15.noop
}) => {
  return useCallback5(
    (...args) => {
      closeOnExport && setIsExportModalOpen(false);
      return onExportButtonClick(...args);
    },
    [closeOnExport, onExportButtonClick, setIsExportModalOpen]
  );
};
var useExportModal_default = useExportModal;

// src/internals/components/modal/accessibilityModal.jsx
import _16 from "lodash/fp.js";
import { useCallback as useCallback6, useRef } from "react";
import {
  Button as Button7,
  KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME2,
  KIT_CLASSNAME_FREE_LIGHT_THEME,
  KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME3,
  RangeButton,
  SelectField as SelectField2,
  SwitchButton
} from "@lls/lls-kit";
import { cx as cx5, dispatchAnalyticsEvent as dispatchAnalyticsEvent3 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_modal_accessibilityModal.module.css
var src_internals_components_modal_accessibilityModal_default = { "largeText": "sk-i-Bm9G-largeText", "switchButton": "sk-i-Bm9G-switchButton", "fontSection": "sk-i-Bm9G-fontSection", "legendContainer": "sk-i-Bm9G-legendContainer", "rangeInfos": "sk-i-Bm9G-rangeInfos", "smallText": "sk-i-Bm9G-smallText", "sectionTitle": "sk-i-Bm9G-sectionTitle", "actionsHolder": "sk-i-Bm9G-actionsHolder", "modalWithTheme": "sk-i-Bm9G-modalWithTheme", "section": "sk-i-Bm9G-section", "select": "sk-i-Bm9G-select", "sectionTitleSize": "sk-i-Bm9G-sectionTitleSize", "modalContent": "sk-i-Bm9G-modalContent" };

// src/internals/components/modal/accessibilityModal.jsx
import { jsx as jsx15, jsxs as jsxs10 } from "react/jsx-runtime";
var getOptions = () => _16.map(
  (font) => ({
    label: font,
    value: font
  }),
  FONTS_FAMILY
);
var DEFAULT_VALUE = {
  sizeIndex: 2,
  fontFamily: FONT_LATO,
  isDarkMode: false,
  isDysMode: false
};
var AccessibilityModal = ({
  isOpen,
  close,
  isDarkMode = false,
  isDysMode = false,
  sizeIndex = 2,
  fontFamily = FONT_LATO,
  onAccessibilityChange = _16.noop,
  isFreeMode = false
}) => {
  const oldAccessibility = useRef({});
  oldAccessibility.current = {
    isDarkMode,
    isDysMode,
    fontFamily,
    sizeIndex
  };
  const setFontFamilyFn = useCallback6(
    (font) => {
      onAccessibilityChange({ fontFamily: font });
    },
    [onAccessibilityChange]
  );
  const closeFn = useCallback6(
    (e) => {
      dispatchAnalyticsEvent3(ANALYTICS_EVENTS_CONTENT_VIEW_CHANGED, { ...oldAccessibility.current });
      close(e);
    },
    [close]
  );
  const toggleIsDarkMode = useCallback6(() => {
    onAccessibilityChange({ isDarkMode: !isDarkMode });
  }, [onAccessibilityChange, isDarkMode]);
  const toggleIsDys = useCallback6(() => {
    onAccessibilityChange({ isDysMode: !isDysMode });
  }, [onAccessibilityChange, isDysMode]);
  const changeFontSize = useCallback6(
    (newSize) => {
      onAccessibilityChange({ sizeIndex: newSize });
    },
    [onAccessibilityChange]
  );
  const reset = useCallback6(() => {
    onAccessibilityChange(DEFAULT_VALUE);
  }, [onAccessibilityChange]);
  return isOpen ? /* @__PURE__ */ jsx15(
    modalWithTheme_default,
    {
      title: "Options d'affichage",
      closeModal: closeFn,
      "data-is-free": 1,
      className: cx5(ACCESSIBILITY_MODAL_CLASSNAME, src_internals_components_modal_accessibilityModal_default.modalWithTheme),
      themeClassName: isFreeMode ? KIT_CLASSNAME_FREE_LIGHT_THEME : isDarkMode ? KIT_CLASSNAME_DARK_THEME2 : KIT_CLASSNAME_LIGHT_THEME3,
      isDysMode,
      sizeIndex,
      fontFamily,
      children: /* @__PURE__ */ jsxs10("div", { className: src_internals_components_modal_accessibilityModal_default.modalContent, children: [
        /* @__PURE__ */ jsxs10("div", { className: src_internals_components_modal_accessibilityModal_default.section, children: [
          !isFreeMode && /* @__PURE__ */ jsx15(
            SwitchButton,
            {
              className: src_internals_components_modal_accessibilityModal_default.switchButton,
              value: !isDarkMode,
              onChange: toggleIsDarkMode,
              trueLabel: "Mode clair",
              trueIcon: "sunmax",
              falseLabel: "Mode sombre",
              falseIcon: "moon"
            }
          ),
          /* @__PURE__ */ jsx15(
            SwitchButton,
            {
              className: src_internals_components_modal_accessibilityModal_default.switchButton,
              value: isDysMode,
              onChange: toggleIsDys,
              trueLabel: "Mode dyslexique",
              falseLabel: "Mode dyslexique"
            }
          )
        ] }),
        !isFreeMode && /* @__PURE__ */ jsxs10("div", { className: src_internals_components_modal_accessibilityModal_default.fontSection, children: [
          /* @__PURE__ */ jsx15("div", { className: src_internals_components_modal_accessibilityModal_default.sectionTitle, children: "Police\xA0: " }),
          /* @__PURE__ */ jsx15(
            SelectField2,
            {
              className: src_internals_components_modal_accessibilityModal_default.select,
              disabled: isDysMode,
              width: "100%",
              value: fontFamily,
              onChange: setFontFamilyFn,
              options: getOptions()
            }
          )
        ] }),
        /* @__PURE__ */ jsxs10("div", { className: src_internals_components_modal_accessibilityModal_default.section, children: [
          /* @__PURE__ */ jsx15("div", { className: src_internals_components_modal_accessibilityModal_default.sectionTitleSize, children: "Taille du texte\xA0:" }),
          /* @__PURE__ */ jsxs10("div", { className: src_internals_components_modal_accessibilityModal_default.rangeInfos, children: [
            /* @__PURE__ */ jsx15(RangeButton, { value: sizeIndex, onChange: changeFontSize, min: 1, max: 10, handles: false }),
            /* @__PURE__ */ jsxs10("div", { className: src_internals_components_modal_accessibilityModal_default.legendContainer, children: [
              /* @__PURE__ */ jsx15("p", { className: src_internals_components_modal_accessibilityModal_default.smallText, children: "A" }),
              /* @__PURE__ */ jsx15("p", { className: src_internals_components_modal_accessibilityModal_default.largeText, children: "A" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsx15("div", { className: src_internals_components_modal_accessibilityModal_default.actionsHolder, children: /* @__PURE__ */ jsx15(Button7, { onClick: reset, theme: "gray", accent: "floating", children: "R\xE9initialiser" }) })
      ] })
    }
  ) : null;
};
var accessibilityModal_default = AccessibilityModal;

// src/internals/components/modal/exportModal.tsx
import _17 from "lodash/fp.js";
import { useEffect as useEffect3, useState as useState7 } from "react";
import { CircularProgressBar, Divider as Divider2, Icon as Icon3, SwitchButton as SwitchButton2 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent4 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_modal_exportModal.module.css
var src_internals_components_modal_exportModal_default = { "icon": "sk-181uYq-icon", "switchButton": "sk-181uYq-switchButton", "hoverbackground": "sk-181uYq-hoverbackground", "section": "sk-181uYq-section", "title": "sk-181uYq-title", "buttonSection": "sk-181uYq-buttonSection", "divider": "sk-181uYq-divider", "circularProgressBar": "sk-181uYq-circularProgressBar", "modalContent": "sk-181uYq-modalContent", "button": "sk-181uYq-button" };

// src/internals/components/modal/exportModal.tsx
import { Fragment as Fragment6, jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var getExportFormat = ({
  type,
  showQuestions,
  showCorrections
}) => `${type}|${showQuestions ? "with" : "without"}_response_fields|${showCorrections ? "with" : "without"}_corrections`;
var getUrl = ({ type, ...props }) => {
  switch (type) {
    case "pdf":
      return generatePdfUrl({ ...props });
    case "word":
      return generateWordUrl({ ...props });
    case "moodle":
      return generateMoodleUrl({ ..._17.omit(["tabId", "renewalDisplayed"], props) });
    default:
      return "";
  }
};
var ExportModal = ({
  isOpen,
  close,
  onExportButtonClick,
  currentPage,
  fullscreenId,
  currentUser,
  tabId,
  onSave,
  renewalDisplayed,
  onDisabledFeatureClick
}) => {
  const slug = currentPage == null ? void 0 : currentPage.slug;
  const isDraft = currentPage == null ? void 0 : currentPage.isDraft;
  const canSeeCorrection = (currentUser == null ? void 0 : currentUser.isTeacher) && !(currentUser == null ? void 0 : currentUser.isTrial);
  const [showQuestions, setShowQuestions] = useState7(true);
  const [showCorrections, setShowCorrections] = useState7(false);
  const [loading, setLoading] = useState7(false);
  const resetLoader = () => setLoading(false);
  useEffect3(() => {
    if (!showQuestions) setShowCorrections(false);
  }, [showQuestions]);
  const handleButtonClick = async (type) => {
    if (currentUser == null ? void 0 : currentUser.isTrial) return onDisabledFeatureClick();
    const draftId = isDraft ? await onSave() : void 0;
    const correctSlug = draftId ? `page/${draftId}` : slug;
    const link = getUrl({
      slug: correctSlug,
      type,
      fullscreenId,
      tabId,
      showCorrections,
      showQuestions,
      renewalDisplayed
    });
    dispatchAnalyticsEvent4(ANALYTICS_EVENTS_PAGE_EXPORTED, {
      exportFormat: getExportFormat({ type, showQuestions, showCorrections })
    });
    type !== "moodle" && setLoading(true);
    onExportButtonClick({ link, resetLoader, shouldLoad: type !== "moodle" });
  };
  const onPdfButtonClick = () => handleButtonClick("pdf");
  const onWordButtonClick = () => handleButtonClick("word");
  const onMoodleButtonClick = () => handleButtonClick("moodle");
  return isOpen ? /* @__PURE__ */ jsx16(modalWithTheme_default, { title: "T\xE9l\xE9charger la page", closeModal: close, className: EXPORT_MODAL_CLASSNAME, children: /* @__PURE__ */ jsx16("div", { className: src_internals_components_modal_exportModal_default.modalContent, children: loading ? /* @__PURE__ */ jsxs11(Fragment6, { children: [
    /* @__PURE__ */ jsx16(CircularProgressBar, { className: src_internals_components_modal_exportModal_default.circularProgressBar, radius: 30 }),
    "Pr\xE9paration du fichier en cours..."
  ] }) : /* @__PURE__ */ jsxs11(Fragment6, { children: [
    /* @__PURE__ */ jsx16("p", { className: src_internals_components_modal_exportModal_default.title, children: "Options de t\xE9l\xE9chargement :" }),
    /* @__PURE__ */ jsxs11("div", { className: src_internals_components_modal_exportModal_default.section, children: [
      /* @__PURE__ */ jsx16(
        SwitchButton2,
        {
          className: src_internals_components_modal_exportModal_default.switchButton,
          value: showQuestions,
          onChange: setShowQuestions,
          trueLabel: "Inclure les champs de r\xE9ponse",
          falseLabel: "Inclure les champs de r\xE9ponse"
        }
      ),
      canSeeCorrection && /* @__PURE__ */ jsx16(
        SwitchButton2,
        {
          className: src_internals_components_modal_exportModal_default.switchButton,
          value: showCorrections,
          onChange: setShowCorrections,
          trueLabel: "Inclure les corrections",
          falseLabel: "Inclure les corrections",
          disabled: !showQuestions
        }
      )
    ] }),
    /* @__PURE__ */ jsx16(Divider2, { className: src_internals_components_modal_exportModal_default.divider }),
    /* @__PURE__ */ jsx16("p", { className: src_internals_components_modal_exportModal_default.title, children: "Type de t\xE9l\xE9chargement :" }),
    /* @__PURE__ */ jsxs11("div", { className: src_internals_components_modal_exportModal_default.buttonSection, children: [
      /* @__PURE__ */ jsxs11("div", { className: src_internals_components_modal_exportModal_default.button, onClick: onPdfButtonClick, "data-color": "error", children: [
        /* @__PURE__ */ jsx16(Icon3, { className: src_internals_components_modal_exportModal_default.icon, name: "printer" }),
        "PDF"
      ] }),
      /* @__PURE__ */ jsxs11("div", { className: src_internals_components_modal_exportModal_default.button, onClick: onWordButtonClick, "data-color": "tertiary", children: [
        /* @__PURE__ */ jsx16(Icon3, { className: src_internals_components_modal_exportModal_default.icon, name: "word" }),
        "Word"
      ] }),
      /* @__PURE__ */ jsxs11("div", { className: src_internals_components_modal_exportModal_default.button, onClick: onMoodleButtonClick, "data-color": "orange", children: [
        /* @__PURE__ */ jsx16(Icon3, { className: src_internals_components_modal_exportModal_default.icon, name: "moodle" }),
        "Moodle"
      ] })
    ] })
  ] }) }) }) : null;
};
var exportModal_default = ExportModal;

// src/internals/components/modal/offlineModal.jsx
import { Button as Button8, Icon as Icon4, Modal as Modal5 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_modal_offlineModal.module.css
var src_internals_components_modal_offlineModal_default = { "modalContent": "sk-xcV7Zq-modalContent" };

// src/internals/components/modal/offlineModal.jsx
import { jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var OfflineModal = ({ close }) => /* @__PURE__ */ jsx17(Modal5, { title: "Non Disponible", closeModal: close, className: OFFLINE_MODAL_CLASSNAME, children: /* @__PURE__ */ jsxs12("div", { className: src_internals_components_modal_offlineModal_default.modalContent, children: [
  /* @__PURE__ */ jsx17(Icon4, { name: "wifislash" }),
  /* @__PURE__ */ jsx17("div", { className: "offline-modal-text", children: "Vous devez \xEAtre connect\xE9 \xE0 Internet pour acc\xE9der \xE0 cette fonctionnalit\xE9" }),
  /* @__PURE__ */ jsx17(Button8, { onClick: close, children: "Retour" })
] }) });
var offlineModal_default = OfflineModal;

// tmp_esbuild1736180050074/_src_internals_components_cardToolbar_index.module.css
var src_internals_components_cardToolbar_index_default = { "toolsMenuButton": "sk-OhI2uq-toolsMenuButton", "toolbarHolder": "sk-OhI2uq-toolbarHolder", "button": "sk-OhI2uq-button", "divider": "sk-OhI2uq-divider" };

// src/internals/components/cardToolbar/toolsMenu/accessibilityButton.jsx
import _19 from "lodash/fp.js";
import { useCallback as useCallback8 } from "react";

// src/internals/components/cardToolbar/toolsMenu/toolsMenuButton.jsx
import { Button as Button9, Z_TOOLBAR_MENU } from "@lls/lls-kit";
import _18 from "lodash/fp.js";
import { Children, cloneElement, isValidElement, useCallback as useCallback7, useEffect as useEffect4, useState as useState8 } from "react";
import { cx as cx6, makeComponent as makeComponent2 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_cardToolbar_toolsMenu_toolsMenuButton.module.css
var src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default = { "menuButton": "sk-vVtOUa-menuButton", "animatedDotIcon": "sk-vVtOUa-animatedDotIcon", "container": "sk-vVtOUa-container", "hola": "sk-vVtOUa-hola", "card": "sk-vVtOUa-card", "dot": "sk-vVtOUa-dot", "viewer-fullscreen-modal": "sk-vVtOUa-viewer-fullscreen-modal", "overlay": "sk-vVtOUa-overlay" };

// src/internals/components/cardToolbar/toolsMenu/toolsMenuButton.jsx
import { jsx as jsx18, jsxs as jsxs13 } from "react/jsx-runtime";
var ANIMATION_DURATION = 400;
var ANIMATION_DELAY = 150;
var MenuButton = makeComponent2(Button9, src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.menuButton);
var AnimatedDotsIcon = ({ isanimated = false, ...props }) => /* @__PURE__ */ jsxs13("div", { className: src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.animatedDotIcon, ...props, children: [
  /* @__PURE__ */ jsx18(
    "div",
    {
      className: src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.dot,
      style: { "--s-animation-duration": `${ANIMATION_DURATION}ms`, "--s-animation-delay": `${ANIMATION_DELAY}ms` },
      "data-isanimated": +isanimated
    }
  ),
  /* @__PURE__ */ jsx18(
    "div",
    {
      className: src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.dot,
      style: { "--s-animation-duration": `${ANIMATION_DURATION}ms`, "--s-animation-delay": `${ANIMATION_DELAY}ms` },
      "data-isanimated": +isanimated
    }
  ),
  /* @__PURE__ */ jsx18(
    "div",
    {
      className: src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.dot,
      style: { "--s-animation-duration": `${ANIMATION_DURATION}ms`, "--s-animation-delay": `${ANIMATION_DELAY}ms` },
      "data-isanimated": +isanimated
    }
  )
] });
var ToolsMenu = ({ children, open = false }) => /* @__PURE__ */ jsx18(
  "div",
  {
    className: src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.card,
    style: { "--s-animation-duration": `${ANIMATION_DURATION}ms`, "--s-z-toolbar-menu": Z_TOOLBAR_MENU },
    "data-open": +open,
    children
  }
);
var ToolsMenuButton = ({ children, size = "big", className, ...props }) => {
  const [open, setOpen] = useState8(false);
  const [isAnimated, setIsAnimated] = useState8(false);
  const onClickCallback = useCallback7(() => {
    setOpen((old) => !old);
    setIsAnimated(true);
  }, []);
  const closeMenu = useCallback7(() => setOpen(false), []);
  useEffect4(() => {
    _18.noop(isAnimated);
    const id = setTimeout(() => {
      setIsAnimated(false);
    }, ANIMATION_DURATION + ANIMATION_DELAY);
    return () => {
      clearTimeout(id);
    };
  }, [isAnimated]);
  return /* @__PURE__ */ jsxs13("div", { className: cx6(className, src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.container), children: [
    /* @__PURE__ */ jsx18(ToolsMenu, { open, children: Children.map(
      children,
      (child) => isValidElement(child) ? cloneElement(child, {
        closeMenu
      }) : null
    ) }),
    open && /* @__PURE__ */ jsx18("div", { className: src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.overlay, onClick: closeMenu }),
    /* @__PURE__ */ jsx18(
      Button9,
      {
        className: src_internals_components_cardToolbar_toolsMenu_toolsMenuButton_default.menuButton,
        theme: "gray",
        accent: "main",
        AnimatedIcon: AnimatedDotsIcon,
        animatedIconProps: { isanimated: isAnimated },
        size,
        onClick: onClickCallback,
        ...props
      }
    )
  ] });
};
var toolsMenuButton_default = ToolsMenuButton;

// src/internals/components/cardToolbar/toolsMenu/accessibilityButton.jsx
import { jsx as jsx19 } from "react/jsx-runtime";
var AccessibilityButton = ({
  theme = "gray",
  accent = "floating",
  inverted = true,
  onClick = _19.noop,
  openAccessibilityModal = _19.noop,
  closeMenu = _19.noop
}) => {
  const onClickCb = useCallback8(
    (event) => {
      onClick(event, openAccessibilityModal);
      closeMenu();
    },
    [openAccessibilityModal, onClick, closeMenu]
  );
  return /* @__PURE__ */ jsx19(
    MenuButton,
    {
      theme,
      accent,
      inverted,
      icon: "textformatsize",
      size: "small",
      onClick: onClickCb,
      children: "Affichage"
    }
  );
};
var accessibilityButton_default = AccessibilityButton;

// src/internals/components/cardToolbar/toolsMenu/exportButton.jsx
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent5 } from "@lls/utils";
import _20 from "lodash/fp.js";
import { useCallback as useCallback9 } from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var ExportButton = ({ onClick = _20.noop, closeMenu = _20.noop, disabled = false }) => {
  const onClickCb = useCallback9(() => {
    dispatchAnalyticsEvent5(ANALYTICS_EVENTS_PAGE_EXPORT_STARTED);
    onClick();
    closeMenu();
  }, [closeMenu, onClick]);
  return disabled ? /* @__PURE__ */ jsx20("div", { onClick, children: /* @__PURE__ */ jsx20(
    MenuButton,
    {
      "data-disabled": +disabled,
      disabled,
      theme: "gray",
      accent: "floating",
      inverted: true,
      icon: "arrowdowntoline",
      size: "small",
      children: "T\xE9l\xE9charger"
    }
  ) }) : /* @__PURE__ */ jsx20(MenuButton, { theme: "gray", accent: "floating", inverted: true, icon: "arrowdowntoline", size: "small", onClick: onClickCb, children: "T\xE9l\xE9charger" });
};
var exportButton_default = ExportButton;

// src/internals/components/cardToolbar/toolsMenu/shareButton.jsx
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent6 } from "@lls/utils";
import _21 from "lodash/fp.js";
import { useCallback as useCallback10 } from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var ShareButton = ({ onClick = _21.noop, closeMenu = _21.noop, openShareModal = _21.noop, disabled = false }) => {
  const onClickCb = useCallback10(
    (event) => {
      dispatchAnalyticsEvent6(ANALYTICS_EVENTS_PAGE_SHARE_STARTED);
      onClick(event, openShareModal);
      closeMenu();
    },
    [closeMenu, onClick, openShareModal]
  );
  return disabled ? /* @__PURE__ */ jsx21("div", { onClick: openShareModal, children: /* @__PURE__ */ jsx21(
    MenuButton,
    {
      theme: "gray",
      accent: "floating",
      inverted: true,
      icon: "share",
      size: "small",
      "data-disabled": +disabled,
      disabled,
      children: "Partager"
    }
  ) }) : /* @__PURE__ */ jsx21(MenuButton, { theme: "gray", accent: "floating", inverted: true, icon: "share", size: "small", onClick: onClickCb, children: "Partager" });
};
var shareButton_default = ShareButton;

// src/internals/components/cardToolbar/toolsMenu/ttsButton.jsx
import _22 from "lodash/fp.js";
import { useCallback as useCallback11 } from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var TtsButton = ({ onClick = _22.noop, closeMenu, disabled = false }) => {
  const onClickCb = useCallback11(() => {
    onClick();
    closeMenu();
  }, [closeMenu, onClick]);
  return disabled ? /* @__PURE__ */ jsx22("div", { onClick, children: /* @__PURE__ */ jsx22(
    MenuButton,
    {
      "data-cy": "tts-button",
      "data-disabled": +disabled,
      disabled,
      theme: "gray",
      accent: "floating",
      inverted: true,
      icon: "speakerwave",
      size: "small",
      children: "\xC9couter"
    }
  ) }) : /* @__PURE__ */ jsx22(
    MenuButton,
    {
      "data-cy": "tts-button",
      theme: "gray",
      accent: "floating",
      inverted: true,
      icon: "speakerwave",
      size: "small",
      onClick: onClickCb,
      children: "\xC9couter"
    }
  );
};
var ttsButton_default = TtsButton;

// src/internals/components/cardToolbar/index.jsx
import { Fragment as Fragment7, jsx as jsx23, jsxs as jsxs14 } from "react/jsx-runtime";
var CardToolbar = ({
  accessibilityProps = {},
  fullscreenProps: { fullscreenId = "", setFullscreenId = _23.noop, onFullscreenClose = _23.noop } = {},
  ttsProps: { fullscreenHtml, subjectId } = {},
  currentPage,
  onExportButtonClick: iOnExportButtonClick = _23.noop,
  exportProps: { closeOnExport = false } = {},
  shareProps = {},
  className,
  isOffline = false,
  isTouchable = false,
  isFreeMode = false,
  currentUser = {}
} = {}) => {
  const closeFullscreenCard = useCallback12(
    (e) => onFullscreenClose(e, () => setFullscreenId(null)),
    [setFullscreenId, onFullscreenClose]
  );
  const [isOfflineModalOpen, setIsOfflineModalOpen] = useState9(false);
  const openOfflineModal = useCallback12(() => setIsOfflineModalOpen(true), []);
  const closeOfflineModal = useCallback12(() => setIsOfflineModalOpen(false), []);
  const onShareButtonClick = _23.getOr(_23.noop, "onShareButtonClick", shareProps);
  const onAccessibilityButtonClick = _23.getOr(_23.noop, "onAccessibilityButtonClick", accessibilityProps);
  const [isAccessibilityModalOpen, setIsAccessibilityModalOpen] = useState9(false);
  const openAccessibilityModal = useCallback12(() => setIsAccessibilityModalOpen(true), []);
  const closeAccessibilityModal = useCallback12(() => setIsAccessibilityModalOpen(false), []);
  const [isTtsModalOpen, setIsTtsModalOpen] = useState9(false);
  const openTtsModal = useCallback12(() => {
    setIsTtsModalOpen(true);
  }, []);
  const closeTtsModal = useCallback12(() => setIsTtsModalOpen(false), []);
  const [isExportModalOpen, setIsExportModalOpen] = useState9(false);
  const onExportButtonClick = useExportModal_default({
    onExportButtonClick: iOnExportButtonClick,
    closeOnExport,
    setIsExportModalOpen
  });
  const openExportModal = useCallback12(() => setIsExportModalOpen(true), []);
  const closeExportModal = useCallback12(() => setIsExportModalOpen(false), []);
  const [isShareModalOpen, setIsShareModalOpen] = useState9(false);
  const openShareModal = useCallback12(() => setIsShareModalOpen(true), []);
  const closeShareModal = useCallback12(() => setIsShareModalOpen(false), []);
  return /* @__PURE__ */ jsxs14(Fragment7, { children: [
    fullscreenId && /* @__PURE__ */ jsxs14("div", { style: { "--s-z-card-toolbar": Z_CARD_TOOLBAR }, className: cx7(className, src_internals_components_cardToolbar_index_default.toolbarHolder), children: [
      /* @__PURE__ */ jsx23(
        Button10,
        {
          className: src_internals_components_cardToolbar_index_default.button,
          onClick: closeFullscreenCard,
          theme: "gray",
          accent: "alt",
          size: "small",
          icon: "cancel",
          inverted: true
        }
      ),
      /* @__PURE__ */ jsxs14(toolsMenuButton_default, { className: src_internals_components_cardToolbar_index_default.toolsMenuButton, size: "small", children: [
        /* @__PURE__ */ jsx23(accessibilityButton_default, { onClick: onAccessibilityButtonClick, openAccessibilityModal }),
        /* @__PURE__ */ jsx23(ttsButton_default, { disabled: isOffline, onClick: isOffline ? openOfflineModal : openTtsModal }),
        /* @__PURE__ */ jsx23(Divider3, { className: src_internals_components_cardToolbar_index_default.divider }),
        /* @__PURE__ */ jsx23(
          shareButton_default,
          {
            onClick: onShareButtonClick,
            openShareModal: isOffline ? openOfflineModal : openShareModal,
            disabled: isOffline
          }
        ),
        /* @__PURE__ */ jsx23(exportButton_default, { disabled: isOffline, onClick: isOffline ? openOfflineModal : openExportModal })
      ] })
    ] }),
    /* @__PURE__ */ jsx23(
      accessibilityModal_default,
      {
        isFreeMode,
        isOpen: isAccessibilityModalOpen,
        close: closeAccessibilityModal,
        ...accessibilityProps
      }
    ),
    /* @__PURE__ */ jsx23(
      ttsModal_default,
      {
        open: isTtsModalOpen,
        close: closeTtsModal,
        fullscreenHtml,
        subjectId,
        isTouchable,
        isDarkMode: accessibilityProps.isDarkMode
      }
    ),
    /* @__PURE__ */ jsx23(
      exportModal_default,
      {
        currentPage,
        fullscreenId,
        isOpen: isExportModalOpen,
        close: closeExportModal,
        onExportButtonClick,
        currentUser
      }
    ),
    /* @__PURE__ */ jsx23(
      shareModal_default,
      {
        ...shareProps,
        isModalOpen: isShareModalOpen,
        closeModal: closeShareModal,
        isOffline,
        openOfflineModal
      }
    ),
    isOfflineModalOpen && /* @__PURE__ */ jsx23(offlineModal_default, { close: closeOfflineModal })
  ] });
};
var cardToolbar_default = CardToolbar;

// src/internals/components/copies/breadcrumb.jsx
import _30 from "lodash/fp.js";
import { useCallback as useCallback16, useEffect as useEffect6, useMemo as useMemo3, useRef as useRef4, useState as useState12 } from "react";
import { Button as Button13, MenuButton as MenuButton2, SelectField as SelectField3, SwitchButton as SwitchButton3 } from "@lls/lls-kit";
import { cx as cx9, dispatchAnalyticsEvent as dispatchAnalyticsEvent7, getPageInterval, makeComponent as makeComponent3 } from "@lls/utils";

// src/internals/components/groups/selectGroupModal/index.jsx
import { useCallback as useCallback14, useDeferredValue, useMemo as useMemo2, useRef as useRef2, useState as useState10 } from "react";
import _28 from "lodash/fp.js";
import { Button as Button11, Modal as Modal6, SelectList as SelectList3, Tab as Tab3, Tabs as Tabs3, TextField as TextField2 } from "@lls/lls-kit";

// src/internals/components/groups/editGroupModal/userList.jsx
import _27 from "lodash/fp.js";
import { useCallback as useCallback13, useMemo } from "react";
import { Divider as Divider5 } from "@lls/lls-kit";
import LazyLoadModule from "react-lazyload";

// src/internals/utils/groups.ts
import _24 from "lodash/fp.js";
var groupGroupsByStudentId = (groups = []) => _24.flow(
  _24.flatMap(
    (group) => {
      var _a;
      return (_a = group.students) == null ? void 0 : _a.map((studentId) => ({
        studentId,
        group
      }));
    }
  ),
  _24.groupBy("studentId"),
  _24.mapValues(_24.map("group"))
)(groups);
var getLevelName = (levelName = "") => _24.replace("\xE8me", "e", levelName);
var connectorNameToField = (connectorName = "") => {
  if (_24.isEmpty(connectorName)) {
    return void 0;
  }
  const name = _24.getOr("ENT", connectorName, CONNECTOR_NAME_TO_LABEL);
  return { id: name, name };
};
var connectorFieldToName = (connectorField) => {
  const name = _24.get("name", connectorField);
  return _24.isEmpty(name) ? void 0 : _24.flow(_24.toPairs, _24.find({ 1: name }), _24.getOr("ENT", 0))(CONNECTOR_NAME_TO_LABEL);
};
var getConnectorFields = _24.flow(
  _24.reject(_24.isEqual("gar_test")),
  _24.map(connectorNameToField),
  _24.compact,
  _24.uniqBy("name"),
  _24.sortBy("name")
);
var shouldDisplaySources = ({
  connectorFields,
  users
}) => _24.some(_24.flow(_24.get("connectorName"), _24.isEmpty), users) && !_24.isEmpty(connectorFields) || _24.size(connectorFields) >= 2;

// src/internals/components/groups/editGroupModal/userList.jsx
import { cx as cx8 } from "@lls/utils";

// src/internals/components/groups/editGroupModal/userCheckbox.jsx
import { CheckBox, Divider as Divider4, Stamp } from "@lls/lls-kit";
import _26 from "lodash/fp.js";

// src/internals/utils/date.tsx
import dayjs from "dayjs";
import "dayjs/locale/fr.js";
import _25 from "lodash/fp.js";
dayjs.locale("fr");
var MS_PER_SECOND = 1e3;
var MS_PER_MINUTE = 60 * MS_PER_SECOND;
var MS_PER_HOUR = 60 * MS_PER_MINUTE;
var format = (inputString, pattern) => dayjs(inputString).format(pattern);
var parseHoursTime = (time) => {
  const hours = _25.floor(time / MS_PER_HOUR);
  const minutes = _25.floor(time % MS_PER_HOUR / MS_PER_MINUTE);
  const seconds = _25.floor(time % MS_PER_MINUTE / MS_PER_SECOND);
  return [hours, minutes, seconds];
};
var timeToText = (time) => {
  const [hours, minutes, seconds] = parseHoursTime(time);
  const hoursText = hours ? `${hours}h ` : "";
  const minutesText = minutes ? `${minutes}min ` : "";
  const secondsText = seconds ? `${seconds}s` : "";
  return _25.trim(hours ? `${hoursText}${minutesText}` : `${minutesText}${secondsText}`);
};
var getUserDisplayedDate = (date) => {
  const days = dayjs(Date.now()).diff(date, "day");
  switch (days) {
    case 0:
      return "En ligne aujourd'hui";
    case 1:
      return "En ligne hier";
    default:
      return `En ligne il y a ${days} jours`;
  }
};

// tmp_esbuild1736180050074/_src_internals_components_groups_editGroupModal_userCheckbox.module.css
var src_internals_components_groups_editGroupModal_userCheckbox_default = { "label": "sk-w6Tmpa-label", "user": "sk-w6Tmpa-user", "contentUser": "sk-w6Tmpa-contentUser", "userName": "sk-w6Tmpa-userName", "userDetails": "sk-w6Tmpa-userDetails", "divider": "sk-w6Tmpa-divider" };

// src/internals/components/groups/editGroupModal/userCheckbox.jsx
import { Fragment as Fragment8, jsx as jsx24, jsxs as jsxs15 } from "react/jsx-runtime";
var UserCheckbox = ({ user, levelById, isChecked, onToggle, groups }) => {
  const groupsByStudent = _26.getOr([], _26.get("id", user), groups);
  const htmlId = `user-checkbox-${_26.get("id", user)}`;
  const lastLogin = _26.get("lastLogin", user);
  const connectorLabel = _26.flow(_26.get("connectorName"), connectorNameToField, _26.get("name"))(user);
  const level = _26.get([_26.get("levels.0", user), "name"], levelById);
  const userInfos = _26.flow(
    _26.compact,
    _26.join(", ")
  )([level || void 0, lastLogin ? getUserDisplayedDate(lastLogin) : void 0, connectorLabel || void 0]);
  return /* @__PURE__ */ jsxs15(Fragment8, { children: [
    /* @__PURE__ */ jsxs15("label", { className: src_internals_components_groups_editGroupModal_userCheckbox_default.label, htmlFor: htmlId, "data-checked": +!!isChecked, children: [
      /* @__PURE__ */ jsx24(CheckBox, { id: htmlId, checked: isChecked, onChange: onToggle }),
      /* @__PURE__ */ jsx24("div", { className: src_internals_components_groups_editGroupModal_userCheckbox_default.user, children: /* @__PURE__ */ jsxs15("div", { className: src_internals_components_groups_editGroupModal_userCheckbox_default.contentUser, children: [
        /* @__PURE__ */ jsxs15("div", { "data-clarity-mask": "true", children: [
          /* @__PURE__ */ jsx24("span", { className: src_internals_components_groups_editGroupModal_userCheckbox_default.userName, children: getStudentFullName(user) }),
          !_26.isEmpty(userInfos) && /* @__PURE__ */ jsxs15("span", { className: src_internals_components_groups_editGroupModal_userCheckbox_default.userDetails, children: [
            " - ",
            userInfos
          ] })
        ] }),
        /* @__PURE__ */ jsx24("div", { children: _26.map(
          (group) => /* @__PURE__ */ jsx24(Stamp, { size: "small", theme: "gray", children: group.name }, group.id),
          groupsByStudent
        ) })
      ] }) })
    ] }),
    /* @__PURE__ */ jsx24(Divider4, { className: src_internals_components_groups_editGroupModal_userCheckbox_default.divider })
  ] });
};
var userCheckbox_default = UserCheckbox;

// tmp_esbuild1736180050074/_src_internals_components_groups_editGroupModal_userList.module.css
var src_internals_components_groups_editGroupModal_userList_default = { "div": "sk-_mKAhG-div", "divider": "sk-_mKAhG-divider", "center": "sk-_mKAhG-center", "letter": "sk-_mKAhG-letter" };

// src/internals/components/groups/editGroupModal/userList.jsx
import { jsx as jsx25, jsxs as jsxs16 } from "react/jsx-runtime";
var LazyLoad = LazyLoadModule.default || LazyLoadModule;
var ADDED_USER = "add";
var REMOVED_USER = "remove";
var UserList = ({ users, allUsers, groups, allLevels, onChange, className }) => {
  const usersById = useMemo(() => _27.keyBy("id", users), [users]);
  const levelById = useMemo(() => _27.keyBy("id", allLevels), [allLevels]);
  const handleToggle = useCallback13(
    (user, checked) => {
      checked ? onChange(_27.concat(user, users), ADDED_USER) : onChange(_27.remove(user, users), REMOVED_USER);
    },
    [onChange, users]
  );
  const aUsers = useMemo(() => {
    const allGroupsByUser = groupGroupsByStudentId(groups);
    return _27.flow(
      _27.groupBy(getUserFirstLetter),
      _27.toPairs,
      _27.sortBy(0),
      _27.flatMap(([letter, userList]) => /* @__PURE__ */ jsx25(LazyLoad, { once: true, overflow: true, height: "100%", offset: 800, children: /* @__PURE__ */ jsxs16("div", { children: [
        /* @__PURE__ */ jsx25("div", { className: src_internals_components_groups_editGroupModal_userList_default.letter, children: /* @__PURE__ */ jsx25("div", { className: src_internals_components_groups_editGroupModal_userList_default.center, children: /* @__PURE__ */ jsx25("span", { children: letter }) }) }),
        /* @__PURE__ */ jsx25(Divider5, { className: src_internals_components_groups_editGroupModal_userList_default.divider }),
        _27.map(
          (user) => /* @__PURE__ */ jsx25(
            userCheckbox_default,
            {
              user,
              groups: allGroupsByUser,
              isChecked: _27.has(_27.get("id", user), usersById),
              onToggle: (yes) => handleToggle(user, yes),
              levelById
            },
            _27.get("id", user)
          ),
          userList
        )
      ] }) }, `letter_${letter}`))
    )(allUsers);
  }, [allUsers, levelById, usersById, groups, handleToggle]);
  return /* @__PURE__ */ jsx25("div", { className: cx8(className, src_internals_components_groups_editGroupModal_userList_default.div), children: aUsers });
};
var userList_default = UserList;

// tmp_esbuild1736180050074/_src_internals_components_groups_selectGroupModal_index.module.css
var src_internals_components_groups_selectGroupModal_index_default = { "userButtonContainer": "sk-YH9X2W-userButtonContainer", "selectList": "sk-YH9X2W-selectList", "noGroupSection": "sk-YH9X2W-noGroupSection", "searchUserInput": "sk-YH9X2W-searchUserInput", "userList": "sk-YH9X2W-userList", "dialogContent": "sk-YH9X2W-dialogContent" };

// src/internals/components/groups/selectGroupModal/index.jsx
import { Fragment as Fragment9, jsx as jsx26, jsxs as jsxs17 } from "react/jsx-runtime";
var ModalMenu3 = ({ selectedTab, handleTabChange }) => /* @__PURE__ */ jsxs17(Tabs3, { value: selectedTab, onChange: handleTabChange, fullWidth: true, variant: "noBackground", children: [
  /* @__PURE__ */ jsx26(Tab3, { children: "Classe" }),
  /* @__PURE__ */ jsx26(Tab3, { children: "\xC9l\xE8ve" })
] });
var GroupList = ({ setSelectedGroup, groups, selectedGroup }) => {
  const options = _28.map((group) => ({ value: group, label: _28.get("name", group) }), groups);
  const selectedOption = { value: selectedGroup, label: _28.get("name", selectedGroup) };
  const selectOption = useCallback14(
    (selected) => {
      setSelectedGroup(_28.get("value", selected));
    },
    [setSelectedGroup]
  );
  return /* @__PURE__ */ jsxs17(Fragment9, { children: [
    /* @__PURE__ */ jsx26(StyledSubtitle, { children: `S\xE9lectionnez la classe d'\xE9l\xE8ves avec lequel vous souhaitez partager les corrections, puis cliquez sur le bouton "Partager".` }),
    /* @__PURE__ */ jsx26(
      SelectList3,
      {
        className: src_internals_components_groups_selectGroupModal_index_default.selectList,
        "data-clarity-mask": "true",
        options,
        selectedOption,
        selectOption
      }
    )
  ] });
};
var GroupTab2 = ({ groups, setSelectedGroup, selectedGroup, onManageGroupClick, onShareGroup }) => {
  return !_28.isEmpty(groups) ? /* @__PURE__ */ jsxs17(Fragment9, { children: [
    /* @__PURE__ */ jsx26(GroupList, { setSelectedGroup, selectedGroup, groups }),
    /* @__PURE__ */ jsxs17("div", { className: "dialog-content-button-container", children: [
      /* @__PURE__ */ jsx26(Button11, { accent: "floating", onClick: onManageGroupClick, children: "G\xE9rer les classes" }),
      /* @__PURE__ */ jsx26(Button11, { onClick: onShareGroup, disabled: _28.isEmpty(selectedGroup), icon: "arrowshareturnupright", children: "Partager" })
    ] })
  ] }) : /* @__PURE__ */ jsxs17("div", { className: src_internals_components_groups_selectGroupModal_index_default.noGroupSection, children: [
    "Vous n'avez pas d\xE9fini de classe d'\xE9l\xE8ves.",
    /* @__PURE__ */ jsx26("div", { className: "dialog-content-button-container no-group-button-container", children: /* @__PURE__ */ jsx26(Button11, { onClick: onManageGroupClick, children: "G\xE9rer les classes" }) })
  ] });
};
var StudentsTab = ({ allUsers, setSelectedStudents, selectedStudents, onShareStudents }) => {
  const searchRef = useRef2();
  const [searchValue, setSearchValue] = useState10("");
  const deferredSearch = useDeferredValue(searchValue);
  const orderedUsers = useMemo2(() => _28.sortBy(getStudentFullName, allUsers), [allUsers]);
  const filteredUsers = useMemo2(() => {
    return searchUsers(orderedUsers, {
      search: searchValue
    });
  }, [searchValue, orderedUsers]);
  return /* @__PURE__ */ jsxs17(Fragment9, { children: [
    /* @__PURE__ */ jsx26(StyledSubtitle, { children: 'S\xE9lectionnez les \xE9l\xE8ves avec lequels vous souhaitez partager les corrections, puis cliquez sur le bouton "Partager".' }),
    /* @__PURE__ */ jsx26(
      TextField2,
      {
        className: src_internals_components_groups_selectGroupModal_index_default.searchUserInput,
        ref: searchRef,
        icon: "magnificentglass",
        placeholder: "Recherchez des \xE9l\xE8ves",
        value: deferredSearch,
        onChange: setSearchValue,
        width: "100%"
      }
    ),
    /* @__PURE__ */ jsx26(
      userList_default,
      {
        className: src_internals_components_groups_selectGroupModal_index_default.userList,
        allUsers: filteredUsers,
        users: selectedStudents,
        onChange: setSelectedStudents
      }
    ),
    /* @__PURE__ */ jsx26("div", { className: src_internals_components_groups_selectGroupModal_index_default.userButtonContainer, children: /* @__PURE__ */ jsx26(Button11, { onClick: onShareStudents, disabled: _28.isEmpty(selectedStudents), icon: "arrowshareturnupright", children: "Partager" }) })
  ] });
};
var SelectGroupModal = ({
  closeModal,
  isModalOpen,
  students,
  setSelectedStudents,
  selectedStudents,
  onShareStudents,
  setSelectedGroup,
  ...props
}) => {
  const [selectedTab, setSelectedTab] = useState10(0);
  const selectTabAndReinitSelection = useCallback14(
    (newSelectedTab) => {
      newSelectedTab === 1 ? setSelectedGroup(null) : setSelectedStudents([]);
      setSelectedTab(newSelectedTab);
    },
    [setSelectedStudents, setSelectedGroup]
  );
  return isModalOpen && /* @__PURE__ */ jsx26(Modal6, { title: "Partager", closeModal, children: /* @__PURE__ */ jsxs17("div", { className: src_internals_components_groups_selectGroupModal_index_default.dialogContent, children: [
    /* @__PURE__ */ jsx26(ModalMenu3, { selectedTab, handleTabChange: selectTabAndReinitSelection }),
    selectedTab === 0 && /* @__PURE__ */ jsx26(GroupTab2, { closeModal, setSelectedGroup, ...props }),
    selectedTab === 1 && /* @__PURE__ */ jsx26(
      StudentsTab,
      {
        allUsers: students,
        setSelectedStudents,
        selectedStudents,
        onShareStudents
      }
    )
  ] }) });
};
var selectGroupModal_default = SelectGroupModal;

// src/internals/components/groups/shareCorrectionsModal/index.jsx
import _29 from "lodash/fp.js";
import { useCallback as useCallback15, useState as useState11 } from "react";
import { Button as Button12, Modal as Modal7 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_groups_shareCorrectionsModal_index.module.css
var src_internals_components_groups_shareCorrectionsModal_index_default = { "actionsButtons": "sk-D7M0Ha-actionsButtons", "contentModal": "sk-D7M0Ha-contentModal", "titleContent": "sk-D7M0Ha-titleContent", "subTitle": "sk-D7M0Ha-subTitle" };

// src/internals/components/groups/shareCorrectionsModal/index.jsx
import { Fragment as Fragment10, jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var ShareCorrectionsModal = ({
  viewerComponent,
  pickedTemplate,
  closeShareCorrectionsModal,
  onAddCorrections,
  selectedGroup,
  page
}) => {
  const pageId = _29.get("id", page);
  const selectedCorrections = _29.getOr([], "children", pickedTemplate);
  const countSelectedCorrections = _29.size(selectedCorrections);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState11(false);
  const openConfirmationModal = useCallback15(() => setIsConfirmationModalOpen(true), []);
  const closeConfirmationModal = useCallback15(() => setIsConfirmationModalOpen(false), []);
  const onShareClick = useCallback15(() => {
    const corrections = [{ pageId, uuids: _29.flatMap("uuid", selectedCorrections) }];
    onAddCorrections({ group: selectedGroup, corrections }, closeShareCorrectionsModal);
  }, [pageId, selectedCorrections, onAddCorrections, selectedGroup, closeShareCorrectionsModal]);
  return /* @__PURE__ */ jsxs18(Fragment10, { children: [
    /* @__PURE__ */ jsxs18(
      Modal7,
      {
        title: "S\xE9lectionner les corrections issues du livre du professeur",
        closeModal: closeShareCorrectionsModal,
        fullscreen: true,
        children: [
          /* @__PURE__ */ jsx27("div", { className: src_internals_components_groups_shareCorrectionsModal_index_default.titleContent, children: !_29.isEmpty(selectedCorrections) && /* @__PURE__ */ jsxs18(Fragment10, { children: [
            /* @__PURE__ */ jsxs18("h5", { className: src_internals_components_groups_shareCorrectionsModal_index_default.subTitle, children: [
              countSelectedCorrections,
              " ",
              handlePlural("correction", selectedCorrections),
              " ",
              handlePlural("s\xE9lection\xE9e", selectedCorrections)
            ] }),
            /* @__PURE__ */ jsx27("div", { className: src_internals_components_groups_shareCorrectionsModal_index_default.actionsButtons, style: { "--s-justify": "space-between" }, children: /* @__PURE__ */ jsx27(
              Button12,
              {
                theme: "primary",
                onClick: isModifiedPage(page) ? openConfirmationModal : onShareClick,
                disabled: _29.isEmpty(selectedCorrections),
                children: "PARTAGER"
              }
            ) })
          ] }) }),
          viewerComponent
        ]
      }
    ),
    isConfirmationModalOpen && /* @__PURE__ */ jsxs18(Modal7, { title: "Partage de correction", closeModal: closeConfirmationModal, children: [
      /* @__PURE__ */ jsx27("div", { className: src_internals_components_groups_shareCorrectionsModal_index_default.contentModal, children: "Assurez-vous de v\xE9rifier les corrections propos\xE9es avant de valider le partage \xE0 vos \xE9l\xE8ves" }),
      /* @__PURE__ */ jsxs18("div", { className: src_internals_components_groups_shareCorrectionsModal_index_default.actionsButtons, style: { "--s-justify": "flex-end" }, children: [
        /* @__PURE__ */ jsx27(Button12, { accent: "floating", inverted: true, onClick: closeConfirmationModal, children: "V\xE9rifier" }),
        /* @__PURE__ */ jsx27(Button12, { onClick: onShareClick, children: "Partager" })
      ] })
    ] })
  ] });
};
var shareCorrectionsModal_default = ShareCorrectionsModal;

// src/internals/hooks/usePrevious.ts
import { useEffect as useEffect5, useRef as useRef3 } from "react";
var usePrevious = (value, shouldUpdate = true) => {
  const ref = useRef3();
  useEffect5(() => {
    if (shouldUpdate) ref.current = value;
  }, [value, shouldUpdate]);
  return ref.current;
};
var usePrevious_default = usePrevious;

// tmp_esbuild1736180050074/_src_internals_components_copies_breadcrumb.module.css
var src_internals_components_copies_breadcrumb_default = { "div": "sk-jWC0QG-div", "title": "sk-jWC0QG-title", "icon": "sk-jWC0QG-icon", "titlePageInterval": "sk-jWC0QG-titlePageInterval", "secondaryTitle": "sk-jWC0QG-secondaryTitle", "switchButton": "sk-jWC0QG-switchButton", "titles": "sk-jWC0QG-titles", "menuContainer": "sk-jWC0QG-menuContainer", "button": "sk-jWC0QG-button", "leftContent": "sk-jWC0QG-leftContent", "extremitiesContainer": "sk-jWC0QG-extremitiesContainer", "mainTitle": "sk-jWC0QG-mainTitle", "card": "sk-jWC0QG-card", "selectContainer": "sk-jWC0QG-selectContainer", "copyBreadcrumbTitle": "sk-jWC0QG-copyBreadcrumbTitle" };

// src/internals/components/copies/breadcrumb.jsx
import { Fragment as Fragment11, jsx as jsx28, jsxs as jsxs19 } from "react/jsx-runtime";
var Title = ({ page, book, copyBreadcrumb }) => /* @__PURE__ */ jsxs19("div", { className: src_internals_components_copies_breadcrumb_default.titles, children: [
  /* @__PURE__ */ jsx28("span", { className: src_internals_components_copies_breadcrumb_default.mainTitle, children: _30.get("displayTitle", book) }),
  copyBreadcrumb ? /* @__PURE__ */ jsx28("div", { className: src_internals_components_copies_breadcrumb_default.titlePageInterval, children: getPageInterval({ page }) }) : /* @__PURE__ */ jsxs19(Fragment11, { children: [
    /* @__PURE__ */ jsx28("span", { className: src_internals_components_copies_breadcrumb_default.secondaryTitle, children: _30.get("title", page) }),
    /* @__PURE__ */ jsx28("div", { className: src_internals_components_copies_breadcrumb_default.titlePageInterval, children: getPageInterval({ page }) })
  ] })
] });
var StyledTitle = makeComponent3("h1", src_internals_components_copies_breadcrumb_default.title);
var CopiesBreadcrumb = ({
  className,
  onGoBack,
  page,
  book,
  groups,
  students,
  onManageGroupClick,
  showSharebutton,
  shareButtonClick,
  shareGroup,
  setShareGroup,
  isBetaPremium,
  onShareGroup,
  // props for shareCorrections v1
  viewerComponent,
  onAddCorrections,
  pickedTemplate,
  setSelectedStudents = _30.noop,
  selectedStudents = _30.noop,
  onShareStudents = _30.noop
}) => {
  const [isModalOpen, setIsModalOpen] = useState12(false);
  const [isModalShareCorrectionsOpen, setIsModalShareCorrectionsOpen] = useState12(false);
  const openModal = useCallback16(() => {
    setIsModalOpen(true);
    dispatchAnalyticsEvent7(ANALYTICS_EVENTS_CORRECTION_STARTED, { pageId: _30.get("id", page) });
  }, [page]);
  const closeModal = useCallback16(() => {
    setIsModalOpen(false);
    setShareGroup(null);
  }, [setShareGroup]);
  const closeShareCorrectionsModal = useCallback16(() => {
    setIsModalShareCorrectionsOpen(false);
    setShareGroup(null);
  }, [setShareGroup]);
  const onShare = useCallback16(() => {
    if (onShareGroup) {
      onShareGroup();
    }
    setIsModalShareCorrectionsOpen(true);
    setIsModalOpen(false);
  }, [onShareGroup]);
  return /* @__PURE__ */ jsxs19(Fragment11, { children: [
    /* @__PURE__ */ jsxs19("div", { className: cx9(className, src_internals_components_copies_breadcrumb_default.card), children: [
      /* @__PURE__ */ jsxs19("div", { className: src_internals_components_copies_breadcrumb_default.leftContent, children: [
        /* @__PURE__ */ jsx28(Button13, { onClick: onGoBack, icon: "arrowleft", theme: "gray", inverted: true }),
        /* @__PURE__ */ jsx28(Title, { book, page })
      ] }),
      /* @__PURE__ */ jsx28("h1", { className: src_internals_components_copies_breadcrumb_default.title, children: "R\xE9ponses" }),
      /* @__PURE__ */ jsx28("div", { className: src_internals_components_copies_breadcrumb_default.div, children: showSharebutton && /* @__PURE__ */ jsx28(Button13, { theme: "gray", onClick: isBetaPremium ? shareButtonClick : openModal, children: "Partager les corrections" }) })
    ] }),
    isModalOpen && /* @__PURE__ */ jsx28(
      selectGroupModal_default,
      {
        isModalOpen,
        groups,
        page,
        closeModal,
        onManageGroupClick,
        setSelectedGroup: setShareGroup,
        selectedGroup: shareGroup,
        onShareGroup: onShare,
        setSelectedStudents,
        selectedStudents,
        onShareStudents,
        students
      }
    ),
    isModalShareCorrectionsOpen && /* @__PURE__ */ jsx28(
      shareCorrectionsModal_default,
      {
        closeShareCorrectionsModal,
        viewerComponent,
        isModalShareCorrectionsOpen,
        onAddCorrections,
        selectedGroup: shareGroup,
        pickedTemplate,
        page
      }
    )
  ] });
};
var CopyBreadcrumb = ({
  book,
  page,
  onGoBack,
  onStudentResponsesChange,
  students,
  sharedPages,
  onStudentChange,
  selectedPageId,
  areStudentResponsesShown,
  className
}) => {
  const oldSelectedPageId = usePrevious_default(selectedPageId);
  const listItems = useMemo3(
    () => [
      {
        msg: areStudentResponsesShown ? "Tout afficher" : "N'afficher que les r\xE9ponses",
        id: 1,
        onClick: () => onStudentResponsesChange(!areStudentResponsesShown)
      }
    ],
    [onStudentResponsesChange, areStudentResponsesShown]
  );
  const options = useMemo3(
    () => _30.flow(
      _30.map((sharedPage) => ({
        label: getStudentFullName(_30.find({ id: _30.get("user", sharedPage) }, students)),
        value: _30.get("id", sharedPage)
      })),
      _30.sortBy("label")
    )(sharedPages),
    [sharedPages, students]
  );
  const selectedOption = _30.find({ value: selectedPageId }, options);
  const areStudentResponsesShownRef = useRef4();
  areStudentResponsesShownRef.current = areStudentResponsesShown;
  useEffect6(() => {
    !_30.isNil(selectedPageId) && !_30.isEqual(selectedPageId, oldSelectedPageId) && dispatchAnalyticsEvent7(ANALYTICS_EVENTS_STUDENT_ANSWER_VIEWED, {
      pageId: selectedPageId,
      filters: `show_cards_with_answers=${areStudentResponsesShownRef.current}`
    });
  }, [selectedPageId, oldSelectedPageId]);
  return /* @__PURE__ */ jsxs19("div", { className: cx9(className, src_internals_components_copies_breadcrumb_default.card), children: [
    /* @__PURE__ */ jsxs19("div", { className: src_internals_components_copies_breadcrumb_default.extremitiesContainer, style: { "--s-justify": "space-between" }, children: [
      /* @__PURE__ */ jsx28(Button13, { className: src_internals_components_copies_breadcrumb_default.button, onClick: onGoBack, icon: "arrowleft", theme: "gray", inverted: true }),
      /* @__PURE__ */ jsx28(Title, { book, page, copyBreadcrumb: true }),
      /* @__PURE__ */ jsx28("div", { className: src_internals_components_copies_breadcrumb_default.selectContainer, children: /* @__PURE__ */ jsx28(
        SelectField3,
        {
          "data-clarity-mask": "true",
          value: _30.get("value", selectedOption),
          onChange: onStudentChange,
          options,
          listMaxHeight: 400
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx28(StyledTitle, { className: src_internals_components_copies_breadcrumb_default.copyBreadcrumbTitle, children: "R\xE9ponses" }),
    /* @__PURE__ */ jsxs19("div", { className: src_internals_components_copies_breadcrumb_default.extremitiesContainer, style: { "--s-justify": "flex-end" }, children: [
      /* @__PURE__ */ jsx28(
        SwitchButton3,
        {
          className: src_internals_components_copies_breadcrumb_default.switchButton,
          value: areStudentResponsesShown,
          onChange: onStudentResponsesChange,
          falseLabel: "N'afficher que les r\xE9ponses",
          trueLabel: "N'afficher que les r\xE9ponses"
        }
      ),
      /* @__PURE__ */ jsx28("div", { className: src_internals_components_copies_breadcrumb_default.menuContainer, children: /* @__PURE__ */ jsx28(MenuButton2, { position: "left", listItems, accent: "main" }) })
    ] })
  ] });
};
var breadcrumb_default = CopyBreadcrumb;

// src/internals/components/workplan/breadcrumb.jsx
import _32 from "lodash/fp.js";
import { useMemo as useMemo4 } from "react";
import { Button as Button14, Icon as Icon5, SelectField as SelectField4 } from "@lls/lls-kit";
import { cx as cx10, makeComponent as makeComponent4 } from "@lls/utils";

// src/internals/utils/workplan.ts
import { pipe } from "@lls/utils";
import _31 from "lodash/fp.js";
var taskTitleRegex = () => /.*<wptask(?:.*?)>(.*?)<\/wptask>.*/gisu;
var getTitleTask = ({ taskId, page }) => {
  return _31.flow(
    _31.get("children"),
    _31.find({ uuid: taskId }),
    _31.getOr("objectif", "contentMd"),
    _31.replace(taskTitleRegex(), "$1"),
    _31.flow(_31.split(":"), ([first, ...rest]) => {
      return _31.isEmpty(rest) ? [first] : [_31.join(":", rest), first];
    })
  )(page);
};
var getLayoutItem = (layoutItem) => {
  const content = _31.filter({ type: "wpcard" }, layoutItem == null ? void 0 : layoutItem.content);
  if (_31.isEmpty(layoutItem == null ? void 0 : layoutItem.content)) return content;
  return _31.flow(
    _31.flatMap(getLayoutItem),
    _31.concat(content)
    // @ts-ignore
  )((layoutItem == null ? void 0 : layoutItem.content) || []);
};
var getWorkplanTasks = (workplanGoal) => {
  const layoutItem = _31.get("layouts.grid-md", workplanGoal);
  const layoutsItems = getLayoutItem(layoutItem);
  const children = _31.get("children", workplanGoal);
  return _31.map((layoutItem2) => {
    var _a;
    const correspondingContentMd = (_a = children == null ? void 0 : children.find((child) => (child == null ? void 0 : child.uuid) === (layoutItem2 == null ? void 0 : layoutItem2.id))) == null ? void 0 : _a.contentMd;
    if (_31.isNil(correspondingContentMd)) return layoutItem2;
    const isOptional = /work="2"/.test(correspondingContentMd);
    const title = _31.flow(
      (contentMd) => contentMd.match(/title="(.*?)"/),
      _31.getOr("", "1")
    )(correspondingContentMd);
    return { ...layoutItem2, title, isOptional };
  }, layoutsItems);
};
var getRelatedWorkplanGoals = (workplanGoals) => {
  const [originalWorkplanGoals, modifiedWorkplanGoals] = _31.partition({ isOriginal: true }, workplanGoals);
  return _31.map(
    (originalWorkplanGoal) => ({
      ...originalWorkplanGoal,
      modifiedWorkplanGoals: _31.filter({ parent: _31.get("id", originalWorkplanGoal) }, modifiedWorkplanGoals)
    }),
    originalWorkplanGoals
  );
};
var extractContent = (regex, contentMd) => {
  var _a;
  const match = contentMd == null ? void 0 : contentMd.match(regex);
  return ((_a = match == null ? void 0 : match[1]) == null ? void 0 : _a.trim()) || null;
};
var areWorkplanTaskContentMdValid = (array) => {
  return array.every((contentMd) => {
    if (!contentMd) return false;
    const title = extractContent(/<wpinfos[^>]*title="([^"]*)"/, contentMd);
    const wpdescription = extractContent(/<wpdescription>([\s\S]*?)<\/wpdescription>/, contentMd);
    const wptask = extractContent(/<wptask>([\s\S]*?)<\/wptask>/, contentMd);
    return Boolean(title && wpdescription && wptask);
  });
};
var areDisabledShareAndSaveButton = (page) => {
  if (!isWorkplanPage(page)) return false;
  const workplanTasks = getWorkplanTasks(page);
  const workplanTasksIds = _31.map("id", workplanTasks);
  const workplanTasksContentMd = pipe(
    page == null ? void 0 : page.children,
    (children) => children == null ? void 0 : children.filter((child) => workplanTasksIds.includes((child == null ? void 0 : child.uuid) ?? "")),
    (filteredChildren) => _31.map("contentMd", filteredChildren)
  );
  const areContentMdValid = areWorkplanTaskContentMdValid(workplanTasksContentMd);
  const areResources = workplanTasks.every(
    (wptask) => {
      var _a;
      return wptask.content.length > 0 && ((_a = wptask.content) == null ? void 0 : _a.some((content) => content.type === "cell"));
    }
  );
  return !areContentMdValid || !areResources;
};

// tmp_esbuild1736180050074/_src_internals_components_workplan_breadcrumb.module.css
var src_internals_components_workplan_breadcrumb_default = { "secondaryTitle": "sk-U8aBpa-secondaryTitle", "title": "sk-U8aBpa-title", "mainLinkTitle": "sk-U8aBpa-mainLinkTitle", "container": "sk-U8aBpa-container", "selectedField": "sk-U8aBpa-selectedField", "icon": "sk-U8aBpa-icon", "card": "sk-U8aBpa-card", "workplanBreadcrumbTitle": "sk-U8aBpa-workplanBreadcrumbTitle", "mainTitle": "sk-U8aBpa-mainTitle" };

// src/internals/components/workplan/breadcrumb.jsx
import { Fragment as Fragment12, jsx as jsx29, jsxs as jsxs20 } from "react/jsx-runtime";
var Title2 = ({ isStudentTask, onClick = _32.noop }) => isStudentTask && /* @__PURE__ */ jsx29("span", { className: src_internals_components_workplan_breadcrumb_default.secondaryTitle, onClick, children: "Suivi des \xE9l\xE8ves" });
var SecondaryTitle = ({ page, onClick = _32.noop }) => /* @__PURE__ */ jsx29("span", { className: src_internals_components_workplan_breadcrumb_default.secondaryTitle, onClick: () => onClick(page), children: page == null ? void 0 : page.displayTitle });
var ChevronIcon = () => /* @__PURE__ */ jsx29(Icon5, { className: src_internals_components_workplan_breadcrumb_default.icon, name: "chevronright" });
var StyledTitle2 = makeComponent4("h1", src_internals_components_workplan_breadcrumb_default.title);
var StyledWorkplanBreadcrumbTitle = makeComponent4(StyledTitle2, src_internals_components_workplan_breadcrumb_default.workplanBreadcrumbTitle);
var WorkplansBreadcrumb = ({
  className,
  currentUser,
  onGoBack,
  onPageClick,
  page,
  taskId,
  isStudentTask = false,
  students,
  onChangeStudent,
  selectedStudent
}) => {
  const [link, subpart = ""] = getTitleTask({ taskId, page });
  const studentsOptions = useMemo4(
    () => _32.flow(
      _32.sortBy(getStudentFullName),
      _32.map((student) => ({ ...student, value: _32.get("id", student), label: getStudentFullName(student) }))
    )(students),
    [students]
  );
  const selectedStudentOption = _32.find({ id: _32.get("id", selectedStudent) }, studentsOptions);
  return /* @__PURE__ */ jsx29(Fragment12, { children: /* @__PURE__ */ jsx29("div", { className: cx10(className, src_internals_components_workplan_breadcrumb_default.card), children: /* @__PURE__ */ jsxs20("div", { className: src_internals_components_workplan_breadcrumb_default.container, children: [
    /* @__PURE__ */ jsx29(Button14, { onClick: onGoBack, icon: "arrowleft", theme: "gray", inverted: true }),
    /* @__PURE__ */ jsx29(Title2, { page, isStudentTask, onClick: onGoBack }),
    /* @__PURE__ */ jsx29(ChevronIcon, {}),
    /* @__PURE__ */ jsx29(SecondaryTitle, { page, onClick: onPageClick }),
    /* @__PURE__ */ jsx29(ChevronIcon, {}),
    /* @__PURE__ */ jsxs20(StyledTitle2, { className: src_internals_components_workplan_breadcrumb_default.workplanBreadcrumbTitle, children: [
      subpart && /* @__PURE__ */ jsx29("span", { className: src_internals_components_workplan_breadcrumb_default.mainTitle, dangerouslySetInnerHTML: { __html: `${subpart} : ` } }),
      /* @__PURE__ */ jsx29("a", { className: src_internals_components_workplan_breadcrumb_default.mainLinkTitle, dangerouslySetInnerHTML: { __html: link } })
    ] }),
    !_32.get("isStudent", currentUser) && isStudentTask && /* @__PURE__ */ jsx29(
      SelectField4,
      {
        className: src_internals_components_workplan_breadcrumb_default.selectedField,
        options: studentsOptions,
        listMaxHeight: "300px",
        value: _32.get("value", selectedStudentOption),
        onChange: onChangeStudent
      }
    )
  ] }) }) });
};
var breadcrumb_default2 = WorkplansBreadcrumb;

// src/internals/components/workplan/studentTracking.jsx
import { useEffect as useEffect8, useMemo as useMemo7, useState as useState16 } from "react";
import {
  CircularProgressBar as CircularProgressBar2,
  Table,
  TableBody,
  TableContainer,
  TableHeader,
  TableHeaderCell as TableHeaderCell2,
  TableRow as TableRow3
} from "@lls/lls-kit";
import _38 from "lodash/fp.js";

// src/internals/components/workplan/emptyState.jsx
import { TableCell, TableRow } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_workplan_emptyState.module.css
var src_internals_components_workplan_emptyState_default = { "tableRow": "sk-m2Zpza-tableRow" };

// src/internals/components/workplan/emptyState.jsx
import { jsx as jsx30 } from "react/jsx-runtime";
var EmptyState = ({ colSpan }) => {
  return /* @__PURE__ */ jsx30(TableRow, { className: src_internals_components_workplan_emptyState_default.tableRow, children: /* @__PURE__ */ jsx30(TableCell, { colSpan, children: "Le travail de vos \xE9l\xE8ves appara\xEEtra ici." }) });
};
var emptyState_default = EmptyState;

// src/internals/components/workplan/pagination.jsx
import { Button as Button15, SelectField as SelectField5 } from "@lls/lls-kit";
import _33 from "lodash/fp.js";
import { useState as useState13 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_workplan_pagination.module.css
var src_internals_components_workplan_pagination_default = { "paginationContainer": "sk-C9ki4G-paginationContainer", "text": "sk-C9ki4G-text", "paginationFooter": "sk-C9ki4G-paginationFooter" };

// src/internals/components/workplan/pagination.jsx
import { jsx as jsx31, jsxs as jsxs21 } from "react/jsx-runtime";
var Pagination = ({ totalCount, setPageSize, onNext, onPrevious, firstPageNum, lastPageNum, hasNext, hasPrev }) => {
  const options = [
    { id: 1, value: 1, label: "35" },
    { id: 2, value: 2, label: "70" },
    { id: 3, value: 3, label: "100" }
  ];
  const [selectedStudentsPerPage, setSelectedStudentsPerPage] = useState13(options[0]);
  const handleChangeStudentsPerPage = (id) => {
    const currentOption = _33.find({ id }, options);
    setSelectedStudentsPerPage(currentOption);
    setPageSize(_33.parseInt(10, _33.get("label", currentOption)));
  };
  return /* @__PURE__ */ jsxs21("div", { className: src_internals_components_workplan_pagination_default.paginationContainer, children: [
    /* @__PURE__ */ jsx31("span", { className: src_internals_components_workplan_pagination_default.text, children: "R\xE9sultats par page:" }),
    /* @__PURE__ */ jsx31(
      SelectField5,
      {
        width: "90px",
        options,
        value: _33.get("value", selectedStudentsPerPage),
        onChange: handleChangeStudentsPerPage
      }
    ),
    /* @__PURE__ */ jsxs21("div", { className: src_internals_components_workplan_pagination_default.paginationFooter, children: [
      firstPageNum,
      " - ",
      lastPageNum,
      " sur ",
      totalCount
    ] }),
    /* @__PURE__ */ jsx31(Button15, { disabled: !hasPrev, onClick: onPrevious, icon: "chevronleft", accent: "floating" }),
    /* @__PURE__ */ jsx31(Button15, { disabled: !hasNext, onClick: onNext, icon: "chevronright", accent: "floating" })
  ] });
};
var pagination_default = Pagination;

// src/internals/components/workplan/studentTrackingHeader.jsx
import _34 from "lodash/fp.js";
import { useCallback as useCallback17, useMemo as useMemo5 } from "react";
import { Button as Button16, Icon as Icon6, SelectField as SelectField6 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_workplan_studentTrackingHeader.module.css
var src_internals_components_workplan_studentTrackingHeader_default = { "selectedField": "sk-Vdvq0a-selectedField", "block": "sk-Vdvq0a-block", "noGroups": "sk-Vdvq0a-noGroups", "header": "sk-Vdvq0a-header", "icon": "sk-Vdvq0a-icon" };

// src/internals/components/workplan/studentTrackingHeader.jsx
import { jsx as jsx32, jsxs as jsxs22 } from "react/jsx-runtime";
var NoGroups = ({ onManageGroupClick }) => {
  return /* @__PURE__ */ jsxs22("div", { className: src_internals_components_workplan_studentTrackingHeader_default.noGroups, children: [
    /* @__PURE__ */ jsx32("span", { children: "Vous n'avez pas d\xE9fini" }),
    /* @__PURE__ */ jsx32("span", { children: "de classe" }),
    /* @__PURE__ */ jsx32(Button16, { icon: "plus", onClick: onManageGroupClick, children: "G\xE9rer les classes" })
  ] });
};
var DEFAULT_GROUP_OPTION_ID = "allStudents";
var DEFAULT_GROUP_OPTION = { id: DEFAULT_GROUP_OPTION_ID, value: DEFAULT_GROUP_OPTION_ID, label: "Tous les \xE9l\xE8ves" };
var transformGroupsToSelectGroups = _34.flow(
  _34.map((group) => ({ ...group, value: _34.get("id", group), label: _34.get("name", group) })),
  _34.concat(DEFAULT_GROUP_OPTION)
);
var Header = ({
  currentUser,
  workplansOptions,
  selectedWorkplanOptions,
  onChangeWorkplan,
  groups,
  onManageGroupClick,
  handleChangeGroup,
  selectedGroup
}) => {
  const isStudent2 = _34.get("isStudent", currentUser);
  const noGroupsOptions = useMemo5(
    () => [
      {
        id: "noGroups",
        value: "noGroups",
        label: /* @__PURE__ */ jsx32(NoGroups, { onManageGroupClick })
      }
    ],
    [onManageGroupClick]
  );
  const groupsOptions = useMemo5(() => transformGroupsToSelectGroups(groups), [groups]);
  const onChangeGroup = useCallback17(
    (id) => {
      if (id === "noGroups") return;
      const groupOptions = _34.find({ id }, groupsOptions);
      handleChangeGroup(groupOptions);
    },
    [groupsOptions, handleChangeGroup]
  );
  return /* @__PURE__ */ jsxs22("div", { className: src_internals_components_workplan_studentTrackingHeader_default.header, children: [
    /* @__PURE__ */ jsxs22("div", { className: src_internals_components_workplan_studentTrackingHeader_default.block, children: [
      /* @__PURE__ */ jsx32(Icon6, { className: src_internals_components_workplan_studentTrackingHeader_default.icon, name: "filter" }),
      " Plan de travail :",
      /* @__PURE__ */ jsx32(
        SelectField6,
        {
          className: src_internals_components_workplan_studentTrackingHeader_default.selectedField,
          options: workplansOptions,
          value: _34.get("value", selectedWorkplanOptions),
          onChange: onChangeWorkplan
        }
      )
    ] }),
    !isStudent2 && /* @__PURE__ */ jsxs22("div", { className: src_internals_components_workplan_studentTrackingHeader_default.block, children: [
      /* @__PURE__ */ jsx32(Icon6, { className: src_internals_components_workplan_studentTrackingHeader_default.icon, name: "groupfilled" }),
      "Classe :",
      /* @__PURE__ */ jsx32(
        SelectField6,
        {
          className: src_internals_components_workplan_studentTrackingHeader_default.selectedField,
          options: _34.isEmpty(groups) ? noGroupsOptions : groupsOptions,
          label: "S\xE9lectionnez une classe",
          value: _34.getOr(DEFAULT_GROUP_OPTION_ID, "id", selectedGroup),
          onChange: onChangeGroup
        }
      )
    ] })
  ] });
};
var studentTrackingHeader_default = Header;

// src/internals/components/workplan/studentTrackingTableHeaderLine.jsx
import { useCallback as useCallback19, useMemo as useMemo6, useState as useState14 } from "react";
import { Icon as Icon8, MenuButton as MenuButton3, Stamp as Stamp2, TableHeaderCell, Tooltip as Tooltip3 } from "@lls/lls-kit";

// src/internals/components/workplan/studentTrackingTableLine.jsx
import _35 from "lodash/fp.js";
import { useCallback as useCallback18 } from "react";
import { Icon as Icon7, TableCell as TableCell2, TableRow as TableRow2 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_workplan_studentTrackingTableLine.module.css
var src_internals_components_workplan_studentTrackingTableLine_default = { "workplanTask": "sk-LvzssG-workplanTask", "icon": "sk-LvzssG-icon", "isDoneSubContent": "sk-LvzssG-isDoneSubContent", "tableCell": "sk-LvzssG-tableCell", "containerWorkplanTasks": "sk-LvzssG-containerWorkplanTasks", "tableRow": "sk-LvzssG-tableRow", "isDoneContent": "sk-LvzssG-isDoneContent" };

// src/internals/components/workplan/studentTrackingTableLine.jsx
import { jsx as jsx33, jsxs as jsxs23 } from "react/jsx-runtime";
var WORKPLANTASK_WIDTH = 32;
var WORKPLANTASK_MARGIN = 8;
var Z_INDEX_TABLE_LINE = 1;
var IsDone = () => {
  return /* @__PURE__ */ jsx33("div", { className: src_internals_components_workplan_studentTrackingTableLine_default.isDoneContent, children: /* @__PURE__ */ jsx33("div", { className: src_internals_components_workplan_studentTrackingTableLine_default.isDoneSubContent, children: /* @__PURE__ */ jsx33(Icon7, { className: src_internals_components_workplan_studentTrackingTableLine_default.icon, name: "checkmark", width: 10, color: "var(--primary-40-color)" }) }) });
};
var StudentTrackingTableLine = ({ student, workplanGoals, stats, onClickStudentTask }) => {
  const onClickTask = useCallback18(
    ({ taskId, pageSlug, studentId }) => {
      onClickStudentTask({
        taskId,
        pageSlug,
        studentId
      });
    },
    [onClickStudentTask]
  );
  return /* @__PURE__ */ jsxs23(TableRow2, { className: src_internals_components_workplan_studentTrackingTableLine_default.tableRow, children: [
    /* @__PURE__ */ jsxs23(TableCell2, { children: [
      student.firstname,
      " ",
      student.lastname
    ] }),
    _35.map((workplanGoal) => {
      const workplanTasks = _35.get("tasks", workplanGoal);
      return /* @__PURE__ */ jsx33(
        TableCell2,
        {
          className: src_internals_components_workplan_studentTrackingTableLine_default.tableCell,
          style: {
            "--s-workplantask-width": `${WORKPLANTASK_WIDTH}px`,
            "--s-workplantask-margin": `${WORKPLANTASK_MARGIN}px`
          },
          children: /* @__PURE__ */ jsx33("div", { className: src_internals_components_workplan_studentTrackingTableLine_default.containerWorkplanTasks, children: _35.map((workplanTask) => {
            const isTaskDone = _35.flow(
              _35.filter({ uuid: _35.get("uuid", workplanTask), isTask: true }),
              _35.orderBy(["beginningDate"], ["desc"]),
              _35.get("0.responses.0")
            )(stats);
            const pageSlug = _35.get("slug", workplanTask);
            const studentId = _35.get("id", student);
            const taskId = _35.get("uuid", workplanTask);
            return /* @__PURE__ */ jsx33(
              "div",
              {
                onClick: () => isTaskDone ? onClickTask({ pageSlug, studentId, taskId }) : _35.noop,
                children: isTaskDone ? /* @__PURE__ */ jsx33(IsDone, {}) : /* @__PURE__ */ jsx33("div", { className: src_internals_components_workplan_studentTrackingTableLine_default.workplanTask })
              },
              workplanTask.id
            );
          }, workplanTasks) })
        },
        workplanGoal.id
      );
    }, workplanGoals)
  ] });
};
var studentTrackingTableLine_default = StudentTrackingTableLine;

// src/internals/components/workplan/studentTrackingTableHeaderLine.jsx
import _36 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_workplan_studentTrackingTableHeaderLine.module.css
var src_internals_components_workplan_studentTrackingTableHeaderLine_default = { "icon": "sk-wQftVW-icon", "div": "sk-wQftVW-div", "option": "sk-wQftVW-option", "stamp": "sk-wQftVW-stamp", "tableHeaderContainer": "sk-wQftVW-tableHeaderContainer", "text": "sk-wQftVW-text", "tableHeaderCell": "sk-wQftVW-tableHeaderCell", "workplanTask": "sk-wQftVW-workplanTask", "menuButton": "sk-wQftVW-menuButton", "titleContent": "sk-wQftVW-titleContent", "subHeader": "sk-wQftVW-subHeader" };

// src/internals/components/workplan/studentTrackingTableHeaderLine.jsx
import { jsx as jsx34, jsxs as jsxs24 } from "react/jsx-runtime";
var map = _36.map.convert({ cap: false });
var OptionContent = ({ onClick, workplanGoal, titleMaxWidth, selectedWorkplanGoal }) => {
  const isSelected = _36.isEqual(_36.get("id", selectedWorkplanGoal), _36.get("id", workplanGoal));
  const textColor = isSelected ? "var(--primary-40-color)" : "var(--text-main-color)";
  const isOriginal = _36.get("isOriginal", workplanGoal);
  return /* @__PURE__ */ jsxs24("div", { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.option, onClick, children: [
    isSelected && /* @__PURE__ */ jsx34(Icon8, { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.icon, name: "checkmark", color: "var(--primary-40-color)", width: 16, height: 16 }),
    isOriginal && /* @__PURE__ */ jsx34(
      Stamp2,
      {
        className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.stamp,
        theme: "light-blue",
        isselected: +isSelected,
        size: "small",
        "data-isselected": +!!+isSelected,
        children: "Original"
      }
    ),
    /* @__PURE__ */ jsx34(
      "div",
      {
        className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.text,
        style: { "--s-color": textColor, "--s-titlemaxwidth": `${titleMaxWidth}px` },
        "data-isoriginal": +!!isOriginal,
        children: _36.get("title", workplanGoal)
      }
    )
  ] });
};
var TitleComponent = ({
  originalWorkplanGoal,
  setSelectedWorkplanGoal,
  selectedWorkplanGoal,
  titleMaxWidth,
  currentWorkplanGoals,
  setCurrentWorkplanGoals
}) => {
  const handleSelectWorkplanGoal = useCallback19(
    (selectedGoal) => {
      const newWorkplanGoals = _36.map((currentWorkplanGoal) => {
        const found = selectedGoal.isOriginal ? selectedGoal.id === currentWorkplanGoal.parent : selectedGoal.parent === currentWorkplanGoal.id;
        return found ? selectedGoal : currentWorkplanGoal;
      }, currentWorkplanGoals);
      setSelectedWorkplanGoal(selectedGoal);
      setCurrentWorkplanGoals(newWorkplanGoals);
    },
    [currentWorkplanGoals, setCurrentWorkplanGoals, setSelectedWorkplanGoal]
  );
  const options = useMemo6(() => {
    return _36.flow(
      _36.get("modifiedWorkplanGoals"),
      _36.concat(originalWorkplanGoal),
      _36.map((workplanGoal) => ({
        type: "component",
        content: /* @__PURE__ */ jsx34(
          OptionContent,
          {
            onClick: () => handleSelectWorkplanGoal(workplanGoal),
            workplanGoal,
            titleMaxWidth,
            selectedWorkplanGoal
          }
        )
      }))
    )(originalWorkplanGoal);
  }, [originalWorkplanGoal, handleSelectWorkplanGoal, selectedWorkplanGoal, titleMaxWidth]);
  const title = _36.get("title", selectedWorkplanGoal);
  return /* @__PURE__ */ jsx34("div", { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.titleContent, children: _36.size(options) > 1 ? /* @__PURE__ */ jsx34(
    MenuButton3,
    {
      className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.menuButton,
      alignment: "end",
      theme: "gray",
      accent: "floating",
      icon: "carretdown",
      iconPosition: "right",
      position: "bottom",
      fixed: true,
      listItems: options,
      children: /* @__PURE__ */ jsx34("div", { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.div, style: { "--s-titlemaxwidth": `${titleMaxWidth}px` }, children: title })
    }
  ) : /* @__PURE__ */ jsx34("div", { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.div, style: { "--s-titlemaxwidth": `${titleMaxWidth}px` }, children: title }) });
};
var TableHeaderLine = ({ workplanGoal, currentWorkplanGoals, setCurrentWorkplanGoals }) => {
  const [selectedWorkplanGoal, setSelectedWorkplanGoal] = useState14(workplanGoal);
  const workplanTasks = _36.get("tasks", selectedWorkplanGoal);
  const titleMaxWidth = _36.size(workplanTasks) * (WORKPLANTASK_WIDTH + WORKPLANTASK_MARGIN);
  return /* @__PURE__ */ jsx34(TableHeaderCell, { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.tableHeaderCell, children: /* @__PURE__ */ jsxs24("div", { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.tableHeaderContainer, children: [
    /* @__PURE__ */ jsx34(
      TitleComponent,
      {
        currentWorkplanGoals,
        titleMaxWidth,
        setCurrentWorkplanGoals,
        originalWorkplanGoal: workplanGoal,
        selectedWorkplanGoal,
        setSelectedWorkplanGoal
      }
    ),
    /* @__PURE__ */ jsx34("div", { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.subHeader, children: map((workplanTask, index) => {
      const isOptional = _36.get("isOptional", workplanTask);
      const title = _36.get("title", workplanTask);
      return /* @__PURE__ */ jsx34(Tooltip3, { content: title, disabled: _36.isEmpty(title), children: /* @__PURE__ */ jsx34("div", { className: src_internals_components_workplan_studentTrackingTableHeaderLine_default.workplanTask, children: isOptional ? `( ${index + 1} )*` : index + 1 }) }, index);
    }, workplanTasks) })
  ] }) });
};
var studentTrackingTableHeaderLine_default = TableHeaderLine;

// src/internals/hooks/usePagination.ts
import _37 from "lodash/fp.js";
import { useCallback as useCallback20, useEffect as useEffect7, useState as useState15 } from "react";
var usePagination = ({
  pageSize,
  totalCount
}) => {
  const [currentPage, setCurrentPage] = useState15(0);
  const totalPageCount = Math.ceil(totalCount / pageSize);
  const [currentRange, setCurrentRange] = useState15(0);
  const onNext = useCallback20(() => {
    setCurrentRange((currentPage + 1) * pageSize + 1);
  }, [pageSize, currentPage]);
  const onPrevious = useCallback20(() => {
    setCurrentRange((currentPage - 1) * pageSize + 1);
  }, [pageSize, currentPage]);
  useEffect7(() => {
    const nextPage = Math.round(currentRange / pageSize);
    if (totalPageCount === 1) {
      setCurrentPage(0);
    } else {
      setCurrentPage(nextPage === totalPageCount ? nextPage - 1 : nextPage);
    }
  }, [pageSize, currentRange, totalPageCount]);
  const firstPageNum = _37.clamp(1, currentPage * pageSize + 1, totalCount);
  const lastPageNum = _37.clamp(1, (currentPage + 1) * pageSize, totalCount);
  const hasNext = lastPageNum < totalCount;
  const hasPrev = currentPage > 0;
  return {
    onNext,
    onPrevious,
    currentPage,
    totalPageCount,
    firstPageNum,
    lastPageNum,
    totalCount,
    hasNext,
    hasPrev
  };
};
var usePagination_default = usePagination;

// tmp_esbuild1736180050074/_src_internals_components_workplan_studentTracking.module.css
var src_internals_components_workplan_studentTracking_default = { "leftTableHeaderCellSpan": "sk-fdIuvW-leftTableHeaderCellSpan", "leftTableHeaderCell": "sk-fdIuvW-leftTableHeaderCell", "tableContainer": "sk-fdIuvW-tableContainer", "container": "sk-fdIuvW-container", "statsLoader": "sk-fdIuvW-statsLoader", "footer": "sk-fdIuvW-footer" };

// src/internals/components/workplan/studentTracking.jsx
import { jsx as jsx35, jsxs as jsxs25 } from "react/jsx-runtime";
var DEFAULT_STUDENTS_PER_PAGE = 35;
var StatsLoader = () => {
  return /* @__PURE__ */ jsx35("div", { className: src_internals_components_workplan_studentTracking_default.statsLoader, style: { "--s-z-index-table-line": Z_INDEX_TABLE_LINE }, children: /* @__PURE__ */ jsx35(CircularProgressBar2, { strokeRatio: 0.2 }) });
};
var StudentTrackingTable = ({
  currentUser,
  onChangeWorkplan = _38.noop,
  groups,
  selectedWorkplanOptions,
  workplanGoals,
  workplansOptions,
  selectedStudents,
  statsByStudentIds,
  setDisplayedStudentIds = _38.noop,
  onManageGroupClick = _38.noop,
  onClickStudentTask = _38.noop,
  handleChangeGroup = _38.noop,
  isLoadingStats,
  selectedGroup
}) => {
  const [studentsPerPage, setStudentsPerPage] = useState16(DEFAULT_STUDENTS_PER_PAGE);
  const { onNext, onPrevious, currentPage, totalPageCount, firstPageNum, lastPageNum, hasNext, hasPrev } = usePagination_default({
    pageSize: studentsPerPage,
    totalCount: _38.size(selectedStudents)
  });
  const currentStudentsData = useMemo7(() => {
    const firstPageIndex = currentPage * studentsPerPage;
    const lastPageIndex = firstPageIndex + studentsPerPage;
    return _38.flow(_38.sortBy(getStudentFullName), _38.slice(firstPageIndex, lastPageIndex))(selectedStudents);
  }, [currentPage, selectedStudents, studentsPerPage]);
  useEffect8(() => {
    !_38.isEmpty(currentStudentsData) && setDisplayedStudentIds(_38.map("id", currentStudentsData));
  }, [setDisplayedStudentIds, currentStudentsData]);
  const isStudent2 = _38.get("isStudent", currentUser);
  const relatedWorkplanGoals = useMemo7(() => getRelatedWorkplanGoals(workplanGoals), [workplanGoals]);
  const [currentWorkplanGoals, setCurrentWorkplanGoals] = useState16([]);
  useEffect8(() => {
    setCurrentWorkplanGoals(relatedWorkplanGoals);
  }, [relatedWorkplanGoals]);
  return /* @__PURE__ */ jsxs25("div", { className: src_internals_components_workplan_studentTracking_default.container, children: [
    isLoadingStats && /* @__PURE__ */ jsx35(StatsLoader, {}),
    /* @__PURE__ */ jsx35(
      studentTrackingHeader_default,
      {
        currentUser,
        workplansOptions,
        selectedWorkplanOptions,
        onChangeWorkplan,
        groups,
        onManageGroupClick,
        handleChangeGroup,
        selectedGroup
      }
    ),
    /* @__PURE__ */ jsx35(TableContainer, { className: src_internals_components_workplan_studentTracking_default.tableContainer, overflow: true, children: /* @__PURE__ */ jsxs25(Table, { children: [
      /* @__PURE__ */ jsx35(TableHeader, { children: /* @__PURE__ */ jsxs25(TableRow3, { children: [
        /* @__PURE__ */ jsxs25(
          TableHeaderCell2,
          {
            className: src_internals_components_workplan_studentTracking_default.leftTableHeaderCell,
            style: { "--s-z-index-table-line": Z_INDEX_TABLE_LINE },
            children: [
              /* @__PURE__ */ jsx35("span", { className: src_internals_components_workplan_studentTracking_default.leftTableHeaderCellSpan, children: "Objectif" }),
              /* @__PURE__ */ jsx35("br", {}),
              /* @__PURE__ */ jsx35("span", { className: src_internals_components_workplan_studentTracking_default.leftTableHeaderCellSpan, children: "Travail \xE0 r\xE9aliser" })
            ]
          }
        ),
        _38.map((workplanGoal) => {
          return /* @__PURE__ */ jsx35(
            studentTrackingTableHeaderLine_default,
            {
              currentWorkplanGoals,
              workplanGoals,
              workplanGoal,
              setCurrentWorkplanGoals
            },
            workplanGoal.id
          );
        }, relatedWorkplanGoals)
      ] }) }),
      /* @__PURE__ */ jsx35(TableBody, { children: _38.isEmpty(currentStudentsData) ? /* @__PURE__ */ jsx35(emptyState_default, { colSpan: _38.size(currentWorkplanGoals) + 1 }) : _38.map(
        (student) => /* @__PURE__ */ jsx35(
          studentTrackingTableLine_default,
          {
            onClickStudentTask,
            stats: _38.get(student.id, statsByStudentIds),
            student,
            workplanGoals: currentWorkplanGoals
          },
          student.id
        ),
        currentStudentsData
      ) })
    ] }) }),
    isStudent2 && /* @__PURE__ */ jsx35(
      pagination_default,
      {
        totalCount: _38.size(selectedStudents),
        pageSize: studentsPerPage,
        setPageSize: setStudentsPerPage,
        onNext,
        onPrevious,
        totalPageCount,
        firstPageNum,
        lastPageNum,
        hasNext,
        hasPrev
      }
    ),
    /* @__PURE__ */ jsx35("div", { className: src_internals_components_workplan_studentTracking_default.footer, children: "* : les t\xE2ches entre parenth\xE8ses sont facultatives." })
  ] });
};
var studentTracking_default = StudentTrackingTable;

// src/internals/components/copies/copiesTable.jsx
import { useMemo as useMemo8, useState as useState17 } from "react";
import {
  ChipSelect,
  Table as Table2,
  TableBody as TableBody2,
  TableCell as TableCell4,
  TableContainer as TableContainer2,
  TableHeader as TableHeader2,
  TableHeaderCell as TableHeaderCell4,
  TableRow as TableRow5,
  Z_SELECT_CHIP_ALTERNATIVE
} from "@lls/lls-kit";

// src/internals/utils/copies.tsx
var getEmptyMessage = ({
  orderedSharedPages,
  selectedGroup,
  selectedStatus
}) => {
  if (!orderedSharedPages || orderedSharedPages.length === 0 && !selectedGroup && !selectedStatus) {
    return "Vous n'avez pas encore re\xE7u de r\xE9ponses sur cette page.";
  }
  if (orderedSharedPages.length === 0 && selectedGroup && !selectedStatus) {
    return "Vous n'avez pas re\xE7u de r\xE9ponses de la part de ce groupe.";
  }
  if (orderedSharedPages.length === 0 && selectedGroup && selectedStatus === READ_STATUSES.READ) {
    return "Vous n'avez pas de r\xE9ponses lues dans ce groupe.";
  }
  if (orderedSharedPages.length === 0 && selectedGroup && selectedStatus === READ_STATUSES.UNREAD) {
    return "Vous n'avez pas de r\xE9ponses non lues dans ce groupe.";
  }
  if (orderedSharedPages.length === 0 && selectedStatus === READ_STATUSES.READ && !selectedGroup) {
    return "Vous n'avez pas de r\xE9ponses lues.";
  }
  if (orderedSharedPages.length === 0 && selectedStatus === READ_STATUSES.UNREAD && !selectedGroup) {
    return "Vous n'avez pas de r\xE9ponses non lues.";
  }
  return null;
};

// src/internals/components/copies/copiesTable.jsx
import _41 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_copies_copiesTable.module.css
var src_internals_components_copies_copiesTable_default = { "table": "sk-EbLGBG-table", "filterTableRow": "sk-EbLGBG-filterTableRow", "tableHeaderCell": "sk-EbLGBG-tableHeaderCell", "styleTableContainer": "sk-EbLGBG-styleTableContainer", "filterCell": "sk-EbLGBG-filterCell", "emptyDataTableRow": "sk-EbLGBG-emptyDataTableRow" };

// src/internals/components/copies/copyTableLine.jsx
import { useCallback as useCallback21 } from "react";
import { Button as Button17, Icon as Icon9, MenuButton as MenuButton4, TableCell as TableCell3, TableRow as TableRow4, Tooltip as Tooltip4 } from "@lls/lls-kit";
import dayjs2 from "dayjs";
import _39 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_copies_copyTableLine.module.css
var src_internals_components_copies_copyTableLine_default = { "hours": "sk-uFrAsa-hours", "tableRow": "sk-uFrAsa-tableRow", "button": "sk-uFrAsa-button", "icon": "sk-uFrAsa-icon" };

// src/internals/components/copies/copyTableLine.jsx
import { Fragment as Fragment13, jsx as jsx36, jsxs as jsxs26 } from "react/jsx-runtime";
var CopyLine = ({ page, read, onCopyClick, markAsNotRead }) => {
  const onCopyClickCb = useCallback21(() => onCopyClick(page), [onCopyClick, page]);
  const actions = [
    {
      msg: 'Marquer comme "Non lu"',
      onClick: () => markAsNotRead(page.id)
    }
  ];
  const isShared = _39.getOr(true, "isShared", page);
  const isSharedPageNotRead = !read && isShared;
  return /* @__PURE__ */ jsxs26(
    TableRow4,
    {
      className: src_internals_components_copies_copyTableLine_default.tableRow,
      onClick: onCopyClickCb,
      "data-shared": +isShared,
      "data-shared-page-not-read": +isSharedPageNotRead,
      children: [
        /* @__PURE__ */ jsx36(TableCell3, { "data-clarity-mask": "true", children: _39.get("studentFullName", page) }),
        /* @__PURE__ */ jsx36(TableCell3, { children: page.updatedAt ? /* @__PURE__ */ jsxs26(Fragment13, { children: [
          dayjs2(page.updatedAt).format("DD[/]MM[/]YY"),
          /* @__PURE__ */ jsx36("span", { className: src_internals_components_copies_copyTableLine_default.hours, children: dayjs2(page.updatedAt).format(" \xE0 HH:mm ") })
        ] }) : /* @__PURE__ */ jsx36("em", { children: "Non rendu" }) }),
        /* @__PURE__ */ jsx36(TableCell3, { children: page.sharedAt ? dayjs2(page.sharedAt).format("DD[/]MM[/]YY") : "/" }),
        /* @__PURE__ */ jsx36(TableCell3, { children: !_39.isEmpty(page.appreciations) ? /* @__PURE__ */ jsx36(Tooltip4, { content: "appr\xE9ciation envoy\xE9e", placement: "top", children: /* @__PURE__ */ jsx36(Icon9, { className: src_internals_components_copies_copyTableLine_default.icon, width: "24", height: "30", name: "appreciation" }) }) : null }),
        /* @__PURE__ */ jsx36(TableCell3, { children: read ? /* @__PURE__ */ jsx36(MenuButton4, { size: "small", listItems: actions, onClick: (e) => e.stopPropagation() }) : /* @__PURE__ */ jsx36(Button17, { className: src_internals_components_copies_copyTableLine_default.button, size: "small", icon: "horizontaldots", theme: "gray", accent: "floating" }) })
      ]
    }
  );
};
var copyTableLine_default = CopyLine;

// src/internals/components/copies/sortButton.jsx
import { useCallback as useCallback22 } from "react";
import { Button as Button18, TableHeaderCell as TableHeaderCell3 } from "@lls/lls-kit";
import _40 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_copies_sortButton.module.css
var src_internals_components_copies_sortButton_default = { "tableHeaderCell": "sk-cxLehq-tableHeaderCell" };

// src/internals/components/copies/sortButton.jsx
import { jsx as jsx37, jsxs as jsxs27 } from "react/jsx-runtime";
var sortToNextState = {
  "": { nextLabel: "Tri croissant", nextSort: "asc" },
  asc: { nextLabel: "Tri d\xE9croissant", nextSort: "desc" },
  desc: { nextLabel: "Tri croissant", nextSort: "asc" }
};
var SortableButton = ({ name, sort: iSort, onSort, text }) => {
  const sortOrder = _40.matches({ name }, iSort) ? _40.getOr("desc", "order", iSort) : "";
  const handleClick = useCallback22(() => {
    _40.flow(_40.get([sortOrder, "nextSort"]), (order) => onSort({ name, order }))(sortToNextState);
  }, [name, sortOrder, onSort]);
  return /* @__PURE__ */ jsx37(TableHeaderCell3, { className: src_internals_components_copies_sortButton_default.tableHeaderCell, visible: name === _40.get("name", iSort), children: /* @__PURE__ */ jsxs27("div", { className: "sort-button-content", onClick: handleClick, children: [
    text,
    /* @__PURE__ */ jsx37(
      Button18,
      {
        "data-visible": +!!(name === _40.get("name", iSort)),
        className: "sort-button-content-button",
        icon: sortOrder === "desc" ? "arrowup" : "arrowdown",
        size: "small",
        theme: "gray",
        accent: "floating"
      }
    )
  ] }) });
};
var sortButton_default = SortableButton;

// src/internals/components/copies/copiesTable.jsx
import { jsx as jsx38, jsxs as jsxs28 } from "react/jsx-runtime";
var CopiesTable = ({
  sharedPages,
  groups,
  students,
  onCopyClick,
  readPageIds,
  markAsNotRead,
  defaultGroupId,
  onManageGroupClick
}) => {
  const [selectedStatus, setSelectedStatus] = useState17(null);
  const [sort, setSort] = useState17({ name: "", order: "" });
  const expandableGroups = useMemo8(() => {
    const actionButton = {
      type: "button",
      msg: "G\xE9rer les classes",
      onClick: () => onManageGroupClick(),
      theme: "blue",
      accent: "main"
    };
    if (_41.isEmpty(groups)) return [actionButton];
    return _41.flow(
      _41.map((el) => {
        return { ...el, label: el.name };
      }),
      (newGroups) => {
        return [...newGroups, { type: "divider" }, actionButton];
      }
    )(_41.concat(groups, WITHOUT_GROUP));
  }, [groups, onManageGroupClick]);
  const [selectedGroup, setSelectedGroup] = useState17(_41.find({ id: defaultGroupId }, expandableGroups) || null);
  const orderedSharedPages = useMemo8(
    () => getOrderedSharedPages({
      sharedPages,
      selectedGroup,
      selectedStatus,
      groups,
      students,
      readPageIds,
      sort
    }),
    [sharedPages, selectedGroup, selectedStatus, groups, students, readPageIds, sort]
  );
  const emptyMessage = getEmptyMessage({
    orderedSharedPages,
    selectedGroup,
    selectedStatus
  });
  return /* @__PURE__ */ jsx38(TableContainer2, { className: src_internals_components_copies_copiesTable_default.styleTableContainer, overflow: 1, children: /* @__PURE__ */ jsxs28(Table2, { className: src_internals_components_copies_copiesTable_default.table, children: [
    /* @__PURE__ */ jsxs28("colgroup", { children: [
      /* @__PURE__ */ jsx38("col", { width: "50%" }),
      /* @__PURE__ */ jsx38("col", { width: "25%" }),
      /* @__PURE__ */ jsx38("col", { width: "25%" }),
      /* @__PURE__ */ jsx38("col", { width: "80px" }),
      /* @__PURE__ */ jsx38("col", { width: "80px" })
    ] }),
    /* @__PURE__ */ jsxs28(TableHeader2, { children: [
      /* @__PURE__ */ jsxs28(TableRow5, { className: src_internals_components_copies_copiesTable_default.filterTableRow, children: [
        /* @__PURE__ */ jsx38(TableHeaderCell4, { className: src_internals_components_copies_copiesTable_default.tableHeaderCell, children: /* @__PURE__ */ jsxs28("div", { className: src_internals_components_copies_copiesTable_default.filterCell, children: [
          "Filtrer par :",
          /* @__PURE__ */ jsx38(
            ChipSelect,
            {
              label: "Classe",
              "data-clarity-mask": "true",
              options: expandableGroups,
              onChange: setSelectedGroup,
              selectedOption: selectedGroup,
              optionsZIndex: Z_SELECT_CHIP_ALTERNATIVE
            }
          ),
          /* @__PURE__ */ jsx38(
            ChipSelect,
            {
              label: "Statut",
              options: [READ_STATUSES.READ, READ_STATUSES.UNREAD],
              onChange: setSelectedStatus,
              selectedOption: selectedStatus,
              optionsZIndex: Z_SELECT_CHIP_ALTERNATIVE
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx38(TableHeaderCell4, { className: src_internals_components_copies_copiesTable_default.tableHeaderCell, colSpan: 4 })
      ] }),
      /* @__PURE__ */ jsxs28(TableRow5, { children: [
        /* @__PURE__ */ jsx38(sortButton_default, { text: "\xC9l\xE8ves", name: "name", sort, onSort: setSort }),
        /* @__PURE__ */ jsx38(sortButton_default, { text: "Re\xE7u le", name: "receivedAt", sort, onSort: setSort }),
        /* @__PURE__ */ jsx38(sortButton_default, { text: "Correction partag\xE9e\xA0le", name: "sharedAt", sort, onSort: setSort }),
        /* @__PURE__ */ jsx38(TableHeaderCell4, { className: src_internals_components_copies_copiesTable_default.tableHeaderCell, colSpan: 2, children: "Annot\xE9" })
      ] })
    ] }),
    /* @__PURE__ */ jsx38(TableBody2, { children: _41.isNil(emptyMessage) ? _41.map(
      (page) => /* @__PURE__ */ jsx38(
        copyTableLine_default,
        {
          page,
          read: _41.includes(page.id, readPageIds),
          onCopyClick,
          students,
          markAsNotRead
        },
        page.id
      ),
      orderedSharedPages
    ) : /* @__PURE__ */ jsx38(TableRow5, { className: src_internals_components_copies_copiesTable_default.emptyDataTableRow, children: /* @__PURE__ */ jsx38(TableCell4, { colSpan: 5, children: emptyMessage }) }) })
  ] }) });
};
var copiesTable_default = CopiesTable;

// src/internals/components/copyClipBoardButton/index.tsx
import { Button as Button19, Tooltip as Tooltip5 } from "@lls/lls-kit";
import clipboardCopy2 from "clipboard-copy";
import { useCallback as useCallback23, useState as useState18 } from "react";
import { jsx as jsx39 } from "react/jsx-runtime";
var CopyClipBoardButton = ({
  link,
  theme,
  accent,
  size,
  inverted,
  icon,
  iconPosition,
  text = "",
  cb,
  className
}) => {
  const [hasCopied, setHasCopied] = useState18(false);
  const handleClick = useCallback23(() => {
    clipboardCopy2(link);
    setHasCopied(true);
    cb();
  }, [link, cb]);
  return /* @__PURE__ */ jsx39(Tooltip5, { content: hasCopied ? "Lien copi\xE9 !" : "Copier le lien", withTail: true, children: /* @__PURE__ */ jsx39(
    Button19,
    {
      className,
      accent,
      theme,
      inverted,
      iconPosition,
      icon,
      size,
      onClick: handleClick,
      children: text
    }
  ) });
};
var copyClipBoardButton_default = CopyClipBoardButton;

// src/internals/components/subToolbarStatusPage/index.jsx
import { Icon as Icon10, SelectField as SelectField7 } from "@lls/lls-kit";
import { useMemo as useMemo9, useState as useState19 } from "react";
import _42 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_subToolbarStatusPage_index.module.css
var src_internals_components_subToolbarStatusPage_index_default = { "container": "sk-JQilrG-container", "text": "sk-JQilrG-text" };

// src/internals/components/subToolbarStatusPage/index.jsx
import { jsx as jsx40, jsxs as jsxs29 } from "react/jsx-runtime";
var SubToolbarStatusPage = ({ page, onChangePage, pages, teachers }) => {
  const options = useMemo9(() => {
    const originalPageOptionId = (page == null ? void 0 : page.isOriginal) ? page == null ? void 0 : page.id : page == null ? void 0 : page.parent;
    const originalPageOption = {
      id: originalPageOptionId,
      value: originalPageOptionId,
      label: "Plan de travail original"
    };
    const pagesWithTeacherOptions = _42.map(
      (page2) => ({
        id: page2 == null ? void 0 : page2.id,
        value: page2 == null ? void 0 : page2.id,
        label: _42.flow(_42.find({ id: page2 == null ? void 0 : page2.user }), _42.get("name"))(teachers)
      }),
      pages
    );
    return _42.concat(originalPageOption, pagesWithTeacherOptions);
  }, [page, teachers, pages]);
  const [selectedOption, setSelectedOption] = useState19(_42.find({ id: page == null ? void 0 : page.id }, options));
  const handleChange = (pageId) => {
    setSelectedOption(_42.find({ id: pageId }, options));
    onChangePage(pageId);
  };
  return /* @__PURE__ */ jsxs29("div", { className: src_internals_components_subToolbarStatusPage_index_default.container, children: [
    /* @__PURE__ */ jsx40(Icon10, { name: "personfilled" }),
    /* @__PURE__ */ jsxs29("div", { children: [
      /* @__PURE__ */ jsx40("span", { className: src_internals_components_subToolbarStatusPage_index_default.text, children: " Plan de travail de " }),
      _42.size(pages) >= 1 && /* @__PURE__ */ jsx40(SelectField7, { value: _42.get("value", selectedOption), options, onChange: handleChange })
    ] })
  ] });
};
var subToolbarStatusPage_default = SubToolbarStatusPage;

// src/internals/components/drawer/search.jsx
import _43 from "lodash/fp.js";
import { useMemo as useMemo10, useState as useState20 } from "react";
import { Button as Button20, TextField as TextField3 } from "@lls/lls-kit";
import { cx as cx11 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_drawer_search.module.css
var src_internals_components_drawer_search_default = { "clearButton": "sk-oCokVq-clearButton", "overridingTextInput": "sk-oCokVq-overridingTextInput", "form": "sk-oCokVq-form" };

// src/internals/components/drawer/search.jsx
import { Fragment as Fragment14, jsx as jsx41, jsxs as jsxs30 } from "react/jsx-runtime";
var Search = ({
  label = "N\xB0 Page",
  defaultValue = "",
  onSubmit: onSubmitFromProps = _43.noop,
  width = "100px",
  placeholder,
  align = "left",
  noBorder = false
}) => {
  const [searchValue, setSearchValue] = useState20(defaultValue);
  const onSubmit = (e) => {
    e.preventDefault();
    if (searchValue !== "") onSubmitFromProps(searchValue);
    setSearchValue("");
  };
  const OverridingSearch = useMemo10(
    () => ({ className, style, ...props }) => /* @__PURE__ */ jsxs30(Fragment14, { children: [
      /* @__PURE__ */ jsx41(
        "input",
        {
          className: cx11(className, src_internals_components_drawer_search_default.overridingTextInput),
          style: { ...style, "--s-align": align },
          ...props
        }
      ),
      /* @__PURE__ */ jsx41(
        Button20,
        {
          className: src_internals_components_drawer_search_default.clearButton,
          theme: "gray",
          accent: "floating",
          size: "small",
          icon: "arrowRight",
          type: "submit"
        }
      )
    ] }),
    [align]
  );
  return /* @__PURE__ */ jsx41("form", { className: src_internals_components_drawer_search_default.form, style: { "--s-width": width }, onSubmit, children: /* @__PURE__ */ jsx41(
    TextField3,
    {
      noBorder,
      hiddenArrows: true,
      label,
      placeholder,
      type: "number",
      min: "1",
      step: "1",
      OverridingInputComponent: OverridingSearch,
      onChange: setSearchValue,
      value: searchValue,
      align
    }
  ) });
};
var search_default = Search;

// src/internals/components/drawer/bookInfos.jsx
import { BookCover, MenuButton as MenuButton5 } from "@lls/lls-kit";
import { cx as cx12 } from "@lls/utils";
import _44 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_drawer_bookInfos.module.css
var src_internals_components_drawer_bookInfos_default = { "bookInfos": "sk-GpDRza-bookInfos" };

// src/internals/components/drawer/bookInfos.jsx
import { jsx as jsx42, jsxs as jsxs31 } from "react/jsx-runtime";
var BookInfos = ({ className = "", book, actions }) => {
  const props = {
    icon: "chevrondown",
    iconPosition: "right",
    children: /* @__PURE__ */ jsx42("span", { className: "book-infos-title", children: _44.get("displayTitle", book) }),
    listItems: actions
  };
  return /* @__PURE__ */ jsxs31("div", { className: cx12(className, src_internals_components_drawer_bookInfos_default.bookInfos), children: [
    /* @__PURE__ */ jsx42(BookCover, { src: _44.get("urlLite", book), small: true, height: "40px" }),
    _44.isEmpty(actions) ? /* @__PURE__ */ jsx42("span", { className: "book-infos-title-no-button", children: _44.get("displayTitle", book) }) : /* @__PURE__ */ jsx42(
      MenuButton5,
      {
        className: "book-infos-menu-button",
        size: "small",
        position: "bottom",
        theme: "gray",
        fixed: true,
        maxSize: true,
        ...props
      }
    )
  ] });
};
var bookInfos_default = BookInfos;

// src/internals/components/drawer/collaborativeInfos.jsx
import { Button as Button21, Icon as Icon11 } from "@lls/lls-kit";
import { cx as cx13 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_drawer_collaborativeInfos.module.css
var src_internals_components_drawer_collaborativeInfos_default = { "text": "sk-JFYzyq-text", "buttonContainer": "sk-JFYzyq-buttonContainer", "container": "sk-JFYzyq-container", "title": "sk-JFYzyq-title", "icon": "sk-JFYzyq-icon" };

// src/internals/components/drawer/collaborativeInfos.jsx
import { jsx as jsx43, jsxs as jsxs32 } from "react/jsx-runtime";
var CollaborativeInfos = ({
  className,
  onLearnMoreClick,
  onContributeClick,
  titleElement = /* @__PURE__ */ jsx43("div", { children: "Rejoignez la communaut\xE9\xA0!" }),
  textElement = /* @__PURE__ */ jsx43("div", { children: "Co-construisez les ressources dont vous avez besoin et partagez votre expertise p\xE9dagogique." }),
  contributeButtonText = "Je rejoins"
}) => {
  return /* @__PURE__ */ jsxs32("div", { className: cx13(className, src_internals_components_drawer_collaborativeInfos_default.container), children: [
    /* @__PURE__ */ jsxs32("div", { className: src_internals_components_drawer_collaborativeInfos_default.text, children: [
      /* @__PURE__ */ jsxs32("div", { className: src_internals_components_drawer_collaborativeInfos_default.title, children: [
        /* @__PURE__ */ jsx43(Icon11, { className: src_internals_components_drawer_collaborativeInfos_default.icon, name: "checkmarkshieldfilled", width: 16, height: 16 }),
        titleElement
      ] }),
      textElement
    ] }),
    /* @__PURE__ */ jsxs32("div", { className: src_internals_components_drawer_collaborativeInfos_default.buttonContainer, children: [
      onLearnMoreClick && /* @__PURE__ */ jsx43(Button21, { theme: "yellow", accent: "floating", onClick: onLearnMoreClick, children: "En savoir plus" }),
      contributeButtonText && /* @__PURE__ */ jsx43(Button21, { theme: "yellow", icon: "arrowright", iconPosition: "right", onClick: onContributeClick, children: contributeButtonText })
    ] })
  ] });
};
var collaborativeInfos_default = CollaborativeInfos;

// src/internals/components/drawer/filters.jsx
import { MenuButton as MenuButton6 } from "@lls/lls-kit";
import _45 from "lodash/fp.js";
import { useMemo as useMemo11 } from "react";
import { jsx as jsx44 } from "react/jsx-runtime";
var getFilterIcons = (type) => {
  switch (type) {
    case "PREMIUM":
      return "premium";
    default:
      return void 0;
  }
};
var FiltersButton = ({ currentFilter = void 0, filtersList = [], onFilterChange = _45.noop, disabled }) => {
  const props = useMemo11(() => {
    const listItems = _45.flow(
      _45.map((filter) => ({
        msg: filter.title,
        icon: getFilterIcons(filter.type),
        onClick: () => onFilterChange(filter)
      }))
    )(filtersList);
    return currentFilter ? {
      icon: disabled ? void 0 : "cancel",
      iconPosition: "right",
      children: currentFilter.title,
      listItems,
      onClick: () => onFilterChange(void 0)
    } : {
      icon: "filter",
      iconPosition: "left",
      children: "Filtrer",
      "data-tour": "superkit-filter-button",
      listItems
    };
  }, [filtersList, currentFilter, onFilterChange, disabled]);
  return /* @__PURE__ */ jsx44(MenuButton6, { fixed: true, position: "bottom", disabled, theme: "gray", accent: "alt", inverted: true, ...props });
};
var filters_default = FiltersButton;

// src/internals/components/drawer/index.jsx
import React2, { useEffect as useEffect9, useRef as useRef5, useState as useState21 } from "react";
import _47 from "lodash/fp.js";
import { cx as cx14 } from "@lls/utils";

// src/internals/components/drawer/constants.js
var DRAWER_CLASSNAME = "lls-drawer";
var SUMMARY_HEADER_HEIGHT_DATA_ATTRIBUTE = "data-header-height";
var DRAWER_MY_PAGES_ID = "lls-drawer-my-pages";
var STYLED_DRAWER_HEADER_HEIGHT = 127;
var DEFAULT_NAVBAR_HEIGHT = 64;

// src/internals/v2/utils/summary.ts
import { pipe as pipe2 } from "@lls/utils";
import _46 from "lodash/fp.js";
var getActivePageId = ({ user, page, summaryPage = {} }) => _46.get("isStudent", user) && _46.matches({ id: _46.get("parent", page) }, summaryPage) ? _46.get("id", summaryPage) : _46.get("id", page);
var getSummaryVariant = ({
  parent = {},
  element,
  depth,
  index,
  SummaryPart,
  SummaryChapter: SummaryChapter2,
  SummaryPage: SummaryPage2,
  ChapterComponent,
  PageComponent,
  chapterProps,
  pageProps
}) => {
  const conditions = _46.compact([
    [
      _46.matches({ type: SUMMARY_PART_TYPE }),
      _46.constant([SummaryPart, { ChapterComponent, PageComponent, chapterProps, pageProps, depth }])
    ],
    [
      _46.matches({ type: SUMMARY_CHAPTER_TYPE }),
      _46.constant([SummaryChapter2, { ChapterComponent, PageComponent, chapterProps, pageProps, depth, index }])
    ],
    [
      _46.matches({ type: SUMMARY_PAGE_TYPE }),
      _46.constant([
        SummaryPage2,
        {
          PageComponent,
          pageProps,
          depth,
          index,
          isChapterPage: _46.matches({ type: SUMMARY_CHAPTER_TYPE }, parent)
        }
      ])
    ],
    [_46.stubTrue, _46.constant([_46.constant(null)])]
  ]);
  return _46.cond(conditions)(element);
};
var buildSummaryPageMapping = (modifiedPages, user) => {
  return _46.flow(
    () => modifiedPages,
    _46.groupBy((page = {}) => (page == null ? void 0 : page.isDraft) ? page.originalPage || page.id : page.originalPage),
    isStudent(user) ? (pageIdToModifiedPages) => {
      const mappings = _46.flow(
        _46.toPairs,
        _46.map(([originalPageId, pages]) => {
          const [forksFromOriginalPage, forksFromTeacherPages] = _46.partition(
            (page = {}) => (page == null ? void 0 : page.isDraft) ? page.parent === _46.parseInt(10, originalPageId) || page.id === _46.parseInt(10, originalPageId) : page.parent === _46.parseInt(10, originalPageId),
            pages
          );
          const relatedPages = _46.flow(_46.groupBy("parent"), _46.map(_46.maxBy("updatedAt")))(forksFromTeacherPages);
          return [originalPageId, { relatedPage: _46.maxBy("updatedAt", forksFromOriginalPage), relatedPages }];
        }),
        _46.fromPairs
      )(pageIdToModifiedPages);
      return (page) => {
        const mapping = _46.get(_46.get("id", page), mappings);
        return mapping ? {
          relatedPage: mapping.relatedPage || page,
          relatedPages: mapping.relatedPages
        } : { relatedPage: page, relatedPages: [] };
      };
    } : (pageIdToModifiedPages) => {
      return (page) => {
        return {
          relatedPage: page,
          relatedPages: _46.getOr([], _46.get("id", page), pageIdToModifiedPages)
        };
      };
    }
  )();
};
var getRelatedPage = ({ page = {}, modifiedPages = [], currentUser = {} }) => _46.get("relatedPage", buildSummaryPageMapping(modifiedPages, currentUser)(page));
var editSummary = (summary, onNode) => {
  const recurseFn = (node) => {
    if (_46.isEmpty(_46.get("elements", node))) return onNode(node, _46.identity);
    return pipe2(
      node,
      _46.get("elements"),
      _46.map((node2) => onNode(node2, recurseFn)),
      (elements) => {
        return _46.set("elements", elements, node);
      }
    );
  };
  return onNode(summary, recurseFn);
};
var isSummaryPage = (summaryElement) => {
  return (summaryElement == null ? void 0 : summaryElement.type) === SUMMARY_PAGE_TYPE;
};
var filterSummary = (summary, { getRelatedPages, filter = {}, filterPages }) => {
  if (_46.isEmpty(filter)) return summary;
  return editSummary(summary, (node, next) => {
    if (!node) return void 0;
    if (isSummaryPage(node)) {
      const { relatedPages } = getRelatedPages(node.element);
      return _46.isEmpty(filterPages([{ ...node.element, isOriginal: _46.isEmpty(relatedPages) }], filter)) ? void 0 : { ...node, filterCount: _46.size(relatedPages) + (filter.isOriginal === false ? 0 : 1) };
    }
    const { elements, ...nextNode } = next(node) || {};
    const nextElements = _46.compact(elements);
    return _46.isEmpty(nextElements) ? void 0 : { ...nextNode, elements: nextElements, filterCount: _46.sumBy("filterCount", nextElements) };
  });
};
var memoEqualSummaryPage = ({ activePageId: oldActivePageId, ...old }, { activePageId: nextActivePageId, ...next }) => {
  if (!_46.isEqual(old, next)) {
    return false;
  }
  const oldActive = _46.find(_46.isEqual(oldActivePageId), [_46.get("page.id", old), ..._46.map("id", old.modifiedPages)]);
  const nextActive = _46.find(_46.isEqual(nextActivePageId), [_46.get("page.id", next), ..._46.map("id", next.modifiedPages)]);
  return oldActive === nextActive;
};
var isChapterPage = (summary, pageId) => {
  if (!pageId || !summary) return false;
  const elements = _46.get("elements", summary);
  for (const element of elements) {
    if (_46.get("id", element) === pageId) return _46.get("type", summary) === SUMMARY_CHAPTER_TYPE;
    if (_46.get("type", element) !== SUMMARY_PAGE_TYPE) {
      const pageIncluded = isChapterPage(element, pageId);
      if (pageIncluded) return pageIncluded;
    }
  }
  return false;
};
var getPagesFromSummary = (summary = {}) => {
  const extractPages = (node) => _46.matches({ type: "Page" }, node) ? [_46.get("element", node)] : _46.flow(_46.get("elements"), _46.flatMap(extractPages))(node);
  return _46.flow(_46.get("elements"), _46.flatMap(extractPages))(summary);
};
var matchPageByNumber = (searchValue) => (page) => {
  const firstPage = _46.getOr(0, "page", page);
  const nbPages = _46.getOr(0, "nbPages", page);
  const lastPage = firstPage + (nbPages - 1);
  const searchPage = _46.parseInt(10, searchValue);
  return searchPage >= firstPage && searchPage <= lastPage;
};
var getPageFromSummary = ({
  summary,
  modifiedPages = [],
  currentUser,
  searchValue
}) => {
  if (!searchValue) return void 0;
  const originalPage = _46.flow(getPagesFromSummary, _46.findLast(matchPageByNumber(searchValue)))(summary);
  if (!originalPage || !_46.get("isStudent", currentUser)) return originalPage;
  return _46.flow(_46.orderBy(["updatedAt"], ["desc"]), _46.find({ originalPage: originalPage.id }))(modifiedPages) || originalPage;
};
var getChapterNumShowFromNodes = (nodes = [], page = {}) => {
  for (const node of nodes) {
    const children = _46.get("elements", node);
    if (_46.get("type", node) === "Chapter" && _46.find({ id: page.originalPage || page.id }, children)) {
      return _46.get("element.numShow", node);
    }
    const result = getChapterNumShowFromNodes(children, page);
    if (result) return result;
  }
};
var mapPagesToChapterNumShow = (summary, pages) => _46.map(
  (page) => ({
    ...page,
    chapterNumShow: getChapterNumShowFromNodes(_46.get("elements", summary), page)
  }),
  pages
);
var getLastPaperPage = (page) => {
  const pageValue = (page == null ? void 0 : page.page) || 0;
  const nbPages = (page == null ? void 0 : page.nbPages) || 1;
  return pageValue + (nbPages - 1);
};
var getMaxPageFromSummary = (summary) => _46.flow(getPagesFromSummary, _46.reject(_46.flow(_46.get("nbPages"), _46.isNil)), _46.maxBy("page"), getLastPaperPage)(summary);
var getNewChapterId = ({ page, summary, isOriginalPageCreatedFromScratch }) => {
  const originalPageId = isOriginalPage(page) || (page == null ? void 0 : page.isPanorama) ? page == null ? void 0 : page.id : page == null ? void 0 : page.originalPage;
  const pageIsInChapter = isChapterPage(summary, originalPageId);
  if (pageIsInChapter) return page == null ? void 0 : page.chapter;
  if ((page == null ? void 0 : page.isCreatedFromScratch) || isOriginalPageCreatedFromScratch) return DRAWER_MY_PAGES_ID;
  return void 0;
};

// tmp_esbuild1736180050074/_src_internals_components_drawer_index.module.css
var src_internals_components_drawer_index_default = { "drawer": "sk-xKYPaq-drawer", "viewer-fullscreen-modal": "sk-xKYPaq-viewer-fullscreen-modal", "drawerContainer": "sk-xKYPaq-drawerContainer" };

// src/internals/components/drawer/index.jsx
import { jsx as jsx45, jsxs as jsxs33 } from "react/jsx-runtime";
var BookDrawer = ({
  children,
  summary,
  toolboxChild,
  width = BOOK_DRAWER_WIDTH,
  headerHeight = STYLED_DRAWER_HEADER_HEIGHT,
  navbarHeight = DEFAULT_NAVBAR_HEIGHT,
  isDrawerOpen,
  page,
  SummaryComponent,
  isOriginalPageCreatedFromScratch,
  expandedId: expandedIdFromProps,
  setExpandedId: setExpandedIdFromProps,
  isBookBrowsingMode = false,
  className,
  style: styleFromProps = {},
  ...props
}) => {
  const [activeChapterId, setActiveChapterId] = useState21();
  const [localExpandedId, setLocalExpandedId] = useState21(() => {
    return !(setExpandedIdFromProps && !isBookBrowsingMode) && getNewChapterId({ page, summary, isOriginalPageCreatedFromScratch });
  });
  const [expandedId, setExpandedId] = setExpandedIdFromProps && !isBookBrowsingMode ? [expandedIdFromProps, setExpandedIdFromProps] : [localExpandedId, setLocalExpandedId];
  const expandedIdRef = useRef5(expandedId);
  useEffect9(() => {
    const newChapterId = getNewChapterId({ page, summary, isOriginalPageCreatedFromScratch });
    setExpandedId(newChapterId || expandedIdRef.current);
    setActiveChapterId(newChapterId);
  }, [page, isOriginalPageCreatedFromScratch, summary, setExpandedId]);
  const [windowHeight, setWindowHeight] = useState21();
  useEffect9(() => {
    const measureWindowHeight = () => {
      setWindowHeight(_47.get("innerHeight", window));
    };
    measureWindowHeight();
    window.addEventListener("resize", measureWindowHeight);
    return () => window.removeEventListener("resize", measureWindowHeight);
  }, []);
  const childrenWithProps = React2.Children.map(children, (child) => {
    if (React2.isValidElement(child) && child.type === SummaryComponent) {
      return React2.cloneElement(child, { setExpandedId, expandedId, activeChapterId });
    }
    return child;
  });
  return /* @__PURE__ */ jsxs33(
    "div",
    {
      className: cx14(className, src_internals_components_drawer_index_default.drawerContainer),
      style: {
        ...styleFromProps,
        "--s-width": `${width}px`,
        "--s-windowheight": windowHeight ? `${windowHeight}px` : "100vh",
        "--s-navbarheight": `${navbarHeight}px`
      },
      ...props,
      "data-isdraweropen": +!!isDrawerOpen,
      children: [
        /* @__PURE__ */ jsx45(
          "div",
          {
            style: { "--s-width": `${width}px` },
            ...{ [SUMMARY_HEADER_HEIGHT_DATA_ATTRIBUTE]: headerHeight },
            className: cx14(DRAWER_CLASSNAME, src_internals_components_drawer_index_default.drawer),
            children: childrenWithProps
          }
        ),
        !_47.isUndefined(toolboxChild) && toolboxChild
      ]
    }
  );
};
var drawer_default = BookDrawer;

// src/internals/components/drawer/summaryChapter.jsx
import _52 from "lodash/fp.js";
import { useEffect as useEffect11, useRef as useRef7 } from "react";

// src/internals/components/drawer/accordion.jsx
import React3, { useCallback as useCallback24 } from "react";
import { Icon as Icon12 } from "@lls/lls-kit";
import _48 from "lodash/fp.js";
import { cx as cx15 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_drawer_accordion.module.css
var src_internals_components_drawer_accordion_default = { "accordion": "sk-NJ86oG-accordion", "viewer-fullscreen-modal": "sk-NJ86oG-viewer-fullscreen-modal", "renewalStamp": "sk-NJ86oG-renewalStamp", "accordionMain": "sk-NJ86oG-accordionMain" };

// src/internals/components/drawer/accordion.jsx
import { jsx as jsx46, jsxs as jsxs34 } from "react/jsx-runtime";
var Accordion = React3.forwardRef(
  ({
    children,
    className,
    collapsed = false,
    mainElement,
    childHeight = 100,
    onCollapse = _48.noop,
    iconName,
    renewedAt,
    ...props
  }, ref) => {
    const handleClick = useCallback24(() => {
      onCollapse(!collapsed);
    }, [collapsed, onCollapse]);
    const handleKeyDown = useCallback24(
      (e) => {
        if (_48.includes(e.code, ["Enter", "Space"])) {
          e.preventDefault();
          onCollapse(!collapsed);
        }
      },
      [collapsed, onCollapse]
    );
    return /* @__PURE__ */ jsxs34(
      "div",
      {
        style: {
          "--s-maxheight": `${_48.size(children) * childHeight}px`
        },
        ref,
        className: cx15(className, src_internals_components_drawer_accordion_default.accordion),
        "data-collapsed": +collapsed,
        ...props,
        children: [
          /* @__PURE__ */ jsxs34("div", { className: src_internals_components_drawer_accordion_default.accordionMain, onClick: handleClick, onKeyDown: handleKeyDown, tabIndex: 0, children: [
            mainElement,
            /* @__PURE__ */ jsx46(Icon12, { className: "accordion-icon", name: iconName })
          ] }),
          /* @__PURE__ */ jsx46("div", { className: "accordion-children", children })
        ]
      }
    );
  }
);
var accordion_default = Accordion;

// src/internals/components/drawer/summaryChapter.jsx
import { Icon as Icon14, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME5 } from "@lls/lls-kit";

// src/internals/v2/utils/drawer.ts
import _49 from "lodash/fp.js";
var scrollToElementInsideDrawer = ({
  marginFromHeader = 24,
  element
}) => {
  if (!element) return;
  const drawer = element.closest(`.${DRAWER_CLASSNAME}`);
  if (!drawer) return;
  const headerHeight = _49.toFinite(drawer.getAttribute(SUMMARY_HEADER_HEIGHT_DATA_ATTRIBUTE));
  const { top: drawerTop } = drawer.getBoundingClientRect();
  const { top: elementTop } = element.getBoundingClientRect();
  drawer.scrollBy({ top: elementTop - drawerTop - headerHeight - marginFromHeader });
};

// tmp_esbuild1736180050074/_src_internals_components_drawer_countChip.module.css
var src_internals_components_drawer_countChip_default = { "viewer-fullscreen-modal": "sk-CZMaWW-viewer-fullscreen-modal", "countChip": "sk-CZMaWW-countChip" };

// src/internals/components/drawer/countChip.jsx
import { jsx as jsx47 } from "react/jsx-runtime";
var CountChip = ({ count }) => /* @__PURE__ */ jsx47("div", { className: src_internals_components_drawer_countChip_default.countChip, children: count });
var countChip_default = CountChip;

// src/internals/components/drawer/notificationIcon.jsx
import { cx as cx16 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_drawer_notificationIcon.module.css
var src_internals_components_drawer_notificationIcon_default = { "notificationIcon": "sk-1k86Ta-notificationIcon" };

// src/internals/components/drawer/notificationIcon.jsx
import { jsx as jsx48 } from "react/jsx-runtime";
var NotificationIcon = ({ className }) => /* @__PURE__ */ jsx48("svg", { className: cx16(src_internals_components_drawer_notificationIcon_default.notificationIcon, className), focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", children: /* @__PURE__ */ jsx48("circle", { cx: "3", cy: "6", r: "3", fill: "currentColor" }) });
var notificationIcon_default = NotificationIcon;

// tmp_esbuild1736180050074/_src_internals_components_drawer_summaryChapter.module.css
var src_internals_components_drawer_summaryChapter_default = { "lockedChapter": "sk-rdLOua-lockedChapter sk-rdLOua-chapterCss", "viewer-fullscreen-modal": "sk-rdLOua-viewer-fullscreen-modal", "summaryChapterComponentTitle": "sk-rdLOua-summaryChapterComponentTitle", "chapterCss": "sk-rdLOua-chapterCss", "accordion": "sk-rdLOua-accordion sk-rdLOua-chapterCss", "summaryChapterComponentPretitle": "sk-rdLOua-summaryChapterComponentPretitle" };

// src/internals/components/drawer/summaryPage.jsx
import { memo, useEffect as useEffect10, useRef as useRef6 } from "react";
import { Icon as Icon13, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME4, Tooltip as Tooltip6 } from "@lls/lls-kit";
import { getPageInterval as getPageInterval2 } from "@lls/utils";
import _50 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_drawer_summaryPage.module.css
var src_internals_components_drawer_summaryPage_default = { "summaryPage": "sk-8_tzka-summaryPage", "summaryPageSubtitle": "sk-8_tzka-summaryPageSubtitle", "summaryModifiedPage": "sk-8_tzka-summaryModifiedPage", "viewer-fullscreen-modal": "sk-8_tzka-viewer-fullscreen-modal", "modifiedPage": "sk-8_tzka-modifiedPage", "summaryPageComponent": "sk-8_tzka-summaryPageComponent", "iconContainer": "sk-8_tzka-iconContainer" };

// src/internals/components/drawer/summaryPage.jsx
import { jsx as jsx49, jsxs as jsxs35 } from "react/jsx-runtime";
var SummaryPageComplement = ({ summaryPage }) => {
  const pageInterval = getPageInterval2({ page: _50.get("element", summaryPage) });
  if (_50.get("element.isPanorama", summaryPage) || _50.get("element.premium", summaryPage)) {
    return /* @__PURE__ */ jsx49("span", { className: "summary-page-title-icon", children: /* @__PURE__ */ jsx49(Icon13, { name: "premium", width: 12, height: 12 }) });
  }
  if (pageInterval) {
    return pageInterval;
  }
  return null;
};
var SummaryModifiedPageSharedPicto = ({ groups }) => {
  return /* @__PURE__ */ jsx49(Tooltip6, { content: `Partag\xE9e \xE0 ${_50.size(groups)} ${handlePlural("groupe", groups)}`, inverted: true, children: /* @__PURE__ */ jsx49("div", { className: src_internals_components_drawer_summaryPage_default.iconContainer, children: /* @__PURE__ */ jsx49(Icon13, { name: "pairfilled", width: 16, height: 16 }) }) });
};
var SummaryModifiedPageComponent = ({
  page,
  active = false,
  hasNotification,
  LinkComponent,
  linkProps,
  onClick
}) => {
  const ref = useRef6(null);
  useEffect10(() => {
    if (active) {
      scrollToElementInsideDrawer({
        element: ref.current,
        marginFromHeader: 80
      });
    }
  }, [active]);
  return /* @__PURE__ */ jsxs35("div", { className: src_internals_components_drawer_summaryPage_default.modifiedPage, ref, "data-active": +active, children: [
    /* @__PURE__ */ jsxs35(
      LinkComponent,
      {
        page,
        className: src_internals_components_drawer_summaryPage_default.summaryModifiedPage,
        linkProps,
        onClick: (event) => onClick({ event, isValid: true, active, page }),
        children: [
          /* @__PURE__ */ jsx49("span", { className: "summary-modified-page-icon", children: /* @__PURE__ */ jsx49(Icon13, { name: "arrowright", width: "16", height: "16" }) }),
          (page == null ? void 0 : page.isDraft) && /* @__PURE__ */ jsx49("span", { className: "summary-draft-page-icon", children: /* @__PURE__ */ jsx49(Icon13, { name: "edit", width: "13", height: "13" }) }),
          /* @__PURE__ */ jsxs35("span", { className: "summary-modified-page-title", children: [
            page == null ? void 0 : page.displayTitle,
            " ",
            hasNotification ? /* @__PURE__ */ jsx49(notificationIcon_default, {}) : null
          ] })
        ]
      }
    ),
    _50.flow(
      _50.get("sharedGroups"),
      (groups) => _50.isEmpty(groups) ? null : /* @__PURE__ */ jsx49(SummaryModifiedPageSharedPicto, { groups })
    )(page)
  ] });
};
var DefaultLink = ({ children, className }) => {
  return /* @__PURE__ */ jsx49("div", { className, children });
};
var SummaryPageComponent = memo(
  ({
    page,
    index,
    depth,
    isChapterPage: isChapterPage2,
    // injectable props
    activePageId,
    isActivePageDraft,
    notificationIds,
    modifiedPages,
    LinkComponent = DefaultLink,
    linkProps,
    onClick = _50.noop,
    teaserMode = false,
    relatedPage = {},
    isLicensedBook = false
  } = {}) => {
    const ref = useRef6(null);
    const isTeaser = _50.get("element.teaser", page);
    const isValid = _50.get("element.valid", page);
    const isActive = _50.matches({ id: activePageId }, page);
    useEffect10(() => {
      if (isActive) {
        scrollToElementInsideDrawer({
          element: ref.current,
          marginFromHeader: 80
        });
      }
    }, [isActive]);
    const thematicName = _50.get("element.thematicName", page);
    const isMainPageActive = Boolean(isActive && (!isActivePageDraft || _50.get("element.isCreatedFromScratch", page)));
    const shouldDisplayLockedIcon = !isValid || teaserMode && !isTeaser && !isLicensedBook;
    return /* @__PURE__ */ jsxs35(
      "div",
      {
        className: src_internals_components_drawer_summaryPage_default.summaryPageComponent,
        ref,
        "data-inchapter": +isChapterPage2,
        "data-active": +isMainPageActive,
        "data-index": index,
        "data-root": +(depth === 1),
        "data-hasdivider": +(index !== 0 && (depth === 1 || !isChapterPage2)),
        "data-deepactive": +(isActive || _50.some({ id: activePageId }, modifiedPages)),
        "data-premium": +_50.getOr(false, "element.premium", page),
        "data-panorama": +_50.getOr(false, "element.isPanorama", page),
        "data-tour": `${DATA_TOUR.SUMMARY_PAGE}-${_50.get("id", page)}`,
        children: [
          /* @__PURE__ */ jsxs35(
            LinkComponent,
            {
              page: page.element,
              className: src_internals_components_drawer_summaryPage_default.summaryPage,
              linkProps,
              teaserMode,
              isTeaser,
              onClick: (event) => onClick({ event, isValid, active: isActive, page }),
              children: [
                isMainPageActive && /* @__PURE__ */ jsx49("span", { className: "summary-page-icon", children: /* @__PURE__ */ jsx49(Icon13, { name: "arrowright", width: "16", height: "18" }) }),
                /* @__PURE__ */ jsxs35("span", { className: "summary-page-title-container", children: [
                  (relatedPage == null ? void 0 : relatedPage.isDraft) && /* @__PURE__ */ jsx49("span", { className: "summary-draft-page-icon", children: /* @__PURE__ */ jsx49(Icon13, { name: "edit", width: "13", height: "13" }) }),
                  /* @__PURE__ */ jsxs35("span", { className: "summary-page-title", children: [
                    /* @__PURE__ */ jsxs35("div", { children: [
                      _50.isEmpty(page.title) ? thematicName : page.title,
                      _50.includes(page.id, notificationIds) || _50.includes(relatedPage.id, notificationIds) ? /* @__PURE__ */ jsx49(notificationIcon_default, {}) : null
                    ] }),
                    /* @__PURE__ */ jsx49("span", { className: src_internals_components_drawer_summaryPage_default.summaryPageSubtitle, children: _50.isEmpty(page.title) ? "" : thematicName })
                  ] })
                ] }),
                /* @__PURE__ */ jsx49("span", { className: "summary-page-complement", children: /* @__PURE__ */ jsx49(SummaryPageComplement, { summaryPage: page }) }),
                shouldDisplayLockedIcon && /* @__PURE__ */ jsx49("span", { className: `summary-page-title-icon summary-page-locked-icon ${KIT_CLASSNAME_LIGHT_THEME4}`, children: /* @__PURE__ */ jsx49(Icon13, { name: "lockfilled", width: 12, height: 12 }) })
              ]
            }
          ),
          !_50.isEmpty(modifiedPages) && isValid && /* @__PURE__ */ jsx49(
            "div",
            {
              className: "summary-page-modified-pages",
              "data-tour": `${DATA_TOUR.SUMMARY_MODIFIED_PAGES}-${_50.get("id", page)}`,
              children: _50.map(
                (modifiedPage) => /* @__PURE__ */ jsx49(
                  SummaryModifiedPageComponent,
                  {
                    active: _50.matches({ id: activePageId }, modifiedPage) && (!(modifiedPage == null ? void 0 : modifiedPage.isDraft) || isActivePageDraft),
                    page: modifiedPage,
                    LinkComponent,
                    linkProps,
                    hasNotification: _50.includes(_50.get("id", modifiedPage), notificationIds),
                    onClick
                  },
                  _50.get("id", modifiedPage)
                ),
                modifiedPages
              )
            }
          )
        ]
      }
    );
  },
  memoEqualSummaryPage
);
var SummaryPage = ({ element: page, isChapterPage: isChapterPage2, PageComponent, pageProps, index, depth }) => {
  return /* @__PURE__ */ jsx49(PageComponent, { page, isChapterPage: isChapterPage2, pageProps, index, depth });
};
var summaryPage_default = SummaryPage;

// tmp_esbuild1736180050074/_src_internals_components_drawer_summaryPart.module.css
var src_internals_components_drawer_summaryPart_default = { "viewer-fullscreen-modal": "sk-HXpAmW-viewer-fullscreen-modal", "part": "sk-HXpAmW-part" };

// src/internals/components/drawer/summaryPart.jsx
import { Fragment as Fragment15, jsx as jsx50, jsxs as jsxs36 } from "react/jsx-runtime";
var Part = ({ element = {}, depth, ChapterComponent, PageComponent, chapterProps, pageProps }) => {
  return /* @__PURE__ */ jsxs36(Fragment15, { children: [
    /* @__PURE__ */ jsx50("div", { className: src_internals_components_drawer_summaryPart_default.part, children: element.title }),
    /* @__PURE__ */ jsx50(
      summaryElements_default,
      {
        currentElement: element,
        depth,
        ChapterComponent,
        PageComponent,
        pageProps,
        chapterProps
      }
    )
  ] });
};
var summaryPart_default = Part;

// src/internals/components/drawer/summaryElements.jsx
import _51 from "lodash/fp.js";
import { useMemo as useMemo12 } from "react";
import { jsx as jsx51 } from "react/jsx-runtime";
var SummaryElement = ({
  parent,
  element = {},
  depth,
  index,
  ChapterComponent,
  PageComponent,
  chapterProps,
  pageProps
}) => {
  const [SummaryVariant, props] = useMemo12(() => {
    return getSummaryVariant({
      parent,
      element,
      depth,
      index,
      SummaryPart: summaryPart_default,
      SummaryChapter: summaryChapter_default,
      SummaryPage: summaryPage_default,
      ChapterComponent,
      PageComponent,
      chapterProps,
      pageProps
    });
  }, [element, ChapterComponent, PageComponent, chapterProps, pageProps, depth, index, parent]);
  return /* @__PURE__ */ jsx51(SummaryVariant, { ...props, element });
};
var SummaryElements = ({ currentElement, depth = 0, ChapterComponent, PageComponent, chapterProps, pageProps }) => {
  return _51.flow(
    _51.getOr([], "elements"),
    _51.map.convert({ cap: false })((element, i) => /* @__PURE__ */ jsx51(
      SummaryElement,
      {
        index: i,
        parent: currentElement,
        element,
        ChapterComponent,
        PageComponent,
        chapterProps,
        pageProps,
        depth: depth + 1
      },
      i
    ))
  )(currentElement);
};
var summaryElements_default = SummaryElements;

// src/internals/components/drawer/summaryChapter.jsx
import { jsx as jsx52, jsxs as jsxs37 } from "react/jsx-runtime";
var SummaryChapterComponent = ({
  chapter,
  isRoot,
  children,
  index,
  // injectable props
  hasNotification,
  filterCount = 0,
  collapsed = true,
  onCollapse,
  onAvailableSoon,
  onNotTeaser = _52.noop,
  activeChapterId,
  teaserMode = false,
  currentUser = {},
  isLicensedBook = false,
  dataTour
}) => {
  const ref = useRef7(null);
  const isTeaser = _52.get("element.teaser", chapter);
  const isValid = _52.get("element.valid", chapter);
  const renewedAt = _52.flow(_52.get("elements"), _52.map("element.renewedAt"), _52.max)(chapter);
  const mainElement = /* @__PURE__ */ jsxs37("div", { className: "summary-chapter-component-main", children: [
    /* @__PURE__ */ jsxs37("div", { className: "summary-chapter-component-title-container", children: [
      /* @__PURE__ */ jsx52("div", { className: src_internals_components_drawer_summaryChapter_default.summaryChapterComponentPretitle, children: _52.get("element.numShow", chapter) }),
      /* @__PURE__ */ jsxs37("div", { className: src_internals_components_drawer_summaryChapter_default.summaryChapterComponentTitle, children: [
        chapter.title,
        hasNotification && isValid ? /* @__PURE__ */ jsx52(notificationIcon_default, {}) : null
      ] })
    ] }),
    filterCount > 0 ? /* @__PURE__ */ jsx52(countChip_default, { count: filterCount }) : null
  ] });
  const iconName = isValid ? collapsed ? "chevrondown" : "chevronup" : "lockfilled";
  useEffect11(() => {
    const currentNode = ref.current;
    return () => {
      if (collapsed) {
        scrollToElementInsideDrawer({
          element: currentNode
        });
      }
    };
  }, [collapsed]);
  const validChapterElement = /* @__PURE__ */ jsx52(
    accordion_default,
    {
      className: src_internals_components_drawer_summaryChapter_default.accordion,
      ref,
      childHeight: 1e3,
      mainElement,
      collapsed,
      onCollapse,
      "data-root": +isRoot,
      "data-hasdivider": +(index !== 0),
      "data-qa-id": `summary-chapter-${chapter.id}`,
      iconName,
      renewedAt,
      "data-active": +(activeChapterId === chapter.id),
      "data-tour": dataTour,
      children: collapsed ? null : children
    }
  );
  const lockedChapterElementFactory = (onClick) => /* @__PURE__ */ jsxs37(
    "div",
    {
      className: src_internals_components_drawer_summaryChapter_default.lockedChapter,
      onClick,
      "data-root": +isRoot,
      "data-hasdivider": +(index !== 0),
      "data-active": +(activeChapterId === chapter.id),
      children: [
        mainElement,
        /* @__PURE__ */ jsx52(Icon14, { className: `locked-chapter-icon ${KIT_CLASSNAME_LIGHT_THEME5}`, name: "lockfilled" })
      ]
    }
  );
  const isLocked = teaserMode && !isTeaser && !isLicensedBook;
  switch (true) {
    case (!isLocked && (isValid || hasAccessToInvalidPageOrChapter(currentUser))):
      return validChapterElement;
    case (!isLocked && !isValid):
      return lockedChapterElementFactory(onAvailableSoon);
    default:
      return lockedChapterElementFactory(onNotTeaser);
  }
};
var SummaryChapter = ({
  ChapterComponent,
  PageComponent,
  element: chapter,
  index,
  depth,
  chapterProps,
  pageProps
} = {}) => {
  return /* @__PURE__ */ jsx52(ChapterComponent, { chapter, isRoot: depth === 1, chapterProps, index, children: /* @__PURE__ */ jsx52(
    summaryElements_default,
    {
      currentElement: chapter,
      depth,
      ChapterComponent,
      PageComponent,
      pageProps,
      chapterProps
    }
  ) });
};
var summaryChapter_default = SummaryChapter;

// src/internals/components/drawer/summary.jsx
import { jsx as jsx53 } from "react/jsx-runtime";
var Summary = ({
  summary,
  ChapterComponent = SummaryChapterComponent,
  PageComponent = SummaryPageComponent,
  chapterProps,
  pageProps
}) => {
  return /* @__PURE__ */ jsx53(
    summaryElements_default,
    {
      currentElement: summary,
      ChapterComponent,
      PageComponent,
      chapterProps,
      pageProps
    }
  );
};
var summary_default = Summary;

// src/internals/components/drawer/renewalTeaser.jsx
import { Icon as Icon15 } from "@lls/lls-kit";
import { cx as cx17 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_drawer_renewalTeaser.module.css
var src_internals_components_drawer_renewalTeaser_default = { "premium": "sk-YfSEBG-premium", "icon": "sk-YfSEBG-icon", "viewer-fullscreen-modal": "sk-YfSEBG-viewer-fullscreen-modal", "arrow": "sk-YfSEBG-arrow", "renewalTeaser": "sk-YfSEBG-renewalTeaser", "allnew": "sk-YfSEBG-allnew" };

// src/internals/components/drawer/renewalTeaser.jsx
import { jsx as jsx54, jsxs as jsxs38 } from "react/jsx-runtime";
var RenewalTeaser = () => {
  return /* @__PURE__ */ jsxs38("div", { className: src_internals_components_drawer_renewalTeaser_default.renewalTeaser, children: [
    /* @__PURE__ */ jsx54("span", { className: src_internals_components_drawer_renewalTeaser_default.premium, children: "Acc\xE9dez" }),
    " \xE0 vos contenus actualis\xE9s en",
    " ",
    /* @__PURE__ */ jsx54("span", { className: src_internals_components_drawer_renewalTeaser_default.premium, children: "2023" }),
    /* @__PURE__ */ jsx54(Icon15, { className: src_internals_components_drawer_renewalTeaser_default.icon, name: "premium", width: "12", height: "12" }),
    /* @__PURE__ */ jsx54("div", { children: /* @__PURE__ */ jsx54("span", { className: cx17(src_internals_components_drawer_renewalTeaser_default.allnew, src_internals_components_drawer_renewalTeaser_default.premium), children: "C'est tout neuf\xA0!" }) }),
    /* @__PURE__ */ jsx54("img", { className: src_internals_components_drawer_renewalTeaser_default.arrow, src: "/assets/renewal-arrow-down.svg" })
  ] });
};
var renewalTeaser_default = RenewalTeaser;

// src/internals/components/revision/index.jsx
import _59 from "lodash/fp.js";
import { useEffect as useEffect13, useMemo as useMemo13, useState as useState23 } from "react";
import { ANALYTICS_PAGE_VIEWED, dispatchAnalyticsEvent as dispatchAnalyticsEvent8 } from "@lls/utils";

// src/internals/hooks/useRevision.ts
import _53 from "lodash/fp.js";
import { useEffect as useEffect12, useState as useState22 } from "react";
var useRevision = ({
  queryParams,
  subjectToBooks,
  setSelectedSubjectBooks,
  setIsShownSelectBook,
  setIsShownSelectLevel,
  levels,
  onGoToRevisionBook
}) => {
  const [isReady, setIsReady] = useState22(false);
  useEffect12(() => {
    if (!_53.isEmpty(queryParams)) {
      const { bookUris: bookUrisQuery, subjectId } = queryParams;
      const subjectBooks = _53.flatMap(_53.identity, subjectToBooks);
      if (bookUrisQuery) {
        const bookUris = _53.split(",", bookUrisQuery);
        const subjectBooksByUri = _53.keyBy("uri", subjectBooks);
        const selectedBooks = _53.map((bookUri) => _53.get(bookUri, subjectBooksByUri), bookUris);
        setSelectedSubjectBooks(selectedBooks);
        setIsShownSelectBook(true);
        return;
      }
      if (subjectId) {
        const selectedBooks = _53.filter(
          (subjectBook) => _53.includes(_53.parseInt(10, subjectId), subjectBook == null ? void 0 : subjectBook.subjects),
          subjectBooks
        );
        setSelectedSubjectBooks(selectedBooks);
        setIsShownSelectLevel(true);
      }
    }
  }, [queryParams, setIsShownSelectBook, setSelectedSubjectBooks, setIsShownSelectLevel, subjectToBooks]);
  useEffect12(() => {
    setIsReady(true);
    if (_53.size(subjectToBooks) === 1 && _53.isEmpty(queryParams)) {
      const subjectBooks = _53.flatMap(_53.identity, subjectToBooks);
      setSelectedSubjectBooks(subjectBooks);
      if (_53.size(levels) > 1) {
        setIsShownSelectLevel(true);
        return;
      }
      if (_53.size(subjectBooks) > 1) {
        setIsShownSelectBook(true);
        return;
      }
      onGoToRevisionBook(subjectBooks[0]);
    }
    return () => setIsReady(false);
  }, [
    subjectToBooks,
    levels,
    queryParams,
    setIsShownSelectBook,
    setIsShownSelectLevel,
    onGoToRevisionBook,
    setSelectedSubjectBooks
  ]);
  return { isReady };
};
var useRevision_default = useRevision;

// src/internals/utils/book.jsx
import _54 from "lodash/fp.js";
var getSubjectToBooks = (books, subjects) => _54.flow(
  _54.reject((book) => _54.isEmpty(book == null ? void 0 : book.revisionPages)),
  _54.map((book) => ({ ...book, subject: _54.find({ id: book == null ? void 0 : book.subjects[0] }, subjects) })),
  _54.groupBy("subject.name")
)(books);
var getRevisionLevels = (levels, books) => {
  const levelByIds = _54.keyBy("id", levels);
  return _54.flow(
    _54.flatMap("levels"),
    _54.uniq,
    _54.map((bookLevel) => _54.get(bookLevel, levelByIds)),
    _54.compact,
    _54.orderBy("order", "desc")
  )(books);
};

// src/internals/components/revision/chooseBook.jsx
import _56 from "lodash/fp.js";

// src/internals/components/revision/subjectsBooks.jsx
import _55 from "lodash/fp.js";
import { useCallback as useCallback25 } from "react";
import { makeComponent as makeComponent5 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_revision_subjectsBooks.module.css
var src_internals_components_revision_subjectsBooks_default = { "title": "sk-r12C6a-title", "subjectBooks": "sk-r12C6a-subjectBooks", "subjectBooksContainer": "sk-r12C6a-subjectBooksContainer", "span": "sk-r12C6a-span" };

// src/internals/components/revision/subjectsBooks.jsx
import { jsx as jsx55, jsxs as jsxs39 } from "react/jsx-runtime";
var StyledSubjectBooksContainer = makeComponent5("div", src_internals_components_revision_subjectsBooks_default.subjectBooksContainer);
var StyledSubjectBooks = makeComponent5("div", src_internals_components_revision_subjectsBooks_default.subjectBooks);
var StyledTitle3 = makeComponent5("span", src_internals_components_revision_subjectsBooks_default.title);
var SubjectsBooks = ({
  levels,
  onGotoRevisionBook,
  setIsShownSelectLevel,
  setIsShownSelectBook,
  setSelectedSubjectBooks,
  subjectToBooks
}) => {
  const onClickSubjectBooks = useCallback25(
    (books) => {
      setSelectedSubjectBooks(books);
      if (_55.size(levels) > 1 && _55.size(books) > 1) return setIsShownSelectLevel(true);
      if (_55.size(books) > 1) {
        setIsShownSelectBook(true);
      } else {
        onGotoRevisionBook(books[0]);
      }
    },
    [setSelectedSubjectBooks, setIsShownSelectBook, onGotoRevisionBook, levels, setIsShownSelectLevel]
  );
  return /* @__PURE__ */ jsx55("div", { className: src_internals_components_revision_subjectsBooks_default.subjectBooksContainer, children: _55.map.convert({ cap: false })((subjectBooks, title) => {
    const subjectUrl = _55.get("0.subject.url", subjectBooks);
    const resourcesNumber = _55.flow(_55.flatMap("revisionPages"), _55.size)(subjectBooks);
    return /* @__PURE__ */ jsxs39("div", { className: src_internals_components_revision_subjectsBooks_default.subjectBooks, onClick: () => onClickSubjectBooks(subjectBooks), children: [
      /* @__PURE__ */ jsx55("img", { src: subjectUrl }),
      /* @__PURE__ */ jsx55("span", { className: src_internals_components_revision_subjectsBooks_default.title, children: title }),
      /* @__PURE__ */ jsxs39("span", { className: src_internals_components_revision_subjectsBooks_default.span, children: [
        resourcesNumber,
        " ",
        handlePlural("ressource", resourcesNumber)
      ] })
    ] }, title);
  }, subjectToBooks) });
};
var subjectsBooks_default = SubjectsBooks;

// src/internals/components/revision/chooseBook.jsx
import { jsx as jsx56, jsxs as jsxs40 } from "react/jsx-runtime";
var ChooseBook = ({ books, onGoToRevisionBook }) => {
  return /* @__PURE__ */ jsx56(StyledSubjectBooksContainer, { children: _56.map(
    (book) => /* @__PURE__ */ jsxs40(
      StyledSubjectBooks,
      {
        onClick: () => onGoToRevisionBook(book, { query: { bookUris: _56.map("uri", books) } }),
        children: [
          /* @__PURE__ */ jsx56("img", { src: book == null ? void 0 : book.urlLite }),
          /* @__PURE__ */ jsx56(StyledTitle3, { children: book == null ? void 0 : book.displayTitle })
        ]
      },
      book == null ? void 0 : book.id
    ),
    books
  ) });
};
var chooseBook_default = ChooseBook;

// src/internals/components/revision/chooseLevel.jsx
import _57 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_revision_chooseLevel.module.css
var src_internals_components_revision_chooseLevel_default = { "levelsContainer": "sk-SN97HG-levelsContainer", "level": "sk-SN97HG-level" };

// src/internals/components/revision/chooseLevel.jsx
import { jsx as jsx57 } from "react/jsx-runtime";
var ChooseLevel = ({
  levels,
  onGoToRevisionBook,
  selectedSubjectBooks,
  setIsShownSelectBook,
  setIsShownSelectLevel,
  setSelectedSubjectBooks
}) => {
  const revisionLevels = getRevisionLevels(levels, selectedSubjectBooks);
  const onClickLevel = (level) => {
    const levelSubjectBooks = _57.filter((subjectBook) => _57.includes(level == null ? void 0 : level.id, subjectBook == null ? void 0 : subjectBook.levels), selectedSubjectBooks);
    if (_57.size(levelSubjectBooks) > 1) {
      setIsShownSelectLevel(false);
      setIsShownSelectBook(true);
      setSelectedSubjectBooks(levelSubjectBooks);
    } else {
      onGoToRevisionBook(levelSubjectBooks[0], { query: { subjectId: _57.get("0.subject.id", levelSubjectBooks) } });
    }
  };
  return /* @__PURE__ */ jsx57("div", { className: src_internals_components_revision_chooseLevel_default.levelsContainer, children: _57.map(
    (level) => /* @__PURE__ */ jsx57("div", { className: src_internals_components_revision_chooseLevel_default.level, onClick: () => onClickLevel(level), children: getLevelName(level == null ? void 0 : level.name) }, level == null ? void 0 : level.id),
    revisionLevels
  ) });
};
var chooseLevel_default = ChooseLevel;

// src/internals/components/revision/emptyState.jsx
import { Button as Button22, Wavy } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_revision_emptyState.module.css
var src_internals_components_revision_emptyState_default = { "subTitle": "sk-X9UhFG-subTitle", "container": "sk-X9UhFG-container", "title": "sk-X9UhFG-title", "rightContent": "sk-X9UhFG-rightContent", "name": "sk-X9UhFG-name", "leftContent": "sk-X9UhFG-leftContent", "img": "sk-X9UhFG-img", "buttonContainer": "sk-X9UhFG-buttonContainer", "annotations": "sk-X9UhFG-annotations" };

// src/internals/components/revision/emptyState.jsx
import { jsx as jsx58, jsxs as jsxs41 } from "react/jsx-runtime";
var EmptyState2 = ({ onGoToJoinCommunity }) => {
  return /* @__PURE__ */ jsxs41("div", { className: src_internals_components_revision_emptyState_default.container, children: [
    /* @__PURE__ */ jsxs41("div", { className: src_internals_components_revision_emptyState_default.leftContent, children: [
      /* @__PURE__ */ jsx58(
        "img",
        {
          className: src_internals_components_revision_emptyState_default.name,
          style: { "--s-top": "0px", "--s-bottom": "initial", "--s-right": "initial" },
          src: "/assets/img/revisionBook/chloe.webp"
        }
      ),
      /* @__PURE__ */ jsx58(
        "img",
        {
          className: src_internals_components_revision_emptyState_default.name,
          style: { "--s-top": "initial", "--s-bottom": "0px", "--s-right": "40px" },
          src: "/assets/img/revisionBook/pascal.webp"
        }
      ),
      /* @__PURE__ */ jsx58("img", { className: src_internals_components_revision_emptyState_default.img, src: "/assets/img/revisionBook/empty_state.webp" })
    ] }),
    /* @__PURE__ */ jsxs41("div", { className: src_internals_components_revision_emptyState_default.rightContent, children: [
      /* @__PURE__ */ jsx58(
        "img",
        {
          className: src_internals_components_revision_emptyState_default.name,
          style: {
            "--s-top": "initial",
            "--s-bottom": "-10px",
            "--s-right": "100px"
          },
          src: "/assets/img/revisionBook/justine.webp",
          "data-display": "0"
        }
      ),
      /* @__PURE__ */ jsx58(
        "img",
        {
          className: src_internals_components_revision_emptyState_default.name,
          style: {
            "--s-top": "initial",
            "--s-bottom": "120px",
            "--s-right": "-10px"
          },
          src: "/assets/img/revisionBook/corinne.webp",
          "data-display": "0"
        }
      ),
      /* @__PURE__ */ jsxs41("h2", { className: src_internals_components_revision_emptyState_default.title, children: [
        "Aucune ressource dans votre mati\xE8re ",
        /* @__PURE__ */ jsx58(Wavy, { waveColor: "var(--premium-50-color)", children: "pour l'instant." })
      ] }),
      /* @__PURE__ */ jsx58("span", { className: src_internals_components_revision_emptyState_default.subTitle, children: "Pas d'inqui\xE9tude ! Vous pouvez rejoindre la communaut\xE9 et fa\xE7onner avec nous les projets et outils p\xE9dagogiques de demain !" }),
      /* @__PURE__ */ jsxs41("div", { className: src_internals_components_revision_emptyState_default.buttonContainer, children: [
        /* @__PURE__ */ jsx58("img", { className: src_internals_components_revision_emptyState_default.annotations, src: "/assets/img/revisionBook/annotations.webp" }),
        /* @__PURE__ */ jsx58(Button22, { theme: "yellow", onClick: onGoToJoinCommunity, children: "Rejoindre la communaut\xE9" })
      ] })
    ] })
  ] });
};
var emptyState_default2 = EmptyState2;

// src/internals/components/revision/header.jsx
import _58 from "lodash/fp.js";
import { Button as Button23, Wavy as Wavy2 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_revision_header.module.css
var src_internals_components_revision_header_default = { "div": "sk-SPxe1W-div", "span": "sk-SPxe1W-span" };

// src/internals/components/revision/header.jsx
import { Fragment as Fragment16, jsx as jsx59, jsxs as jsxs42 } from "react/jsx-runtime";
var WavyComponent = ({ word }) => /* @__PURE__ */ jsx59(Wavy2, { waveColor: "var(--premium-50-color)", children: word });
var Header2 = ({
  user,
  levels,
  subjectToBooks,
  isShownSelectBook,
  isShownSelectLevel,
  setIsShownSelectLevel,
  setSelectedSubjectBooks,
  setIsShownSelectBook,
  selectedSubjectBooks
}) => {
  const subjectName = _58.get("0.subject.name", selectedSubjectBooks);
  const isStudent2 = user == null ? void 0 : user.isStudent;
  const onGoBack = () => {
    if (!isShownSelectBook && isShownSelectLevel) return setIsShownSelectLevel(false);
    setSelectedSubjectBooks(_58.get(subjectName, subjectToBooks));
    setIsShownSelectBook(false);
    if (_58.size(levels) > 1) setIsShownSelectLevel(true);
  };
  const isShownGoBack = _58.size(subjectToBooks) > 1 && isShownSelectLevel || isShownSelectBook;
  return /* @__PURE__ */ jsxs42("div", { className: src_internals_components_revision_header_default.div, children: [
    isShownGoBack && /* @__PURE__ */ jsx59(Button23, { onClick: onGoBack, theme: "gray", inverted: true, accent: "floating", icon: "arrowleft", size: "medium", children: subjectName }),
    /* @__PURE__ */ jsx59("h2", { children: isStudent2 ? /* @__PURE__ */ jsxs42(Fragment16, { children: [
      "Sur quelle ",
      /* @__PURE__ */ jsx59(WavyComponent, { word: "mati\xE8re" }),
      " porte ton examen ?",
      /* @__PURE__ */ jsx59("br", {}),
      /* @__PURE__ */ jsx59("span", { className: src_internals_components_revision_header_default.span, children: "r\xE9vise \xE0 ton rythme, en autonomie !" })
    ] }) : isShownSelectLevel ? /* @__PURE__ */ jsxs42(Fragment16, { children: [
      "Quel ",
      /* @__PURE__ */ jsx59(WavyComponent, { word: "niveau" }),
      " souhaitez-vous consulter ?"
    ] }) : isShownSelectBook ? /* @__PURE__ */ jsxs42(Fragment16, { children: [
      "Quel ",
      /* @__PURE__ */ jsx59(WavyComponent, { word: "manuel" }),
      " souhaitez-vous consulter ?"
    ] }) : /* @__PURE__ */ jsxs42(Fragment16, { children: [
      "Quelle ",
      /* @__PURE__ */ jsx59(WavyComponent, { word: "mati\xE8re" }),
      " aimeriez-vous que vos \xE9l\xE8ves r\xE9visent ?"
    ] }) })
  ] });
};
var header_default = Header2;

// tmp_esbuild1736180050074/_src_internals_components_revision_index.module.css
var src_internals_components_revision_index_default = { "container": "sk-oaztZa-container" };

// src/internals/components/revision/index.jsx
import { Fragment as Fragment17, jsx as jsx60, jsxs as jsxs43 } from "react/jsx-runtime";
var getExtraData = ({ subjectToBooks, isShownSelectLevel, isShownSelectBook }) => {
  switch (true) {
    case _59.isEmpty(subjectToBooks):
      return "emptyState";
    case isShownSelectBook === true:
      return "questionBook";
    case isShownSelectLevel === true:
      return "questionLevel";
    default:
      return "questionSubject";
  }
};
var Revision = ({ books, subjects, user, levels, onGoToRevisionBook, onGoToJoinCommunity, queryParams }) => {
  const [isShownSelectLevel, setIsShownSelectLevel] = useState23(false);
  const [isShownSelectBook, setIsShownSelectBook] = useState23(false);
  const [selectedSubjectBooks, setSelectedSubjectBooks] = useState23([]);
  const subjectToBooks = useMemo13(() => getSubjectToBooks(books, subjects), [books, subjects]);
  const { isReady } = useRevision_default({
    queryParams,
    subjectToBooks,
    setSelectedSubjectBooks,
    setIsShownSelectBook,
    setIsShownSelectLevel,
    levels,
    onGoToRevisionBook
  });
  const extraData = getExtraData({
    subjectToBooks,
    isShownSelectBook,
    isShownSelectLevel
  });
  useEffect13(() => {
    if (isReady) dispatchAnalyticsEvent8(ANALYTICS_PAGE_VIEWED, { extraData });
  }, [extraData, isReady]);
  return /* @__PURE__ */ jsx60("div", { className: src_internals_components_revision_index_default.container, children: _59.isEmpty(subjectToBooks) ? /* @__PURE__ */ jsx60(emptyState_default2, { onGoToJoinCommunity }) : /* @__PURE__ */ jsxs43(Fragment17, { children: [
    /* @__PURE__ */ jsx60(
      header_default,
      {
        user,
        levels,
        setIsShownSelectLevel,
        isShownSelectLevel,
        isShownSelectBook,
        setSelectedSubjectBooks,
        subjectToBooks,
        setIsShownSelectBook,
        selectedSubjectBooks
      }
    ),
    isShownSelectLevel ? /* @__PURE__ */ jsx60(
      chooseLevel_default,
      {
        selectedSubjectBooks,
        setSelectedSubjectBooks,
        setIsShownSelectLevel,
        levels,
        onGoToRevisionBook,
        setIsShownSelectBook
      }
    ) : isShownSelectBook ? /* @__PURE__ */ jsx60(chooseBook_default, { books: selectedSubjectBooks, onGoToRevisionBook }) : /* @__PURE__ */ jsx60(
      subjectsBooks_default,
      {
        subjectToBooks,
        subjects,
        levels,
        onGotoRevisionBook: onGoToRevisionBook,
        setIsShownSelectLevel,
        setIsShownSelectBook,
        setSelectedSubjectBooks
      }
    )
  ] }) });
};
var revision_default = Revision;

// src/internals/components/revision/revisionBook/index.jsx
import _62 from "lodash/fp.js";
import { useCallback as useCallback28, useRef as useRef8, useState as useState25 } from "react";

// src/internals/components/revision/revisionBook/chapterList.jsx
import _61 from "lodash/fp.js";
import { useCallback as useCallback27, useState as useState24 } from "react";
import { Icon as Icon17 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_revision_revisionBook_chapterList.module.css
var src_internals_components_revision_revisionBook_chapterList_default = { "chapterContent": "sk-RubsLa-chapterContent", "chapterItem": "sk-RubsLa-chapterItem", "contentLeft": "sk-RubsLa-contentLeft", "span": "sk-RubsLa-span", "container": "sk-RubsLa-container" };

// src/internals/components/revision/revisionBook/pageList.jsx
import _60 from "lodash/fp.js";
import { useCallback as useCallback26, useMemo as useMemo14 } from "react";
import { Button as Button24, Icon as Icon16 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_revision_revisionBook_pageList.module.css
var src_internals_components_revision_revisionBook_pageList_default = { "pageCard": "sk-BMk78a-pageCard", "span": "sk-BMk78a-span", "infos": "sk-BMk78a-infos", "icon": "sk-BMk78a-icon", "img": "sk-BMk78a-img", "container": "sk-BMk78a-container", "topCard": "sk-BMk78a-topCard" };

// src/internals/components/revision/revisionBook/pageList.jsx
import { jsx as jsx61, jsxs as jsxs44 } from "react/jsx-runtime";
var isRevisionSheetPage = (page) => _60.get("thematicName", page) === PAGES_THEMATIC.REVISION_SHEET;
var PageCard = ({ page, onGoToPage, user, setIsShareToGroupModalOpen, setSelectedPage }) => {
  const isRevisionSheet = isRevisionSheetPage(page);
  const imgSrc = isRevisionSheet ? "/assets/img/revisionBook/paper.webp" : "/assets/img/revisionBook/quiz.webp";
  const onShareIconClick = useCallback26(
    (e) => {
      e.stopPropagation();
      setSelectedPage(page);
      setIsShareToGroupModalOpen(true);
    },
    [page, setIsShareToGroupModalOpen, setSelectedPage]
  );
  return /* @__PURE__ */ jsxs44("div", { className: src_internals_components_revision_revisionBook_pageList_default.pageCard, children: [
    /* @__PURE__ */ jsxs44("div", { className: src_internals_components_revision_revisionBook_pageList_default.topCard, children: [
      /* @__PURE__ */ jsxs44("div", { className: src_internals_components_revision_revisionBook_pageList_default.infos, children: [
        page == null ? void 0 : page.categoryTitle,
        (user == null ? void 0 : user.isTeacher) && /* @__PURE__ */ jsx61(Icon16, { className: src_internals_components_revision_revisionBook_pageList_default.icon, onClick: onShareIconClick, name: "share", color: "var(--text-alt-color)" })
      ] }),
      /* @__PURE__ */ jsx61("span", { className: src_internals_components_revision_revisionBook_pageList_default.span, children: page == null ? void 0 : page.displayTitle })
    ] }),
    /* @__PURE__ */ jsx61("img", { className: src_internals_components_revision_revisionBook_pageList_default.img, src: imgSrc }),
    /* @__PURE__ */ jsxs44(Button24, { onClick: () => onGoToPage(page), children: [
      " ",
      isRevisionSheet ? "R\xE9viser" : "M'entra\xEEner"
    ] })
  ] });
};
var getCategoryTitle = (page) => isRevisionSheetPage(page) ? "Fiche de r\xE9vision" : "Quiz";
var PageList = ({ pages, onGoToPage, user, setIsShareToGroupModalOpen, setSelectedPage }) => {
  const pagesWithCategoryTitle = useMemo14(
    () => _60.map((page) => ({ ...page, categoryTitle: getCategoryTitle(page) }), pages),
    [pages]
  );
  return /* @__PURE__ */ jsx61("div", { className: src_internals_components_revision_revisionBook_pageList_default.container, children: _60.flow(
    _60.sortBy("categoryTitle"),
    _60.map((page) => /* @__PURE__ */ jsx61(
      PageCard,
      {
        onGoToPage,
        page,
        user,
        setSelectedPage,
        setIsShareToGroupModalOpen
      },
      page == null ? void 0 : page.id
    ))
  )(pagesWithCategoryTitle) });
};
var pageList_default = PageList;

// src/internals/components/revision/revisionBook/chapterList.jsx
import { jsx as jsx62, jsxs as jsxs45 } from "react/jsx-runtime";
var PADDING_REVISION_BOOK_CONTAINER = 80;
var PADDING_CHAPTER_CONTAINER = 48;
var ChapterItem = ({
  id,
  numShow,
  title,
  pages,
  onGoToPage,
  user,
  setIsShareToGroupModalOpen,
  setSelectedPage,
  setSelectedIndex,
  selectedIndex
}) => {
  const chapterPages = _61.filter({ chapter: id }, pages);
  const isActive = selectedIndex === id;
  const onClickChapterItem = useCallback27(() => {
    setSelectedIndex(isActive ? null : id);
  }, [id, setSelectedIndex, isActive]);
  return /* @__PURE__ */ jsxs45("div", { className: src_internals_components_revision_revisionBook_chapterList_default.chapterItem, children: [
    /* @__PURE__ */ jsxs45("div", { className: src_internals_components_revision_revisionBook_chapterList_default.chapterContent, onClick: onClickChapterItem, children: [
      /* @__PURE__ */ jsxs45("div", { className: src_internals_components_revision_revisionBook_chapterList_default.contentLeft, children: [
        /* @__PURE__ */ jsx62("span", { className: src_internals_components_revision_revisionBook_chapterList_default.span, children: _61.truncate({ length: 7, omission: "." }, numShow) }),
        /* @__PURE__ */ jsx62("h2", { children: title })
      ] }),
      /* @__PURE__ */ jsx62(Icon17, { name: isActive ? "chevronup" : "chevrondown" })
    ] }),
    isActive && /* @__PURE__ */ jsx62(
      pageList_default,
      {
        pages: chapterPages,
        onGoToPage,
        user,
        setSelectedPage,
        setIsShareToGroupModalOpen
      }
    )
  ] });
};
var ChapterList = ({ headerRef, chapters, pages, onGoToPage, user, setIsShareToGroupModalOpen, setSelectedPage }) => {
  var _a, _b;
  const headerHeight = (_b = (_a = headerRef.current) == null ? void 0 : _a.getBoundingClientRect()) == null ? void 0 : _b.top;
  const [selectedIndex, setSelectedIndex] = useState24(null);
  return /* @__PURE__ */ jsx62(
    "div",
    {
      className: src_internals_components_revision_revisionBook_chapterList_default.container,
      style: {
        "--s-padding-chapter-container": `${PADDING_CHAPTER_CONTAINER}px`,
        "--s-default-navbar-height": `${DEFAULT_NAVBAR_HEIGHT}px`,
        "--s-padding-revision-book-container": `${PADDING_REVISION_BOOK_CONTAINER}px`,
        "--s-header-height": `${headerHeight}px`
      },
      children: _61.map(
        (chapter) => /* @__PURE__ */ jsx62(
          ChapterItem,
          {
            id: chapter == null ? void 0 : chapter.id,
            numShow: chapter == null ? void 0 : chapter.numShow,
            title: chapter == null ? void 0 : chapter.title,
            selectedIndex,
            setSelectedIndex,
            onGoToPage,
            pages,
            user,
            setSelectedPage,
            setIsShareToGroupModalOpen
          },
          chapter == null ? void 0 : chapter.id
        ),
        chapters
      )
    }
  );
};
var chapterList_default = ChapterList;

// src/internals/components/revision/revisionBook/header.jsx
import { Button as Button25 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_revision_revisionBook_header.module.css
var src_internals_components_revision_revisionBook_header_default = { "div": "sk-rxwd0q-div", "header": "sk-rxwd0q-header" };

// src/internals/components/revision/revisionBook/header.jsx
import { jsx as jsx63, jsxs as jsxs46 } from "react/jsx-runtime";
var Header3 = ({ headerRef, book, onGoBack, subject }) => {
  return /* @__PURE__ */ jsx63("div", { className: src_internals_components_revision_revisionBook_header_default.header, ref: headerRef, children: /* @__PURE__ */ jsxs46("div", { className: src_internals_components_revision_revisionBook_header_default.div, children: [
    /* @__PURE__ */ jsx63(Button25, { onClick: onGoBack, theme: "gray", inverted: true, accent: "floating", icon: "arrowleft", size: "medium", children: "Retour" }),
    /* @__PURE__ */ jsx63("h2", { children: book == null ? void 0 : book.displayTitle }),
    /* @__PURE__ */ jsx63("img", { src: subject == null ? void 0 : subject.url })
  ] }) });
};
var header_default2 = Header3;

// tmp_esbuild1736180050074/_src_internals_components_revision_revisionBook_index.module.css
var src_internals_components_revision_revisionBook_index_default = { "container": "sk-5Zdlza-container" };

// src/internals/components/revision/revisionBook/index.jsx
import { jsx as jsx64, jsxs as jsxs47 } from "react/jsx-runtime";
var RevisionBook = ({
  book,
  chapters,
  groups,
  onGoBack,
  onGoToPage,
  onShareGroup,
  onManageGroupClick,
  subject,
  selectedPage,
  setSelectedPage,
  pages,
  user
}) => {
  const validChapters = _62.flow(
    _62.filter((chapter) => _62.includes(chapter == null ? void 0 : chapter.id, _62.flatMap("chapter", pages))),
    _62.sortBy("number")
  )(chapters);
  const headerRef = useRef8(null);
  const [isShareToGroupsModalOpen, setIsShareToGroupModalOpen] = useState25(false);
  const closeShareToGroupsModal = useCallback28(() => setIsShareToGroupModalOpen(false), []);
  return /* @__PURE__ */ jsxs47(
    "div",
    {
      className: src_internals_components_revision_revisionBook_index_default.container,
      style: { "--s-padding-revision-book-container": `${PADDING_REVISION_BOOK_CONTAINER}px` },
      children: [
        /* @__PURE__ */ jsx64(header_default2, { headerRef, onGoBack, book, subject }),
        /* @__PURE__ */ jsx64(
          chapterList_default,
          {
            headerRef,
            chapters: validChapters,
            pages,
            onGoToPage,
            user,
            setSelectedPage,
            setIsShareToGroupModalOpen
          }
        ),
        /* @__PURE__ */ jsx64(
          shareModal_default,
          {
            isModalOpen: isShareToGroupsModalOpen,
            closeModal: closeShareToGroupsModal,
            groups,
            currentUser: user,
            page: selectedPage,
            onManageGroupClick,
            onShareGroup
          }
        )
      ]
    }
  );
};
var revisionBook_default = RevisionBook;

// src/internals/components/learningAssessment/common.jsx
import { Button as Button26, Stepper } from "@lls/lls-kit";
import { cx as cx18, makeComponent as makeComponent6 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_common.module.css
var src_internals_components_learningAssessment_common_default = { "containerLayout": "sk-tOWrMG-containerLayout", "layoutNavbar": "sk-tOWrMG-layoutNavbar", "contentMainNavbar": "sk-tOWrMG-contentMainNavbar", "mainNavbarImg": "sk-tOWrMG-mainNavbarImg", "mainNavbar": "sk-tOWrMG-mainNavbar", "stepper": "sk-tOWrMG-stepper", "contentLeft": "sk-tOWrMG-contentLeft", "sessionCardSubTitle": "sk-tOWrMG-sessionCardSubTitle", "sessionsContainer": "sk-tOWrMG-sessionsContainer", "emptyDiv": "sk-tOWrMG-emptyDiv", "divStepBackLayoutNavbar": "sk-tOWrMG-divStepBackLayoutNavbar", "navbar": "sk-tOWrMG-navbar", "sessionCardChapterImg": "sk-tOWrMG-sessionCardChapterImg", "chapterImg": "sk-tOWrMG-chapterImg", "sessionCard": "sk-tOWrMG-sessionCard", "sessionCardTitle": "sk-tOWrMG-sessionCardTitle", "infosSessionCard": "sk-tOWrMG-infosSessionCard", "divStepBackContainer": "sk-tOWrMG-divStepBackContainer", "layoutNavbarTitle": "sk-tOWrMG-layoutNavbarTitle", "title": "sk-tOWrMG-title", "mainNavbarTitle": "sk-tOWrMG-mainNavbarTitle" };

// src/internals/components/learningAssessment/common.jsx
import { jsx as jsx65, jsxs as jsxs48 } from "react/jsx-runtime";
var STEP_NAVBAR_HEIGHT = 104;
var StyledContainerLayout = makeComponent6("div", src_internals_components_learningAssessment_common_default.containerLayout);
var StyledChapterImg = makeComponent6("img", src_internals_components_learningAssessment_common_default.chapterImg);
var StyledSessionsContainer = makeComponent6("div", src_internals_components_learningAssessment_common_default.sessionsContainer);
var StyledSessionCard = makeComponent6("div", src_internals_components_learningAssessment_common_default.sessionCard);
var StyledInfosSessionCard = makeComponent6("div", src_internals_components_learningAssessment_common_default.infosSessionCard);
var StyledSessionCardTitle = makeComponent6("h3", src_internals_components_learningAssessment_common_default.sessionCardTitle);
var StyledSessionCardSubTitle = makeComponent6("span", src_internals_components_learningAssessment_common_default.sessionCardSubTitle);
var StyledSessionCardChapterImg = makeComponent6(StyledChapterImg, src_internals_components_learningAssessment_common_default.sessionCardChapterImg);
var StyledNavbar = makeComponent6("div", src_internals_components_learningAssessment_common_default.navbar);
var StyledStepper = makeComponent6("div", src_internals_components_learningAssessment_common_default.stepper);
var StyledDivStepBackContainer = makeComponent6("div", src_internals_components_learningAssessment_common_default.divStepBackContainer);
var StyledTitle4 = makeComponent6("div", src_internals_components_learningAssessment_common_default.title);
var StyledEmptyDiv = makeComponent6("div", src_internals_components_learningAssessment_common_default.emptyDiv);
var getStepIndexFromStep = (step) => {
  switch (step) {
    case LEARNING_ASSESSMENT_STEPS.SELECT_NOTION:
      return 0;
    case LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES:
      return 1;
    case LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS:
      return 2;
  }
};
var getTitle = (step) => {
  switch (step) {
    case LEARNING_ASSESSMENT_STEPS.SELECT_NOTION:
      return "Cr\xE9er une session";
    case LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES:
      return "Choisir les questions";
    case LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS:
      return "Envoyer la session";
  }
};
var StepNavbar = ({ currentStep, onGoBack, onGoToNextStep, isNextButtonDisabled = false }) => {
  const isShownNextButton = currentStep !== LEARNING_ASSESSMENT_STEPS.SELECT_NOTION;
  return /* @__PURE__ */ jsxs48(StyledNavbar, { style: { "--s-step-navbar-height": `${STEP_NAVBAR_HEIGHT}px` }, children: [
    /* @__PURE__ */ jsxs48(StyledDivStepBackContainer, { children: [
      /* @__PURE__ */ jsx65(Button26, { theme: "gray", icon: "arrowleft", onClick: onGoBack }),
      "Pr\xE9c\xE9dent"
    ] }),
    /* @__PURE__ */ jsxs48(StyledStepper, { children: [
      /* @__PURE__ */ jsx65(StyledTitle4, { children: getTitle(currentStep) }),
      /* @__PURE__ */ jsx65(Stepper, { currentStep: getStepIndexFromStep(currentStep), nbSteps: 3 })
    ] }),
    isShownNextButton ? /* @__PURE__ */ jsx65(Button26, { disabled: isNextButtonDisabled, onClick: onGoToNextStep, children: "Continuer" }) : /* @__PURE__ */ jsx65(StyledEmptyDiv, {})
  ] });
};
var LayoutNavbar = ({ chapter, backButtonWording = "Quitter", onGoBack, className }) => {
  return /* @__PURE__ */ jsxs48("div", { className: cx18(className, src_internals_components_learningAssessment_common_default.layoutNavbar), children: [
    /* @__PURE__ */ jsxs48(StyledDivStepBackContainer, { className: src_internals_components_learningAssessment_common_default.divStepBackLayoutNavbar, children: [
      /* @__PURE__ */ jsx65(Button26, { theme: "gray", icon: "arrowleft", onClick: onGoBack }),
      backButtonWording
    ] }),
    chapter && /* @__PURE__ */ jsx65("h2", { className: src_internals_components_learningAssessment_common_default.layoutNavbarTitle, children: chapter == null ? void 0 : chapter.title })
  ] });
};
var MainNavbar = ({ isTeacher: isTeacher2, onGoTo, onGoToHome }) => {
  const onCreateSession = () => onGoTo(LEARNING_ASSESSMENT_STEPS.SELECT_NOTION);
  return /* @__PURE__ */ jsx65("div", { className: cx18(src_internals_components_learningAssessment_common_default.mainNavbar, src_internals_components_learningAssessment_common_default.layoutNavbar), children: /* @__PURE__ */ jsxs48("div", { className: src_internals_components_learningAssessment_common_default.contentMainNavbar, children: [
    /* @__PURE__ */ jsxs48("div", { className: src_internals_components_learningAssessment_common_default.contentLeft, children: [
      /* @__PURE__ */ jsx65(Button26, { onClick: onGoToHome, icon: "home", theme: "gray" }),
      /* @__PURE__ */ jsx65("img", { onClick: onGoToHome, className: src_internals_components_learningAssessment_common_default.mainNavbarImg, src: "/assets/img/navbar/logo-premium.webp" }),
      " |",
      /* @__PURE__ */ jsx65("span", { className: src_internals_components_learningAssessment_common_default.mainNavbarTitle, children: "Suivi des acquis" })
    ] }),
    isTeacher2 && /* @__PURE__ */ jsx65(Button26, { icon: "plus", onClick: () => onCreateSession(), children: "Cr\xE9er une session" })
  ] }) });
};

// src/internals/components/learningAssessment/student/index.jsx
import _65 from "lodash/fp.js";
import { useState as useState28 } from "react";

// src/internals/components/learningAssessment/student/exitSessionModal.jsx
import { Button as Button27, Modal as Modal8 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_student_exitSessionModal.module.css
var src_internals_components_learningAssessment_student_exitSessionModal_default = { "buttonContainer": "sk-D5Wl4a-buttonContainer", "button": "sk-D5Wl4a-button", "modalContent": "sk-D5Wl4a-modalContent" };

// src/internals/components/learningAssessment/student/exitSessionModal.jsx
import { jsx as jsx66, jsxs as jsxs49 } from "react/jsx-runtime";
var ExitSessionModal = ({ close, onGoBack }) => /* @__PURE__ */ jsx66(Modal8, { closeModal: close, withCloseButton: false, children: /* @__PURE__ */ jsxs49("div", { className: src_internals_components_learningAssessment_student_exitSessionModal_default.modalContent, children: [
  /* @__PURE__ */ jsx66("h3", { children: "Voulez-vous quitter la session ?" }),
  "En quittant une session non finie vous devrez la reprendre pour la terminer.",
  /* @__PURE__ */ jsxs49("div", { className: src_internals_components_learningAssessment_student_exitSessionModal_default.buttonContainer, children: [
    /* @__PURE__ */ jsx66(Button27, { className: src_internals_components_learningAssessment_student_exitSessionModal_default.button, onClick: onGoBack, children: "confirmer" }),
    /* @__PURE__ */ jsx66(Button27, { className: src_internals_components_learningAssessment_student_exitSessionModal_default.button, theme: "error", accent: "floating", onClick: close, children: "fermer" })
  ] })
] }) });
var exitSessionModal_default = ExitSessionModal;

// src/internals/components/learningAssessment/student/home.jsx
import { Tab as Tab4, Tabs as Tabs4, Wavy as Wavy3 } from "@lls/lls-kit";
import _64 from "lodash/fp.js";
import { useState as useState27 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_student_home.module.css
var src_internals_components_learningAssessment_student_home_default = { "layout": "sk-mm9Aka-layout", "tab": "sk-mm9Aka-tab", "header": "sk-mm9Aka-header", "stylePictureProfileImg": "sk-mm9Aka-stylePictureProfileImg", "badge": "sk-mm9Aka-badge", "container": "sk-mm9Aka-container", "h2": "sk-mm9Aka-h2", "stylePictureProfileContainer": "sk-mm9Aka-stylePictureProfileContainer", "tabs": "sk-mm9Aka-tabs", "png": "sk-mm9Aka-png", "svgContainer": "sk-mm9Aka-svgContainer" };

// src/internals/components/learningAssessment/student/sessionList.jsx
import _63 from "lodash/fp.js";
import { useMemo as useMemo15, useState as useState26 } from "react";
import { Button as Button28, Tooltip as Tooltip7 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_student_emptyState.module.css
var src_internals_components_learningAssessment_student_emptyState_default = { "title": "sk-oGLzCq-title", "layout": "sk-oGLzCq-layout", "span": "sk-oGLzCq-span", "container": "sk-oGLzCq-container" };

// src/internals/components/learningAssessment/student/emptyState.jsx
import { jsx as jsx67, jsxs as jsxs50 } from "react/jsx-runtime";
var EmptyState3 = ({ areFinished }) => {
  const title = areFinished ? "Aucune session termin\xE9e pour le moment." : "F\xE9licitations tu es \xE0 jour dans tes exercices !";
  return /* @__PURE__ */ jsx67("div", { className: src_internals_components_learningAssessment_student_emptyState_default.layout, children: /* @__PURE__ */ jsxs50("div", { className: src_internals_components_learningAssessment_student_emptyState_default.container, children: [
    /* @__PURE__ */ jsx67("h2", { className: src_internals_components_learningAssessment_student_emptyState_default.title, children: title }),
    /* @__PURE__ */ jsx67("span", { className: src_internals_components_learningAssessment_student_emptyState_default.span, children: "Aucun exercice \xE0 faire pour le moment." })
  ] }) });
};
var emptyState_default3 = EmptyState3;

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_student_sessionList.module.css
var src_internals_components_learningAssessment_student_sessionList_default = { "container": "sk-tXAINq-container", "studentSessionCard": "sk-tXAINq-studentSessionCard", "progressSegment": "sk-tXAINq-progressSegment", "styleContentToolTip": "sk-tXAINq-styleContentToolTip", "button": "sk-tXAINq-button", "progressStudentsBar": "sk-tXAINq-progressStudentsBar" };

// src/internals/components/learningAssessment/student/sessionList.jsx
import { Fragment as Fragment18, jsx as jsx68, jsxs as jsxs51 } from "react/jsx-runtime";
var map2 = _63.map.convert({ cap: false });
var getAnswersCount = (userWrongResponseCount, stats) => _63.flow(_63.filter({ userWrongResponseCount }), _63.size)(stats);
var StudentProgressBar = ({ stats, page }) => {
  var _a;
  const [node, setNode] = useState26(null);
  const total = _63.size(page == null ? void 0 : page.children);
  const totalRightAnswers = getAnswersCount(0, stats);
  const totalWrongAnswers = getAnswersCount(1, stats);
  const parentWidth = (_a = node == null ? void 0 : node.getBoundingClientRect()) == null ? void 0 : _a.width;
  const wrongAnswerWidthSegment = totalWrongAnswers / total * parentWidth * 100 / parentWidth;
  const rightAnswerWidthSegment = totalRightAnswers / total * parentWidth * 100 / parentWidth;
  const isOnlyOneChildComponent = _63.flow(_63.compact, _63.size, (size) => size <= 1)([totalRightAnswers, totalWrongAnswers]);
  return /* @__PURE__ */ jsxs51("div", { className: src_internals_components_learningAssessment_student_sessionList_default.progressStudentsBar, ref: setNode, children: [
    totalRightAnswers > 0 && /* @__PURE__ */ jsx68(
      "div",
      {
        className: src_internals_components_learningAssessment_student_sessionList_default.progressSegment,
        style: { "--s-backgroundcolor": "var(--success-40-color)", "--s-width": `${rightAnswerWidthSegment}%` },
        "data-onechild": +isOnlyOneChildComponent,
        children: /* @__PURE__ */ jsx68(
          Tooltip7,
          {
            content: `${totalRightAnswers} ${handlePlural("r\xE9ponse", totalRightAnswers)} ${handlePlural("correcte", totalRightAnswers)}`,
            withTail: true,
            children: /* @__PURE__ */ jsx68("div", { className: src_internals_components_learningAssessment_student_sessionList_default.styleContentToolTip })
          }
        )
      }
    ),
    totalWrongAnswers > 0 && /* @__PURE__ */ jsx68(
      "div",
      {
        className: src_internals_components_learningAssessment_student_sessionList_default.progressSegment,
        style: { "--s-backgroundcolor": "var(--error-40-color)", "--s-width": `${wrongAnswerWidthSegment}%` },
        "data-onechild": +isOnlyOneChildComponent,
        children: /* @__PURE__ */ jsx68(
          Tooltip7,
          {
            content: `${totalWrongAnswers} ${handlePlural("r\xE9ponse", totalWrongAnswers)} ${handlePlural("incorrecte", totalWrongAnswers)}`,
            withTail: true,
            children: /* @__PURE__ */ jsx68("div", { className: src_internals_components_learningAssessment_student_sessionList_default.styleContentToolTip })
          }
        )
      }
    )
  ] });
};
var SessionCard = ({ chapter, page, teacher, onGoTo, areFinished, stats }) => {
  const onClick = () => {
    onGoTo(LEARNING_ASSESSMENT_STEPS.START_SESSION, { pageSlug: page == null ? void 0 : page.slug });
  };
  const isStarted = _63.flow(_63.get("children"), _63.flatMap("responses"), _63.isEmpty)(page);
  return /* @__PURE__ */ jsxs51(StyledSessionCard, { className: src_internals_components_learningAssessment_student_sessionList_default.studentSessionCard, children: [
    /* @__PURE__ */ jsx68(StyledSessionCardChapterImg, { src: chapter == null ? void 0 : chapter.img, style: { "--s-backgroundcolor": chapter == null ? void 0 : chapter.backgroundColor } }),
    /* @__PURE__ */ jsx68(StyledSessionCardTitle, { children: chapter == null ? void 0 : chapter.title }),
    /* @__PURE__ */ jsx68(StyledSessionCardSubTitle, { children: getTeacherTitleAndLastName(teacher) }),
    !areFinished && /* @__PURE__ */ jsx68(Button28, { className: src_internals_components_learningAssessment_student_sessionList_default.button, accent: isStarted ? "main" : "floating", onClick, children: isStarted ? "Commencer" : "Reprendre" }),
    areFinished && /* @__PURE__ */ jsx68(StudentProgressBar, { stats, page })
  ] });
};
var SessionList = ({ myLearningAssessmentPages, chapters, teachers, onGoTo, stats = {}, areFinished = false }) => {
  const pages = useMemo15(
    () => _63.map(
      (page) => ({
        ...page,
        chapter: _63.find({ id: page == null ? void 0 : page.chapter }, chapters),
        teacher: _63.find({ id: page == null ? void 0 : page.user }, teachers)
      }),
      myLearningAssessmentPages
    ),
    [chapters, myLearningAssessmentPages, teachers]
  );
  const statsByPageId = useMemo15(
    () => _63.flow(
      _63.map((stat) => _63.pick(["userWrongResponseCount", "pageId"], stat)),
      _63.groupBy("pageId")
    )(stats),
    [stats]
  );
  return /* @__PURE__ */ jsx68(Fragment18, { children: _63.isEmpty(myLearningAssessmentPages) ? /* @__PURE__ */ jsx68(emptyState_default3, { areFinished }) : /* @__PURE__ */ jsx68(StyledSessionsContainer, { className: src_internals_components_learningAssessment_student_sessionList_default.container, children: map2(
    (page, i) => /* @__PURE__ */ jsx68(
      SessionCard,
      {
        stats: _63.get(page == null ? void 0 : page.id, statsByPageId),
        onGoTo,
        chapter: page == null ? void 0 : page.chapter,
        teacher: page == null ? void 0 : page.teacher,
        page,
        areFinished
      },
      i
    ),
    pages
  ) }) });
};
var sessionList_default = SessionList;

// src/internals/components/learningAssessment/student/home.jsx
import { Fragment as Fragment19, jsx as jsx69, jsxs as jsxs52 } from "react/jsx-runtime";
var Home = ({
  chapters,
  finishedLearningAssessmentPages,
  learningAssessmentPages,
  teachers,
  onStartSession,
  onGoTo,
  stats
}) => {
  const [selectedTab, setSelectedTab] = useState27(0);
  const sessionListProps = {
    chapters,
    teachers,
    onGoTo,
    onStartSession,
    stats,
    myLearningAssessmentPages: selectedTab === 0 ? learningAssessmentPages : finishedLearningAssessmentPages
  };
  return /* @__PURE__ */ jsxs52("div", { className: src_internals_components_learningAssessment_student_home_default.container, children: [
    /* @__PURE__ */ jsxs52("div", { className: src_internals_components_learningAssessment_student_home_default.header, children: [
      /* @__PURE__ */ jsx69("h2", { className: src_internals_components_learningAssessment_student_home_default.h2, children: /* @__PURE__ */ jsx69(Wavy3, { waveColor: "var(--premium-50-color)", children: "\xC9valuations" }) }),
      /* @__PURE__ */ jsxs52("div", { className: src_internals_components_learningAssessment_student_home_default.stylePictureProfileContainer, children: [
        /* @__PURE__ */ jsx69(
          "img",
          {
            className: src_internals_components_learningAssessment_student_home_default.png,
            style: { "--s-bottom": "initial", "--s-left": "300px", "--s-top": "16px" },
            src: "/assets/img/learningAssessment/bubble.webp"
          }
        ),
        /* @__PURE__ */ jsx69(
          "img",
          {
            className: src_internals_components_learningAssessment_student_home_default.png,
            style: { "--s-bottom": "72px", "--s-left": "-100px", "--s-top": "initial" },
            src: "/assets/img/learningAssessment/triangle.webp"
          }
        ),
        /* @__PURE__ */ jsx69("div", { className: src_internals_components_learningAssessment_student_home_default.svgContainer, children: /* @__PURE__ */ jsx69("img", { src: "/assets/img/learningAssessment/profile_circle.svg" }) }),
        /* @__PURE__ */ jsx69("img", { className: src_internals_components_learningAssessment_student_home_default.stylePictureProfileImg, src: "/assets/img/learningAssessment/picture_profil.webp" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs52(StyledContainerLayout, { className: src_internals_components_learningAssessment_student_home_default.layout, children: [
      /* @__PURE__ */ jsxs52(Tabs4, { className: src_internals_components_learningAssessment_student_home_default.tabs, value: selectedTab, onChange: setSelectedTab, children: [
        /* @__PURE__ */ jsx69(Tab4, { className: src_internals_components_learningAssessment_student_home_default.tab, children: "\xC0 faire" }),
        /* @__PURE__ */ jsx69(Tab4, { className: src_internals_components_learningAssessment_student_home_default.tab, children: handlePlural("Termin\xE9e", _64.size(finishedLearningAssessmentPages)) })
      ] }),
      /* @__PURE__ */ jsxs52(Fragment19, { children: [
        selectedTab === 0 && /* @__PURE__ */ jsx69(sessionList_default, { ...sessionListProps }),
        selectedTab === 1 && /* @__PURE__ */ jsx69(sessionList_default, { ...sessionListProps, areFinished: true })
      ] })
    ] })
  ] });
};
var home_default = Home;

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_student_index.module.css
var src_internals_components_learningAssessment_student_index_default = { "viewerContainer": "sk-VpU8yG-viewerContainer", "container": "sk-VpU8yG-container" };

// src/internals/components/learningAssessment/student/index.jsx
import { jsx as jsx70, jsxs as jsxs53 } from "react/jsx-runtime";
var StudentLearningAssessment = ({
  myLearningAssessmentPages,
  finishedLearningAssessmentPages,
  learningAssessmentPages,
  viewerElement,
  chapters,
  chapter,
  teachers,
  currentStep,
  onGoTo,
  onGoBack,
  queryParams,
  stats
}) => {
  const [isShownExitModal, setIsShownExitModal] = useState28(false);
  const chapterWithSettings = _65.find({ id: chapter == null ? void 0 : chapter.id }, chapters);
  const currentSession = _65.find({ slug: queryParams == null ? void 0 : queryParams.pageSlug }, learningAssessmentPages);
  const isCurrentSessionFinished = _65.every(({ responses }) => !_65.isEmpty(responses), currentSession == null ? void 0 : currentSession.children);
  return /* @__PURE__ */ jsxs53("div", { className: src_internals_components_learningAssessment_student_index_default.container, children: [
    isShownExitModal && /* @__PURE__ */ jsx70(exitSessionModal_default, { onGoBack, close: () => setIsShownExitModal(false) }),
    currentStep === LEARNING_ASSESSMENT_STEPS.DEFAULT && /* @__PURE__ */ jsx70(
      home_default,
      {
        myLearningAssessmentPages,
        chapters,
        finishedLearningAssessmentPages,
        learningAssessmentPages,
        onGoTo,
        stats,
        teachers
      }
    ),
    currentStep === LEARNING_ASSESSMENT_STEPS.START_SESSION && /* @__PURE__ */ jsxs53("div", { className: src_internals_components_learningAssessment_student_index_default.viewerContainer, children: [
      /* @__PURE__ */ jsx70(
        LayoutNavbar,
        {
          onGoBack: () => isCurrentSessionFinished ? onGoBack() : setIsShownExitModal(true),
          chapter: chapterWithSettings
        }
      ),
      viewerElement
    ] })
  ] });
};
var student_default = StudentLearningAssessment;

// src/internals/components/learningAssessment/teacher/index.jsx
import _79 from "lodash/fp.js";
import { useCallback as useCallback30, useState as useState34 } from "react";

// src/internals/components/learningAssessment/teacher/confirmModal.jsx
import _66 from "lodash/fp.js";
import { useState as useState29 } from "react";
import { Button as Button29, Icon as Icon18, Modal as Modal9 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_confirmModal.module.css
var src_internals_components_learningAssessment_teacher_confirmModal_default = { "img": "sk-WGiKha-img", "group": "sk-WGiKha-group", "iconBackground": "sk-WGiKha-iconBackground", "notion": "sk-WGiKha-notion", "commonTitle": "sk-WGiKha-commonTitle", "modalContent": "sk-WGiKha-modalContent", "groups": "sk-WGiKha-groups", "infos": "sk-WGiKha-infos", "icon": "sk-WGiKha-icon", "commonSpan": "sk-WGiKha-commonSpan", "title": "sk-WGiKha-title", "buttonContainer": "sk-WGiKha-buttonContainer" };

// src/internals/components/learningAssessment/teacher/confirmModal.jsx
import { jsx as jsx71, jsxs as jsxs54 } from "react/jsx-runtime";
var Group = ({ name, students }) => {
  const totalStudents = _66.size(students);
  return /* @__PURE__ */ jsxs54("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.group, children: [
    /* @__PURE__ */ jsx71("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.iconBackground, children: /* @__PURE__ */ jsx71(Icon18, { className: src_internals_components_learningAssessment_teacher_confirmModal_default.icon, width: 30, height: 30, name: "groupfilled", color: "var(--white-color)" }) }),
    /* @__PURE__ */ jsxs54("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.infos, children: [
      /* @__PURE__ */ jsx71("h3", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.commonTitle, children: name }),
      /* @__PURE__ */ jsxs54("span", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.commonSpan, children: [
        totalStudents,
        " ",
        handlePlural("\xE9l\xE8ve", totalStudents)
      ] })
    ] })
  ] });
};
var ConfirmModal = ({ close, groups, chapter, selectedExercises, onGotoNextStep }) => {
  const [node, setNode] = useState29(null);
  const hasOverflow = (node == null ? void 0 : node.scrollHeight) > (node == null ? void 0 : node.clientHeight);
  return /* @__PURE__ */ jsx71(Modal9, { closeModal: close, title: "R\xE9capitulatif", children: /* @__PURE__ */ jsxs54("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.modalContent, children: [
    /* @__PURE__ */ jsx71("h3", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.title, children: "Notion \xE0 \xE9valuer" }),
    /* @__PURE__ */ jsxs54("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.notion, children: [
      /* @__PURE__ */ jsx71(
        "img",
        {
          className: src_internals_components_learningAssessment_teacher_confirmModal_default.img,
          style: { "--s-backgroundcolor": chapter == null ? void 0 : chapter.backgroundColor },
          src: chapter == null ? void 0 : chapter.img
        }
      ),
      /* @__PURE__ */ jsxs54("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.infos, children: [
        /* @__PURE__ */ jsxs54("h3", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.commonTitle, children: [
          " ",
          chapter == null ? void 0 : chapter.title,
          " "
        ] }),
        /* @__PURE__ */ jsxs54("span", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.commonSpan, children: [
          _66.size(selectedExercises),
          " ",
          handlePlural("question", selectedExercises)
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx71("h3", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.title, children: "Pour qui ?" }),
    /* @__PURE__ */ jsx71("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.groups, "data-hasoverflow": +hasOverflow, ref: setNode, children: _66.map(
      (group) => /* @__PURE__ */ jsx71(Group, { name: group == null ? void 0 : group.name, students: group == null ? void 0 : group.students }, group == null ? void 0 : group.id),
      groups
    ) }),
    /* @__PURE__ */ jsx71("div", { className: src_internals_components_learningAssessment_teacher_confirmModal_default.buttonContainer, children: /* @__PURE__ */ jsx71(Button29, { icon: "paperplane", onClick: onGotoNextStep, children: "Envoyer" }) })
  ] }) });
};
var confirmModal_default = ConfirmModal;

// src/internals/components/learningAssessment/teacher/exercises/index.jsx
import _67 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_exercises_index.module.css
var src_internals_components_learningAssessment_teacher_exercises_index_default = { "container": "sk-f64ikG-container", "viewerContainer": "sk-f64ikG-viewerContainer" };

// src/internals/components/learningAssessment/teacher/exercises/index.jsx
import { jsx as jsx72, jsxs as jsxs55 } from "react/jsx-runtime";
var SelectExercises = ({ currentStep, onGoBack, queryParams, onGoToNextStep, viewerElement, selectedExercises }) => {
  const isNextButtonDisabled = _67.size(selectedExercises) === 0;
  return /* @__PURE__ */ jsxs55("div", { className: src_internals_components_learningAssessment_teacher_exercises_index_default.container, style: { "--s-step-navbar-height": `${STEP_NAVBAR_HEIGHT}px` }, children: [
    /* @__PURE__ */ jsx72(
      StepNavbar,
      {
        onGoToNextStep: () => onGoToNextStep({ pageSlug: queryParams == null ? void 0 : queryParams.pageSlug, chapterId: queryParams == null ? void 0 : queryParams.chapterId }),
        isNextButtonDisabled,
        currentStep,
        onGoBack: () => onGoBack({ chapterId: queryParams == null ? void 0 : queryParams.chapterId })
      }
    ),
    /* @__PURE__ */ jsx72("div", { className: src_internals_components_learningAssessment_teacher_exercises_index_default.viewerContainer, children: viewerElement })
  ] });
};
var exercises_default = SelectExercises;

// src/internals/components/learningAssessment/teacher/groups/index.jsx
import _68 from "lodash/fp.js";
import { CheckBox as CheckBox2, Icon as Icon19 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_groups_index.module.css
var src_internals_components_learningAssessment_teacher_groups_index_default = { "groupStudents": "sk-6vW4OG-groupStudents", "title": "sk-6vW4OG-title", "group": "sk-6vW4OG-group", "groupName": "sk-6vW4OG-groupName", "groupsContainer": "sk-6vW4OG-groupsContainer", "icon": "sk-6vW4OG-icon", "checkbox": "sk-6vW4OG-checkbox", "layout": "sk-6vW4OG-layout", "iconBackground": "sk-6vW4OG-iconBackground" };

// src/internals/components/learningAssessment/teacher/groups/index.jsx
import { Fragment as Fragment20, jsx as jsx73, jsxs as jsxs56 } from "react/jsx-runtime";
var Group2 = ({ group, selectedGroups, setSelectedGroups }) => {
  const students = group == null ? void 0 : group.students;
  const isGroupSelected = _68.includes(group == null ? void 0 : group.id, _68.map("id", selectedGroups));
  const onChange = () => setSelectedGroups((old) => {
    const isSelected = _68.includes(group == null ? void 0 : group.id, _68.map("id", old));
    return isSelected ? _68.reject({ id: group == null ? void 0 : group.id }, old) : _68.concat(group, old);
  });
  return /* @__PURE__ */ jsxs56("div", { className: src_internals_components_learningAssessment_teacher_groups_index_default.group, "data-isselected": +isGroupSelected, children: [
    /* @__PURE__ */ jsx73(CheckBox2, { className: src_internals_components_learningAssessment_teacher_groups_index_default.checkbox, state: "success", onChange }),
    /* @__PURE__ */ jsx73("div", { className: src_internals_components_learningAssessment_teacher_groups_index_default.iconBackground, children: /* @__PURE__ */ jsx73(Icon19, { className: src_internals_components_learningAssessment_teacher_groups_index_default.icon, name: "groupfilled", color: "var(--white-color)" }) }),
    /* @__PURE__ */ jsxs56("h3", { className: src_internals_components_learningAssessment_teacher_groups_index_default.groupName, children: [
      " ",
      group == null ? void 0 : group.name,
      " "
    ] }),
    /* @__PURE__ */ jsxs56("span", { className: src_internals_components_learningAssessment_teacher_groups_index_default.groupStudents, children: [
      _68.size(students),
      " ",
      handlePlural("\xE9l\xE8ve", students)
    ] })
  ] });
};
var SelectGroups = ({
  groups,
  currentStep,
  onGoBack,
  queryParams,
  selectedGroups,
  setSelectedGroups,
  setSelectedExercises,
  openConfirModal
}) => {
  const goBack = () => {
    setSelectedGroups([]);
    setSelectedExercises([]);
    onGoBack({ chapterId: queryParams == null ? void 0 : queryParams.chapterId, pageSlug: queryParams == null ? void 0 : queryParams.pageSlug });
  };
  return /* @__PURE__ */ jsxs56(Fragment20, { children: [
    /* @__PURE__ */ jsx73(
      StepNavbar,
      {
        onGoToNextStep: openConfirModal,
        isNextButtonDisabled: _68.isEmpty(selectedGroups),
        currentStep,
        onGoBack: goBack
      }
    ),
    /* @__PURE__ */ jsxs56(StyledContainerLayout, { className: src_internals_components_learningAssessment_teacher_groups_index_default.layout, children: [
      /* @__PURE__ */ jsx73("h3", { className: src_internals_components_learningAssessment_teacher_groups_index_default.title, children: "\xC0 quelle(s) classe(s) souhaitez-vous envoyer la session ?" }),
      /* @__PURE__ */ jsx73("div", { className: src_internals_components_learningAssessment_teacher_groups_index_default.groupsContainer, children: _68.map(
        (group) => /* @__PURE__ */ jsx73(
          Group2,
          {
            group,
            selectedGroups,
            setSelectedGroups
          },
          group == null ? void 0 : group.id
        ),
        groups
      ) })
    ] })
  ] });
};
var groups_default = SelectGroups;

// src/internals/components/learningAssessment/teacher/home/index.jsx
import _74 from "lodash/fp.js";
import { useEffect as useEffect14, useState as useState32 } from "react";

// src/internals/components/learningAssessment/teacher/firstConnectionModal.jsx
import { useState as useState30 } from "react";
import { Button as Button30, Modal as Modal10 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_firstConnectionModal.module.css
var src_internals_components_learningAssessment_teacher_firstConnectionModal_default = { "container": "sk-WzmMeG-container", "img": "sk-WzmMeG-img", "content": "sk-WzmMeG-content", "stepBarContainer": "sk-WzmMeG-stepBarContainer", "title": "sk-WzmMeG-title", "modal": "sk-WzmMeG-modal", "stepBar": "sk-WzmMeG-stepBar" };

// src/internals/components/learningAssessment/teacher/firstConnectionModal.jsx
import { jsx as jsx74, jsxs as jsxs57 } from "react/jsx-runtime";
var DATA_STEP = [
  {
    title: "V\xE9rifiez les connaissances de vos \xE9l\xE8ves",
    content: "Cr\xE9ez des \xE9valuations diagnostiques pour d\xE9terminer le niveau de vos \xE9l\xE8ves et ajuster votre cours.",
    img: "/assets/img/learningAssessment/step1.webp"
  },
  {
    title: "Testez les progr\xE8s de vos \xE9l\xE8ves",
    content: "Testez vos \xE9l\xE8ves avec des quiz simples et personnalisables.",
    img: "/assets/img/learningAssessment/step2.webp"
  },
  {
    title: "Anticipez les difficult\xE9s de vos \xE9l\xE8ves",
    content: "Gr\xE2ce aux r\xE9sultats des quiz, vous pouvez cibler les difficult\xE9s de vos \xE9l\xE8ves et adapter votre cours.",
    img: "/assets/img/learningAssessment/step3.webp"
  }
];
var FirstConnectionModal = ({ close }) => {
  const [step, setStep] = useState30(0);
  const currentStepData = DATA_STEP[step];
  const next = () => {
    if (step > 1) {
      close();
      return;
    }
    setStep((oldStep) => oldStep + 1);
  };
  return /* @__PURE__ */ jsxs57(Modal10, { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.modal, closeModal: close, withCloseButton: false, children: [
    /* @__PURE__ */ jsx74("img", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.img, src: currentStepData.img }),
    /* @__PURE__ */ jsxs57("div", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.container, children: [
      /* @__PURE__ */ jsxs57("div", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.stepBarContainer, children: [
        /* @__PURE__ */ jsx74("div", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.stepBar, "data-drawer-open": +(step === 0) }),
        /* @__PURE__ */ jsx74("div", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.stepBar, "data-drawer-open": +(step === 1) }),
        /* @__PURE__ */ jsx74("div", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.stepBar, "data-drawer-open": +(step === 2) })
      ] }),
      /* @__PURE__ */ jsx74("div", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.title, children: currentStepData.title }),
      /* @__PURE__ */ jsx74("img", { src: "/assets/img/learningAssessment/Union.svg" }),
      /* @__PURE__ */ jsx74("div", { className: src_internals_components_learningAssessment_teacher_firstConnectionModal_default.content, children: currentStepData.content }),
      /* @__PURE__ */ jsx74(Button30, { icon: "arrowright", iconPosition: "right", onClick: next, children: "Suivant" })
    ] })
  ] });
};
var firstConnectionModal_default = FirstConnectionModal;

// src/internals/components/learningAssessment/teacher/home/emptyState.jsx
import _69 from "lodash/fp.js";
import { Button as Button31 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_home_emptyState.module.css
var src_internals_components_learningAssessment_teacher_home_emptyState_default = { "layout": "sk-Ys6BUW-layout", "container": "sk-Ys6BUW-container", "span": "sk-Ys6BUW-span", "title": "sk-Ys6BUW-title" };

// src/internals/components/learningAssessment/teacher/home/emptyState.jsx
import { jsx as jsx75, jsxs as jsxs58 } from "react/jsx-runtime";
var EmptyState4 = ({ onGoToNextStep, openManageGroupModal, groups }) => {
  const onClick = () => _69.isEmpty(groups) ? openManageGroupModal() : onGoToNextStep();
  return /* @__PURE__ */ jsx75(StyledContainerLayout, { className: src_internals_components_learningAssessment_teacher_home_emptyState_default.layout, children: /* @__PURE__ */ jsxs58("div", { className: src_internals_components_learningAssessment_teacher_home_emptyState_default.container, children: [
    /* @__PURE__ */ jsx75("h2", { className: src_internals_components_learningAssessment_teacher_home_emptyState_default.title, children: "Vos sessions cr\xE9\xE9es appara\xEEtront ici" }),
    /* @__PURE__ */ jsx75("span", { className: src_internals_components_learningAssessment_teacher_home_emptyState_default.span, children: "Cr\xE9er une session avec vos \xE9l\xE8ves pour suivre leurs acquis" }),
    /* @__PURE__ */ jsx75(Button31, { icon: "plus", onClick, children: "Cr\xE9er une session" })
  ] }) });
};
var emptyState_default4 = EmptyState4;

// src/internals/components/learningAssessment/teacher/home/header.jsx
import _70 from "lodash/fp.js";
import { useCallback as useCallback29, useMemo as useMemo16 } from "react";
import { Carousel, Wavy as Wavy4 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_home_header.module.css
var src_internals_components_learningAssessment_teacher_home_header_default = { "contentCard": "sk-D_GWZG-contentCard", "topCard": "sk-D_GWZG-topCard", "png": "sk-D_GWZG-png", "span": "sk-D_GWZG-span", "card": "sk-D_GWZG-card", "container": "sk-D_GWZG-container", "left": "sk-D_GWZG-left", "right": "sk-D_GWZG-right", "label": "sk-D_GWZG-label" };

// src/internals/components/learningAssessment/teacher/home/header.jsx
import { jsx as jsx76, jsxs as jsxs59 } from "react/jsx-runtime";
var NotionsLabel = ({ notions }) => /* @__PURE__ */ jsxs59("div", { className: src_internals_components_learningAssessment_teacher_home_header_default.label, children: [
  _70.size(notions),
  " ",
  handlePlural("notion", _70.size(notions))
] });
var SimpleCarouselItem = ({ numShow, title, notions, backgroundColor, img, onClick } = {}) => {
  return /* @__PURE__ */ jsxs59("div", { className: src_internals_components_learningAssessment_teacher_home_header_default.card, style: { "--s-backgroundcolor": backgroundColor }, onClick, children: [
    /* @__PURE__ */ jsxs59("div", { className: src_internals_components_learningAssessment_teacher_home_header_default.topCard, children: [
      _70.replace(/Chapitre (\d+)/, "Ch.$1", numShow),
      /* @__PURE__ */ jsx76(NotionsLabel, { notions })
    ] }),
    /* @__PURE__ */ jsx76("span", { className: src_internals_components_learningAssessment_teacher_home_header_default.contentCard, children: title }),
    /* @__PURE__ */ jsx76(StyledChapterImg, { backgroundcolor: backgroundColor, src: img })
  ] });
};
var Header4 = ({ chapters, revisionPages, openManageGroupModal, groups, onGoToNextStep }) => {
  const onCarouselItemClick = useCallback29(
    (chapterId) => _70.isEmpty(groups) ? openManageGroupModal() : onGoToNextStep({ chapterId }),
    [groups, onGoToNextStep, openManageGroupModal]
  );
  const chaptersWithNotions = useMemo16(
    () => _70.map(
      (chapter) => ({
        ...chapter,
        notions: _70.filter({ chapter: chapter == null ? void 0 : chapter.id }, revisionPages),
        onClick: () => onCarouselItemClick(chapter == null ? void 0 : chapter.id)
      }),
      chapters
    ),
    [chapters, revisionPages, onCarouselItemClick]
  );
  return /* @__PURE__ */ jsxs59("div", { className: src_internals_components_learningAssessment_teacher_home_header_default.container, children: [
    /* @__PURE__ */ jsxs59("div", { className: src_internals_components_learningAssessment_teacher_home_header_default.left, children: [
      /* @__PURE__ */ jsxs59("h2", { children: [
        "Quelles ",
        /* @__PURE__ */ jsx76(Wavy4, { waveColor: "var(--premium-50-color)", children: "notions" }),
        " souhaitez-vous interroger ?"
      ] }),
      /* @__PURE__ */ jsx76("span", { className: src_internals_components_learningAssessment_teacher_home_header_default.span, children: "\xC9valuez les acquis de vos \xE9l\xE8ves" })
    ] }),
    /* @__PURE__ */ jsxs59("div", { className: src_internals_components_learningAssessment_teacher_home_header_default.right, children: [
      /* @__PURE__ */ jsx76(
        "img",
        {
          className: src_internals_components_learningAssessment_teacher_home_header_default.png,
          style: { "--s-bottom": "initial", "--s-left": "455px", "--s-top": "16px" },
          src: "/assets/img/learningAssessment/bubble.webp"
        }
      ),
      /* @__PURE__ */ jsx76(
        "img",
        {
          className: src_internals_components_learningAssessment_teacher_home_header_default.png,
          style: { "--s-bottom": "40px", "--s-left": "217px", "--s-top": "initial" },
          src: "/assets/img/learningAssessment/triangle.webp"
        }
      ),
      /* @__PURE__ */ jsx76(Carousel, { items: chaptersWithNotions, ComponentItem: SimpleCarouselItem, width: "100%" })
    ] })
  ] });
};
var header_default3 = Header4;

// src/internals/components/learningAssessment/teacher/home/sessionList.jsx
import _73 from "lodash/fp.js";
import { useMemo as useMemo17 } from "react";
import { Icon as Icon20 } from "@lls/lls-kit";

// src/internals/utils/learningAssessment.ts
import _71 from "lodash/fp.js";
var GOOD_LEVEL_RATIO = 0.7;
var BAD_LEVEL_RATIO = 0.3;
var getSessionPagesForEachGroup = (pages) => _71.flow(
  _71.map((page) => {
    const sharedGroupIds = page == null ? void 0 : page.sharedGroups;
    return _71.map(
      (sharedGroupId) => ({
        ...page,
        groupId: sharedGroupId
      }),
      sharedGroupIds
    );
  }),
  _71.flatten
)(pages);
var getGoodAnswersRatio = ({ stats, exercisesCount }) => {
  return _71.flow(_71.filter({ userWrongResponseCount: 0 }), _71.size, (count) => count / exercisesCount)(stats);
};
var getGroupedStudentsByLevel = ({
  group,
  stats,
  students,
  page
}) => {
  const studentByIds = _71.keyBy("id", students);
  const exercisesCount = _71.size(page == null ? void 0 : page.children);
  const groupStudentIds = group == null ? void 0 : group.students;
  const groupStudents = _71.map((studentId) => _71.get(studentId, studentByIds), groupStudentIds);
  const totalExercises = _71.size(page == null ? void 0 : page.children);
  const [answeredStudents, otherStudents] = _71.partition(
    (student) => _71.flow(
      //@ts-ignore
      _71.get(student == null ? void 0 : student.id),
      _71.filter({ pageId: page == null ? void 0 : page.id }),
      (responses) => _71.size(responses) === totalExercises
    )(stats),
    groupStudents
  );
  const studentsWithStats = _71.map((student) => {
    const goodAnswersRatio = _71.flow(
      //@ts-ignore
      _71.get(student == null ? void 0 : student.id),
      _71.filter({ pageId: page == null ? void 0 : page.id }),
      _71.map(_71.pick(["userWrongResponseCount"])),
      (filteredStats) => getGoodAnswersRatio({ stats: filteredStats, exercisesCount })
    )(stats);
    return {
      ...student,
      ratio: goodAnswersRatio
    };
  }, answeredStudents);
  const weakStudents = _71.filter((student) => (student == null ? void 0 : student.ratio) <= BAD_LEVEL_RATIO, studentsWithStats);
  const goodStudents = _71.filter((student) => (student == null ? void 0 : student.ratio) >= GOOD_LEVEL_RATIO, studentsWithStats);
  const mediumStudents = _71.filter(
    (student) => (student == null ? void 0 : student.ratio) > BAD_LEVEL_RATIO && (student == null ? void 0 : student.ratio) < GOOD_LEVEL_RATIO,
    studentsWithStats
  );
  return {
    veryWeakStudents: otherStudents,
    weakStudents,
    mediumStudents,
    goodStudents
  };
};
var shoulHideMainNavbar = (step) => _71.includes(step, [
  LEARNING_ASSESSMENT_STEPS.SELECT_NOTION,
  LEARNING_ASSESSMENT_STEPS.START_SESSION,
  LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES,
  LEARNING_ASSESSMENT_STEPS.START_SESSION,
  LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS
]);

// src/internals/components/learningAssessment/teacher/home/progressStudentBar.jsx
import _72 from "lodash/fp.js";
import { useState as useState31 } from "react";
import { Tooltip as Tooltip8 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_home_progressStudentBar.module.css
var src_internals_components_learningAssessment_teacher_home_progressStudentBar_default = { "styleContentToolTip": "sk-5T5wOa-styleContentToolTip", "progressStudentsBar": "sk-5T5wOa-progressStudentsBar", "progressSegment": "sk-5T5wOa-progressSegment" };

// src/internals/components/learningAssessment/teacher/home/progressStudentBar.jsx
import { jsx as jsx77, jsxs as jsxs60 } from "react/jsx-runtime";
var ProgressionStudentBar = ({ veryWeakStudents, weakStudents, mediumStudents, goodStudents }) => {
  var _a;
  const [node, setNode] = useState31(null);
  const parentWidth = (_a = node == null ? void 0 : node.getBoundingClientRect()) == null ? void 0 : _a.width;
  const veryWeakStudentsCount = _72.size(veryWeakStudents);
  const weakStudentsCount = _72.size(weakStudents);
  const mediumStudentsCount = _72.size(mediumStudents);
  const goodStudentsCount = _72.size(goodStudents);
  const allCounts = [veryWeakStudentsCount, weakStudentsCount, mediumStudentsCount, goodStudentsCount];
  const total = _72.sum(allCounts) || 1;
  const areNotAnswered = _72.every(_72.isEqual(0), allCounts);
  const goodStudentsWidthSegment = goodStudentsCount / total * parentWidth * 100 / parentWidth;
  const veryWeakStudentsWidthSegment = areNotAnswered ? 100 : veryWeakStudentsCount / total * parentWidth * 100 / parentWidth;
  const weakStudentsWidthSegment = weakStudentsCount / total * parentWidth * 100 / parentWidth;
  const mediumStudentsWidthSegment = mediumStudentsCount / total * parentWidth * 100 / parentWidth;
  const isOnlyOneChildComponent = _72.flow(_72.compact, _72.size, (size) => size <= 1)(allCounts);
  return /* @__PURE__ */ jsxs60("div", { className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.progressStudentsBar, ref: setNode, children: [
    goodStudentsCount > 0 && /* @__PURE__ */ jsx77(
      "div",
      {
        className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.progressSegment,
        style: { "--s-backgroundcolor": "var(--tertiary-40-color)", "--s-width": `${goodStudentsWidthSegment}%` },
        "data-onechild": +isOnlyOneChildComponent,
        children: /* @__PURE__ */ jsx77(
          Tooltip8,
          {
            content: `${goodStudentsCount} ${handlePlural("\xE9l\xE8ve", goodStudentsCount)} ${goodStudentsCount > 1 ? "ont" : "a"} acquis la notion`,
            withTail: true,
            children: /* @__PURE__ */ jsx77("div", { className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.styleContentToolTip })
          }
        )
      }
    ),
    mediumStudentsCount > 0 && /* @__PURE__ */ jsx77(
      "div",
      {
        className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.progressSegment,
        style: { "--s-backgroundcolor": "var(--secondary-40-color)", "--s-width": `${mediumStudentsWidthSegment}%` },
        "data-onechild": +isOnlyOneChildComponent,
        children: /* @__PURE__ */ jsx77(
          Tooltip8,
          {
            content: `${mediumStudentsCount} ${handlePlural("\xE9l\xE8ve", mediumStudentsCount)} en cours d'acquisition`,
            withTail: true,
            children: /* @__PURE__ */ jsx77("div", { className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.styleContentToolTip })
          }
        )
      }
    ),
    weakStudentsCount > 0 && /* @__PURE__ */ jsx77(
      "div",
      {
        className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.progressSegment,
        style: { "--s-backgroundcolor": "var(--error-40-color)", "--s-width": `${weakStudentsWidthSegment}%` },
        "data-onechild": +isOnlyOneChildComponent,
        children: /* @__PURE__ */ jsx77(
          Tooltip8,
          {
            content: `${weakStudentsCount} ${handlePlural("\xE9l\xE8ve", weakStudentsCount)}  ${weakStudentsCount > 1 ? "doivent" : "doit"} revoir la notion`,
            withTail: true,
            children: /* @__PURE__ */ jsx77("div", { className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.styleContentToolTip })
          }
        )
      }
    ),
    (veryWeakStudentsCount > 0 || total === 1) && /* @__PURE__ */ jsx77(
      "div",
      {
        className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.progressSegment,
        style: { "--s-backgroundcolor": "var(--gray-20-color)", "--s-width": `${veryWeakStudentsWidthSegment}%` },
        "data-onechild": +isOnlyOneChildComponent,
        children: /* @__PURE__ */ jsx77(
          Tooltip8,
          {
            content: areNotAnswered ? "Aucun \xE9l\xE8ve n'a fait la notion" : `${veryWeakStudentsCount} ${handlePlural("\xE9l\xE8ve", veryWeakStudentsCount)} n'${veryWeakStudentsCount > 1 ? "ont" : "a"} pas fait la notion`,
            withTail: true,
            children: /* @__PURE__ */ jsx77("div", { className: src_internals_components_learningAssessment_teacher_home_progressStudentBar_default.styleContentToolTip })
          }
        )
      }
    )
  ] });
};
var progressStudentBar_default = ProgressionStudentBar;

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_home_sessionList.module.css
var src_internals_components_learningAssessment_teacher_home_sessionList_default = { "title": "sk-yELtva-title", "exercises": "sk-yELtva-exercises", "icon": "sk-yELtva-icon", "infos": "sk-yELtva-infos", "layout": "sk-yELtva-layout" };

// src/internals/components/learningAssessment/teacher/home/sessionList.jsx
import { jsx as jsx78, jsxs as jsxs61 } from "react/jsx-runtime";
var map3 = _73.map.convert({ cap: false });
var SessionCard2 = ({ chapter, group, students, page, stats, onGoTo }) => {
  const { veryWeakStudents, weakStudents, mediumStudents, goodStudents } = getGroupedStudentsByLevel({
    group,
    stats,
    students,
    page
  });
  const onClick = () => {
    onGoTo(LEARNING_ASSESSMENT_STEPS.FOLLOW_GROUP_PROGRESSION, { groupId: group == null ? void 0 : group.id, pageSlug: page == null ? void 0 : page.slug });
  };
  return /* @__PURE__ */ jsxs61(StyledSessionCard, { onClick, children: [
    /* @__PURE__ */ jsx78(StyledSessionCardChapterImg, { src: chapter == null ? void 0 : chapter.img, style: { "--s-backgroundcolor": "var(--gray-90-color)" } }),
    /* @__PURE__ */ jsxs61("div", { className: src_internals_components_learningAssessment_teacher_home_sessionList_default.infos, children: [
      /* @__PURE__ */ jsx78(StyledSessionCardTitle, { children: chapter == null ? void 0 : chapter.title }),
      /* @__PURE__ */ jsx78(StyledSessionCardSubTitle, { children: group == null ? void 0 : group.name })
    ] }),
    /* @__PURE__ */ jsx78(
      progressStudentBar_default,
      {
        veryWeakStudents,
        weakStudents,
        mediumStudents,
        goodStudents,
        page
      }
    ),
    /* @__PURE__ */ jsxs61("div", { className: src_internals_components_learningAssessment_teacher_home_sessionList_default.exercises, children: [
      /* @__PURE__ */ jsx78(Icon20, { className: src_internals_components_learningAssessment_teacher_home_sessionList_default.icon, name: "questionmarkcircle", color: "var(--primary-40-color)" }),
      _73.size(page == null ? void 0 : page.children),
      " ",
      handlePlural("question", page == null ? void 0 : page.children)
    ] })
  ] });
};
var SessionList2 = ({ chapters, myLearningAssessmentPages, groups, students, stats, onGoTo }) => {
  const pages = useMemo17(
    () => _73.flow(
      getSessionPagesForEachGroup,
      _73.map((page) => ({
        ...page,
        chapter: _73.find({ id: page == null ? void 0 : page.chapter }, chapters),
        group: _73.find({ id: page == null ? void 0 : page.groupId }, groups)
      })),
      _73.sortBy("chapter.number")
    )(myLearningAssessmentPages),
    [chapters, myLearningAssessmentPages, groups]
  );
  return /* @__PURE__ */ jsxs61(StyledContainerLayout, { className: src_internals_components_learningAssessment_teacher_home_sessionList_default.layout, children: [
    /* @__PURE__ */ jsxs61("h2", { className: src_internals_components_learningAssessment_teacher_home_sessionList_default.title, children: [
      handlePlural("Derni\xE8re", pages),
      " ",
      handlePlural("session", pages),
      " ",
      handlePlural("partag\xE9e", pages)
    ] }),
    /* @__PURE__ */ jsx78(StyledSessionsContainer, { children: map3(
      (page, i) => /* @__PURE__ */ jsx78(
        SessionCard2,
        {
          onGoTo,
          chapter: page == null ? void 0 : page.chapter,
          group: page == null ? void 0 : page.group,
          students,
          stats,
          page
        },
        i
      ),
      pages
    ) })
  ] });
};
var sessionList_default2 = SessionList2;

// src/internals/components/learningAssessment/teacher/home/index.jsx
import { Fragment as Fragment21, jsx as jsx79, jsxs as jsxs62 } from "react/jsx-runtime";
var Home2 = ({
  chapters,
  revisionPages,
  myLearningAssessmentPages,
  openManageGroupModal,
  groups,
  onManageGroupClick,
  onGoTo,
  onGoToNextStep,
  students,
  stats,
  isFirstConnection = false,
  setHasSeenLearningAssessment
}) => {
  const [showFirstConnectionModal, setShowFirstConnectionModal] = useState32(false);
  const onClose = () => {
    setShowFirstConnectionModal(false);
    setHasSeenLearningAssessment(true);
  };
  useEffect14(() => {
    isFirstConnection && setShowFirstConnectionModal(isFirstConnection);
  }, [isFirstConnection]);
  return /* @__PURE__ */ jsxs62(Fragment21, { children: [
    /* @__PURE__ */ jsx79(
      header_default3,
      {
        revisionPages,
        chapters,
        onGoToNextStep,
        openManageGroupModal,
        groups
      }
    ),
    _74.isEmpty(myLearningAssessmentPages) ? /* @__PURE__ */ jsx79(
      emptyState_default4,
      {
        openManageGroupModal,
        groups,
        onManageGroupClick,
        onGoToNextStep
      }
    ) : /* @__PURE__ */ jsx79(
      sessionList_default2,
      {
        chapters,
        myLearningAssessmentPages,
        groups,
        students,
        stats,
        onGoTo
      }
    ),
    showFirstConnectionModal && /* @__PURE__ */ jsx79(firstConnectionModal_default, { close: onClose })
  ] });
};
var home_default2 = Home2;

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_index.module.css
var src_internals_components_learningAssessment_teacher_index_default = { "container": "sk-TNKfQW-container" };

// src/internals/components/learningAssessment/teacher/noGroupsModal.jsx
import { Button as Button32, Modal as Modal11 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_noGroupsModal.module.css
var src_internals_components_learningAssessment_teacher_noGroupsModal_default = { "modalContent": "sk-GisZZG-modalContent", "contentBottom": "sk-GisZZG-contentBottom", "button": "sk-GisZZG-button", "h3": "sk-GisZZG-h3", "modal": "sk-GisZZG-modal", "img": "sk-GisZZG-img" };

// src/internals/components/learningAssessment/teacher/noGroupsModal.jsx
import { jsx as jsx80, jsxs as jsxs63 } from "react/jsx-runtime";
var NoGroupsModal = ({ close, onManageGroupClick }) => /* @__PURE__ */ jsx80(Modal11, { className: src_internals_components_learningAssessment_teacher_noGroupsModal_default.modal, closeModal: close, withCloseButton: false, children: /* @__PURE__ */ jsxs63("div", { className: src_internals_components_learningAssessment_teacher_noGroupsModal_default.modalContent, children: [
  /* @__PURE__ */ jsx80("img", { className: src_internals_components_learningAssessment_teacher_noGroupsModal_default.img, src: "/assets/img/learningAssessment/group.webp" }),
  /* @__PURE__ */ jsxs63("div", { className: src_internals_components_learningAssessment_teacher_noGroupsModal_default.contentBottom, children: [
    /* @__PURE__ */ jsx80("h3", { className: src_internals_components_learningAssessment_teacher_noGroupsModal_default.h3, children: "Commen\xE7ons d'abord par ajouter vos classes" }),
    /* @__PURE__ */ jsx80("img", { src: "/assets/img/learningAssessment/Union.svg" }),
    /* @__PURE__ */ jsx80(Button32, { className: src_internals_components_learningAssessment_teacher_noGroupsModal_default.button, icon: "arrowright", iconPosition: "right", onClick: onManageGroupClick, children: "Cr\xE9er mes classes" })
  ] })
] }) });
var noGroupsModal_default = NoGroupsModal;

// src/internals/components/learningAssessment/teacher/notion/chapterList.jsx
import _76 from "lodash/fp.js";
import { useEffect as useEffect15, useState as useState33 } from "react";
import { Icon as Icon21 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_notion_chapterList.module.css
var src_internals_components_learningAssessment_teacher_notion_chapterList_default = { "title": "sk-rum5sG-title", "chapterItem": "sk-rum5sG-chapterItem", "chapterContent": "sk-rum5sG-chapterContent", "span": "sk-rum5sG-span", "contentLeft": "sk-rum5sG-contentLeft", "container": "sk-rum5sG-container", "img": "sk-rum5sG-img", "chapterList": "sk-rum5sG-chapterList" };

// src/internals/components/learningAssessment/teacher/notion/pageList.jsx
import _75 from "lodash/fp.js";
import { Button as Button33 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_notion_pageList.module.css
var src_internals_components_learningAssessment_teacher_notion_pageList_default = { "span": "sk-1BHeoG-span", "pageCard": "sk-1BHeoG-pageCard", "button": "sk-1BHeoG-button", "container": "sk-1BHeoG-container" };

// src/internals/components/learningAssessment/teacher/notion/pageList.jsx
import { jsx as jsx81, jsxs as jsxs64 } from "react/jsx-runtime";
var PageCard2 = ({ page, onGoToNextStep }) => {
  return /* @__PURE__ */ jsxs64(
    "div",
    {
      className: src_internals_components_learningAssessment_teacher_notion_pageList_default.pageCard,
      onClick: () => onGoToNextStep({ pageSlug: page == null ? void 0 : page.slug, chapterId: page == null ? void 0 : page.chapter }),
      children: [
        /* @__PURE__ */ jsx81("span", { className: src_internals_components_learningAssessment_teacher_notion_pageList_default.span, children: page == null ? void 0 : page.displayTitle }),
        /* @__PURE__ */ jsx81(Button33, { className: src_internals_components_learningAssessment_teacher_notion_pageList_default.button, theme: "gray", inverted: true, icon: "arrowright" })
      ]
    }
  );
};
var PageList2 = ({ pages, onGoToNextStep }) => {
  return /* @__PURE__ */ jsx81("div", { className: src_internals_components_learningAssessment_teacher_notion_pageList_default.container, children: _75.map(
    (page) => /* @__PURE__ */ jsx81(PageCard2, { onGoToNextStep, page }, page == null ? void 0 : page.id),
    pages
  ) });
};
var pageList_default2 = PageList2;

// src/internals/components/learningAssessment/teacher/notion/chapterList.jsx
import { jsx as jsx82, jsxs as jsxs65 } from "react/jsx-runtime";
var ChapterItem2 = ({
  id,
  numShow,
  title,
  pages,
  onGoToNextStep,
  setSelectedIndex,
  selectedChapterId,
  setSelectedChapterId,
  selectedIndex
}) => {
  const chapterPages = _76.filter({ chapter: id }, pages);
  const isActive = selectedChapterId ? selectedChapterId === id : selectedIndex === id;
  const onClickChapterItem = () => {
    setSelectedIndex(isActive ? null : id);
    setSelectedChapterId(null);
  };
  useEffect15(() => {
    const element = document.getElementById(`chapter-item-${selectedChapterId}`);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  }, [selectedChapterId]);
  return /* @__PURE__ */ jsxs65("div", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.chapterItem, id: `chapter-item-${id}`, children: [
    /* @__PURE__ */ jsxs65("div", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.chapterContent, onClick: onClickChapterItem, children: [
      /* @__PURE__ */ jsxs65("div", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.contentLeft, children: [
        /* @__PURE__ */ jsx82("span", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.span, children: numShow }),
        /* @__PURE__ */ jsx82("h2", { children: title })
      ] }),
      /* @__PURE__ */ jsx82(Icon21, { name: isActive ? "chevronup" : "chevrondown" })
    ] }),
    isActive && /* @__PURE__ */ jsx82(pageList_default2, { pages: chapterPages, onGoToNextStep })
  ] });
};
var ChapterList2 = ({ chapters, pages, queryParams, onGoToNextStep }) => {
  const [selectedIndex, setSelectedIndex] = useState33(null);
  const [selectedChapterId, setSelectedChapterId] = useState33(_76.parseInt(10, queryParams == null ? void 0 : queryParams.chapterId));
  return /* @__PURE__ */ jsxs65("div", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.container, children: [
    /* @__PURE__ */ jsx82("h2", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.title, children: "Quelle notion souhaitez-vous interroger ?" }),
    /* @__PURE__ */ jsx82("img", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.img, src: "/assets/img/learningAssessment/Union.svg" }),
    /* @__PURE__ */ jsx82("div", { className: src_internals_components_learningAssessment_teacher_notion_chapterList_default.chapterList, children: _76.map(
      (chapter) => /* @__PURE__ */ jsx82(
        ChapterItem2,
        {
          id: chapter == null ? void 0 : chapter.id,
          numShow: chapter == null ? void 0 : chapter.numShow,
          title: chapter == null ? void 0 : chapter.title,
          selectedIndex,
          selectedChapterId,
          setSelectedChapterId,
          setSelectedIndex,
          onGoToNextStep,
          pages
        },
        chapter == null ? void 0 : chapter.id
      ),
      chapters
    ) })
  ] });
};
var chapterList_default2 = ChapterList2;

// src/internals/components/learningAssessment/teacher/notion/index.jsx
import { Fragment as Fragment22, jsx as jsx83, jsxs as jsxs66 } from "react/jsx-runtime";
var SelectNotion = ({ currentStep, onGoBack, onGoToNextStep, queryParams, chapters, pages }) => {
  return /* @__PURE__ */ jsxs66(Fragment22, { children: [
    /* @__PURE__ */ jsx83(StepNavbar, { currentStep, onGoBack }),
    /* @__PURE__ */ jsx83(chapterList_default2, { chapters, queryParams, onGoToNextStep, pages })
  ] });
};
var notion_default = SelectNotion;

// src/internals/components/learningAssessment/teacher/showGroupProgression/index.jsx
import _78 from "lodash/fp.js";
import { useMemo as useMemo19 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_showGroupProgression_index.module.css
var src_internals_components_learningAssessment_teacher_showGroupProgression_index_default = { "answeredStudents": "sk-ZKw9Ya-answeredStudents", "chapterImg": "sk-ZKw9Ya-chapterImg", "notAnsweredStudents": "sk-ZKw9Ya-notAnsweredStudents", "container": "sk-ZKw9Ya-container", "layout": "sk-ZKw9Ya-layout" };

// src/internals/components/learningAssessment/teacher/showGroupProgression/studentListCard.jsx
import { Badge, Icon as Icon22 } from "@lls/lls-kit";
import _77 from "lodash/fp.js";
import { useMemo as useMemo18 } from "react";
import { cx as cx19 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard.module.css
var src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default = { "emptyState": "sk-Np0Zhq-emptyState", "fullName": "sk-Np0Zhq-fullName", "container": "sk-Np0Zhq-container", "title": "sk-Np0Zhq-title", "badge": "sk-Np0Zhq-badge", "right": "sk-Np0Zhq-right", "left": "sk-Np0Zhq-left", "iconBackground": "sk-Np0Zhq-iconBackground", "icon": "sk-Np0Zhq-icon", "studentItem": "sk-Np0Zhq-studentItem", "studentItemIcon": "sk-Np0Zhq-studentItemIcon", "studentListContainer": "sk-Np0Zhq-studentListContainer", "listHeader": "sk-Np0Zhq-listHeader" };

// src/internals/components/learningAssessment/teacher/showGroupProgression/studentListCard.jsx
import { Fragment as Fragment23, jsx as jsx84, jsxs as jsxs67 } from "react/jsx-runtime";
var StudentItem = ({ student, totalExercises }) => {
  const goodAnswerRatio = student == null ? void 0 : student.ratio;
  const goodAnsweredExercises = goodAnswerRatio * totalExercises;
  return /* @__PURE__ */ jsxs67("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.studentItem, children: [
    /* @__PURE__ */ jsxs67("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.left, children: [
      /* @__PURE__ */ jsx84("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.iconBackground, children: /* @__PURE__ */ jsx84(Icon22, { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.studentItemIcon, name: "personfilled", color: "var(--tertiary-40-color)" }) }),
      /* @__PURE__ */ jsx84("span", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.fullName, children: getStudentFullName(student) })
    ] }),
    /* @__PURE__ */ jsx84("span", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.right, children: !_77.isUndefined(goodAnswerRatio) && /* @__PURE__ */ jsxs67(Fragment23, { children: [
      goodAnsweredExercises,
      " / ",
      totalExercises
    ] }) })
  ] });
};
var StudentListCard = ({ listTitle, students, iconName, backgroundColor, badgeColor, page, className }) => {
  const orderedStudents = useMemo18(() => _77.sortBy(getStudentFullName, students), [students]);
  const totalExercises = _77.size(page == null ? void 0 : page.children);
  return /* @__PURE__ */ jsxs67("div", { style: { "--s-backgroundcolor": backgroundColor }, className: cx19(className, src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.container), children: [
    /* @__PURE__ */ jsxs67("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.listHeader, style: { "--s-backgroundcolor": backgroundColor }, children: [
      /* @__PURE__ */ jsxs67("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.left, children: [
        /* @__PURE__ */ jsx84(Icon22, { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.icon, name: iconName, color: "var(--white-color)" }),
        /* @__PURE__ */ jsx84("h3", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.title, children: listTitle })
      ] }),
      /* @__PURE__ */ jsx84(
        Badge,
        {
          className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.badge,
          style: { "--s-backgroundcolor": badgeColor },
          backgroundcolor: badgeColor,
          content: _77.size(students)
        }
      )
    ] }),
    /* @__PURE__ */ jsx84("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.studentListContainer, children: _77.isEmpty(orderedStudents) ? /* @__PURE__ */ jsx84("div", { className: cx19(src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.studentItem, src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.emptyState), children: "Aucun \xE9l\xE8ve dans cette cat\xE9gorie" }) : /* @__PURE__ */ jsx84(Fragment23, { children: _77.map(
      (student) => /* @__PURE__ */ jsx84(
        StudentItem,
        {
          className: src_internals_components_learningAssessment_teacher_showGroupProgression_studentListCard_default.studentItem,
          student,
          totalExercises
        },
        student == null ? void 0 : student.id
      ),
      orderedStudents
    ) }) })
  ] });
};
var studentListCard_default = StudentListCard;

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_teacher_showGroupProgression_titleSection.module.css
var src_internals_components_learningAssessment_teacher_showGroupProgression_titleSection_default = { "groupName": "sk-94Ucpa-groupName", "chapterTitle": "sk-94Ucpa-chapterTitle", "titleSection": "sk-94Ucpa-titleSection" };

// src/internals/components/learningAssessment/teacher/showGroupProgression/titleSection.jsx
import { jsx as jsx85, jsxs as jsxs68 } from "react/jsx-runtime";
var TiltleSection = ({ chapter, group }) => {
  return /* @__PURE__ */ jsxs68("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_titleSection_default.titleSection, children: [
    /* @__PURE__ */ jsx85("h2", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_titleSection_default.chapterTitle, children: chapter == null ? void 0 : chapter.title }),
    /* @__PURE__ */ jsx85("h3", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_titleSection_default.groupName, children: group == null ? void 0 : group.name })
  ] });
};
var titleSection_default = TiltleSection;

// src/internals/components/learningAssessment/teacher/showGroupProgression/index.jsx
import { jsx as jsx86, jsxs as jsxs69 } from "react/jsx-runtime";
var ShowGroupProgression = ({
  groups,
  students,
  stats,
  myLearningAssessmentPages,
  queryParams,
  chapter,
  onGoBack
}) => {
  const groupId = _78.parseInt(10, queryParams == null ? void 0 : queryParams.groupId);
  const pageSlug = queryParams == null ? void 0 : queryParams.pageSlug;
  const page = _78.find({ slug: pageSlug }, myLearningAssessmentPages);
  const group = _78.find({ id: groupId }, groups);
  const { veryWeakStudents, weakStudents, mediumStudents, goodStudents } = useMemo19(
    () => getGroupedStudentsByLevel({ group, stats, students, page }),
    [page, group, students, stats]
  );
  return /* @__PURE__ */ jsxs69("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_index_default.container, children: [
    /* @__PURE__ */ jsx86(LayoutNavbar, { backButtonWording: "Retour", onGoBack, className: "show-group-progression-navbar" }),
    /* @__PURE__ */ jsxs69(StyledContainerLayout, { className: src_internals_components_learningAssessment_teacher_showGroupProgression_index_default.layout, children: [
      /* @__PURE__ */ jsx86(
        StyledSessionCardChapterImg,
        {
          className: src_internals_components_learningAssessment_teacher_showGroupProgression_index_default.chapterImg,
          src: chapter == null ? void 0 : chapter.img,
          style: { "--s-backgroundcolor": chapter == null ? void 0 : chapter.backgroundColor }
        }
      ),
      /* @__PURE__ */ jsx86(titleSection_default, { group, chapter }),
      /* @__PURE__ */ jsxs69("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_index_default.answeredStudents, children: [
        /* @__PURE__ */ jsx86(
          studentListCard_default,
          {
            backgroundColor: "var(--error-40-color)",
            badgeColor: "var(--error-30-color)",
            students: weakStudents,
            listTitle: "\xC0 revoir",
            iconName: "warningfilled",
            page
          }
        ),
        /* @__PURE__ */ jsx86(
          studentListCard_default,
          {
            backgroundColor: "var(--secondary-40-color)",
            badgeColor: "var(--secondary-30-color)",
            students: mediumStudents,
            listTitle: "En cours d'acquisition",
            iconName: "timer",
            page
          }
        ),
        /* @__PURE__ */ jsx86(
          studentListCard_default,
          {
            backgroundColor: "var(--tertiary-40-color)",
            badgeColor: "var(--tertiary-30-color)",
            students: goodStudents,
            listTitle: "Acquis",
            iconName: "checkmarkfilled",
            page
          }
        )
      ] }),
      /* @__PURE__ */ jsx86("div", { className: src_internals_components_learningAssessment_teacher_showGroupProgression_index_default.notAnsweredStudents, children: /* @__PURE__ */ jsx86(
        studentListCard_default,
        {
          className: "student-list-very-weak-student",
          backgroundColor: "var(--gray-40-color)",
          badgeColor: "var(--gray-30-color)",
          students: veryWeakStudents,
          listTitle: "N'a pas fait la session",
          iconName: "cancelcirclefilled",
          page
        }
      ) })
    ] })
  ] });
};
var showGroupProgression_default = ShowGroupProgression;

// src/internals/components/learningAssessment/teacher/index.jsx
import { jsx as jsx87, jsxs as jsxs70 } from "react/jsx-runtime";
var getNextStep = (oldStep) => {
  switch (oldStep) {
    case LEARNING_ASSESSMENT_STEPS.DEFAULT:
      return LEARNING_ASSESSMENT_STEPS.SELECT_NOTION;
    case LEARNING_ASSESSMENT_STEPS.SELECT_NOTION:
      return LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES;
    case LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES:
      return LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS;
  }
};
var TeacherLearningAssessment = ({
  groups,
  students,
  onGoTo,
  onGoBack,
  queryParams,
  onManageGroupClick,
  revisionPages,
  chapters,
  chapter,
  currentStep,
  viewerElement,
  onShareSession,
  selectedExercises,
  setSelectedExercises,
  myLearningAssessmentPages,
  stats,
  isFirstConnection = false,
  setHasSeenLearningAssessment
}) => {
  const [isShownManageGroupModal, setIsShownManageGroupModal] = useState34(false);
  const closeManageGroupModal = () => setIsShownManageGroupModal(false);
  const openManageGroupModal = () => setIsShownManageGroupModal(true);
  const [isShownConfirmModal, setIsShownConfirmModal] = useState34(false);
  const closeConfirmModal = () => setIsShownConfirmModal(false);
  const openConfirModal = () => setIsShownConfirmModal(true);
  const [selectedGroups, setSelectedGroups] = useState34([]);
  const onGoToNextStep = useCallback30(
    (query) => {
      const nextStep2 = getNextStep(currentStep);
      if (currentStep === LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS) {
        onShareSession(selectedGroups);
      }
      onGoTo(nextStep2, query);
    },
    [onGoTo, selectedGroups, onShareSession, currentStep]
  );
  const chapterWithSettings = _79.find({ id: chapter == null ? void 0 : chapter.id }, chapters);
  return /* @__PURE__ */ jsxs70("div", { className: src_internals_components_learningAssessment_teacher_index_default.container, children: [
    isShownManageGroupModal && /* @__PURE__ */ jsx87(noGroupsModal_default, { onManageGroupClick, close: closeManageGroupModal }),
    isShownConfirmModal && /* @__PURE__ */ jsx87(
      confirmModal_default,
      {
        chapter: chapterWithSettings,
        groups: selectedGroups,
        close: closeConfirmModal,
        onGotoNextStep: onGoToNextStep,
        selectedExercises
      }
    ),
    currentStep === LEARNING_ASSESSMENT_STEPS.DEFAULT && /* @__PURE__ */ jsx87(
      home_default2,
      {
        chapters,
        isFirstConnection,
        setHasSeenLearningAssessment,
        revisionPages,
        myLearningAssessmentPages,
        openManageGroupModal,
        groups,
        students,
        stats,
        onGoTo,
        onGoToNextStep,
        onManageGroupClick
      }
    ),
    currentStep === LEARNING_ASSESSMENT_STEPS.SELECT_NOTION && /* @__PURE__ */ jsx87(
      notion_default,
      {
        currentStep,
        onGoBack,
        queryParams,
        onGoToNextStep,
        chapters,
        pages: revisionPages
      }
    ),
    currentStep === LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES && /* @__PURE__ */ jsx87(
      exercises_default,
      {
        viewerElement,
        onGoBack,
        currentStep,
        queryParams,
        onGoToNextStep,
        selectedExercises
      }
    ),
    currentStep === LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS && /* @__PURE__ */ jsx87(
      groups_default,
      {
        currentStep,
        onGoBack,
        groups,
        queryParams,
        selectedGroups,
        openConfirModal,
        setSelectedGroups,
        setSelectedExercises
      }
    ),
    currentStep === LEARNING_ASSESSMENT_STEPS.FOLLOW_GROUP_PROGRESSION && /* @__PURE__ */ jsx87(
      showGroupProgression_default,
      {
        groups,
        students,
        queryParams,
        chapter: chapterWithSettings,
        onGoBack,
        stats,
        myLearningAssessmentPages
      }
    )
  ] });
};
var teacher_default = TeacherLearningAssessment;

// src/internals/utils/learningAssessmentConstants.ts
var CHAPTERS_SETTINGS = {
  0: {
    bg: "var(--primary-40-color)",
    img: "/assets/img/learningAssessment/chapter/notion_figures_analyse.svg"
  },
  1: {
    bg: "var(--secondary-40-color)",
    img: "/assets/img/learningAssessment/chapter/notion_statistics_probabilities.svg"
  },
  2: {
    bg: "var(--premium-50-color)",
    img: "/assets/img/learningAssessment/chapter/notion_linear_growth.svg"
  },
  3: {
    bg: "var(--gray-40-color)",
    img: "/assets/img/learningAssessment/chapter/notion_exponential_growth.svg"
  },
  4: {
    bg: "var(--primary-40-color)",
    img: "/assets/img/learningAssessment/chapter/notion_instantaneous_variation.svg"
  },
  5: {
    bg: "var(--secondary-40-color)",
    img: "/assets/img/learningAssessment/chapter/notion_global_variations.svg"
  }
};

// src/internals/components/learningAssessment/index.jsx
import _80 from "lodash/fp.js";
import { useCallback as useCallback31, useMemo as useMemo20 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_learningAssessment_index.module.css
var src_internals_components_learningAssessment_index_default = { "container": "sk-214lGW-container" };

// src/internals/components/learningAssessment/index.jsx
import { jsx as jsx88, jsxs as jsxs71 } from "react/jsx-runtime";
var getBackStep = (oldStep) => {
  switch (oldStep) {
    case LEARNING_ASSESSMENT_STEPS.SELECT_NOTION:
    case LEARNING_ASSESSMENT_STEPS.START_SESSION:
    case LEARNING_ASSESSMENT_STEPS.FOLLOW_GROUP_PROGRESSION:
      return LEARNING_ASSESSMENT_STEPS.DEFAULT;
    case LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES:
      return LEARNING_ASSESSMENT_STEPS.SELECT_NOTION;
    case LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS:
      return LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES;
  }
};
var LearningAssessment = ({
  viewerElement,
  user,
  chapter,
  chapters,
  currentStep,
  teacherProps,
  studentProps,
  stats,
  onGoTo,
  onGoToHome
}) => {
  const chaptersWithSettings = useMemo20(
    () => _80.map.convert({ cap: false })((chapter2, i) => ({
      ...chapter2,
      backgroundColor: _80.get(`${i}.bg`, CHAPTERS_SETTINGS),
      img: _80.get(`${i}.img`, CHAPTERS_SETTINGS)
    }))(chapters),
    [chapters]
  );
  const onGoBack = useCallback31(
    (query) => {
      const backStep = getBackStep(currentStep);
      onGoTo(backStep, query);
    },
    [onGoTo, currentStep]
  );
  const commonProps = {
    viewerElement,
    chapter,
    onGoTo,
    onGoBack,
    currentStep,
    chapters: chaptersWithSettings
  };
  return /* @__PURE__ */ jsxs71("div", { className: src_internals_components_learningAssessment_index_default.container, children: [
    !shoulHideMainNavbar(currentStep) && /* @__PURE__ */ jsx88(MainNavbar, { isTeacher: user == null ? void 0 : user.isTeacher, onGoTo, onGoToHome }),
    (user == null ? void 0 : user.isTeacher) ? /* @__PURE__ */ jsx88(teacher_default, { ...commonProps, ...teacherProps, stats }) : /* @__PURE__ */ jsx88(student_default, { stats: _80.get(user == null ? void 0 : user.id, stats), ...commonProps, ...studentProps })
  ] });
};
var learningAssessment_default = LearningAssessment;

// src/internals/components/classrooms/index.jsx
import _93 from "lodash/fp.js";
import { useCallback as useCallback39 } from "react";
import { BREAKPOINT_SM, useUnderBreakpoint } from "@lls/utils";

// src/internals/components/classrooms/modalClassroom.jsx
import { Button as Button36, Divider as Divider7, Icon as Icon24, SelectField as SelectField8, Snackbar as Snackbar2, TextField as TextField5 } from "@lls/lls-kit";
import _84 from "lodash/fp.js";
import { useCallback as useCallback34, useState as useState37 } from "react";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent9 } from "@lls/utils";

// src/internals/components/classrooms/edit/index.jsx
import React4, { useState as useState36, useCallback as useCallback33, useMemo as useMemo22, useEffect as useEffect16, useRef as useRef9 } from "react";
import { Button as Button34, ChipSelect as ChipSelect2, Help, TextField as TextField4, Z_SELECT_CHIP } from "@lls/lls-kit";
import _83 from "lodash/fp.js";
import { cx as cx21 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_edit_index.module.css
var src_internals_components_classrooms_edit_index_default = { "helpBody": "sk-a9m9CW-helpBody", "clearButton": "sk-a9m9CW-clearButton", "modalFooter": "sk-a9m9CW-modalFooter", "filterContainer": "sk-a9m9CW-filterContainer", "modalHeader": "sk-a9m9CW-modalHeader", "overridingTextInput": "sk-a9m9CW-overridingTextInput", "filters": "sk-a9m9CW-filters", "subTitle": "sk-a9m9CW-subTitle", "help": "sk-a9m9CW-help", "helpBodyContainer": "sk-a9m9CW-helpBodyContainer" };

// src/internals/components/classrooms/edit/userList.jsx
import _82 from "lodash/fp.js";
import { useCallback as useCallback32, useMemo as useMemo21, useState as useState35 } from "react";
import { Snackbar } from "@lls/lls-kit";
import { cx as cx20 } from "@lls/utils";
import LazyLoadModule2 from "react-lazyload";

// src/internals/components/classrooms/edit/userCheckbox.jsx
import { Divider as Divider6, Icon as Icon23, Stamp as Stamp3 } from "@lls/lls-kit";
import _81 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_edit_userCheckbox.module.css
var src_internals_components_classrooms_edit_userCheckbox_default = { "user": "sk-ZCTiWW-user", "contentUser": "sk-ZCTiWW-contentUser", "icon": "sk-ZCTiWW-icon", "userName": "sk-ZCTiWW-userName", "userDetails": "sk-ZCTiWW-userDetails", "label": "sk-ZCTiWW-label", "divider": "sk-ZCTiWW-divider" };

// src/internals/components/classrooms/edit/userCheckbox.jsx
import { Fragment as Fragment24, jsx as jsx89, jsxs as jsxs72 } from "react/jsx-runtime";
var UserCheckbox2 = ({ user, levelById, isChecked, onToggle, classrooms }) => {
  var _a;
  const classroomsByStudent = _81.getOr([], _81.get("id", user), classrooms);
  const htmlId = `user-checkbox-${_81.get("id", user)}`;
  const lastLogin = _81.get("lastLogin", user);
  const connectorLabel = _81.flow(_81.get("connectorName"), connectorNameToField, _81.get("name"))(user);
  const userInfos = _81.flow(
    _81.compact,
    _81.join(", ")
  )([
    (_a = user == null ? void 0 : user.levels) == null ? void 0 : _a.map((levelId) => {
      var _a2;
      return (_a2 = levelById[levelId]) == null ? void 0 : _a2.name;
    }).join(", "),
    lastLogin && getUserDisplayedDate(lastLogin),
    connectorLabel
  ]);
  return /* @__PURE__ */ jsxs72(Fragment24, { children: [
    /* @__PURE__ */ jsxs72("label", { className: src_internals_components_classrooms_edit_userCheckbox_default.label, htmlFor: htmlId, onClick: () => onToggle(isChecked ? void 0 : htmlId), children: [
      /* @__PURE__ */ jsxs72("div", { children: [
        /* @__PURE__ */ jsx89(
          Icon23,
          {
            className: src_internals_components_classrooms_edit_userCheckbox_default.icon,
            name: "checkmarkfilled",
            color: "var(--primary-40-color)",
            width: "32px",
            height: "32px",
            "data-display": +isChecked
          }
        ),
        /* @__PURE__ */ jsx89(Icon23, { className: src_internals_components_classrooms_edit_userCheckbox_default.icon, name: "circle", width: "32px", height: "32px", "data-display": +!isChecked })
      ] }),
      /* @__PURE__ */ jsx89("div", { className: src_internals_components_classrooms_edit_userCheckbox_default.user, children: /* @__PURE__ */ jsxs72("div", { className: src_internals_components_classrooms_edit_userCheckbox_default.contentUser, children: [
        /* @__PURE__ */ jsxs72("div", { "data-clarity-mask": "true", children: [
          /* @__PURE__ */ jsx89("span", { className: src_internals_components_classrooms_edit_userCheckbox_default.userName, children: getStudentFullName(user) }),
          !_81.isEmpty(userInfos) && /* @__PURE__ */ jsxs72("span", { className: src_internals_components_classrooms_edit_userCheckbox_default.userDetails, children: [
            " - ",
            userInfos
          ] })
        ] }),
        /* @__PURE__ */ jsx89("div", { children: _81.map(
          (classroom) => /* @__PURE__ */ jsx89(Stamp3, { size: "small", theme: "gray", children: classroom.name }, classroom.id),
          classroomsByStudent
        ) })
      ] }) })
    ] }),
    /* @__PURE__ */ jsx89(Divider6, { className: src_internals_components_classrooms_edit_userCheckbox_default.divider })
  ] });
};
var userCheckbox_default2 = UserCheckbox2;

// tmp_esbuild1736180050074/_src_internals_components_classrooms_edit_userList.module.css
var src_internals_components_classrooms_edit_userList_default = { "unselected": "sk-x3mzoG-unselected", "list": "sk-x3mzoG-list", "div": "sk-x3mzoG-div" };

// src/internals/components/classrooms/edit/userList.jsx
import { jsx as jsx90, jsxs as jsxs73 } from "react/jsx-runtime";
var LazyLoad2 = LazyLoadModule2.default || LazyLoadModule2;
var ADDED_USER2 = "add";
var REMOVED_USER2 = "remove";
var UserList2 = ({ users, allUsers, classrooms, allLevels, onChange, className, handleUnselectUsers }) => {
  const usersById = useMemo21(() => _82.keyBy("id", users), [users]);
  const levelById = useMemo21(() => _82.keyBy("id", allLevels), [allLevels]);
  const [snackbarData, setSnackbarData] = useState35(false);
  const handleClose = useCallback32(() => {
    setSnackbarData(false);
  }, []);
  const handleToggle = useCallback32(
    (user, checked) => {
      setSnackbarData(checked && getStudentFullName(user));
      checked ? onChange(_82.concat(user, users), ADDED_USER2) : onChange(_82.remove(user, users), REMOVED_USER2);
    },
    [onChange, users]
  );
  const aUsers = useMemo21(() => {
    const allClassroomsByUser = groupGroupsByStudentId(classrooms);
    return /* @__PURE__ */ jsx90("div", { className: src_internals_components_classrooms_edit_userList_default.list, children: _82.map(
      (user) => /* @__PURE__ */ jsx90(LazyLoad2, { once: true, overflow: true, height: "100%", offset: 800, children: /* @__PURE__ */ jsx90(
        userCheckbox_default2,
        {
          user,
          groups: allClassroomsByUser,
          isChecked: _82.has(_82.get("id", user), usersById),
          onToggle: (yes) => handleToggle(user, yes),
          levelById
        }
      ) }, _82.get("id", user)),
      allUsers
    ) });
  }, [allUsers, levelById, usersById, classrooms, handleToggle]);
  return /* @__PURE__ */ jsxs73("div", { className: cx20(className, src_internals_components_classrooms_edit_userList_default.div), children: [
    aUsers,
    /* @__PURE__ */ jsx90("div", { className: src_internals_components_classrooms_edit_userList_default.unselected, onClick: handleUnselectUsers, children: "Tout d\xE9s\xE9lectionner" }),
    snackbarData && /* @__PURE__ */ jsx90(
      Snackbar,
      {
        open: !!snackbarData,
        close: handleClose,
        severity: "info",
        message: `${snackbarData} ajout\xE9(e) \xE0 la s\xE9lection.`,
        autoHide: 1500,
        position: "bottom"
      }
    )
  ] });
};
var userList_default2 = UserList2;

// src/internals/components/classrooms/edit/index.jsx
import { Fragment as Fragment25, jsx as jsx91, jsxs as jsxs74 } from "react/jsx-runtime";
var toSelectable = (el) => el ? { value: _83.get("id", el), label: _83.get("name", el) } : null;
var EditClassroomModal = ({
  allUsers,
  isOffline,
  allLevels = [],
  classroom,
  classrooms,
  onUpdateClassroom,
  onClose
}) => {
  const name = _83.get("name", classroom);
  const searchRef = useRef9();
  const userIds = _83.get("students", classroom);
  const handleUnselectUsers = useCallback33(() => setSelectedUsers([]), []);
  const allUsersById = useMemo22(() => _83.keyBy("id", allUsers), [allUsers]);
  const [selectedUsers, setSelectedUsers] = useState36();
  useEffect16(() => {
    setSelectedUsers(_83.map((userId) => allUsersById[userId], userIds));
  }, [userIds, allUsersById]);
  const [searchValue, setSearchValue] = useState36("");
  const [inputValue, setInputValue] = useState36(searchValue);
  const [level, setLevel] = useState36();
  const [connectorField, setConnectorField] = useState36();
  const debouncedSetSearchValue = useMemo22(() => _83.debounce(500, setSearchValue), []);
  const handleSearch = useCallback33(
    (search) => {
      setInputValue(search);
      debouncedSetSearchValue(search);
    },
    [debouncedSetSearchValue]
  );
  const allLevelsById = _83.keyBy("id", allLevels);
  const levels = useMemo22(
    () => _83.flow(
      _83.flatMap("levels"),
      _83.uniq,
      _83.map((el) => ({
        id: _83.get([el, "id"], allLevelsById),
        name: getLevelName(_83.get([el, "name"], allLevelsById)),
        order: _83.get([el, "order"], allLevelsById)
      })),
      _83.orderBy("order", "desc")
    )(allUsers),
    [allUsers, allLevelsById]
  );
  const connectorFields = useMemo22(() => _83.flow(_83.map("connectorName"), getConnectorFields)(allUsers), [allUsers]);
  const handleSelectLevel = useCallback33(
    (selectedLevel) => setLevel(selectedLevel ? _83.find(["id", _83.get("value", selectedLevel)], levels) : null),
    [levels]
  );
  const handleSelectConnectorField = useCallback33(
    (selectedConnectorField) => setConnectorField(
      selectedConnectorField ? _83.find(["id", _83.get("value", selectedConnectorField)], connectorFields) : null
    ),
    [connectorFields]
  );
  const handleClearSearch = useCallback33(() => {
    setSearchValue("");
    setInputValue("");
    searchRef.current.focus();
  }, []);
  const handleSelectedUsers = useCallback33(
    (users, mode) => {
      setSelectedUsers(users);
      mode === ADDED_USER2 && handleClearSearch();
    },
    [handleClearSearch]
  );
  const handleSubmit = useCallback33(() => {
    const updatedClassroom = _83.assign(classroom, { students: _83.map("id", selectedUsers) });
    onUpdateClassroom({ classroom, updatedClassroom });
    onClose();
  }, [onUpdateClassroom, selectedUsers, onClose, classroom]);
  const filteredUsers = useMemo22(() => {
    const name2 = connectorFieldToName(connectorField);
    const orderedUsers = _83.sortBy(getStudentFullName, allUsers);
    return searchUsers(orderedUsers, {
      search: searchValue,
      levels: level ? [_83.get("id", level)] : void 0,
      connectorNames: name2 ? [name2] : void 0
    });
  }, [searchValue, level, connectorField, allUsers]);
  const areShownSources = shouldDisplaySources({ connectorFields, allUsers });
  const OverridingSearch = useMemo22(
    () => React4.forwardRef(({ className, value, ...props }, ref) => /* @__PURE__ */ jsxs74(Fragment25, { children: [
      /* @__PURE__ */ jsx91("input", { ...props, value, className: cx21(className, src_internals_components_classrooms_edit_index_default.overridingTextInput), ref }),
      !_83.isEmpty(value) && /* @__PURE__ */ jsx91(
        Button34,
        {
          className: src_internals_components_classrooms_edit_index_default.clearButton,
          theme: "gray",
          accent: "floating",
          icon: "cancelcirclefilled",
          onClick: handleClearSearch
        }
      )
    ] })),
    [handleClearSearch]
  );
  return /* @__PURE__ */ jsxs74(Fragment25, { children: [
    /* @__PURE__ */ jsxs74("div", { className: src_internals_components_classrooms_edit_index_default.modalHeader, children: [
      /* @__PURE__ */ jsxs74("div", { className: src_internals_components_classrooms_edit_index_default.subTitle, children: [
        "S\xE9lectionnez les \xE9l\xE8ves que vous souhaitez ajouter \xE0 la classe ",
        name,
        "."
      ] }),
      /* @__PURE__ */ jsxs74("div", { className: src_internals_components_classrooms_edit_index_default.filterContainer, children: [
        /* @__PURE__ */ jsx91(
          TextField4,
          {
            ref: searchRef,
            icon: "magnificentglass",
            placeholder: "Rechercher",
            value: inputValue,
            onChange: handleSearch,
            OverridingInputComponent: OverridingSearch
          }
        ),
        /* @__PURE__ */ jsxs74("div", { className: src_internals_components_classrooms_edit_index_default.filters, children: [
          /* @__PURE__ */ jsx91(
            ChipSelect2,
            {
              label: "Niveaux",
              options: _83.map(toSelectable, levels),
              selectedOption: toSelectable(level),
              onChange: handleSelectLevel,
              optionsZIndex: Z_SELECT_CHIP
            }
          ),
          areShownSources && /* @__PURE__ */ jsx91(
            ChipSelect2,
            {
              label: "Sources",
              options: _83.map(toSelectable, connectorFields),
              selectedOption: toSelectable(connectorField),
              onChange: handleSelectConnectorField,
              optionsZIndex: Z_SELECT_CHIP
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx91(
      userList_default2,
      {
        allLevels,
        allUsers: filteredUsers,
        classrooms,
        users: selectedUsers,
        onChange: handleSelectedUsers,
        handleUnselectUsers
      },
      `${(level == null ? void 0 : level.id) || "NO"}${searchValue}`
    ),
    /* @__PURE__ */ jsxs74("div", { className: src_internals_components_classrooms_edit_index_default.modalFooter, children: [
      /* @__PURE__ */ jsx91(Help, { className: src_internals_components_classrooms_edit_index_default.help, title: "Des \xE9l\xE8ves absents ?", theme: "primary", icon: "questionmarkcircle", children: /* @__PURE__ */ jsx91("div", { className: src_internals_components_classrooms_edit_index_default.helpBodyContainer, children: /* @__PURE__ */ jsxs74("div", { className: src_internals_components_classrooms_edit_index_default.helpBody, children: [
        " ",
        "Assurez-vous qu'ils se soient connect\xE9s au moins une fois \xE0 la plateforme Lelivrescolaire.fr depuis l'ENT"
      ] }) }) }),
      /* @__PURE__ */ jsx91(Button34, { onClick: handleSubmit, disabled: _83.isEmpty(selectedUsers) || isOffline, children: _83.size(selectedUsers) > 1 ? `Ajouter les ${_83.size(selectedUsers)} \xE9l\xE8ves` : "Ajouter l'\xE9l\xE8ve" })
    ] })
  ] });
};
var edit_default = EditClassroomModal;

// tmp_esbuild1736180050074/_src_internals_components_classrooms_modalClassroom.module.css
var src_internals_components_classrooms_modalClassroom_default = { "bodyItem": "sk-BI0Vaq-bodyItem", "itemTitle": "sk-BI0Vaq-itemTitle", "customDivider": "sk-BI0Vaq-customDivider", "iconContainer": "sk-BI0Vaq-iconContainer", "divider": "sk-BI0Vaq-divider", "addStudentSubTitle": "sk-BI0Vaq-addStudentSubTitle", "styleIcon": "sk-BI0Vaq-styleIcon", "buttonContainer2": "sk-BI0Vaq-buttonContainer2", "buttonContainer3": "sk-BI0Vaq-buttonContainer3", "button": "sk-BI0Vaq-button", "inviteContainer": "sk-BI0Vaq-inviteContainer", "modalBody": "sk-BI0Vaq-modalBody", "bigQrcode": "sk-BI0Vaq-bigQrcode", "addStudentContainerTitle": "sk-BI0Vaq-addStudentContainerTitle", "itemContainer": "sk-BI0Vaq-itemContainer", "addStudentTitle": "sk-BI0Vaq-addStudentTitle", "qrcode": "sk-BI0Vaq-qrcode", "itemSubTitle": "sk-BI0Vaq-itemSubTitle", "buttonContainer": "sk-BI0Vaq-buttonContainer", "orContainer": "sk-BI0Vaq-orContainer", "addStudentContainer": "sk-BI0Vaq-addStudentContainer", "or": "sk-BI0Vaq-or" };

// src/internals/components/classrooms/successAddedClassroom.jsx
import { Button as Button35 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_successAddedClassroom.module.css
var src_internals_components_classrooms_successAddedClassroom_default = { "easyDiv": "sk-rOn4wq-easyDiv", "paper": "sk-rOn4wq-paper", "button": "sk-rOn4wq-button", "mainTitle": "sk-rOn4wq-mainTitle", "think": "sk-rOn4wq-think" };

// src/internals/components/classrooms/successAddedClassroom.jsx
import { jsx as jsx92, jsxs as jsxs75 } from "react/jsx-runtime";
var SuccessAddedClassroom = ({ onNextStep, retrieve = true }) => {
  return /* @__PURE__ */ jsxs75("div", { className: src_internals_components_classrooms_successAddedClassroom_default.paper, children: [
    /* @__PURE__ */ jsx92("img", { src: "/assets/img/classroom/classroom_success.webp" }),
    /* @__PURE__ */ jsx92("div", { className: src_internals_components_classrooms_successAddedClassroom_default.easyDiv, children: retrieve ? "Tout est pr\xEAt !" : "Vous avez presque termin\xE9 !" }),
    /* @__PURE__ */ jsxs75("div", { className: src_internals_components_classrooms_successAddedClassroom_default.mainTitle, children: [
      "Vos classes ont \xE9t\xE9 ",
      retrieve ? "ajout\xE9es" : "cr\xE9\xE9es",
      " avec succ\xE8s !"
    ] }),
    !retrieve && /* @__PURE__ */ jsx92("div", { className: src_internals_components_classrooms_successAddedClassroom_default.think, children: "Cliquez sur vos classes pour ajouter vos \xE9l\xE8ves." }),
    /* @__PURE__ */ jsx92(Button35, { className: src_internals_components_classrooms_successAddedClassroom_default.button, onClick: onNextStep, children: "Continuer" })
  ] });
};
var successAddedClassroom_default = SuccessAddedClassroom;

// src/internals/components/classrooms/modalClassroom.jsx
import { jsx as jsx93, jsxs as jsxs76 } from "react/jsx-runtime";
var MODAL_TYPE_INVITE = "invite";
var MODAL_TYPE_RENAME = "rename";
var MODAL_TYPE_DELETE = "delete";
var MODAL_TYPE_ADD_STUDENTS = "add_students";
var MODAL_TYPE_REMOVE_STUDENT = "remove_student";
var InviteStudentItem = ({ title, isOffline, subTitle, onClick, buttonText, children }) => {
  return /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.itemContainer, children: [
    /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.itemTitle, children: title }),
    /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.itemSubTitle, children: subTitle }),
    children,
    /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.buttonContainer3, children: /* @__PURE__ */ jsx93(Button36, { disabled: isOffline, onClick, theme: "blue", accent: "main", children: buttonText }) })
  ] });
};
var QrCodeModal = ({ name, url, onClose }) => {
  return /* @__PURE__ */ jsx93(
    modalWithTheme_default,
    {
      title: `Scannez ce QR Code 
  pour rejoindre la classe ${name} `,
      closeModal: onClose,
      children: /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.modalBody, children: [
        " ",
        /* @__PURE__ */ jsx93("img", { className: src_internals_components_classrooms_modalClassroom_default.bigQrcode, src: url })
      ] })
    }
  );
};
var AddInviteStudentModal = ({
  onCancel,
  isOffline,
  code,
  name,
  id,
  onOpenCodeClassroomPdf,
  setModalType
}) => {
  const [qrCodeModalIsOpen, setQrCodeModalIsOpen] = useState37(false);
  const [snackbarIsOpen, setSnackbarIsOpen] = useState37(false);
  const handleClose = useCallback34(() => {
    setSnackbarIsOpen(false);
  }, []);
  const url = generateQrcodeClassroomUrl({ code });
  const miniUrlCode = generateCodeClasroomMiniUrl({ code });
  const dispatchEvent = useCallback34((featureName) => {
    dispatchAnalyticsEvent9(ANALYTICS_INVITATION_METHOD_USED, {
      featureName
    });
  }, []);
  const openAddStudentModal = useCallback34(() => {
    setModalType(MODAL_TYPE_ADD_STUDENTS);
    dispatchEvent("cr\xE9ation manuelle");
  }, [setModalType, dispatchEvent]);
  return /* @__PURE__ */ jsxs76(modalWithTheme_default, { title: "Invitez vos \xE9l\xE8ves \xE0 rejoindre leur classe", closeModal: onCancel, children: [
    /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.modalBody, children: [
      /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.inviteContainer, children: [
        /* @__PURE__ */ jsx93(
          InviteStudentItem,
          {
            title: "Je suis avec mes \xE9l\xE8ves",
            subTitle: "Demandez \xE0 vos \xE9l\xE8ves de scanner ce QR Code",
            buttonText: "Afficher en plein \xE9cran",
            isOffline,
            onClick: () => {
              setQrCodeModalIsOpen(true);
              dispatchEvent("qr_code");
            },
            children: /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.bodyItem, children: /* @__PURE__ */ jsx93("img", { className: src_internals_components_classrooms_modalClassroom_default.qrcode, src: url }) })
          }
        ),
        /* @__PURE__ */ jsx93(Divider7, { vertical: true }),
        /* @__PURE__ */ jsx93(Divider7, { className: src_internals_components_classrooms_modalClassroom_default.divider }),
        /* @__PURE__ */ jsx93(
          InviteStudentItem,
          {
            title: "Je ne suis pas en classe",
            subTitle: "Envoyez ce lien par mail ou via l'ENT \xE0 vos \xE9l\xE8ves",
            buttonText: "Copier le lien",
            isOffline,
            onClick: () => {
              navigator.clipboard.writeText(miniUrlCode);
              setSnackbarIsOpen(true);
              dispatchEvent("lien");
            },
            children: /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.bodyItem, children: miniUrlCode })
          }
        ),
        /* @__PURE__ */ jsx93(Divider7, { vertical: true }),
        /* @__PURE__ */ jsx93(Divider7, { className: src_internals_components_classrooms_modalClassroom_default.divider }),
        /* @__PURE__ */ jsx93(
          InviteStudentItem,
          {
            title: "Je souhaite imprimer",
            subTitle: "Imprimez ces coupons et distribuez-les en classe \xE0 vos \xE9l\xE8ves",
            buttonText: "Imprimer les coupons",
            isOffline,
            onClick: () => {
              onOpenCodeClassroomPdf(id);
              dispatchEvent("pdf");
            },
            children: /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.bodyItem, children: /* @__PURE__ */ jsx93(Icon24, { name: "printer", color: "var(--tertiary-30-color)", width: "87", height: "87" }) })
          }
        ),
        /* @__PURE__ */ jsx93(Divider7, { className: src_internals_components_classrooms_modalClassroom_default.divider })
      ] }),
      /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.orContainer, children: [
        /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.customDivider }),
        /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.or, children: "ou" }),
        /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.customDivider })
      ] }),
      /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.addStudentContainer, onClick: openAddStudentModal, children: [
        /* @__PURE__ */ jsx93(Icon24, { className: src_internals_components_classrooms_modalClassroom_default.iconContainer, children: /* @__PURE__ */ jsx93(Icon24, { name: "personcheckmark", width: 24, height: 24 }) }),
        /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.addStudentContainerTitle, children: [
          /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.addStudentTitle, children: "J'ajoute moi-m\xEAme mes \xE9l\xE8ves" }),
          /* @__PURE__ */ jsx93("div", { className: src_internals_components_classrooms_modalClassroom_default.addStudentSubTitle, children: "Ajoutez vos \xE9l\xE8ves manuellement" })
        ] }),
        /* @__PURE__ */ jsx93(Icon24, { className: src_internals_components_classrooms_modalClassroom_default.styleIcon, name: "arrowright", width: 24, height: 24 })
      ] })
    ] }),
    qrCodeModalIsOpen && /* @__PURE__ */ jsx93(QrCodeModal, { url, name, onClose: () => setQrCodeModalIsOpen(false) }),
    snackbarIsOpen && /* @__PURE__ */ jsx93(
      Snackbar2,
      {
        open: snackbarIsOpen,
        close: handleClose,
        severity: "success",
        message: "Lien copi\xE9 dans le presse-papier !",
        autoHide: 1500,
        position: "bottom"
      }
    )
  ] });
};
var AddClassroomModal = ({ onCancel, onAddClassroom, classrooms = [], levels }) => {
  const [name, setName] = useState37();
  const [level, setLevel] = useState37();
  const classroomAlreadyExist = _84.some({ name }, classrooms);
  return /* @__PURE__ */ jsx93(modalWithTheme_default, { title: "Ajouter une classe", closeModal: onCancel, children: /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.modalBody, children: [
    /* @__PURE__ */ jsx93(
      SelectField8,
      {
        options: _84.map(({ id, name: name2 }) => ({ value: id, label: name2 }), levels),
        value: level,
        onChange: setLevel,
        label: "Niveau"
      }
    ),
    /* @__PURE__ */ jsx93(
      TextField5,
      {
        defaultValue: name,
        onChange: setName,
        label: "Nom de votre classe",
        state: classroomAlreadyExist && "error",
        hint: classroomAlreadyExist && "Une classe du m\xEAme nom existe d\xE9j\xE0"
      }
    ),
    /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.buttonContainer2, children: [
      /* @__PURE__ */ jsx93(
        Button36,
        {
          className: src_internals_components_classrooms_modalClassroom_default.button,
          onClick: () => onAddClassroom({ id: -Date.now(), name, levels: [level] }),
          maxSize: true,
          disabled: _84.isNil(name) || classroomAlreadyExist,
          children: "Ajouter"
        }
      ),
      /* @__PURE__ */ jsx93(Button36, { onClick: onCancel, accent: "floating", maxSize: true, children: "Annuler" })
    ] })
  ] }) });
};
var RenameModal = ({ onCancel, onRenameClassroom, name, classroom }) => {
  const [newName, setNewName] = useState37(name);
  return /* @__PURE__ */ jsx93(modalWithTheme_default, { title: "Renommer la classe", closeModal: onCancel, children: /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.modalBody, children: [
    /* @__PURE__ */ jsx93(TextField5, { defaultValue: name, placeholder: classroom == null ? void 0 : classroom.name, onChange: setNewName }),
    /* @__PURE__ */ jsxs76("div", { className: src_internals_components_classrooms_modalClassroom_default.buttonContainer, children: [
      /* @__PURE__ */ jsx93(Button36, { theme: "gray", icon: "arrowleft", onClick: onCancel, accent: "floating", children: "Annuler" }),
      /* @__PURE__ */ jsx93(Button36, { icon: "edit", onClick: () => onRenameClassroom(newName), children: "Renommer" })
    ] })
  ] }) });
};
var AddStudentsModal = ({
  onCancel,
  isOffline,
  students,
  onUpdateClassroom,
  classroom,
  classrooms,
  onDeleteClassroom,
  levels
}) => {
  return /* @__PURE__ */ jsx93(modalWithTheme_default, { title: "Ajouter un \xE9l\xE8ve", closeModal: onCancel, fullwidth: true, maxwidth: "sm", children: /* @__PURE__ */ jsx93(
    edit_default,
    {
      isOffline,
      users: students,
      onClose: onCancel,
      allUsers: students,
      classrooms,
      classroom,
      allLevels: levels,
      onUpdateClassroom,
      onDeleteClassroom
    }
  ) });
};
var ModaClassrooms = ({ onCancel, retrieve }) => {
  return /* @__PURE__ */ jsx93(modalWithTheme_default, { withCloseButton: false, closeModal: onCancel, children: /* @__PURE__ */ jsx93(successAddedClassroom_default, { retrieve, onNextStep: onCancel }) });
};
var ModalClassroom = ({
  modalType,
  isOffline,
  setModalType,
  classroom,
  classrooms,
  onRenameClassroom,
  onDeleteClassroom,
  students,
  onUpdateClassroom,
  onRemoveStudent,
  student = {},
  onOpenCodeClassroomPdf,
  levels
}) => {
  const onCancel = useCallback34(() => setModalType(void 0), [setModalType]);
  switch (modalType) {
    case MODAL_TYPE_DELETE:
      return /* @__PURE__ */ jsxs76(
        modalWithTheme_default,
        {
          title: `\xCAtes-vous s\xFBr(e) de vouloir supprimer la classe ${classroom == null ? void 0 : classroom.name} ?`,
          closeModal: onCancel,
          children: [
            /* @__PURE__ */ jsx93(Button36, { onClick: onCancel, accent: "floating", children: "J'ai chang\xE9 d'avis" }),
            /* @__PURE__ */ jsx93(Button36, { onClick: onDeleteClassroom, theme: "error", children: "Supprimer d\xE9finitivement la classe" })
          ]
        }
      );
    case MODAL_TYPE_RENAME:
      return /* @__PURE__ */ jsx93(
        RenameModal,
        {
          onCancel,
          classroom,
          onRenameClassroom,
          name: classroom == null ? void 0 : classroom.name
        }
      );
    case MODAL_TYPE_INVITE:
      return /* @__PURE__ */ jsx93(
        AddInviteStudentModal,
        {
          isOffline,
          onCancel,
          ...classroom,
          onOpenCodeClassroomPdf,
          setModalType
        }
      );
    case MODAL_TYPE_ADD_STUDENTS:
      return /* @__PURE__ */ jsx93(
        AddStudentsModal,
        {
          title: "Ajouter un \xE9l\xE8ve",
          onCancel,
          students,
          isOffline,
          classroom,
          classrooms,
          onDeleteClassroom,
          onUpdateClassroom,
          levels
        }
      );
    case MODAL_TYPE_REMOVE_STUDENT:
      return /* @__PURE__ */ jsxs76(
        modalWithTheme_default,
        {
          title: `\xCAtes-vous s\xFBr(e) de vouloir retirer l\u2019\xE9l\xE8ve ${getStudentFullName(student)} de ${classroom.name} ?`,
          closeModal: onCancel,
          children: [
            /* @__PURE__ */ jsx93(Button36, { onClick: onCancel, accent: "floating", children: "J'ai chang\xE9 d'avis" }),
            /* @__PURE__ */ jsx93(Button36, { onClick: onRemoveStudent, theme: "error", children: "Supprimer d\xE9finitivement l'\xE9l\xE8ve" })
          ]
        }
      );
    default:
      return null;
  }
};
var modalClassroom_default = ModalClassroom;

// src/internals/components/classrooms/addCustomClassroom.jsx
import { useCallback as useCallback35, useState as useState38 } from "react";
import { Button as Button39, Icon as Icon26 } from "@lls/lls-kit";

// src/internals/components/classrooms/classroomItem.jsx
import _86 from "lodash/fp.js";
import { Button as Button37, Icon as Icon25, Stamp as Stamp4 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_classroomItem.module.css
var src_internals_components_classrooms_classroomItem_default = { "newClassroom": "sk-e6NwLW-newClassroom", "newClassroomContainer": "sk-e6NwLW-newClassroomContainer", "footer": "sk-e6NwLW-footer", "studentsSubtitle": "sk-e6NwLW-studentsSubtitle", "stamp": "sk-e6NwLW-stamp", "checkIcon": "sk-e6NwLW-checkIcon", "classroom": "sk-e6NwLW-classroom", "inviteButton": "sk-e6NwLW-inviteButton", "actionContainer": "sk-e6NwLW-actionContainer", "name": "sk-e6NwLW-name", "deleteButton": "sk-e6NwLW-deleteButton", "alreadyImportedButton": "sk-e6NwLW-alreadyImportedButton", "createdBy": "sk-e6NwLW-createdBy", "noStudent": "sk-e6NwLW-noStudent", "icon": "sk-e6NwLW-icon", "studentsNumber": "sk-e6NwLW-studentsNumber", "otherClassroomName": "sk-e6NwLW-otherClassroomName", "classroomName": "sk-e6NwLW-classroomName", "link": "sk-e6NwLW-link" };

// src/internals/components/classrooms/menu.jsx
import _85 from "lodash/fp.js";
import { useMemo as useMemo23 } from "react";
import { MenuButton as MenuButton7 } from "@lls/lls-kit";
import { cx as cx22 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_menu.module.css
var src_internals_components_classrooms_menu_default = { "menuButton": "sk-SXnHeG-menuButton" };

// src/internals/components/classrooms/menu.jsx
import { jsx as jsx94 } from "react/jsx-runtime";
var getItemsMenu = ({
  classroom,
  isOffline,
  onDuplicateClassroom = _85.noop,
  setModalType,
  withInviteStudent = true,
  goToClassroom
}) => {
  const isEnt = _85.get("isEnt", classroom);
  const commonListItems = [
    {
      icon: "squareonsquare",
      msg: "Dupliquer",
      disabled: isOffline,
      onClick: () => onDuplicateClassroom(classroom)
    },
    {
      type: "divider"
    },
    {
      icon: "delete",
      disabled: isOffline,
      iconProps: { color: "var(--error-50-color)" },
      msg: "Supprimer",
      onClick: () => setModalType(MODAL_TYPE_DELETE)
    }
  ];
  return isEnt ? commonListItems : _85.flow(
    _85.concat([
      withInviteStudent ? {
        icon: "share",
        msg: "Inviter des \xE9l\xE8ves",
        disabled: isOffline,
        onClick: () => goToClassroom()
      } : void 0,
      {
        icon: "highlight",
        msg: "Renommer",
        disabled: isOffline,
        onClick: () => setModalType(MODAL_TYPE_RENAME)
      }
    ]),
    _85.compact
  )(commonListItems);
};
var ClassroomMenu = ({
  classroom,
  isOffline,
  setSelectedClassRoom = _85.noop,
  onDuplicateClassroom = _85.noop,
  setModalType,
  orientation = "vertical",
  className = "",
  alignment = "center",
  withInviteStudent,
  goToClassroom
}) => {
  const itemsMenu = useMemo23(
    () => getItemsMenu({ classroom, isOffline, onDuplicateClassroom, setModalType, withInviteStudent, goToClassroom }),
    [classroom, onDuplicateClassroom, isOffline, setModalType, withInviteStudent, goToClassroom]
  );
  return /* @__PURE__ */ jsx94(
    MenuButton7,
    {
      onClick: () => setSelectedClassRoom(classroom),
      className: cx22(className, src_internals_components_classrooms_menu_default.menuButton),
      orientation,
      size: "small",
      position: "bottom",
      alignment,
      listItems: itemsMenu
    }
  );
};
var menu_default = ClassroomMenu;

// src/internals/components/classrooms/classroomItem.jsx
import { Fragment as Fragment26, jsx as jsx95, jsxs as jsxs77 } from "react/jsx-runtime";
var getDisplayStudentNumber = (nbStudents) => nbStudents === 0 ? "Aucun \xE9l\xE8ve" : nbStudents > 1 ? `${nbStudents} \xE9l\xE8ves` : `${nbStudents} \xE9l\xE8ve`;
var OtherClassroomItem = ({
  name = "test",
  owner,
  nbStudents = 0,
  onCloneClassroom = _86.noop,
  isChecked = false,
  teachers = [],
  alreadyImported = false
}) => {
  const teacher = _86.find({ id: owner }, teachers);
  const teacherDisplayName = `${_86.get("firstname", teacher)} ${_86.get("lastname", teacher)}`;
  return /* @__PURE__ */ jsx95(
    "div",
    {
      className: src_internals_components_classrooms_classroomItem_default.newClassroom,
      onClick: alreadyImported ? _86.noop : onCloneClassroom,
      "data-is-checked": +isChecked,
      "data-is-disabled": +alreadyImported,
      children: /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.newClassroomContainer, children: [
        /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.otherClassroomName, children: [
          /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.name, "data-is-disabled": +alreadyImported, children: name }),
          /* @__PURE__ */ jsx95(
            Icon25,
            {
              className: src_internals_components_classrooms_classroomItem_default.checkIcon,
              name: "circle",
              width: "32px",
              height: "32px",
              "data-display": +!(isChecked || alreadyImported)
            }
          ),
          /* @__PURE__ */ jsx95(
            Icon25,
            {
              className: src_internals_components_classrooms_classroomItem_default.checkIcon,
              name: "checkmarkfilled",
              color: alreadyImported ? "var(--text-disabled-light-mode, #ADBACC)" : "var(--primary-40-color)",
              width: "32px",
              height: "32px",
              "data-display": +(isChecked || alreadyImported)
            }
          )
        ] }),
        /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.studentsNumber, "data-is-disabled": +alreadyImported, children: getDisplayStudentNumber(nbStudents) }),
        alreadyImported && /* @__PURE__ */ jsx95(Button37, { className: src_internals_components_classrooms_classroomItem_default.alreadyImportedButton, disabled: "true", children: "D\xE9j\xE0 ajout\xE9e" }),
        /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.footer, children: [
          /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.createdBy, "data-is-disabled": +alreadyImported, children: [
            "Cr\xE9\xE9e par ",
            teacherDisplayName,
            " "
          ] }),
          " "
        ] })
      ] })
    }
  );
};
var NewClassroomItem = ({ name = "test", nbStudents = 0, onDeleteClassroom }) => {
  return /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.newClassroom, "data-is-checked": 1, children: /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.newClassroomContainer, children: [
    /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.otherClassroomName, children: [
      /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.name, children: name }),
      /* @__PURE__ */ jsx95(
        Icon25,
        {
          className: src_internals_components_classrooms_classroomItem_default.checkIcon,
          name: "checkmarkfilled",
          color: "var(--primary-40-color)",
          width: "32px",
          height: "32px",
          "data-display": 1
        }
      )
    ] }),
    /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.studentsNumber, children: getDisplayStudentNumber(nbStudents) }),
    /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.studentsSubtitle, children: "Vous pourrez ajouter des \xE9l\xE8ves \xE0 la prochaine \xE9tape." }),
    /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.footer, children: [
      /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.createdBy, children: "Cr\xE9\xE9e par vous " }),
      onDeleteClassroom && /* @__PURE__ */ jsx95(
        Button37,
        {
          className: src_internals_components_classrooms_classroomItem_default.deleteButton,
          icon: "delete",
          theme: "error",
          accent: "floating",
          size: "small",
          onClick: onDeleteClassroom
        }
      )
    ] })
  ] }) });
};
var ClassroomItem = ({ classroom, isOffline, setSelectedClassRoom, goToClassroom, index, modalProps }) => {
  const { name, isEnt, students } = classroom;
  const nbStudents = _86.size(students);
  const classRoomHasStudents = nbStudents > 0;
  return /* @__PURE__ */ jsxs77(
    "div",
    {
      className: src_internals_components_classrooms_classroomItem_default.classroom,
      "data-hasstudent": +classRoomHasStudents,
      onClick: () => classRoomHasStudents ? goToClassroom(false) : _86.noop,
      "data-qa-id": `sk-classrooms-item-${index}`,
      children: [
        /* @__PURE__ */ jsxs77("div", { className: src_internals_components_classrooms_classroomItem_default.classroomName, children: [
          /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.name, "data-clarity-mask": "true", children: name }),
          " ",
          isEnt && /* @__PURE__ */ jsx95(Stamp4, { className: src_internals_components_classrooms_classroomItem_default.stamp, theme: "light-yellow", size: "small", children: "ENT" }),
          /* @__PURE__ */ jsx95(
            menu_default,
            {
              ...modalProps,
              isOffline,
              setSelectedClassRoom,
              classroom,
              goToClassroom: () => goToClassroom(true)
            }
          )
        ] }),
        /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.studentsNumber, "data-hasstudent": +classRoomHasStudents, children: nbStudents === 0 ? /* @__PURE__ */ jsxs77(Fragment26, { children: [
          /* @__PURE__ */ jsx95(Icon25, { name: "exclamationmarkcirclefilled", width: 20, height: 20 }),
          /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.noStudent, children: "Aucun \xE9l\xE8ve" })
        ] }) : getDisplayStudentNumber(nbStudents) }),
        /* @__PURE__ */ jsx95("div", { className: src_internals_components_classrooms_classroomItem_default.actionContainer, children: isEnt ? /* @__PURE__ */ jsxs77("a", { className: src_internals_components_classrooms_classroomItem_default.link, onClick: () => goToClassroom(false), children: [
          " ",
          /* @__PURE__ */ jsx95(Icon25, { className: src_internals_components_classrooms_classroomItem_default.icon, name: "eye", width: 18, height: 12 }),
          "Consulter la classe"
        ] }) : nbStudents === 0 ? /* @__PURE__ */ jsx95(
          Button37,
          {
            disabled: isOffline,
            className: src_internals_components_classrooms_classroomItem_default.inviteButton,
            icon: "plus",
            onClick: () => goToClassroom(true),
            "data-qa-id": `sk-classrooms-item-${index}-invitebutton`,
            children: "Inviter des \xE9l\xE8ves"
          }
        ) : /* @__PURE__ */ jsxs77("a", { className: src_internals_components_classrooms_classroomItem_default.link, children: [
          " ",
          /* @__PURE__ */ jsx95(Icon25, { className: src_internals_components_classrooms_classroomItem_default.icon, name: "edit", width: 14, height: 14 }),
          "\xC9diter la classe"
        ] }) })
      ]
    }
  );
};
var classroomItem_default = ClassroomItem;

// src/internals/components/classrooms/addCustomClassroom.jsx
import _88 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_addCustomClassroom.module.css
var src_internals_components_classrooms_addCustomClassroom_default = { "easyDiv": "sk-5rMGHa-easyDiv", "buttonContainer": "sk-5rMGHa-buttonContainer", "paper": "sk-5rMGHa-paper", "icon": "sk-5rMGHa-icon", "stamp": "sk-5rMGHa-stamp", "addEmptyClassroom": "sk-5rMGHa-addEmptyClassroom", "mainTitle": "sk-5rMGHa-mainTitle", "buttonContainerBottom": "sk-5rMGHa-buttonContainerBottom", "wrapper": "sk-5rMGHa-wrapper", "classRoomNumberContainer": "sk-5rMGHa-classRoomNumberContainer", "classRoomNumber": "sk-5rMGHa-classRoomNumber", "barFloating": "sk-5rMGHa-barFloating", "inspirateTitle": "sk-5rMGHa-inspirateTitle", "classroomContainer": "sk-5rMGHa-classroomContainer", "inputContainer": "sk-5rMGHa-inputContainer" };

// src/internals/components/classrooms/stepBar.jsx
import { Button as Button38, Stepper as Stepper2 } from "@lls/lls-kit";
import _87 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_stepBar.module.css
var src_internals_components_classrooms_stepBar_default = { "divStepBackContainer": "sk-lvPKgq-divStepBackContainer", "container": "sk-lvPKgq-container", "paper": "sk-lvPKgq-paper", "styleTitle": "sk-lvPKgq-styleTitle" };

// src/internals/components/classrooms/stepBar.jsx
import { jsx as jsx96, jsxs as jsxs78 } from "react/jsx-runtime";
var STEPBAR_HEIGHT = 74;
var getStepIndexFromStep2 = (step) => {
  switch (step) {
    case CLASSROOM_STEP.ADD_ENT_CLASSROOM:
    case CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM:
      return 1;
    case CLASSROOM_STEP.SUCCES_ADDED_CLASS:
    case CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS:
      return 2;
    default:
      return 0;
  }
};
var StepBar = ({ currentStep, onGoBack = _87.noop }) => {
  return /* @__PURE__ */ jsxs78("div", { className: src_internals_components_classrooms_stepBar_default.paper, children: [
    /* @__PURE__ */ jsxs78("div", { className: src_internals_components_classrooms_stepBar_default.divStepBackContainer, children: [
      /* @__PURE__ */ jsx96(Button38, { theme: "gray", icon: "arrowleft", onClick: onGoBack }),
      "\xC9tape pr\xE9c\xE9dente"
    ] }),
    /* @__PURE__ */ jsxs78("div", { className: src_internals_components_classrooms_stepBar_default.container, children: [
      /* @__PURE__ */ jsx96("div", { className: src_internals_components_classrooms_stepBar_default.styleTitle, children: "Ajoutez vos classes " }),
      /* @__PURE__ */ jsx96(Stepper2, { currentStep: getStepIndexFromStep2(currentStep), nbSteps: 3 })
    ] })
  ] });
};
var stepBar_default = StepBar;

// src/internals/components/classrooms/addCustomClassroom.jsx
import { Fragment as Fragment27, jsx as jsx97, jsxs as jsxs79 } from "react/jsx-runtime";
var AddCustomClassroom = ({
  onNextStep,
  isOffline,
  onCreateClassroom,
  allClassrooms = [],
  teachers = [],
  classrooms,
  levels = []
}) => {
  const [newClassrooms, setNewClassrooms] = useState38([]);
  const [nbClassroomShown, setNbClassroomShown] = useState38(4);
  const [modalIsOpen, setModalIsOpen] = useState38(false);
  const onAddClassroom = useCallback35((newClassroom) => {
    setNewClassrooms((oldClassrooms) => _88.concat(oldClassrooms, newClassroom));
    setModalIsOpen(false);
  }, []);
  const removeNewClassroom = (newClassroom) => {
    setNewClassrooms(_88.remove({ id: newClassroom == null ? void 0 : newClassroom.id }));
  };
  const saveClassroom = useCallback35(() => {
    _88.map((classroom) => onCreateClassroom(_88.omit("id", classroom)), newClassrooms);
    onNextStep();
  }, [onNextStep, onCreateClassroom, newClassrooms]);
  return /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.paper, style: { "--s-stepbar-height": `${STEPBAR_HEIGHT}px` }, children: /* @__PURE__ */ jsxs79("div", { className: src_internals_components_classrooms_addCustomClassroom_default.wrapper, children: [
    /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.easyDiv, children: "\xC9tape 2" }),
    /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.mainTitle, children: "Comment s'appellent vos classes ?" }),
    /* @__PURE__ */ jsxs79("div", { className: src_internals_components_classrooms_addCustomClassroom_default.inputContainer, children: [
      _88.flow(
        _88.filter(({ id }) => id < 0),
        _88.map((newClassroom) => {
          return /* @__PURE__ */ jsx97(
            NewClassroomItem,
            {
              onDeleteClassroom: () => removeNewClassroom(newClassroom),
              ...newClassroom
            },
            newClassroom.id
          );
        })
      )(newClassrooms),
      /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.classroomContainer, onClick: () => setModalIsOpen(true), children: /* @__PURE__ */ jsxs79("div", { className: src_internals_components_classrooms_addCustomClassroom_default.addEmptyClassroom, children: [
        /* @__PURE__ */ jsx97(
          Icon26,
          {
            className: src_internals_components_classrooms_addCustomClassroom_default.icon,
            width: "40",
            height: "40",
            name: "pluscirclefilled",
            color: "var(--primary-40-color)"
          }
        ),
        " ",
        "Ajouter une classe"
      ] }) })
    ] }),
    !_88.isEmpty(allClassrooms) && /* @__PURE__ */ jsxs79(Fragment27, { children: [
      /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.inspirateTitle, children: "Ou r\xE9cup\xE9rez des classes d\xE9j\xE0 cr\xE9\xE9es par vos coll\xE8gues : " }),
      /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.inputContainer, children: _88.flow(
        _88.slice(0, nbClassroomShown),
        _88.map((classroom) => {
          const isChecked = _88.some({ id: classroom == null ? void 0 : classroom.id }, newClassrooms);
          const alreadyImported = _88.some({ name: classroom == null ? void 0 : classroom.name }, classrooms);
          const onCloneClassroom = () => isChecked ? removeNewClassroom(classroom) : onAddClassroom(classroom);
          return /* @__PURE__ */ jsx97(
            OtherClassroomItem,
            {
              name: classroom == null ? void 0 : classroom.name,
              owner: classroom == null ? void 0 : classroom.owner,
              nbStudents: _88.size(classroom == null ? void 0 : classroom.students),
              isChecked,
              onCloneClassroom,
              teachers,
              alreadyImported
            },
            classroom.id
          );
        })
      )(allClassrooms) }),
      nbClassroomShown < _88.size(allClassrooms) && /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.buttonContainer, children: /* @__PURE__ */ jsx97(
        Button39,
        {
          theme: "blue",
          accent: "floating",
          icon: "arrowdown",
          iconPosition: "right",
          onClick: () => setNbClassroomShown((old) => old + 4),
          children: "Voir plus"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.barFloating, children: /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.buttonContainerBottom, children: /* @__PURE__ */ jsx97(Button39, { onClick: saveClassroom, disabled: _88.isEmpty(newClassrooms) || isOffline, children: _88.size(newClassrooms) > 1 ? /* @__PURE__ */ jsxs79("div", { className: src_internals_components_classrooms_addCustomClassroom_default.classRoomNumberContainer, children: [
      "Ajouter",
      /* @__PURE__ */ jsx97("div", { className: src_internals_components_classrooms_addCustomClassroom_default.classRoomNumber, children: _88.size(newClassrooms) }),
      "classes"
    ] }) : "Ajouter la classe" }) }) }),
    modalIsOpen && /* @__PURE__ */ jsx97(
      AddClassroomModal,
      {
        isOffline,
        levels,
        onAddClassroom,
        onCancel: () => setModalIsOpen(false),
        classrooms
      }
    )
  ] }) });
};
var addCustomClassroom_default = AddCustomClassroom;

// src/internals/components/classrooms/addEntClassroom.jsx
import { useCallback as useCallback36, useState as useState39 } from "react";
import { Button as Button40, Divider as Divider8, Icon as Icon27, Stamp as Stamp5 } from "@lls/lls-kit";
import _89 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_addEntClassroom.module.css
var src_internals_components_classrooms_addEntClassroom_default = { "listScroll": "sk-JNxwEW-listScroll", "textClassroom": "sk-JNxwEW-textClassroom", "listContainer": "sk-JNxwEW-listContainer", "unselectdLink": "sk-JNxwEW-unselectdLink", "stamp": "sk-JNxwEW-stamp", "item": "sk-JNxwEW-item", "paper": "sk-JNxwEW-paper", "containerItem": "sk-JNxwEW-containerItem", "easyDiv": "sk-JNxwEW-easyDiv", "mainTitle": "sk-JNxwEW-mainTitle", "icon": "sk-JNxwEW-icon" };

// src/internals/components/classrooms/addEntClassroom.jsx
import { Fragment as Fragment28, jsx as jsx98, jsxs as jsxs80 } from "react/jsx-runtime";
var ClassroomItem2 = ({ entClassroom, selectedClassroom, onSelectItem }) => {
  const alreadySelected = _89.findIndex({ id: entClassroom.id }, selectedClassroom) > -1;
  return /* @__PURE__ */ jsxs80("div", { className: src_internals_components_classrooms_addEntClassroom_default.item, onClick: () => onSelectItem(entClassroom), children: [
    /* @__PURE__ */ jsxs80("div", { className: src_internals_components_classrooms_addEntClassroom_default.containerItem, children: [
      /* @__PURE__ */ jsx98(
        Icon27,
        {
          className: src_internals_components_classrooms_addEntClassroom_default.icon,
          name: "checkmarkfilled",
          color: "var(--primary-40-color)",
          width: "32px",
          height: "32px",
          "data-display": +alreadySelected
        }
      ),
      /* @__PURE__ */ jsx98(Icon27, { className: src_internals_components_classrooms_addEntClassroom_default.icon, name: "circle", width: "32px", height: "32px", "data-display": +!alreadySelected }),
      /* @__PURE__ */ jsx98("div", { className: src_internals_components_classrooms_addEntClassroom_default.textClassroom, children: entClassroom.name })
    ] }),
    /* @__PURE__ */ jsx98(Divider8, {})
  ] });
};
var AddEntClassroom = ({ onNextStep, entClassrooms, onCreateClassroom = _89.noop }) => {
  const [selectedClassroom, setSelectedClassroom] = useState39([]);
  const onSelectItem = useCallback36(
    (entClassroom) => {
      const alreadySelected = _89.findIndex({ id: entClassroom.id }, selectedClassroom) > -1;
      setSelectedClassroom(
        alreadySelected ? _89.remove(({ id: id2 }) => entClassroom.id === id2) : _89.concat(entClassroom)
      );
    },
    [selectedClassroom]
  );
  const saveClassroom = useCallback36(() => {
    _89.map(({ id: garDivisionId, name }) => onCreateClassroom({ garDivisionId, name }), selectedClassroom);
    onNextStep();
  }, [onNextStep, onCreateClassroom, selectedClassroom]);
  return /* @__PURE__ */ jsxs80("div", { className: src_internals_components_classrooms_addEntClassroom_default.paper, style: { "--s-stepbar-height": `${STEPBAR_HEIGHT}px` }, children: [
    /* @__PURE__ */ jsx98("div", { className: src_internals_components_classrooms_addEntClassroom_default.easyDiv, children: "Interagissez avec vos classes" }),
    /* @__PURE__ */ jsx98("div", { className: src_internals_components_classrooms_addEntClassroom_default.mainTitle, children: "Quelles classes souhaitez-vous ajouter ?" }),
    /* @__PURE__ */ jsx98("div", { className: src_internals_components_classrooms_addEntClassroom_default.listScroll, children: /* @__PURE__ */ jsx98("div", { className: src_internals_components_classrooms_addEntClassroom_default.listContainer, children: _89.flow(
      _89.sortBy("name"),
      _89.map.convert({ cap: false })((entClassroom, i) => /* @__PURE__ */ jsx98(
        ClassroomItem2,
        {
          entClassroom,
          selectedClassroom,
          onSelectItem
        },
        i
      ))
    )(entClassrooms) }) }),
    /* @__PURE__ */ jsx98("div", { className: src_internals_components_classrooms_addEntClassroom_default.unselectdLink, onClick: () => setSelectedClassroom([]), children: "Tout d\xE9selectionner" }),
    /* @__PURE__ */ jsx98(Button40, { onClick: saveClassroom, disabled: _89.isEmpty(selectedClassroom), children: _89.size(selectedClassroom) > 1 ? /* @__PURE__ */ jsxs80(Fragment28, { children: [
      "R\xE9cup\xE9rer mes",
      " ",
      /* @__PURE__ */ jsx98(Stamp5, { className: src_internals_components_classrooms_addEntClassroom_default.stamp, size: "small", children: _89.size(selectedClassroom) }),
      "classes"
    ] }) : "R\xE9cup\xE9rer ma classe" })
  ] });
};
var addEntClassroom_default = AddEntClassroom;

// src/internals/components/classrooms/chooseClassroomType.jsx
import { Icon as Icon28 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_chooseClassroomType.module.css
var src_internals_components_classrooms_chooseClassroomType_default = { "titleChoice": "sk-uLRKMG-titleChoice", "descrptionChoice": "sk-uLRKMG-descrptionChoice", "containerChoices": "sk-uLRKMG-containerChoices", "paper": "sk-uLRKMG-paper", "circleContainerIcon": "sk-uLRKMG-circleContainerIcon", "icone": "sk-uLRKMG-icone", "containerChoice": "sk-uLRKMG-containerChoice", "easyDiv": "sk-uLRKMG-easyDiv", "mainTitle": "sk-uLRKMG-mainTitle" };

// src/internals/components/classrooms/chooseClassroomType.jsx
import { Fragment as Fragment29, jsx as jsx99, jsxs as jsxs81 } from "react/jsx-runtime";
var ClassRoomChoice = ({ iconName, title, description, onNextStep, recommended = false }) => {
  return /* @__PURE__ */ jsxs81("div", { className: src_internals_components_classrooms_chooseClassroomType_default.containerChoice, onClick: onNextStep, "data-recommended": +recommended, children: [
    /* @__PURE__ */ jsx99("div", { className: src_internals_components_classrooms_chooseClassroomType_default.circleContainerIcon, children: /* @__PURE__ */ jsx99(Icon28, { className: src_internals_components_classrooms_chooseClassroomType_default.icone, name: iconName, width: 48, height: 48 }) }),
    /* @__PURE__ */ jsx99("div", { className: src_internals_components_classrooms_chooseClassroomType_default.titleChoice, children: title }),
    /* @__PURE__ */ jsx99("div", { className: src_internals_components_classrooms_chooseClassroomType_default.descrptionChoice, children: description })
  ] });
};
var ChooseClassroomType = ({ onNextStep }) => {
  return /* @__PURE__ */ jsx99(Fragment29, { children: /* @__PURE__ */ jsxs81("div", { className: src_internals_components_classrooms_chooseClassroomType_default.paper, style: { "--s-stepbar-height": `${STEPBAR_HEIGHT}px` }, children: [
    /* @__PURE__ */ jsx99("div", { className: src_internals_components_classrooms_chooseClassroomType_default.easyDiv, children: "C'est facile et rapide !" }),
    /* @__PURE__ */ jsx99("div", { className: src_internals_components_classrooms_chooseClassroomType_default.mainTitle, children: "Comment souhaitez-vous ajouter vos classes ?" }),
    /* @__PURE__ */ jsxs81("div", { className: src_internals_components_classrooms_chooseClassroomType_default.containerChoices, children: [
      /* @__PURE__ */ jsx99(
        ClassRoomChoice,
        {
          iconName: "magicexchange",
          title: "R\xE9cup\xE9rer depuis mon ENT",
          description: "Les classes seront automatiquement mises \xE0 jour.",
          onNextStep: () => onNextStep({ entType: true }),
          recommended: true
        }
      ),
      /* @__PURE__ */ jsx99(
        ClassRoomChoice,
        {
          iconName: "groupadd",
          title: "Configurer moi-m\xEAme",
          description: "Cr\xE9ez des classes personnalis\xE9es comme vous le souhaitez.",
          onNextStep: () => onNextStep({ entType: false })
        }
      )
    ] })
  ] }) });
};
var chooseClassroomType_default = ChooseClassroomType;

// src/internals/components/classrooms/classroom.jsx
import _90 from "lodash/fp.js";
import { useCallback as useCallback38, useEffect as useEffect17, useMemo as useMemo24, useState as useState41 } from "react";
import { Button as Button41, Credit, Divider as Divider9, KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME3, Stamp as Stamp6, TextField as TextField6 } from "@lls/lls-kit";
import { cx as cx23 } from "@lls/utils";

// src/internals/hooks/useModalClassroom.ts
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent10 } from "@lls/utils";
import { useCallback as useCallback37, useState as useState40 } from "react";
var useModalClassroom = ({
  classroom,
  onDeleteClassroom: onDeleteClassroomFromProps,
  onUpdateClassroom,
  onDuplicateClassroom: onDuplicateClassroomFromProps,
  onOpenCodeClassroomPdf: onOpenCodeClassroomPdfFromProps
}) => {
  const [modalType, setModalType] = useState40(void 0);
  const onRenameClassroom = useCallback37(
    (newName) => {
      onUpdateClassroom({ classroom, updatedClassroom: { ...classroom, name: newName } });
      dispatchAnalyticsEvent10(ANALYTICS_EVENT_GROUP_RENAMED);
      setModalType(void 0);
    },
    [classroom, onUpdateClassroom]
  );
  const onDeleteClassroom = useCallback37(() => {
    onDeleteClassroomFromProps(classroom);
    setModalType(void 0);
  }, [classroom, onDeleteClassroomFromProps]);
  const onDuplicateClassroom = useCallback37(
    () => onDuplicateClassroomFromProps(classroom),
    [classroom, onDuplicateClassroomFromProps]
  );
  const onOpenCodeClassroomPdf = useCallback37(
    () => onOpenCodeClassroomPdfFromProps(classroom == null ? void 0 : classroom.id),
    [classroom, onOpenCodeClassroomPdfFromProps]
  );
  return {
    classroom,
    modalType,
    setModalType,
    onRenameClassroom,
    onDeleteClassroom,
    onDuplicateClassroom,
    onOpenCodeClassroomPdf
  };
};
var useModalClassroom_default = useModalClassroom;

// tmp_esbuild1736180050074/_src_internals_components_classrooms_classroom.module.css
var src_internals_components_classrooms_classroom_default = { "syledImage": "sk-s0laiW-syledImage", "container": "sk-s0laiW-container", "name": "sk-s0laiW-name", "overridingTextInput": "sk-s0laiW-overridingTextInput", "classroomMenu": "sk-s0laiW-classroomMenu", "body1": "sk-s0laiW-body1", "credit": "sk-s0laiW-credit", "itemContainer": "sk-s0laiW-itemContainer", "emptyContainer": "sk-s0laiW-emptyContainer", "mainTitle": "sk-s0laiW-mainTitle", "headerList": "sk-s0laiW-headerList", "item": "sk-s0laiW-item", "bodyEmpty": "sk-s0laiW-bodyEmpty", "header": "sk-s0laiW-header", "deleteButton": "sk-s0laiW-deleteButton", "listContainer": "sk-s0laiW-listContainer", "content": "sk-s0laiW-content", "addButton": "sk-s0laiW-addButton" };

// src/internals/components/classrooms/classroom.jsx
import { Fragment as Fragment30, jsx as jsx100, jsxs as jsxs82 } from "react/jsx-runtime";
var StudentItem2 = ({ isLast = false, isOffline, onOpenRemoveModal, isEnt, ...user }) => {
  return /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.itemContainer, children: [
    /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.item, "data-clarity-mask": "true", children: [
      /* @__PURE__ */ jsx100(Button41, { icon: "personfilled", accent: "alt" }),
      getStudentFullName(user),
      !isEnt && /* @__PURE__ */ jsx100(
        Button41,
        {
          disabled: isOffline,
          className: src_internals_components_classrooms_classroom_default.deleteButton,
          icon: "forward",
          theme: "error",
          accent: "floating",
          onClick: () => onOpenRemoveModal({ ...user }),
          children: "Retirer"
        }
      )
    ] }),
    !isLast && /* @__PURE__ */ jsx100(Divider9, {})
  ] });
};
var OverridingInputComponent = ({ search, setSearch }) => {
  const OverridingSearch = useMemo24(
    () => ({ className, ...props }) => /* @__PURE__ */ jsx100("input", { className: cx23(className, src_internals_components_classrooms_classroom_default.overridingTextInput), ...props }),
    []
  );
  return /* @__PURE__ */ jsx100(
    TextField6,
    {
      icon: "magnificentglass",
      placeholder: "Rechercher",
      value: search,
      onChange: setSearch,
      OverridingInputComponent: OverridingSearch
    }
  );
};
var filterStudents = (search, classroom, allStudents) => _90.flow(
  _90.get("students"),
  _90.map((id) => _90.find({ id }, allStudents)),
  _90.isEmpty(search) ? _90.identity : _90.filter((student) => {
    const lSearch = _90.lowerCase(search);
    return _90.includes(lSearch, _90.lowerCase(student.lastname)) || _90.includes(lSearch, _90.lowerCase(student.firstname));
  }),
  _90.sortBy("lastname")
)(classroom);
var EmptyClassroom = ({ isEnt = false, setModalType }) => {
  return /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.emptyContainer, children: [
    /* @__PURE__ */ jsx100("img", { className: src_internals_components_classrooms_classroom_default.syledImage, src: "/assets/img/classroom/empty_classroom.webp" }),
    /* @__PURE__ */ jsx100("div", { className: src_internals_components_classrooms_classroom_default.mainTitle, children: "Vos \xE9l\xE8ves appara\xEEtront ici" }),
    /* @__PURE__ */ jsx100("div", { className: src_internals_components_classrooms_classroom_default.bodyEmpty, children: isEnt ? "Vos \xE9l\xE8ves s'afficheront automatiquement ici apr\xE8s leur premi\xE8re connexion \xE0 la plateforme Lelivrescolaire.fr depuis l'ENT, vous n'avez rien \xE0 faire." : "Invitez vos \xE9l\xE8ves \xE0 rejoindre la classe ou ajoutez-les directement." }),
    !isEnt && /* @__PURE__ */ jsx100(Button41, { icon: "plus", onClick: () => setModalType(MODAL_TYPE_ADD_STUDENTS), children: "Ajouter un \xE9l\xE8ve" })
  ] });
};
var Classroom = ({
  isOffline,
  classroom,
  classrooms,
  goToClassrooms,
  allStudents,
  onUpdateClassroom,
  onDeleteClassroom,
  onDuplicateClassroom = _90.noop,
  levels,
  onOpenCodeClassroomPdf,
  withInviteModal = false
}) => {
  const [search, setSearch] = useState41("");
  const [removedStudent, setRemovedStudent] = useState41("");
  const onDeleteClassroomAndRedirect = useCallback38(
    (id) => {
      onDeleteClassroom(id);
      goToClassrooms();
    },
    [onDeleteClassroom, goToClassrooms]
  );
  const modalProps = useModalClassroom_default({
    classroom,
    onDeleteClassroom: onDeleteClassroomAndRedirect,
    onUpdateClassroom,
    onDuplicateClassroom,
    onOpenCodeClassroomPdf
  });
  const { setModalType } = modalProps;
  const students = _90.get("students", classroom);
  const filteredStudents = filterStudents(search, classroom, allStudents);
  const isEnt = classroom == null ? void 0 : classroom.isEnt;
  const name = classroom == null ? void 0 : classroom.name;
  useEffect17(() => {
    withInviteModal && setModalType(MODAL_TYPE_INVITE);
  }, [withInviteModal, setModalType]);
  const onInviteStudents = useCallback38(() => {
    setModalType(MODAL_TYPE_INVITE);
  }, [setModalType]);
  const onOpenRemoveModal = useCallback38(
    (student) => {
      setRemovedStudent(student);
      setModalType(MODAL_TYPE_REMOVE_STUDENT);
    },
    [setModalType]
  );
  const onRemoveStudent = useCallback38(() => {
    onUpdateClassroom({
      classroom,
      updatedClassroom: {
        ...classroom,
        students: _90.flow(
          _90.get("students"),
          _90.remove((id) => id === removedStudent.id)
        )(classroom)
      }
    });
    setModalType(void 0);
  }, [removedStudent, onUpdateClassroom, classroom, setModalType]);
  return /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.container, children: [
    /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.content, children: [
      /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.header, children: [
        /* @__PURE__ */ jsx100(Button41, { theme: "gray", icon: "arrowleft", onClick: goToClassrooms }),
        /* @__PURE__ */ jsx100("div", { className: src_internals_components_classrooms_classroom_default.name, children: name }),
        isEnt ? /* @__PURE__ */ jsxs82(Fragment30, { children: [
          /* @__PURE__ */ jsx100(Stamp6, { theme: "yellow", size: "small", className: KIT_CLASSNAME_DARK_THEME3, children: "ENT" }),
          /* @__PURE__ */ jsx100(
            Credit,
            {
              className: src_internals_components_classrooms_classroom_default.credit,
              msg: "Cette classe est automatiquement mise \xE0 jour depuis votre ENT. Vous ne pouvez pas la modifier."
            }
          )
        ] }) : /* @__PURE__ */ jsx100(Button41, { disabled: isOffline, className: src_internals_components_classrooms_classroom_default.addButton, onClick: onInviteStudents, icon: "plus", children: "Inviter des \xE9l\xE8ves" }),
        /* @__PURE__ */ jsx100(
          menu_default,
          {
            className: src_internals_components_classrooms_classroom_default.classroomMenu,
            ...modalProps,
            isOffline,
            alignment: "right",
            withInviteStudent: false
          }
        )
      ] }),
      _90.isEmpty(students) ? /* @__PURE__ */ jsx100(EmptyClassroom, { isEnt, ...modalProps }) : /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.listContainer, children: [
        /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.headerList, children: [
          /* @__PURE__ */ jsxs82("div", { className: src_internals_components_classrooms_classroom_default.body1, children: [
            _90.size(students),
            " ",
            handlePlural("\xE9l\xE8ve", students)
          ] }),
          /* @__PURE__ */ jsx100(OverridingInputComponent, { search, setSearch })
        ] }),
        _90.map.convert({ cap: false })(
          (student, i) => /* @__PURE__ */ jsx100(
            StudentItem2,
            {
              ...student,
              isOffline,
              isLast: i === _90.size(filteredStudents) - 1,
              onOpenRemoveModal,
              isEnt
            },
            _90.get("id", student)
          ),
          filteredStudents
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx100(
      modalClassroom_default,
      {
        classrooms,
        isOffline,
        students: allStudents,
        onUpdateClassroom,
        onRemoveStudent,
        student: removedStudent,
        levels,
        ...modalProps
      }
    )
  ] });
};
var classroom_default = Classroom;

// src/internals/components/classrooms/classrooms.jsx
import _92 from "lodash/fp.js";
import { useState as useState42 } from "react";
import { Button as Button43, Wavy as Wavy5 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_classrooms.module.css
var src_internals_components_classrooms_classrooms_default = { "containerPaper": "sk-VYQ3fW-containerPaper", "subTitle": "sk-VYQ3fW-subTitle superkit-permanentMarkerRegular", "button": "sk-VYQ3fW-button", "classroomsContainer": "sk-VYQ3fW-classroomsContainer", "title": "sk-VYQ3fW-title", "paper": "sk-VYQ3fW-paper" };

// src/internals/components/classrooms/empty.tsx
import { Button as Button42, Icon as Icon29 } from "@lls/lls-kit";
import { cx as cx24 } from "@lls/utils";

// src/v2/constants.js
var SUPERKIT_CLASSNAME_DARK_THEME = "superkit-dark";
var SUPERKIT_CLASSNAME_LIGHT_THEME = "superkit-light";

// src/internals/components/classrooms/empty.tsx
import _91 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_empty.module.css
var src_internals_components_classrooms_empty_default = { "div": "sk-5P-QnG-div", "text": "sk-5P-QnG-text", "imgContainer": "sk-5P-QnG-imgContainer", "containerPaper": "sk-5P-QnG-containerPaper", "paper": "sk-5P-QnG-paper", "divList": "sk-5P-QnG-divList", "textContainer": "sk-5P-QnG-textContainer", "title": "sk-5P-QnG-title" };

// src/internals/components/classrooms/empty.tsx
import { jsx as jsx101, jsxs as jsxs83 } from "react/jsx-runtime";
var EmptyClassroom2 = ({
  title = "Ajoutez vos classes et interagissez facilement avec vos \xE9l\xE8ves",
  text = "Des \xE9changes rapides et fluides gr\xE2ce \xE0 la gestion de classe.",
  onNextStep = _91.noop,
  isButtonDisabled = false
}) => /* @__PURE__ */ jsx101("div", { className: cx24(SUPERKIT_CLASSNAME_LIGHT_THEME, src_internals_components_classrooms_empty_default.containerPaper), children: /* @__PURE__ */ jsxs83("div", { className: src_internals_components_classrooms_empty_default.paper, children: [
  /* @__PURE__ */ jsx101("div", { className: src_internals_components_classrooms_empty_default.imgContainer }),
  /* @__PURE__ */ jsxs83("div", { className: src_internals_components_classrooms_empty_default.textContainer, children: [
    /* @__PURE__ */ jsx101("div", { className: src_internals_components_classrooms_empty_default.title, children: title }),
    /* @__PURE__ */ jsx101("div", { className: src_internals_components_classrooms_empty_default.text, children: text }),
    /* @__PURE__ */ jsxs83("div", { className: src_internals_components_classrooms_empty_default.div, children: [
      /* @__PURE__ */ jsx101(Icon29, { name: "checkmarkfilled", color: "var(--primary-40-color)" }),
      /* @__PURE__ */ jsx101("div", { className: src_internals_components_classrooms_empty_default.divList, children: "Partagez les activit\xE9s \xE0 vos \xE9l\xE8ves" })
    ] }),
    /* @__PURE__ */ jsxs83("div", { className: src_internals_components_classrooms_empty_default.div, children: [
      /* @__PURE__ */ jsx101(Icon29, { name: "checkmarkfilled", color: "var(--primary-40-color)" }),
      /* @__PURE__ */ jsx101("div", { className: src_internals_components_classrooms_empty_default.divList, children: "Partagez les corrections \xE0 un groupe d'\xE9l\xE8ves" })
    ] }),
    /* @__PURE__ */ jsxs83("div", { className: src_internals_components_classrooms_empty_default.div, children: [
      /* @__PURE__ */ jsx101(Icon29, { name: "checkmarkfilled", color: "var(--primary-40-color)" }),
      /* @__PURE__ */ jsx101("div", { className: src_internals_components_classrooms_empty_default.divList, children: "Acc\xE9dez aux statistiques de suivi de vos classes" })
    ] }),
    /* @__PURE__ */ jsx101(Button42, { disabled: isButtonDisabled, onClick: onNextStep, children: "J'ajoute mes classes" })
  ] })
] }) });
var empty_default = EmptyClassroom2;

// src/internals/components/classrooms/classrooms.jsx
import { jsx as jsx102, jsxs as jsxs84 } from "react/jsx-runtime";
var AllClassrooms = ({
  isOffline,
  goToAddClassrooms,
  classrooms,
  goToClassroom,
  onDeleteClassroom,
  onDuplicateClassroom,
  onUpdateClassroom,
  onOpenCodeClassroomPdf
}) => {
  const [selecteClassRoom, setSelectedClassRoom] = useState42(null);
  const modalProps = useModalClassroom_default({
    classroom: selecteClassRoom,
    onDeleteClassroom,
    onUpdateClassroom,
    onDuplicateClassroom,
    onOpenCodeClassroomPdf
  });
  return _92.isEmpty(classrooms) ? /* @__PURE__ */ jsx102(empty_default, { onNextStep: goToAddClassrooms }) : /* @__PURE__ */ jsxs84("div", { className: src_internals_components_classrooms_classrooms_default.containerPaper, children: [
    /* @__PURE__ */ jsx102(modalClassroom_default, { ...modalProps }),
    /* @__PURE__ */ jsxs84("div", { className: src_internals_components_classrooms_classrooms_default.paper, children: [
      /* @__PURE__ */ jsxs84("div", { className: src_internals_components_classrooms_classrooms_default.title, children: [
        "Mes ",
        /* @__PURE__ */ jsx102(Wavy5, { waveColor: "var(--premium-50-color)", children: "Classes" })
      ] }),
      /* @__PURE__ */ jsx102("div", { className: src_internals_components_classrooms_classrooms_default.subTitle, children: "Interagissez plus naturellement avec vos \xE9l\xE8ves" }),
      /* @__PURE__ */ jsx102(
        Button43,
        {
          disabled: isOffline,
          className: src_internals_components_classrooms_classrooms_default.button,
          onClick: goToAddClassrooms,
          icon: "plus",
          "data-qa-id": "sk-classrooms-addclassrooms",
          children: "Ajouter une classe"
        }
      ),
      /* @__PURE__ */ jsx102("div", { className: src_internals_components_classrooms_classrooms_default.classroomsContainer, children: classrooms == null ? void 0 : classrooms.map((classroom, i) => {
        return /* @__PURE__ */ jsx102(
          classroomItem_default,
          {
            isOffline,
            index: i,
            setSelectedClassRoom,
            modalProps,
            classroom,
            onOpenCodeClassroomPdf,
            goToClassroom: (withInviteModal) => goToClassroom(i, withInviteModal),
            onDeleteClassroom,
            onDuplicateClassroom,
            onUpdateClassroom
          },
          i
        );
      }) })
    ] })
  ] });
};
var classrooms_default = AllClassrooms;

// tmp_esbuild1736180050074/_src_internals_components_classrooms_index.module.css
var src_internals_components_classrooms_index_default = { "mainContainer": "sk-cbIXAq-mainContainer" };

// src/internals/components/classrooms/mobileClassroom.tsx
import { Icon as Icon30 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_classrooms_mobileClassroom.module.css
var src_internals_components_classrooms_mobileClassroom_default = { "icon": "sk-EFu-KW-icon" };

// src/internals/components/classrooms/mobileClassroom.tsx
import { Fragment as Fragment31, jsx as jsx103, jsxs as jsxs85 } from "react/jsx-runtime";
var MobileClassRoom = () => /* @__PURE__ */ jsx103(
  empty_default,
  {
    title: /* @__PURE__ */ jsxs85(Fragment31, { children: [
      /* @__PURE__ */ jsx103(Icon30, { name: "warningfilled", color: "var(--secondary-30-color)", className: src_internals_components_classrooms_mobileClassroom_default.icon }),
      " La gestion de classe n'est pas disponible pour votre taille d\u2019\xE9cran"
    ] }),
    text: "Connectez-vous via un support plus grand pour acc\xE9der \xE0 l'ensemble de ses fonctionnalit\xE9s.",
    isButtonDisabled: true
  }
);
var mobileClassroom_default = MobileClassRoom;

// src/internals/components/classrooms/index.jsx
import { Fragment as Fragment32, jsx as jsx104, jsxs as jsxs86 } from "react/jsx-runtime";
var getSecondStep = ({ classrooms, entClassrooms = [] }) => {
  const hasNoClassroomEntToSync = _93.flow(_93.filter("isEnt"), _93.differenceBy("id", entClassrooms), _93.isEmpty)(classrooms);
  return _93.isEmpty(entClassrooms) && hasNoClassroomEntToSync ? CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM : CLASSROOM_STEP.CHOOSE_CLASSROOM_TYPE;
};
var nextStep = ({ oldStep, entClassrooms, classrooms, opts = {} }) => {
  switch (oldStep) {
    case CLASSROOM_STEP.ALL_CLASSROOMS:
      return getSecondStep({ entClassrooms, classrooms });
    case CLASSROOM_STEP.CHOOSE_CLASSROOM_TYPE:
      return opts.entType ? CLASSROOM_STEP.ADD_ENT_CLASSROOM : CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM;
    case CLASSROOM_STEP.ADD_ENT_CLASSROOM:
      return CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS;
    case CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM:
      return CLASSROOM_STEP.SUCCES_ADDED_CLASS;
    default:
      return CLASSROOM_STEP.ALL_CLASSROOMS;
  }
};
var MyClassroom = ({
  isOffline,
  entClassrooms,
  classrooms,
  allClassrooms,
  students = [],
  onCreateClassroom,
  onDuplicateClassroom,
  onDeleteClassroom,
  onUpdateClassroom,
  isTrial,
  onGoBack,
  onOpenCodeClassroomPdf,
  goTo,
  currentStep,
  classroomId,
  levels,
  teachers,
  withInviteModal,
  onDisabledFeatureClick
}) => {
  const goToClassroom = (classroomId2, withInviteModal2 = false) => {
    goTo({ step: CLASSROOM_STEP.CLASSROOM, classroomId: classroomId2, withInviteModal: withInviteModal2 });
  };
  const onNextStep = useCallback39(
    (opts = {}) => {
      const step = nextStep({ opts, oldStep: currentStep, entClassrooms, classrooms });
      if (step === CLASSROOM_STEP.SUCCES_ADDED_CLASS && isTrial) return onDisabledFeatureClick();
      goTo({ step });
    },
    [currentStep, entClassrooms, classrooms, isTrial, onDisabledFeatureClick, goTo]
  );
  const isPhablet = useUnderBreakpoint(BREAKPOINT_SM);
  return /* @__PURE__ */ jsx104(Fragment32, { children: isPhablet ? /* @__PURE__ */ jsx104(mobileClassroom_default, {}) : /* @__PURE__ */ jsx104(Fragment32, { children: currentStep === CLASSROOM_STEP.ALL_CLASSROOMS || currentStep === CLASSROOM_STEP.CLASSROOM || currentStep === CLASSROOM_STEP.SUCCES_ADDED_CLASS || currentStep === CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS ? /* @__PURE__ */ jsxs86(Fragment32, { children: [
    (currentStep === CLASSROOM_STEP.ALL_CLASSROOMS || currentStep === CLASSROOM_STEP.SUCCES_ADDED_CLASS || currentStep === CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS) && /* @__PURE__ */ jsx104(
      classrooms_default,
      {
        isOffline,
        classrooms,
        onDuplicateClassroom,
        onDeleteClassroom,
        onUpdateClassroom,
        goToAddClassrooms: onNextStep,
        goToClassroom,
        onOpenCodeClassroomPdf
      }
    ),
    (currentStep === CLASSROOM_STEP.SUCCES_ADDED_CLASS || currentStep === CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS) && /* @__PURE__ */ jsx104(
      ModaClassrooms,
      {
        isOffline,
        retrieve: currentStep === CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS,
        onCancel: onNextStep
      }
    ),
    currentStep === CLASSROOM_STEP.CLASSROOM && /* @__PURE__ */ jsx104(
      classroom_default,
      {
        isOffline,
        classroom: classrooms[classroomId],
        classrooms,
        onDuplicateClassroom,
        onDeleteClassroom,
        onUpdateClassroom,
        allStudents: students,
        levels,
        onOpenCodeClassroomPdf,
        goToClassrooms: () => goTo({ step: CLASSROOM_STEP.ALL_CLASSROOMS }),
        withInviteModal
      }
    )
  ] }) : /* @__PURE__ */ jsxs86("div", { className: src_internals_components_classrooms_index_default.mainContainer, children: [
    /* @__PURE__ */ jsx104(stepBar_default, { currentStep, onGoBack }),
    currentStep === CLASSROOM_STEP.CHOOSE_CLASSROOM_TYPE && /* @__PURE__ */ jsx104(chooseClassroomType_default, { onNextStep }),
    currentStep === CLASSROOM_STEP.ADD_ENT_CLASSROOM && /* @__PURE__ */ jsx104(
      addEntClassroom_default,
      {
        isOffline,
        onNextStep,
        onCreateClassroom,
        classrooms,
        entClassrooms
      }
    ),
    currentStep === CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM && /* @__PURE__ */ jsx104(
      addCustomClassroom_default,
      {
        isOffline,
        levels,
        onNextStep,
        classrooms,
        onCreateClassroom,
        allClassrooms,
        teachers
      }
    )
  ] }) }) });
};
var classrooms_default2 = MyClassroom;

// src/internals/components/notification/notificationMenu.jsx
import { Badge as Badge2, Button as Button44, Icon as Icon31, Z_NOTIFICATION_MENU } from "@lls/lls-kit";
import _95 from "lodash/fp.js";
import { useCallback as useCallback40, useState as useState43 } from "react";
import { cx as cx25 } from "@lls/utils";

// src/internals/utils/notification.tsx
import _94 from "lodash/fp.js";
var getComparisonBoolean = (nofification, user) => {
  if (nofification.updatedAt && user.lastActivitySeenAt)
    return new Date(nofification.updatedAt) > new Date(user.lastActivitySeenAt);
  return false;
};
var getNewNotificationsNumber = (notifications, user) => {
  const filteredNotifications = _94.filter(
    (notification) => notification.read === false && (!user.lastActivitySeenAt ? true : getComparisonBoolean(notification, user)),
    notifications
  );
  return _94.size(filteredNotifications);
};

// src/internals/components/notification/notificationMenu.jsx
import ClickAwayListener from "react-click-away-listener";

// tmp_esbuild1736180050074/_src_internals_components_notification_notificationMenu.module.css
var src_internals_components_notification_notificationMenu_default = { "notificationMenu": "sk-q_PLyW-notificationMenu" };

// src/internals/components/notification/notificationMenu.jsx
import { jsx as jsx105, jsxs as jsxs87 } from "react/jsx-runtime";
var Notification = ({ notification, onNotificationClick, closeMenu }) => {
  const onClick = useCallback40(() => {
    onNotificationClick(notification);
    closeMenu();
  }, [onNotificationClick, notification, closeMenu]);
  const pageInterval = _95.get("content.pageInterval", notification);
  return /* @__PURE__ */ jsxs87("div", { className: "notification-menu-line", onClick, children: [
    /* @__PURE__ */ jsx105("img", { className: "notification-menu-line-thumbnail", src: _95.get("content.thumbnail", notification), alt: "" }),
    /* @__PURE__ */ jsxs87("div", { className: "notification-menu-line-content", children: [
      /* @__PURE__ */ jsxs87("span", { className: "notification-menu-line-title", children: [
        /* @__PURE__ */ jsx105("b", { children: _95.get("content.title", notification) }),
        pageInterval ? ` - ${pageInterval}` : null
      ] }),
      /* @__PURE__ */ jsx105("span", { className: "notification-menu-line-subtitle", children: _95.get("content.subtitle", notification) })
    ] }),
    /* @__PURE__ */ jsx105("div", { children: notification.read ? null : /* @__PURE__ */ jsx105(Icon31, { name: "circlefilled", className: "notification-menu-line-not-read-icon", width: "12", height: "12" }) })
  ] });
};
var NotificationMenu = ({
  notifications = [],
  user,
  inverted = false,
  onNotificationClick = _95.noop,
  onOpen = _95.noop,
  onClose = _95.noop,
  className,
  buttonSize
}) => {
  const [open, setOpen] = useState43(false);
  const newNotificationsNumber = getNewNotificationsNumber(notifications, user);
  const openMenu = useCallback40(() => {
    setOpen(true);
    onOpen();
  }, [onOpen]);
  const closeMenu = useCallback40(() => {
    setOpen(false);
    onClose();
  }, [onClose]);
  return /* @__PURE__ */ jsxs87(
    "div",
    {
      style: { "--s-z-notification-menu": Z_NOTIFICATION_MENU },
      className: cx25(className, src_internals_components_notification_notificationMenu_default.notificationMenu),
      children: [
        newNotificationsNumber > 0 ? /* @__PURE__ */ jsx105(Badge2, { content: newNotificationsNumber, overlap: true, children: /* @__PURE__ */ jsx105(
          Button44,
          {
            icon: "bell",
            theme: "gray",
            accent: "floating",
            onClick: open ? closeMenu : openMenu,
            inverted,
            size: buttonSize,
            "data-tour": "superkit-notification-menu"
          }
        ) }) : /* @__PURE__ */ jsx105(
          Button44,
          {
            icon: "bell",
            theme: "gray",
            accent: "floating",
            size: buttonSize,
            onClick: open ? closeMenu : openMenu,
            inverted,
            "data-tour": "superkit-notification-menu"
          }
        ),
        open && /* @__PURE__ */ jsx105(ClickAwayListener, { onClickAway: closeMenu, children: /* @__PURE__ */ jsxs87("div", { className: "notification-menu-container", children: [
          /* @__PURE__ */ jsx105("div", { className: "notification-menu-main-title", children: "Notifications sur 30 jours" }),
          _95.isEmpty(notifications) ? /* @__PURE__ */ jsx105("div", { className: "notification-menu-empty-text", children: "Aucune notification" }) : _95.flow(
            _95.orderBy(["createdAt"], ["desc"]),
            _95.map((notification) => /* @__PURE__ */ jsx105(
              Notification,
              {
                notification,
                onNotificationClick,
                closeMenu
              },
              notification.id
            ))
          )(notifications)
        ] }) })
      ]
    }
  );
};
var notificationMenu_default = NotificationMenu;

// src/internals/components/modal/notificationModal.jsx
import { useCallback as useCallback41, useEffect as useEffect18, useState as useState44 } from "react";
import { Icon as Icon32, Modal as Modal12 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_modal_notificationModal.module.css
var src_internals_components_modal_notificationModal_default = { "modalContent": "sk-Y5Y3pa-modalContent", "modalTitle": "sk-Y5Y3pa-modalTitle", "img": "sk-Y5Y3pa-img", "modalText": "sk-Y5Y3pa-modalText" };

// src/internals/components/modal/notificationModal.jsx
import { jsx as jsx106, jsxs as jsxs88 } from "react/jsx-runtime";
var ModalNotification = ({ title, message, onClose, children }) => {
  const [open, setOpen] = useState44(true);
  const handleClose = useCallback41(() => {
    setOpen(false);
    onClose();
  }, [onClose]);
  useEffect18(() => {
    const timeout = setTimeout(handleClose, 3e3);
    return () => {
      clearTimeout(timeout);
    };
  }, [handleClose]);
  return open ? /* @__PURE__ */ jsx106(Modal12, { closeModal: handleClose, children: /* @__PURE__ */ jsxs88("div", { className: src_internals_components_modal_notificationModal_default.modalContent, children: [
    /* @__PURE__ */ jsx106("div", { className: src_internals_components_modal_notificationModal_default.img, children: /* @__PURE__ */ jsx106(Icon32, { name: "circlecheckmark", width: 115, height: 115 }) }),
    /* @__PURE__ */ jsx106("div", { className: src_internals_components_modal_notificationModal_default.modalTitle, children: title }),
    /* @__PURE__ */ jsxs88("div", { className: src_internals_components_modal_notificationModal_default.modalText, children: [
      message,
      children
    ] })
  ] }) }) : null;
};
var notificationModal_default = ModalNotification;

// src/internals/components/printView/index.jsx
import _96 from "lodash/fp.js";
import { useEffect as useEffect19, useRef as useRef10, useState as useState45 } from "react";
import { Button as Button45, KIT_CLASSNAME_INVERTED_THEME, Z_PRESENTATION_MODE, ZoomFrame } from "@lls/lls-kit";
import { cx as cx26, getPageInterval as getPageInterval3 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_printView_index.module.css
var src_internals_components_printView_index_default = { "pagination": "sk-fTnTIa-pagination", "pageImage": "sk-fTnTIa-pageImage", "printView": "sk-fTnTIa-printView", "pages": "sk-fTnTIa-pages", "zoomFrame": "sk-fTnTIa-zoomFrame" };

// src/internals/components/printView/index.jsx
import { Fragment as Fragment33, jsx as jsx107, jsxs as jsxs89 } from "react/jsx-runtime";
var PROJECTOR_INTERFACE_DURATION = 3e3;
var PageImg = ({ src, disabled }) => /* @__PURE__ */ jsxs89("div", { className: src_internals_components_printView_index_default.pageImage, "data-disabled": +disabled, children: [
  /* @__PURE__ */ jsx107("img", { src }),
  /* @__PURE__ */ jsx107("div", {})
] });
var PrintView = ({
  children,
  currentPage = {},
  className,
  isPresentationMode = false,
  presentationToolbarHeight = 64,
  onGoTo = _96.noop
}) => {
  const [isPaginationVisible, setIsPaginationVisible] = useState45(false);
  const [isInsideUi, setIsInsideUi] = useState45(false);
  const timeoutRef = useRef10(void 0);
  useEffect19(() => {
    if (!window) return;
    const handleMouseMove = () => {
      setIsPaginationVisible(true);
      clearTimeout(timeoutRef.current);
      if (!isInsideUi) {
        timeoutRef.current = setTimeout(() => {
          setIsPaginationVisible(false);
        }, PROJECTOR_INTERFACE_DURATION);
      }
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isInsideUi]);
  useEffect19(
    () => () => {
      clearTimeout(timeoutRef.current);
    },
    []
  );
  const handleMouseEnter = () => {
    setIsInsideUi(true);
    clearTimeout(timeoutRef.current);
    setIsPaginationVisible(true);
  };
  const handleMouseLeave = () => {
    setIsInsideUi(false);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIsPaginationVisible(false);
    }, PROJECTOR_INTERFACE_DURATION);
  };
  return /* @__PURE__ */ jsxs89(Fragment33, { children: [
    /* @__PURE__ */ jsxs89(
      "div",
      {
        style: {
          "--s-presentationtoolbarheight": `${presentationToolbarHeight}px`
        },
        className: cx26(className, src_internals_components_printView_index_default.printView),
        "data-ispresentation": +isPresentationMode,
        children: [
          children,
          _96.flow([
            _96.getOr([], "printUrls"),
            _96.chunk(2),
            _96.map(([leftPage, rightPage]) => /* @__PURE__ */ jsx107(
              ZoomFrame,
              {
                className: src_internals_components_printView_index_default.zoomFrame,
                "data-ispresentation": +isPresentationMode,
                children: /* @__PURE__ */ jsxs89("div", { className: src_internals_components_printView_index_default.pages, children: [
                  _96.has("url", leftPage) && /* @__PURE__ */ jsx107(PageImg, { src: _96.get("url", leftPage), disabled: +_96.get("blurred", leftPage) }),
                  _96.has("url", rightPage) && /* @__PURE__ */ jsx107(PageImg, { src: _96.get("url", rightPage), disabled: +_96.get("blurred", rightPage) })
                ] })
              },
              _96.get("url", leftPage)
            ))
          ])(currentPage)
        ]
      }
    ),
    isPresentationMode && /* @__PURE__ */ jsxs89(
      "div",
      {
        className: cx26(KIT_CLASSNAME_INVERTED_THEME, src_internals_components_printView_index_default.pagination),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-ispaginationvisible": +isPaginationVisible,
        style: { "--s-zIndex": Z_PRESENTATION_MODE + 1 },
        children: [
          /* @__PURE__ */ jsx107(
            Button45,
            {
              size: "small",
              icon: "arrowleft",
              theme: "gray",
              accent: "floating",
              onClick: () => onGoTo({ indexOffset: -1 })
            }
          ),
          getPageInterval3({ page: currentPage }),
          /* @__PURE__ */ jsx107(
            Button45,
            {
              size: "small",
              icon: "arrowright",
              theme: "gray",
              accent: "floating",
              onClick: () => onGoTo({ indexOffset: 1 })
            }
          )
        ]
      }
    )
  ] });
};
var printView_default = PrintView;

// src/internals/components/reportFooter/index.tsx
import { useCallback as useCallback43, useState as useState46 } from "react";
import { Button as Button47 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent12 } from "@lls/utils";

// src/internals/components/reportFooter/assets.jsx
import { jsx as jsx108, jsxs as jsxs90 } from "react/jsx-runtime";
var Sparkles = (props) => /* @__PURE__ */ jsxs90("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 276.34 192.04", ...props, children: [
  /* @__PURE__ */ jsx108("path", { d: "M56,31.8a2,2,0,0,1-1.85-1.23c-.36-.86-.81-2.06-1.34-3.46C49,17,46.22,11.61,44.67,11.27a2,2,0,0,1-2-2,2,2,0,0,1,2-2c4.12,0,7.21,6.21,11.82,18.43.51,1.36.95,2.53,1.28,3.32a2,2,0,0,1-1.07,2.62A1.9,1.9,0,0,1,56,31.8Z" }),
  /* @__PURE__ */ jsx108("path", { d: "M42.17,58a2,2,0,0,1-.93-.23,126.64,126.64,0,0,0-15-6.36c-6.11-2.28-12.43-4.64-18.48-8.29A2,2,0,0,1,9.8,39.7c5.74,3.46,11.61,5.65,17.82,8a130.4,130.4,0,0,1,15.49,6.56A2,2,0,0,1,42.17,58Z" }),
  /* @__PURE__ */ jsx108("path", { d: "M24.06,98.28a2,2,0,0,1-.44-4c4.86-1.11,9.77-1.75,14.51-2.38l1.62-.22a2,2,0,1,1,.53,4l-1.62.21c-4.87.65-9.47,1.26-14.15,2.32A1.73,1.73,0,0,1,24.06,98.28Z" }),
  /* @__PURE__ */ jsx108("path", { d: "M258,148.35a2,2,0,0,1-1-.25c-2.45-1.37-5.69-1.7-9.12-2a46.09,46.09,0,0,1-6.84-1,2,2,0,1,1,1-3.87,43.67,43.67,0,0,0,6.23.93c3.68.37,7.49.76,10.67,2.53a2,2,0,0,1-1,3.75Z" }),
  /* @__PURE__ */ jsx108("path", { d: "M261.52,192a2.06,2.06,0,0,1-.76-.15A53.65,53.65,0,0,1,246.82,184c-3-2.45-5.14-5.69-7.23-8.83-3-4.55-5.85-8.85-10.91-10.23a2,2,0,1,1,1-3.86c6.51,1.78,9.91,6.91,13.2,11.88,2,3,3.9,5.88,6.42,7.94a49.74,49.74,0,0,0,12.93,7.33,2,2,0,0,1-.76,3.85Z" }),
  /* @__PURE__ */ jsx108("path", { d: "M245.33,128.47a1.73,1.73,0,0,1-.32,0,1.5,1.5,0,0,1-1.15-1.15,1.46,1.46,0,0,1-.57-.83,17.25,17.25,0,0,0-3.14-5.76c-7.47-.39-8.86-1.13-9.15-2.63-.2-1,.4-1.87,1.79-2.51a12.47,12.47,0,0,1,3.13-.77,12.27,12.27,0,0,0,2.63-.61l0-.07a14.51,14.51,0,0,0-1.8-1.91,14.35,14.35,0,0,1-2.3-2.56,1.66,1.66,0,0,1,.16-2c1-1.09,2.39-.56,6.37,1.1l1,.4c.53.17.93.34,1.22.46l.19.09a9.65,9.65,0,0,0,.9-.73,4.67,4.67,0,0,0,1-1.5,11.25,11.25,0,0,1,1.27-2.07c.72-.91,1.81-2.27,3.24-1.83.89.27,1.39,1.08,1.48,2.41v.15a32.89,32.89,0,0,1-.85,6.68c-.05.24-.12.51-.15.71.17.09.43.22.78.38a15.64,15.64,0,0,1,2.81,1.82,16.39,16.39,0,0,0,2.14,1.44c2.23,1.08,2,2.47,1.85,3-.49,1.42-2.33,1.82-3.9,1.49a15.23,15.23,0,0,0-5.79,0c-.24.39-.66,1.54-1.18,4.83-.06.37-.11.64-.14.79A1.49,1.49,0,0,1,245.33,128.47Zm-7.65-10.94q1.13.09,2.7.18l.5,0,.27,0,.23.1c.73.33,2.19,2.19,3.35,4.33.56-2,1.28-3.16,2.48-3.41a18.14,18.14,0,0,1,5.21-.32l-.41-.31a14.31,14.31,0,0,0-2.26-1.49c-2.6-1.19-2.84-2.11-2.3-4.49a30.27,30.27,0,0,0,.61-3.61l-.15.3a7.29,7.29,0,0,1-1.71,2.4c-1.74,1.52-2.55,1.88-4.25,1.14A8.4,8.4,0,0,0,241,112c-.09,0-.23-.08-.42-.15a5.65,5.65,0,0,1,.59.84,2.92,2.92,0,0,1,.16,2.77C240.72,116.74,239.27,117.22,237.68,117.53Z" })
] });
var Arrow1 = (props) => /* @__PURE__ */ jsxs90("svg", { width: "127", height: "46", viewBox: "0 23 127 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx108(
    "path",
    {
      d: "M6.70929 52.8705C22.2038 77.1503 48.4564 60.905 57.6433 55.3872C75.644 44.5758 99.9845 45.4134 116.503 41.5224",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ jsx108(
    "path",
    {
      d: "M109.736 36.6997C111.692 37.6337 114.071 38.0482 116.161 38.8217C117.026 39.1414 119.365 39.5043 119.293 39.8288C119.162 40.4175 117.292 42.3338 115.693 44.2104C114.867 45.1789 112.299 48.2086 111.525 49.0453",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round"
    }
  )
] });
var Arrow2 = (props) => /* @__PURE__ */ jsxs90("svg", { width: "81", height: "94", viewBox: "0 0 81 94", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx108(
    "path",
    {
      d: "M78.4144 76.3633C79.1066 64.1251 67.6606 52.7944 55.5817 49.5365C45.2901 46.7608 31.6946 51 36.6946 56C41.6946 61 47.1735 46.3886 33.1946 34.5001C26.3743 28.6996 21.6946 25.5001 5.69458 18.0001",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ jsx108(
    "path",
    {
      d: "M7.90824 26.2801C7.06849 24.277 4.81156 20.9715 3.764 18.9985C3.33095 18.1829 1.82289 16.3506 2.09329 16.1561C2.58394 15.8031 5.261 15.6174 7.7091 15.2808C8.97258 15.1072 12.9143 14.5543 14.0509 14.4444",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round"
    }
  )
] });
var PaperPlane = (props) => /* @__PURE__ */ jsx108("svg", { width: "25", height: "21", viewBox: "0 0 25 21", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx108(
  "path",
  {
    d: "M4.44393 17.7222C3.91235 15.5067 3.42386 13.2836 2.85636 11.0756C2.1021 8.15175 1.24008 5.25046 0.521732 2.3115C0.0332551 0.337125 0.327785 0.141204 2.1452 0.661174C5.65792 1.6559 9.20657 2.51497 12.7049 3.56245C16.6343 4.73803 20.736 5.52176 23.9902 8.45318C24.1011 8.53393 24.1893 8.64443 24.2457 8.77316C24.302 8.90189 24.3244 9.04414 24.3105 9.18503C24.2965 9.32592 24.2468 9.4603 24.1664 9.57415C24.0861 9.68799 23.9781 9.77713 23.8537 9.83223C23.055 10.3422 22.2045 10.7567 21.3179 11.0681C20.4584 11.2933 19.6802 11.777 19.0792 12.4598C18.4781 13.1425 18.0802 13.9946 17.9345 14.9114C17.4772 16.5481 16.918 18.1516 16.2607 19.7117C15.9518 20.5029 15.5783 20.5858 14.9246 20.1713C14.2709 19.7569 13.531 19.3349 12.8414 18.9053C12.432 18.6491 11.4981 18.3401 11.8429 17.6695C11.9004 17.5564 12.2524 17.4208 12.2093 17.2475C11.965 17.2927 9.68068 18.6416 9.49391 18.7546C9.07326 19.0682 8.62315 19.3359 8.1506 19.5534C8.01412 19.6137 7.29576 19.7644 6.65643 19.9453C6.31143 20.0395 5.9456 19.9999 5.62621 19.8337C5.30683 19.6676 5.05537 19.3861 4.91804 19.041C4.69535 18.4909 4.50139 17.9408 4.44393 17.7222ZM7.95664 17.8277C9.07007 17.2701 10.1691 16.6747 11.3041 16.1698C11.7895 15.5559 12.4665 15.1421 13.2149 15.0018C12.5612 14.3763 12.0009 13.9242 11.5412 13.3816C9.35743 10.8345 7.20238 8.27232 5.07608 5.69508C4.90367 5.48408 4.91803 5.11482 4.8462 4.82092C5.1542 4.84653 5.4556 4.92814 5.73694 5.06208C9.03626 7.57236 12.5985 9.67849 16.3541 11.3394C16.5719 11.451 16.8144 11.4988 17.056 11.4775C17.2975 11.4563 17.5291 11.3669 17.7262 11.2188C18.9186 10.518 20.1973 9.97541 21.4472 9.38008C21.8279 9.19922 22.2302 9.07866 22.848 8.84505C16.0381 5.69509 9.09163 3.84882 1.81477 2.06283C3.43105 7.66946 4.98987 13.0651 6.57742 18.5587C7.03716 18.2723 7.50408 18.0613 7.95664 17.8277ZM13.0497 12.6582C14.2781 13.7885 15.607 14.8134 15.7579 16.7727L16.9575 13.0048L10.1548 9.45545L10.0327 9.62877C11.0312 10.6612 11.9794 11.7011 13.0497 12.6582V12.6582ZM14.1919 17.6695C14.041 17.0666 13.9333 16.622 13.7968 16.0643L12.5684 16.8857L14.1919 17.6695Z",
    fill: "white"
  }
) });

// src/internals/components/reportFooter/modal.tsx
import { Modal as Modal13 } from "@lls/lls-kit";

// src/internals/components/reportFooter/form.tsx
import { useCallback as useCallback42 } from "react";
import { Button as Button46, CheckBox as CheckBox3, SelectField2 as SelectField9, TextField as TextField7 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent11 } from "@lls/utils";
import _97 from "lodash/fp.js";
import { Controller, useForm } from "react-hook-form";

// tmp_esbuild1736180050074/_src_internals_components_reportFooter_form.module.css
var src_internals_components_reportFooter_form_default = { "textField": "sk-J2i43G-textField", "correctionTextLink": "sk-J2i43G-correctionTextLink", "modalDescription": "sk-J2i43G-modalDescription", "label": "sk-J2i43G-label", "submit": "sk-J2i43G-submit", "form": "sk-J2i43G-form", "fieldContainer": "sk-J2i43G-fieldContainer" };

// src/internals/components/reportFooter/form.tsx
import { jsx as jsx109, jsxs as jsxs91 } from "react/jsx-runtime";
var OPTIONS = [
  {
    value: 1,
    label: "Proposer une id\xE9e (contenu, fonctionnalit\xE9)"
  },
  {
    value: 2,
    label: "Signaler une erreur (coquille, contenu obsol\xE8te\u2026)"
  },
  {
    value: 3,
    label: "Acc\xE9der aux corrections"
  },
  {
    value: 4,
    label: "Donner votre avis"
  }
];
var ReportForm = ({ close, defaultSuggestionType, user, onSubmitReport, isFree }) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isDirty: isDirty2, isValid },
    watch
  } = useForm({
    defaultValues: {
      suggestionType: defaultSuggestionType,
      details: "",
      consent: false,
      email: ""
    },
    mode: "onBlur"
  });
  const submit = useCallback42(
    (data, e) => {
      e == null ? void 0 : e.preventDefault();
      const { suggestionType, details, email } = data;
      dispatchAnalyticsEvent11(ANALYTICS_EVENT_REPORT_SENT);
      onSubmitReport({
        suggestionType: _97.flow(_97.find({ value: suggestionType }), _97.get("label"))(OPTIONS),
        details,
        email
      });
      close();
    },
    [onSubmitReport, close]
  );
  const hasUserConsent = watch("consent");
  const watchSuggestionType = watch("suggestionType");
  const displayFields = watchSuggestionType !== 3;
  return /* @__PURE__ */ jsxs91("form", { className: src_internals_components_reportFooter_form_default.form, onSubmit: handleSubmit(submit), children: [
    /* @__PURE__ */ jsx109("p", { className: src_internals_components_reportFooter_form_default.modalDescription, children: "Pour proposer une am\xE9lioration, sugg\xE9rer une \xE9volution ou tout simplement signaler une erreur, merci d'utiliser le formulaire ci-dessous. Pour toute autre question, n'h\xE9sitez pas \xE0 utiliser notre FAQ avant de nous contacter." }),
    /* @__PURE__ */ jsxs91("div", { className: src_internals_components_reportFooter_form_default.fieldContainer, children: [
      /* @__PURE__ */ jsx109("p", { className: src_internals_components_reportFooter_form_default.label, children: "Ma demande concerne :" }),
      /* @__PURE__ */ jsx109(
        Controller,
        {
          name: "suggestionType",
          control,
          rules: {
            required: {
              value: true,
              message: "Le type de suggestion est obligatoire"
            }
          },
          render: ({ field }) => /* @__PURE__ */ jsx109(
            SelectField9,
            {
              listMaxHeight: "165px",
              width: "350px",
              "margin-bottom": "18px",
              options: OPTIONS,
              state: _97.has("suggestionType", errors) ? "error" : void 0,
              hint: _97.get("suggestionType.message", errors),
              ...field
            }
          )
        }
      )
    ] }),
    displayFields && /* @__PURE__ */ jsxs91("div", { className: src_internals_components_reportFooter_form_default.fieldContainer, children: [
      /* @__PURE__ */ jsx109("p", { className: src_internals_components_reportFooter_form_default.label, children: "Description :" }),
      /* @__PURE__ */ jsx109(
        Controller,
        {
          name: "details",
          control,
          rules: {
            minLength: {
              value: 20,
              message: "20 caract\xE8res minimum"
            },
            required: {
              value: true,
              message: "20 caract\xE8res minimum"
            }
          },
          render: ({ field }) => /* @__PURE__ */ jsx109(
            TextField7,
            {
              className: src_internals_components_reportFooter_form_default.textField,
              placeholder: "D\xE9taillez votre message",
              multiline: true,
              rows: 6,
              width: "100%",
              state: _97.has("details", errors) ? "error" : void 0,
              hint: _97.get("details.message", errors),
              ...field
            }
          )
        }
      )
    ] }),
    !isFree && !_97.get("email", user) && displayFields ? /* @__PURE__ */ jsx109("div", { className: src_internals_components_reportFooter_form_default.fieldContainer, children: /* @__PURE__ */ jsx109(
      Controller,
      {
        name: "consent",
        control,
        render: ({ field }) => /* @__PURE__ */ jsx109(CheckBox3, { label: "Je souhaite \xEAtre inform\xE9(e) quand ma demande aura \xE9t\xE9 trait\xE9e", ...field })
      }
    ) }) : null,
    (isFree || !isFree && hasUserConsent) && displayFields ? /* @__PURE__ */ jsxs91("div", { className: src_internals_components_reportFooter_form_default.fieldContainer, children: [
      /* @__PURE__ */ jsx109("p", { className: src_internals_components_reportFooter_form_default.label, children: "Comment pouvons-nous vous recontacter ?" }),
      /* @__PURE__ */ jsx109(
        Controller,
        {
          name: "email",
          control,
          rules: {
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: "Vous devez entrer un email valide"
            },
            required: {
              value: true,
              message: "L'email est obligatoire"
            }
          },
          render: ({ field }) => /* @__PURE__ */ jsx109(
            TextField7,
            {
              className: src_internals_components_reportFooter_form_default.textField,
              icon: "envelope",
              label: "Votre email",
              state: _97.has("email", errors) ? "error" : void 0,
              hint: _97.get("email.message", errors),
              ...field
            }
          )
        }
      )
    ] }) : null,
    !displayFields && /* @__PURE__ */ jsxs91("p", { className: src_internals_components_reportFooter_form_default.correctionText, children: [
      "Les corrections sont uniquement disponibles pour les enseignants. Vous pouvez y acc\xE9der",
      " ",
      /* @__PURE__ */ jsx109("a", { className: src_internals_components_reportFooter_form_default.correctionTextLink, href: "https://www.lelivrescolaire.fr/le-livre-du-professeur/", children: "sur cette page" }),
      "."
    ] }),
    /* @__PURE__ */ jsxs91("div", { className: src_internals_components_reportFooter_form_default.submit, children: [
      /* @__PURE__ */ jsx109(Button46, { theme: "gray", accent: "floating", onClick: close, children: "Annuler" }),
      /* @__PURE__ */ jsx109(Button46, { icon: "paperplane", type: "submit", disabled: !isDirty2 || !isValid || !displayFields, children: "Envoyer" })
    ] })
  ] });
};
var form_default = ReportForm;

// tmp_esbuild1736180050074/_src_internals_components_reportFooter_modal.module.css
var src_internals_components_reportFooter_modal_default = { "modalContent": "sk-zNy1qW-modalContent" };

// src/internals/components/reportFooter/modal.tsx
import { jsx as jsx110 } from "react/jsx-runtime";
var ReportModal = ({ close, ...props }) => {
  return /* @__PURE__ */ jsx110(Modal13, { title: "Contacter l'\xE9quipe LLS", closeModal: close, children: /* @__PURE__ */ jsx110("div", { className: src_internals_components_reportFooter_modal_default.modalContent, children: /* @__PURE__ */ jsx110(form_default, { close, ...props }) }) });
};
var modal_default = ReportModal;

// src/internals/components/reportFooter/index.tsx
import _98 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_reportFooter_index.module.css
var src_internals_components_reportFooter_index_default = { "container": "sk-56ytEq-container", "sparkles": "sk-56ytEq-sparkles", "text": "sk-56ytEq-text", "marker": "sk-56ytEq-marker superkit-permanentMarkerRegular", "cta": "sk-56ytEq-cta", "h3": "sk-56ytEq-h3", "bubble": "sk-56ytEq-bubble", "buttonContainer": "sk-56ytEq-buttonContainer" };

// src/internals/components/reportFooter/index.tsx
import { Fragment as Fragment34, jsx as jsx111, jsxs as jsxs92 } from "react/jsx-runtime";
var ReportFooter = ({
  onSubmitReport = _98.noop,
  isFree = false,
  user,
  isPresentationMode = false,
  isOffline = false
}) => {
  const [isReportModalOpen, setIsReportModalOpen] = useState46(false);
  const [defaultSuggestionType, setDefaultSuggestionType] = useState46(void 0);
  const openModalWithDefaultOption = useCallback43((defaultOption) => {
    dispatchAnalyticsEvent12(ANALYTICS_EVENTS_REPORT_STARTED);
    setDefaultSuggestionType(defaultOption);
    setIsReportModalOpen(true);
  }, []);
  const [isOfflineModalOpen, setIsOfflineModalOpen] = useState46(false);
  const closeOfflineModal = useCallback43(() => setIsOfflineModalOpen(false), []);
  const handleClick = (defaultOption) => {
    if (isOffline) {
      setIsOfflineModalOpen(true);
    } else {
      openModalWithDefaultOption(defaultOption);
    }
  };
  return /* @__PURE__ */ jsxs92(Fragment34, { children: [
    /* @__PURE__ */ jsxs92("div", { className: src_internals_components_reportFooter_index_default.container, "data-is-free": +isFree, "data-ispresentationmode": +isPresentationMode, children: [
      /* @__PURE__ */ jsx111("h3", { className: src_internals_components_reportFooter_index_default.h3, tabIndex: 0, children: "Une erreur sur la page ? Une id\xE9e \xE0 proposer ?" }),
      /* @__PURE__ */ jsx111("p", { className: src_internals_components_reportFooter_index_default.text, tabIndex: 0, children: "Nos manuels sont collaboratifs, n'h\xE9sitez pas \xE0 nous en faire part." }),
      /* @__PURE__ */ jsxs92("div", { className: src_internals_components_reportFooter_index_default.cta, children: [
        /* @__PURE__ */ jsxs92("div", { className: src_internals_components_reportFooter_index_default.bubble, "data-index": "1", onClick: () => handleClick(3), children: [
          /* @__PURE__ */ jsx111("p", { className: src_internals_components_reportFooter_index_default.marker, children: "Oups, une coquille" }),
          /* @__PURE__ */ jsx111(Arrow1, {})
        ] }),
        /* @__PURE__ */ jsxs92("div", { className: src_internals_components_reportFooter_index_default.buttonContainer, children: [
          /* @__PURE__ */ jsx111(Sparkles, { className: src_internals_components_reportFooter_index_default.sparkles }),
          /* @__PURE__ */ jsx111(
            Button47,
            {
              onClick: () => handleClick(void 0),
              theme: isFree ? "yellow" : "gray",
              accent: "main",
              inverted: !isFree,
              children: "Je contribue"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs92("div", { className: src_internals_components_reportFooter_index_default.bubble, "data-index": "2", onClick: () => handleClick(1), children: [
          /* @__PURE__ */ jsx111(PaperPlane, {}),
          /* @__PURE__ */ jsx111(Arrow2, {}),
          /* @__PURE__ */ jsx111("p", { className: src_internals_components_reportFooter_index_default.marker, children: "j'ai une id\xE9e !" })
        ] })
      ] })
    ] }),
    isOfflineModalOpen && /* @__PURE__ */ jsx111(offlineModal_default, { close: closeOfflineModal }),
    isReportModalOpen && /* @__PURE__ */ jsx111(
      modal_default,
      {
        onSubmitReport,
        close: () => setIsReportModalOpen(false),
        defaultSuggestionType,
        isFree,
        user
      }
    )
  ] });
};
var reportFooter_default = ReportFooter;

// src/internals/components/shareBar/index.jsx
import { useCallback as useCallback44, useEffect as useEffect20, useState as useState47 } from "react";
import { Button as Button48 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent13 } from "@lls/utils";
import _99 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_shareBar_index.module.css
var src_internals_components_shareBar_index_default = { "title": "sk-jWoqKW-title", "shareBar": "sk-jWoqKW-shareBar", "header": "sk-jWoqKW-header", "shareBarContainer": "sk-jWoqKW-shareBarContainer", "actions": "sk-jWoqKW-actions", "container": "sk-jWoqKW-container", "viewer-fullscreen-modal": "sk-jWoqKW-viewer-fullscreen-modal", "button": "sk-jWoqKW-button" };

// src/internals/components/shareBar/index.jsx
import { Fragment as Fragment35, jsx as jsx112, jsxs as jsxs93 } from "react/jsx-runtime";
var ANIMATION_SHAREBAR_DURATION = 500;
var ShareBar = ({
  isShown: isShownFromProps = false,
  isShareButtonDisabled = false,
  onShareClick = _99.noop,
  areSharedCorrections = false,
  shareProps = {},
  title = "Partager ma page"
}) => {
  const { setIsShareModalOpen = _99.noop, isShareModalOpen } = shareProps;
  const [isDisplayed, setIsDisplayed] = useState47(false);
  const [isAnimationLaunched, setIsAnimationLaunched] = useState47(false);
  const [isOpen, setIsOpen] = useState47(isShownFromProps);
  const openShareModal = useCallback44(() => setIsShareModalOpen(true), [setIsShareModalOpen]);
  const closeShareModal = useCallback44(() => setIsShareModalOpen(false), [setIsShareModalOpen]);
  const closeShareBar = useCallback44((event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsOpen(false);
  }, []);
  const openShareBar = useCallback44(() => {
    if (!isOpen) {
      setIsOpen(true);
      dispatchAnalyticsEvent13(ANALYTICS_EVENTS_PAGE_SHARE_STARTED);
    }
  }, [isOpen]);
  const onShareClickCb = useCallback44(() => {
    onShareClick();
    if (!areSharedCorrections) {
      openShareModal();
    }
  }, [areSharedCorrections, onShareClick, openShareModal]);
  useEffect20(() => {
    let animationTimeOut;
    if (isShownFromProps) {
      setIsOpen(true);
      setIsDisplayed(true);
    } else {
      setIsAnimationLaunched(false);
      animationTimeOut = setTimeout(() => {
        setIsDisplayed(false);
        setIsOpen(false);
      }, ANIMATION_SHAREBAR_DURATION);
    }
    return () => {
      clearTimeout(animationTimeOut);
    };
  }, [isShownFromProps]);
  useEffect20(() => {
    isOpen && isDisplayed && setIsAnimationLaunched(true);
  }, [isOpen, isDisplayed]);
  return isDisplayed ? /* @__PURE__ */ jsxs93(Fragment35, { children: [
    /* @__PURE__ */ jsx112("div", { className: src_internals_components_shareBar_index_default.shareBarContainer, children: /* @__PURE__ */ jsx112(
      "div",
      {
        className: src_internals_components_shareBar_index_default.shareBar,
        style: {
          "--s-isshown": isAnimationLaunched ? 0 : "105%",
          "--s-animation-sharebar-duration": `${ANIMATION_SHAREBAR_DURATION}ms`
        },
        "data-isopen": +isOpen,
        children: /* @__PURE__ */ jsxs93("div", { className: src_internals_components_shareBar_index_default.container, onClick: openShareBar, children: [
          /* @__PURE__ */ jsxs93("div", { className: src_internals_components_shareBar_index_default.header, children: [
            /* @__PURE__ */ jsx112("span", { className: src_internals_components_shareBar_index_default.title, children: title }),
            /* @__PURE__ */ jsx112(
              Button48,
              {
                onClick: isOpen ? closeShareBar : openShareBar,
                icon: isOpen ? "chevrondown" : "chevronup",
                theme: "gray",
                accent: "floating",
                size: "small"
              }
            )
          ] }),
          isOpen && /* @__PURE__ */ jsx112("div", { className: src_internals_components_shareBar_index_default.actions, children: /* @__PURE__ */ jsx112(
            Button48,
            {
              className: src_internals_components_shareBar_index_default.button,
              onClick: onShareClickCb,
              icon: "uploadcloud",
              disabled: isShareButtonDisabled,
              children: "Partager"
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ jsx112(shareModal_default, { ...shareProps, isModalOpen: isShareModalOpen, closeModal: closeShareModal })
  ] }) : null;
};
var shareBar_default = ShareBar;

// src/internals/components/copies/teacherAppreciationHeader.jsx
import { useCallback as useCallback45, useEffect as useEffect21, useState as useState48 } from "react";
import { Button as Button49, TextField as TextField8 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_copies_teacherAppreciationHeader.module.css
var src_internals_components_copies_teacherAppreciationHeader_default = { "cardContent": "sk-v3U51G-cardContent", "editAppreciation": "sk-v3U51G-editAppreciation", "title": "sk-v3U51G-title", "buttonContainer": "sk-v3U51G-buttonContainer", "card": "sk-v3U51G-card" };

// src/internals/components/copies/teacherAppreciationHeader.jsx
import { jsx as jsx113, jsxs as jsxs94 } from "react/jsx-runtime";
var EditAppreciation = ({ content, setAppreciationInput, title }) => {
  return /* @__PURE__ */ jsxs94("div", { className: src_internals_components_copies_teacherAppreciationHeader_default.editAppreciation, children: [
    /* @__PURE__ */ jsx113("div", { className: src_internals_components_copies_teacherAppreciationHeader_default.title, children: title }),
    /* @__PURE__ */ jsx113(
      TextField8,
      {
        "data-clarity-mask": "true",
        value: content,
        onChange: setAppreciationInput,
        width: "100%",
        multiline: true,
        rows: "5"
      }
    )
  ] });
};
var TeacherAppreciationHeader = ({ onSend, appreciationDefaultContent, teacher }) => {
  const [appreciationInput, setAppreciationInput] = useState48(appreciationDefaultContent);
  const [isShownAppreciationHeader, setIsShownAppreciationHeader] = useState48(false);
  useEffect21(() => {
    setAppreciationInput(appreciationDefaultContent);
    setIsShownAppreciationHeader(!!appreciationDefaultContent);
  }, [appreciationDefaultContent]);
  const onSendClick = useCallback45(() => {
    onSend(appreciationInput);
    setIsShownAppreciationHeader(true);
  }, [onSend, appreciationInput]);
  const onToggleEdit = useCallback45(() => {
    setIsShownAppreciationHeader(false);
  }, []);
  const title = "R\xE9digez une appr\xE9ciation";
  return /* @__PURE__ */ jsx113("div", { className: src_internals_components_copies_teacherAppreciationHeader_default.card, children: /* @__PURE__ */ jsxs94("div", { className: src_internals_components_copies_teacherAppreciationHeader_default.cardContent, children: [
    isShownAppreciationHeader ? /* @__PURE__ */ jsx113(
      appreciationHeader_default,
      {
        className: "superkit-teacher-appreciation-header",
        content: appreciationInput,
        teacher,
        title
      }
    ) : /* @__PURE__ */ jsx113(EditAppreciation, { title, content: appreciationInput, setAppreciationInput }),
    /* @__PURE__ */ jsx113("div", { className: src_internals_components_copies_teacherAppreciationHeader_default.buttonContainer, children: /* @__PURE__ */ jsx113(
      Button49,
      {
        disabled: !appreciationInput,
        icon: isShownAppreciationHeader ? "squareandpencil" : "paperplane",
        onClick: isShownAppreciationHeader ? onToggleEdit : onSendClick,
        children: isShownAppreciationHeader ? "Actualiser" : "Envoyer"
      }
    ) })
  ] }) });
};
var teacherAppreciationHeader_default = TeacherAppreciationHeader;

// src/internals/components/shareCorrections/breadcrumb.tsx
import _100 from "lodash/fp.js";
import { Button as Button50, SwitchButton as SwitchButton4 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_shareCorrections_breadcrumb.module.css
var src_internals_components_shareCorrections_breadcrumb_default = { "span": "sk-fscOOq-span", "card": "sk-fscOOq-card", "div": "sk-fscOOq-div", "leftContent": "sk-fscOOq-leftContent", "title": "sk-fscOOq-title" };

// src/internals/components/shareCorrections/breadcrumb.tsx
import { jsx as jsx114, jsxs as jsxs95 } from "react/jsx-runtime";
var Breadcrumb = ({ documents, onGoBack, areAnsweredDocumentsShown, onAnsweredDocumentsChange }) => {
  return /* @__PURE__ */ jsxs95("div", { className: src_internals_components_shareCorrections_breadcrumb_default.card, children: [
    /* @__PURE__ */ jsxs95("div", { className: src_internals_components_shareCorrections_breadcrumb_default.leftContent, children: [
      /* @__PURE__ */ jsx114(Button50, { onClick: onGoBack, icon: "arrowleft", theme: "gray", inverted: true }),
      /* @__PURE__ */ jsx114("span", { className: src_internals_components_shareCorrections_breadcrumb_default.span, children: "Retour" })
    ] }),
    /* @__PURE__ */ jsx114("h1", { className: src_internals_components_shareCorrections_breadcrumb_default.title, children: "S\xE9lectionnez les corrections issues du livre du professeur" }),
    /* @__PURE__ */ jsx114("div", { className: src_internals_components_shareCorrections_breadcrumb_default.div, children: !_100.isEmpty(documents) && /* @__PURE__ */ jsx114(
      SwitchButton4,
      {
        value: areAnsweredDocumentsShown,
        onChange: onAnsweredDocumentsChange,
        falseLabel: "N'afficher que les r\xE9ponses",
        trueLabel: "N'afficher que les r\xE9ponses"
      }
    ) })
  ] });
};
var breadcrumb_default3 = Breadcrumb;

// src/internals/components/toolbar/index.jsx
import _117 from "lodash/fp.js";
import { useCallback as useCallback51, useEffect as useEffect24, useState as useState51 } from "react";
import { styleThemeProps as styleThemeProps2 } from "@lls/lls-kit";
import { cx as cx30 } from "@lls/utils";

// src/internals/components/modal/deletePageModal.jsx
import _101 from "lodash/fp.js";
import { Button as Button51, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME6, Modal as Modal14 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_modal_deletePageModal.module.css
var src_internals_components_modal_deletePageModal_default = { "modalContent": "sk-Hs92sq-modalContent", "buttonContainer": "sk-Hs92sq-buttonContainer" };

// src/internals/components/modal/deletePageModal.jsx
import { jsx as jsx115, jsxs as jsxs96 } from "react/jsx-runtime";
var DeletePageModal = ({ close, page: { title = "" } = {}, onDelete = _101.noop, className = "", ...props }) => {
  const onSubmit = (e) => {
    e.preventDefault();
    onDelete();
    close();
  };
  return /* @__PURE__ */ jsx115(
    Modal14,
    {
      title: "Supprimer la page",
      closeModal: close,
      className: `${KIT_CLASSNAME_LIGHT_THEME6} ${className}`,
      ...props,
      children: /* @__PURE__ */ jsxs96("form", { onSubmit, children: [
        /* @__PURE__ */ jsxs96("div", { className: src_internals_components_modal_deletePageModal_default.modalContent, children: [
          '\xCAtes-vous s\xFBr(e) de vouloir supprimer votre page personnelle "',
          title,
          '" ?'
        ] }),
        /* @__PURE__ */ jsxs96("div", { className: src_internals_components_modal_deletePageModal_default.buttonContainer, children: [
          /* @__PURE__ */ jsx115(Button51, { onClick: close, icon: "arrowleft", size: "medium", theme: "gray", accent: "floating", children: "Annuler" }),
          /* @__PURE__ */ jsx115(Button51, { type: "submit", icon: "trash", size: "medium", theme: "error", children: "Supprimer" })
        ] })
      ] })
    }
  );
};
var deletePageModal_default = DeletePageModal;

// src/internals/components/modal/savePageModal.jsx
import { useState as useState49 } from "react";
import _102 from "lodash/fp.js";
import { Button as Button52, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME7, Modal as Modal15, TextField as TextField9 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_modal_savePageModal.module.css
var src_internals_components_modal_savePageModal_default = { "buttonContainer": "sk-cE_NiG-buttonContainer", "modalContent": "sk-cE_NiG-modalContent" };

// src/internals/components/modal/savePageModal.jsx
import { jsx as jsx116, jsxs as jsxs97 } from "react/jsx-runtime";
var SAVE_MODAL_STATUS = {
  CLOSED: 0,
  SAVE: 1,
  RENAME: 2,
  COPY: 3
};
var SAVE_MODAl_LABELS = {
  [SAVE_MODAL_STATUS.SAVE]: {
    title: "Enregistrer la page",
    action: "Enregistrer",
    icon: "uploadcloud"
  },
  [SAVE_MODAL_STATUS.RENAME]: {
    title: "Renommer la page",
    action: "Renommer",
    icon: "edit"
  },
  [SAVE_MODAL_STATUS.COPY]: {
    // Coming soon
    title: "",
    action: "",
    icon: ""
  }
};
var inputWidth = "342px";
var SavePageModal = ({ close, page, onSave = _102.noop, saveModalStatus, className = "", ...props }) => {
  const [title, setTitle] = useState49((page == null ? void 0 : page.displayTitle) ?? "");
  const onSubmit = (e) => {
    e.preventDefault();
    onSave(title);
    close();
  };
  return /* @__PURE__ */ jsx116(
    Modal15,
    {
      title: _102.get([saveModalStatus, "title"], SAVE_MODAl_LABELS),
      closeModal: close,
      className: `${KIT_CLASSNAME_LIGHT_THEME7} ${className}`,
      ...props,
      children: /* @__PURE__ */ jsxs97("form", { onSubmit, children: [
        /* @__PURE__ */ jsx116("div", { className: src_internals_components_modal_savePageModal_default.modalContent, children: /* @__PURE__ */ jsx116(TextField9, { label: "Nommez votre page", value: title, onChange: setTitle, width: inputWidth }) }),
        /* @__PURE__ */ jsxs97("div", { className: src_internals_components_modal_savePageModal_default.buttonContainer, children: [
          /* @__PURE__ */ jsx116(Button52, { onClick: close, icon: "arrowleft", size: "medium", theme: "gray", accent: "floating", children: "Annuler" }),
          /* @__PURE__ */ jsx116(
            Button52,
            {
              type: "submit",
              icon: _102.get([saveModalStatus, "icon"], SAVE_MODAl_LABELS),
              size: "medium",
              disabled: !title,
              children: _102.get([saveModalStatus, "action"], SAVE_MODAl_LABELS)
            }
          )
        ] })
      ] })
    }
  );
};
var savePageModal_default = SavePageModal;

// tmp_esbuild1736180050074/_src_internals_components_toolbar_index.module.css
var src_internals_components_toolbar_index_default = { "accessibilityElement": "sk-oRokIG-accessibilityElement kit-themecss" };

// src/internals/components/toolbar/presentationToolbar.tsx
import _106 from "lodash/fp.js";
import { Button as Button54, Divider as Divider10, KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME4, Tooltip as Tooltip11, Z_TOOLBAR } from "@lls/lls-kit";
import { cx as cx28, dispatchAnalyticsEvent as dispatchAnalyticsEvent16 } from "@lls/utils";

// src/internals/components/toolbar/laserCursor.tsx
import { getBrowserHeight, getBrowserWidth } from "@lls/utils";
import _103 from "lodash/fp.js";
import { useEffect as useEffect22, useRef as useRef11, useState as useState50 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_toolbar_laserCursor.module.css
var src_internals_components_toolbar_laserCursor_default = { "laserCursor": "sk-3wvhLq-laserCursor", "laserClick": "sk-3wvhLq-laserClick", "laserCanvas": "sk-3wvhLq-laserCanvas", "animTraces": "sk-3wvhLq-animTraces" };

// src/internals/components/toolbar/laserCursor.tsx
import { Fragment as Fragment36, jsx as jsx117, jsxs as jsxs98 } from "react/jsx-runtime";
var TRAIL_DURATION = 400;
var RIPPLE_DURATION = 2e3;
var DRAW_INTERVAL = 1e3 / 10;
var LASER_COLOR = "#ff5c93";
var LaserCursor = () => {
  const laserRef = useRef11(null);
  const canvasRef = useRef11(null);
  const pointsRef = useRef11([]);
  const [browserHeight, setBrowserHeight] = useState50(0);
  const [browserWidth, setBrowserWidth] = useState50(0);
  const [ripplePoints, setRipplePoints] = useState50([]);
  useEffect22(() => {
    var _a;
    const ctx = (_a = canvasRef.current) == null ? void 0 : _a.getContext("2d");
    if (!ctx) return;
    const animatePoints = () => {
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
      ctx.lineJoin = "round";
      ctx.lineCap = "round";
      let lastPoint = pointsRef.current[0];
      for (const point of pointsRef.current) {
        const lifePercent = (Date.now() - point.lifetime) / TRAIL_DURATION;
        const spreadRate = 11 * (1 - lifePercent);
        ctx.beginPath();
        ctx.lineWidth = spreadRate;
        ctx.strokeStyle = LASER_COLOR;
        ctx.moveTo(lastPoint.x, lastPoint.y);
        ctx.lineTo(point.x, point.y);
        ctx.stroke();
        ctx.closePath();
        lastPoint = point;
      }
    };
    const canvasInterval = setInterval(requestAnimationFrame, DRAW_INTERVAL, animatePoints);
    return () => {
      clearInterval(canvasInterval);
    };
  }, []);
  useEffect22(() => {
    const activeTimeouts = [];
    const addPoint = (x, y) => {
      const pointId = _103.uniqueId("point");
      const point = { x, y, lifetime: Date.now(), pointId };
      pointsRef.current = [...pointsRef.current, point];
      const pointTimeout = setTimeout(() => {
        pointsRef.current = _103.reject({ pointId }, pointsRef.current);
      }, TRAIL_DURATION - 50);
      activeTimeouts.push(pointTimeout);
    };
    const onMouseMove = (e) => {
      if (!laserRef.current || !canvasRef.current) return;
      laserRef.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      addPoint(e.clientX - canvasRef.current.offsetLeft, e.clientY - canvasRef.current.offsetTop);
    };
    const onClick = (e) => {
      const rippleId = _103.uniqueId("ripple");
      setRipplePoints((prev) => [
        ...prev,
        {
          id: rippleId,
          x: e.clientX,
          y: e.clientY
        }
      ]);
      const rippleTimeout = setTimeout(() => {
        setRipplePoints((prev) => _103.reject({ id: rippleId }, prev));
      }, RIPPLE_DURATION);
      activeTimeouts.push(rippleTimeout);
    };
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onClick);
    document.body.style.cursor = "none";
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onClick);
      document.body.style.cursor = "default";
      for (const activeTimeout of activeTimeouts) {
        clearTimeout(activeTimeout);
      }
    };
  }, []);
  useEffect22(() => {
    setBrowserHeight(getBrowserHeight());
    setBrowserWidth(getBrowserWidth());
  }, []);
  return /* @__PURE__ */ jsxs98(Fragment36, { children: [
    /* @__PURE__ */ jsx117("canvas", { ref: canvasRef, className: src_internals_components_toolbar_laserCursor_default.laserCanvas, height: browserHeight, width: browserWidth }),
    /* @__PURE__ */ jsx117(
      "div",
      {
        ref: laserRef,
        className: src_internals_components_toolbar_laserCursor_default.laserCursor,
        style: {
          "--s-laser-color": LASER_COLOR
        }
      }
    ),
    _103.map(
      (point) => /* @__PURE__ */ jsx117(
        "div",
        {
          className: src_internals_components_toolbar_laserCursor_default.laserClick,
          style: {
            "--s-point-top": `${point.y}px`,
            "--s-point-left": `${point.x}px`,
            "--s-laser-color": LASER_COLOR,
            "--s-ripple-duration": `${RIPPLE_DURATION}ms`
          }
        },
        point.id
      ),
      ripplePoints
    )
  ] });
};
var laserCursor_default = LaserCursor;

// src/internals/components/toolbar/presentationButton.jsx
import _104 from "lodash/fp.js";
import { Button as Button53, Tooltip as Tooltip9 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent14 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_toolbar_presentationButton.module.css
var src_internals_components_toolbar_presentationButton_default = { "mobileButton": "sk-QWm8aW-mobileButton", "desktopButton": "sk-QWm8aW-desktopButton" };

// src/internals/components/toolbar/presentationButton.jsx
import { Fragment as Fragment37, jsx as jsx118, jsxs as jsxs99 } from "react/jsx-runtime";
var PresentationButton = ({
  presentationProps: {
    openProjectorView = _104.noop,
    closeProjectorView = _104.noop,
    isPresentationMode: appInPresentationMode = false
  } = {},
  className = void 0,
  isPrintMode = false,
  isTeacher: isTeacher2 = false,
  isFreeMode = false,
  page = void 0
}) => {
  const enterAccessibilityText = isTeacher2 ? "Pr\xE9senter la page" : "Passer en plein \xE9cran";
  const onCloseProjectorView = () => {
    closeProjectorView();
    dispatchAnalyticsEvent14(ANALYTICS_EVENTS_CONTENT_VIEW_CHANGED, {
      contentViewFormat: isPrintMode ? ANALYTICS_VIEW_PDF : ANALYTICS_VIEW_WEB
    });
  };
  const onOpenProjectorView = () => {
    openProjectorView();
    dispatchAnalyticsEvent14(ANALYTICS_EVENTS_CONTENT_VIEW_CHANGED, {
      contentViewFormat: isPrintMode ? ANALYTICS_VIEW_PRESENTATION_PDF : ANALYTICS_VIEW_PRESENTATION_WEB
    });
  };
  return appInPresentationMode ? /* @__PURE__ */ jsxs99(Fragment37, { children: [
    /* @__PURE__ */ jsx118(
      Button53,
      {
        className: src_internals_components_toolbar_presentationButton_default.mobileButton,
        theme: "gray",
        accent: "floating",
        onClick: onCloseProjectorView,
        icon: "cancel",
        "aria-label": "Retour"
      }
    ),
    /* @__PURE__ */ jsx118(
      Button53,
      {
        className: src_internals_components_toolbar_presentationButton_default.desktopButton,
        theme: "gray",
        accent: "floating",
        onClick: onCloseProjectorView,
        "aria-label": "Retour",
        children: "Retour"
      }
    )
  ] }) : /* @__PURE__ */ jsx118(Tooltip9, { content: enterAccessibilityText, position: "bottom", withTail: true, children: /* @__PURE__ */ jsx118(
    Button53,
    {
      className,
      theme: isFreeMode ? "premium" : "gray",
      accent: isFreeMode ? "main" : "floating",
      size: "medium",
      icon: "fitscreen",
      onClick: onOpenProjectorView,
      "aria-label": enterAccessibilityText,
      disabled: isFreeMode && ((page == null ? void 0 : page.premium) || (page == null ? void 0 : page.isPartOfSession) || !(page == null ? void 0 : page.valid))
    }
  ) });
};
var presentationButton_default = PresentationButton;

// src/internals/components/toolbar/switchViewButton.jsx
import { SwitchViewButton as SwitchButton5, Tooltip as Tooltip10 } from "@lls/lls-kit";
import _105 from "lodash/fp.js";
import { useCallback as useCallback46 } from "react";
import { cx as cx27, dispatchAnalyticsEvent as dispatchAnalyticsEvent15 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_toolbar_switchViewButton.module.css
var src_internals_components_toolbar_switchViewButton_default = { "switchButton": "sk-r2DGkG-switchButton" };

// src/internals/components/toolbar/switchViewButton.jsx
import { jsx as jsx119 } from "react/jsx-runtime";
var SwitchViewButton = ({
  setIsPrintMode = _105.noop,
  isPrintMode = false,
  isPresentationMode = false,
  onClick,
  disabled = false,
  className = void 0,
  resetLeftDocZoomViewerStep = _105.noop
}) => {
  const onViewChange = useCallback46(
    (isPrintMode2) => {
      dispatchAnalyticsEvent15(ANALYTICS_EVENTS_CONTENT_VIEW_CHANGED, {
        contentViewFormat: isPrintMode2 ? isPresentationMode ? ANALYTICS_VIEW_PRESENTATION_PDF : ANALYTICS_VIEW_PDF : isPresentationMode ? ANALYTICS_VIEW_PRESENTATION_WEB : ANALYTICS_VIEW_WEB
      });
      onClick(isPrintMode2, () => {
        if (isPresentationMode && !isPrintMode2) {
          resetLeftDocZoomViewerStep();
        }
        setIsPrintMode(isPrintMode2);
      });
    },
    [setIsPrintMode, isPresentationMode, resetLeftDocZoomViewerStep, onClick]
  );
  const accessibilityText3 = isPrintMode ? "Passer en vue web" : "Passer en vue page";
  return /* @__PURE__ */ jsx119(Tooltip10, { content: accessibilityText3, position: "bottom", withTail: true, disabled, children: /* @__PURE__ */ jsx119("div", { onClick: disabled ? onClick : _105.noop, children: /* @__PURE__ */ jsx119(
    SwitchButton5,
    {
      labelIconOptions: ["web", "print"],
      "aria-label": accessibilityText3,
      disabled,
      onChange: onViewChange,
      value: isPrintMode,
      className: cx27(className, src_internals_components_toolbar_switchViewButton_default.switchButton)
    }
  ) }) });
};
var switchViewButton_default = SwitchViewButton;

// tmp_esbuild1736180050074/_src_internals_components_toolbar_presentationToolbar.module.css
var src_internals_components_toolbar_presentationToolbar_default = { "title": "sk-ouZVOa-title", "container": "sk-ouZVOa-container" };

// src/internals/components/toolbar/presentationToolbar.tsx
import { Fragment as Fragment38, jsx as jsx120, jsxs as jsxs100 } from "react/jsx-runtime";
var PresentationToolbar = ({
  className,
  page,
  presentationProps = {},
  accessibilityProps: { onAccessibilityChange = _106.noop, areQuestionsHidden = false, isDarkMode = false } = {},
  printProps: { isPrintMode = false, setIsPrintMode = _106.noop, onPrintModeChange = _106.noop } = {},
  isOffline = false,
  currentUser = {},
  openOfflineModal = _106.noop,
  isFreeMode = false,
  style: iStyle = {}
}) => {
  const isUserTeacher = isTeacher(currentUser);
  const showSwitchViewButton = checkSwitchPagePermission({ page, user: currentUser, isFreeMode });
  const questionAccessibilityText = areQuestionsHidden ? "Afficher les champs de r\xE9ponse" : "Masquer les champs de r\xE9ponse";
  const darkModeAccessibilityText = isDarkMode ? "Passer en mode clair" : "Passer en mode sombre";
  const laserAccessibilityText = presentationProps.isLaserCursor ? "D\xE9sactiver le curseur laser" : "Activer le curseur laser";
  return /* @__PURE__ */ jsxs100(Fragment38, { children: [
    presentationProps.isLaserCursor && /* @__PURE__ */ jsx120(laserCursor_default, {}),
    /* @__PURE__ */ jsxs100(
      "div",
      {
        style: { ...iStyle, "--s-z-toolbar": Z_TOOLBAR },
        className: cx28(className, KIT_CLASSNAME_DARK_THEME4, src_internals_components_toolbar_presentationToolbar_default.container),
        children: [
          /* @__PURE__ */ jsx120("div", { className: src_internals_components_toolbar_presentationToolbar_default.title, children: page == null ? void 0 : page.displayTitle }),
          !isPrintMode && /* @__PURE__ */ jsx120(Tooltip11, { content: questionAccessibilityText, position: "bottom", withTail: true, children: /* @__PURE__ */ jsx120(
            Button54,
            {
              theme: "gray",
              accent: "floating",
              onClick: () => onAccessibilityChange({ areQuestionsHidden: !areQuestionsHidden }),
              icon: areQuestionsHidden ? "unpublished" : "circlecheckmark",
              "aria-label": questionAccessibilityText
            }
          ) }),
          /* @__PURE__ */ jsx120(Tooltip11, { content: laserAccessibilityText, position: "bottom", withTail: true, children: /* @__PURE__ */ jsx120(
            Button54,
            {
              theme: presentationProps.isLaserCursor ? "primary" : "gray",
              accent: "floating",
              onClick: () => {
                var _a;
                dispatchAnalyticsEvent16(ANALYTIC_EVENTS_LINK_CLICKED, {
                  featureName: "laser_pointer",
                  extraData: presentationProps.isLaserCursor ? "laser_off" : "laser_on"
                });
                (_a = presentationProps.setIsLaserCursor) == null ? void 0 : _a.call(presentationProps, (prev) => !prev);
              },
              icon: "focuscursor"
            }
          ) }),
          !isPrintMode && !isFreeMode && /* @__PURE__ */ jsx120(Tooltip11, { content: darkModeAccessibilityText, position: "bottom", withTail: true, children: /* @__PURE__ */ jsx120(
            Button54,
            {
              theme: "gray",
              accent: "floating",
              onClick: () => onAccessibilityChange({ isDarkMode: !isDarkMode }),
              icon: isDarkMode ? "moon" : "sunmax",
              "aria-label": darkModeAccessibilityText
            }
          ) }),
          showSwitchViewButton && /* @__PURE__ */ jsx120(
            switchViewButton_default,
            {
              setIsPrintMode,
              isPrintMode,
              resetLeftDocZoomViewerStep: presentationProps.resetLeftDocZoomViewerStep,
              isPresentationMode: presentationProps == null ? void 0 : presentationProps.isPresentationMode,
              disabled: isOffline,
              onClick: isOffline ? openOfflineModal : onPrintModeChange
            }
          ),
          !isFreeMode && /* @__PURE__ */ jsx120(Divider10, { vertical: true }),
          /* @__PURE__ */ jsx120(presentationButton_default, { presentationProps, isPrintMode, isTeacher: isUserTeacher })
        ]
      }
    )
  ] });
};
var presentationToolbar_default = PresentationToolbar;

// src/internals/components/toolbar/toolbarContent.jsx
import { Divider as Divider11, KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME5, KIT_CLASSNAME_FREE_LIGHT_THEME as KIT_CLASSNAME_FREE_LIGHT_THEME2, Z_TOOLBAR as Z_TOOLBAR2 } from "@lls/lls-kit";
import _116 from "lodash/fp.js";
import { useRef as useRef13 } from "react";

// src/internals/components/toolbar/hideScroll.jsx
import _107 from "lodash/fp.js";
import { useEffect as useEffect23, useRef as useRef12 } from "react";
import { jsx as jsx121 } from "react/jsx-runtime";
var STATE_SCROLLING = "scrolling";
var STATE_HIDDEN = "hidden";
var STATE_FIXED = "fixed";
var SCROLL_THRESHOLD = 16;
var Toolbar = ({ children, offset: offsetHeight = 0, areShownContextualActions, ...props }) => {
  const toolbarRef = useRef12(null);
  const navDataRef = useRef12({
    oldScrollTop: 0,
    thresholdCounter: 0,
    currentOffsetAmount: 0,
    scrollThreshold: 16,
    state: STATE_FIXED,
    offsetLimit: TOOLBAR_HEIGHT
  });
  useEffect23(() => {
    const updateScrollTop = (newScrollTop) => {
      navDataRef.current = _107.set("oldScrollTop", newScrollTop, navDataRef.current);
    };
    if (areShownContextualActions) {
      toolbarRef.current.style.top = `${offsetHeight}px`;
      navDataRef.current = _107.assign(navDataRef.current, {
        state: STATE_FIXED,
        currentOffsetAmount: 0,
        thresholdCounter: 0
      });
      return;
    }
    toolbarRef.current.style.top = `${offsetHeight}px`;
    updateScrollTop(window.scrollY);
    const handleWindowScroll = () => {
      if (!navDataRef.current || !toolbarRef.current) return;
      const newScrollTop = window.scrollY;
      const delta = navDataRef.current.oldScrollTop - newScrollTop;
      navDataRef.current = _107.set(
        "thresholdCounter",
        _107.clamp(-SCROLL_THRESHOLD, SCROLL_THRESHOLD, navDataRef.current.thresholdCounter + delta),
        navDataRef.current
      );
      if (Math.abs(navDataRef.current.thresholdCounter) < SCROLL_THRESHOLD && navDataRef.current.state !== STATE_SCROLLING) {
        return updateScrollTop(newScrollTop);
      }
      const scrollingToBottom = delta < 0;
      if (scrollingToBottom && navDataRef.current.state !== STATE_HIDDEN) {
        if (navDataRef.current.currentOffsetAmount <= -navDataRef.current.offsetLimit) {
          navDataRef.current = _107.assign(navDataRef.current, { state: STATE_HIDDEN, thresholdCounter: 0 });
          return updateScrollTop(newScrollTop);
        }
        const amount = Math.max(navDataRef.current.currentOffsetAmount + delta, -navDataRef.current.offsetLimit);
        navDataRef.current = _107.assign(navDataRef.current, { currentOffsetAmount: amount, state: STATE_SCROLLING });
        toolbarRef.current.style.top = `${offsetHeight + navDataRef.current.currentOffsetAmount}px`;
        return updateScrollTop(newScrollTop);
      }
      if (!scrollingToBottom && navDataRef.current.state !== STATE_FIXED) {
        if (navDataRef.current.currentOffsetAmount >= 0) {
          navDataRef.current = _107.assign(navDataRef.current, { state: STATE_FIXED, thresholdCounter: 0 });
          return updateScrollTop(newScrollTop);
        }
        const amount = Math.min(navDataRef.current.currentOffsetAmount + delta, 0);
        navDataRef.current = _107.assign(navDataRef.current, { currentOffsetAmount: amount, state: STATE_SCROLLING });
        toolbarRef.current.style.top = `${offsetHeight + navDataRef.current.currentOffsetAmount}px`;
        return updateScrollTop(newScrollTop);
      }
      return updateScrollTop(newScrollTop);
    };
    window.addEventListener("scroll", handleWindowScroll);
    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    };
  }, [offsetHeight, areShownContextualActions]);
  return /* @__PURE__ */ jsx121("div", { ...props, ref: toolbarRef, children });
};
var hideScroll_default = Toolbar;

// src/internals/components/toolbar/toolbarContent.jsx
import { cx as cx29, makeComponent as makeComponent7 } from "@lls/utils";

// src/internals/components/toolbar/accessibilityButton.jsx
import { Button as Button55, Tooltip as Tooltip12 } from "@lls/lls-kit";
import _108 from "lodash/fp.js";
import { useCallback as useCallback47 } from "react";
import { jsx as jsx122 } from "react/jsx-runtime";
var accessibilityText = "Modifier les param\xE8tres d'affichage";
var ACCESSIBILITY_CLASSNAME = "toolbar-a11ybutton";
var AccessibilityButton2 = ({ onClick = _108.noop, openAccessibilityModal = _108.noop, isFreeMode = false }) => {
  const onClickCb = useCallback47(
    (event) => {
      onClick(event, openAccessibilityModal);
    },
    [openAccessibilityModal, onClick]
  );
  return /* @__PURE__ */ jsx122("span", { className: ACCESSIBILITY_CLASSNAME, children: /* @__PURE__ */ jsx122(Tooltip12, { content: accessibilityText, position: isFreeMode ? "left" : "bottom", withTail: true, children: /* @__PURE__ */ jsx122(
    Button55,
    {
      "aria-label": accessibilityText,
      theme: "gray",
      accent: "floating",
      icon: "textformatsize",
      size: "medium",
      onClick: onClickCb,
      "data-tour": "superkit-accessibility-button"
    }
  ) }) });
};
var accessibilityButton_default2 = AccessibilityButton2;

// src/internals/components/toolbar/exportButton.jsx
import _109 from "lodash/fp.js";
import { useCallback as useCallback48 } from "react";
import { Button as Button56, Tooltip as Tooltip13 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent17 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_toolbar_exportButton.module.css
var src_internals_components_toolbar_exportButton_default = { "button": "sk-U2YEzG-button" };

// src/internals/components/toolbar/exportButton.jsx
import { jsx as jsx123 } from "react/jsx-runtime";
var ExportButton2 = ({ onClick = _109.noop, disabled = false }) => {
  const onClickCb = useCallback48(() => {
    dispatchAnalyticsEvent17(ANALYTICS_EVENTS_PAGE_EXPORT_STARTED);
    onClick();
  }, [onClick]);
  return /* @__PURE__ */ jsx123(Tooltip13, { content: "T\xE9l\xE9charger la page", position: "bottom", withTail: true, disabled, children: /* @__PURE__ */ jsx123("div", { onClick: disabled ? onClick : _109.noop, children: /* @__PURE__ */ jsx123(
    Button56,
    {
      className: src_internals_components_toolbar_exportButton_default.button,
      "data-disabled": +disabled,
      "aria-label": "T\xE9l\xE9charger la page",
      theme: "gray",
      accent: "floating",
      icon: "arrowdowntoline",
      size: "medium",
      onClick: onClickCb,
      disabled,
      "data-tour": "superkit-export-button"
    }
  ) }) });
};
var exportButton_default2 = ExportButton2;

// src/internals/components/toolbar/goBackButton.tsx
import { Button as Button57, Tooltip as Tooltip14 } from "@lls/lls-kit";
import _110 from "lodash/fp.js";
import { jsx as jsx124 } from "react/jsx-runtime";
var GoBackButton = ({ isRevisionPage = false, onClick = _110.noop, text = "Retour", link }) => {
  return /* @__PURE__ */ jsx124(Tooltip14, { disabled: isRevisionPage, content: text, position: "bottom", withTail: true, children: /* @__PURE__ */ jsx124(Button57, { theme: "gray", accent: "floating", icon: "arrowleft", size: "medium", onClick, ...link ?? {}, children: text }) });
};
var goBackButton_default = GoBackButton;

// src/internals/components/toolbar/historyButtons.jsx
import { Button as Button58, Tooltip as Tooltip15 } from "@lls/lls-kit";
import _111 from "lodash/fp.js";
import { Fragment as Fragment39, jsx as jsx125, jsxs as jsxs101 } from "react/jsx-runtime";
var undoAccessibilityText = "Annuler";
var redoAccessibilityText = "R\xE9tablir";
var HistoryButtons = ({
  historyProps: { hasPreviousEntry, hasNextEntry, onGoBack = _111.noop, onGoForward = _111.noop } = {}
}) => {
  return /* @__PURE__ */ jsxs101(Fragment39, { children: [
    /* @__PURE__ */ jsx125(Tooltip15, { content: undoAccessibilityText, position: "bottom", withTail: true, children: /* @__PURE__ */ jsx125(
      Button58,
      {
        "aria-label": undoAccessibilityText,
        theme: "gray",
        accent: "floating",
        size: "medium",
        icon: "backward",
        disabled: !hasPreviousEntry,
        onClick: onGoBack
      }
    ) }),
    /* @__PURE__ */ jsx125(Tooltip15, { content: redoAccessibilityText, position: "bottom", withTail: true, children: /* @__PURE__ */ jsx125(
      Button58,
      {
        "aria-label": redoAccessibilityText,
        theme: "gray",
        accent: "floating",
        size: "medium",
        icon: "forward",
        disabled: !hasNextEntry,
        onClick: onGoForward
      }
    ) })
  ] });
};
var historyButtons_default = HistoryButtons;

// src/internals/components/toolbar/moreButton.jsx
import { MenuButton as MenuButton8, Tooltip as Tooltip16 } from "@lls/lls-kit";
import _112 from "lodash/fp.js";
import { useMemo as useMemo25 } from "react";
import { jsx as jsx126 } from "react/jsx-runtime";
var MoreButton = ({
  openDeleteModal = _112.noop,
  onDeleteClick = _112.noop,
  onSaveClick = _112.noop,
  openSaveModal = _112.noop
}) => {
  const listItems = useMemo25(
    () => [
      {
        icon: "squareandpencil",
        msg: "Renommer",
        onClick: (event) => onSaveClick(event, () => openSaveModal(SAVE_MODAL_STATUS.RENAME), true)
      },
      {
        type: "divider"
      },
      {
        icon: "trash",
        theme: "error",
        msg: "Supprimer cette page",
        onClick: (event) => onDeleteClick(event, openDeleteModal)
        // TODO : add delete modal and callback next PR
      }
    ],
    [onDeleteClick, onSaveClick, openSaveModal, openDeleteModal]
  );
  return /* @__PURE__ */ jsx126(Tooltip16, { content: "G\xE9rer ma page perso.", position: "bottom", withTail: true, children: /* @__PURE__ */ jsx126(
    MenuButton8,
    {
      orientation: "vertical",
      size: "medium",
      position: "bottom",
      alignment: "end",
      theme: "gray",
      accent: "floating",
      listItems
    }
  ) });
};
var moreButton_default = MoreButton;

// src/internals/components/toolbar/saveButton.jsx
import { Button as Button59 } from "@lls/lls-kit";
import _113 from "lodash/fp.js";
import { jsx as jsx127 } from "react/jsx-runtime";
var SaveButton = ({ disabled = false, isTeacher: isTeacher2 = false, openSaveModal = _113.noop, onSaveButtonClick = _113.noop }) => {
  const onClickCb = (event) => {
    onSaveButtonClick(event, () => openSaveModal(SAVE_MODAL_STATUS.SAVE));
  };
  return /* @__PURE__ */ jsx127(
    Button59,
    {
      disabled,
      "data-tour": "superkit-save-button",
      onClick: onClickCb,
      accent: isTeacher2 ? "main" : "alt",
      children: "Enregistrer"
    }
  );
};
var saveButton_default = SaveButton;

// src/internals/components/toolbar/shareButton.jsx
import { Button as Button60, Tooltip as Tooltip17 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent18 } from "@lls/utils";
import _114 from "lodash/fp.js";
import { useCallback as useCallback49 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_toolbar_shareButton.module.css
var src_internals_components_toolbar_shareButton_default = { "button": "sk-ipm1sa-button" };

// src/internals/components/toolbar/shareButton.jsx
import { jsx as jsx128 } from "react/jsx-runtime";
var accessibilityText2 = "Partager la page";
var ShareButton2 = ({ onClick = _114.noop, openShareModal = _114.noop, disabled }) => {
  const onClickCb = useCallback49(
    (event) => {
      dispatchAnalyticsEvent18(ANALYTICS_EVENTS_PAGE_SHARE_STARTED);
      onClick(event, openShareModal);
    },
    [onClick, openShareModal]
  );
  return /* @__PURE__ */ jsx128(Tooltip17, { content: accessibilityText2, position: "bottom", withTail: true, disabled, children: /* @__PURE__ */ jsx128("div", { onClick: disabled ? openShareModal : _114.noop, children: /* @__PURE__ */ jsx128(
    Button60,
    {
      className: src_internals_components_toolbar_shareButton_default.button,
      "data-disabled": +disabled,
      "aria-label": accessibilityText2,
      "data-tour": "superkit-share-button",
      theme: "gray",
      accent: "floating",
      icon: "share",
      onClick: onClickCb,
      size: "medium",
      disabled
    }
  ) }) });
};
var shareButton_default2 = ShareButton2;

// src/internals/components/toolbar/shareOrNotifyButton.jsx
import { Button as Button61 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent19 } from "@lls/utils";
import _115 from "lodash/fp.js";
import { jsx as jsx129 } from "react/jsx-runtime";
var ShareOrNotifyButton = ({
  openShareModal = _115.noop,
  onShareButtonClick = _115.noop,
  onShare = _115.noop,
  sharedUser = {}
}) => {
  const onShareClickCb = (event) => {
    onShareButtonClick(event, openShareModal);
    dispatchAnalyticsEvent19(ANALYTICS_EVENTS_PAGE_SHARE_STARTED);
  };
  const onShareCb = () => {
    onShare(sharedUser);
    dispatchAnalyticsEvent19(ANALYTICS_EVENTS_PAGE_SHARE_STARTED);
  };
  return _115.isEmpty(sharedUser) ? /* @__PURE__ */ jsx129(Button61, { onClick: onShareClickCb, icon: "paperplane", children: "Envoyer mes r\xE9ponses" }) : /* @__PURE__ */ jsx129(Button61, { onClick: onShareCb, icon: "bell", children: "Pr\xE9venir mon prof." });
};
var shareOrNotifyButton_default = ShareOrNotifyButton;

// src/internals/components/toolbar/summaryButton.jsx
import { Button as Button62, Tooltip as Tooltip18 } from "@lls/lls-kit";
import { useCallback as useCallback50 } from "react";
import { jsx as jsx130 } from "react/jsx-runtime";
var SummaryButton = ({ isDrawerOpen, setIsDrawerOpen, onClick, containerNode = null, isFreeMode = false }) => {
  const onClickCb = useCallback50(
    (event) => {
      onClick(event, () => setIsDrawerOpen(!isDrawerOpen));
    },
    [setIsDrawerOpen, isDrawerOpen, onClick]
  );
  const accessibilityText3 = isDrawerOpen ? "Replier le sommaire" : "D\xE9plier le sommaire";
  return /* @__PURE__ */ jsx130(
    Tooltip18,
    {
      containerNode,
      content: accessibilityText3,
      position: isFreeMode ? "right" : "bottom",
      withTail: true,
      children: /* @__PURE__ */ jsx130(
        Button62,
        {
          "aria-label": accessibilityText3,
          onClick: onClickCb,
          "data-tour": DATA_TOUR.SUMMARY_BUTTON,
          "data-cy": "summary-button",
          icon: "sidebarleft",
          theme: "gray",
          accent: "floating",
          size: "medium"
        }
      )
    }
  );
};
var summaryButton_default = SummaryButton;

// tmp_esbuild1736180050074/_src_internals_components_toolbar_toolbarContent.module.css
var src_internals_components_toolbar_toolbarContent_default = { "toolbarTitle": "sk-wrGf8W-toolbarTitle", "toolbarPrimaryContainer": "sk-wrGf8W-toolbarPrimaryContainer", "toolbarBreakingLineContent": "sk-wrGf8W-toolbarBreakingLineContent", "toolbarWrapper": "sk-wrGf8W-toolbarWrapper", "toolbarElementContainer": "sk-wrGf8W-toolbarElementContainer", "toolbarDoubleLineContainer": "sk-wrGf8W-toolbarDoubleLineContainer", "dividerContainer": "sk-wrGf8W-dividerContainer", "hiddenInMobilePortrait": "sk-wrGf8W-hiddenInMobilePortrait", "toolbarContextualActions": "sk-wrGf8W-toolbarContextualActions", "toolbarHistoryContainer": "sk-wrGf8W-toolbarHistoryContainer" };

// src/internals/components/toolbar/toolbarContent.jsx
import { Fragment as Fragment40, jsx as jsx131, jsxs as jsxs102 } from "react/jsx-runtime";
var StyledToolbarElementContainer = makeComponent7("div", src_internals_components_toolbar_toolbarContent_default.toolbarElementContainer);
var ToolbarContent = ({
  offset = 0,
  isOffline = false,
  isCreatingPage = false,
  isRevisionPage,
  openOfflineModal = _116.noop,
  openExportModal = _116.noop,
  openAccessibilityModal = _116.noop,
  onGoBack = _116.noop,
  currentPage = {},
  openShareModal = _116.noop,
  openSaveModal = _116.noop,
  openDeleteModal = _116.noop,
  printProps: { isPrintMode = false, setIsPrintMode = _116.noop, onPrintModeChange = _116.noop } = {},
  drawerProps: { isDrawerOpen = true, setIsDrawerOpen = _116.noop, onDrawerButtonClick = _116.noop } = {},
  presentationProps = {},
  accessibilityProps: { onAccessibilityButtonClick = _116.noop } = {},
  historyProps = {},
  areShownContextualActions = false,
  shareProps = {},
  currentUser = {},
  className = "",
  isEducationalGuide = false,
  isFreeMode = false,
  style: iStyle = {}
}) => {
  const { isPresentationMode = false } = presentationProps;
  const {
    onShareButtonClick = _116.noop,
    onShare = _116.noop,
    onOpenSaveModalEvent = _116.noop,
    onDeleteButtonClick = _116.noop,
    sharedUser
    /*, sharedGroups */
  } = shareProps;
  const summaryContainerRef = useRef13(null);
  const isUserTeacher = currentUser == null ? void 0 : currentUser.isTeacher;
  const isUserStudent = currentUser == null ? void 0 : currentUser.isStudent;
  const showTitle = isPresentationMode;
  const showShareButton = checkShareButtonPermission({
    isFreeMode,
    isCreatingPage,
    isPresentationMode,
    isPrintMode,
    user: currentUser,
    page: currentPage
  });
  const isWorkplanPage2 = isWorkplanPage(currentPage);
  const showExportButton = !isCreatingPage && !isPrintMode && !isPresentationMode && !isWorkplanPage2 && !isFreeMode && !(currentPage == null ? void 0 : currentPage.isPartOfSession);
  const showPresentationButton = isPrintMode && !isEducationalGuide && !isPresentationMode && !(currentPage == null ? void 0 : currentPage.isPartOfSession) && !isCreatingPage && !isRevisionPage;
  const showAccessibilityButton = !isPrintMode;
  const showSwitchViewButton = checkSwitchPagePermission({
    page: currentPage,
    user: currentUser,
    isFreeMode,
    isEducationalGuide
  });
  const showSaveButton = !isOffline && (currentPage == null ? void 0 : currentPage.isDraft) && !isFreeMode && !_116.isEmpty(currentUser);
  const showShareOrNotifyButton = !isCreatingPage && isUserStudent && !isFreeMode;
  const showOtherButton = !isCreatingPage && isUserTeacher && !isOriginalPage(currentPage) && !isFreeMode;
  const showHistoryButton = isUserTeacher && (currentPage == null ? void 0 : currentPage.isDraft) && !isPrintMode && !isPresentationMode && !isFreeMode && !isWorkplanPage2;
  const disabledShareAndSaveButton = areDisabledShareAndSaveButton(currentPage);
  return /* @__PURE__ */ jsxs102(
    hideScroll_default,
    {
      style: {
        ...iStyle,
        "--s-toolbar-height": `${TOOLBAR_HEIGHT}px`,
        "--s-offset": `${offset}px`,
        "--s-z-toolbar": Z_TOOLBAR2
      },
      className: cx29(
        className,
        isFreeMode ? KIT_CLASSNAME_FREE_LIGHT_THEME2 : KIT_CLASSNAME_DARK_THEME5,
        src_internals_components_toolbar_toolbarContent_default.toolbarWrapper
      ),
      "data-is-free": +isFreeMode,
      "data-drawer-open": +isDrawerOpen,
      areShownContextualActions,
      offset,
      children: [
        /* @__PURE__ */ jsx131("div", { className: src_internals_components_toolbar_toolbarContent_default.toolbarElementContainer, ref: summaryContainerRef, children: isCreatingPage || isRevisionPage ? /* @__PURE__ */ jsx131(goBackButton_default, { isRevisionPage, onClick: onGoBack }) : /* @__PURE__ */ jsx131(
          summaryButton_default,
          {
            containerNode: summaryContainerRef.current,
            isDrawerOpen,
            setIsDrawerOpen,
            onClick: onDrawerButtonClick,
            isFreeMode
          }
        ) }),
        showTitle && /* @__PURE__ */ jsx131("div", { className: src_internals_components_toolbar_toolbarContent_default.toolbarElementContainer, "data-fillspace": "1", children: /* @__PURE__ */ jsx131("h3", { className: src_internals_components_toolbar_toolbarContent_default.toolbarTitle, children: currentPage == null ? void 0 : currentPage.displayTitle }) }),
        /* @__PURE__ */ jsxs102("div", { className: src_internals_components_toolbar_toolbarContent_default.toolbarDoubleLineContainer, children: [
          /* @__PURE__ */ jsxs102(StyledToolbarElementContainer, { className: src_internals_components_toolbar_toolbarContent_default.toolbarBreakingLineContent, children: [
            showHistoryButton && /* @__PURE__ */ jsxs102(StyledToolbarElementContainer, { className: src_internals_components_toolbar_toolbarContent_default.toolbarHistoryContainer, children: [
              /* @__PURE__ */ jsx131(historyButtons_default, { historyProps }),
              /* @__PURE__ */ jsx131("div", { className: src_internals_components_toolbar_toolbarContent_default.dividerContainer, children: /* @__PURE__ */ jsx131(Divider11, { vertical: true }) })
            ] }),
            /* @__PURE__ */ jsxs102(
              StyledToolbarElementContainer,
              {
                className: src_internals_components_toolbar_toolbarContent_default.toolbarContextualActions,
                "data-hidden": +!areShownContextualActions,
                children: [
                  showShareOrNotifyButton && /* @__PURE__ */ jsx131(
                    shareOrNotifyButton_default,
                    {
                      sharedUser,
                      onShare,
                      openShareModal,
                      onShareButtonClick
                    }
                  ),
                  showSaveButton && /* @__PURE__ */ jsx131(
                    saveButton_default,
                    {
                      disabled: disabledShareAndSaveButton,
                      isTeacher: isUserTeacher,
                      onSaveButtonClick: onOpenSaveModalEvent,
                      openSaveModal
                    }
                  )
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs102(StyledToolbarElementContainer, { className: cx29("toolbar-primary-container", src_internals_components_toolbar_toolbarContent_default.toolbarPrimaryContainer), children: [
            showShareButton && /* @__PURE__ */ jsx131(Fragment40, { children: /* @__PURE__ */ jsx131(
              shareButton_default2,
              {
                onClick: onShareButtonClick,
                openShareModal: isOffline ? openOfflineModal : openShareModal,
                disabled: isOffline || disabledShareAndSaveButton
              }
            ) }),
            showExportButton && /* @__PURE__ */ jsx131(exportButton_default2, { disabled: isOffline, onClick: isOffline ? openOfflineModal : openExportModal }),
            showPresentationButton && /* @__PURE__ */ jsx131(
              presentationButton_default,
              {
                className: src_internals_components_toolbar_toolbarContent_default.hiddenInMobilePortrait,
                presentationProps,
                isPrintMode,
                isTeacher: isUserTeacher,
                isFreeMode,
                page: currentPage
              }
            ),
            showAccessibilityButton && /* @__PURE__ */ jsx131(
              accessibilityButton_default2,
              {
                onClick: onAccessibilityButtonClick,
                openAccessibilityModal,
                isFreeMode
              }
            ),
            showSwitchViewButton && /* @__PURE__ */ jsx131(
              switchViewButton_default,
              {
                labelIconOptions: ["web", "print"],
                setIsPrintMode,
                isPrintMode,
                isPresentationMode: presentationProps == null ? void 0 : presentationProps.isPresentationMode,
                disabled: isOffline,
                onClick: isOffline ? openOfflineModal : onPrintModeChange
              }
            ),
            showOtherButton && /* @__PURE__ */ jsx131(
              moreButton_default,
              {
                onSaveClick: onOpenSaveModalEvent,
                onDeleteClick: onDeleteButtonClick,
                openSaveModal,
                openDeleteModal
              }
            )
          ] })
        ] })
      ]
    }
  );
};
var toolbarContent_default = ToolbarContent;

// src/internals/components/toolbar/index.jsx
import { Fragment as Fragment41, jsx as jsx132, jsxs as jsxs103 } from "react/jsx-runtime";
var TOOLBAR_HEIGHT = 64;
var Toolbar2 = ({
  currentPage,
  onExportButtonClick: iOnExportButtonClick = _117.noop,
  accessibilityProps = {},
  shareProps = {},
  areShownContextualActions = false,
  exportProps: { closeOnExport = false } = {},
  tabId,
  isRevisionPage = false,
  renewalDisplayed = true,
  sendTourEvent = _117.noop,
  className = "",
  onDisabledFeatureClick,
  ...props
} = {}) => {
  var _a;
  const [isAccessibilityModalOpen, setIsAccessibilityModalOpen] = useState51(false);
  const [saveModalStatus, setSaveModalStatus] = useState51(SAVE_MODAL_STATUS.CLOSED);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState51(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState51(false);
  const [isOfflineModalOpen, setIsOfflineModalOpen] = useState51(false);
  const isShareModalOpen = _117.getOr(false, "isShareModalOpen", shareProps);
  const setIsShareModalOpen = _117.getOr(_117.noop, "setIsShareModalOpen", shareProps);
  const forceSaveModalToOpen = _117.getOr(void 0, "forceSaveModalToOpen", shareProps);
  const onOpenSaveModalEvent = _117.getOr(_117.noop, "onOpenSaveModalEvent", shareProps);
  const isOffline = _117.getOr(false, "isOffline", props);
  const onExportButtonClick = useExportModal_default({
    onExportButtonClick: iOnExportButtonClick,
    closeOnExport,
    setIsExportModalOpen
  });
  const openAccessibilityModal = useCallback51(() => setIsAccessibilityModalOpen(true), []);
  const closeAccessibilityModal = useCallback51(() => setIsAccessibilityModalOpen(false), []);
  const openShareModal = useCallback51(() => {
    setIsShareModalOpen(true);
    sendTourEvent("open_share_modal");
  }, [setIsShareModalOpen, sendTourEvent]);
  const closeShareModal = useCallback51(() => setIsShareModalOpen(false), [setIsShareModalOpen]);
  const openSaveModal = useCallback51((status) => setSaveModalStatus(status), []);
  const closeSaveModal = useCallback51(() => setSaveModalStatus(SAVE_MODAL_STATUS.CLOSED), []);
  const openDeleteModal = useCallback51(() => setIsDeleteModalOpen(true), []);
  const closeDeleteModal = useCallback51(() => setIsDeleteModalOpen(false), []);
  const openExportModal = useCallback51(() => setIsExportModalOpen(true), []);
  const closeExportModal = useCallback51(() => setIsExportModalOpen(false), []);
  const openOfflineModal = useCallback51(() => setIsOfflineModalOpen(true), []);
  const closeOfflineModal = useCallback51(() => setIsOfflineModalOpen(false), []);
  useEffect24(() => {
    forceSaveModalToOpen && onOpenSaveModalEvent(void 0, () => openSaveModal(SAVE_MODAL_STATUS.SAVE));
  }, [forceSaveModalToOpen, openSaveModal, onOpenSaveModalEvent]);
  const isPresentationMode = (_a = props == null ? void 0 : props.presentationProps) == null ? void 0 : _a.isPresentationMode;
  return /* @__PURE__ */ jsxs103(Fragment41, { children: [
    isPresentationMode ? /* @__PURE__ */ jsx132(
      presentationToolbar_default,
      {
        className: cx30(src_internals_components_toolbar_index_default.accessibilityElement, className),
        page: currentPage,
        accessibilityProps,
        shareProps,
        openOfflineModal,
        ...props,
        style: { ...props.style, ...styleThemeProps2({ isDysMode: false, sizeIndex: 2, font: FONT_LATO }) }
      }
    ) : /* @__PURE__ */ jsxs103(Fragment41, { children: [
      /* @__PURE__ */ jsx132(
        toolbarContent_default,
        {
          className: cx30(TOOLBAR_CLASS, src_internals_components_toolbar_index_default.accessibilityElement, className),
          currentPage,
          openAccessibilityModal,
          openExportModal,
          openShareModal,
          openOfflineModal,
          openSaveModal,
          openDeleteModal,
          accessibilityProps,
          areShownContextualActions,
          shareProps,
          isRevisionPage,
          ...props,
          style: { ...props.style, ...styleThemeProps2({ isDysMode: false, sizeIndex: 2, font: FONT_LATO }) }
        }
      ),
      /* @__PURE__ */ jsx132(
        accessibilityModal_default,
        {
          isdysmode: false,
          sizeindex: 2,
          font: FONT_LATO,
          className: cx30(TOOLBAR_CLASS, src_internals_components_toolbar_index_default.accessibilityElement),
          isOpen: isAccessibilityModalOpen,
          close: closeAccessibilityModal,
          ...accessibilityProps,
          isFreeMode: props.isFreeMode
        }
      ),
      /* @__PURE__ */ jsx132(
        exportModal_default,
        {
          isdysmode: false,
          sizeindex: 2,
          font: FONT_LATO,
          className: cx30(TOOLBAR_CLASS, src_internals_components_toolbar_index_default.accessibilityElement),
          currentPage,
          isOpen: isExportModalOpen,
          close: closeExportModal,
          onExportButtonClick,
          currentUser: props.currentUser,
          tabId,
          renewalDisplayed,
          onSave: shareProps.onSave,
          onDisabledFeatureClick
        }
      ),
      /* @__PURE__ */ jsx132(
        shareModal_default,
        {
          className: src_internals_components_toolbar_index_default.accessibilityElement,
          isdysmode: false,
          sizeindex: 2,
          font: FONT_LATO,
          ...shareProps,
          isModalOpen: isShareModalOpen,
          closeModal: closeShareModal,
          isOffline,
          openOfflineModal,
          renewalDisplayed
        }
      ),
      isDeleteModalOpen && /* @__PURE__ */ jsx132(
        deletePageModal_default,
        {
          className: src_internals_components_toolbar_index_default.accessibilityElement,
          isdysmode: false,
          sizeindex: 2,
          font: FONT_LATO,
          page: currentPage,
          close: closeDeleteModal,
          ...shareProps
        }
      )
    ] }),
    isOfflineModalOpen && /* @__PURE__ */ jsx132(offlineModal_default, { className: src_internals_components_toolbar_index_default.accessibilityElement, close: closeOfflineModal }),
    saveModalStatus > 0 && /* @__PURE__ */ jsx132(
      savePageModal_default,
      {
        className: src_internals_components_toolbar_index_default.accessibilityElement,
        isdysmode: false,
        sizeindex: 2,
        font: FONT_LATO,
        page: currentPage,
        saveModalStatus,
        close: closeSaveModal,
        ...shareProps
      }
    )
  ] });
};
var toolbar_default = Toolbar2;

// src/internals/components/toolbox/index.jsx
import _119 from "lodash/fp.js";
import { useCallback as useCallback52, useMemo as useMemo26, useState as useState52 } from "react";
import { Icon as Icon33 } from "@lls/lls-kit";
import { cx as cx31, openWindow as openWindow2 } from "@lls/utils";

// src/internals/v2/utils/tool.ts
import _118 from "lodash/fp.js";
var hasProfile = ({ user, tool }) => {
  switch (true) {
    case _118.flow(_118.get("profiles"), _118.isEmpty)(tool):
      return true;
    case _118.get("isTeacher", user):
      return _118.flow(_118.get("profiles"), _118.includes("teacher"))(tool);
    case _118.get("isStudent", user):
      return _118.flow(_118.get("profiles"), _118.includes("student"))(tool) && !_118.get("locked", tool);
    default:
      return false;
  }
};
var hasRole = ({ user, tool }) => {
  switch (true) {
    case _118.flow(_118.get("roles"), _118.isEmpty)(tool):
      return true;
    case !user:
      return _118.flow(_118.get("roles"), _118.includes("ROLE_NOT_CONNECTED"))(tool);
    case !!user:
      return _118.flow(_118.get("roles"), _118.includes(_118.get("roleCalc", user)))(tool);
    default:
      return false;
  }
};
var REDIRECT_TOOL_URLS_FOR_HOST = [
  "/le-livre-du-professeur/{bookUri}",
  "/labo-sciences",
  "/labo-langues",
  "/labo-grand-oral",
  "/labo-arduino",
  "/labo-oral",
  "/labo-electricite",
  "/console-python"
];
var REDIRECT_TOOL_URL_FOR_PREMIUM_HOST = /page\/\d+/;
var getToolHref = ({ tool, token, bookUri }) => {
  const toolUrl = (tool == null ? void 0 : tool.url) || "";
  const href = _118.flow(_118.replace("{token}", token), _118.replace("{bookUri}", bookUri))(toolUrl);
  if (_118.includes(toolUrl, REDIRECT_TOOL_URLS_FOR_HOST)) return `${config_default.host}${href}`;
  if (REDIRECT_TOOL_URL_FOR_PREMIUM_HOST.test(toolUrl)) return `${config_default.host_premium}${href}`;
  return href;
};
var filterTools = ({ tools, user } = {}) => _118.filter((tool) => _118.overEvery([hasProfile, hasRole])({ user, tool }), tools);

// tmp_esbuild1736180050074/_src_internals_components_toolbox_index.module.css
var src_internals_components_toolbox_index_default = { "tools": "sk-ChzmXq-tools", "viewer-fullscreen-modal": "sk-ChzmXq-viewer-fullscreen-modal", "toolbox": "sk-ChzmXq-toolbox", "title": "sk-ChzmXq-title" };

// src/internals/components/toolbox/index.jsx
import { jsx as jsx133, jsxs as jsxs104 } from "react/jsx-runtime";
var Tool = ({ token, tool, bookUri, onClick }) => {
  const wording = _119.get("wording", tool);
  const href = getToolHref({ token, bookUri, tool });
  const defaultBehavior = useCallback52(() => openWindow2(href, "_blank", "noreferrer"), [href]);
  return /* @__PURE__ */ jsx133("a", { onClick: (event) => onClick({ event, defaultBehavior, tool, href }), children: wording });
};
var ToolBox = ({ className = "", tools, token, bookUri, onClick, user, isTouchable }) => {
  const [isOpen, setIsOpen] = useState52(false);
  const filteredTools = useMemo26(
    () => _119.flow((tools2) => filterTools({ tools: tools2, user }), _119.sortBy("order"))(tools),
    [tools, user]
  );
  return /* @__PURE__ */ jsx133(
    "div",
    {
      className: cx31(className, src_internals_components_toolbox_index_default.toolbox),
      "data-tour": "superkit-toolbox",
      onMouseEnter: isTouchable ? void 0 : () => setIsOpen(true),
      onMouseLeave: isTouchable ? void 0 : () => setIsOpen(false),
      children: /* @__PURE__ */ jsxs104("div", { className: "toolbox-inner", "data-open": +isOpen, children: [
        /* @__PURE__ */ jsxs104("div", { className: src_internals_components_toolbox_index_default.title, onClick: () => setIsOpen((prev) => !prev), children: [
          /* @__PURE__ */ jsxs104("div", { className: "toolbox-title-left", children: [
            /* @__PURE__ */ jsx133(Icon33, { name: "books", color: "var(--primary-40-color)" }),
            /* @__PURE__ */ jsx133("span", { children: "Bo\xEEte \xE0 outils" })
          ] }),
          /* @__PURE__ */ jsx133(Icon33, { className: "toolbox-icon", name: "chevrondown" })
        ] }),
        /* @__PURE__ */ jsx133("div", { className: src_internals_components_toolbox_index_default.tools, children: _119.map(
          (tool) => /* @__PURE__ */ jsx133(Tool, { token, tool, bookUri, onClick }, _119.get("id", tool)),
          filteredTools
        ) })
      ] })
    }
  );
};
var toolbox_default = ToolBox;

// src/internals/components/book/bookToolbar.jsx
import { Button as Button63, Tooltip as Tooltip19 } from "@lls/lls-kit";
import { useCallback as useCallback53 } from "react";
import _120 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_book_bookToolbar.module.css
var src_internals_components_book_bookToolbar_default = { "toolbar": "sk-HhfJla-toolbar" };

// src/internals/components/book/bookToolbar.jsx
import { jsx as jsx134 } from "react/jsx-runtime";
var BookToolbar = ({
  drawer: { setIsDrawerOpen = _120.noop, onDrawerButtonClick = _120.noop, isDrawerOpen } = {},
  disabled = false,
  isFree = false,
  isMobile = false
}) => {
  const onClickCb = useCallback53(
    (event) => {
      onDrawerButtonClick(event, () => setIsDrawerOpen(!isDrawerOpen));
    },
    [setIsDrawerOpen, isDrawerOpen, onDrawerButtonClick]
  );
  const accessibilityText3 = isDrawerOpen ? "Replier le sommaire" : "D\xE9plier le sommaire";
  return /* @__PURE__ */ jsx134("div", { className: src_internals_components_book_bookToolbar_default.toolbar, "data-is-free": +isFree, children: /* @__PURE__ */ jsx134(Tooltip19, { content: accessibilityText3, withTail: true, children: /* @__PURE__ */ jsx134(
    Button63,
    {
      icon: "sidebarleft",
      theme: "gray",
      accent: isFree ? "floating" : "main",
      onClick: onClickCb,
      disabled,
      children: isMobile ? "Afficher le sommaire" : null
    }
  ) }) });
};
var bookToolbar_default = BookToolbar;

// src/internals/components/book/bookHeader.jsx
import {
  BookCover as BookCover2,
  Button as Button64,
  Icon as Icon34,
  KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME6,
  KIT_CLASSNAME_FREE_LIGHT_THEME as KIT_CLASSNAME_FREE_LIGHT_THEME3,
  KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME8
} from "@lls/lls-kit";
import { cx as cx32 } from "@lls/utils";

// src/internals/v2/utils/book.js
import _121 from "lodash/fp.js";
var getResourcesCountByCategory = _121.flow(
  _121.reject(_121.flow(_121.get("categories"), _121.overSome([_121.isNil, _121.isEmpty]))),
  _121.groupBy("categories.0"),
  _121.mapValues(_121.size),
  _121.toPairs,
  _121.slice(0, 10)
);
var isCanopePublisher = (publisher) => _121.isEqual(_121.toLower(publisher), _121.toLower("Canop\xE9"));
var handlePluralResources = (arg) => handlePlural("ressource", arg);
var getNumericalResourcesPlural = (resources) => `${_121.size(resources)} ${handlePluralResources(resources)} ${handlePlural("num\xE9rique", resources)}`;
var categoryHasResources = ({ category, resources }) => _121.flow(_121.some(_121.flow(_121.get("categories.0"), _121.isEqual(category))))(resources);
var getSortedChapterWithResources = ({ chapters, resources, pages }) => _121.flow(
  _121.sortBy("number"),
  _121.map(
    _121.update(
      "resources",
      _121.flow(
        _121.map((resourceId) => {
          const resource = _121.find({ id: resourceId }, resources);
          return resource ? { ...resource, page: _121.find((page) => page.slug === `page/${resource.page}`, pages) } : void 0;
        }),
        _121.orderBy(["page.page", "title"], ["asc", "asc"]),
        _121.compact
      )
    )
  ),
  _121.filter("resources.0")
)(chapters);

// src/internals/components/book/bookHeader.jsx
import _122 from "lodash/fp.js";
import { useCallback as useCallback54 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_book_bookHeader.module.css
var src_internals_components_book_bookHeader_default = { "renewedAt": "sk-p5RB6q-renewedAt", "bookInfos": "sk-p5RB6q-bookInfos", "book3D": "sk-p5RB6q-book3D", "discover": "sk-p5RB6q-discover", "contributorsFree": "sk-p5RB6q-contributorsFree", "searchContainer": "sk-p5RB6q-searchContainer", "bookCollection": "sk-p5RB6q-bookCollection", "contributorsPremium": "sk-p5RB6q-contributorsPremium", "bookCover": "sk-p5RB6q-bookCover", "link": "sk-p5RB6q-link", "contributorsIcon": "sk-p5RB6q-contributorsIcon", "bookSection": "sk-p5RB6q-bookSection", "header": "sk-p5RB6q-header", "coverImg": "sk-p5RB6q-coverImg", "bookTitle": "sk-p5RB6q-bookTitle" };

// src/internals/components/book/bookHeader.jsx
import { jsx as jsx135, jsxs as jsxs105 } from "react/jsx-runtime";
var ContributorsLink = ({ contributors, children }) => {
  return contributors ? /* @__PURE__ */ jsx135("a", { className: cx32("contributorsLink", src_internals_components_book_bookHeader_default.link), href: contributors, target: "_blank", rel: "noreferrer", children }) : /* @__PURE__ */ jsx135("span", { className: "contributorsLink", children });
};
var BookInfos2 = ({
  book,
  collection,
  currentUser,
  workbook,
  textbook,
  workplan,
  onTeacherBookClick,
  isCanope,
  navLinks: { textbookLink, workbookLink, workplanLink, participateLink } = {},
  onGoTo,
  isFree = false,
  renewalLabel
}) => {
  const nbContributors = _122.get("nbContributors", book);
  const isEducationalGuide = book == null ? void 0 : book.isEducationalGuide;
  const ButtonLink = useCallback54((props) => /* @__PURE__ */ jsx135(Button64, { className: "button-discover", ...props, onGoTo }), [onGoTo]);
  return /* @__PURE__ */ jsxs105("div", { className: src_internals_components_book_bookHeader_default.bookInfos, children: [
    !isFree && renewalLabel && /* @__PURE__ */ jsx135("div", { className: src_internals_components_book_bookHeader_default.renewedAt, children: renewalLabel }),
    /* @__PURE__ */ jsx135("div", { className: src_internals_components_book_bookHeader_default.bookTitle, children: _122.get("displayTitle", book) }),
    /* @__PURE__ */ jsx135("div", { className: src_internals_components_book_bookHeader_default.bookCollection, children: _122.get("name", collection) }),
    isFree ? /* @__PURE__ */ jsxs105("div", { className: src_internals_components_book_bookHeader_default.contributorsFree, children: [
      /* @__PURE__ */ jsx135(Icon34, { width: 24, name: "pairfilled", className: src_internals_components_book_bookHeader_default.contributorsIcon }),
      /* @__PURE__ */ jsxs105("span", { children: [
        /* @__PURE__ */ jsxs105(ContributorsLink, { contributors: _122.get("contributors", book), children: [
          nbContributors ? `${nbContributors} ` : "Des dizaines d'",
          "enseignants ont particip\xE9 \xE0 ce manuel."
        ] }),
        /* @__PURE__ */ jsx135("br", {}),
        "Rejoignez vous aussi l'aventure collaborative\xA0!"
      ] }),
      /* @__PURE__ */ jsx135(
        ButtonLink,
        {
          href: participateLink,
          target: "_blank",
          theme: "yellow",
          accent: "alt",
          icon: "arrowright",
          iconPosition: "right",
          children: "Je participe"
        }
      )
    ] }) : /* @__PURE__ */ jsx135("div", { className: src_internals_components_book_bookHeader_default.contributorsPremium, children: /* @__PURE__ */ jsxs105("span", { children: [
      /* @__PURE__ */ jsxs105(ContributorsLink, { contributors: _122.get("contributors", book), children: [
        /* @__PURE__ */ jsx135(Icon34, { width: 24, name: "pairfilled" }),
        " ",
        nbContributors ? `${nbContributors} ` : "Des dizaines de ",
        "professeurs"
      ] }),
      " ",
      "ont particip\xE9 \xE0 l'\xE9criture.",
      /* @__PURE__ */ jsx135("br", {})
    ] }) }),
    !_122.get("hasNoTeacherBook", book) && (isFree || _122.get("isTeacher", currentUser)) && !isCanope && !isEducationalGuide && /* @__PURE__ */ jsx135(Button64, { onClick: onTeacherBookClick, icon: "locallibrary", theme: "blue", children: (book == null ? void 0 : book.isClassic) ? "Guide p\xE9dagogique" : "Livre du professeur" }),
    workbook && /* @__PURE__ */ jsx135(ButtonLink, { href: workbookLink, target: "_self", icon: "highlight", accent: "alt", children: "Cahier d'activit\xE9s" }),
    textbook && /* @__PURE__ */ jsx135(ButtonLink, { href: textbookLink, target: "_self", icon: "bookclosed", accent: "alt", children: "Manuel associ\xE9" }),
    workplan && /* @__PURE__ */ jsx135(ButtonLink, { href: workplanLink, target: "_self", icon: "highlight", accent: "alt", children: "Plan de Travail" })
  ] });
};
var BookHeader = ({ book, isDrawerOpen = false, isFree = false, onSearchSubmit = _122.noop, ...props }) => {
  const isCanope = isCanopePublisher(_122.get("publisher", book));
  const maxPage = getMaxPageFromSummary(_122.get("summary", book));
  return /* @__PURE__ */ jsxs105(
    "div",
    {
      className: cx32(isFree ? KIT_CLASSNAME_FREE_LIGHT_THEME3 : KIT_CLASSNAME_DARK_THEME6, src_internals_components_book_bookHeader_default.header),
      "data-drawer-open": +isDrawerOpen,
      "data-is-free": +isFree,
      children: [
        /* @__PURE__ */ jsxs105("div", { className: src_internals_components_book_bookHeader_default.bookSection, children: [
          /* @__PURE__ */ jsx135(BookCover2, { hasWallShadow: false, src: _122.get("urlLite", book), height: "180px", className: src_internals_components_book_bookHeader_default.bookCover }),
          /* @__PURE__ */ jsx135(BookInfos2, { book, isCanope, isFree, ...props })
        ] }),
        !isCanope && /* @__PURE__ */ jsx135("div", { className: KIT_CLASSNAME_LIGHT_THEME8, children: /* @__PURE__ */ jsxs105("div", { className: src_internals_components_book_bookHeader_default.searchContainer, "data-tour": "superkit-search-container", children: [
          /* @__PURE__ */ jsx135("span", { children: "Aller \xE0 la page :" }),
          /* @__PURE__ */ jsx135(
            search_default,
            {
              placeholder: maxPage ? ` / ${maxPage}` : void 0,
              width: "140px",
              theme: null,
              onSubmit: onSearchSubmit,
              align: "right",
              label: null
            }
          )
        ] }) })
      ]
    }
  );
};
var bookHeader_default = BookHeader;

// src/internals/components/book/bookToolbox.jsx
import { Carousel as Carousel2 } from "@lls/lls-kit";
import { openWindow as openWindow3 } from "@lls/utils";
import { useCallback as useCallback55, useMemo as useMemo27 } from "react";
import _123 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_book_bookToolbox.module.css
var src_internals_components_book_bookToolbox_default = { "carousel": "sk-1kpZ7q-carousel", "toolInfos": "sk-1kpZ7q-toolInfos", "toolCover": "sk-1kpZ7q-toolCover", "toolItem": "sk-1kpZ7q-toolItem" };

// src/internals/components/book/bookToolbox.jsx
import { jsx as jsx136, jsxs as jsxs106 } from "react/jsx-runtime";
var ToolItem = ({ onClick, bookId, token, ...tool } = {}) => {
  const href = getToolHref({ tool, bookId, token });
  const onToolClick = useCallback55(() => {
    onClick();
    openWindow3(href, "_blank", "noreferrer");
  }, [href, onClick]);
  const { title, picture, description } = tool;
  return /* @__PURE__ */ jsxs106("div", { className: src_internals_components_book_bookToolbox_default.toolItem, onClick: onToolClick, children: [
    /* @__PURE__ */ jsx136("img", { className: src_internals_components_book_bookToolbox_default.toolCover, src: picture }),
    /* @__PURE__ */ jsxs106("div", { className: src_internals_components_book_bookToolbox_default.toolInfos, children: [
      /* @__PURE__ */ jsx136("h4", { children: title }),
      /* @__PURE__ */ jsx136("p", { children: description })
    ] })
  ] });
};
var BookToolbox = ({ tools, bookId, onClick = _123.noop, token, isDrawerOpen = false }) => {
  const ClickableToolItem = useMemo27(
    () => (props) => /* @__PURE__ */ jsx136(ToolItem, { ...props, onClick, bookId, token }),
    [onClick, bookId, token]
  );
  return /* @__PURE__ */ jsx136("div", { "data-drawer-open": +isDrawerOpen, children: /* @__PURE__ */ jsx136(Carousel2, { className: src_internals_components_book_bookToolbox_default.carousel, ComponentItem: ClickableToolItem, items: tools, width: "100%" }) });
};
var bookToolbox_default = BookToolbox;

// src/internals/components/book/bookResources.jsx
import _124 from "lodash/fp.js";
import { Divider as Divider12, List, ListItem } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_book_bookResources.module.css
var src_internals_components_book_bookResources_default = { "list": "sk-EGVzta-list", "itemTitle": "sk-EGVzta-itemTitle", "subtitle": "sk-EGVzta-subtitle" };

// src/internals/components/book/common.jsx
import { Icon as Icon35 } from "@lls/lls-kit";
import { cx as cx33 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_book_common.module.css
var src_internals_components_book_common_default = { "iconContainer": "sk-j3iybW-iconContainer", "pageIcon": "sk-j3iybW-pageIcon", "emptyTitle": "sk-j3iybW-emptyTitle", "title": "sk-j3iybW-title", "emptyPagesBlock": "sk-j3iybW-emptyPagesBlock", "emptySubtitle": "sk-j3iybW-emptySubtitle" };

// src/internals/components/book/common.jsx
import { jsx as jsx137, jsxs as jsxs107 } from "react/jsx-runtime";
var StyledTitle5 = (props) => /* @__PURE__ */ jsx137("div", { className: src_internals_components_book_common_default.title, ...props });
var CommonPagesIcon = ({ className, iconName, iconColor, iconBg }) => /* @__PURE__ */ jsx137("div", { className: cx33(className, src_internals_components_book_common_default.iconContainer), bgcolor: iconBg, children: /* @__PURE__ */ jsx137(Icon35, { name: iconName, color: iconColor }) });
var EmptyPagesBlock = ({ iconProps, title, subtitle }) => {
  return /* @__PURE__ */ jsxs107("div", { className: src_internals_components_book_common_default.emptyPagesBlock, children: [
    /* @__PURE__ */ jsx137(CommonPagesIcon, { className: src_internals_components_book_common_default.pageIcon, style: { "--s-bgcolor": iconProps == null ? void 0 : iconProps.bgcolor }, ...iconProps }),
    /* @__PURE__ */ jsx137("div", { className: src_internals_components_book_common_default.emptyTitle, children: title }),
    /* @__PURE__ */ jsx137("div", { className: src_internals_components_book_common_default.emptySubtitle, children: subtitle })
  ] });
};

// src/internals/components/book/bookResources.jsx
import { Fragment as Fragment42, jsx as jsx138, jsxs as jsxs108 } from "react/jsx-runtime";
var TitleComponent2 = ({ category }) => /* @__PURE__ */ jsx138("span", { className: src_internals_components_book_bookResources_default.itemTitle, children: category });
var BookResources = ({ resources, onClick }) => {
  const resourcesCountByCategory = getResourcesCountByCategory(resources);
  return /* @__PURE__ */ jsxs108(Fragment42, { children: [
    /* @__PURE__ */ jsxs108(StyledTitle5, { children: [
      "Ressources compl\xE9mentaires",
      /* @__PURE__ */ jsxs108("span", { className: src_internals_components_book_bookResources_default.subtitle, children: [
        _124.size(resources),
        " ",
        handlePluralResources(resources),
        " ",
        handlePlural("num\xE9rique", resources)
      ] })
    ] }),
    /* @__PURE__ */ jsx138(List, { className: src_internals_components_book_bookResources_default.list, foldedMaxLength: 5, children: _124.map(
      ([category, resourceCount]) => /* @__PURE__ */ jsxs108("div", { children: [
        /* @__PURE__ */ jsx138(
          ListItem,
          {
            item: { category, description: `${resourceCount} ${handlePluralResources(resourceCount)}` },
            TitleComponent: TitleComponent2,
            onClick,
            hoverable: true
          }
        ),
        /* @__PURE__ */ jsx138(Divider12, {})
      ] }, category),
      resourcesCountByCategory
    ) })
  ] });
};
var bookResources_default = BookResources;

// src/internals/components/book/bookPremiumResources.tsx
import _126 from "lodash/fp.js";
import { useState as useState53 } from "react";
import { Button as Button66, Carousel as Carousel3, Icon as Icon37, KIT_CLASSNAME_FREE_LIGHT_THEME as KIT_CLASSNAME_FREE_LIGHT_THEME4, Stamp as Stamp7 } from "@lls/lls-kit";
import { cx as cx35, makeComponent as makeComponent8, pipe as pipe3 } from "@lls/utils";

// src/internals/components/modal/premiumResourcesModal.jsx
import React5 from "react";
import _125 from "lodash/fp.js";
import { Button as Button65, Divider as Divider13, Icon as Icon36, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME9, Modal as Modal16, Wavy as Wavy6 } from "@lls/lls-kit";
import { cx as cx34 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_modal_premiumResourcesModal.module.css
var src_internals_components_modal_premiumResourcesModal_default = { "mobileTitle": "sk-Yh2hbq-mobileTitle", "stamp": "sk-Yh2hbq-stamp", "description": "sk-Yh2hbq-description", "cardTitle": "sk-Yh2hbq-cardTitle", "cardInfos": "sk-Yh2hbq-cardInfos", "header": "sk-Yh2hbq-header", "count": "sk-Yh2hbq-count", "cardTitleContainer": "sk-Yh2hbq-cardTitleContainer", "card": "sk-Yh2hbq-card", "modalContent": "sk-Yh2hbq-modalContent", "divider": "sk-Yh2hbq-divider", "desktopTitle": "sk-Yh2hbq-desktopTitle", "modal": "sk-Yh2hbq-modal", "hoverText": "sk-Yh2hbq-hoverText", "closeButton": "sk-Yh2hbq-closeButton" };

// src/internals/components/modal/premiumResourcesModal.jsx
import { jsx as jsx139, jsxs as jsxs109 } from "react/jsx-runtime";
var PremiumResourcesModal = ({ premiumResources, className = "", onClose, onResourceClick, ...props }) => {
  return /* @__PURE__ */ jsx139(
    Modal16,
    {
      maxwidth: "md",
      isRoot: true,
      withCloseButton: false,
      closeModal: onClose,
      className: cx34(`${KIT_CLASSNAME_LIGHT_THEME9} ${className}`, src_internals_components_modal_premiumResourcesModal_default.modal),
      ...props,
      children: /* @__PURE__ */ jsxs109("div", { className: src_internals_components_modal_premiumResourcesModal_default.header, children: [
        /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.desktopTitle, children: /* @__PURE__ */ jsx139(Wavy6, { waveColor: "var(--premium-50-color)", children: _125.get("0.category.title", premiumResources) }) }),
        /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.mobileTitle, children: _125.get("0.category.title", premiumResources) }),
        /* @__PURE__ */ jsx139(
          Button65,
          {
            className: src_internals_components_modal_premiumResourcesModal_default.closeButton,
            size: "small",
            icon: "cancel",
            theme: "gray",
            accent: "floating",
            onClick: onClose,
            inverted: true
          }
        ),
        /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.description, children: _125.get("0.category.description", premiumResources) }),
        /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.modalContent, children: _125.map.convert({ cap: false })(({ id, type, url, title, subtitle, comingSoon }, index) => {
          return /* @__PURE__ */ jsxs109(React5.Fragment, { children: [
            /* @__PURE__ */ jsxs109(
              "div",
              {
                className: src_internals_components_modal_premiumResourcesModal_default.card,
                "data-disabled": +!!comingSoon,
                onClick: () => {
                  comingSoon ? _125.noop() : onResourceClick({ url });
                },
                children: [
                  /* @__PURE__ */ jsxs109("div", { className: src_internals_components_modal_premiumResourcesModal_default.cardInfos, children: [
                    /* @__PURE__ */ jsxs109("div", { className: src_internals_components_modal_premiumResourcesModal_default.cardTitleContainer, children: [
                      /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.cardTitle, children: title }),
                      /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.stamp, children: comingSoon || type })
                    ] }),
                    subtitle && /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.count, children: subtitle })
                  ] }),
                  /* @__PURE__ */ jsx139("div", { className: src_internals_components_modal_premiumResourcesModal_default.hoverText, children: !comingSoon && /* @__PURE__ */ jsx139(Icon36, { name: "arrowright", height: "16", width: "16" }) })
                ]
              },
              id
            ),
            index !== _125.size(premiumResources) - 1 && /* @__PURE__ */ jsx139(Divider13, { className: src_internals_components_modal_premiumResourcesModal_default.divider })
          ] }, `${id}${index}`);
        }, premiumResources) })
      ] })
    }
  );
};
var premiumResourcesModal_default = PremiumResourcesModal;

// tmp_esbuild1736180050074/_src_internals_components_book_bookPremiumResources.module.css
var src_internals_components_book_bookPremiumResources_default = { "premium": "sk-VrkAQG-premium", "card": "sk-VrkAQG-card", "type": "sk-VrkAQG-type", "count": "sk-VrkAQG-count", "bookPremiumResources": "sk-VrkAQG-bookPremiumResources", "typeStamp": "sk-VrkAQG-typeStamp", "icon": "sk-VrkAQG-icon", "subtitle": "sk-VrkAQG-subtitle", "carousel": "sk-VrkAQG-carousel", "comingSoonStamp": "sk-VrkAQG-comingSoonStamp", "button": "sk-VrkAQG-button" };

// src/internals/components/book/bookPremiumResources.tsx
import { Fragment as Fragment43, jsx as jsx140, jsxs as jsxs110 } from "react/jsx-runtime";
var StyledComingSoonStamp = makeComponent8("div", src_internals_components_book_bookPremiumResources_default.comingSoonStamp);
var SimpleCarouselItem2 = ({
  campaign,
  title,
  subtitle,
  imgUrl,
  imgAlt = "",
  setOpenCategory,
  onCategoryClick,
  comingSoon,
  type,
  metaCategory,
  downloadBlocked,
  isPremiumMode = true
} = {}) => {
  const handleClick = () => {
    if (comingSoon || !isPremiumMode) return;
    setOpenCategory == null ? void 0 : setOpenCategory(title);
    onCategoryClick == null ? void 0 : onCategoryClick({ title, campaign, metaCategory, downloadBlocked });
  };
  return /* @__PURE__ */ jsxs110("div", { className: src_internals_components_book_bookPremiumResources_default.card, onClick: handleClick, "data-disabled": +!isPremiumMode, children: [
    comingSoon && /* @__PURE__ */ jsx140("div", { className: src_internals_components_book_bookPremiumResources_default.comingSoonStamp, children: comingSoon }),
    /* @__PURE__ */ jsx140("img", { src: imgUrl, alt: imgAlt }),
    /* @__PURE__ */ jsx140(Stamp7, { className: cx35(KIT_CLASSNAME_FREE_LIGHT_THEME4, src_internals_components_book_bookPremiumResources_default.typeStamp), theme: "premium", size: "small", children: type }),
    /* @__PURE__ */ jsx140("div", { className: src_internals_components_book_bookPremiumResources_default.type, children: title }),
    /* @__PURE__ */ jsx140("div", { className: src_internals_components_book_bookPremiumResources_default.count, children: subtitle })
  ] });
};
var defaultTitle = /* @__PURE__ */ jsxs110(StyledTitle5, { children: [
  "Actualisations et enrichissements 2023 ",
  /* @__PURE__ */ jsx140(Icon37, { className: src_internals_components_book_bookPremiumResources_default.icon, name: "premium" })
] });
var defaultSubtitle = /* @__PURE__ */ jsx140("span", { className: src_internals_components_book_bookPremiumResources_default.subtitle, children: "D\xE9couvrez les ressources actualis\xE9es et les enrichissements du manuel dans la version Premium." });
var BookPremiumResources = ({
  premiumResources,
  onCategoryClick = _126.noop,
  onResourceClick = _126.noop,
  title = defaultTitle,
  subtitle = defaultSubtitle,
  displayCardShadow = true,
  displayTypeStamp = false,
  ModalComponent = premiumResourcesModal_default
}) => {
  const [openCategory, setOpenCategory] = useState53("");
  const items = pipe3(
    premiumResources,
    _126.map(
      ({ category, type, metaCategory, downloadBlocked }) => _126.assign(category, { type, metaCategory, downloadBlocked })
    ),
    _126.sortBy("subtitle"),
    _126.uniqBy("title"),
    _126.sortBy("order"),
    _126.map(_126.assign({ onCategoryClick, setOpenCategory }))
  );
  return /* @__PURE__ */ jsxs110(Fragment43, { children: [
    openCategory && /* @__PURE__ */ jsx140(
      ModalComponent,
      {
        premiumResources: _126.flow(
          _126.filter({ category: { title: openCategory } }),
          _126.sortBy("order")
        )(premiumResources),
        onClose: () => setOpenCategory(""),
        onResourceClick
      }
    ),
    /* @__PURE__ */ jsxs110("div", { className: src_internals_components_book_bookPremiumResources_default.bookPremiumResources, "data-tour": "superkit-renewal", children: [
      title,
      subtitle,
      /* @__PURE__ */ jsx140(
        Carousel3,
        {
          className: src_internals_components_book_bookPremiumResources_default.carousel,
          items,
          ComponentItem: SimpleCarouselItem2,
          width: "100%",
          "data-shadow": +displayCardShadow,
          "data-type-stamp": +displayTypeStamp
        }
      )
    ] })
  ] });
};
var BookFakePremiumResources = ({
  onCategoryClick = _126.noop,
  onStartDemoClick,
  isTrialOpen
}) => {
  const items = [
    {
      campaign: "demo_projector",
      title: "Projetez toutes les ressources",
      imgUrl: "/assets/img/renewal/fake-projection.webp",
      imgAlt: "Animation illustrant la fonctionnalit\xE9 de vid\xE9oprojection"
    },
    {
      campaign: "demo_correction",
      title: "T\xE9l\xE9chargez les pages de manuel",
      imgUrl: "/assets/img/renewal/download-offline.webp",
      imgAlt: "Animation illustrant la fonctionnalit\xE9 de t\xE9l\xE9chargement de page"
    },
    {
      campaign: "demo_creation",
      title: "Cr\xE9ez vos pages personnalis\xE9es",
      imgUrl: "/assets/img/renewal/custom-page.webp",
      imgAlt: "Animation illustrant la fonctionnalit\xE9 de cr\xE9ation de page"
    }
  ].map((e) => ({ ...e, onCategoryClick, setOpenCategory: _126.noop, isPremiumMode: false }));
  return /* @__PURE__ */ jsxs110("div", { className: src_internals_components_book_bookPremiumResources_default.bookPremiumResources, children: [
    /* @__PURE__ */ jsxs110(StyledTitle5, { children: [
      "Plus de fonctionnalit\xE9s dans la version ",
      /* @__PURE__ */ jsx140("span", { className: src_internals_components_book_bookPremiumResources_default.premium, children: "Premium" }),
      " ",
      /* @__PURE__ */ jsx140(Icon37, { className: src_internals_components_book_bookPremiumResources_default.icon, name: "premium" })
    ] }),
    /* @__PURE__ */ jsx140("span", { className: src_internals_components_book_bookPremiumResources_default.subtitle, children: "Profitez, dans la version Premium, de fonctionnalit\xE9s et contenus exclusifs con\xE7us pour faciliter vos usages." }),
    /* @__PURE__ */ jsx140("br", {}),
    /* @__PURE__ */ jsx140(
      Button66,
      {
        className: src_internals_components_book_bookPremiumResources_default.button,
        onClick: onStartDemoClick,
        theme: "premium",
        icon: "arrowright",
        iconPosition: "right",
        children: isTrialOpen ? "Testez la version Premium" : "D\xE9couvrir l\u2019offre premium"
      }
    ),
    /* @__PURE__ */ jsx140(Carousel3, { className: src_internals_components_book_bookPremiumResources_default.carousel, items, ComponentItem: SimpleCarouselItem2, width: "100%" })
  ] });
};
var bookPremiumResources_default = BookPremiumResources;

// src/internals/components/book/bookResourcesModal.jsx
import _127 from "lodash/fp.js";
import { openWindow as openWindow4 } from "@lls/utils";
import { Accordion as Accordion2, Icon as Icon38, ListItem as ListItem2, Modal as Modal17 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_book_bookResourcesModal.module.css
var src_internals_components_book_bookResourcesModal_default = { "icon": "sk-mPsR6a-icon", "accordionTitle": "sk-mPsR6a-accordionTitle", "modalContent": "sk-mPsR6a-modalContent", "accordionContainer": "sk-mPsR6a-accordionContainer", "modalTitle": "sk-mPsR6a-modalTitle" };

// src/internals/components/book/bookResourcesModal.jsx
import { jsx as jsx141, jsxs as jsxs111 } from "react/jsx-runtime";
var AccordionTitle = ({ chapter: { numShow, title } = {}, resources }) => {
  return /* @__PURE__ */ jsxs111("div", { className: src_internals_components_book_bookResourcesModal_default.accordionTitle, children: [
    /* @__PURE__ */ jsxs111("h3", { className: "kit-heading3", children: [
      _127.isEmpty(numShow) ? "" : `${numShow} : `,
      " ",
      title,
      " "
    ] }),
    /* @__PURE__ */ jsx141("span", { className: "kit-heading4", children: getNumericalResourcesPlural(resources) })
  ] });
};
var ItemTitle = ({ resource }) => /* @__PURE__ */ jsxs111("span", { children: [
  /* @__PURE__ */ jsx141("b", { children: _127.get("title", resource) }),
  !isFromLLS(_127.get("url", resource)) && /* @__PURE__ */ jsx141(Icon38, { className: src_internals_components_book_bookResourcesModal_default.icon, name: "linkout", width: 18, height: 18 })
] });
var ChapterAccordion = ({ chapter, resources, onClick }) => {
  const onListItemClick = ({ resource }) => {
    onClick(resource);
    openWindow4(_127.get("url", resource), "_blank");
  };
  return /* @__PURE__ */ jsx141(Accordion2, { category: /* @__PURE__ */ jsx141(AccordionTitle, { chapter, resources }), children: /* @__PURE__ */ jsx141("div", { className: src_internals_components_book_bookResourcesModal_default.accordionContainer, children: _127.map.convert({ cap: false })(
    (resource, index) => /* @__PURE__ */ jsx141(
      ListItem2,
      {
        item: { resource },
        TitleComponent: ItemTitle,
        onClick: onListItemClick,
        withDivider: !_127.isEqual(index, _127.size(resources) - 1),
        hoverable: true
      },
      _127.get("id", resource)
    ),
    resources
  ) }) });
};
var ModalTitle = ({ category, resources }) => /* @__PURE__ */ jsxs111("div", { className: src_internals_components_book_bookResourcesModal_default.modalTitle, children: [
  /* @__PURE__ */ jsx141("h1", { className: "kit-heading2", children: category }),
  /* @__PURE__ */ jsx141("span", { className: "kit-body1", children: getNumericalResourcesPlural(resources) })
] });
var BookResourcesModal = ({ category, resources, chapters, pages, onClick = _127.noop, close }) => {
  const filteredResources = _127.filter(_127.flow(_127.get("categories.0"), _127.isEqual(category)), resources);
  const chaptersWithResources = getSortedChapterWithResources({ chapters, resources: filteredResources, pages });
  return /* @__PURE__ */ jsx141(Modal17, { title: /* @__PURE__ */ jsx141(ModalTitle, { category, resources: filteredResources }), closeModal: close, maxWidth: "md", children: /* @__PURE__ */ jsx141("div", { className: src_internals_components_book_bookResourcesModal_default.modalContent, children: _127.map(
    (chapter) => /* @__PURE__ */ jsx141(
      ChapterAccordion,
      {
        chapter,
        resources: _127.get("resources", chapter),
        chapters,
        onClick
      },
      _127.get("id", chapter)
    ),
    chaptersWithResources
  ) }) });
};
var bookResourcesModal_default = BookResourcesModal;

// src/internals/components/communityContactHelp/communityContactHelp.tsx
import _128 from "lodash/fp.js";
import { Button as Button67, Icon as Icon39 } from "@lls/lls-kit";
import { cx as cx36, getWindow } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_communityContactHelp_communityContactHelp.module.css
var src_internals_components_communityContactHelp_communityContactHelp_default = { "contactPictureContainer": "sk-Ishf8q-contactPictureContainer", "contactPicture": "sk-Ishf8q-contactPicture", "contactLink": "sk-Ishf8q-contactLink", "cardContainer": "sk-Ishf8q-cardContainer", "decorationContainer": "sk-Ishf8q-decorationContainer", "icon": "sk-Ishf8q-icon", "chatButton": "sk-Ishf8q-chatButton", "contactEmail": "sk-Ishf8q-contactEmail", "contactNameContainer": "sk-Ishf8q-contactNameContainer", "textDecoration": "sk-Ishf8q-textDecoration superkit-permanentMarkerRegular", "contactName": "sk-Ishf8q-contactName", "contactIcon": "sk-Ishf8q-contactIcon", "firstNameContainer": "sk-Ishf8q-firstNameContainer superkit-permanentMarkerRegular", "rightArrow": "sk-Ishf8q-rightArrow", "phoneNumber": "sk-Ishf8q-phoneNumber", "container": "sk-Ishf8q-container", "contactCaption": "sk-Ishf8q-contactCaption", "contactInfoGrid": "sk-Ishf8q-contactInfoGrid" };

// src/internals/components/communityContactHelp/communityContactHelp.tsx
import { Fragment as Fragment44, jsx as jsx142, jsxs as jsxs112 } from "react/jsx-runtime";
var SUPPORT_EMAIL = "support@lelivrescolaire.fr";
var getEmailBody = ({ contactFirstName, school, subjects }) => `
Bonjour ${contactFirstName || ""},%0D%0D
${school || (subjects == null ? void 0 : subjects.length) ? `Voici quelques informations pour simplifier le traitement de ma demande :%0D
    ${(school == null ? void 0 : school.rne) ? `- UAI de l'\xE9tablissement : ${school == null ? void 0 : school.rne}%0D` : ""}
    ${(subjects == null ? void 0 : subjects.length) ? `- Mati\xE8res enseign\xE9es : ${_128.flow(_128.map("name"), _128.join(", "))(subjects)}` : ""}
      %0D%0D` : ""}
`;
var ContactNameIcon = ({ firstname, top, left, color }) => /* @__PURE__ */ jsxs112(
  "div",
  {
    className: src_internals_components_communityContactHelp_communityContactHelp_default.firstNameContainer,
    style: { "--c-top": `${top}px`, "--c-left": `${left}px`, "--c-color": color },
    children: [
      /* @__PURE__ */ jsx142(Icon39, { className: src_internals_components_communityContactHelp_communityContactHelp_default.bubbleIcon, name: "bubble" }),
      firstname
    ]
  }
);
var ContactPicture = ({ url, isDrawerOpen }) => /* @__PURE__ */ jsx142("div", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactPictureContainer, "data-drawer-open": +isDrawerOpen, children: /* @__PURE__ */ jsx142("div", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactPicture, style: { "--background-url": `url(${url})` } }) });
var ContactEmail = ({ email, firstname, school, subjects }) => /* @__PURE__ */ jsxs112("div", { className: cx36(src_internals_components_communityContactHelp_communityContactHelp_default.contactInfoGrid, src_internals_components_communityContactHelp_communityContactHelp_default.contactEmail), children: [
  /* @__PURE__ */ jsx142(Icon39, { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactIcon, name: "mailfill" }),
  /* @__PURE__ */ jsx142(
    "a",
    {
      className: cx36(src_internals_components_communityContactHelp_communityContactHelp_default.contactLink),
      href: `mailto:${email}?subject=Question sur Lelivrescolaire&body=${getEmailBody({ contactFirstName: firstname, school, subjects })}`,
      children: email
    }
  )
] });
var ChatButton = ({ firstname }) => {
  const hasCrisp = _128.get("$crisp", getWindow());
  const openCrispChat = () => {
    const $crisp = hasCrisp;
    $crisp == null ? void 0 : $crisp.push(["do", "chat:open"]);
  };
  return hasCrisp ? /* @__PURE__ */ jsxs112(Button67, { icon: "bubbleempty", onClick: openCrispChat, className: src_internals_components_communityContactHelp_communityContactHelp_default.chatButton, children: [
    "Chatter avec ",
    firstname
  ] }) : null;
};
var ContactInfos = ({
  contact: { firstname, lastname, gender, phone, secondPhone, email: iEmail, role },
  school,
  subjects,
  isTrial,
  displayChatButton
}) => {
  const email = isTrial ? SUPPORT_EMAIL : iEmail;
  return /* @__PURE__ */ jsx142("div", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactInfosContainer, children: isTrial ? /* @__PURE__ */ jsxs112(Fragment44, { children: [
    /* @__PURE__ */ jsx142("p", { children: "Si vous avez besoin d'aide, n'h\xE9sitez pas \xE0 nous contacter \xE0 l'adresse mail :" }),
    /* @__PURE__ */ jsx142(ContactEmail, { email, subjects, school })
  ] }) : /* @__PURE__ */ jsxs112(Fragment44, { children: [
    /* @__PURE__ */ jsxs112("h4", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactName, children: [
      firstname,
      " ",
      lastname
    ] }),
    /* @__PURE__ */ jsx142("div", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactCaption, children: role ? role : /* @__PURE__ */ jsx142(Fragment44, { children: gender === "neutral" ? "Vos accompagnateurs num\xE9riques" : gender === "female" ? "Votre accompagnatrice num\xE9rique" : "Votre accompagnateur num\xE9rique" }) }),
    /* @__PURE__ */ jsxs112("div", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactInfoGrid, children: [
      /* @__PURE__ */ jsx142(Icon39, { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactIcon, name: "phoneintalk" }),
      /* @__PURE__ */ jsx142("a", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactLink, href: `tel:${phone}`, children: phone })
    ] }),
    /* @__PURE__ */ jsx142("div", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactInfoGrid, children: /* @__PURE__ */ jsx142("a", { className: src_internals_components_communityContactHelp_communityContactHelp_default.contactLink, href: `tel:${secondPhone}`, children: secondPhone }) }),
    /* @__PURE__ */ jsx142(ContactEmail, { email, firstname, subjects, school }),
    displayChatButton && /* @__PURE__ */ jsx142(ChatButton, { firstname })
  ] }) });
};
var CommunityContactHelp = ({
  isTrial,
  isDrawerOpen = false,
  displayChatButton = false,
  contact,
  subjects,
  school,
  firstContactNameIcon,
  secondContactNameIcon
}) => {
  return _128.isEmpty(contact) ? null : /* @__PURE__ */ jsxs112("section", { className: src_internals_components_communityContactHelp_communityContactHelp_default.container, children: [
    /* @__PURE__ */ jsx142("div", { className: cx36(src_internals_components_communityContactHelp_communityContactHelp_default.decorationContainer, src_internals_components_communityContactHelp_communityContactHelp_default.textDecoration), "data-drawer-open": +isDrawerOpen, children: /* @__PURE__ */ jsxs112("p", { children: [
      "Nous sommes l\xE0 ",
      /* @__PURE__ */ jsx142("br", {}),
      " pour vous aider"
    ] }) }),
    /* @__PURE__ */ jsxs112("div", { className: src_internals_components_communityContactHelp_communityContactHelp_default.cardContainer, "data-drawer-open": +isDrawerOpen, children: [
      !isTrial && /* @__PURE__ */ jsx142(ContactPicture, { url: _128.get("url", contact), isDrawerOpen }),
      /* @__PURE__ */ jsx142(
        ContactInfos,
        {
          contact,
          school,
          subjects,
          isTrial,
          displayChatButton
        }
      ),
      /* @__PURE__ */ jsx142(
        "img",
        {
          className: src_internals_components_communityContactHelp_communityContactHelp_default.rightArrow,
          src: "/assets/img/communityContactHelp/right-arrow.svg",
          "data-drawer-open": +isDrawerOpen,
          alt: ""
        }
      )
    ] }),
    /* @__PURE__ */ jsxs112(
      "div",
      {
        className: cx36(src_internals_components_communityContactHelp_communityContactHelp_default.decorationContainer, src_internals_components_communityContactHelp_communityContactHelp_default.contactNameContainer),
        "data-drawer-open": +isDrawerOpen,
        children: [
          firstContactNameIcon && /* @__PURE__ */ jsx142(ContactNameIcon, { firstname: firstContactNameIcon, top: 20, left: 0, color: "var(--secondary-40-color)" }),
          secondContactNameIcon && /* @__PURE__ */ jsx142(ContactNameIcon, { firstname: secondContactNameIcon, top: 0, left: 50, color: "var(--green-50-color)" })
        ]
      }
    )
  ] });
};
var communityContactHelp_default = CommunityContactHelp;

// src/internals/components/book/pageList.jsx
import _130 from "lodash/fp.js";
import { useCallback as useCallback56 } from "react";
import { Divider as Divider14, Icon as Icon40, List as List2, ListItem as ListItem3 } from "@lls/lls-kit";

// src/internals/v2/utils/page.ts
import dayjs3 from "dayjs";
import _129 from "lodash/fp.js";
var shouldHideContextualActions = ({ page, oldPage }) => {
  const pageId = page == null ? void 0 : page.id;
  const oldPageId = oldPage == null ? void 0 : oldPage.id;
  const originalPageId = page == null ? void 0 : page.originalPage;
  const parentPageId = page == null ? void 0 : page.parent;
  return pageId !== oldPageId && (originalPageId !== oldPageId || _129.isNil(oldPageId)) && (parentPageId !== oldPageId || _129.isNil(parentPageId));
};
var getFilteredAndOrderedPages = ({
  pages,
  nbDaysLimit = NB_DAYS_LIMIT,
  timeProp
}) => _129.flow(
  _129.compact,
  _129.filter((page) => {
    const date = dayjs3(timeProp ? page[timeProp] : page.updatedAt || page.createdAt);
    return dayjs3().diff(date, "day") < nbDaysLimit;
  }),
  _129.orderBy((page) => timeProp ? page[timeProp] : page.updatedAt || page.createdAt, "desc"),
  _129.take(10)
)(pages);

// src/internals/components/book/pageList.jsx
import dayjs4 from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime.js";

// tmp_esbuild1736180050074/_src_internals_components_book_pageList.module.css
var src_internals_components_book_pageList_default = { "title": "sk-tU7pZW-title", "pageList": "sk-tU7pZW-pageList", "header": "sk-tU7pZW-header", "chapter": "sk-tU7pZW-chapter", "premiumIcon": "sk-tU7pZW-premiumIcon" };

// src/internals/components/book/pageList.jsx
import { Fragment as Fragment45, jsx as jsx143, jsxs as jsxs113 } from "react/jsx-runtime";
dayjs4.extend(relativeTime);
var getLabelFromTimeProp = ({ timeProp, updatedAt, withTimePrefix }) => {
  switch (timeProp) {
    case "seenAt":
      return "";
    case "sharedAt":
      return "Re\xE7ue ";
    default:
      return updatedAt ? "Modifi\xE9e " : "Cr\xE9\xE9e ";
  }
};
var getPageDate = ({ timeProp, updatedAt, createdAt, ...page }) => dayjs4(timeProp ? _130.get(timeProp, page) : updatedAt || createdAt).fromNow();
var map4 = _130.map.convert({ cap: false });
var TitleComponent3 = ({ numShow, title }) => /* @__PURE__ */ jsxs113(Fragment45, { children: [
  /* @__PURE__ */ jsx143("span", { className: src_internals_components_book_pageList_default.chapter, children: numShow && `${numShow} - ` }),
  title
] });
var PageList3 = ({
  title,
  premiumIcon,
  titleButtonElement,
  pages: iPages = [],
  timeProp,
  iconProps,
  withTimePrefix = true,
  book,
  emptyTitle,
  emptySubtitle,
  onClick = _130.noop
}) => {
  const pages = _130.flow(
    (pages2) => getFilteredAndOrderedPages({ pages: pages2, nbDaysLimit: 14, timeProp }),
    (pages2) => mapPagesToChapterNumShow(_130.get("summary", book), pages2),
    _130.map(({ updatedAt, ...page }) => ({
      ...page,
      title: page.displayTitle,
      description: `${getLabelFromTimeProp({ timeProp, updatedAt, withTimePrefix })}
        ${getPageDate({ timeProp, updatedAt, ...page })}
        `
    })),
    _130.slice(0, 10)
  )(iPages);
  const EmptyComponent = useCallback56(
    () => /* @__PURE__ */ jsx143(EmptyPagesBlock, { iconProps, title: emptyTitle, subtitle: emptySubtitle }),
    [iconProps, emptyTitle, emptySubtitle]
  );
  return /* @__PURE__ */ jsxs113("div", { className: src_internals_components_book_pageList_default.pageList, children: [
    /* @__PURE__ */ jsxs113("div", { className: src_internals_components_book_pageList_default.header, children: [
      /* @__PURE__ */ jsxs113("div", { className: src_internals_components_book_pageList_default.title, children: [
        title,
        premiumIcon && /* @__PURE__ */ jsx143(Icon40, { className: src_internals_components_book_pageList_default.premiumIcon, name: "premium" })
      ] }),
      !_130.isUndefined(titleButtonElement) && titleButtonElement
    ] }),
    /* @__PURE__ */ jsx143(List2, { EmptyComponent, children: map4(
      (page, index) => /* @__PURE__ */ jsxs113("div", { children: [
        /* @__PURE__ */ jsx143(ListItem3, { item: page, iconProps, TitleComponent: TitleComponent3, onClick, hoverable: true }),
        !_130.isEqual(_130.size(pages), index + 1) && /* @__PURE__ */ jsx143(Divider14, {})
      ] }, index),
      pages
    ) })
  ] });
};
var pageList_default3 = PageList3;

// src/internals/components/modal/npsModal.jsx
import { useState as useState54 } from "react";
import { Button as Button68, Modal as Modal18 } from "@lls/lls-kit";
import _131 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_modal_npsModal.module.css
var src_internals_components_modal_npsModal_default = { "modal": "sk-tLTlBa-modal", "grades": "sk-tLTlBa-grades", "subtitle": "sk-tLTlBa-subtitle", "labels": "sk-tLTlBa-labels", "modalTitle": "sk-tLTlBa-modalTitle", "modalContent": "sk-tLTlBa-modalContent" };

// src/internals/components/modal/npsModal.jsx
import { jsx as jsx144, jsxs as jsxs114 } from "react/jsx-runtime";
var Grades = ({ selectedGrade, setSelectedGrade }) => /* @__PURE__ */ jsx144("div", { className: src_internals_components_modal_npsModal_default.grades, children: _131.times((grade) => {
  grade++;
  return /* @__PURE__ */ jsx144(Button68, { onClick: () => setSelectedGrade(grade), accent: grade === selectedGrade ? "main" : "alt", children: _131.toString(grade) }, grade);
}, 10) });
var NpsModal = ({ onSubmit, close, isFree = false }) => {
  const [selectedGrade, setSelectedGrade] = useState54(void 0);
  return /* @__PURE__ */ jsx144(
    Modal18,
    {
      className: src_internals_components_modal_npsModal_default.modal,
      title: /* @__PURE__ */ jsx144("h3", { className: src_internals_components_modal_npsModal_default.modalTitle, children: "Votre avis nous int\xE9resse !" }),
      closeModal: close,
      children: /* @__PURE__ */ jsxs114("div", { className: src_internals_components_modal_npsModal_default.modalContent, children: [
        /* @__PURE__ */ jsxs114("h4", { className: src_internals_components_modal_npsModal_default.subtitle, children: [
          "Recommanderiez-vous notre ",
          isFree ? "site web" : "manuel num\xE9rique Premium",
          " \xE0 un(e) coll\xE8gue ?"
        ] }),
        /* @__PURE__ */ jsx144(Grades, { setSelectedGrade, selectedGrade }),
        /* @__PURE__ */ jsxs114("div", { className: src_internals_components_modal_npsModal_default.labels, children: [
          /* @__PURE__ */ jsx144("div", { children: "Peu probable" }),
          /* @__PURE__ */ jsx144("div", { children: "Tr\xE8s probable" })
        ] }),
        /* @__PURE__ */ jsx144(
          Button68,
          {
            icon: "arrowright",
            iconPosition: "right",
            onClick: () => onSubmit(selectedGrade),
            disabled: _131.isNil(selectedGrade),
            children: "Valider"
          }
        )
      ] })
    }
  );
};
var npsModal_default = NpsModal;

// src/internals/components/navbar/index.tsx
import _143 from "lodash/fp.js";
import { KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME7, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME11, Navbar, useAudio, useConfetti } from "@lls/lls-kit";
import { ANALYTICS_LINK_CLICKED, cx as cx38, dispatchAnalyticsEvent as dispatchAnalyticsEvent20 } from "@lls/utils";

// src/internals/components/navbar/buttons/aboutUsButton.tsx
import _132 from "lodash/fp.js";
import { useCallback as useCallback57, useMemo as useMemo28 } from "react";
import { Accordion as Accordion3, Button as Button69, MenuButton as MenuButton9 } from "@lls/lls-kit";
import { jsx as jsx145, jsxs as jsxs115 } from "react/jsx-runtime";
var AboutUsButton = ({
  mobile = false,
  closeSidePanel = _132.noop,
  links,
  navigateCallback = _132.noop
}) => {
  const aboutLinks = useMemo28(() => (links == null ? void 0 : links.aboutLinks) || {}, [links]);
  const onProjectOriginClick = useCallback57(() => {
    closeSidePanel();
    navigateCallback(aboutLinks.projectOrigin);
  }, [closeSidePanel, aboutLinks, navigateCallback]);
  const onOurSkillsClick = useCallback57(() => {
    closeSidePanel();
    navigateCallback(aboutLinks.ourSkills);
  }, [closeSidePanel, aboutLinks, navigateCallback]);
  const onCollaborativeProjectClick = useCallback57(() => {
    closeSidePanel();
    navigateCallback(aboutLinks.collaborativeProject);
  }, [closeSidePanel, aboutLinks, navigateCallback]);
  const aboutButtonList = useMemo28(
    () => [
      {
        msg: "L'origine du projet",
        onClick: onProjectOriginClick,
        href: aboutLinks.projectOrigin
      },
      {
        msg: "Nos savoir-faire",
        onClick: onOurSkillsClick,
        href: aboutLinks.ourSkills
      },
      {
        msg: "Un projet collaboratif unique",
        onClick: onCollaborativeProjectClick,
        href: aboutLinks.collaborativeProject
      }
    ],
    [onProjectOriginClick, onOurSkillsClick, onCollaborativeProjectClick, aboutLinks]
  );
  return mobile ? /* @__PURE__ */ jsxs115(Accordion3, { category: "Qui sommes-nous", children: [
    /* @__PURE__ */ jsx145(Button69, { href: aboutLinks.projectOrigin, theme: "gray", accent: "floating", onClick: onProjectOriginClick, children: "L'origine du projet" }),
    /* @__PURE__ */ jsx145(Button69, { href: aboutLinks.ourSkills, theme: "gray", accent: "floating", onClick: onOurSkillsClick, children: "Nos savoir-faire" }),
    /* @__PURE__ */ jsx145(
      Button69,
      {
        href: aboutLinks.collaborativeProject,
        theme: "gray",
        accent: "floating",
        onClick: onCollaborativeProjectClick,
        children: "Un projet collaboratif unique"
      }
    )
  ] }) : /* @__PURE__ */ jsx145(
    MenuButton9,
    {
      fixed: true,
      alignment: "end",
      theme: "gray",
      accent: "floating",
      size: "xsmall",
      icon: "chevrondown",
      iconPosition: "right",
      position: "bottom",
      listItems: aboutButtonList,
      children: "Qui sommes-nous"
    }
  );
};
var aboutUsButton_default = AboutUsButton;

// src/internals/components/navbar/buttons/booksButton.tsx
import { autoUpdate, shift, useFloating } from "@floating-ui/react";
import _135 from "lodash/fp.js";
import { useEffect as useEffect26, useRef as useRef14, useState as useState56 } from "react";
import { Button as Button72 } from "@lls/lls-kit";
import { isInsideNode } from "@lls/utils";

// src/internals/utils/navbar.tsx
import _133 from "lodash/fp.js";
var SUBJECTS_SLUG = [
  {
    slug: "matiere/francais",
    name: "Fran\xE7ais"
  },
  {
    slug: "matiere/histoire-geographie-emc",
    name: "Histoire-G\xE9ographie-EMC"
  },
  {
    slug: "matiere/sciences-economiques-et-sociales",
    name: "SES"
  },
  {
    slug: "matiere/philosophie",
    name: "Philosophie"
  },
  {
    slug: "matiere/anglais",
    name: "Anglais"
  },
  {
    slug: "matiere/espagnol",
    name: "Espagnol"
  },
  {
    slug: "matiere/mathematiques",
    name: "Math\xE9matiques"
  },
  {
    slug: "matiere/physique-chimie",
    name: "Physique-Chimie"
  },
  {
    slug: "matiere/sciences-de-la-vie-et-de-la-terre",
    name: "SVT"
  },
  {
    slug: "matiere/enseignement-scientifique",
    name: "Enseignement Scientifique"
  },
  {
    slug: "matiere/sciences-numeriques-et-technologie",
    name: "SNT"
  },
  {
    slug: "matiere/prevention-sante-environnement",
    name: "PSE"
  },
  {
    slug: "matiere/sciences-et-technologie",
    name: "Sciences et Technologie"
  }
];
var SUBJECT_BY_FIELD = [
  {
    name: "Sciences",
    src: "/assets/img/navbar/subjects/home_matieres_pc.webp",
    subjects: [
      "Math\xE9matiques",
      "Physique-Chimie",
      "Sciences et Technologie",
      "SNT",
      "SVT",
      "Enseignement Scientifique",
      "PSE"
    ]
  },
  {
    name: "Sciences Humaines et Sociales",
    src: "/assets/img/navbar/subjects/home_matieres_philov2.webp",
    subjects: ["Fran\xE7ais", "Histoire-G\xE9ographie-EMC", "Philosophie", "SES"]
  },
  {
    name: "Langues vivantes",
    src: "/assets/img/navbar/subjects/languages.webp",
    subjects: ["Anglais", "Espagnol"]
  }
];
var SUBJECTS_BY_SCHOOL_TYPE = [
  { name: "Primaire" },
  {
    name: "Coll\xE8ge",
    slug: "college",
    subjects: [
      "Fran\xE7ais",
      "Histoire-G\xE9ographie-EMC",
      "Anglais",
      "Espagnol",
      "Math\xE9matiques",
      "Physique-Chimie",
      "SVT",
      "Sciences et Technologie"
    ]
  },
  {
    name: "Lyc\xE9e G\xE9n\xE9ral et Technologique",
    slug: "lycee-general",
    subjects: [
      "Fran\xE7ais",
      "Histoire-G\xE9ographie-EMC",
      "Philosophie",
      "SES",
      "Anglais",
      "Espagnol",
      "Math\xE9matiques",
      "Physique-Chimie",
      "SVT",
      "Enseignement Scientifique",
      "SNT"
    ]
  },
  {
    name: "Lyc\xE9e professionnel",
    slug: "lycee-professionnel",
    subjects: ["Fran\xE7ais", "Histoire-G\xE9ographie-EMC", "Math\xE9matiques", "PSE"]
  }
];
var mapSubjectsToSection = (sections, subjects) => _133.map(
  (section) => ({
    ...section,
    subjects: _133.flow(
      _133.get("subjects"),
      _133.map((name) => _133.find({ name }, subjects)),
      _133.compact
    )(section)
  }),
  sections
);
var mapSchoolTypesToSubjectsWithSection = (schoolTypes, subjects, sections) => _133.map(
  (schoolType) => ({
    ...schoolType,
    sections: mapSubjectsToSection(
      sections,
      _133.flow(
        _133.get("subjects"),
        _133.map((name) => _133.find({ name }, subjects))
      )(schoolType)
    )
  }),
  schoolTypes
);

// src/internals/components/navbar/buttons/mobileAccordionList.tsx
import _134 from "lodash/fp.js";
import { Accordion as Accordion4, Button as Button70, Tag } from "@lls/lls-kit";
import { Meli } from "@lls/lls-kit/primary";

// tmp_esbuild1736180050074/_src_internals_components_navbar_buttons_mobileAccordionList.module.css
var src_internals_components_navbar_buttons_mobileAccordionList_default = { "sectionImg": "sk-xKulWq-sectionImg", "subjectsContainer": "sk-xKulWq-subjectsContainer", "collectionContainer": "sk-xKulWq-collectionContainer", "mobileTag": "sk-xKulWq-mobileTag", "subjectButton": "sk-xKulWq-subjectButton", "sectionName": "sk-xKulWq-sectionName", "collectionTitle": "sk-xKulWq-collectionTitle" };

// src/internals/components/navbar/buttons/mobileAccordionList.tsx
import { jsx as jsx146, jsxs as jsxs116 } from "react/jsx-runtime";
var MobileLink = ({
  name,
  href,
  closeSidePanel = _134.noop,
  navigateCallback = _134.noop,
  setIsOpen
}) => /* @__PURE__ */ jsx146(
  Button70,
  {
    theme: "gray",
    accent: "floating",
    title: name,
    href,
    className: src_internals_components_navbar_buttons_mobileAccordionList_default.subjectButton,
    onGoTo: () => {
      setIsOpen(false);
      closeSidePanel();
      navigateCallback(href);
    },
    children: name
  }
);
var SectionMobilePrimary = ({
  section,
  navigateCallback,
  setIsOpen,
  closeSidePanel
}) => /* @__PURE__ */ jsxs116("div", { className: src_internals_components_navbar_buttons_mobileAccordionList_default.collectionContainer, children: [
  /* @__PURE__ */ jsxs116("span", { className: src_internals_components_navbar_buttons_mobileAccordionList_default.sectionName, children: [
    /* @__PURE__ */ jsx146(Meli, { width: 32, height: 32, name: section.meliName, className: src_internals_components_navbar_buttons_mobileAccordionList_default.sectionImg }),
    section.name
  ] }),
  /* @__PURE__ */ jsx146("div", { className: src_internals_components_navbar_buttons_mobileAccordionList_default.subjectsContainer, children: section.links ? section.links.map((link) => /* @__PURE__ */ jsx146(
    MobileLink,
    {
      name: link.name,
      href: link.href,
      navigateCallback,
      setIsOpen,
      closeSidePanel
    },
    link.href
  )) : section.tag ? /* @__PURE__ */ jsx146(Tag, { className: src_internals_components_navbar_buttons_mobileAccordionList_default.mobileTag, children: section.tag }) : null })
] });
var SectionMobile = ({
  section,
  schoolTypeSlug,
  ...props
}) => {
  return section.subjects.length !== 0 && /* @__PURE__ */ jsxs116("div", { className: src_internals_components_navbar_buttons_mobileAccordionList_default.collectionContainer, children: [
    /* @__PURE__ */ jsx146("span", { className: src_internals_components_navbar_buttons_mobileAccordionList_default.sectionName, children: section.name }),
    /* @__PURE__ */ jsx146("div", { className: src_internals_components_navbar_buttons_mobileAccordionList_default.subjectsContainer, children: section.subjects.map((subject) => /* @__PURE__ */ jsx146(
      MobileLink,
      {
        href: getNavbarLink(schoolTypeSlug, subject.slug),
        name: subject.name,
        ...props
      },
      subject.slug
    )) })
  ] });
};
var SchoolTypeMobile = ({
  schoolType,
  ...props
}) => /* @__PURE__ */ jsx146(Accordion4, { category: schoolType.name, children: schoolType.name === "Primaire" ? PRIMARY_SECTIONS.map((section) => /* @__PURE__ */ jsx146(SectionMobilePrimary, { section, ...props }, section.name)) : schoolType.sections.map((section) => /* @__PURE__ */ jsx146(SectionMobile, { section, schoolTypeSlug: schoolType.slug, ...props }, section.name)) });
var MobileAccordionList = ({
  schoolTypesWithSubjectsBySection,
  ...props
}) => /* @__PURE__ */ jsx146(Accordion4, { category: "Nos manuels", children: _134.map(
  (schoolType) => /* @__PURE__ */ jsx146(SchoolTypeMobile, { schoolType, ...props }, schoolType.name),
  schoolTypesWithSubjectsBySection
) });
var mobileAccordionList_default = MobileAccordionList;

// src/internals/components/navbar/buttons/subjectListPanel.tsx
import { forwardRef, useEffect as useEffect25, useState as useState55 } from "react";
import { Button as Button71, Divider as Divider15, Icon as Icon41, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME10, Portal, Tag as Tag2, Z_MENU_BUTTON } from "@lls/lls-kit";
import { cx as cx37 } from "@lls/utils";
import { Meli as Meli2 } from "@lls/lls-kit/primary";

// tmp_esbuild1736180050074/_src_internals_components_navbar_buttons_subjectListPanel.module.css
var src_internals_components_navbar_buttons_subjectListPanel_default = { "ctaButton": "sk-1jngRa-ctaButton", "schoolTypeSelector": "sk-1jngRa-schoolTypeSelector", "primaryIllustration": "sk-1jngRa-primaryIllustration", "schoolTypesContainer": "sk-1jngRa-schoolTypesContainer", "slide": "sk-1jngRa-slide", "panel": "sk-1jngRa-panel", "sectionContainer": "sk-1jngRa-sectionContainer", "panelClickableItem": "sk-1jngRa-panelClickableItem", "panelWrapper": "sk-1jngRa-panelWrapper", "schoolTypeFadeIn": "sk-1jngRa-schoolTypeFadeIn", "marketingContainer": "sk-1jngRa-marketingContainer", "primaryText": "sk-1jngRa-primaryText", "primaryContainer": "sk-1jngRa-primaryContainer", "markerTitle": "sk-1jngRa-markerTitle", "sectionImg": "sk-1jngRa-sectionImg", "sectionsContainer": "sk-1jngRa-sectionsContainer", "clickableSection": "sk-1jngRa-clickableSection sk-1jngRa-panelClickableItem", "panelContent": "sk-1jngRa-panelContent", "schoolTypeRight": "sk-1jngRa-schoolTypeRight", "navbarLinkItem": "sk-1jngRa-navbarLinkItem", "marketingIllustration": "sk-1jngRa-marketingIllustration", "sectionContainerPrimary": "sk-1jngRa-sectionContainerPrimary", "navbarLink": "sk-1jngRa-navbarLink sk-1jngRa-panelClickableItem", "clippedBackground": "sk-1jngRa-clippedBackground", "schoolTypeName": "sk-1jngRa-schoolTypeName", "leftPanel": "sk-1jngRa-leftPanel", "subjectList": "sk-1jngRa-subjectList", "wobble": "sk-1jngRa-wobble" };

// src/internals/components/navbar/buttons/subjectListPanel.tsx
import { jsx as jsx147, jsxs as jsxs117 } from "react/jsx-runtime";
import { createElement } from "react";
var MarketingLink = ({ navigateCallback }) => /* @__PURE__ */ jsxs117("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.marketingContainer, children: [
  /* @__PURE__ */ jsx147("h3", { children: "Nouvelle collection Primaire !" }),
  /* @__PURE__ */ jsx147("p", { children: "D\xE9couvrez nos manuels de Lecture et Math\xE9matiques pour le CP !" }),
  /* @__PURE__ */ jsx147(
    Button71,
    {
      className: src_internals_components_navbar_buttons_subjectListPanel_default.ctaButton,
      theme: "gray",
      href: "/primaire",
      onGoTo: ({ href }) => navigateCallback(href == null ? void 0 : href.toString()),
      children: "D\xE9couvrir"
    }
  ),
  /* @__PURE__ */ jsx147(
    "img",
    {
      className: src_internals_components_navbar_buttons_subjectListPanel_default.marketingIllustration,
      src: "/assets/img/navbar/lumi.webp",
      alt: "L'\xE9toile Lumi, mascotte primaire LLS"
    }
  )
] });
var LeftPanelSection = ({
  schoolTypes,
  navigateCallback,
  selectedSchoolType,
  setSelectedSchoolType
}) => {
  return /* @__PURE__ */ jsxs117("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.leftPanel, children: [
    /* @__PURE__ */ jsx147("h3", { className: src_internals_components_navbar_buttons_subjectListPanel_default.markerTitle, children: "Niveau" }),
    schoolTypes.map((schoolType) => /* @__PURE__ */ jsxs117(
      "div",
      {
        onMouseEnter: () => setSelectedSchoolType(schoolType.name),
        className: src_internals_components_navbar_buttons_subjectListPanel_default.schoolTypeSelector,
        "data-selected": +(selectedSchoolType === schoolType.name),
        children: [
          /* @__PURE__ */ jsx147("span", { className: src_internals_components_navbar_buttons_subjectListPanel_default.schoolTypeName, children: schoolType.name }),
          /* @__PURE__ */ jsxs117("span", { className: src_internals_components_navbar_buttons_subjectListPanel_default.schoolTypeRight, children: [
            schoolType.name === "Primaire" && /* @__PURE__ */ jsx147(Tag2, { className: src_internals_components_navbar_buttons_subjectListPanel_default.tag, theme: "yellow", children: "Nouveau" }),
            /* @__PURE__ */ jsx147(Icon41, { name: "carretright", width: 8, height: 8 })
          ] })
        ]
      },
      schoolType.name
    )),
    /* @__PURE__ */ jsx147(MarketingLink, { navigateCallback })
  ] });
};
var SectionComponent = ({ name, src, subjects, navigateCallback, isShown, schoolTypeSlug }) => /* @__PURE__ */ jsxs117("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.sectionContainer, "data-shown": +isShown, children: [
  /* @__PURE__ */ jsxs117("h4", { className: src_internals_components_navbar_buttons_subjectListPanel_default.markerTitle, children: [
    /* @__PURE__ */ jsx147("img", { className: src_internals_components_navbar_buttons_subjectListPanel_default.sectionImg, src, alt: `Illustration de la mati\xE8re ${name}` }),
    name
  ] }),
  /* @__PURE__ */ jsx147("ul", { className: src_internals_components_navbar_buttons_subjectListPanel_default.subjectList, children: subjects.map((subject) => /* @__PURE__ */ jsx147(
    NavbarLink,
    {
      name: subject.name,
      href: getNavbarLink(schoolTypeSlug, subject.slug),
      navigateCallback
    },
    subject.slug
  )) })
] });
var NavbarLink = ({ name, href, navigateCallback }) => {
  const onClick = (e) => {
    e.preventDefault();
    navigateCallback(href);
  };
  return /* @__PURE__ */ jsx147("li", { className: src_internals_components_navbar_buttons_subjectListPanel_default.navbarLinkItem, children: /* @__PURE__ */ jsx147("a", { className: src_internals_components_navbar_buttons_subjectListPanel_default.navbarLink, href, onClick, children: name }) });
};
var PrimarySection = ({ meliName, name, links, navigateCallback, tag }) => {
  return /* @__PURE__ */ jsxs117("div", { className: cx37(src_internals_components_navbar_buttons_subjectListPanel_default.sectionContainer, src_internals_components_navbar_buttons_subjectListPanel_default.sectionContainerPrimary), children: [
    /* @__PURE__ */ jsxs117("h4", { className: src_internals_components_navbar_buttons_subjectListPanel_default.markerTitle, children: [
      /* @__PURE__ */ jsx147(Meli2, { width: 40, height: 40, className: src_internals_components_navbar_buttons_subjectListPanel_default.sectionImg, name: meliName }),
      name
    ] }),
    links ? /* @__PURE__ */ jsx147("ul", { className: src_internals_components_navbar_buttons_subjectListPanel_default.subjectList, children: links.map((link) => /* @__PURE__ */ createElement(NavbarLink, { ...link, navigateCallback, key: link.href })) }) : tag ? /* @__PURE__ */ jsx147(Tag2, { theme: "gray", children: tag }) : null
  ] });
};
var PrimaryBlock = ({ navigateCallback, isShown }) => /* @__PURE__ */ jsxs117("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.primaryContainer, "data-shown": +isShown, children: [
  /* @__PURE__ */ jsx147("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.sectionsContainer, "data-shown": +isShown, children: PRIMARY_SECTIONS.map((section) => /* @__PURE__ */ createElement(PrimarySection, { ...section, key: section.name, navigateCallback })) }),
  /* @__PURE__ */ jsx147(
    "img",
    {
      className: src_internals_components_navbar_buttons_subjectListPanel_default.primaryIllustration,
      "data-shown": +isShown,
      src: "/assets/img/navbar/personnages-illustrations-commerciales.webp",
      alt: "4 personnages illustrant la collection primaire lelivrescolaire.fr"
    }
  )
] });
var SchoolTypeComponent = ({ schoolType, navigateCallback, isShown }) => {
  if ((schoolType == null ? void 0 : schoolType.name) === "Primaire") return /* @__PURE__ */ jsx147(PrimaryBlock, { navigateCallback, isShown });
  const { sections } = schoolType;
  return /* @__PURE__ */ jsx147("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.sectionsContainer, "data-shown": +isShown, children: sections.filter((section) => Boolean(section.subjects[0])).map((section) => /* @__PURE__ */ createElement(
    SectionComponent,
    {
      ...section,
      schoolTypeSlug: schoolType.slug,
      navigateCallback,
      key: section.name,
      isShown
    }
  )) });
};
var RightPanelSection = ({ schoolTypes, navigateCallback, selectedSchoolType }) => /* @__PURE__ */ jsx147("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.schoolTypesContainer, children: schoolTypes.map((schoolType) => /* @__PURE__ */ jsx147(
  SchoolTypeComponent,
  {
    schoolType,
    navigateCallback,
    isShown: selectedSchoolType === schoolType.name
  },
  schoolType.name
)) });
var SubjectListPanel = forwardRef(
  ({
    schoolTypesWithSubjectsBySection,
    navigateCallback: iNavigateCallback,
    setIsOpen,
    isOpen,
    floatingStyles = {},
    defaultSchoolTypeName
  }, ref) => {
    const [selectedSchoolType, setSelectedSchoolType] = useState55(
      defaultSchoolTypeName
    );
    const navigateCallback = (href) => {
      setIsOpen(false);
      iNavigateCallback(href);
    };
    useEffect25(() => {
      !isOpen && setSelectedSchoolType(defaultSchoolTypeName);
    }, [isOpen, defaultSchoolTypeName]);
    return isOpen && /* @__PURE__ */ jsx147(Portal, { shouldDisableScroll: false, children: /* @__PURE__ */ jsx147(
      "div",
      {
        className: cx37(KIT_CLASSNAME_LIGHT_THEME10, src_internals_components_navbar_buttons_subjectListPanel_default.panelWrapper),
        ref,
        style: { ...floatingStyles, "--s-z-panel": Z_MENU_BUTTON },
        children: /* @__PURE__ */ jsxs117("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.panel, children: [
          /* @__PURE__ */ jsx147("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.clippedBackground }),
          /* @__PURE__ */ jsxs117("div", { className: src_internals_components_navbar_buttons_subjectListPanel_default.panelContent, children: [
            /* @__PURE__ */ jsx147(
              LeftPanelSection,
              {
                schoolTypes: schoolTypesWithSubjectsBySection,
                ...{
                  navigateCallback,
                  selectedSchoolType,
                  setSelectedSchoolType
                }
              }
            ),
            /* @__PURE__ */ jsx147(Divider15, { vertical: true }),
            /* @__PURE__ */ jsx147(
              RightPanelSection,
              {
                schoolTypes: schoolTypesWithSubjectsBySection,
                navigateCallback,
                selectedSchoolType
              }
            )
          ] })
        ] })
      }
    ) });
  }
);
var subjectListPanel_default = SubjectListPanel;

// src/internals/components/navbar/buttons/booksButton.tsx
import { Fragment as Fragment46, jsx as jsx148, jsxs as jsxs118 } from "react/jsx-runtime";
var getDefaultSchoolTypeFromUser = (user) => {
  var _a;
  const userDefaultSchoolType = ((_a = user == null ? void 0 : user.schoolTypes) == null ? void 0 : _a.length) !== 1 ? void 0 : user.schoolTypes[0];
  switch (userDefaultSchoolType) {
    case "Coll\xE8ge":
      return SUBJECTS_BY_SCHOOL_TYPE[1];
    case "Lyc\xE9e G\xE9n\xE9ral":
    case "Lyc\xE9e Technologique":
      return SUBJECTS_BY_SCHOOL_TYPE[2];
    case "Lyc\xE9e Professionnel":
      return SUBJECTS_BY_SCHOOL_TYPE[3];
    default:
      return SUBJECTS_BY_SCHOOL_TYPE[0];
  }
};
var BooksButton = ({
  mobile = false,
  closeSidePanel = _135.noop,
  navigateCallback = _135.noop,
  currentUser
}) => {
  var _a;
  const [isOpen, setIsOpen] = useState56(false);
  const buttonRef = useRef14(null);
  const schoolTypesWithSubjectsBySection = mapSchoolTypesToSubjectsWithSection(
    SUBJECTS_BY_SCHOOL_TYPE,
    SUBJECTS_SLUG,
    SUBJECT_BY_FIELD
  );
  const { refs, floatingStyles } = useFloating({
    elements: { reference: buttonRef.current },
    whileElementsMounted: autoUpdate,
    placement: "bottom-start",
    strategy: "fixed",
    middleware: [shift()]
  });
  useEffect26(() => {
    if (isOpen) {
      const outsideClickListener = (event) => {
        if (!isInsideNode(event, refs.floating) && !isInsideNode(event, refs.domReference)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", outsideClickListener);
      return () => {
        document.removeEventListener("mousedown", outsideClickListener);
      };
    }
  }, [isOpen, refs]);
  const defaultSchoolTypeName = (_a = getDefaultSchoolTypeFromUser(currentUser)) == null ? void 0 : _a.name;
  return mobile ? /* @__PURE__ */ jsx148(
    mobileAccordionList_default,
    {
      ...{
        schoolTypesWithSubjectsBySection,
        closeSidePanel,
        setIsOpen,
        navigateCallback
      }
    }
  ) : /* @__PURE__ */ jsxs118(Fragment46, { children: [
    /* @__PURE__ */ jsx148(
      Button72,
      {
        ref: buttonRef,
        onClick: () => setIsOpen((prev) => !prev),
        theme: "gray",
        accent: "floating",
        icon: "chevrondown",
        size: "xsmall",
        iconPosition: "right",
        children: "Nos manuels"
      }
    ),
    /* @__PURE__ */ jsx148(
      subjectListPanel_default,
      {
        ref: refs.setFloating,
        floatingStyles,
        ...{
          isOpen,
          mobile,
          setIsOpen,
          navigateCallback,
          schoolTypesWithSubjectsBySection,
          defaultSchoolTypeName
        }
      }
    )
  ] });
};
var booksButton_default = BooksButton;

// src/internals/components/navbar/buttons/classicsButton.tsx
import _136 from "lodash/fp.js";
import { Button as Button73 } from "@lls/lls-kit";
import { openWindow as openWindow5 } from "@lls/utils";
import { jsx as jsx149 } from "react/jsx-runtime";
var ClassicsButton = ({ closeSidePanel = _136.noop, links }) => {
  const classicsLink = _136.get("classicsLink", links);
  return /* @__PURE__ */ jsx149(
    Button73,
    {
      theme: "gray",
      accent: "floating",
      target: "_self",
      href: classicsLink,
      style: {
        "--k-button-display": "flex"
      },
      onGoTo: ({ href, target }) => {
        closeSidePanel();
        openWindow5(href, target);
      },
      children: "Nos Classiques"
    }
  );
};
var classicsButton_default = ClassicsButton;

// src/internals/components/navbar/buttons/commandButton.tsx
import _137 from "lodash/fp.js";
import { useCallback as useCallback58, useMemo as useMemo29 } from "react";
import { Accordion as Accordion5, Button as Button74, MenuButton as MenuButton10 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_navbar_buttons_commandButton.module.css
var src_internals_components_navbar_buttons_commandButton_default = { "styleCommandButton": "sk-B1sz-G-styleCommandButton", "description": "sk-B1sz-G-description", "title": "sk-B1sz-G-title" };

// src/internals/components/navbar/buttons/commandButton.tsx
import { jsx as jsx150, jsxs as jsxs119 } from "react/jsx-runtime";
var CommandBooksButton = ({ href, handleClick }) => /* @__PURE__ */ jsxs119("a", { className: src_internals_components_navbar_buttons_commandButton_default.styleCommandButton, href, onClick: handleClick, children: [
  /* @__PURE__ */ jsx150("div", { className: src_internals_components_navbar_buttons_commandButton_default.title, children: "Commander des manuels" }),
  /* @__PURE__ */ jsx150("p", { className: src_internals_components_navbar_buttons_commandButton_default.description, children: "\xC9tablissements, libraires, particuliers : commandez vos manuels papier et num\xE9riques." })
] });
var DigitalBookButton = ({ href, handleClick }) => /* @__PURE__ */ jsxs119("a", { className: src_internals_components_navbar_buttons_commandButton_default.styleCommandButton, href, onClick: handleClick, children: [
  /* @__PURE__ */ jsx150("div", { className: src_internals_components_navbar_buttons_commandButton_default.title, children: "Manuels Num\xE9riques Premium" }),
  /* @__PURE__ */ jsx150("p", { className: src_internals_components_navbar_buttons_commandButton_default.description, children: "Une nouvelle exp\xE9rience du manuel num\xE9rique avec des fonctionnalit\xE9s innovantes et un accompagnement sur mesure." })
] });
var CommandButton = ({
  mobile = false,
  closeSidePanel = _137.noop,
  navigateCallback = _137.noop,
  links
}) => {
  const commandLinks = useMemo29(() => (links == null ? void 0 : links.commandLinks) || {}, [links]);
  const onCommandButtonClick = useCallback58(() => {
    closeSidePanel();
    navigateCallback(commandLinks.command);
  }, [closeSidePanel, navigateCallback, commandLinks]);
  const onDigitalBookButtonClick = useCallback58(() => {
    closeSidePanel();
    navigateCallback(commandLinks.digitalBook);
  }, [closeSidePanel, navigateCallback, commandLinks]);
  const commandButtonList = useMemo29(
    () => [
      {
        type: "component",
        content: /* @__PURE__ */ jsx150(CommandBooksButton, { href: commandLinks.command }),
        onClick: onCommandButtonClick
      },
      {
        type: "divider"
      },
      {
        type: "component",
        content: /* @__PURE__ */ jsx150(DigitalBookButton, { href: commandLinks.digitalBook }),
        onClick: onDigitalBookButtonClick
      }
    ],
    [onCommandButtonClick, onDigitalBookButtonClick, commandLinks]
  );
  return mobile ? /* @__PURE__ */ jsxs119(Accordion5, { category: "Nos offres", children: [
    /* @__PURE__ */ jsx150(Button74, { href: commandLinks.command, theme: "gray", accent: "floating", onClick: onCommandButtonClick, children: "Commander des manuels" }),
    /* @__PURE__ */ jsx150(Button74, { href: commandLinks.digitalBook, theme: "gray", accent: "floating", onClick: onDigitalBookButtonClick, children: "Manuels Num\xE9riques Premium" })
  ] }) : /* @__PURE__ */ jsx150(
    MenuButton10,
    {
      fixed: true,
      alignment: "end",
      theme: "gray",
      accent: "floating",
      icon: "chevrondown",
      size: "xsmall",
      iconPosition: "right",
      position: "bottom",
      listItems: commandButtonList,
      children: "Nos offres"
    }
  );
};
var commandButton_default = CommandButton;

// src/internals/components/navbar/buttons/loginButton.tsx
import _138 from "lodash/fp.js";
import { Button as Button75 } from "@lls/lls-kit";
import { jsx as jsx151 } from "react/jsx-runtime";
var LoginButton = ({ onLoginClick = _138.noop }) => /* @__PURE__ */ jsx151(Button75, { theme: "gray", accent: "floating", onClick: onLoginClick, children: "Se connecter" });
var loginButton_default = LoginButton;

// src/internals/components/navbar/buttons/registrationButton.tsx
import _139 from "lodash/fp.js";
import { useCallback as useCallback59 } from "react";
import { Button as Button76 } from "@lls/lls-kit";
import { jsx as jsx152 } from "react/jsx-runtime";
var RegistrationButton = ({
  mobile = false,
  closeSidePanel = _139.noop,
  onRegistrationClick = _139.noop
}) => {
  const onRegistrationClickCb = useCallback59(() => {
    onRegistrationClick();
    closeSidePanel();
  }, [closeSidePanel, onRegistrationClick]);
  return /* @__PURE__ */ jsx152(Button76, { accent: mobile ? "floating" : "main", onClick: onRegistrationClickCb, children: "S'inscrire" });
};
var registrationButton_default = RegistrationButton;

// src/internals/components/navbar/buttons/sidePanelButton.tsx
import { Button as Button77, SidePanel as SidePanel2 } from "@lls/lls-kit";
import React6, { useCallback as useCallback60, useState as useState57 } from "react";

// tmp_esbuild1736180050074/_src_internals_components_navbar_buttons_sidePanelButton.module.css
var src_internals_components_navbar_buttons_sidePanelButton_default = { "logo": "sk-dOSNDG-logo", "sidePanelContent": "sk-dOSNDG-sidePanelContent" };

// src/internals/components/navbar/buttons/sidePanelButton.tsx
import { Fragment as Fragment47, jsx as jsx153, jsxs as jsxs120 } from "react/jsx-runtime";
var SidePanelButton = ({ children }) => {
  const [open, setOpen] = useState57(false);
  const onOpen = useCallback60(() => setOpen(true), []);
  const onClose = useCallback60(() => setOpen(false), []);
  return /* @__PURE__ */ jsxs120(Fragment47, { children: [
    /* @__PURE__ */ jsx153(
      SidePanel2,
      {
        open,
        onClose,
        titleContent: /* @__PURE__ */ jsx153("img", { className: src_internals_components_navbar_buttons_sidePanelButton_default.logo, src: "/assets/img/navbar/logo.svg" }),
        position: "right",
        children: /* @__PURE__ */ jsx153("div", { className: src_internals_components_navbar_buttons_sidePanelButton_default.sidePanelContent, children: React6.Children.map(
          children,
          (child) => (
            // TODO: type with sidepanel children type
            React6.isValidElement(child) ? React6.cloneElement(child, { closeSidePanel: onClose }) : null
          )
        ) })
      }
    ),
    /* @__PURE__ */ jsx153(Button77, { icon: "threelines", theme: "gray", accent: "floating", onClick: onOpen })
  ] });
};
var sidePanelButton_default = SidePanelButton;

// src/internals/components/navbar/anonymousNavbarContent.tsx
import { Fragment as Fragment48, jsx as jsx154, jsxs as jsxs121 } from "react/jsx-runtime";
var AnonymousNavbarContent = (props) => (props == null ? void 0 : props.mobile) ? /* @__PURE__ */ jsxs121(sidePanelButton_default, { children: [
  /* @__PURE__ */ jsx154(booksButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx154(classicsButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx154(commandButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx154(aboutUsButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx154(loginButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx154(registrationButton_default, { mobile: true, ...props })
] }) : /* @__PURE__ */ jsxs121(Fragment48, { children: [
  /* @__PURE__ */ jsx154(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx154(classicsButton_default, { ...props }),
  /* @__PURE__ */ jsx154(commandButton_default, { ...props }),
  /* @__PURE__ */ jsx154(aboutUsButton_default, { ...props }),
  /* @__PURE__ */ jsx154(loginButton_default, { ...props }),
  /* @__PURE__ */ jsx154(registrationButton_default, { ...props })
] });
var anonymousNavbarContent_default = AnonymousNavbarContent;

// src/internals/components/navbar/anonymousPageViewNavbarContent.tsx
import { Fragment as Fragment49, jsx as jsx155, jsxs as jsxs122 } from "react/jsx-runtime";
var AnonymousPageViewNavbarContent = (props) => (props == null ? void 0 : props.mobile) ? /* @__PURE__ */ jsx155(Fragment49, { children: /* @__PURE__ */ jsxs122(sidePanelButton_default, { children: [
  /* @__PURE__ */ jsx155(booksButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx155(loginButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx155(registrationButton_default, { mobile: true, ...props })
] }) }) : /* @__PURE__ */ jsxs122(Fragment49, { children: [
  /* @__PURE__ */ jsx155(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx155(loginButton_default, { ...props }),
  /* @__PURE__ */ jsx155(registrationButton_default, { ...props })
] });
var anonymousPageViewNavbarContent_default = AnonymousPageViewNavbarContent;

// src/internals/components/navbar/buttons/myAccountButton.tsx
import _140 from "lodash/fp.js";
import { useCallback as useCallback61, useMemo as useMemo30 } from "react";
import { Accordion as Accordion6, Button as Button78, MenuButton as MenuButton11 } from "@lls/lls-kit";
import { displayUser, displayUserProfile } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_navbar_buttons_myAccountButton.module.css
var src_internals_components_navbar_buttons_myAccountButton_default = { "userName": "sk-U3KASG-userName", "userProfile": "sk-U3KASG-userProfile" };

// src/internals/components/navbar/buttons/myAccountButton.tsx
import { jsx as jsx156, jsxs as jsxs123 } from "react/jsx-runtime";
var MyAccountButton = ({
  mobile = false,
  closeSidePanel = _140.noop,
  currentUser,
  onTeacherBookClick = _140.noop,
  onHelpClick = _140.noop,
  onLogout = _140.noop,
  links,
  navigateCallback = _140.noop
}) => {
  const accountLinks = links == null ? void 0 : links.accountLinks;
  const isPremium = currentUser == null ? void 0 : currentUser.isPremium;
  const isTrial = currentUser == null ? void 0 : currentUser.isTrial;
  const onTeacherBookClickCb = useCallback61(() => {
    closeSidePanel();
    onTeacherBookClick();
  }, [closeSidePanel, onTeacherBookClick]);
  const onParametersClick = useCallback61(() => {
    closeSidePanel();
    navigateCallback(accountLinks == null ? void 0 : accountLinks.parameters);
  }, [closeSidePanel, accountLinks, navigateCallback]);
  const onHelpClickCb = useCallback61(() => {
    onHelpClick();
    closeSidePanel();
  }, [closeSidePanel, onHelpClick]);
  const onLogoutClick = useCallback61(() => {
    closeSidePanel();
    onLogout();
  }, [onLogout, closeSidePanel]);
  const userListItems = useMemo30(
    () => _140.compact([
      {
        type: "component",
        content: /* @__PURE__ */ jsxs123("div", { className: src_internals_components_navbar_buttons_myAccountButton_default.userProfile, children: [
          /* @__PURE__ */ jsx156("div", { className: src_internals_components_navbar_buttons_myAccountButton_default.userName, "data-clarity-mask": "true", children: displayUser(currentUser) }),
          /* @__PURE__ */ jsx156("div", { className: "navbar-user-profile", "data-premium": +(isPremium === true), children: displayUserProfile(currentUser) })
        ] })
      },
      ...(currentUser == null ? void 0 : currentUser.isStudent) ? [] : [
        {
          type: "divider"
        },
        {
          msg: "Livre du professeur",
          icon: "teacherbook",
          size: "small",
          iconProps: { color: "var(--white-color)" },
          onClick: onTeacherBookClickCb
        }
      ],
      {
        type: "divider"
      },
      isTrial ? void 0 : {
        msg: "Mon compte",
        icon: "personfilled",
        size: "small",
        onClick: onParametersClick
      },
      {
        msg: "Aide & Support",
        icon: "questionmarkcirclefilled",
        size: "small",
        onClick: onHelpClickCb
      },
      {
        type: "divider"
      },
      {
        msg: "Se d\xE9connecter",
        icon: "logout",
        size: "small",
        onClick: onLogoutClick
      }
    ]),
    [currentUser, isPremium, onTeacherBookClickCb, isTrial, onParametersClick, onHelpClickCb, onLogoutClick]
  );
  return mobile ? /* @__PURE__ */ jsxs123(Accordion6, { category: "Mon compte", children: [
    /* @__PURE__ */ jsxs123("div", { className: src_internals_components_navbar_buttons_myAccountButton_default.userProfile, children: [
      /* @__PURE__ */ jsx156("div", { className: src_internals_components_navbar_buttons_myAccountButton_default.userName, "data-clarity-mask": "true", children: displayUser(currentUser) }),
      /* @__PURE__ */ jsx156("div", { className: "navbar-user-profile", "data-premium": +(isPremium === true), children: displayUserProfile(currentUser) })
    ] }),
    (currentUser == null ? void 0 : currentUser.isTeacher) && /* @__PURE__ */ jsx156(Button78, { theme: "gray", accent: "floating", onClick: onTeacherBookClickCb, children: "Livre du professeur" }),
    !isTrial && /* @__PURE__ */ jsx156(Button78, { theme: "gray", accent: "floating", onClick: onParametersClick, children: "Mon compte" }),
    /* @__PURE__ */ jsx156(Button78, { theme: "gray", accent: "floating", onClick: onHelpClickCb, children: "Aide & Support" }),
    /* @__PURE__ */ jsx156(Button78, { theme: "gray", accent: "floating", onClick: onLogoutClick, children: "Se d\xE9connecter" })
  ] }) : /* @__PURE__ */ jsx156(MenuButton11, { fixed: true, icon: "person", theme: "gray", accent: "main", listItems: userListItems });
};
var myAccountButton_default = MyAccountButton;

// src/internals/components/navbar/freeStudentNavbarContent.tsx
import { Fragment as Fragment50, jsx as jsx157, jsxs as jsxs124 } from "react/jsx-runtime";
var FreeStudentNavbarContent = (props) => (props == null ? void 0 : props.mobile) ? /* @__PURE__ */ jsxs124(sidePanelButton_default, { children: [
  /* @__PURE__ */ jsx157(booksButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx157(myAccountButton_default, { mobile: true, ...props })
] }) : /* @__PURE__ */ jsxs124(Fragment50, { children: [
  /* @__PURE__ */ jsx157(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx157(myAccountButton_default, { ...props })
] });
var freeStudentNavbarContent_default = FreeStudentNavbarContent;

// src/internals/components/navbar/freeTeacherNavbarContent.tsx
import { Fragment as Fragment51, jsx as jsx158, jsxs as jsxs125 } from "react/jsx-runtime";
var FreeTeacherNavbarContent = (props) => (props == null ? void 0 : props.mobile) ? /* @__PURE__ */ jsxs125(sidePanelButton_default, { children: [
  /* @__PURE__ */ jsx158(booksButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx158(classicsButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx158(commandButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx158(aboutUsButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx158(myAccountButton_default, { mobile: true, ...props })
] }) : /* @__PURE__ */ jsxs125(Fragment51, { children: [
  /* @__PURE__ */ jsx158(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx158(classicsButton_default, { ...props }),
  /* @__PURE__ */ jsx158(commandButton_default, { ...props }),
  /* @__PURE__ */ jsx158(aboutUsButton_default, { ...props }),
  /* @__PURE__ */ jsx158(myAccountButton_default, { ...props })
] });
var freeTeacherNavbarContent_default = FreeTeacherNavbarContent;

// src/internals/components/navbar/freeUserPageViewNavbarContent.tsx
import { Fragment as Fragment52, jsx as jsx159, jsxs as jsxs126 } from "react/jsx-runtime";
var FreeUserPageViewNavbarContent = (props) => (props == null ? void 0 : props.mobile) ? /* @__PURE__ */ jsx159(Fragment52, { children: /* @__PURE__ */ jsxs126(sidePanelButton_default, { children: [
  /* @__PURE__ */ jsx159(booksButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx159(myAccountButton_default, { mobile: true, ...props })
] }) }) : /* @__PURE__ */ jsxs126(Fragment52, { children: [
  /* @__PURE__ */ jsx159(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx159(myAccountButton_default, { ...props })
] });
var freeUserPageViewNavbarContent_default = FreeUserPageViewNavbarContent;

// tmp_esbuild1736180050074/_src_internals_components_navbar_index.module.css
var src_internals_components_navbar_index_default = { "navbar": "sk-xjXmlq-navbar", "desktopNavbar": "sk-xjXmlq-desktopNavbar", "snowBallContainer": "sk-xjXmlq-snowBallContainer", "snowBall": "sk-xjXmlq-snowBall", "mobileNavbar": "sk-xjXmlq-mobileNavbar", "fillSpace": "sk-xjXmlq-fillSpace", "snowBallWiggle": "sk-xjXmlq-snowBallWiggle" };

// src/internals/components/navbar/buttons/discoverPremiumButton.tsx
import _141 from "lodash/fp.js";
import { Button as Button79 } from "@lls/lls-kit";
import { jsx as jsx160 } from "react/jsx-runtime";
var DiscoverPremiumButton = ({
  onPremiumButtonClick = _141.noop,
  isPremiumMode,
  nbRemainingTrials = 0
}) => {
  const discoverPremiumModeText = _141.isInteger(nbRemainingTrials) ? `${nbRemainingTrials} ${handlePlural("essai", nbRemainingTrials)} ${handlePlural("restant", nbRemainingTrials)}` : "D\xE9couvrir Premium";
  return /* @__PURE__ */ jsx160(
    Button79,
    {
      theme: "premium",
      icon: isPremiumMode ? "cancel" : "premium",
      onClick: onPremiumButtonClick,
      inverted: isPremiumMode,
      children: isPremiumMode ? "Quitter Premium" : discoverPremiumModeText
    }
  );
};
var discoverPremiumButton_default = DiscoverPremiumButton;

// src/internals/components/navbar/premiumModeNavbarContent.tsx
import { jsx as jsx161 } from "react/jsx-runtime";
var PremiumModeNavbarContent = (props) => /* @__PURE__ */ jsx161(discoverPremiumButton_default, { ...props });
var premiumModeNavbarContent_default = PremiumModeNavbarContent;

// src/internals/components/navbar/buttons/myPremiumSpaceButton.tsx
import { Button as Button80 } from "@lls/lls-kit";
import _142 from "lodash/fp.js";
import { useCallback as useCallback62 } from "react";
import { jsx as jsx162 } from "react/jsx-runtime";
var MyPremiumSpaceButton = ({
  mobile = false,
  closeSidePanel = _142.noop,
  onPremiumSpaceClick = _142.noop
}) => {
  const onPremiumSpaceClickCb = useCallback62(() => {
    closeSidePanel();
    onPremiumSpaceClick();
  }, [closeSidePanel, onPremiumSpaceClick]);
  return /* @__PURE__ */ jsx162(Button80, { theme: "premium", accent: mobile ? "floating" : "main", icon: "premium", onClick: onPremiumSpaceClickCb, children: "Mon espace" });
};
var myPremiumSpaceButton_default = MyPremiumSpaceButton;

// src/internals/components/navbar/premiumStudentNavbarContent.tsx
import { Fragment as Fragment53, jsx as jsx163, jsxs as jsxs127 } from "react/jsx-runtime";
var PremiumStudentNavbarContent = (props) => (props == null ? void 0 : props.mobile) ? /* @__PURE__ */ jsxs127(sidePanelButton_default, { children: [
  /* @__PURE__ */ jsx163(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx163(myPremiumSpaceButton_default, { ...props }),
  /* @__PURE__ */ jsx163(myAccountButton_default, { ...props })
] }) : /* @__PURE__ */ jsxs127(Fragment53, { children: [
  /* @__PURE__ */ jsx163(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx163(myPremiumSpaceButton_default, { ...props }),
  /* @__PURE__ */ jsx163(myAccountButton_default, { ...props })
] });
var premiumStudentNavbarContent_default = PremiumStudentNavbarContent;

// src/internals/components/navbar/premiumTeacherNavbarContent.tsx
import { Fragment as Fragment54, jsx as jsx164, jsxs as jsxs128 } from "react/jsx-runtime";
var PremiumTeacherNavbarContent = (props) => (props == null ? void 0 : props.mobile) ? /* @__PURE__ */ jsxs128(sidePanelButton_default, { children: [
  /* @__PURE__ */ jsx164(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx164(classicsButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx164(commandButton_default, { ...props }),
  /* @__PURE__ */ jsx164(aboutUsButton_default, { mobile: true, ...props }),
  /* @__PURE__ */ jsx164(myPremiumSpaceButton_default, { ...props }),
  /* @__PURE__ */ jsx164(myAccountButton_default, { ...props })
] }) : /* @__PURE__ */ jsxs128(Fragment54, { children: [
  /* @__PURE__ */ jsx164(booksButton_default, { ...props }),
  /* @__PURE__ */ jsx164(classicsButton_default, { ...props }),
  /* @__PURE__ */ jsx164(commandButton_default, { ...props }),
  /* @__PURE__ */ jsx164(aboutUsButton_default, { ...props }),
  /* @__PURE__ */ jsx164(myPremiumSpaceButton_default, { ...props }),
  /* @__PURE__ */ jsx164(myAccountButton_default, { ...props })
] });
var premiumTeacherNavbarContent_default = PremiumTeacherNavbarContent;

// src/internals/components/navbar/index.tsx
import { Fragment as Fragment55, jsx as jsx165, jsxs as jsxs129 } from "react/jsx-runtime";
var NAVBAR_HEIGHT = 64;
var SnowBall = () => {
  const { startConfetti } = useConfetti("snow");
  const { onPlay, isPlaying } = useAudio({ src: "/assets/sound/snow-fade.mp3" });
  const snowBallClick = () => {
    if (isPlaying) return;
    onPlay();
    startConfetti();
    dispatchAnalyticsEvent20(ANALYTICS_LINK_CLICKED, {
      featureName: "christmas_snow"
    });
  };
  return /* @__PURE__ */ jsx165("div", { className: src_internals_components_navbar_index_default.snowBallContainer, children: /* @__PURE__ */ jsx165(
    "img",
    {
      src: "/assets/img/navbar/christmas/boule_a_neige.svg",
      alt: "une boule \xE0 neige interactive",
      className: src_internals_components_navbar_index_default.snowBall,
      onClick: snowBallClick
    }
  ) });
};
var NavbarContent = (props) => {
  const currentUser = props.currentUser;
  const isAnonymous = _143.isEmpty(currentUser);
  const isPremium = currentUser == null ? void 0 : currentUser.isPremium;
  const isStudent2 = currentUser == null ? void 0 : currentUser.isStudent;
  const isTeacher2 = currentUser == null ? void 0 : currentUser.isTeacher;
  const isOnPagePath = props == null ? void 0 : props.isOnPagePath;
  switch (true) {
    case (props == null ? void 0 : props.isPremiumMode):
      return /* @__PURE__ */ jsx165(premiumModeNavbarContent_default, { ...props });
    case (isPremium && isTeacher2):
      return /* @__PURE__ */ jsx165(premiumTeacherNavbarContent_default, { ...props });
    case (isPremium && isStudent2):
      return /* @__PURE__ */ jsx165(premiumStudentNavbarContent_default, { ...props });
    case (!isPremium && isTeacher2 && isOnPagePath):
    case (!isPremium && isStudent2 && isOnPagePath):
      return /* @__PURE__ */ jsx165(freeUserPageViewNavbarContent_default, { ...props });
    case (!isPremium && isTeacher2 && !isOnPagePath):
      return /* @__PURE__ */ jsx165(freeTeacherNavbarContent_default, { ...props });
    case (!isPremium && isStudent2 && !isOnPagePath):
      return /* @__PURE__ */ jsx165(freeStudentNavbarContent_default, { ...props });
    case (isOnPagePath && isAnonymous):
      return /* @__PURE__ */ jsx165(anonymousPageViewNavbarContent_default, { ...props });
    default:
      return /* @__PURE__ */ jsx165(anonymousNavbarContent_default, { ...props });
  }
};
var NavbarComponent = ({
  isPremiumMode = false,
  isDarkMode = false,
  isChristmas = false,
  currentUser = {},
  navigateCallback = _143.noop,
  links = {},
  ...props
}) => {
  const navbarProps = {
    logoHref: links == null ? void 0 : links.logo,
    onLogoClick: isPremiumMode ? _143.noop : (_e, { href } = {}) => navigateCallback(href)
  };
  const navbarContentProps = {
    isPremiumMode,
    currentUser,
    navigateCallback,
    links,
    ...props
  };
  return /* @__PURE__ */ jsxs129(Fragment55, { children: [
    /* @__PURE__ */ jsxs129(
      Navbar,
      {
        className: cx38(
          isPremiumMode || isDarkMode ? KIT_CLASSNAME_DARK_THEME7 : KIT_CLASSNAME_LIGHT_THEME11,
          src_internals_components_navbar_index_default.navbar,
          src_internals_components_navbar_index_default.desktopNavbar
        ),
        "data-isdarkmode": +isDarkMode,
        "data-ispremiummode": +isPremiumMode,
        "data-isanonymous": +_143.isEmpty(currentUser),
        "data-ischristmas": +isChristmas,
        style: { "--s-navbar-height": `${NAVBAR_HEIGHT}px` },
        ...navbarProps,
        children: [
          isChristmas && /* @__PURE__ */ jsxs129(Fragment55, { children: [
            /* @__PURE__ */ jsx165(SnowBall, {}),
            /* @__PURE__ */ jsx165("div", { className: src_internals_components_navbar_index_default.fillSpace })
          ] }),
          /* @__PURE__ */ jsx165(NavbarContent, { ...navbarContentProps })
        ]
      }
    ),
    /* @__PURE__ */ jsxs129(
      Navbar,
      {
        className: cx38(
          isPremiumMode || isDarkMode ? KIT_CLASSNAME_DARK_THEME7 : KIT_CLASSNAME_LIGHT_THEME11,
          src_internals_components_navbar_index_default.navbar,
          src_internals_components_navbar_index_default.mobileNavbar
        ),
        "data-isdarkmode": +isDarkMode,
        "data-ispremiummode": +isPremiumMode,
        "data-isanonymous": +_143.isEmpty(currentUser),
        "data-ischristmas": +isChristmas,
        style: { "--s-navbar-height": `${NAVBAR_HEIGHT}px` },
        ...navbarProps,
        children: [
          isChristmas && /* @__PURE__ */ jsxs129(Fragment55, { children: [
            /* @__PURE__ */ jsx165(SnowBall, {}),
            /* @__PURE__ */ jsx165("div", { className: src_internals_components_navbar_index_default.fillSpace })
          ] }),
          /* @__PURE__ */ jsx165(NavbarContent, { ...navbarContentProps, mobile: true })
        ]
      }
    )
  ] });
};
var navbar_default = NavbarComponent;

// src/internals/components/cookies/index.jsx
import { Icon as Icon42, Z_COOKIES } from "@lls/lls-kit";
import _144 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_cookies_index.module.css
var src_internals_components_cookies_index_default = { "icon": "sk-7l8pra-icon", "title": "sk-7l8pra-title", "cookies": "sk-7l8pra-cookies" };

// src/internals/components/cookies/index.jsx
import { jsx as jsx166, jsxs as jsxs130 } from "react/jsx-runtime";
var Cookies = ({ onClose = _144.noop }) => /* @__PURE__ */ jsxs130("div", { className: src_internals_components_cookies_index_default.cookies, style: { "--s-z-cookies": Z_COOKIES }, children: [
  /* @__PURE__ */ jsx166(Icon42, { className: src_internals_components_cookies_index_default.icon, onClick: onClose, name: "cancel", width: "17", height: "17" }),
  /* @__PURE__ */ jsx166("div", { className: src_internals_components_cookies_index_default.title, children: "Utilisation des cookies" }),
  /* @__PURE__ */ jsx166("div", { children: "Lors de votre navigation sur ce site, des cookies n\xE9cessaires au bon fonctionnement et exempt\xE9s de consentement sont d\xE9pos\xE9s." })
] });
var cookies_default = Cookies;

// src/internals/components/book/classicResourceLink.jsx
import { Button as Button81 } from "@lls/lls-kit";
import { openWindow as openWindow6 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_book_classicResourceLink.module.css
var src_internals_components_book_classicResourceLink_default = { "title": "sk-DuMITa-title", "classicResourceLink": "sk-DuMITa-classicResourceLink", "classicCoverContent": "sk-DuMITa-classicCoverContent", "classicResourceText": "sk-DuMITa-classicResourceText", "resourceTitle": "sk-DuMITa-resourceTitle", "container": "sk-DuMITa-container", "classicResourceCover": "sk-DuMITa-classicResourceCover" };

// src/internals/components/book/classicResourceLink.jsx
import { jsx as jsx167, jsxs as jsxs131 } from "react/jsx-runtime";
var ClassicResourceLink = ({
  book: { id, classicColor, displayTitle, isClassicTextDark = true } = {},
  isDrawerOpen = true,
  resourceUrl = ""
}) => {
  return /* @__PURE__ */ jsxs131("div", { className: src_internals_components_book_classicResourceLink_default.container, children: [
    /* @__PURE__ */ jsx167("h2", { className: src_internals_components_book_classicResourceLink_default.title, children: "Ressources" }),
    /* @__PURE__ */ jsxs131("div", { className: src_internals_components_book_classicResourceLink_default.classicResourceLink, "data-drawer-open": +isDrawerOpen, children: [
      /* @__PURE__ */ jsx167(
        "div",
        {
          className: src_internals_components_book_classicResourceLink_default.classicResourceCover,
          style: { "--s-url": `url(${ASSETS_URL}/books/${id}/header-tablet.png)`, "--s-bgcolor": classicColor },
          children: /* @__PURE__ */ jsxs131("div", { className: src_internals_components_book_classicResourceLink_default.classicCoverContent, "data-dark": +isClassicTextDark, children: [
            /* @__PURE__ */ jsx167(
              "img",
              {
                src: isClassicTextDark ? "/assets/img/book/logo-classics-black.svg" : "/assets/img/book/logo-classics-white.svg"
              }
            ),
            /* @__PURE__ */ jsx167("div", { children: displayTitle })
          ] })
        }
      ),
      /* @__PURE__ */ jsxs131("div", { className: src_internals_components_book_classicResourceLink_default.classicResourceText, children: [
        /* @__PURE__ */ jsx167("h1", { className: src_internals_components_book_classicResourceLink_default.resourceTitle, children: "Poursuivez l'exp\xE9rience de votre Classique !" }),
        /* @__PURE__ */ jsx167("div", { children: "Retrouvez sur cette page, l'ensemble des ressources num\xE9riques disponibles en lien avec votre classique pr\xE9f\xE9r\xE9." }),
        /* @__PURE__ */ jsx167(
          Button81,
          {
            theme: "premium",
            href: resourceUrl,
            target: "_blank",
            onGoTo: ({ href, target }) => openWindow6(href, target),
            children: "Acc\xE9der aux ressources"
          }
        )
      ] })
    ] })
  ] });
};
var classicResourceLink_default = ClassicResourceLink;

// src/internals/components/book/classicEpubLink.jsx
import { Button as Button82 } from "@lls/lls-kit";
import { openWindow as openWindow7 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_book_classicEpubLink.module.css
var src_internals_components_book_classicEpubLink_default = { "container": "sk-brRpVa-container", "wrapper": "sk-brRpVa-wrapper", "clipped": "sk-brRpVa-clipped", "content": "sk-brRpVa-content", "cta": "sk-brRpVa-cta", "img": "sk-brRpVa-img", "card": "sk-brRpVa-card" };

// src/internals/components/book/classicEpubLink.jsx
import { jsx as jsx168, jsxs as jsxs132 } from "react/jsx-runtime";
var ClassicEpubLink = ({ book: { id, classicColor, isClassicTextDark = false } = {}, width = "100%", epubLink }) => {
  return /* @__PURE__ */ jsxs132("div", { className: src_internals_components_book_classicEpubLink_default.container, style: { "--s-width": width }, children: [
    /* @__PURE__ */ jsx168(StyledTitle5, { children: "\u0152uvre num\xE9rique" }),
    /* @__PURE__ */ jsxs132("div", { className: src_internals_components_book_classicEpubLink_default.card, children: [
      /* @__PURE__ */ jsxs132("div", { className: src_internals_components_book_classicEpubLink_default.wrapper, children: [
        /* @__PURE__ */ jsx168("div", { className: src_internals_components_book_classicEpubLink_default.clipped, style: { "--s-bgcolor": classicColor } }),
        /* @__PURE__ */ jsx168("div", { className: src_internals_components_book_classicEpubLink_default.content, "data-is-dark": +isClassicTextDark, children: /* @__PURE__ */ jsxs132("div", { className: src_internals_components_book_classicEpubLink_default.cta, children: [
          "Consultez l'oeuvre int\xE9grale de votre Classique au format num\xE9rique ",
          /* @__PURE__ */ jsx168("br", {}),
          /* @__PURE__ */ jsx168(
            Button82,
            {
              theme: "premium",
              href: epubLink,
              target: "_blank",
              onGoTo: ({ href, target }) => openWindow7(href, target),
              children: "Consulter l'\u0153uvre num\xE9rique"
            }
          )
        ] }) })
      ] }),
      /* @__PURE__ */ jsx168(
        "img",
        {
          className: src_internals_components_book_classicEpubLink_default.img,
          style: { "--s-width": "120px", "--s-left": "0", "--s-bottom": "0" },
          src: `${ASSETS_URL}/books/${id}/Asset-3.png`
        }
      ),
      /* @__PURE__ */ jsx168(
        "img",
        {
          className: src_internals_components_book_classicEpubLink_default.img,
          style: { "--s-width": "90px", "--s-bottom": "30%", "--s-right": "0" },
          src: `${ASSETS_URL}/books/${id}/Asset-1.png`
        }
      )
    ] })
  ] });
};
var classicEpubLink_default = ClassicEpubLink;

// src/internals/components/session/index.jsx
import { useCallback as useCallback65, useMemo as useMemo33 } from "react";
import { KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME8, KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME12, styleThemeProps as styleThemeProps3 } from "@lls/lls-kit";
import _164 from "lodash/fp.js";
import { cx as cx42 } from "@lls/utils";

// src/internals/components/session/end/index.jsx
import _148 from "lodash/fp.js";
import { Button as Button83 } from "@lls/lls-kit";

// src/internals/components/session/exercisesStats.jsx
import _147 from "lodash/fp.js";
import { cx as cx39 } from "@lls/utils";

// src/internals/components/stats/progressRound.jsx
import { CircularProgressBar as CircularProgressBar3 } from "@lls/lls-kit";
import _145 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_stats_progressRound.module.css
var src_internals_components_stats_progressRound_default = { "container": "sk-CoNiCG-container", "label": "sk-CoNiCG-label" };

// src/internals/components/stats/progressRound.jsx
import { jsx as jsx169, jsxs as jsxs133 } from "react/jsx-runtime";
var ProgressRound = ({ value, label, fillColor = "#FFF" }) => {
  const percentValue = _145.round(value * 100);
  return /* @__PURE__ */ jsxs133("div", { className: src_internals_components_stats_progressRound_default.container, children: [
    label && /* @__PURE__ */ jsx169("div", { className: src_internals_components_stats_progressRound_default.label, children: label }),
    /* @__PURE__ */ jsx169(
      CircularProgressBar3,
      {
        radius: 30,
        strokeRatio: 0.3,
        progress: percentValue,
        inverse: false,
        displayPercent: true,
        progressColor: fillColor,
        variant: "determinate"
      }
    )
  ] });
};
var progressRound_default = ProgressRound;

// tmp_esbuild1736180050074/_src_internals_components_session_exercisesStats.module.css
var src_internals_components_session_exercisesStats_default = { "viewer-fullscreen-modal": "sk-wZM8cG-viewer-fullscreen-modal", "firstLabel": "sk-wZM8cG-firstLabel", "circle": "sk-wZM8cG-circle", "wrapper": "sk-wZM8cG-wrapper" };

// src/internals/components/stats/flipPaper.jsx
import _146 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_stats_flipPaper.module.css
var src_internals_components_stats_flipPaper_default = { "animate7": "sk-UmlWlG-animate7", "stopwatchElementLabel": "sk-UmlWlG-stopwatchElementLabel", "animate2": "sk-UmlWlG-animate2", "animate9": "sk-UmlWlG-animate9", "duration": "sk-UmlWlG-duration", "durationDigit": "sk-UmlWlG-durationDigit", "animate0": "sk-UmlWlG-animate0", "animate8": "sk-UmlWlG-animate8", "animate1": "sk-UmlWlG-animate1", "animate4": "sk-UmlWlG-animate4", "animate6": "sk-UmlWlG-animate6", "digits": "sk-UmlWlG-digits", "viewer-fullscreen-modal": "sk-UmlWlG-viewer-fullscreen-modal", "animate3": "sk-UmlWlG-animate3", "animate5": "sk-UmlWlG-animate5", "stopwatchElement": "sk-UmlWlG-stopwatchElement" };

// src/internals/components/stats/flipPaper.jsx
import { jsx as jsx170, jsxs as jsxs134 } from "react/jsx-runtime";
var Digit = ({ digit, delay }) => /* @__PURE__ */ jsx170("div", { className: src_internals_components_stats_flipPaper_default.duration, style: { "--s-delay": `${delay}s` }, "data-digit": digit, children: _146.times(
  (i) => /* @__PURE__ */ jsx170("div", { className: src_internals_components_stats_flipPaper_default.durationDigit, children: i }, i),
  10
) });
var FlipPaper = ({ value, label, delayBase }) => {
  const deltaDelay = 0.1 / (_146.size(value) - 1 > 0 ? _146.size(value) - 1 : 1);
  return /* @__PURE__ */ jsxs134("div", { className: src_internals_components_stats_flipPaper_default.stopwatchElement, children: [
    /* @__PURE__ */ jsx170("div", { className: src_internals_components_stats_flipPaper_default.digits, children: _146.map.convert({ cap: false })((digit, i) => {
      return /* @__PURE__ */ jsx170(Digit, { digit: _146.parseInt(10, digit), delay: delayBase + i * deltaDelay }, i);
    }, value) }),
    /* @__PURE__ */ jsx170("div", { className: src_internals_components_stats_flipPaper_default.stopwatchElementLabel, children: label })
  ] });
};
var flipPaper_default = FlipPaper;

// tmp_esbuild1736180050074/_src_internals_components_session_stopWatch.module.css
var src_internals_components_session_stopWatch_default = { "stopwatchElements": "sk-6YgMwW-stopwatchElements", "label": "sk-6YgMwW-label" };

// src/internals/components/session/stopWatch.jsx
import { jsx as jsx171, jsxs as jsxs135 } from "react/jsx-runtime";
var SessionStopwatch = ({ time }) => {
  const [hours, minutes, seconds] = parseHoursTime(time);
  return /* @__PURE__ */ jsxs135("div", { children: [
    /* @__PURE__ */ jsx171("div", { className: src_internals_components_session_stopWatch_default.label, children: "Temps pass\xE9" }),
    /* @__PURE__ */ jsxs135("div", { className: src_internals_components_session_stopWatch_default.stopwatchElements, children: [
      hours !== 0 && /* @__PURE__ */ jsx171(flipPaper_default, { value: formatDigit(hours), label: "heures", delayBase: 0.9 }),
      /* @__PURE__ */ jsx171(flipPaper_default, { value: formatDigit(minutes), label: "minutes", delayBase: 0.7 }),
      /* @__PURE__ */ jsx171(flipPaper_default, { value: formatDigit(seconds), label: "secondes", delayBase: 0.5 })
    ] })
  ] });
};
var stopWatch_default = SessionStopwatch;

// src/internals/components/session/exercisesStats.jsx
import { jsx as jsx172, jsxs as jsxs136 } from "react/jsx-runtime";
var SessionExercisesStats = ({
  stats,
  color = "var(--secondary-40-color)",
  label,
  circle,
  className,
  withCircle = true
}) => /* @__PURE__ */ jsx172("div", { color, className: cx39(className, src_internals_components_session_exercisesStats_default.wrapper), children: /* @__PURE__ */ jsxs136("div", { className: "exercices-stats-header", children: [
  /* @__PURE__ */ jsxs136("div", { className: "exercices-stats-header-item", children: [
    /* @__PURE__ */ jsx172("div", { className: src_internals_components_session_exercisesStats_default.firstLabel, children: label }),
    /* @__PURE__ */ jsx172("div", { className: withCircle ? src_internals_components_session_exercisesStats_default.circle : "exercices-stats-first-item", children: /* @__PURE__ */ jsx172("div", { className: "exercices-stats-first-item-container", children: circle }) })
  ] }),
  /* @__PURE__ */ jsx172("div", { className: "exercices-stats-header-item", children: /* @__PURE__ */ jsx172(
    progressRound_default,
    {
      value: _147.get("ratio", stats),
      circleStrokeWidth: 12,
      fillColor: color,
      svgSize: 78,
      svgSizeXs: 78,
      circleRay: 33,
      circleRayXs: 33,
      label: "Bonnes r\xE9ponses"
    }
  ) }),
  /* @__PURE__ */ jsx172("div", { className: "exercices-stats-header-item", children: /* @__PURE__ */ jsx172(stopWatch_default, { time: _147.getOr(0, "time", stats) }) })
] }) });
var exercisesStats_default = SessionExercisesStats;

// src/internals/components/session/wrapper.jsx
import { makeComponent as makeComponent9 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_session_wrapper.module.css
var src_internals_components_session_wrapper_default = { "wrapper": "sk-Yxhq8a-wrapper" };

// src/internals/components/session/wrapper.jsx
var StyledWrapper = makeComponent9("div", src_internals_components_session_wrapper_default.wrapper);
var wrapper_default = StyledWrapper;

// tmp_esbuild1736180050074/_src_internals_components_session_end_index.module.css
var src_internals_components_session_end_index_default = { "footer": "sk-SP2UAG-footer" };

// tmp_esbuild1736180050074/_src_internals_components_session_exercisesStatsSkeleton.module.css
var src_internals_components_session_exercisesStatsSkeleton_default = { "firstStopwtachElementSkeleton": "sk-zYMXtG-firstStopwtachElementSkeleton", "stopwatchSkeleton": "sk-zYMXtG-stopwatchSkeleton", "statsLabelSkeleton": "sk-zYMXtG-statsLabelSkeleton", "stats": "sk-zYMXtG-stats", "statsElements": "sk-zYMXtG-statsElements", "exercisesStatsSkeleton": "sk-zYMXtG-exercisesStatsSkeleton" };

// src/internals/components/session/skeleton.jsx
import { cx as cx40 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_session_skeleton.module.css
var src_internals_components_session_skeleton_default = { "skeleton": "sk-4MUUyW-skeleton" };

// src/internals/components/session/skeleton.jsx
import { jsx as jsx173 } from "react/jsx-runtime";
var Skeleton = ({ width = "100%", height = "10px", borderRadius = "4px", className, children }) => /* @__PURE__ */ jsx173(
  "div",
  {
    style: { "--s-width": width, "--s-height": height, "--s-borderradius": borderRadius },
    className: cx40(className, src_internals_components_session_skeleton_default.skeleton),
    children
  }
);
var skeleton_default = Skeleton;

// src/internals/components/session/exercisesStatsSkeleton.jsx
import { jsx as jsx174, jsxs as jsxs137 } from "react/jsx-runtime";
var ExercisesStatsSkeleton = () => /* @__PURE__ */ jsx174(skeleton_default, { className: src_internals_components_session_exercisesStatsSkeleton_default.exercisesStatsSkeleton, height: "175px", borderRadius: "0px", children: /* @__PURE__ */ jsxs137("div", { className: src_internals_components_session_exercisesStatsSkeleton_default.stats, children: [
  /* @__PURE__ */ jsxs137("div", { className: src_internals_components_session_exercisesStatsSkeleton_default.statsElements, children: [
    /* @__PURE__ */ jsxs137("div", { className: src_internals_components_session_exercisesStatsSkeleton_default.stopwatchSkeleton, children: [
      /* @__PURE__ */ jsx174(skeleton_default, { className: src_internals_components_session_exercisesStatsSkeleton_default.firstStopwtachElementSkeleton, width: "82px", height: "82px" }),
      /* @__PURE__ */ jsx174(skeleton_default, { width: "82px", height: "82px" })
    ] }),
    /* @__PURE__ */ jsx174(skeleton_default, { className: src_internals_components_session_exercisesStatsSkeleton_default.statsLabelSkeleton, width: "125px" })
  ] }),
  /* @__PURE__ */ jsxs137("div", { className: src_internals_components_session_exercisesStatsSkeleton_default.statsElements, children: [
    /* @__PURE__ */ jsx174(skeleton_default, { width: "82px", height: "82px", borderRadius: "50%" }),
    /* @__PURE__ */ jsx174(skeleton_default, { className: src_internals_components_session_exercisesStatsSkeleton_default.statsLabelSkeleton, width: "125px" })
  ] }),
  /* @__PURE__ */ jsxs137("div", { className: src_internals_components_session_exercisesStatsSkeleton_default.statsElements, children: [
    /* @__PURE__ */ jsx174(skeleton_default, { width: "82px", height: "82px", borderRadius: "50%" }),
    /* @__PURE__ */ jsx174(skeleton_default, { className: src_internals_components_session_exercisesStatsSkeleton_default.statsLabelSkeleton, width: "125px" })
  ] })
] }) });
var exercisesStatsSkeleton_default = ExercisesStatsSkeleton;

// tmp_esbuild1736180050074/_src_internals_components_session_end_skeleton.module.css
var src_internals_components_session_end_skeleton_default = { "progressionSkeleton": "sk-69PBHG-progressionSkeleton" };

// src/internals/components/session/end/skeleton.jsx
import { jsx as jsx175, jsxs as jsxs138 } from "react/jsx-runtime";
var ProgressionSkeleton = () => /* @__PURE__ */ jsx175(skeleton_default, { className: src_internals_components_session_end_skeleton_default.progressionSkeleton, borderRadius: "0px", children: /* @__PURE__ */ jsx175(skeleton_default, {}) });
var SessionEndSkeleton = () => /* @__PURE__ */ jsxs138("div", { children: [
  /* @__PURE__ */ jsx175(ProgressionSkeleton, {}),
  /* @__PURE__ */ jsx175(exercisesStatsSkeleton_default, {})
] });
var skeleton_default2 = SessionEndSkeleton;

// src/internals/components/session/end/index.jsx
import { jsx as jsx176, jsxs as jsxs139 } from "react/jsx-runtime";
var Cup = (props) => /* @__PURE__ */ jsxs139("svg", { width: "87", height: "76", viewBox: "0 0 87 76", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx176(
    "path",
    {
      d: "M78.7431 3.85045C75.9554 3.23393 72.7361 3.6293 69.7051 4.77186C69.7313 3.13408 69.7232 1.53452 69.677 0H17.7039C17.6577 1.53391 17.649 3.13355 17.6758 4.77186C14.6448 3.6293 11.4262 3.23394 8.63776 3.85045C4.51453 4.75713 1.71482 7.59112 0.755167 11.8229C-0.498631 17.3481 2.26159 23.6828 8.52591 29.6625C13.462 34.3728 20.0842 38.2917 27.0774 40.7121C29.9751 44.7971 33.6842 48.0881 38.3904 50.0891C37.7042 52.5953 35.2958 59.8562 29.4764 64.2997H57.9041C52.0834 59.8569 49.6757 52.5953 48.9902 50.0891C53.6965 48.0881 57.4068 44.7964 60.3031 40.7108C67.2959 38.291 73.9186 34.3721 78.8546 29.6618C85.1197 23.6817 87.8791 17.3477 86.6254 11.8222C85.6644 7.59111 82.8653 4.75709 78.7421 3.85045H78.7431ZM12.696 25.2943C8.16533 20.9673 5.90292 16.4327 6.64539 13.161C7.08165 11.2297 8.12837 10.1462 9.93831 9.74683C12.3273 9.21944 15.4441 10.0209 18.0113 11.6085C18.5943 18.5342 19.9627 25.7668 22.5226 32.1843C18.8389 30.2684 15.4549 27.9283 12.696 25.2941V25.2943ZM74.6842 25.2943C71.9253 27.9273 68.5419 30.2686 64.8576 32.1852C67.4189 25.7681 68.7865 18.5349 69.3689 11.6094C71.9362 10.0225 75.0522 9.22102 77.4419 9.74768C79.252 10.1471 80.2993 11.2307 80.7348 13.1619C81.4773 16.4341 79.215 20.9688 74.6842 25.2945V25.2943Z",
      fill: "#FFA800"
    }
  ),
  /* @__PURE__ */ jsx176("path", { d: "M25.437 68.1086H61.9431V76H25.437V68.1086Z", fill: "#FFA800" })
] });
var SessionEnd = ({ startANewSession, stats, isLoading }) => isLoading ? /* @__PURE__ */ jsx176(skeleton_default2, {}) : /* @__PURE__ */ jsxs139(wrapper_default, { children: [
  /* @__PURE__ */ jsx176(exercisesStats_default, { stats: _148.get("global", stats), label: "Session termin\xE9e !", withCircle: false, circle: /* @__PURE__ */ jsx176(Cup, {}) }),
  /* @__PURE__ */ jsx176("div", { className: src_internals_components_session_end_index_default.footer, children: /* @__PURE__ */ jsx176(Button83, { theme: "success", onClick: startANewSession, children: "Refaire une session d'exercices" }) })
] });
var end_default = SessionEnd;

// src/internals/components/session/exercise.jsx
import { jsx as jsx177 } from "react/jsx-runtime";
var SessionExercise = ({ viewerElement, isSessionEnded, stats, isLoading, startANewSession, color }) => isSessionEnded ? /* @__PURE__ */ jsx177(end_default, { color, isLoading, stats, startANewSession }) : viewerElement;
var exercise_default = SessionExercise;

// src/internals/components/session/header.jsx
import { Stamp as Stamp8 } from "@lls/lls-kit";
import _149 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_session_header.module.css
var src_internals_components_session_header_default = { "header": "sk-fHpYoW-header", "viewer-fullscreen-modal": "sk-fHpYoW-viewer-fullscreen-modal", "headerTitle": "sk-fHpYoW-headerTitle" };

// src/internals/components/session/header.jsx
import { jsx as jsx178, jsxs as jsxs140 } from "react/jsx-runtime";
var SessionHeader = ({ template }) => /* @__PURE__ */ jsxs140("div", { className: src_internals_components_session_header_default.header, children: [
  /* @__PURE__ */ jsx178(Stamp8, { theme: "blue", size: "medium", children: "Premium" }),
  /* @__PURE__ */ jsx178("h1", { className: src_internals_components_session_header_default.headerTitle, children: _149.get("metadata.title", template) })
] });
var header_default4 = SessionHeader;

// src/internals/components/session/sessionTabs.jsx
import { Tab as Tab5, Tabs as Tabs5 } from "@lls/lls-kit";
import { jsx as jsx179, jsxs as jsxs141 } from "react/jsx-runtime";
var SessionTabs = ({ selectedTab, onSelectTab, sessionTabs }) => {
  return /* @__PURE__ */ jsx179(
    Tabs5,
    {
      variant: "noBackground",
      centered: true,
      value: sessionTabs == null ? void 0 : sessionTabs.indexOf(selectedTab),
      onChange: (i) => onSelectTab(sessionTabs == null ? void 0 : sessionTabs[i]),
      children: sessionTabs == null ? void 0 : sessionTabs.map((tab) => {
        switch (tab) {
          case SESSION_EXERCISE_TAB:
            return /* @__PURE__ */ jsxs141(Tab5, { icon: "highlight", "data-tour": `${DATA_TOUR.SESSION_TAB}-${SESSION_EXERCISE_TAB}`, children: [
              " ",
              "Exercices"
            ] }, tab);
          case SESSION_STATS_TAB:
            return /* @__PURE__ */ jsx179(Tab5, { icon: "chart", "data-tour": `${DATA_TOUR.SESSION_TAB}-${SESSION_STATS_TAB}`, children: "Statistiques" }, tab);
          default:
            return /* @__PURE__ */ jsx179(Tab5, { icon: "mathtools", "data-tour": `${DATA_TOUR.SESSION_TAB}-${SESSION_STATS_TEACHER_TAB}`, children: "Statistiques de mes \xE9l\xE8ves" }, tab);
        }
      })
    }
  );
};
var sessionTabs_default = SessionTabs;

// src/internals/components/session/stats/index.jsx
import { useState as useState59 } from "react";
import _157 from "lodash/fp.js";
import { SelectField as SelectField10 } from "@lls/lls-kit";

// src/internals/utils/session.jsx
import dayjs6 from "dayjs";
import _151 from "lodash/fp.js";

// src/internals/utils/stats.tsx
import dayjs5 from "dayjs";
import _150 from "lodash/fp.js";
import round from "lodash/round.js";
var SESSION_EXERCISE_MAX_TIME = 1e3 * 60 * 10;
var getSelectedStudentIds = (groups, selectedGroupIds) => {
  const selectedGroups = _150.filter((group) => _150.includes(group.id, selectedGroupIds), groups);
  return _150.flatMap(_150.get("students"), selectedGroups);
};
var pick = ({ props, object, path, where }) => {
  if (_150.isEmpty(path)) return _150.pick(props, object);
  const key = _150.first(path);
  const value = _150.get(key, object);
  return { [key]: mapPick({ props, path, where })(value) };
};
var mapPick = ({ props, path, where = _150.constant(true) }) => _150.flow(
  (val) => _150.map.convert({ cap: false })(
    (value, key) => where(value, key, _150.first(path)) ? { id: key, ...pick({ props, object: value, path: _150.tail(path), where }) } : null,
    val
  ),
  _150.compact
);
var makeGetData = ({ props, by, where }) => (stats) => {
  const path = _150.split(".", by);
  return _150.flow(_150.get(by), mapPick({ props, path, where }))(stats);
};
var isStudentSelectedBySection = ({
  user,
  section: { min = 0, max = 1 },
  selectedStudentIds
}) => {
  const isUserSelected = _150.isEmpty(selectedStudentIds) || _150.includes(_150.get("id", user), selectedStudentIds);
  const ratio = _150.flow(
    // GetOr does not seem to handle types as it should
    _150.getOr(0, "ratio"),
    (ratio2) => round(ratio2, 2)
  )(user);
  return isUserSelected && ratio >= min && ratio <= max;
};
var getMedals = (score) => ({
  bronze: score >= MEDALS.bronze.score,
  silver: score >= MEDALS.silver.score,
  gold: score >= MEDALS.gold.score
});
var medalsToLevel = (medals) => {
  if (_150.get("gold", medals)) return MEDALS.gold.name;
  if (_150.get("silver", medals)) return MEDALS.silver.name;
  if (_150.get("bronze", medals)) return MEDALS.bronze.name;
  return MEDALS.beginner.name;
};
var medalsToMaxLevelScore = (medals) => {
  if (_150.get("gold", medals) || _150.get("silver", medals)) return MEDALS.gold.score;
  if (_150.get("bronze", medals)) return MEDALS.silver.score;
  return MEDALS.bronze.score;
};
var statsCumulator = (stats) => {
  const totalAnswers = _150.sumBy("totalAnswers", stats);
  const validAnswers = _150.sumBy("validAnswers", stats);
  const ratio = validAnswers / Math.max(1, totalAnswers);
  const score = _150.sumBy("score", stats);
  const time = _150.flow(_150.sumBy("time"), (time2) => _150.min([SESSION_EXERCISE_MAX_TIME, time2]))(stats);
  return {
    ratio,
    totalAnswers,
    validAnswers,
    valid: ratio === 1,
    score,
    time,
    nbExercises: _150.sumBy("nbExercises", stats)
  };
};
var whereDateIn = ({ min, max }) => (_stat, date) => {
  const dateObject = new Date(date);
  return dayjs5(dateObject).isAfter(min) && dayjs5(dateObject).isBefore(max);
};
var getTabs = (isTeacher2) => isTeacher2 ? [SESSION_STATS_TEACHER_TAB, SESSION_EXERCISE_TAB] : [SESSION_EXERCISE_TAB, SESSION_STATS_TAB];

// src/internals/utils/session.jsx
var getDatesFromNDays = (n) => _151.reverse(
  _151.times((offset) => {
    const today = dayjs6().startOf("day");
    const day = today.subtract(offset, "day");
    return {
      min: day.valueOf(),
      max: day.endOf("day").valueOf()
    };
  }, n)
);
var getDatesFromSeptember = () => {
  const now = Date.now();
  const firstMonthDay = dayjs6(now).startOf("month");
  const currentMonth = dayjs6(now).get("month");
  const septemberMonth = 8;
  const monthDiff = (currentMonth - septemberMonth + 12) % 12;
  return _151.reverse(
    _151.times((offset) => {
      const day = firstMonthDay.subtract(offset, "month");
      return {
        min: day.valueOf(),
        max: day.endOf("month").valueOf()
      };
    }, monthDiff + 1)
  );
};
var getDatesByPeriod = (period) => {
  switch (period) {
    case SESSION_WEEK_PERIOD:
      return getDatesFromNDays(7);
    case SESSION_MONTH_PERIOD:
      return getDatesFromNDays(30);
    case SESSION_YEAR_PERIOD:
      return getDatesFromSeptember();
    default:
      return getDatesFromNDays(7);
  }
};
var buildExercisesDataByPeriod = (stats, period) => {
  const dates = getDatesByPeriod(period);
  const getStatsByDates = (dates2) => makeGetData({
    props: ["nbExercises", "ratio", "time", "totalAnswers", "validAnswers"],
    by: "statUnit",
    where: whereDateIn(dates2)
  })(stats);
  return _151.map((date) => {
    const dateStats = _151.flow(getStatsByDates, statsCumulator)(date);
    return _151.flow(_151.pick(["nbExercises", "ratio", "time"]), _151.set("date", date.min))(dateStats);
  }, dates);
};

// tmp_esbuild1736180050074/_src_internals_components_session_stats_chartsStats.module.css
var src_internals_components_session_stats_chartsStats_default = { "container": "sk-7wU4ia-container" };

// src/internals/components/session/stats/quantityChart.jsx
import _153 from "lodash/fp.js";
import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip as Tooltip20, XAxis, YAxis } from "recharts";
import { Icon as Icon43 } from "@lls/lls-kit";

// src/internals/utils/chart.tsx
import _152 from "lodash/fp.js";
import { jsx as jsx180 } from "react/jsx-runtime";
var makeCustomTick = (formatter) => (props) => {
  var _a, _b;
  const attrs = _152.pick(["textAnchor", "fill", "width", "height", "x", "y", "style"], props);
  attrs.dominantBaseline = "central";
  if (formatter === _152.identity && props.dy) {
    return /* @__PURE__ */ jsx180("g", { transform: `translate(0,${props.dy})`, children: /* @__PURE__ */ jsx180("text", { ...attrs, children: formatter((_a = props.payload) == null ? void 0 : _a.value) }) });
  }
  return /* @__PURE__ */ jsx180("text", { ...attrs, children: formatter((_b = props.payload) == null ? void 0 : _b.value) });
};
var tickDateFormatter = (period) => (value) => {
  const pattern = period === SESSION_YEAR_PERIOD ? "MMM" : "D MMM";
  return format(value, pattern);
};

// src/internals/components/session/stats/chartCommon.jsx
import { makeComponent as makeComponent10 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_session_stats_chartCommon.module.css
var src_internals_components_session_stats_chartCommon_default = { "viewer-fullscreen-modal": "sk-DMFKGW-viewer-fullscreen-modal", "boldP": "sk-DMFKGW-boldP", "tooltipStyle": "sk-DMFKGW-tooltipStyle", "tooltipSpan": "sk-DMFKGW-tooltipSpan" };

// src/internals/components/session/stats/chartCommon.jsx
var BoldP = makeComponent10("p", src_internals_components_session_stats_chartCommon_default.boldP);
var TooltipStyle = makeComponent10("div", src_internals_components_session_stats_chartCommon_default.tooltipStyle);
var TooltipSpan = makeComponent10("span", src_internals_components_session_stats_chartCommon_default.tooltipSpan);

// tmp_esbuild1736180050074/_src_internals_components_session_stats_chartHeader.module.css
var src_internals_components_session_stats_chartHeader_default = { "headerSubtitle": "sk-M14DgG-headerSubtitle", "header": "sk-M14DgG-header", "headerTitle": "sk-M14DgG-headerTitle" };

// src/internals/components/session/stats/chartHeader.jsx
import { jsx as jsx181, jsxs as jsxs142 } from "react/jsx-runtime";
var SessionChartHeader = ({ title, subtitle }) => /* @__PURE__ */ jsxs142("div", { className: src_internals_components_session_stats_chartHeader_default.header, children: [
  /* @__PURE__ */ jsx181("div", { className: src_internals_components_session_stats_chartHeader_default.headerTitle, children: title }),
  /* @__PURE__ */ jsx181("div", { className: src_internals_components_session_stats_chartHeader_default.headerSubtitle, children: subtitle })
] });
var chartHeader_default = SessionChartHeader;

// tmp_esbuild1736180050074/_src_internals_components_session_stats_quantityChart.module.css
var src_internals_components_session_stats_quantityChart_default = { "legendNumber": "sk-pW1rZa-legendNumber", "viewer-fullscreen-modal": "sk-pW1rZa-viewer-fullscreen-modal", "legendContainer": "sk-pW1rZa-legendContainer", "chartsContainer": "sk-pW1rZa-chartsContainer", "legendLabel": "sk-pW1rZa-legendLabel", "icon": "sk-pW1rZa-icon" };

// src/internals/components/session/stats/quantityChart.jsx
import { jsx as jsx182, jsxs as jsxs143 } from "react/jsx-runtime";
var renderLegend = ({ stats }) => {
  const time = _153.getOr(0, "time", stats);
  const timeText = time ? timeToText(time) : "0s";
  const nbExercises = _153.getOr(0, "nbExercises", stats);
  const nbExercisesPlural = nbExercises > 1 ? "Exercices r\xE9alis\xE9s" : "Exercice r\xE9alis\xE9";
  return /* @__PURE__ */ jsxs143("div", { className: src_internals_components_session_stats_quantityChart_default.legendContainer, children: [
    /* @__PURE__ */ jsxs143("div", { className: "charts-legend-entry", children: [
      /* @__PURE__ */ jsx182(Icon43, { className: src_internals_components_session_stats_quantityChart_default.icon, name: "timer", "data-timer": "1", width: 24, height: 24 }),
      /* @__PURE__ */ jsxs143("div", { className: "charts-legend-time", children: [
        /* @__PURE__ */ jsx182("div", { className: src_internals_components_session_stats_quantityChart_default.legendLabel, children: "Temps de r\xE9visions" }),
        /* @__PURE__ */ jsxs143("div", { className: src_internals_components_session_stats_quantityChart_default.legendNumber, children: [
          timeText,
          " "
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs143("div", { className: "charts-legend-entry", children: [
      /* @__PURE__ */ jsx182(Icon43, { className: src_internals_components_session_stats_quantityChart_default.icon, name: "highlight", "data-exercice": "1", width: 24, height: 24 }),
      /* @__PURE__ */ jsxs143("div", { className: "charts-legend-exercice", children: [
        /* @__PURE__ */ jsx182("div", { className: src_internals_components_session_stats_quantityChart_default.legendLabel, children: nbExercisesPlural }),
        /* @__PURE__ */ jsx182("div", { className: src_internals_components_session_stats_quantityChart_default.legendNumber, children: nbExercises })
      ] })
    ] })
  ] });
};
var CustomTooltip = ({ active, payload, label, period }) => {
  if (!active || _153.isEmpty(payload)) return null;
  const time = _153.flow(_153.getOr(0, "0.value"), timeToText)(payload) || "0 min";
  const count = _153.getOr(0, "1.value", payload);
  const pluralExercise = count > 1 ? "s" : "";
  const date = period === SESSION_YEAR_PERIOD ? `en ${format(label, "MMM")}` : `le ${format(label, "D MMM YYYY")}`;
  return /* @__PURE__ */ jsxs143(TooltipStyle, { children: [
    /* @__PURE__ */ jsxs143(BoldP, { children: [
      count,
      " exercice",
      pluralExercise,
      /* @__PURE__ */ jsxs143(TooltipSpan, { children: [
        " ",
        date
      ] })
    ] }),
    /* @__PURE__ */ jsxs143(BoldP, { children: [
      time,
      /* @__PURE__ */ jsxs143(TooltipSpan, { children: [
        " ",
        date
      ] })
    ] })
  ] });
};
var QuantityChart = ({ data, period, stats }) => {
  return /* @__PURE__ */ jsxs143("div", { className: src_internals_components_session_stats_quantityChart_default.chartsContainer, children: [
    /* @__PURE__ */ jsx182(chartHeader_default, { title: "Quantit\xE9 de travail", subtitle: "Temps pass\xE9 et nombre d'exercices faits" }),
    /* @__PURE__ */ jsx182(ResponsiveContainer, { height: 500, children: /* @__PURE__ */ jsxs143(AreaChart, { data, ...SESSION_STATS_CHART_CONFIG, children: [
      /* @__PURE__ */ jsx182(CartesianGrid, { ...SESSION_STATS_CARTESION_GRID_CONFIG }),
      /* @__PURE__ */ jsx182(
        XAxis,
        {
          dataKey: "date",
          padding: { left: 10, right: 10 },
          tick: makeCustomTick(tickDateFormatter(period)),
          style: { fontSize: 11 },
          dy: 5,
          tickLine: false
        }
      ),
      /* @__PURE__ */ jsx182(
        YAxis,
        {
          yAxisId: "0",
          dataKey: "time",
          orientation: "left",
          axisLine: false,
          tickLine: false,
          stroke: "var(--primary-40-color)",
          tick: makeCustomTick(timeToText),
          style: { fontSize: 11 }
        }
      ),
      /* @__PURE__ */ jsx182(
        YAxis,
        {
          yAxisId: "1",
          dataKey: "nbExercises",
          orientation: "right",
          axisLine: false,
          tickLine: false,
          stroke: "var(--secondary-40-color)",
          tick: makeCustomTick((value) => `${value}ex`),
          style: { fontSize: 11 }
        }
      ),
      /* @__PURE__ */ jsx182(Tooltip20, { content: /* @__PURE__ */ jsx182(CustomTooltip, { period }) }),
      /* @__PURE__ */ jsx182(
        Area,
        {
          yAxisId: "0",
          dataKey: "time",
          stroke: "var(--primary-40-color)",
          fill: "var(--area-0-fill-color)",
          dot: { fill: "var(--area-dot-fill-color)", strokeWidth: 1 }
        }
      ),
      /* @__PURE__ */ jsx182(Area, { yAxisId: "1", dataKey: "nbExercises", stroke: "var(--secondary-40-color)", fill: "var(--area-1-fill-color)" }),
      /* @__PURE__ */ jsx182(Legend, { content: renderLegend, stats })
    ] }) })
  ] });
};
var quantityChart_default = QuantityChart;

// src/internals/components/session/stats/rateChart.jsx
import _154 from "lodash/fp.js";
import { Bar, BarChart, CartesianGrid as CartesianGrid2, Cell, Legend as Legend2, ResponsiveContainer as ResponsiveContainer2, Tooltip as Tooltip21, XAxis as XAxis2, YAxis as YAxis2 } from "recharts";
import { Icon as Icon44 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_session_stats_rateChart.module.css
var src_internals_components_session_stats_rateChart_default = { "legendNumber": "sk-Fusl5a-legendNumber", "legendLabel": "sk-Fusl5a-legendLabel", "legendContainer": "sk-Fusl5a-legendContainer", "viewer-fullscreen-modal": "sk-Fusl5a-viewer-fullscreen-modal", "chartsContainer": "sk-Fusl5a-chartsContainer" };

// src/internals/components/session/stats/rateChart.jsx
import { jsx as jsx183, jsxs as jsxs144 } from "react/jsx-runtime";
var map5 = _154.map.convert({ cap: false });
var renderLegend2 = ({ ratio }) => {
  return /* @__PURE__ */ jsx183("div", { className: src_internals_components_session_stats_rateChart_default.legendContainer, children: /* @__PURE__ */ jsxs144("div", { className: "charts-legend-entry", children: [
    /* @__PURE__ */ jsx183(Icon44, { name: "checkmark", color: "var(--primary-40-color)", width: 24, height: 24 }),
    /* @__PURE__ */ jsxs144("div", { className: "charts-legend", children: [
      /* @__PURE__ */ jsx183("div", { className: src_internals_components_session_stats_rateChart_default.legendLabel, children: "Taux de bonnes r\xE9ponses" }),
      /* @__PURE__ */ jsxs144("div", { className: src_internals_components_session_stats_rateChart_default.legendNumber, children: [
        ratio,
        " "
      ] })
    ] })
  ] }) });
};
var CustomTooltip2 = ({ active, payload, label, period }) => {
  if (!active || _154.isEmpty(payload)) return null;
  const ratio = _154.flow(_154.first, _154.get("value"), formatPercent)(payload);
  const date = period === SESSION_YEAR_PERIOD ? `en ${format(label, "MMM")}` : `le ${format(label, "D MMM YYYY")}`;
  return /* @__PURE__ */ jsx183(TooltipStyle, { children: /* @__PURE__ */ jsxs144(BoldP, { children: [
    ratio,
    " de bonnes r\xE9ponses",
    /* @__PURE__ */ jsxs144(TooltipSpan, { children: [
      " ",
      date
    ] })
  ] }) });
};
var RateChart = ({ data, period, stats }) => {
  const ratio = stats ? _154.flow(_154.get("ratio"), formatPercent)(stats) : "-";
  return /* @__PURE__ */ jsxs144("div", { className: src_internals_components_session_stats_rateChart_default.chartsContainer, children: [
    /* @__PURE__ */ jsx183(chartHeader_default, { title: "Taux de bonnes r\xE9ponses", subtitle: "Sur les pr\xE9c\xE9dentes sessions" }),
    /* @__PURE__ */ jsx183(ResponsiveContainer2, { height: 500, children: /* @__PURE__ */ jsxs144(BarChart, { data, ..._154.set("margin.right", 40, SESSION_STATS_CHART_CONFIG), children: [
      /* @__PURE__ */ jsx183(CartesianGrid2, { ...SESSION_STATS_CARTESION_GRID_CONFIG }),
      /* @__PURE__ */ jsx183(
        XAxis2,
        {
          dataKey: "date",
          padding: { left: 10, right: 10 },
          tick: makeCustomTick(tickDateFormatter(period)),
          style: { fontSize: 12 },
          tickLine: false,
          tickCount: 30,
          dy: 5
        }
      ),
      /* @__PURE__ */ jsx183(
        YAxis2,
        {
          yAxisId: "0",
          dataKey: "ratio",
          orientation: "left",
          axisLine: false,
          tickLine: { fill: "red", stroke: "pink" },
          tick: makeCustomTick(formatPercent),
          style: { fontSize: 12 }
        }
      ),
      /* @__PURE__ */ jsx183(Bar, { dataKey: "ratio", fill: "#21BFEF", radius: [4, 4, 0, 0], children: map5(
        (_entry, index) => /* @__PURE__ */ jsx183(Cell, { fill: "#21BFEF" }, `cell-${index}`),
        data
      ) }),
      /* @__PURE__ */ jsx183(Tooltip21, { content: /* @__PURE__ */ jsx183(CustomTooltip2, { period }), cursor: false }),
      /* @__PURE__ */ jsx183(Legend2, { content: renderLegend2, ratio })
    ] }) })
  ] });
};
var rateChart_default = RateChart;

// src/internals/components/session/stats/chartsStats.jsx
import { jsx as jsx184, jsxs as jsxs145 } from "react/jsx-runtime";
var SessionChartsStats = ({ period, stats, periodStats }) => {
  const data = buildExercisesDataByPeriod(stats, period);
  return /* @__PURE__ */ jsxs145("div", { className: src_internals_components_session_stats_chartsStats_default.container, children: [
    /* @__PURE__ */ jsx184("div", { className: "charts-stats-col", children: /* @__PURE__ */ jsx184(quantityChart_default, { data, period, stats: periodStats }) }),
    /* @__PURE__ */ jsx184("div", { className: "charts-stats-col", children: /* @__PURE__ */ jsx184(rateChart_default, { data, period, stats: periodStats }) })
  ] });
};
var chartsStats_default = SessionChartsStats;

// src/internals/components/session/stats/notionsStats.jsx
import { Icon as Icon45 } from "@lls/lls-kit";
import _155 from "lodash/fp.js";

// src/internals/v2/utils/session.ts
var getColorByRatio = (ratio) => {
  switch (true) {
    case ratio > 0.7:
      return RIGHT_ANSWER_COLOR;
    case ratio > 0.45:
      return MEDIUM_ANSWER_COLOR;
    default:
      return WRONG_ANSWER_COLOR;
  }
};

// tmp_esbuild1736180050074/_src_internals_components_session_stats_notionsStats.module.css
var src_internals_components_session_stats_notionsStats_default = { "header": "sk-VwdvmG-header", "dot": "sk-VwdvmG-dot", "container": "sk-VwdvmG-container", "viewer-fullscreen-modal": "sk-VwdvmG-viewer-fullscreen-modal" };

// src/internals/components/session/stats/notionsStats.jsx
import { jsx as jsx185, jsxs as jsxs146 } from "react/jsx-runtime";
var map6 = _155.map.convert({ cap: false });
var SessionNotionsStats = ({ stats }) => {
  const notions = makeGetData({
    props: ["nbExercises", "ratio", "time"],
    by: "notion"
  })(stats);
  return /* @__PURE__ */ jsxs146("div", { className: src_internals_components_session_stats_notionsStats_default.container, children: [
    /* @__PURE__ */ jsx185("div", { className: src_internals_components_session_stats_notionsStats_default.header, children: "D\xE9couvrez vos points forts et vos points faibles !" }),
    /* @__PURE__ */ jsx185("table", { className: "notion-stats-table", children: /* @__PURE__ */ jsx185("tbody", { children: map6((notion, i) => {
      const timeText = _155.flow(_155.getOr(0, "time"), timeToText)(notion);
      const ratio = _155.getOr(0, "ratio", notion);
      const ratioText = formatPercent(ratio);
      const nbExercises = _155.getOr(0, "nbExercises", notion);
      return /* @__PURE__ */ jsxs146("tr", { className: "notion-stats-row ", children: [
        /* @__PURE__ */ jsxs146("td", { className: "notion-stats-named-column", children: [
          /* @__PURE__ */ jsx185("div", { className: src_internals_components_session_stats_notionsStats_default.dot, style: { "--s-color": getColorByRatio(ratio) } }),
          /* @__PURE__ */ jsx185("div", { children: _155.get("id", notion) })
        ] }),
        /* @__PURE__ */ jsx185("td", { className: "notion-stats-column", children: /* @__PURE__ */ jsxs146("div", { className: "notion-stats-column-content", children: [
          /* @__PURE__ */ jsx185(Icon45, { name: "highlight", color: "#21BFEF", width: 16, height: 16 }),
          /* @__PURE__ */ jsx185("div", { className: "notion-stats-text", children: nbExercises })
        ] }) }),
        /* @__PURE__ */ jsx185("td", { className: "notion-stats-column", children: /* @__PURE__ */ jsxs146("div", { className: "notion-stats-column-content", children: [
          /* @__PURE__ */ jsx185(Icon45, { name: "timer", color: "#21BFEF", width: 16, height: 16 }),
          /* @__PURE__ */ jsxs146("div", { className: "notion-stats-text", children: [
            timeText,
            " "
          ] })
        ] }) }),
        /* @__PURE__ */ jsx185("td", { className: "notion-stats-column ", children: /* @__PURE__ */ jsxs146("div", { className: "notion-stats-column-content", children: [
          /* @__PURE__ */ jsx185(Icon45, { name: "checkmark", color: "#21BFEF", width: 16, height: 16 }),
          /* @__PURE__ */ jsx185("div", { className: "notion-stats-text", children: ratioText })
        ] }) })
      ] }, i);
    }, notions) }) })
  ] });
};
var notionsStats_default = SessionNotionsStats;

// src/internals/components/session/stats/animatedCounter.jsx
import { useEffect as useEffect27, useRef as useRef15, useState as useState58 } from "react";
import { jsx as jsx186 } from "react/jsx-runtime";
var DURATION = 1e3;
var AnimatedCounter = ({ number }) => {
  const [value, setValue] = useState58(number);
  const prevNumber = useRef15(number);
  const interval = useRef15(null);
  useEffect27(() => {
    if (number !== prevNumber.current) {
      const diff = number - prevNumber.current;
      const stepValue = diff / DURATION;
      interval.current = setInterval(() => {
        const newValue = prevNumber.current + (Math.round(stepValue) || 1);
        if (newValue >= number) {
          setValue(number);
          clearInterval(interval.current);
        } else {
          setValue(newValue);
        }
        prevNumber.current = newValue;
      }, stepValue);
    }
    return () => {
      prevNumber.current = number;
      clearInterval(interval.current);
    };
  }, [number]);
  return /* @__PURE__ */ jsx186("span", { children: value });
};
var animatedCounter_default = AnimatedCounter;

// tmp_esbuild1736180050074/_src_internals_components_session_stats_progressionPoint.module.css
var src_internals_components_session_stats_progressionPoint_default = { "pointsProgressbar": "sk-1oZnLW-pointsProgressbar", "points": "sk-1oZnLW-points", "pointsLabel": "sk-1oZnLW-pointsLabel", "pointsProgressbarContent": "sk-1oZnLW-pointsProgressbarContent", "pointsContent": "sk-1oZnLW-pointsContent", "pointsLabels": "sk-1oZnLW-pointsLabels" };

// src/internals/components/session/stats/progressionPoint.jsx
import { jsx as jsx187, jsxs as jsxs147 } from "react/jsx-runtime";
var ProgressionPoint = ({ score }) => {
  const medals = getMedals(score);
  const level = medalsToLevel(medals);
  return /* @__PURE__ */ jsx187("div", { className: src_internals_components_session_stats_progressionPoint_default.points, children: /* @__PURE__ */ jsxs147("div", { className: src_internals_components_session_stats_progressionPoint_default.pointsContent, children: [
    /* @__PURE__ */ jsxs147("div", { className: src_internals_components_session_stats_progressionPoint_default.pointsLabels, children: [
      /* @__PURE__ */ jsx187("div", { className: src_internals_components_session_stats_progressionPoint_default.pointsLabel, children: level }),
      /* @__PURE__ */ jsxs147("div", { className: src_internals_components_session_stats_progressionPoint_default.pointsLabel, children: [
        /* @__PURE__ */ jsx187(animatedCounter_default, { number: score }),
        " pts"
      ] })
    ] }),
    /* @__PURE__ */ jsx187("div", { className: src_internals_components_session_stats_progressionPoint_default.pointsProgressbar, children: /* @__PURE__ */ jsx187(
      "div",
      {
        className: src_internals_components_session_stats_progressionPoint_default.pointsProgressbarContent,
        style: { "--s-progress": score / medalsToMaxLevelScore(medals) }
      }
    ) })
  ] }) });
};
var progressionPoint_default = ProgressionPoint;

// src/internals/components/session/stats/skeleton.jsx
import _156 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_session_stats_skeleton.module.css
var src_internals_components_session_stats_skeleton_default = { "notionNameSkeleton": "sk-gEJOyG-notionNameSkeleton", "legendSkeleton": "sk-gEJOyG-legendSkeleton", "chartSkeleton": "sk-gEJOyG-chartSkeleton", "chartHeaderSkeleton": "sk-gEJOyG-chartHeaderSkeleton", "notion": "sk-gEJOyG-notion", "chartWrapper": "sk-gEJOyG-chartWrapper", "periodSkeleton": "sk-gEJOyG-periodSkeleton", "barChartSkeleton": "sk-gEJOyG-barChartSkeleton", "notionsSkeleton": "sk-gEJOyG-notionsSkeleton", "chartTitleSkeleton": "sk-gEJOyG-chartTitleSkeleton", "legendNameSkeleton": "sk-gEJOyG-legendNameSkeleton" };

// src/internals/components/session/stats/skeleton.jsx
import { jsx as jsx188, jsxs as jsxs148 } from "react/jsx-runtime";
var PeriodSkeleton = () => /* @__PURE__ */ jsx188(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.periodSkeleton, borderRadius: "0px", children: /* @__PURE__ */ jsx188(skeleton_default, { width: "335px" }) });
var ChartHeaderSkeleton = () => /* @__PURE__ */ jsxs148(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.chartHeaderSkeleton, borderRadius: "0px", height: "auto", children: [
  /* @__PURE__ */ jsx188(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.chartTitleSkeleton, width: "100px" }),
  /* @__PURE__ */ jsx188(skeleton_default, { width: "150px" })
] });
var BarSkeleton = () => /* @__PURE__ */ jsxs148("div", { className: src_internals_components_session_stats_skeleton_default.chartWrapper, children: [
  /* @__PURE__ */ jsx188(ChartHeaderSkeleton, {}),
  /* @__PURE__ */ jsx188(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.barChartSkeleton, height: "500px", borderRadius: "0px", children: _156.times(
    (index) => /* @__PURE__ */ jsx188(skeleton_default, { width: "7%", height: `${_156.random(40, 85)}%`, borderRadius: "0px" }, index),
    5
  ) }),
  /* @__PURE__ */ jsxs148(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.legendSkeleton, borderRadius: "0px", children: [
    /* @__PURE__ */ jsx188(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.legendNameSkeleton, width: "100px" }),
    /* @__PURE__ */ jsx188(skeleton_default, { width: "150px" })
  ] })
] });
var ChatsSkeletons = () => /* @__PURE__ */ jsxs148("div", { className: src_internals_components_session_stats_skeleton_default.chartSkeleton, children: [
  /* @__PURE__ */ jsx188(BarSkeleton, {}),
  /* @__PURE__ */ jsx188(BarSkeleton, {})
] });
var Notion = () => /* @__PURE__ */ jsxs148("div", { className: src_internals_components_session_stats_skeleton_default.notion, children: [
  /* @__PURE__ */ jsx188(skeleton_default, { width: "50%" }),
  /* @__PURE__ */ jsx188(skeleton_default, { width: "10%" }),
  /* @__PURE__ */ jsx188(skeleton_default, { width: "10%" }),
  /* @__PURE__ */ jsx188(skeleton_default, { width: "10%" })
] });
var NotionsSkeleton = () => /* @__PURE__ */ jsxs148(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.notionsSkeleton, borderRadius: "0px", height: "auto", children: [
  /* @__PURE__ */ jsx188(skeleton_default, { className: src_internals_components_session_stats_skeleton_default.notionNameSkeleton, width: "300px" }),
  _156.times(
    (index) => /* @__PURE__ */ jsx188(Notion, {}, index),
    4
  )
] });
var StatsSkeleton = () => /* @__PURE__ */ jsxs148("div", { children: [
  /* @__PURE__ */ jsx188(PeriodSkeleton, {}),
  /* @__PURE__ */ jsx188(exercisesStatsSkeleton_default, {}),
  /* @__PURE__ */ jsx188(ChatsSkeletons, {}),
  /* @__PURE__ */ jsx188(NotionsSkeleton, {})
] });
var skeleton_default3 = StatsSkeleton;

// tmp_esbuild1736180050074/_src_internals_components_session_stats_index.module.css
var src_internals_components_session_stats_index_default = { "wrapperHeader": "sk-DsumcW-wrapperHeader", "period": "sk-DsumcW-period", "periodWrapper": "sk-DsumcW-periodWrapper", "exercisesStats": "sk-DsumcW-exercisesStats" };

// src/internals/components/session/stats/index.jsx
import { Fragment as Fragment56, jsx as jsx189, jsxs as jsxs149 } from "react/jsx-runtime";
var SessionStats = ({ stats, isLoading, onPeriodChange = _157.noop, score }) => {
  const [period, setPeriod] = useState59(SESSION_YEAR_PERIOD);
  const dates = getDatesByPeriod(period);
  const fromDate = _157.flow(_157.get("0.min"), (date) => format(date, "DD/MM/YYYY"))(dates);
  const toDate = format(Date.now(), "DD/MM/YYYY");
  const periodStats = _157.get("global", stats);
  const nbExercises = _157.getOr(0, "nbExercises", periodStats);
  const onChange = (nextPeriod) => {
    const date = _157.flow(getDatesByPeriod, _157.get("0.min"), (date2) => new Date(date2).toISOString())(nextPeriod);
    setPeriod(nextPeriod);
    onPeriodChange(date);
  };
  return /* @__PURE__ */ jsx189(wrapper_default, { "data-tour": DATA_TOUR.EXERCISES_WRAPPER, children: isLoading ? /* @__PURE__ */ jsx189(skeleton_default3, {}) : /* @__PURE__ */ jsxs149(Fragment56, { children: [
    /* @__PURE__ */ jsxs149("div", { className: src_internals_components_session_stats_index_default.wrapperHeader, children: [
      /* @__PURE__ */ jsx189(progressionPoint_default, { score }),
      /* @__PURE__ */ jsxs149("div", { className: src_internals_components_session_stats_index_default.periodWrapper, children: [
        /* @__PURE__ */ jsx189(
          SelectField10,
          {
            value: period,
            onChange,
            width: "100%",
            options: [
              { value: SESSION_WEEK_PERIOD, label: "Semaine" },
              { value: SESSION_MONTH_PERIOD, label: "Mois" },
              { value: SESSION_YEAR_PERIOD, label: "Depuis le d\xE9but d'ann\xE9e" }
            ]
          }
        ),
        /* @__PURE__ */ jsxs149("div", { className: src_internals_components_session_stats_index_default.period, children: [
          "Du ",
          fromDate,
          " au ",
          toDate
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx189(
      exercisesStats_default,
      {
        className: src_internals_components_session_stats_index_default.exercisesStats,
        stats: periodStats,
        label: nbExercises > 1 ? "Exercices r\xE9alis\xE9s" : "Exercice r\xE9alis\xE9",
        circle: nbExercises,
        period
      }
    ),
    /* @__PURE__ */ jsx189(chartsStats_default, { period, stats, periodStats }),
    /* @__PURE__ */ jsx189(notionsStats_default, { stats })
  ] }) });
};
var stats_default = SessionStats;

// src/internals/components/session/statsTeacher/index.jsx
import { useMemo as useMemo32, useState as useState61 } from "react";
import _163 from "lodash/fp.js";

// src/internals/components/stats/pieChart.jsx
import { useCallback as useCallback63, useMemo as useMemo31 } from "react";
import _158 from "lodash/fp.js";
import { Cell as Cell2, Legend as Legend3, Pie, PieChart, ResponsiveContainer as ResponsiveContainer3, Sector } from "recharts";

// tmp_esbuild1736180050074/_src_internals_components_stats_pieChart.module.css
var src_internals_components_stats_pieChart_default = { "entryLabel": "sk-mIH3bW-entryLabel", "labelContainer": "sk-mIH3bW-labelContainer", "entryColor": "sk-mIH3bW-entryColor", "label": "sk-mIH3bW-label", "statsTeacherSuccessChart": "sk-mIH3bW-statsTeacherSuccessChart", "viewer-fullscreen-modal": "sk-mIH3bW-viewer-fullscreen-modal", "legend": "sk-mIH3bW-legend", "entry": "sk-mIH3bW-entry", "circle": "sk-mIH3bW-circle", "pieChart": "sk-mIH3bW-pieChart" };

// src/internals/components/stats/pieChart.jsx
import { jsx as jsx190, jsxs as jsxs150 } from "react/jsx-runtime";
var map7 = _158.map.convert({ cap: false });
var RADIAN = Math.PI / 180;
var LEGEND_HEIGHT = 100;
var renderCustomizedLabel = ({ value, cx: cx44, cy, innerRadius, outerRadius, midAngle }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
  const x = cx44 + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return /* @__PURE__ */ jsx190(
    "text",
    {
      className: src_internals_components_stats_pieChart_default.label,
      x,
      y,
      fill: "#002E4D",
      textAnchor: x > cx44 ? "start" : "end",
      dominantBaseline: "central",
      children: value || ""
    }
  );
};
var renderActiveShape = ({ cx: cx44, cy, innerRadius, outerRadius, startAngle, endAngle, fill }) => /* @__PURE__ */ jsx190("g", { children: /* @__PURE__ */ jsx190(
  Sector,
  {
    className: "activeShape",
    cx: cx44,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill
  }
) });
var toggleSelectedIndex = (index) => (prevIndex) => _158.includes(index, prevIndex) ? [] : [index];
var renderLegend3 = ({ payload, selectedIndex, setSelectedIndex }) => /* @__PURE__ */ jsx190("div", { className: src_internals_components_stats_pieChart_default.legend, style: { "--s-legend-height": `${LEGEND_HEIGHT}px` }, children: _158.flow(
  map7((entry, index) => {
    const isSelected = _158.includes(index, selectedIndex) || _158.isEmpty(selectedIndex);
    return /* @__PURE__ */ jsxs150("div", { className: src_internals_components_stats_pieChart_default.entry, onClick: () => setSelectedIndex(toggleSelectedIndex(index)), children: [
      /* @__PURE__ */ jsx190(
        "div",
        {
          className: src_internals_components_stats_pieChart_default.entryColor,
          style: { "--s-color": getCellColor({ entry, index, activeIndex: selectedIndex }) }
        }
      ),
      /* @__PURE__ */ jsx190("div", { className: src_internals_components_stats_pieChart_default.labelContainer, children: /* @__PURE__ */ jsx190("div", { className: src_internals_components_stats_pieChart_default.entryLabel, "data-isselected": +isSelected, children: _158.get("payload.label", entry) }) })
    ] }, index);
  })
)(payload) });
var getCellColor = ({ index, entry, activeIndex }) => _158.isEmpty(activeIndex) || _158.first(activeIndex) === index ? _158.get("color", entry) : `var(--index-${index}-color)`;
var SuccessChart = ({ height, hoverIndex, setHoverIndex, selectedIndex, setSelectedIndex, data, labelCenter }) => {
  const onPieEnter = useCallback63(
    (__, index) => {
      setHoverIndex([index]);
    },
    [setHoverIndex]
  );
  const onPieLeave = useCallback63(() => {
    setHoverIndex([]);
  }, [setHoverIndex]);
  const onPieClick = useCallback63(
    (__, index) => {
      setSelectedIndex(toggleSelectedIndex(index));
    },
    [setSelectedIndex]
  );
  const activeIndex = useMemo31(() => _158.flow(_158.concat(selectedIndex), _158.uniq)(hoverIndex), [selectedIndex, hoverIndex]);
  return /* @__PURE__ */ jsx190("div", { className: src_internals_components_stats_pieChart_default.statsTeacherSuccessChart, style: { "--s-height": `${height}px` }, children: /* @__PURE__ */ jsx190(ResponsiveContainer3, { width: "99%", children: /* @__PURE__ */ jsxs150(PieChart, { className: src_internals_components_stats_pieChart_default.pieChart, cursor: "pointer", children: [
    /* @__PURE__ */ jsx190(
      Pie,
      {
        cx: "50%",
        cy: "50%",
        isActiveAnimation: false,
        dataKey: "value",
        data,
        innerRadius: 70,
        outerRadius: 140,
        fill: "#82ca9d",
        labelLine: false,
        onClick: onPieClick,
        onMouseEnter: onPieEnter,
        onMouseOut: onPieLeave,
        activeIndex,
        activeShape: renderActiveShape,
        label: renderCustomizedLabel,
        isAnimationActive: false,
        children: map7(
          (entry, index) => /* @__PURE__ */ jsx190(
            Cell2,
            {
              className: "pie-chart-cell",
              fill: getCellColor({ index, entry, activeIndex })
            },
            `cell-${index}`
          ),
          data
        )
      }
    ),
    /* @__PURE__ */ jsx190(
      "circle",
      {
        className: src_internals_components_stats_pieChart_default.circle,
        cx: "50%",
        cy: `calc(50% - ${LEGEND_HEIGHT / 2}px)`,
        r: 69,
        strokeWidth: "2",
        onClick: () => setSelectedIndex([])
      }
    ),
    /* @__PURE__ */ jsx190(
      "text",
      {
        className: "circle-text",
        x: "50%",
        y: "50%",
        dy: `${-LEGEND_HEIGHT / 2}px`,
        dominantBaseline: "middle",
        textAnchor: "middle",
        children: _158.flow(
          _158.split(" "),
          map7((s, index) => /* @__PURE__ */ jsx190("tspan", { x: "50%", y: "50%", dy: `${-LEGEND_HEIGHT / 2 + index * 20 - 10}px`, children: s }))
        )(labelCenter)
      }
    ),
    /* @__PURE__ */ jsx190(
      Legend3,
      {
        content: renderLegend3,
        selectedIndex,
        setSelectedIndex,
        wrapperStyle: { left: 0, bottom: 0, width: "100%" }
      }
    )
  ] }) }) });
};
var pieChart_default = SuccessChart;

// src/internals/v2/utils/stats.ts
import _159 from "lodash/fp.js";
var getSuccessChartData = ({
  stats,
  selectedStudentIds
}) => {
  const getValue = (section) => makeGetData({
    props: "ratio",
    by: "userId",
    where: (user, userId) => isStudentSelectedBySection({
      user: _159.set("id", _159.parseInt(10, userId), user),
      //@ts-ignore conflit de données entre stats V1 et V2 : à uniformiser
      section,
      selectedStudentIds
    })
  });
  return _159.map((section) => {
    const value = _159.flow(getValue(section), _159.size)(stats);
    return _159.flow(_159.pick(["label", "color", "title", "darkColor", "lightColor"]), _159.set("value", value))(section);
  }, SESSION_RATIO_SECTIONS);
};

// src/internals/components/session/statsTeacher/skeleton.jsx
import _160 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_session_statsTeacher_skeleton.module.css
var src_internals_components_session_statsTeacher_skeleton_default = { "rates": "sk-N6SLRG-rates", "pie": "sk-N6SLRG-pie", "lineText": "sk-N6SLRG-lineText", "nameSkeleton": "sk-N6SLRG-nameSkeleton", "rateSkeleton": "sk-N6SLRG-rateSkeleton", "sectionSkeleton": "sk-N6SLRG-sectionSkeleton", "line": "sk-N6SLRG-line", "dotSkeleton": "sk-N6SLRG-dotSkeleton", "avatarSkeleton": "sk-N6SLRG-avatarSkeleton", "innerPieSkeleton": "sk-N6SLRG-innerPieSkeleton" };

// src/internals/components/session/statsTeacher/skeleton.jsx
import { jsx as jsx191, jsxs as jsxs151 } from "react/jsx-runtime";
var SectionSkeleton = () => /* @__PURE__ */ jsx191("div", { className: src_internals_components_session_statsTeacher_skeleton_default.sectionSkeleton, children: _160.times(
  (i) => /* @__PURE__ */ jsxs151("div", { className: src_internals_components_session_statsTeacher_skeleton_default.line, children: [
    /* @__PURE__ */ jsx191(skeleton_default, { className: src_internals_components_session_statsTeacher_skeleton_default.avatarSkeleton, width: "27px", height: "27px", borderRadius: "50%" }),
    /* @__PURE__ */ jsxs151("div", { className: src_internals_components_session_statsTeacher_skeleton_default.lineText, children: [
      /* @__PURE__ */ jsx191(skeleton_default, { className: src_internals_components_session_statsTeacher_skeleton_default.nameSkeleton, width: "120px", height: "7px" }),
      /* @__PURE__ */ jsx191(skeleton_default, { width: "100px", height: "7px" })
    ] }),
    /* @__PURE__ */ jsx191(skeleton_default, { width: "70px", height: "7px" })
  ] }, i),
  3
) });
var RateSkeleton = () => /* @__PURE__ */ jsxs151("div", { className: src_internals_components_session_statsTeacher_skeleton_default.rateSkeleton, children: [
  /* @__PURE__ */ jsx191(skeleton_default, { width: "100px", height: "20px", borderRadius: "10px" }),
  /* @__PURE__ */ jsx191(skeleton_default, { className: src_internals_components_session_statsTeacher_skeleton_default.dotSkeleton, width: "20px", height: "20px", borderRadius: "50%" })
] });
var ChartSkeleton = () => /* @__PURE__ */ jsxs151("div", { children: [
  /* @__PURE__ */ jsxs151("div", { className: src_internals_components_session_statsTeacher_skeleton_default.pie, children: [
    /* @__PURE__ */ jsx191(skeleton_default, { width: "280px", height: "280px", borderRadius: "50%" }),
    /* @__PURE__ */ jsx191(skeleton_default, { className: src_internals_components_session_statsTeacher_skeleton_default.innerPieSkeleton, width: "125px", height: "125px", borderRadius: "50%" })
  ] }),
  /* @__PURE__ */ jsxs151("div", { className: src_internals_components_session_statsTeacher_skeleton_default.rates, children: [
    /* @__PURE__ */ jsx191(RateSkeleton, {}),
    /* @__PURE__ */ jsx191(RateSkeleton, {}),
    /* @__PURE__ */ jsx191(RateSkeleton, {})
  ] })
] });
var TableSkeleton = () => /* @__PURE__ */ jsxs151("div", { children: [
  /* @__PURE__ */ jsx191(skeleton_default, { width: "100%", height: "40px", borderRadius: "0px" }),
  /* @__PURE__ */ jsx191(SectionSkeleton, {}),
  /* @__PURE__ */ jsx191(skeleton_default, { width: "100%", height: "10px", borderRadius: "0px" }),
  /* @__PURE__ */ jsx191(SectionSkeleton, {})
] });

// src/internals/components/session/statsTeacher/successTable.jsx
import { useCallback as useCallback64, useState as useState60 } from "react";
import { Icon as Icon46, Stamp as Stamp9 } from "@lls/lls-kit";
import _162 from "lodash/fp.js";
import { cx as cx41 } from "@lls/utils";

// src/internals/components/session/statsTeacher/header.jsx
import { ChipSelect as ChipSelect3 } from "@lls/lls-kit";
import _161 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_session_statsTeacher_header.module.css
var src_internals_components_session_statsTeacher_header_default = { "sessionStatsGroupSetting": "sk-bJAnbG-sessionStatsGroupSetting", "header": "sk-bJAnbG-header", "viewer-fullscreen-modal": "sk-bJAnbG-viewer-fullscreen-modal", "headertopTitle": "sk-bJAnbG-headertopTitle" };

// src/internals/components/session/statsTeacher/header.jsx
import { jsx as jsx192, jsxs as jsxs152 } from "react/jsx-runtime";
var SessionStatsTeacherHeader = ({ onOpenGroupsSettings, groups, selectedGroupIds, setSelectedGroupIds }) => {
  const noGroups = _161.isEmpty(groups);
  const toggleGroup = (newSelectedOption) => setSelectedGroupIds(_161.isNil(newSelectedOption) ? [] : [_161.get("value", newSelectedOption)]);
  const selectedOption = _161.flow(
    _161.first,
    (id) => _161.find({ id }, groups),
    (selectedGroup) => _161.isNil(selectedGroup) ? void 0 : {
      value: _161.get("id", selectedGroup),
      label: _161.get("name", selectedGroup)
    }
  )(selectedGroupIds);
  const options = _161.map((group) => {
    const value = _161.get("id", group);
    const label = _161.get("name", group);
    return { value, label, ...group };
  }, groups);
  return /* @__PURE__ */ jsxs152("div", { className: src_internals_components_session_statsTeacher_header_default.header, children: [
    /* @__PURE__ */ jsx192("div", { className: "sessionstats-headertop", children: /* @__PURE__ */ jsx192("div", { className: src_internals_components_session_statsTeacher_header_default.headertopTitle, children: "\xC9l\xE8ves" }) }),
    /* @__PURE__ */ jsxs152("div", { className: "sessionstats-headertop-filter-container", children: [
      /* @__PURE__ */ jsx192("div", { className: "sessionstats-headertop-filters", "data-nogroups": +noGroups, children: noGroups ? /* @__PURE__ */ jsx192("div", { className: "sessionstats-headertop-emptygroup", children: "Vous n'avez pas de classe" }) : /* @__PURE__ */ jsx192("div", { className: "sessionstats-headertop-grouplist", children: /* @__PURE__ */ jsx192(
        ChipSelect3,
        {
          options,
          selectedOption,
          onChange: toggleGroup,
          label: "Filtrer par classe"
        }
      ) }) }),
      /* @__PURE__ */ jsx192("div", { className: "sessionstats-headertop-separator" }),
      /* @__PURE__ */ jsx192("div", { className: src_internals_components_session_statsTeacher_header_default.sessionStatsGroupSetting, tabIndex: 0, role: "button", onClick: onOpenGroupsSettings, children: "G\xE9rer les classes" })
    ] })
  ] });
};
var header_default5 = SessionStatsTeacherHeader;

// tmp_esbuild1736180050074/_src_internals_components_session_statsTeacher_successTable.module.css
var src_internals_components_session_statsTeacher_successTable_default = { "header": "sk-i1Ldzq-header", "viewer-fullscreen-modal": "sk-i1Ldzq-viewer-fullscreen-modal", "sessionStatsLabel": "sk-i1Ldzq-sessionStatsLabel", "sessionStatsName": "sk-i1Ldzq-sessionStatsName", "sessionStatsNbExercises": "sk-i1Ldzq-sessionStatsNbExercises", "successTable": "sk-i1Ldzq-successTable", "avatar": "sk-i1Ldzq-avatar" };

// src/internals/components/session/statsTeacher/successTable.jsx
import { Fragment as Fragment57, jsx as jsx193, jsxs as jsxs153 } from "react/jsx-runtime";
var map8 = _162.map.convert({ cap: false });
var Avatar = () => /* @__PURE__ */ jsx193("svg", { className: src_internals_components_session_statsTeacher_successTable_default.avatar, focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", children: /* @__PURE__ */ jsx193(
  "path",
  {
    fill: "currentColor",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
  }
) });
var Line = ({ user, themeStamp, stats, students }) => {
  const [showDetail, setShowDetail] = useState60(false);
  const studentId = _162.get("id", user);
  const student = _162.find({ id: _162.parseInt(10, studentId) }, students);
  const firstname = _162.get("firstname", student);
  const lastname = _162.get("lastname", student);
  const getUserInfos = makeGetData({
    props: ["nbExercises", "ratio"],
    by: "userId",
    where: (_user, id) => id === studentId
  });
  const nbExercises = _162.flow(getUserInfos, _162.get("0.nbExercises"))(stats);
  const ratio = _162.flow(getUserInfos, _162.get("0.ratio"), formatPercent)(stats);
  const getUserRatioAndNbExerciseByNotion = makeGetData({
    props: ["ratio", "nbExercises"],
    by: "userId.notion",
    where: (_value, key, entityName) => entityName === "userId" ? key === studentId : true
  });
  const notions = _162.flow(getUserRatioAndNbExerciseByNotion, _162.get("0.notion"))(stats);
  const toggleShowDetail = useCallback64(() => {
    setShowDetail((prev) => !prev);
  }, []);
  return /* @__PURE__ */ jsxs153(Fragment57, { children: [
    /* @__PURE__ */ jsxs153("tr", { className: "sessionstats-tr", children: [
      /* @__PURE__ */ jsx193("td", { className: "sessionstats-td", children: /* @__PURE__ */ jsx193(Avatar, {}) }),
      /* @__PURE__ */ jsx193("td", { className: "sessionstats-td flex-grow", children: /* @__PURE__ */ jsxs153("div", { className: "sessionstats-info", children: [
        /* @__PURE__ */ jsxs153("div", { className: src_internals_components_session_statsTeacher_successTable_default.sessionStatsName, children: [
          firstname,
          " ",
          lastname
        ] }),
        /* @__PURE__ */ jsxs153("div", { className: src_internals_components_session_statsTeacher_successTable_default.sessionStatsNbExercises, children: [
          "\u2014 ",
          nbExercises,
          " ",
          handlePlural("exercice", nbExercises)
        ] })
      ] }) }),
      /* @__PURE__ */ jsx193("td", { className: "sessionstats-td", children: /* @__PURE__ */ jsx193(Stamp9, { theme: themeStamp, children: ratio }) }),
      /* @__PURE__ */ jsx193("td", { className: "sessionstats-td pointer", onClick: toggleShowDetail, children: /* @__PURE__ */ jsx193(Icon46, { className: "chevron", name: showDetail ? "chevronup" : "chevrondown" }) })
    ] }),
    showDetail && map8((notion, index) => {
      const nbNotionExercices = _162.get("nbExercises", notion);
      return /* @__PURE__ */ jsxs153("tr", { className: "sessionstats-tr_detail", children: [
        /* @__PURE__ */ jsx193("td", { className: "sessionstats-td flex-grow", children: /* @__PURE__ */ jsxs153("div", { className: "sessionstats-info", children: [
          /* @__PURE__ */ jsx193("div", { className: src_internals_components_session_statsTeacher_successTable_default.sessionStatsName, children: _162.get("id", notion) }),
          /* @__PURE__ */ jsxs153("div", { className: src_internals_components_session_statsTeacher_successTable_default.sessionStatsNbExercises, children: [
            "\u2014 ",
            nbNotionExercices,
            " ",
            handlePlural("exercice", nbNotionExercices)
          ] })
        ] }) }),
        /* @__PURE__ */ jsx193("td", { className: "sessionstats-td", children: /* @__PURE__ */ jsx193(Stamp9, { theme: `light-${themeStamp}`, children: _162.flow(_162.get("ratio"), formatPercent)(notion) }) })
      ] }, index);
    }, notions)
  ] });
};
var Section = ({ section, stats, students, isSelected, selectedStudentIds }) => {
  const label = _162.get("label", section);
  const color = _162.get("color", section);
  const themeStamp = _162.get("themeStamp", section);
  const getUsers = makeGetData({
    props: "ratio",
    by: "userId",
    where: (user, userId) => isStudentSelectedBySection({
      user: _162.set("id", _162.parseInt(10, userId), user),
      section,
      selectedStudentIds
    })
  });
  const lines = getUsers(stats);
  if (!isSelected || _162.isEmpty(lines)) return null;
  return /* @__PURE__ */ jsxs153("table", { className: "sessionstats-table", children: [
    /* @__PURE__ */ jsx193("thead", { style: { "--s-color": `${color}` }, className: cx41("sessionstats-header", src_internals_components_session_statsTeacher_successTable_default.header), children: /* @__PURE__ */ jsx193("div", { className: src_internals_components_session_statsTeacher_successTable_default.sessionStatsLabel, children: label }) }),
    /* @__PURE__ */ jsx193("tbody", { className: "sessionstats-body", children: _162.flow(
      _162.orderBy("ratio", "desc"),
      map8((user, index) => /* @__PURE__ */ jsx193(Line, { user, themeStamp, stats, students, color }, index))
    )(lines) })
  ] });
};
var EmptyStats = () => /* @__PURE__ */ jsxs153("div", { className: "sessionstats-emptystats", children: [
  /* @__PURE__ */ jsx193("div", { className: "sessionstats-emptystats-title", children: "Pas de statistiques" }),
  /* @__PURE__ */ jsx193("div", { children: "Invitez vos \xE9l\xE8ves \xE0 r\xE9viser pour suivre leurs progr\xE8s !" })
] });
var SuccessTable = ({
  stats,
  students,
  groups,
  height,
  selectedIndex,
  onOpenGroupsSettings,
  selectedGroupIds,
  setSelectedGroupIds,
  selectedStudentIds
}) => /* @__PURE__ */ jsxs153("div", { className: src_internals_components_session_statsTeacher_successTable_default.successTable, style: { "--s-height": `${height}px` }, children: [
  /* @__PURE__ */ jsx193(
    header_default5,
    {
      onOpenGroupsSettings,
      groups,
      selectedGroupIds,
      setSelectedGroupIds
    }
  ),
  _162.flow(_162.get("userId"), _162.isEmpty)(stats) ? /* @__PURE__ */ jsx193(EmptyStats, {}) : /* @__PURE__ */ jsx193("div", { className: "sessionstats-section", children: _162.flow(
    _162.reverse,
    map8((section, index) => {
      const reverseIndex = _162.size(SESSION_RATIO_SECTIONS) - 1 - index;
      return /* @__PURE__ */ jsx193(
        Section,
        {
          isSelected: _162.isEmpty(selectedIndex) || _162.includes(reverseIndex, selectedIndex),
          stats,
          section,
          students,
          selectedStudentIds
        },
        index
      );
    })
  )(SESSION_RATIO_SECTIONS) })
] });
var successTable_default = SuccessTable;

// tmp_esbuild1736180050074/_src_internals_components_session_statsTeacher_index.module.css
var src_internals_components_session_statsTeacher_index_default = { "viewer-fullscreen-modal": "sk-zbE1bq-viewer-fullscreen-modal", "container": "sk-zbE1bq-container", "pieChart": "sk-zbE1bq-pieChart", "col": "sk-zbE1bq-col" };

// src/internals/components/session/statsTeacher/index.jsx
import { jsx as jsx194, jsxs as jsxs154 } from "react/jsx-runtime";
var HEIGHT = 800;
var PIECHART_HEIGHT = 500;
var Skeleton2 = () => /* @__PURE__ */ jsxs154("div", { className: src_internals_components_session_statsTeacher_index_default.container, children: [
  /* @__PURE__ */ jsx194("div", { className: src_internals_components_session_statsTeacher_index_default.col, children: /* @__PURE__ */ jsx194(ChartSkeleton, {}) }),
  /* @__PURE__ */ jsx194("div", { className: src_internals_components_session_statsTeacher_index_default.col, children: /* @__PURE__ */ jsx194(TableSkeleton, {}) })
] });
var SessionStatsTeacher = ({ onOpenGroupsSettings, stats, students, groups, isLoading, isDrawerOpen = false }) => {
  const [selectedIndex, setSelectedIndex] = useState61([]);
  const [hoverIndex, setHoverIndex] = useState61([]);
  const [selectedGroupIds, setSelectedGroupIds] = useState61([]);
  const selectedStudentIds = useMemo32(() => {
    return getSelectedStudentIds(groups, selectedGroupIds);
  }, [selectedGroupIds, groups]);
  const data = getSuccessChartData({ stats, selectedStudentIds });
  const totalValue = _163.sumBy("value", data);
  return /* @__PURE__ */ jsx194(wrapper_default, { children: isLoading ? /* @__PURE__ */ jsx194(Skeleton2, {}) : /* @__PURE__ */ jsxs154("div", { className: src_internals_components_session_statsTeacher_index_default.container, "data-drawer-open": +isDrawerOpen, children: [
    /* @__PURE__ */ jsx194("div", { className: src_internals_components_session_statsTeacher_index_default.col, children: /* @__PURE__ */ jsxs154("div", { className: "stats-teacher-container-piechart", "data-drawer-open": +isDrawerOpen, children: [
      /* @__PURE__ */ jsx194("div", { className: src_internals_components_session_statsTeacher_index_default.pieChart, children: "Vue d'ensemble des r\xE9sultats des \xE9l\xE8ves" }),
      /* @__PURE__ */ jsx194(
        pieChart_default,
        {
          height: PIECHART_HEIGHT,
          hoverIndex,
          setHoverIndex,
          selectedIndex,
          setSelectedIndex,
          data,
          labelCenter: `${totalValue} ${handlePlural("\xE9l\xE8ve", totalValue)}`
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx194("div", { className: src_internals_components_session_statsTeacher_index_default.col, children: /* @__PURE__ */ jsx194(
      successTable_default,
      {
        selectedIndex,
        height: HEIGHT,
        stats,
        students,
        groups,
        onOpenGroupsSettings,
        selectedGroupIds,
        setSelectedGroupIds,
        selectedStudentIds
      }
    ) })
  ] }) });
};
var statsTeacher_default = SessionStatsTeacher;

// tmp_esbuild1736180050074/_src_internals_components_session_index.module.css
var src_internals_components_session_index_default = { "sessionFirstBackground": "sk-C8rEra-sessionFirstBackground", "sessionSecondBackground": "sk-C8rEra-sessionSecondBackground", "session": "sk-C8rEra-session", "div": "sk-C8rEra-div kit-themecss", "viewer-fullscreen-modal": "sk-C8rEra-viewer-fullscreen-modal", "container": "sk-C8rEra-container", "exerciseWrapper": "sk-C8rEra-exerciseWrapper" };

// src/internals/components/session/index.jsx
import { jsx as jsx195, jsxs as jsxs155 } from "react/jsx-runtime";
var Session = ({
  viewerElement,
  user,
  color,
  stats,
  isLoadingStats,
  onOpenGroupsSettings,
  students,
  groups,
  setSelectedTab,
  selectedTab,
  onPeriodChange,
  score,
  isSessionEnded,
  setIsSessionEnded,
  isDrawerOpen,
  isDysMode,
  sizeIndex,
  fontFamily,
  template,
  isDarkMode
}) => {
  const isTeacher2 = _164.matchesProperty("isTeacher", true)(user);
  const sessionTabs = useMemo33(() => getTabs(isTeacher2), [isTeacher2]);
  const startANewSession = useCallback65(() => {
    setIsSessionEnded(false);
  }, [setIsSessionEnded]);
  return /* @__PURE__ */ jsxs155(
    "div",
    {
      className: cx42(
        `lls-viewer-builder-session ${isDarkMode ? `${SUPERKIT_CLASSNAME_DARK_THEME} ${KIT_CLASSNAME_DARK_THEME8}` : `${SUPERKIT_CLASSNAME_LIGHT_THEME} ${KIT_CLASSNAME_LIGHT_THEME12}`}`,
        src_internals_components_session_index_default.div
      ),
      "data-tour": DATA_TOUR.SESSION,
      style: styleThemeProps3({ isDysMode, sizeIndex, fontFamily }),
      children: [
        /* @__PURE__ */ jsx195(header_default4, { template }),
        /* @__PURE__ */ jsxs155("div", { className: src_internals_components_session_index_default.session, children: [
          /* @__PURE__ */ jsxs155("div", { className: src_internals_components_session_index_default.container, children: [
            /* @__PURE__ */ jsx195(sessionTabs_default, { selectedTab, onSelectTab: setSelectedTab, sessionTabs }),
            /* @__PURE__ */ jsx195("div", { className: src_internals_components_session_index_default.exerciseWrapper, "data-is-exercise-tab": +(selectedTab !== SESSION_EXERCISE_TAB), children: /* @__PURE__ */ jsx195(
              exercise_default,
              {
                viewerElement,
                color,
                isSessionEnded,
                startANewSession,
                stats,
                isLoading: isLoadingStats
              }
            ) }),
            selectedTab === SESSION_STATS_TAB && /* @__PURE__ */ jsx195(
              stats_default,
              {
                score,
                stats,
                isLoading: isLoadingStats,
                color,
                onPeriodChange
              }
            ),
            selectedTab === SESSION_STATS_TEACHER_TAB && /* @__PURE__ */ jsx195(
              statsTeacher_default,
              {
                onOpenGroupsSettings,
                stats,
                students,
                groups,
                isLoading: isLoadingStats,
                isDrawerOpen
              }
            )
          ] }),
          /* @__PURE__ */ jsx195("div", { className: src_internals_components_session_index_default.sessionFirstBackground }),
          /* @__PURE__ */ jsx195("div", { className: src_internals_components_session_index_default.sessionSecondBackground })
        ] })
      ]
    }
  );
};
var session_default = Session;

// src/internals/hooks/useContextualActions.ts
import _165 from "lodash/fp.js";
import { useEffect as useEffect28 } from "react";
var useContextualActions = ({
  page,
  areShownContextualActions = false,
  setShownContextualActions = _165.noop
}) => {
  const oldPage = usePrevious_default(page);
  useEffect28(() => {
    if (page == null ? void 0 : page.isDraft) {
      setShownContextualActions(true);
    }
  }, [page, setShownContextualActions]);
  useEffect28(() => {
    if (!(page == null ? void 0 : page.isDraft) && shouldHideContextualActions({ page, oldPage })) {
      setShownContextualActions(false);
    }
  }, [page, oldPage, setShownContextualActions]);
  return { areShownContextualActions };
};
var useContextualActions_default = useContextualActions;

// src/internals/hooks/useAccessibilityState.ts
import _166 from "lodash/fp.js";
import { useCallback as useCallback66, useEffect as useEffect29, useState as useState62 } from "react";
var DEFAULT_ACCESSIBILITY_STATE = {
  sizeIndex: 2,
  fontFamily: "LatoWeb",
  isDarkMode: false,
  isDysMode: false,
  areQuestionsHidden: false
};
var useAccessibilityState = ({
  currentUserId,
  accessibilityCookie
}) => {
  const [accessibilityState, setAccessibilityState] = useState62(
    _166.assign(DEFAULT_ACCESSIBILITY_STATE, _166.get(currentUserId, accessibilityCookie))
  );
  useEffect29(() => {
    if (currentUserId && !_166.has(currentUserId, accessibilityCookie)) {
      setAccessibilityState(DEFAULT_ACCESSIBILITY_STATE);
    }
  }, [currentUserId, accessibilityCookie]);
  const handleAccessibilityChange = useCallback66((newState) => {
    setAccessibilityState(
      (oldState) => _166.isEqual({ ...oldState, ...newState }, oldState) ? oldState : { ...oldState, ...newState }
    );
  }, []);
  return { accessibilityState, handleAccessibilityChange };
};
var useAccessibilityState_default = useAccessibilityState;

// src/internals/components/profile/index.tsx
import { useState as useState64 } from "react";
import { Tab as Tab6, Tabs as Tabs6 } from "@lls/lls-kit";

// src/internals/components/profile/communicationTab.tsx
import { Button as Button84 } from "@lls/lls-kit";

// src/internals/components/profile/common.jsx
import { makeComponent as makeComponent11 } from "@lls/utils";

// tmp_esbuild1736180050074/_src_internals_components_profile_common.module.css
var src_internals_components_profile_common_default = { "title": "sk-8LJ5qq-title", "fieldContainer": "sk-8LJ5qq-fieldContainer", "tabContainer": "sk-8LJ5qq-tabContainer", "formContainer": "sk-8LJ5qq-formContainer" };

// src/internals/components/profile/common.jsx
var StyledTabContainer = makeComponent11("div", src_internals_components_profile_common_default.tabContainer);
var StyledTitle6 = makeComponent11("h2", src_internals_components_profile_common_default.title);
var StyledFormContainer = makeComponent11("div", src_internals_components_profile_common_default.formContainer);
var StyledFieldContainer = makeComponent11("div", src_internals_components_profile_common_default.fieldContainer);

// tmp_esbuild1736180050074/_src_internals_components_profile_communicationTab.module.css
var src_internals_components_profile_communicationTab_default = { "clickable": "sk-K892Va-clickable", "noMarginButton": "sk-K892Va-noMarginButton", "paragraph": "sk-K892Va-paragraph" };

// src/internals/components/profile/communicationTab.tsx
import { Fragment as Fragment58, jsx as jsx196, jsxs as jsxs156 } from "react/jsx-runtime";
var CommunicationTab = ({
  onSubscribeClick,
  onNavigateToProfile,
  visible,
  hasUnsubscribed
}) => {
  return /* @__PURE__ */ jsx196(StyledTabContainer, { "data-visible": +visible, children: /* @__PURE__ */ jsxs156(Fragment58, { children: [
    /* @__PURE__ */ jsx196(StyledTitle6, { children: "Vos pr\xE9f\xE9rences de communication" }),
    /* @__PURE__ */ jsxs156("p", { className: src_internals_components_profile_communicationTab_default.paragraph, children: [
      "Vos pr\xE9f\xE9rences de communication sont adapt\xE9es aux informations de votre profil. Mettez \xE0 jour",
      " ",
      /* @__PURE__ */ jsx196("span", { className: src_internals_components_profile_communicationTab_default.clickable, onClick: onNavigateToProfile, children: "votre profil" }),
      " ",
      "pour recevoir des ressources pertinentes."
    ] }),
    /* @__PURE__ */ jsx196(
      Button84,
      {
        className: src_internals_components_profile_communicationTab_default.noMarginButton,
        onClick: () => onSubscribeClick(!!hasUnsubscribed),
        theme: hasUnsubscribed ? "yellow" : "error",
        children: hasUnsubscribed ? "S'abonner \xE0 la newsletter" : "Se d\xE9sabonner de toutes les communications"
      }
    )
  ] }) });
};
var communicationTab_default = CommunicationTab;

// tmp_esbuild1736180050074/_src_internals_components_profile_index.module.css
var src_internals_components_profile_index_default = { "card": "sk-VdJkka-card", "tabs": "sk-VdJkka-tabs", "tab": "sk-VdJkka-tab" };

// src/internals/components/profile/passwordTab.tsx
import { Button as Button85 } from "@lls/lls-kit";
import { useForm as useForm2 } from "react-hook-form";

// src/internals/components/form/password.tsx
import { TextField as TextField10 } from "@lls/lls-kit";
import { isValidPassword } from "@lls/utils";
import { Controller as Controller2 } from "react-hook-form";
import { jsx as jsx197 } from "react/jsx-runtime";
var Password = ({
  control,
  width,
  name = "password",
  label = "Mot de passe",
  error = false,
  required,
  requiredLabel = "Mot de passe requis",
  errorMessage,
  validate,
  autoComplete,
  ...props
}) => /* @__PURE__ */ jsx197(
  Controller2,
  {
    rules: {
      ...required ? { required: requiredLabel } : {},
      ...validate ? {
        validate: (value) => isValidPassword(value) || "Votre mot de passe doit \xEAtre de 6 caract\xE8res minimum et contenir des lettres et des chiffres."
      } : {}
    },
    render: ({ field }) => /* @__PURE__ */ jsx197(
      TextField10,
      {
        width,
        type: "password",
        label,
        state: error ? "error" : void 0,
        hint: errorMessage,
        autoComplete,
        ...props,
        ...field
      }
    ),
    name,
    control
  }
);
var password_default = Password;

// tmp_esbuild1736180050074/_src_internals_components_profile_passwordTab.module.css
var src_internals_components_profile_passwordTab_default = { "formContainer": "sk-3hnWCG-formContainer", "passwordForm": "sk-3hnWCG-passwordForm" };

// src/internals/components/profile/passwordTab.tsx
import { jsx as jsx198, jsxs as jsxs157 } from "react/jsx-runtime";
var PasswordTab = ({ visible, onUpdatePassword }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { control, handleSubmit, formState, setError, reset } = useForm2({
    defaultValues: {
      currentPassword: "",
      password1: "",
      password2: ""
    }
  });
  const submit = async (form) => {
    if (form.password1 !== form.password2) {
      setError("password1", { message: "Les mots de passe saisis ne correspondent pas" });
      setError("password2", { message: "Les mots de passe saisis ne correspondent pas" });
      return;
    }
    await onUpdatePassword({ oldPassword: form.currentPassword, password: form.password1 });
    reset();
  };
  return /* @__PURE__ */ jsxs157(StyledTabContainer, { "data-visible": +visible, children: [
    /* @__PURE__ */ jsx198(StyledTitle6, { children: "Changer de mot de passe" }),
    /* @__PURE__ */ jsx198(StyledFormContainer, { className: src_internals_components_profile_passwordTab_default.formContainer, children: /* @__PURE__ */ jsxs157("form", { onSubmit: handleSubmit(submit), className: src_internals_components_profile_passwordTab_default.passwordForm, children: [
      /* @__PURE__ */ jsx198(StyledFieldContainer, { children: /* @__PURE__ */ jsx198(
        password_default,
        {
          name: "currentPassword",
          label: "Mot de passe actuel",
          control,
          errorMessage: (_b = (_a = formState.errors) == null ? void 0 : _a.currentPassword) == null ? void 0 : _b.message,
          error: !!((_c = formState.errors) == null ? void 0 : _c.currentPassword),
          required: true,
          requiredLabel: "Veuillez saisir votre mot de passe actuel"
        }
      ) }),
      /* @__PURE__ */ jsx198(StyledFieldContainer, { children: /* @__PURE__ */ jsx198(
        password_default,
        {
          name: "password1",
          label: "Nouveau mot de passe",
          control,
          errorMessage: (_e = (_d = formState.errors) == null ? void 0 : _d.password1) == null ? void 0 : _e.message,
          error: !!((_f = formState.errors) == null ? void 0 : _f.password1),
          required: true,
          requiredLabel: "Veuillez saisir votre nouveau mot de passe",
          autoComplete: "off",
          validate: true
        }
      ) }),
      /* @__PURE__ */ jsx198(StyledFieldContainer, { children: /* @__PURE__ */ jsx198(
        password_default,
        {
          name: "password2",
          label: "Confirmer le nouveau mot de passe",
          control,
          errorMessage: (_h = (_g = formState.errors) == null ? void 0 : _g.password2) == null ? void 0 : _h.message,
          error: !!((_i = formState.errors) == null ? void 0 : _i.password2),
          required: true,
          requiredLabel: "Veuillez confirmer votre nouveau mot de passe",
          autoComplete: "off",
          validate: true
        }
      ) }),
      /* @__PURE__ */ jsx198(Button85, { type: "submit", children: "Enregistrer le nouveau mot de passe" })
    ] }) })
  ] });
};
var passwordTab_default = PasswordTab;

// src/internals/components/profile/personalInfosTab.tsx
import _174 from "lodash/fp.js";
import { useForm as useForm3 } from "react-hook-form";
import { Button as Button86, Divider as Divider16 } from "@lls/lls-kit";
import { canUpdateSchools, pipe as pipe4, useLevelFiltersForm } from "@lls/utils";

// src/internals/components/form/email.tsx
import { TextField as TextField11 } from "@lls/lls-kit";
import { Controller as Controller3 } from "react-hook-form";
import { jsx as jsx199 } from "react/jsx-runtime";
var Email = ({
  control,
  error = false,
  label = "E-mail",
  name = "email",
  required = true,
  ...props
}) => /* @__PURE__ */ jsx199(
  Controller3,
  {
    render: ({ field }) => /* @__PURE__ */ jsx199(TextField11, { label, required, state: error ? "error" : void 0, ...props, ...field }),
    rules: {
      required: required ? {
        value: true,
        message: "Email obligatoire"
      } : void 0,
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Email incorrect"
      }
    },
    name,
    control
  }
);
var email_default = Email;

// src/internals/components/form/firstname.tsx
import { TextField as TextField12 } from "@lls/lls-kit";
import { Controller as Controller4 } from "react-hook-form";
import { jsx as jsx200 } from "react/jsx-runtime";
var Firstname = ({
  control,
  name = "firstname",
  label = "Pr\xE9nom",
  error = false,
  required,
  ...props
}) => /* @__PURE__ */ jsx200(
  Controller4,
  {
    rules: required ? { required: "Le pr\xE9nom est obligatoire" } : void 0,
    render: ({ field }) => /* @__PURE__ */ jsx200(TextField12, { required, label, state: error ? "error" : void 0, ...props, ...field }),
    name,
    control
  }
);
var firstname_default = Firstname;

// src/internals/components/form/functionsTeacher.tsx
import { SelectField as SelectField11 } from "@lls/lls-kit";
import _167 from "lodash/fp.js";
import { Controller as Controller5 } from "react-hook-form";
import { jsx as jsx201 } from "react/jsx-runtime";
var FUNCTIONS = [
  "Professeur",
  "Chef d'\xE9tablissement",
  "\xC9tudiant (MEEF, IUFM)",
  "Gestionnaire",
  "Inspecteur",
  "Parent d'\xE9l\xE8ve",
  "R\xE9f\xE9rent num\xE9rique"
];
var FunctionsTeacher = ({ control, label = "Fonction(s)", error, ...props }) => /* @__PURE__ */ jsx201(
  Controller5,
  {
    name: "functions",
    control,
    render: ({ field }) => /* @__PURE__ */ jsx201(
      SelectField11,
      {
        label,
        multiple: true,
        listMaxHeight: "200px",
        state: error ? "error" : void 0,
        options: _167.map(
          (f) => ({
            value: f,
            label: f
          }),
          FUNCTIONS
        ),
        ...field,
        ...props
      }
    )
  }
);
var functionsTeacher_default = FunctionsTeacher;

// src/internals/components/form/lastname.tsx
import { TextField as TextField13 } from "@lls/lls-kit";
import { Controller as Controller6 } from "react-hook-form";
import { jsx as jsx202 } from "react/jsx-runtime";
var Lastname = ({
  control,
  name = "lastname",
  label = "Nom de famille",
  error = false,
  required,
  ...props
}) => /* @__PURE__ */ jsx202(
  Controller6,
  {
    rules: required ? { required: "Le nom est obligatoire" } : void 0,
    render: ({ field }) => /* @__PURE__ */ jsx202(TextField13, { required, label, state: error ? "error" : void 0, ...props, ...field }),
    name,
    control
  }
);
var lastname_default = Lastname;

// src/internals/components/form/levels.tsx
import { SelectField as SelectField12 } from "@lls/lls-kit";
import { Controller as Controller7 } from "react-hook-form";
import { jsx as jsx203 } from "react/jsx-runtime";
var Levels = ({ control, label = "Classe", levels, error, required = true, ...props }) => {
  const options = levels == null ? void 0 : levels.map((level) => ({
    value: level.id,
    label: level.name
  }));
  return /* @__PURE__ */ jsx203(
    Controller7,
    {
      name: "levels",
      rules: required ? { required: "Classe obligatoire" } : {},
      control,
      render: ({ field }) => /* @__PURE__ */ jsx203(
        SelectField12,
        {
          label,
          required,
          listMaxHeight: "200px",
          state: error ? "error" : void 0,
          options,
          multiple: true,
          ...props,
          ...field
        }
      )
    }
  );
};
var levels_default = Levels;

// src/internals/components/form/schoolTypes.tsx
import { SelectField as SelectField13 } from "@lls/lls-kit";
import _168 from "lodash/fp.js";
import { Controller as Controller8 } from "react-hook-form";
import { jsx as jsx204 } from "react/jsx-runtime";
var SchoolTypes = ({
  control,
  label = "Type d\u2019\xE9tablissement",
  schoolTypes,
  error,
  valueProp = "name",
  valueFunction = _168.identity,
  required = true,
  ...props
}) => {
  const options = _168.flow(
    _168.sortBy("order"),
    _168.map((schoolType) => ({
      value: valueFunction(schoolType == null ? void 0 : schoolType[valueProp]),
      label: schoolType == null ? void 0 : schoolType.name
    }))
  )(schoolTypes);
  return /* @__PURE__ */ jsx204(
    Controller8,
    {
      name: "schoolTypes",
      rules: required ? { required: "Type d\u2019\xE9tablissement obligatoire" } : {},
      control,
      render: ({ field }) => /* @__PURE__ */ jsx204(
        SelectField13,
        {
          label,
          listMaxHeight: "200px",
          state: error ? "error" : void 0,
          options,
          required,
          ...props,
          ...field
        }
      )
    }
  );
};
var schoolTypes_default = SchoolTypes;

// src/internals/components/form/schoolsSelector.tsx
import { cx as cx43, useDidUpdate } from "@lls/utils";

// src/internals/utils/form.ts
import _169 from "lodash/fp.js";
var hasError = ({ fieldName, formState }) => _169.has(fieldName, formState.errors);
var getHint = ({ fieldName, formState }) => _169.get(`errors.${fieldName}.message`, formState);
var hasNoError = _169.negate(hasError);
var isDirty = ({ fieldName, formState }) => _169.flow(_169.get(`dirtyFields.${fieldName}`), _169.isEqual(true))(formState);
var isClean = _169.negate(isDirty);
var isDirtyAndWithoutError = (fieldName, formState) => _169.overEvery([isDirty, hasNoError])({ fieldName, formState });

// src/internals/components/form/schoolsSelector.tsx
import _172 from "lodash/fp.js";
import { useCallback as useCallback67, useEffect as useEffect30, useRef as useRef16, useState as useState63 } from "react";
import { useWatch } from "react-hook-form";

// src/internals/components/form/departments.tsx
import { SelectField as SelectField14 } from "@lls/lls-kit";
import { departments, displayDepartment } from "@lls/utils";
import _170 from "lodash/fp.js";
import { Controller as Controller9 } from "react-hook-form";
import { jsx as jsx205 } from "react/jsx-runtime";
var Departments = ({
  control,
  name = "departments",
  label = "D\xE9partement",
  filterFn = _170.identity,
  multiple,
  error,
  required,
  listMaxHeight = "200px",
  ...props
}) => /* @__PURE__ */ jsx205(
  Controller9,
  {
    rules: required ? { required: "Obligatoire pour s\xE9lectionner un \xE9tablissement" } : void 0,
    name,
    control,
    render: ({ field }) => /* @__PURE__ */ jsx205(
      SelectField14,
      {
        searchable: true,
        multiple,
        label,
        required,
        listMaxHeight,
        state: error ? "error" : void 0,
        ...props,
        options: _170.flow(
          _170.filter(filterFn),
          _170.sortBy("zipcode"),
          _170.map((department) => ({
            value: _170.get("zipcode", department),
            label: displayDepartment(department)
          }))
        )(departments),
        ...field
      }
    )
  }
);
var departments_default = Departments;

// tmp_esbuild1736180050074/_src_internals_components_form_index.module.css
var src_internals_components_form_index_default = { "schoolsSelectorContainer": "sk-8lvDeq-schoolsSelectorContainer", "required": "sk-8lvDeq-required", "label": "sk-8lvDeq-label", "radioGroup": "sk-8lvDeq-radioGroup" };

// src/internals/components/form/schools.tsx
import { SelectField as SelectField15 } from "@lls/lls-kit";
import { displaySchool, groupSchoolByCity } from "@lls/utils";
import _171 from "lodash/fp.js";
import { Controller as Controller10 } from "react-hook-form";
import { jsx as jsx206 } from "react/jsx-runtime";
var Schools = ({
  label = "\xC9tablissement",
  schools,
  control,
  multiple,
  error,
  schoolValue = "id",
  name = "schools",
  listMaxHeight = "200px",
  required,
  ...props
}) => /* @__PURE__ */ jsx206(
  Controller10,
  {
    rules: required ? { required: "\xC9tablissement scolaire obligatoire" } : void 0,
    name,
    control,
    render: ({ field }) => /* @__PURE__ */ jsx206(
      SelectField15,
      {
        searchable: true,
        multiple,
        label,
        required,
        listMaxHeight,
        state: error ? "error" : void 0,
        ...props,
        stringifyFunction: (option) => {
          var _a;
          return `${option.label} ${option.value} ${(_a = option.data) == null ? void 0 : _a.rne}`;
        },
        options: _171.flow(
          groupSchoolByCity,
          _171.toPairs,
          _171.map(([city, sortedSchools]) => ({
            label: city,
            options: _171.map(
              (school) => ({
                value: _171.get(schoolValue, school),
                label: displaySchool(school),
                group: city,
                rne: school.rne
              }),
              sortedSchools
            )
          }))
        )(schools),
        ...field
      }
    )
  }
);
var schools_default = Schools;

// src/internals/components/form/schoolsSelector.tsx
import { jsx as jsx207, jsxs as jsxs158 } from "react/jsx-runtime";
var SchoolsSelector = ({
  className,
  control,
  defaultSchools = [],
  departmentFieldName = "department",
  departmentFilterFn,
  departmentRequired = true,
  schoolRequired = true,
  disabled = false,
  getValues,
  labels: { department: departmentLabel, schools: schoolsLabel } = {},
  multiple = false,
  schoolFieldName = "schools",
  schoolTypes,
  schoolValue,
  width,
  formState,
  setValue,
  searchSchoolsApi = _172.noop,
  listMaxHeight
}) => {
  const watchDepartment = useWatch({
    control,
    name: departmentFieldName
  });
  const schoolsRef = useRef16(getValues == null ? void 0 : getValues(schoolFieldName));
  const [schoolsOptions, setSchoolsOptions] = useState63(defaultSchools);
  const fetchSchools = useCallback67(
    async ({ department, rnes, schoolTypes: schoolTypes2, ids }) => {
      const schools = await searchSchoolsApi({ department, rnes, schoolTypes: schoolTypes2, ids });
      setSchoolsOptions(
        (options) => _172.uniqBy("id", (schools ?? []).concat(options.filter((school) => school.id === schoolsRef.current)))
      );
    },
    [searchSchoolsApi]
  );
  useEffect30(() => {
    _172.noop(setSchoolsOptions, searchSchoolsApi);
    !_172.isEmpty(watchDepartment) && !_172.isEmpty(schoolTypes) && fetchSchools({ department: watchDepartment, schoolTypes });
  }, [watchDepartment, searchSchoolsApi, fetchSchools, schoolTypes]);
  useEffect30(() => {
    _172.noop(searchSchoolsApi);
    schoolsRef.current && fetchSchools({ ids: _172.castArray(schoolsRef.current) });
  }, [searchSchoolsApi, fetchSchools]);
  useDidUpdate(() => {
    if (!multiple) setValue(schoolFieldName, null);
  }, [watchDepartment, setValue, multiple]);
  return /* @__PURE__ */ jsxs158("div", { className: cx43(className, src_internals_components_form_index_default.schoolsSelectorContainer), children: [
    /* @__PURE__ */ jsx207(
      departments_default,
      {
        name: departmentFieldName,
        control,
        label: departmentLabel,
        filterFn: departmentFilterFn,
        multiple,
        error: hasError({ fieldName: departmentFieldName, formState }),
        hint: getHint({ fieldName: departmentFieldName, formState }),
        disabled,
        width,
        required: departmentRequired,
        listMaxHeight
      }
    ),
    /* @__PURE__ */ jsx207(
      schools_default,
      {
        name: schoolFieldName,
        schools: schoolsOptions,
        control,
        label: schoolsLabel,
        multiple,
        error: hasError({ fieldName: schoolFieldName, formState }),
        hint: getHint({ fieldName: schoolFieldName, formState }),
        disabled,
        width,
        schoolValue,
        required: schoolRequired,
        listMaxHeight
      }
    )
  ] });
};
var schoolsSelector_default = SchoolsSelector;

// src/internals/components/form/subjects.tsx
import { SelectField as SelectField16 } from "@lls/lls-kit";
import { sortSubjects } from "@lls/utils";
import _173 from "lodash/fp.js";
import { Controller as Controller11 } from "react-hook-form";
import { jsx as jsx208 } from "react/jsx-runtime";
var Subjects = ({
  control,
  label = "Mati\xE8re(s) enseign\xE9e(s)",
  subjects,
  error,
  valueProp = "id",
  listMaxHeight = "200px",
  required = false,
  ...props
}) => {
  return /* @__PURE__ */ jsx208(
    Controller11,
    {
      rules: required ? { required: "Mati\xE8re obligatoire" } : void 0,
      name: "subjects",
      control,
      render: ({ field }) => /* @__PURE__ */ jsx208(
        SelectField16,
        {
          searchable: true,
          label,
          required,
          listMaxHeight,
          state: error ? "error" : void 0,
          disabled: props.disabled,
          options: _173.flow(
            sortSubjects,
            _173.map((subject) => ({
              value: _173.get(valueProp, subject),
              label: _173.get("name", subject)
            }))
          )(subjects),
          ...props,
          ...field
        }
      )
    }
  );
};
var subjects_default = Subjects;

// src/internals/components/form/academicEmail.tsx
import { TextField as TextField14 } from "@lls/lls-kit";
import { Controller as Controller12 } from "react-hook-form";
import { jsx as jsx209 } from "react/jsx-runtime";
var AcademicEmail = ({
  control,
  name = "academicEmail",
  label = "Adresse email acad\xE9mique",
  error = false,
  required,
  ...props
}) => /* @__PURE__ */ jsx209(Controller12, { render: ({ field }) => /* @__PURE__ */ jsx209(TextField14, { label, ...props, ...field }), name, control });
var academicEmail_default = AcademicEmail;

// src/internals/components/form/id.tsx
import { TextField as TextField15 } from "@lls/lls-kit";
import { Controller as Controller13 } from "react-hook-form";
import { jsx as jsx210 } from "react/jsx-runtime";
var Id = ({
  control,
  name = "id",
  label = "Identifiant",
  error = false,
  required,
  ...props
}) => /* @__PURE__ */ jsx210(Controller13, { render: ({ field }) => /* @__PURE__ */ jsx210(TextField15, { label, ...props, ...field }), name, control });
var id_default = Id;

// src/internals/components/form/username.tsx
import { TextField as TextField16 } from "@lls/lls-kit";
import { Controller as Controller14 } from "react-hook-form";
import { jsx as jsx211 } from "react/jsx-runtime";
var Username = ({
  control,
  name = "username",
  label = "Nom d'utilisateur",
  error = false,
  required,
  ...props
}) => /* @__PURE__ */ jsx211(Controller14, { render: ({ field }) => /* @__PURE__ */ jsx211(TextField16, { label, ...props, ...field }), name, control });
var username_default = Username;

// tmp_esbuild1736180050074/_src_internals_components_profile_personalInfosTab.module.css
var src_internals_components_profile_personalInfosTab_default = { "schoolWrapper": "sk-gjI7ya-schoolWrapper", "submitButton": "sk-gjI7ya-submitButton", "cancelButton": "sk-gjI7ya-cancelButton", "divider": "sk-gjI7ya-divider", "schoolSelector": "sk-gjI7ya-schoolSelector", "paragraph": "sk-gjI7ya-paragraph", "deleteInfosButton": "sk-gjI7ya-deleteInfosButton" };

// src/internals/components/profile/personalInfosTab.tsx
import { Fragment as Fragment59, jsx as jsx212, jsxs as jsxs159 } from "react/jsx-runtime";
var schoolTypeValueFunction = (value) => pipe4(value, _174.toString, _174.capitalize);
var PersonalInfosTab = ({
  subjects,
  levels,
  schoolTypes,
  searchSchoolsApi,
  submitPersonalInfos = _174.noop,
  onDeleteInfosClick,
  user = {},
  showDeletePersonalInfos = false,
  visible,
  isAccountProfile
}) => {
  var _a, _b, _c, _d, _e;
  const { control, formState, setValue, getValues, handleSubmit, watch } = useForm3({
    defaultValues: {
      username: user.username,
      id: isAccountProfile ? user.id : null,
      email: user.email,
      academicEmail: user.academicEmail,
      firstname: user.firstname,
      lastname: user.lastname,
      subjects: user.subjects,
      levels: user.levels,
      schoolTypes: (_a = user == null ? void 0 : user.schoolTypes) == null ? void 0 : _a.map(schoolTypeValueFunction),
      school: (_c = (_b = user == null ? void 0 : user.schools) == null ? void 0 : _b[0]) == null ? void 0 : _c.id,
      department: (_e = (_d = user == null ? void 0 : user.schools) == null ? void 0 : _d[0]) == null ? void 0 : _e.department,
      functions: user.functions
    }
  });
  const watchedSchoolTypeNames = _174.compact(watch("schoolTypes"));
  const { filteredLevels, subjectsWithoutPrimary } = useLevelFiltersForm({
    levels,
    subjects,
    schoolTypes,
    watchedSchoolTypeNames
  });
  const isTeacher2 = !(user == null ? void 0 : user.isStudent);
  const disableSchoolUpdate = !canUpdateSchools(user) || !isTeacher2;
  const onSubmit = (form) => {
    const user2 = _174.flow(
      _174.omit(["id", "username", "firstname", "lastname", "academicEmail"]),
      _174.omitBy((val, key) => ["levels", "subjects", "schoolTypes"].includes(key) && val === null)
    )(form);
    submitPersonalInfos(user2);
  };
  return /* @__PURE__ */ jsx212(StyledTabContainer, { "data-visible": +visible, children: /* @__PURE__ */ jsxs159("form", { onSubmit: handleSubmit(onSubmit), className: src_internals_components_profile_personalInfosTab_default, children: [
    /* @__PURE__ */ jsx212(StyledTitle6, { children: "Informations personnelles" }),
    /* @__PURE__ */ jsxs159(StyledFormContainer, { "data-clarity-mask": "true", children: [
      isAccountProfile && /* @__PURE__ */ jsxs159(Fragment59, { children: [
        /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(username_default, { control, width: "100%", readonly: true }) }),
        /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(id_default, { control, width: "100%", readonly: true }) })
      ] }),
      /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(firstname_default, { control, width: "100%", readonly: true }) }),
      /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(lastname_default, { control, width: "100%", readonly: true }) }),
      /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(email_default, { required: false, control, width: "100%", readonly: true }) }),
      isAccountProfile && isTeacher2 && /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(academicEmail_default, { control, width: "100%", readonly: true }) })
    ] }),
    /* @__PURE__ */ jsx212(StyledTitle6, { children: "Enseignement" }),
    /* @__PURE__ */ jsxs159(StyledFormContainer, { "data-clarity-mask": "true", children: [
      /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(
        schoolTypes_default,
        {
          schoolTypes,
          label: "Niveau(x) d'enseignement",
          control,
          width: "100%",
          valueProp: "name",
          error: hasError({ fieldName: "schoolTypes", formState }),
          disabled: disableSchoolUpdate,
          valueFunction: schoolTypeValueFunction,
          required: false,
          multiple: true
        }
      ) }),
      /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(
        levels_default,
        {
          control,
          width: "100%",
          levels: filteredLevels,
          required: false,
          disabled: (user == null ? void 0 : user.isGarUser) && !isTeacher2
        }
      ) }),
      isTeacher2 && /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(
        subjects_default,
        {
          control,
          width: "100%",
          subjects: subjectsWithoutPrimary,
          error: hasError({ fieldName: "subjects", formState }),
          multiple: true
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx212(StyledTitle6, { children: "\xC9tablissement et fonction" }),
    /* @__PURE__ */ jsxs159(StyledFormContainer, { "data-clarity-mask": "true", children: [
      /* @__PURE__ */ jsx212("div", { className: src_internals_components_profile_personalInfosTab_default.schoolWrapper, children: /* @__PURE__ */ jsx212(
        schoolsSelector_default,
        {
          className: src_internals_components_profile_personalInfosTab_default.schoolSelector,
          schoolValue: "id",
          schoolFieldName: "school",
          setValue,
          formState,
          searchSchoolsApi,
          getValues,
          departmentRequired: false,
          control,
          disabled: disableSchoolUpdate,
          schoolTypes: watchedSchoolTypeNames ?? void 0
        }
      ) }),
      isTeacher2 && /* @__PURE__ */ jsx212(StyledFieldContainer, { children: /* @__PURE__ */ jsx212(functionsTeacher_default, { label: "Fonction", control, width: "100%" }) })
    ] }),
    /* @__PURE__ */ jsx212(Button86, { className: src_internals_components_profile_personalInfosTab_default.submitButton, type: "submit", children: "Enregistrer les modifications" }),
    showDeletePersonalInfos && /* @__PURE__ */ jsxs159(Fragment59, { children: [
      /* @__PURE__ */ jsx212(Divider16, { className: src_internals_components_profile_personalInfosTab_default.divider }),
      /* @__PURE__ */ jsx212(StyledTitle6, { children: "Supprimer mes informations personnelles" }),
      /* @__PURE__ */ jsx212("p", { className: src_internals_components_profile_personalInfosTab_default.paragraph, children: "Vos donn\xE9es restent priv\xE9es et ne seront jamais partag\xE9es sans votre autorisation. Nous les utilisons uniquement pour vous fournir des ressources adapt\xE9es. Si vous d\xE9cidez de supprimer vos donn\xE9es personnelles, vous recevrez un e-mail de confirmation. Cette action est irr\xE9versible." }),
      /* @__PURE__ */ jsx212(Button86, { className: src_internals_components_profile_personalInfosTab_default.deleteInfosButton, theme: "error", onClick: onDeleteInfosClick, children: "Supprimer mes informations personnelles" })
    ] })
  ] }) });
};
var personalInfosTab_default = PersonalInfosTab;

// tmp_esbuild1736180050074/_src_internals_components_profile_subscriptionTab.module.css
var src_internals_components_profile_subscriptionTab_default = { "premium": "sk-R934mq-premium" };

// src/internals/components/profile/subscriptionTab.tsx
import { jsx as jsx213, jsxs as jsxs160 } from "react/jsx-runtime";
var SubscriptionTab = ({ visible = false }) => /* @__PURE__ */ jsxs160(StyledTabContainer, { "data-visible": +visible, children: [
  /* @__PURE__ */ jsx213(StyledTitle6, { children: "Votre abonnement" }),
  "Vous poss\xE9dez un abonnement ",
  /* @__PURE__ */ jsx213("span", { className: src_internals_components_profile_subscriptionTab_default.premium, children: "Premium" }),
  "."
] });
var subscriptionTab_default = SubscriptionTab;

// src/internals/components/profile/index.tsx
import { jsx as jsx214, jsxs as jsxs161 } from "react/jsx-runtime";
var ProfileComponent = ({
  subjects,
  levels,
  schoolTypes,
  searchSchoolsApi,
  onDeleteInfosClick,
  submitPersonalInfos,
  onSubscribeClick,
  onUpdatePassword,
  user,
  isAccountProfile,
  hasUnsubscribed
}) => {
  const [activeTab, setActiveTab] = useState64(0);
  return /* @__PURE__ */ jsxs161("div", { className: src_internals_components_profile_index_default.card, children: [
    /* @__PURE__ */ jsxs161(Tabs6, { className: src_internals_components_profile_index_default.tabs, value: activeTab, onChange: setActiveTab, variant: "noBackground", children: [
      /* @__PURE__ */ jsx214(Tab6, { className: src_internals_components_profile_index_default.tab, icon: "personfilled", children: "Profil" }),
      isAccountProfile && !(user == null ? void 0 : user.isGarUser) && /* @__PURE__ */ jsx214(Tab6, { className: src_internals_components_profile_index_default.tab, icon: "lockfilled", children: "Mot de passe" }),
      /* @__PURE__ */ jsx214(Tab6, { className: src_internals_components_profile_index_default.tab, icon: "envelope", children: "Pr\xE9f\xE9rences de communication" }),
      (user == null ? void 0 : user.isPremium) && /* @__PURE__ */ jsx214(Tab6, { className: src_internals_components_profile_index_default.tab, icon: "sellfilled", children: "Abonnements" })
    ] }),
    /* @__PURE__ */ jsx214(
      personalInfosTab_default,
      {
        onDeleteInfosClick,
        submitPersonalInfos,
        subjects,
        levels,
        schoolTypes,
        searchSchoolsApi,
        user,
        visible: activeTab === 0,
        isAccountProfile
      }
    ),
    /* @__PURE__ */ jsx214(passwordTab_default, { visible: activeTab === 1, onUpdatePassword }),
    /* @__PURE__ */ jsx214(
      communicationTab_default,
      {
        onNavigateToProfile: () => setActiveTab(0),
        onSubscribeClick,
        hasUnsubscribed,
        visible: activeTab === 2
      }
    ),
    /* @__PURE__ */ jsx214(subscriptionTab_default, { visible: activeTab === 3 })
  ] });
};
var profile_default = ProfileComponent;

// src/internals/components/error/index.tsx
import _175 from "lodash/fp.js";
import { Button as Button87 } from "@lls/lls-kit";

// tmp_esbuild1736180050074/_src_internals_components_error_index.module.css
var src_internals_components_error_index_default = { "title": "sk-kJezAa-title", "illustration": "sk-kJezAa-illustration", "message": "sk-kJezAa-message", "buttonContainer": "sk-kJezAa-buttonContainer", "errorPage": "sk-kJezAa-errorPage", "marker": "sk-kJezAa-marker superkit-permanentMarkerRegular" };

// src/internals/components/error/index.tsx
import { jsx as jsx215, jsxs as jsxs162 } from "react/jsx-runtime";
var ErrorPage = ({
  onGoToHomePage = _175.noop,
  onCustomButtonClick = _175.noop,
  customButtonText = null,
  markerText = "Oups ...",
  title = "Il y a un probl\xE8me avec cette page.",
  message = "Nous faisons le maximum pour le r\xE9gler. Si votre besoin est urgent, contactez l'assistance :",
  subText = null
}) => /* @__PURE__ */ jsxs162("div", { className: src_internals_components_error_index_default.errorPage, children: [
  /* @__PURE__ */ jsxs162("div", { children: [
    /* @__PURE__ */ jsx215("div", { className: src_internals_components_error_index_default.marker, children: markerText }),
    /* @__PURE__ */ jsx215("h1", { className: src_internals_components_error_index_default.title, children: title }),
    /* @__PURE__ */ jsx215("p", { className: src_internals_components_error_index_default.message, children: message }),
    subText && /* @__PURE__ */ jsxs162("p", { className: src_internals_components_error_index_default.message, children: [
      " ",
      subText,
      " "
    ] }),
    /* @__PURE__ */ jsxs162("div", { className: src_internals_components_error_index_default.buttonContainer, children: [
      customButtonText && /* @__PURE__ */ jsx215(Button87, { onClick: onCustomButtonClick, children: customButtonText }),
      /* @__PURE__ */ jsx215(Button87, { accent: customButtonText ? "floating" : void 0, onClick: onGoToHomePage, children: "Revenir \xE0 l'accueil" })
    ] })
  ] }),
  /* @__PURE__ */ jsx215("img", { className: src_internals_components_error_index_default.illustration, src: "/assets/img/error/error-illu.webp" })
] });
var error_default = ErrorPage;

// src/internals/components/form/gradeLevel.tsx
import { RadioButton } from "@lls/lls-kit";
import { Controller as Controller15 } from "react-hook-form";
import { Fragment as Fragment60, jsx as jsx216, jsxs as jsxs163 } from "react/jsx-runtime";
var GradeLevel = ({
  label = "Degr\xE9 d'enseignement :",
  onChangeExternal,
  register,
  error,
  required = false,
  control,
  formValueKey,
  currentGradeLevel
}) => {
  if (!formValueKey) return;
  return /* @__PURE__ */ jsxs163(Fragment60, { children: [
    /* @__PURE__ */ jsxs163("span", { className: src_internals_components_form_index_default.label, children: [
      label,
      required && /* @__PURE__ */ jsx216("span", { className: src_internals_components_form_index_default.required, children: " *" })
    ] }),
    /* @__PURE__ */ jsx216(
      Controller15,
      {
        name: formValueKey,
        rules: required ? { required: "Degr\xE9 d\u2019enseignement obligatoire" } : {},
        control,
        render: ({ field: { value, onChange, ...field } }) => /* @__PURE__ */ jsxs163("div", { className: src_internals_components_form_index_default.radioGroup, children: [
          /* @__PURE__ */ jsx216(
            RadioButton,
            {
              ...register(formValueKey),
              value: "primaire",
              onChange: (value2) => {
                onChangeExternal == null ? void 0 : onChangeExternal();
                onChange(value2);
              },
              label: "Primaire",
              isChecked: currentGradeLevel === "primaire",
              state: error ? "error" : void 0,
              ...field
            }
          ),
          /* @__PURE__ */ jsx216(
            RadioButton,
            {
              ...register(formValueKey),
              value: "secondaire",
              onChange: (value2) => {
                onChangeExternal == null ? void 0 : onChangeExternal();
                onChange(value2);
              },
              label: "Secondaire",
              isChecked: currentGradeLevel === "secondaire",
              state: error ? "error" : void 0,
              ...field
            }
          )
        ] })
      }
    )
  ] });
};
var gradeLevel_default = GradeLevel;

// src/internals/components/form/checkMark.tsx
import { Icon as Icon47 } from "@lls/lls-kit";
import _176 from "lodash/fp.js";

// tmp_esbuild1736180050074/_src_internals_components_form_checkMark.module.css
var src_internals_components_form_checkMark_default = { "checkMarkIcon": "sk-xjBKFq-checkMarkIcon" };

// src/internals/components/form/checkMark.tsx
import { jsx as jsx217 } from "react/jsx-runtime";
var CheckMark = ({
  formData = {},
  fieldName,
  formState,
  watch
}) => {
  const isShownCheckMark = (!_176.isEmpty(formData[fieldName]) && isClean({ fieldName, formState }) || isDirtyAndWithoutError(fieldName, formState)) && (!_176.isFunction(watch) || _176.isFunction(watch) && !_176.isEmpty(watch(fieldName)) || _176.isFunction(watch) && _176.isNumber(watch(fieldName)) && !_176.isNil(watch(fieldName)));
  return /* @__PURE__ */ jsx217(Icon47, { className: src_internals_components_form_checkMark_default.checkMarkIcon, "data-visible": +isShownCheckMark, name: "checkmarkfilled" });
};
var checkMark_default = CheckMark;

// src/internals/components/form/phone.tsx
import { TextField as TextField17 } from "@lls/lls-kit";
import { Controller as Controller16 } from "react-hook-form";
import { jsx as jsx218 } from "react/jsx-runtime";
var Phone = ({
  control,
  error = false,
  label = "T\xE9l\xE9phone",
  name = "phone",
  required = true,
  ...props
}) => /* @__PURE__ */ jsx218(
  Controller16,
  {
    render: ({ field }) => /* @__PURE__ */ jsx218(TextField17, { label, state: error ? "error" : void 0, required, ...props, ...field }),
    rules: {
      required: required ? {
        value: true,
        message: "T\xE9l\xE9phone obligatoire"
      } : void 0
    },
    name,
    control
  }
);
var phone_default = Phone;

// src/internals/components/form/honeyPot.tsx
import { TextField as TextField18 } from "@lls/lls-kit";
import { Controller as Controller17 } from "react-hook-form";

// tmp_esbuild1736180050074/_src_internals_components_form_honeyPot.module.css
var src_internals_components_form_honeyPot_default = { "fieldContainer": "sk-w2822G-fieldContainer" };

// src/internals/components/form/honeyPot.tsx
import { jsx as jsx219 } from "react/jsx-runtime";
var HoneyPot = ({
  control,
  // generic name, not used in any marketing form
  name = "details",
  label = "D\xE9tails",
  error = false,
  ...props
}) => /* @__PURE__ */ jsx219("div", { className: src_internals_components_form_honeyPot_default.fieldContainer, children: /* @__PURE__ */ jsx219(
  Controller17,
  {
    render: ({ field }) => /* @__PURE__ */ jsx219(
      TextField18,
      {
        label,
        state: error ? "error" : void 0,
        autoComplete: "off",
        tabIndex: -1,
        ...props,
        ...field
      }
    ),
    name,
    control
  }
) });
var honeyPot_default = HoneyPot;

// src/internals/components/forms/userInfo.tsx
import { CheckBox as CheckBox4 } from "@lls/lls-kit";
import {
  BREAKPOINT_MD,
  SCHOOL_TYPE_AUTRE,
  getSubjectsBySchoolTypes,
  useLevelFiltersForm as useLevelFiltersForm2,
  useUnderBreakpoint as useUnderBreakpoint2
} from "@lls/utils";
import _177 from "lodash/fp.js";
import { Controller as Controller18 } from "react-hook-form";

// tmp_esbuild1736180050074/_src_internals_components_forms_userInfo.module.css
var src_internals_components_forms_userInfo_default = { "schoolSelector": "sk-RIiieG-schoolSelector", "checkMarkCommon": "sk-RIiieG-checkMarkCommon", "subtext": "sk-RIiieG-subtext", "checkMark": "sk-RIiieG-checkMark", "h3": "sk-RIiieG-h3", "checkMarkSchool": "sk-RIiieG-checkMarkSchool", "fieldContainer": "sk-RIiieG-fieldContainer", "fields": "sk-RIiieG-fields" };

// src/internals/components/forms/userInfo.tsx
import { jsx as jsx220, jsxs as jsxs164 } from "react/jsx-runtime";
var FULL_WIDTH = "100%";
var UserInfo = ({
  schoolTypes,
  control,
  register,
  title = "Vous \xEAtes enseignant de\u2026",
  schoolTitle = "O\xF9 enseignez-vous ?",
  showTitle = true,
  setValue,
  formState,
  watch,
  required = true,
  showCheckMark = false,
  searchSchools,
  showUlis = false,
  formData,
  showSchoolTitle = true,
  fullWidth = false,
  subjects,
  levels
}) => {
  const currentGradeLevel = watch("gradeLevel");
  const selectedSchoolTypesNames = watch("schoolTypes");
  const selectedLevelsName = watch("levels");
  const isUlis = watch("isUlis");
  const { filteredLevels, filteredSchoolTypes, subjectsWithoutPrimary } = useLevelFiltersForm2({
    levels,
    subjects,
    schoolTypes,
    watchedSchoolTypeNames: selectedSchoolTypesNames,
    watchedGradeLevel: currentGradeLevel
  });
  const isMobile = useUnderBreakpoint2(BREAKPOINT_MD);
  const formWidth = fullWidth ? FULL_WIDTH : isMobile ? "240px" : "260px";
  return /* @__PURE__ */ jsxs164("div", { "data-fullwidth": +fullWidth, "data-showcheckmark": +showCheckMark, children: [
    showTitle && /* @__PURE__ */ jsx220("h3", { className: src_internals_components_forms_userInfo_default.h3, children: title }),
    /* @__PURE__ */ jsx220("div", { className: src_internals_components_forms_userInfo_default.fields, children: /* @__PURE__ */ jsx220("div", { className: src_internals_components_forms_userInfo_default.fieldContainer, children: /* @__PURE__ */ jsx220(
      gradeLevel_default,
      {
        label: "Degr\xE9 d'enseignement :",
        formValueKey: "gradeLevel",
        control,
        required,
        error: hasError({ fieldName: "gradeLevel", formState }),
        onChangeExternal: () => setValue("schoolTypes", []),
        ...{ register, setValue, currentGradeLevel }
      }
    ) }) }),
    /* @__PURE__ */ jsxs164("div", { className: src_internals_components_forms_userInfo_default.fields, children: [
      /* @__PURE__ */ jsxs164("div", { className: src_internals_components_forms_userInfo_default.fieldContainer, children: [
        /* @__PURE__ */ jsx220(
          schoolTypes_default,
          {
            label: "Type d'\xE9tablissement",
            multiple: true,
            name: "schoolTypes",
            valueProp: "name",
            control,
            schoolTypes: filteredSchoolTypes,
            error: hasError({ fieldName: "schoolTypes", formState }),
            hint: getHint({ fieldName: "schoolTypes", formState }),
            rules: { required: true },
            width: formWidth,
            disabled: !currentGradeLevel
          }
        ),
        showCheckMark && /* @__PURE__ */ jsx220("div", { className: src_internals_components_forms_userInfo_default.checkMarkCommon, children: /* @__PURE__ */ jsx220(checkMark_default, { formData, fieldName: "schoolTypes", formState, watch }) })
      ] }),
      showUlis && /* @__PURE__ */ jsx220("div", { className: src_internals_components_forms_userInfo_default.fieldContainer, children: /* @__PURE__ */ jsx220(
        Controller18,
        {
          render: ({ field }) => /* @__PURE__ */ jsx220(CheckBox4, { label: "J'enseigne au sein d'une classe Ulis", ...field }),
          name: "isUlis",
          control
        }
      ) }),
      !isUlis && /* @__PURE__ */ jsxs164("div", { className: src_internals_components_forms_userInfo_default.fieldContainer, children: [
        /* @__PURE__ */ jsx220(
          levels_default,
          {
            label: "Classe",
            control,
            width: formWidth,
            required,
            levels: filteredLevels,
            error: hasError({ fieldName: "levels", formState }),
            hint: getHint({ fieldName: "levels", formState }),
            disabled: !selectedSchoolTypesNames || selectedSchoolTypesNames.length === 0
          }
        ),
        showCheckMark && /* @__PURE__ */ jsx220("div", { className: src_internals_components_forms_userInfo_default.checkMarkCommon, children: /* @__PURE__ */ jsx220(checkMark_default, { formData, fieldName: "levels", formState, watch }) })
      ] }),
      currentGradeLevel && currentGradeLevel !== "primaire" && /* @__PURE__ */ jsxs164("div", { className: src_internals_components_forms_userInfo_default.fieldContainer, children: [
        /* @__PURE__ */ jsx220(
          subjects_default,
          {
            multiple: true,
            required,
            control,
            name: "subjects",
            subjects: _177.size(selectedSchoolTypesNames) === 1 && _177.includes(SCHOOL_TYPE_AUTRE, selectedSchoolTypesNames) ? subjectsWithoutPrimary : getSubjectsBySchoolTypes(subjects, _177.without([SCHOOL_TYPE_AUTRE], selectedSchoolTypesNames)),
            width: formWidth,
            hint: getHint({ fieldName: "subjects", formState }),
            error: hasError({ fieldName: "subjects", formState }),
            label: "Mati\xE8res enseign\xE9es",
            disabled: (!selectedLevelsName || selectedLevelsName.length === 0) && !isUlis
          }
        ),
        showCheckMark && /* @__PURE__ */ jsx220("div", { className: src_internals_components_forms_userInfo_default.checkMarkCommon, children: /* @__PURE__ */ jsx220(checkMark_default, { formData, fieldName: "subjects", formState, watch }) })
      ] })
    ] }),
    showSchoolTitle && /* @__PURE__ */ jsx220("h3", { className: src_internals_components_forms_userInfo_default.h3, children: schoolTitle }),
    /* @__PURE__ */ jsxs164("div", { className: src_internals_components_forms_userInfo_default.fieldContainer, children: [
      /* @__PURE__ */ jsx220(
        schoolsSelector_default,
        {
          className: src_internals_components_forms_userInfo_default.schoolSelector,
          departmentRequired: required,
          schoolRequired: required,
          schoolFieldName: "school",
          departmentFieldName: "department",
          setValue,
          formState,
          width: formWidth,
          searchSchoolsApi: searchSchools,
          schoolTypes: selectedSchoolTypesNames,
          control
        }
      ),
      showCheckMark && /* @__PURE__ */ jsx220("div", { className: src_internals_components_forms_userInfo_default.checkMarkSchool, children: /* @__PURE__ */ jsx220(checkMark_default, { formData, fieldName: "school", formState, watch }) })
    ] }),
    /* @__PURE__ */ jsxs164("div", { className: src_internals_components_forms_userInfo_default.subtext, children: [
      "Votre \xE9tablissement n'appara\xEEt pas dans la liste ?",
      " ",
      /* @__PURE__ */ jsx220("a", { href: "mailto:contact@lelivrescolaire.fr", children: "Contactez-nous" })
    ] })
  ] });
};
var userInfo_default = UserInfo;

// src/index.tsx
var src_default = {};
export {
  ANALYTIC_EVENTS_LINK_CLICKED,
  accordion_default as Accordion,
  appointmentBooking_default as AppointmentBooking,
  appreciationHeader_default as AppreciationHeader,
  availableCopiesHeader_default as AvailableCopiesHeader,
  BookFakePremiumResources,
  bookHeader_default as BookHeader,
  bookInfos_default as BookInfos,
  bookPremiumResources_default as BookPremiumResources,
  bookResources_default as BookResources,
  bookResourcesModal_default as BookResourcesModal,
  bookToolbar_default as BookToolbar,
  bookToolbox_default as BookToolbox,
  CLASSROOM_STEP,
  cardToolbar_default as CardToolbar,
  checkMark_default as CheckMark,
  classicEpubLink_default as ClassicEpubLink,
  classicResourceLink_default as ClassicResourcesLink,
  classrooms_default2 as Classrooms,
  collaborativeInfos_default as CollaborativeInfos,
  communityContactHelp_default as CommunityContactHelp,
  cookies_default as Cookies,
  CopiesBreadcrumb,
  copiesTable_default as CopiesTable,
  breadcrumb_default as CopyBreadcrumb,
  copyClipBoardButton_default as CopyClipBoardButton,
  DRAWER_MY_PAGES_ID,
  departments_default as Departments,
  drawer_default as Drawer,
  email_default as Email,
  error_default as ErrorPage,
  FULLWIDTH_DRAWER_BREAKPOINT,
  filters_default as FiltersButton,
  firstname_default as Firstname,
  functionsTeacher_default as FunctionsTeacher,
  goBackButton_default as GoBackButton,
  gradeLevel_default as GradeLevel,
  honeyPot_default as HoneyPot,
  LEARNING_ASSESSMENT_STEPS,
  lastname_default as Lastname,
  learningAssessment_default as LearningAssessment,
  levels_default as Levels,
  navbar_default as Navbar,
  notificationIcon_default as NotificationIcon,
  notificationMenu_default as NotificationMenu,
  notificationModal_default as NotificationModal,
  npsModal_default as NpsModal,
  offlineModal_default as OfflineModal,
  PAGES_THEMATIC,
  pageList_default3 as PageList,
  phone_default as Phone,
  printView_default as PrintView,
  profile_default as Profile,
  renewalTeaser_default as RenewalTeaser,
  reportFooter_default as ReportFooter,
  revision_default as Revision,
  revisionBook_default as RevisionBook,
  SESSION_EXERCISE_TAB,
  SESSION_STATS_TAB,
  SESSION_STATS_TEACHER_TAB,
  STYLED_DRAWER_HEADER_HEIGHT,
  SUPERKIT_CLASSNAME_DARK_THEME,
  SUPERKIT_CLASSNAME_LIGHT_THEME,
  schoolTypes_default as SchoolTypes,
  schools_default as Schools,
  schoolsSelector_default as SchoolsSelector,
  search_default as Search,
  session_default as Session,
  shareBar_default as ShareBar,
  breadcrumb_default3 as ShareCorrectionsBreadcrumb,
  SnowBall,
  StyledComingSoonStamp,
  subToolbarStatusPage_default as SubToolbarStatusPage,
  subjects_default as Subjects,
  summary_default as Summary,
  SummaryChapterComponent,
  SummaryPageComponent,
  teacherAppreciationHeader_default as TeacherAppreciationHeader,
  toolbox_default as ToolBox,
  toolbar_default as Toolbar,
  ttsModal_default as TtsModal,
  userInfo_default as UserInfo,
  studentTracking_default as WorkplanStudentTracking,
  breadcrumb_default2 as WorkplansBreadcrumb,
  buildSummaryPageMapping,
  categoryHasResources,
  src_default as default,
  editSummary,
  filterSummary,
  getActivePageId,
  getNewChapterId,
  getNewNotificationsNumber,
  getPageFromSummary,
  getPagesFromSummary,
  getRelatedPage,
  getTabs,
  getVoiceIdBySubjectId,
  isChapterPage,
  shouldHideContextualActions,
  useAccessibilityState_default as useAccessibilityState,
  useContextualActions_default as useContextualActions
};
